(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire9829"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire9829"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("dbPRX", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("blLX2")).default);

var $blLX2 = parcelRequire("blLX2");
// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $99a48996dc00d8ba$export$1c00760e9e5a4e95, AxiosError: $99a48996dc00d8ba$export$c1fbed17c2f6a328, CanceledError: $99a48996dc00d8ba$export$1ab0c6b20d94fa14, isCancel: $99a48996dc00d8ba$export$3b22524397b493c6, CancelToken: $99a48996dc00d8ba$export$fd08e3cb425f0d61, VERSION: $99a48996dc00d8ba$export$a4ad2735b021c132, all: $99a48996dc00d8ba$export$84bf76cd7afc7469, Cancel: $99a48996dc00d8ba$export$848c9b7ead0df967, isAxiosError: $99a48996dc00d8ba$export$fbafdbe06a5b5a9a, spread: $99a48996dc00d8ba$export$3ae0fd4797ed47c8, toFormData: $99a48996dc00d8ba$export$10ae0d317ea97f8b, AxiosHeaders: $99a48996dc00d8ba$export$4e7d6ff0f3e6520, HttpStatusCode: $99a48996dc00d8ba$export$a972f69c851492b3, formToJSON: $99a48996dc00d8ba$export$86d7c59254d6a2c9, getAdapter: $99a48996dc00d8ba$export$17ddc20a97d669e2, mergeConfig: $99a48996dc00d8ba$export$7ec1ebcfa9d8bd6a } = (0, $blLX2.default);

});
parcelRegister("blLX2", function(module, exports) {

$parcel$export(module.exports, "default", () => $8436d9f756bd06f2$export$2e2bcd8739ae039);

var $4XH08 = parcelRequire("4XH08");

var $eta2s = parcelRequire("eta2s");

var $90bzW = parcelRequire("90bzW");

var $luOh9 = parcelRequire("luOh9");

var $1w8Ed = parcelRequire("1w8Ed");

var $3KAH7 = parcelRequire("3KAH7");

var $kQSDV = parcelRequire("kQSDV");

var $aQQwb = parcelRequire("aQQwb");

var $2A3ns = parcelRequire("2A3ns");

var $dcZVy = parcelRequire("dcZVy");

var $57jd0 = parcelRequire("57jd0");

var $gm1iz = parcelRequire("gm1iz");

var $axAZq = parcelRequire("axAZq");

var $dX7P5 = parcelRequire("dX7P5");

var $7RmVV = parcelRequire("7RmVV");

var $5fP8B = parcelRequire("5fP8B");

var $aM2we = parcelRequire("aM2we");
"use strict";
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $8436d9f756bd06f2$var$createInstance(defaultConfig) {
    const context = new (0, $90bzW.default)(defaultConfig);
    const instance = (0, $eta2s.default)((0, $90bzW.default).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $4XH08.default).extend(instance, (0, $90bzW.default).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $4XH08.default).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $8436d9f756bd06f2$var$createInstance((0, $luOh9.default)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $8436d9f756bd06f2$var$axios = $8436d9f756bd06f2$var$createInstance((0, $1w8Ed.default));
// Expose Axios class to allow class inheritance
$8436d9f756bd06f2$var$axios.Axios = (0, $90bzW.default);
// Expose Cancel & CancelToken
$8436d9f756bd06f2$var$axios.CanceledError = (0, $kQSDV.default);
$8436d9f756bd06f2$var$axios.CancelToken = (0, $aQQwb.default);
$8436d9f756bd06f2$var$axios.isCancel = (0, $2A3ns.default);
$8436d9f756bd06f2$var$axios.VERSION = (0, $dcZVy.VERSION);
$8436d9f756bd06f2$var$axios.toFormData = (0, $57jd0.default);
// Expose AxiosError class
$8436d9f756bd06f2$var$axios.AxiosError = (0, $gm1iz.default);
// alias for CanceledError for backward compatibility
$8436d9f756bd06f2$var$axios.Cancel = $8436d9f756bd06f2$var$axios.CanceledError;
// Expose all/spread
$8436d9f756bd06f2$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$8436d9f756bd06f2$var$axios.spread = (0, $axAZq.default);
// Expose isAxiosError
$8436d9f756bd06f2$var$axios.isAxiosError = (0, $dX7P5.default);
// Expose mergeConfig
$8436d9f756bd06f2$var$axios.mergeConfig = (0, $luOh9.default);
$8436d9f756bd06f2$var$axios.AxiosHeaders = (0, $7RmVV.default);
$8436d9f756bd06f2$var$axios.formToJSON = (thing)=>(0, $3KAH7.default)((0, $4XH08.default).isHTMLForm(thing) ? new FormData(thing) : thing);
$8436d9f756bd06f2$var$axios.getAdapter = (0, $5fP8B.default).getAdapter;
$8436d9f756bd06f2$var$axios.HttpStatusCode = (0, $aM2we.default);
$8436d9f756bd06f2$var$axios.default = $8436d9f756bd06f2$var$axios;
var // this module should only have a default export
$8436d9f756bd06f2$export$2e2bcd8739ae039 = $8436d9f756bd06f2$var$axios;

});
parcelRegister("4XH08", function(module, exports) {

$parcel$export(module.exports, "default", () => $39ce07443c56ddcc$export$2e2bcd8739ae039);

var $eta2s = parcelRequire("eta2s");

var $9EgzP = parcelRequire("9EgzP");
"use strict";
// utils is a library of generic helper functions non-specific to axios
const { toString: $39ce07443c56ddcc$var$toString } = Object.prototype;
const { getPrototypeOf: $39ce07443c56ddcc$var$getPrototypeOf } = Object;
const $39ce07443c56ddcc$var$kindOf = ((cache)=>(thing)=>{
        const str = $39ce07443c56ddcc$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $39ce07443c56ddcc$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$39ce07443c56ddcc$var$kindOf(thing) === type;
};
const $39ce07443c56ddcc$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $39ce07443c56ddcc$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $39ce07443c56ddcc$var$isUndefined = $39ce07443c56ddcc$var$typeOfTest("undefined");
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $39ce07443c56ddcc$var$isBuffer(val) {
    return val !== null && !$39ce07443c56ddcc$var$isUndefined(val) && val.constructor !== null && !$39ce07443c56ddcc$var$isUndefined(val.constructor) && $39ce07443c56ddcc$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $39ce07443c56ddcc$var$isArrayBuffer = $39ce07443c56ddcc$var$kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $39ce07443c56ddcc$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $39ce07443c56ddcc$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $39ce07443c56ddcc$var$isString = $39ce07443c56ddcc$var$typeOfTest("string");
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $39ce07443c56ddcc$var$isFunction = $39ce07443c56ddcc$var$typeOfTest("function");
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $39ce07443c56ddcc$var$isNumber = $39ce07443c56ddcc$var$typeOfTest("number");
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $39ce07443c56ddcc$var$isObject = (thing)=>thing !== null && typeof thing === "object";
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $39ce07443c56ddcc$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $39ce07443c56ddcc$var$isPlainObject = (val)=>{
    if ($39ce07443c56ddcc$var$kindOf(val) !== "object") return false;
    const prototype = $39ce07443c56ddcc$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $39ce07443c56ddcc$var$isDate = $39ce07443c56ddcc$var$kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $39ce07443c56ddcc$var$isFile = $39ce07443c56ddcc$var$kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $39ce07443c56ddcc$var$isBlob = $39ce07443c56ddcc$var$kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $39ce07443c56ddcc$var$isFileList = $39ce07443c56ddcc$var$kindOfTest("FileList");
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $39ce07443c56ddcc$var$isStream = (val)=>$39ce07443c56ddcc$var$isObject(val) && $39ce07443c56ddcc$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $39ce07443c56ddcc$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === "function" && thing instanceof FormData || $39ce07443c56ddcc$var$isFunction(thing.append) && ((kind = $39ce07443c56ddcc$var$kindOf(thing)) === "formdata" || // detect form-data instance
    kind === "object" && $39ce07443c56ddcc$var$isFunction(thing.toString) && thing.toString() === "[object FormData]"));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $39ce07443c56ddcc$var$isURLSearchParams = $39ce07443c56ddcc$var$kindOfTest("URLSearchParams");
const [$39ce07443c56ddcc$var$isReadableStream, $39ce07443c56ddcc$var$isRequest, $39ce07443c56ddcc$var$isResponse, $39ce07443c56ddcc$var$isHeaders] = [
    "ReadableStream",
    "Request",
    "Response",
    "Headers"
].map($39ce07443c56ddcc$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $39ce07443c56ddcc$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $39ce07443c56ddcc$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($39ce07443c56ddcc$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $39ce07443c56ddcc$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $39ce07443c56ddcc$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : $parcel$global;
})();
const $39ce07443c56ddcc$var$isContextDefined = (context)=>!$39ce07443c56ddcc$var$isUndefined(context) && context !== $39ce07443c56ddcc$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $39ce07443c56ddcc$var$merge() {
    const { caseless: caseless } = $39ce07443c56ddcc$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $39ce07443c56ddcc$var$findKey(result, key) || key;
        if ($39ce07443c56ddcc$var$isPlainObject(result[targetKey]) && $39ce07443c56ddcc$var$isPlainObject(val)) result[targetKey] = $39ce07443c56ddcc$var$merge(result[targetKey], val);
        else if ($39ce07443c56ddcc$var$isPlainObject(val)) result[targetKey] = $39ce07443c56ddcc$var$merge({}, val);
        else if ($39ce07443c56ddcc$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $39ce07443c56ddcc$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $39ce07443c56ddcc$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $39ce07443c56ddcc$var$forEach(b, (val, key)=>{
        if (thisArg && $39ce07443c56ddcc$var$isFunction(val)) a[key] = (0, $eta2s.default)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $39ce07443c56ddcc$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $39ce07443c56ddcc$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, "super", {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $39ce07443c56ddcc$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $39ce07443c56ddcc$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $39ce07443c56ddcc$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $39ce07443c56ddcc$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($39ce07443c56ddcc$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$39ce07443c56ddcc$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $39ce07443c56ddcc$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== "undefined" && $39ce07443c56ddcc$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $39ce07443c56ddcc$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $39ce07443c56ddcc$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $39ce07443c56ddcc$var$isHTMLForm = $39ce07443c56ddcc$var$kindOfTest("HTMLFormElement");
const $39ce07443c56ddcc$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $39ce07443c56ddcc$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $39ce07443c56ddcc$var$isRegExp = $39ce07443c56ddcc$var$kindOfTest("RegExp");
const $39ce07443c56ddcc$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $39ce07443c56ddcc$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $39ce07443c56ddcc$var$freezeMethods = (obj)=>{
    $39ce07443c56ddcc$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($39ce07443c56ddcc$var$isFunction(obj) && [
            "arguments",
            "caller",
            "callee"
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$39ce07443c56ddcc$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ("writable" in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
const $39ce07443c56ddcc$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $39ce07443c56ddcc$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $39ce07443c56ddcc$var$noop = ()=>{};
const $39ce07443c56ddcc$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
const $39ce07443c56ddcc$var$ALPHA = "abcdefghijklmnopqrstuvwxyz";
const $39ce07443c56ddcc$var$DIGIT = "0123456789";
const $39ce07443c56ddcc$var$ALPHABET = {
    DIGIT: $39ce07443c56ddcc$var$DIGIT,
    ALPHA: $39ce07443c56ddcc$var$ALPHA,
    ALPHA_DIGIT: $39ce07443c56ddcc$var$ALPHA + $39ce07443c56ddcc$var$ALPHA.toUpperCase() + $39ce07443c56ddcc$var$DIGIT
};
const $39ce07443c56ddcc$var$generateString = (size = 16, alphabet = $39ce07443c56ddcc$var$ALPHABET.ALPHA_DIGIT)=>{
    let str = "";
    const { length: length } = alphabet;
    while(size--)str += alphabet[Math.random() * length | 0];
    return str;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $39ce07443c56ddcc$var$isSpecCompliantForm(thing) {
    return !!(thing && $39ce07443c56ddcc$var$isFunction(thing.append) && thing[Symbol.toStringTag] === "FormData" && thing[Symbol.iterator]);
}
const $39ce07443c56ddcc$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($39ce07443c56ddcc$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!("toJSON" in source)) {
                stack[i] = source;
                const target = $39ce07443c56ddcc$var$isArray(source) ? [] : {};
                $39ce07443c56ddcc$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$39ce07443c56ddcc$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $39ce07443c56ddcc$var$isAsyncFn = $39ce07443c56ddcc$var$kindOfTest("AsyncFunction");
const $39ce07443c56ddcc$var$isThenable = (thing)=>thing && ($39ce07443c56ddcc$var$isObject(thing) || $39ce07443c56ddcc$var$isFunction(thing)) && $39ce07443c56ddcc$var$isFunction(thing.then) && $39ce07443c56ddcc$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
const $39ce07443c56ddcc$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $39ce07443c56ddcc$var$_global.addEventListener("message", ({ source: source, data: data })=>{
            if (source === $39ce07443c56ddcc$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $39ce07443c56ddcc$var$_global.postMessage(token, "*");
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === "function", $39ce07443c56ddcc$var$isFunction($39ce07443c56ddcc$var$_global.postMessage));
const $39ce07443c56ddcc$var$asap = typeof queueMicrotask !== "undefined" ? queueMicrotask.bind($39ce07443c56ddcc$var$_global) : typeof $9EgzP !== "undefined" && $9EgzP.nextTick || $39ce07443c56ddcc$var$_setImmediate;
var // *********************
$39ce07443c56ddcc$export$2e2bcd8739ae039 = {
    isArray: $39ce07443c56ddcc$var$isArray,
    isArrayBuffer: $39ce07443c56ddcc$var$isArrayBuffer,
    isBuffer: $39ce07443c56ddcc$var$isBuffer,
    isFormData: $39ce07443c56ddcc$var$isFormData,
    isArrayBufferView: $39ce07443c56ddcc$var$isArrayBufferView,
    isString: $39ce07443c56ddcc$var$isString,
    isNumber: $39ce07443c56ddcc$var$isNumber,
    isBoolean: $39ce07443c56ddcc$var$isBoolean,
    isObject: $39ce07443c56ddcc$var$isObject,
    isPlainObject: $39ce07443c56ddcc$var$isPlainObject,
    isReadableStream: $39ce07443c56ddcc$var$isReadableStream,
    isRequest: $39ce07443c56ddcc$var$isRequest,
    isResponse: $39ce07443c56ddcc$var$isResponse,
    isHeaders: $39ce07443c56ddcc$var$isHeaders,
    isUndefined: $39ce07443c56ddcc$var$isUndefined,
    isDate: $39ce07443c56ddcc$var$isDate,
    isFile: $39ce07443c56ddcc$var$isFile,
    isBlob: $39ce07443c56ddcc$var$isBlob,
    isRegExp: $39ce07443c56ddcc$var$isRegExp,
    isFunction: $39ce07443c56ddcc$var$isFunction,
    isStream: $39ce07443c56ddcc$var$isStream,
    isURLSearchParams: $39ce07443c56ddcc$var$isURLSearchParams,
    isTypedArray: $39ce07443c56ddcc$var$isTypedArray,
    isFileList: $39ce07443c56ddcc$var$isFileList,
    forEach: $39ce07443c56ddcc$var$forEach,
    merge: $39ce07443c56ddcc$var$merge,
    extend: $39ce07443c56ddcc$var$extend,
    trim: $39ce07443c56ddcc$var$trim,
    stripBOM: $39ce07443c56ddcc$var$stripBOM,
    inherits: $39ce07443c56ddcc$var$inherits,
    toFlatObject: $39ce07443c56ddcc$var$toFlatObject,
    kindOf: $39ce07443c56ddcc$var$kindOf,
    kindOfTest: $39ce07443c56ddcc$var$kindOfTest,
    endsWith: $39ce07443c56ddcc$var$endsWith,
    toArray: $39ce07443c56ddcc$var$toArray,
    forEachEntry: $39ce07443c56ddcc$var$forEachEntry,
    matchAll: $39ce07443c56ddcc$var$matchAll,
    isHTMLForm: $39ce07443c56ddcc$var$isHTMLForm,
    hasOwnProperty: $39ce07443c56ddcc$var$hasOwnProperty,
    hasOwnProp: $39ce07443c56ddcc$var$hasOwnProperty,
    reduceDescriptors: $39ce07443c56ddcc$var$reduceDescriptors,
    freezeMethods: $39ce07443c56ddcc$var$freezeMethods,
    toObjectSet: $39ce07443c56ddcc$var$toObjectSet,
    toCamelCase: $39ce07443c56ddcc$var$toCamelCase,
    noop: $39ce07443c56ddcc$var$noop,
    toFiniteNumber: $39ce07443c56ddcc$var$toFiniteNumber,
    findKey: $39ce07443c56ddcc$var$findKey,
    global: $39ce07443c56ddcc$var$_global,
    isContextDefined: $39ce07443c56ddcc$var$isContextDefined,
    ALPHABET: $39ce07443c56ddcc$var$ALPHABET,
    generateString: $39ce07443c56ddcc$var$generateString,
    isSpecCompliantForm: $39ce07443c56ddcc$var$isSpecCompliantForm,
    toJSONObject: $39ce07443c56ddcc$var$toJSONObject,
    isAsyncFn: $39ce07443c56ddcc$var$isAsyncFn,
    isThenable: $39ce07443c56ddcc$var$isThenable,
    setImmediate: $39ce07443c56ddcc$var$_setImmediate,
    asap: $39ce07443c56ddcc$var$asap
};

});
parcelRegister("eta2s", function(module, exports) {

$parcel$export(module.exports, "default", () => $a88b8f9a3f399b56$export$2e2bcd8739ae039);
"use strict";
function $a88b8f9a3f399b56$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}

});

parcelRegister("9EgzP", function(module, exports) {
// shim for using process in browser
var $7064b5528fae221c$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $7064b5528fae221c$var$cachedSetTimeout;
var $7064b5528fae221c$var$cachedClearTimeout;
function $7064b5528fae221c$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $7064b5528fae221c$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $7064b5528fae221c$var$cachedSetTimeout = setTimeout;
        else $7064b5528fae221c$var$cachedSetTimeout = $7064b5528fae221c$var$defaultSetTimout;
    } catch (e) {
        $7064b5528fae221c$var$cachedSetTimeout = $7064b5528fae221c$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $7064b5528fae221c$var$cachedClearTimeout = clearTimeout;
        else $7064b5528fae221c$var$cachedClearTimeout = $7064b5528fae221c$var$defaultClearTimeout;
    } catch (e) {
        $7064b5528fae221c$var$cachedClearTimeout = $7064b5528fae221c$var$defaultClearTimeout;
    }
})();
function $7064b5528fae221c$var$runTimeout(fun) {
    if ($7064b5528fae221c$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($7064b5528fae221c$var$cachedSetTimeout === $7064b5528fae221c$var$defaultSetTimout || !$7064b5528fae221c$var$cachedSetTimeout) && setTimeout) {
        $7064b5528fae221c$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $7064b5528fae221c$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $7064b5528fae221c$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $7064b5528fae221c$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $7064b5528fae221c$var$runClearTimeout(marker) {
    if ($7064b5528fae221c$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($7064b5528fae221c$var$cachedClearTimeout === $7064b5528fae221c$var$defaultClearTimeout || !$7064b5528fae221c$var$cachedClearTimeout) && clearTimeout) {
        $7064b5528fae221c$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $7064b5528fae221c$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $7064b5528fae221c$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $7064b5528fae221c$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $7064b5528fae221c$var$queue = [];
var $7064b5528fae221c$var$draining = false;
var $7064b5528fae221c$var$currentQueue;
var $7064b5528fae221c$var$queueIndex = -1;
function $7064b5528fae221c$var$cleanUpNextTick() {
    if (!$7064b5528fae221c$var$draining || !$7064b5528fae221c$var$currentQueue) return;
    $7064b5528fae221c$var$draining = false;
    if ($7064b5528fae221c$var$currentQueue.length) $7064b5528fae221c$var$queue = $7064b5528fae221c$var$currentQueue.concat($7064b5528fae221c$var$queue);
    else $7064b5528fae221c$var$queueIndex = -1;
    if ($7064b5528fae221c$var$queue.length) $7064b5528fae221c$var$drainQueue();
}
function $7064b5528fae221c$var$drainQueue() {
    if ($7064b5528fae221c$var$draining) return;
    var timeout = $7064b5528fae221c$var$runTimeout($7064b5528fae221c$var$cleanUpNextTick);
    $7064b5528fae221c$var$draining = true;
    var len = $7064b5528fae221c$var$queue.length;
    while(len){
        $7064b5528fae221c$var$currentQueue = $7064b5528fae221c$var$queue;
        $7064b5528fae221c$var$queue = [];
        while(++$7064b5528fae221c$var$queueIndex < len)if ($7064b5528fae221c$var$currentQueue) $7064b5528fae221c$var$currentQueue[$7064b5528fae221c$var$queueIndex].run();
        $7064b5528fae221c$var$queueIndex = -1;
        len = $7064b5528fae221c$var$queue.length;
    }
    $7064b5528fae221c$var$currentQueue = null;
    $7064b5528fae221c$var$draining = false;
    $7064b5528fae221c$var$runClearTimeout(timeout);
}
$7064b5528fae221c$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $7064b5528fae221c$var$queue.push(new $7064b5528fae221c$var$Item(fun, args));
    if ($7064b5528fae221c$var$queue.length === 1 && !$7064b5528fae221c$var$draining) $7064b5528fae221c$var$runTimeout($7064b5528fae221c$var$drainQueue);
};
// v8 likes predictible objects
function $7064b5528fae221c$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$7064b5528fae221c$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$7064b5528fae221c$var$process.title = "browser";
$7064b5528fae221c$var$process.browser = true;
$7064b5528fae221c$var$process.env = {};
$7064b5528fae221c$var$process.argv = [];
$7064b5528fae221c$var$process.version = ""; // empty string to avoid regexp issues
$7064b5528fae221c$var$process.versions = {};
function $7064b5528fae221c$var$noop() {}
$7064b5528fae221c$var$process.on = $7064b5528fae221c$var$noop;
$7064b5528fae221c$var$process.addListener = $7064b5528fae221c$var$noop;
$7064b5528fae221c$var$process.once = $7064b5528fae221c$var$noop;
$7064b5528fae221c$var$process.off = $7064b5528fae221c$var$noop;
$7064b5528fae221c$var$process.removeListener = $7064b5528fae221c$var$noop;
$7064b5528fae221c$var$process.removeAllListeners = $7064b5528fae221c$var$noop;
$7064b5528fae221c$var$process.emit = $7064b5528fae221c$var$noop;
$7064b5528fae221c$var$process.prependListener = $7064b5528fae221c$var$noop;
$7064b5528fae221c$var$process.prependOnceListener = $7064b5528fae221c$var$noop;
$7064b5528fae221c$var$process.listeners = function(name) {
    return [];
};
$7064b5528fae221c$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$7064b5528fae221c$var$process.cwd = function() {
    return "/";
};
$7064b5528fae221c$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$7064b5528fae221c$var$process.umask = function() {
    return 0;
};

});


parcelRegister("90bzW", function(module, exports) {

$parcel$export(module.exports, "default", () => $68dd186b8ccd7cdd$export$2e2bcd8739ae039);

var $4XH08 = parcelRequire("4XH08");

var $iy0lg = parcelRequire("iy0lg");

var $lvwFy = parcelRequire("lvwFy");

var $dozAp = parcelRequire("dozAp");

var $luOh9 = parcelRequire("luOh9");

var $hYteF = parcelRequire("hYteF");

var $6oDno = parcelRequire("6oDno");

var $7RmVV = parcelRequire("7RmVV");
"use strict";
const $68dd186b8ccd7cdd$var$validators = (0, $6oDno.default).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $68dd186b8ccd7cdd$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, $lvwFy.default)(),
            response: new (0, $lvwFy.default)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy;
                Error.captureStackTrace ? Error.captureStackTrace(dummy = {}) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, "") : "";
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ""))) err.stack += "\n" + stack;
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === "string") {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $luOh9.default)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $6oDno.default).assertOptions(transitional, {
            silentJSONParsing: $68dd186b8ccd7cdd$var$validators.transitional($68dd186b8ccd7cdd$var$validators.boolean),
            forcedJSONParsing: $68dd186b8ccd7cdd$var$validators.transitional($68dd186b8ccd7cdd$var$validators.boolean),
            clarifyTimeoutError: $68dd186b8ccd7cdd$var$validators.transitional($68dd186b8ccd7cdd$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $4XH08.default).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $6oDno.default).assertOptions(paramsSerializer, {
                encode: $68dd186b8ccd7cdd$var$validators.function,
                serialize: $68dd186b8ccd7cdd$var$validators.function
            }, true);
        }
        // Set config.method
        config.method = (config.method || this.defaults.method || "get").toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $4XH08.default).merge(headers.common, headers[config.method]);
        headers && (0, $4XH08.default).forEach([
            "delete",
            "get",
            "head",
            "post",
            "put",
            "patch",
            "common"
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $7RmVV.default).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $dozAp.default).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $dozAp.default).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $luOh9.default)(this.defaults, config);
        const fullPath = (0, $hYteF.default)(config.baseURL, config.url);
        return (0, $iy0lg.default)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $4XH08.default).forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $68dd186b8ccd7cdd$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $luOh9.default)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $4XH08.default).forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $luOh9.default)(config || {}, {
                method: method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $68dd186b8ccd7cdd$var$Axios.prototype[method] = generateHTTPMethod();
    $68dd186b8ccd7cdd$var$Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
var $68dd186b8ccd7cdd$export$2e2bcd8739ae039 = $68dd186b8ccd7cdd$var$Axios;

});
parcelRegister("iy0lg", function(module, exports) {

$parcel$export(module.exports, "default", () => $d80baadf43e1e699$export$2e2bcd8739ae039);

var $4XH08 = parcelRequire("4XH08");

var $7vTLH = parcelRequire("7vTLH");
"use strict";
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $d80baadf43e1e699$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function $d80baadf43e1e699$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $d80baadf43e1e699$var$encode;
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $4XH08.default).isURLSearchParams(params) ? params.toString() : new (0, $7vTLH.default)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
}

});
parcelRegister("7vTLH", function(module, exports) {

$parcel$export(module.exports, "default", () => $5786b0179ca985e9$export$2e2bcd8739ae039);

var $57jd0 = parcelRequire("57jd0");
"use strict";
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $5786b0179ca985e9$var$encode(str) {
    const charMap = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+",
        "%00": "\0"
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $5786b0179ca985e9$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $57jd0.default)(params, this, options);
}
const $5786b0179ca985e9$var$prototype = $5786b0179ca985e9$var$AxiosURLSearchParams.prototype;
$5786b0179ca985e9$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$5786b0179ca985e9$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $5786b0179ca985e9$var$encode);
    } : $5786b0179ca985e9$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + "=" + _encode(pair[1]);
    }, "").join("&");
};
var $5786b0179ca985e9$export$2e2bcd8739ae039 = $5786b0179ca985e9$var$AxiosURLSearchParams;

});
parcelRegister("57jd0", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b9c81adcae05dba$export$2e2bcd8739ae039);

var $4XH08 = parcelRequire("4XH08");

var $gm1iz = parcelRequire("gm1iz");

var $is9h8 = parcelRequire("is9h8");

var $ipcqQ = parcelRequire("ipcqQ");
var $3b9c81adcae05dba$require$Buffer = $ipcqQ.Buffer;
"use strict";
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $3b9c81adcae05dba$var$isVisitable(thing) {
    return (0, $4XH08.default).isPlainObject(thing) || (0, $4XH08.default).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $3b9c81adcae05dba$var$removeBrackets(key) {
    return (0, $4XH08.default).endsWith(key, "[]") ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $3b9c81adcae05dba$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $3b9c81adcae05dba$var$removeBrackets(token);
        return !dots && i ? "[" + token + "]" : token;
    }).join(dots ? "." : "");
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $3b9c81adcae05dba$var$isFlatArray(arr) {
    return (0, $4XH08.default).isArray(arr) && !arr.some($3b9c81adcae05dba$var$isVisitable);
}
const $3b9c81adcae05dba$var$predicates = (0, $4XH08.default).toFlatObject((0, $4XH08.default), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $3b9c81adcae05dba$var$toFormData(obj, formData, options) {
    if (!(0, $4XH08.default).isObject(obj)) throw new TypeError("target must be an object");
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $is9h8.default) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $4XH08.default).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $4XH08.default).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
    const useBlob = _Blob && (0, $4XH08.default).isSpecCompliantForm(formData);
    if (!(0, $4XH08.default).isFunction(visitor)) throw new TypeError("visitor must be a function");
    function convertValue(value) {
        if (value === null) return "";
        if ((0, $4XH08.default).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $4XH08.default).isBlob(value)) throw new (0, $gm1iz.default)("Blob is not supported. Use a Buffer instead.");
        if ((0, $4XH08.default).isArrayBuffer(value) || (0, $4XH08.default).isTypedArray(value)) return useBlob && typeof Blob === "function" ? new Blob([
            value
        ]) : $3b9c81adcae05dba$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === "object") {
            if ((0, $4XH08.default).endsWith(key, "{}")) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $4XH08.default).isArray(value) && $3b9c81adcae05dba$var$isFlatArray(value) || ((0, $4XH08.default).isFileList(value) || (0, $4XH08.default).endsWith(key, "[]")) && (arr = (0, $4XH08.default).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $3b9c81adcae05dba$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $4XH08.default).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $3b9c81adcae05dba$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + "[]", convertValue(el));
                });
                return false;
            }
        }
        if ($3b9c81adcae05dba$var$isVisitable(value)) return true;
        formData.append($3b9c81adcae05dba$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($3b9c81adcae05dba$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $3b9c81adcae05dba$var$isVisitable
    });
    function build(value, path) {
        if ((0, $4XH08.default).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error("Circular reference detected in " + path.join("."));
        stack.push(value);
        (0, $4XH08.default).forEach(value, function each(el, key) {
            const result = !((0, $4XH08.default).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $4XH08.default).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $4XH08.default).isObject(obj)) throw new TypeError("data must be an object");
    build(obj);
    return formData;
}
var $3b9c81adcae05dba$export$2e2bcd8739ae039 = $3b9c81adcae05dba$var$toFormData;

});
parcelRegister("gm1iz", function(module, exports) {

$parcel$export(module.exports, "default", () => $be7fb5460030689b$export$2e2bcd8739ae039);

var $4XH08 = parcelRequire("4XH08");
"use strict";
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $be7fb5460030689b$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    if (response) {
        this.response = response;
        this.status = response.status ? response.status : null;
    }
}
(0, $4XH08.default).inherits($be7fb5460030689b$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $4XH08.default).toJSONObject(this.config),
            code: this.code,
            status: this.status
        };
    }
});
const $be7fb5460030689b$var$prototype = $be7fb5460030689b$var$AxiosError.prototype;
const $be7fb5460030689b$var$descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED",
    "ERR_NOT_SUPPORT",
    "ERR_INVALID_URL"
].forEach((code)=>{
    $be7fb5460030689b$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($be7fb5460030689b$var$AxiosError, $be7fb5460030689b$var$descriptors);
Object.defineProperty($be7fb5460030689b$var$prototype, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
$be7fb5460030689b$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($be7fb5460030689b$var$prototype);
    (0, $4XH08.default).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== "isAxiosError";
    });
    $be7fb5460030689b$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $be7fb5460030689b$export$2e2bcd8739ae039 = $be7fb5460030689b$var$AxiosError;

});

parcelRegister("is9h8", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6f209695c873678$export$2e2bcd8739ae039);
// eslint-disable-next-line strict
var $d6f209695c873678$export$2e2bcd8739ae039 = null;

});

parcelRegister("ipcqQ", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $03753aa7640d6096$export$a143d493d941bafc, (v) => $03753aa7640d6096$export$a143d493d941bafc = v);
$parcel$export(module.exports, "SlowBuffer", () => $03753aa7640d6096$export$e4cf37d7f6fb9e0a, (v) => $03753aa7640d6096$export$e4cf37d7f6fb9e0a = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $03753aa7640d6096$export$f99ded8fe4b79145, (v) => $03753aa7640d6096$export$f99ded8fe4b79145 = v);
$parcel$export(module.exports, "kMaxLength", () => $03753aa7640d6096$export$599f31c3813fae4d, (v) => $03753aa7640d6096$export$599f31c3813fae4d = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $03753aa7640d6096$export$a143d493d941bafc;
var $03753aa7640d6096$export$e4cf37d7f6fb9e0a;
var $03753aa7640d6096$export$f99ded8fe4b79145;
var $03753aa7640d6096$export$599f31c3813fae4d;
"use strict";

var $jU1w1 = parcelRequire("jU1w1");

var $eZp9s = parcelRequire("eZp9s");
const $03753aa7640d6096$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$03753aa7640d6096$export$a143d493d941bafc = $03753aa7640d6096$var$Buffer;
$03753aa7640d6096$export$e4cf37d7f6fb9e0a = $03753aa7640d6096$var$SlowBuffer;
$03753aa7640d6096$export$f99ded8fe4b79145 = 50;
const $03753aa7640d6096$var$K_MAX_LENGTH = 0x7fffffff;
$03753aa7640d6096$export$599f31c3813fae4d = $03753aa7640d6096$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $03753aa7640d6096$var$Buffer.TYPED_ARRAY_SUPPORT = $03753aa7640d6096$var$typedArraySupport();
if (!$03753aa7640d6096$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $03753aa7640d6096$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($03753aa7640d6096$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$03753aa7640d6096$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($03753aa7640d6096$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$03753aa7640d6096$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $03753aa7640d6096$var$createBuffer(length) {
    if (length > $03753aa7640d6096$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $03753aa7640d6096$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $03753aa7640d6096$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $03753aa7640d6096$var$allocUnsafe(arg);
    }
    return $03753aa7640d6096$var$from(arg, encodingOrOffset, length);
}
$03753aa7640d6096$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $03753aa7640d6096$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $03753aa7640d6096$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $03753aa7640d6096$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($03753aa7640d6096$var$isInstance(value, ArrayBuffer) || value && $03753aa7640d6096$var$isInstance(value.buffer, ArrayBuffer)) return $03753aa7640d6096$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($03753aa7640d6096$var$isInstance(value, SharedArrayBuffer) || value && $03753aa7640d6096$var$isInstance(value.buffer, SharedArrayBuffer))) return $03753aa7640d6096$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $03753aa7640d6096$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $03753aa7640d6096$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $03753aa7640d6096$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $03753aa7640d6096$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $03753aa7640d6096$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($03753aa7640d6096$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($03753aa7640d6096$var$Buffer, Uint8Array);
function $03753aa7640d6096$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $03753aa7640d6096$var$alloc(size, fill, encoding) {
    $03753aa7640d6096$var$assertSize(size);
    if (size <= 0) return $03753aa7640d6096$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $03753aa7640d6096$var$createBuffer(size).fill(fill, encoding) : $03753aa7640d6096$var$createBuffer(size).fill(fill);
    return $03753aa7640d6096$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $03753aa7640d6096$var$Buffer.alloc = function(size, fill, encoding) {
    return $03753aa7640d6096$var$alloc(size, fill, encoding);
};
function $03753aa7640d6096$var$allocUnsafe(size) {
    $03753aa7640d6096$var$assertSize(size);
    return $03753aa7640d6096$var$createBuffer(size < 0 ? 0 : $03753aa7640d6096$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $03753aa7640d6096$var$Buffer.allocUnsafe = function(size) {
    return $03753aa7640d6096$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $03753aa7640d6096$var$Buffer.allocUnsafeSlow = function(size) {
    return $03753aa7640d6096$var$allocUnsafe(size);
};
function $03753aa7640d6096$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$03753aa7640d6096$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $03753aa7640d6096$var$byteLength(string, encoding) | 0;
    let buf = $03753aa7640d6096$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $03753aa7640d6096$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $03753aa7640d6096$var$checked(array.length) | 0;
    const buf = $03753aa7640d6096$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $03753aa7640d6096$var$fromArrayView(arrayView) {
    if ($03753aa7640d6096$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $03753aa7640d6096$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $03753aa7640d6096$var$fromArrayLike(arrayView);
}
function $03753aa7640d6096$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $03753aa7640d6096$var$Buffer.prototype);
    return buf;
}
function $03753aa7640d6096$var$fromObject(obj) {
    if ($03753aa7640d6096$var$Buffer.isBuffer(obj)) {
        const len = $03753aa7640d6096$var$checked(obj.length) | 0;
        const buf = $03753aa7640d6096$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $03753aa7640d6096$var$numberIsNaN(obj.length)) return $03753aa7640d6096$var$createBuffer(0);
        return $03753aa7640d6096$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $03753aa7640d6096$var$fromArrayLike(obj.data);
}
function $03753aa7640d6096$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $03753aa7640d6096$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $03753aa7640d6096$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $03753aa7640d6096$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $03753aa7640d6096$var$Buffer.alloc(+length);
}
$03753aa7640d6096$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $03753aa7640d6096$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$03753aa7640d6096$var$Buffer.compare = function compare(a, b) {
    if ($03753aa7640d6096$var$isInstance(a, Uint8Array)) a = $03753aa7640d6096$var$Buffer.from(a, a.offset, a.byteLength);
    if ($03753aa7640d6096$var$isInstance(b, Uint8Array)) b = $03753aa7640d6096$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$03753aa7640d6096$var$Buffer.isBuffer(a) || !$03753aa7640d6096$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$03753aa7640d6096$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$03753aa7640d6096$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $03753aa7640d6096$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $03753aa7640d6096$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($03753aa7640d6096$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$03753aa7640d6096$var$Buffer.isBuffer(buf)) buf = $03753aa7640d6096$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$03753aa7640d6096$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $03753aa7640d6096$var$byteLength(string, encoding) {
    if ($03753aa7640d6096$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $03753aa7640d6096$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $03753aa7640d6096$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $03753aa7640d6096$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $03753aa7640d6096$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$03753aa7640d6096$var$Buffer.byteLength = $03753aa7640d6096$var$byteLength;
function $03753aa7640d6096$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $03753aa7640d6096$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $03753aa7640d6096$var$utf8Slice(this, start, end);
        case "ascii":
            return $03753aa7640d6096$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $03753aa7640d6096$var$latin1Slice(this, start, end);
        case "base64":
            return $03753aa7640d6096$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $03753aa7640d6096$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$03753aa7640d6096$var$Buffer.prototype._isBuffer = true;
function $03753aa7640d6096$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$03753aa7640d6096$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$03753aa7640d6096$var$swap(this, i, i + 1);
    return this;
};
$03753aa7640d6096$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $03753aa7640d6096$var$swap(this, i, i + 3);
        $03753aa7640d6096$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$03753aa7640d6096$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $03753aa7640d6096$var$swap(this, i, i + 7);
        $03753aa7640d6096$var$swap(this, i + 1, i + 6);
        $03753aa7640d6096$var$swap(this, i + 2, i + 5);
        $03753aa7640d6096$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$03753aa7640d6096$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $03753aa7640d6096$var$utf8Slice(this, 0, length);
    return $03753aa7640d6096$var$slowToString.apply(this, arguments);
};
$03753aa7640d6096$var$Buffer.prototype.toLocaleString = $03753aa7640d6096$var$Buffer.prototype.toString;
$03753aa7640d6096$var$Buffer.prototype.equals = function equals(b) {
    if (!$03753aa7640d6096$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $03753aa7640d6096$var$Buffer.compare(this, b) === 0;
};
$03753aa7640d6096$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $03753aa7640d6096$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($03753aa7640d6096$var$customInspectSymbol) $03753aa7640d6096$var$Buffer.prototype[$03753aa7640d6096$var$customInspectSymbol] = $03753aa7640d6096$var$Buffer.prototype.inspect;
$03753aa7640d6096$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($03753aa7640d6096$var$isInstance(target, Uint8Array)) target = $03753aa7640d6096$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$03753aa7640d6096$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $03753aa7640d6096$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($03753aa7640d6096$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $03753aa7640d6096$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($03753aa7640d6096$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $03753aa7640d6096$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $03753aa7640d6096$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $03753aa7640d6096$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$03753aa7640d6096$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$03753aa7640d6096$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $03753aa7640d6096$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$03753aa7640d6096$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $03753aa7640d6096$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $03753aa7640d6096$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($03753aa7640d6096$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $03753aa7640d6096$var$utf8Write(buf, string, offset, length) {
    return $03753aa7640d6096$var$blitBuffer($03753aa7640d6096$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $03753aa7640d6096$var$asciiWrite(buf, string, offset, length) {
    return $03753aa7640d6096$var$blitBuffer($03753aa7640d6096$var$asciiToBytes(string), buf, offset, length);
}
function $03753aa7640d6096$var$base64Write(buf, string, offset, length) {
    return $03753aa7640d6096$var$blitBuffer($03753aa7640d6096$var$base64ToBytes(string), buf, offset, length);
}
function $03753aa7640d6096$var$ucs2Write(buf, string, offset, length) {
    return $03753aa7640d6096$var$blitBuffer($03753aa7640d6096$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$03753aa7640d6096$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $03753aa7640d6096$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $03753aa7640d6096$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $03753aa7640d6096$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $03753aa7640d6096$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $03753aa7640d6096$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$03753aa7640d6096$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $03753aa7640d6096$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $jU1w1.fromByteArray(buf);
    else return $jU1w1.fromByteArray(buf.slice(start, end));
}
function $03753aa7640d6096$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $03753aa7640d6096$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $03753aa7640d6096$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $03753aa7640d6096$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $03753aa7640d6096$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $03753aa7640d6096$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $03753aa7640d6096$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $03753aa7640d6096$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $03753aa7640d6096$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $03753aa7640d6096$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $03753aa7640d6096$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$03753aa7640d6096$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $03753aa7640d6096$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $03753aa7640d6096$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$03753aa7640d6096$var$Buffer.prototype.readUintLE = $03753aa7640d6096$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $03753aa7640d6096$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$03753aa7640d6096$var$Buffer.prototype.readUintBE = $03753aa7640d6096$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $03753aa7640d6096$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$03753aa7640d6096$var$Buffer.prototype.readUint8 = $03753aa7640d6096$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $03753aa7640d6096$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$03753aa7640d6096$var$Buffer.prototype.readUint16LE = $03753aa7640d6096$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $03753aa7640d6096$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$03753aa7640d6096$var$Buffer.prototype.readUint16BE = $03753aa7640d6096$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $03753aa7640d6096$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$03753aa7640d6096$var$Buffer.prototype.readUint32LE = $03753aa7640d6096$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $03753aa7640d6096$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$03753aa7640d6096$var$Buffer.prototype.readUint32BE = $03753aa7640d6096$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $03753aa7640d6096$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$03753aa7640d6096$var$Buffer.prototype.readBigUInt64LE = $03753aa7640d6096$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $03753aa7640d6096$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $03753aa7640d6096$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$03753aa7640d6096$var$Buffer.prototype.readBigUInt64BE = $03753aa7640d6096$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $03753aa7640d6096$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $03753aa7640d6096$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$03753aa7640d6096$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $03753aa7640d6096$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$03753aa7640d6096$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $03753aa7640d6096$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$03753aa7640d6096$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $03753aa7640d6096$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$03753aa7640d6096$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $03753aa7640d6096$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$03753aa7640d6096$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $03753aa7640d6096$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$03753aa7640d6096$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $03753aa7640d6096$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$03753aa7640d6096$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $03753aa7640d6096$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$03753aa7640d6096$var$Buffer.prototype.readBigInt64LE = $03753aa7640d6096$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $03753aa7640d6096$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $03753aa7640d6096$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$03753aa7640d6096$var$Buffer.prototype.readBigInt64BE = $03753aa7640d6096$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $03753aa7640d6096$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $03753aa7640d6096$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$03753aa7640d6096$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $03753aa7640d6096$var$checkOffset(offset, 4, this.length);
    return $eZp9s.read(this, offset, true, 23, 4);
};
$03753aa7640d6096$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $03753aa7640d6096$var$checkOffset(offset, 4, this.length);
    return $eZp9s.read(this, offset, false, 23, 4);
};
$03753aa7640d6096$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $03753aa7640d6096$var$checkOffset(offset, 8, this.length);
    return $eZp9s.read(this, offset, true, 52, 8);
};
$03753aa7640d6096$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $03753aa7640d6096$var$checkOffset(offset, 8, this.length);
    return $eZp9s.read(this, offset, false, 52, 8);
};
function $03753aa7640d6096$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$03753aa7640d6096$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$03753aa7640d6096$var$Buffer.prototype.writeUintLE = $03753aa7640d6096$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $03753aa7640d6096$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$03753aa7640d6096$var$Buffer.prototype.writeUintBE = $03753aa7640d6096$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $03753aa7640d6096$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$03753aa7640d6096$var$Buffer.prototype.writeUint8 = $03753aa7640d6096$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $03753aa7640d6096$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$03753aa7640d6096$var$Buffer.prototype.writeUint16LE = $03753aa7640d6096$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $03753aa7640d6096$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$03753aa7640d6096$var$Buffer.prototype.writeUint16BE = $03753aa7640d6096$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $03753aa7640d6096$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$03753aa7640d6096$var$Buffer.prototype.writeUint32LE = $03753aa7640d6096$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $03753aa7640d6096$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$03753aa7640d6096$var$Buffer.prototype.writeUint32BE = $03753aa7640d6096$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $03753aa7640d6096$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $03753aa7640d6096$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $03753aa7640d6096$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $03753aa7640d6096$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $03753aa7640d6096$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$03753aa7640d6096$var$Buffer.prototype.writeBigUInt64LE = $03753aa7640d6096$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $03753aa7640d6096$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$03753aa7640d6096$var$Buffer.prototype.writeBigUInt64BE = $03753aa7640d6096$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $03753aa7640d6096$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$03753aa7640d6096$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $03753aa7640d6096$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$03753aa7640d6096$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $03753aa7640d6096$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$03753aa7640d6096$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $03753aa7640d6096$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$03753aa7640d6096$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $03753aa7640d6096$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$03753aa7640d6096$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $03753aa7640d6096$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$03753aa7640d6096$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $03753aa7640d6096$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$03753aa7640d6096$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $03753aa7640d6096$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$03753aa7640d6096$var$Buffer.prototype.writeBigInt64LE = $03753aa7640d6096$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $03753aa7640d6096$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$03753aa7640d6096$var$Buffer.prototype.writeBigInt64BE = $03753aa7640d6096$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $03753aa7640d6096$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $03753aa7640d6096$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $03753aa7640d6096$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $03753aa7640d6096$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $eZp9s.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$03753aa7640d6096$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $03753aa7640d6096$var$writeFloat(this, value, offset, true, noAssert);
};
$03753aa7640d6096$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $03753aa7640d6096$var$writeFloat(this, value, offset, false, noAssert);
};
function $03753aa7640d6096$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $03753aa7640d6096$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $eZp9s.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$03753aa7640d6096$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $03753aa7640d6096$var$writeDouble(this, value, offset, true, noAssert);
};
$03753aa7640d6096$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $03753aa7640d6096$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$03753aa7640d6096$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$03753aa7640d6096$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$03753aa7640d6096$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$03753aa7640d6096$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $03753aa7640d6096$var$Buffer.isBuffer(val) ? val : $03753aa7640d6096$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $03753aa7640d6096$var$errors = {};
function $03753aa7640d6096$var$E(sym, getMessage, Base) {
    $03753aa7640d6096$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$03753aa7640d6096$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$03753aa7640d6096$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$03753aa7640d6096$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $03753aa7640d6096$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $03753aa7640d6096$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $03753aa7640d6096$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $03753aa7640d6096$var$checkBounds(buf, offset, byteLength) {
    $03753aa7640d6096$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $03753aa7640d6096$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $03753aa7640d6096$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $03753aa7640d6096$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $03753aa7640d6096$var$checkBounds(buf, offset, byteLength);
}
function $03753aa7640d6096$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $03753aa7640d6096$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $03753aa7640d6096$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $03753aa7640d6096$var$validateNumber(value, type);
        throw new $03753aa7640d6096$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $03753aa7640d6096$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $03753aa7640d6096$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $03753aa7640d6096$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $03753aa7640d6096$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($03753aa7640d6096$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $03753aa7640d6096$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $03753aa7640d6096$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $03753aa7640d6096$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $03753aa7640d6096$var$base64ToBytes(str) {
    return $jU1w1.toByteArray($03753aa7640d6096$var$base64clean(str));
}
function $03753aa7640d6096$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $03753aa7640d6096$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $03753aa7640d6096$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $03753aa7640d6096$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $03753aa7640d6096$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $03753aa7640d6096$var$BufferBigIntNotDefined : fn;
}
function $03753aa7640d6096$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});
parcelRegister("jU1w1", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $e7d46c33bab09e74$export$d622b2ad8d90c771, (v) => $e7d46c33bab09e74$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $e7d46c33bab09e74$export$6100ba28696e12de, (v) => $e7d46c33bab09e74$export$6100ba28696e12de = v);
var $e7d46c33bab09e74$export$a48f0734ac7c2329;
var $e7d46c33bab09e74$export$d622b2ad8d90c771;
var $e7d46c33bab09e74$export$6100ba28696e12de;
"use strict";
$e7d46c33bab09e74$export$a48f0734ac7c2329 = $e7d46c33bab09e74$var$byteLength;
$e7d46c33bab09e74$export$d622b2ad8d90c771 = $e7d46c33bab09e74$var$toByteArray;
$e7d46c33bab09e74$export$6100ba28696e12de = $e7d46c33bab09e74$var$fromByteArray;
var $e7d46c33bab09e74$var$lookup = [];
var $e7d46c33bab09e74$var$revLookup = [];
var $e7d46c33bab09e74$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $e7d46c33bab09e74$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $e7d46c33bab09e74$var$i = 0, $e7d46c33bab09e74$var$len = $e7d46c33bab09e74$var$code.length; $e7d46c33bab09e74$var$i < $e7d46c33bab09e74$var$len; ++$e7d46c33bab09e74$var$i){
    $e7d46c33bab09e74$var$lookup[$e7d46c33bab09e74$var$i] = $e7d46c33bab09e74$var$code[$e7d46c33bab09e74$var$i];
    $e7d46c33bab09e74$var$revLookup[$e7d46c33bab09e74$var$code.charCodeAt($e7d46c33bab09e74$var$i)] = $e7d46c33bab09e74$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$e7d46c33bab09e74$var$revLookup["-".charCodeAt(0)] = 62;
$e7d46c33bab09e74$var$revLookup["_".charCodeAt(0)] = 63;
function $e7d46c33bab09e74$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $e7d46c33bab09e74$var$byteLength(b64) {
    var lens = $e7d46c33bab09e74$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $e7d46c33bab09e74$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $e7d46c33bab09e74$var$toByteArray(b64) {
    var tmp;
    var lens = $e7d46c33bab09e74$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $e7d46c33bab09e74$var$Arr($e7d46c33bab09e74$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $e7d46c33bab09e74$var$revLookup[b64.charCodeAt(i)] << 18 | $e7d46c33bab09e74$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $e7d46c33bab09e74$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $e7d46c33bab09e74$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $e7d46c33bab09e74$var$revLookup[b64.charCodeAt(i)] << 2 | $e7d46c33bab09e74$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $e7d46c33bab09e74$var$revLookup[b64.charCodeAt(i)] << 10 | $e7d46c33bab09e74$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $e7d46c33bab09e74$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $e7d46c33bab09e74$var$tripletToBase64(num) {
    return $e7d46c33bab09e74$var$lookup[num >> 18 & 0x3F] + $e7d46c33bab09e74$var$lookup[num >> 12 & 0x3F] + $e7d46c33bab09e74$var$lookup[num >> 6 & 0x3F] + $e7d46c33bab09e74$var$lookup[num & 0x3F];
}
function $e7d46c33bab09e74$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($e7d46c33bab09e74$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $e7d46c33bab09e74$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($e7d46c33bab09e74$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($e7d46c33bab09e74$var$lookup[tmp >> 2] + $e7d46c33bab09e74$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($e7d46c33bab09e74$var$lookup[tmp >> 10] + $e7d46c33bab09e74$var$lookup[tmp >> 4 & 0x3F] + $e7d46c33bab09e74$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("eZp9s", function(module, exports) {

$parcel$export(module.exports, "read", () => $ae9a45bfab5266e7$export$aafa59e2e03f2942, (v) => $ae9a45bfab5266e7$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $ae9a45bfab5266e7$export$68d8715fc104d294, (v) => $ae9a45bfab5266e7$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $ae9a45bfab5266e7$export$aafa59e2e03f2942;
var $ae9a45bfab5266e7$export$68d8715fc104d294;
$ae9a45bfab5266e7$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$ae9a45bfab5266e7$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});





parcelRegister("lvwFy", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa85d5a31fb1fbc9$export$2e2bcd8739ae039);

var $4XH08 = parcelRequire("4XH08");
"use strict";
class $fa85d5a31fb1fbc9$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $4XH08.default).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $fa85d5a31fb1fbc9$export$2e2bcd8739ae039 = $fa85d5a31fb1fbc9$var$InterceptorManager;

});

parcelRegister("dozAp", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c091eecaf2ee612$export$2e2bcd8739ae039);

var $h5bDM = parcelRequire("h5bDM");

var $2A3ns = parcelRequire("2A3ns");

var $1w8Ed = parcelRequire("1w8Ed");

var $kQSDV = parcelRequire("kQSDV");

var $7RmVV = parcelRequire("7RmVV");

var $5fP8B = parcelRequire("5fP8B");
"use strict";
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $9c091eecaf2ee612$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $kQSDV.default)(null, config);
}
function $9c091eecaf2ee612$export$2e2bcd8739ae039(config) {
    $9c091eecaf2ee612$var$throwIfCancellationRequested(config);
    config.headers = (0, $7RmVV.default).from(config.headers);
    // Transform request data
    config.data = (0, $h5bDM.default).call(config, config.transformRequest);
    if ([
        "post",
        "put",
        "patch"
    ].indexOf(config.method) !== -1) config.headers.setContentType("application/x-www-form-urlencoded", false);
    const adapter = (0, $5fP8B.default).getAdapter(config.adapter || (0, $1w8Ed.default).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $9c091eecaf2ee612$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $h5bDM.default).call(config, config.transformResponse, response);
        response.headers = (0, $7RmVV.default).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $2A3ns.default)(reason)) {
            $9c091eecaf2ee612$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $h5bDM.default).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $7RmVV.default).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}

});
parcelRegister("h5bDM", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6fbeee79c15abb8$export$2e2bcd8739ae039);

var $4XH08 = parcelRequire("4XH08");

var $1w8Ed = parcelRequire("1w8Ed");

var $7RmVV = parcelRequire("7RmVV");
"use strict";
function $c6fbeee79c15abb8$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $1w8Ed.default);
    const context = response || config;
    const headers = (0, $7RmVV.default).from(context.headers);
    let data = context.data;
    (0, $4XH08.default).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}

});
parcelRegister("1w8Ed", function(module, exports) {

$parcel$export(module.exports, "default", () => $11af7cda3ed64f8c$export$2e2bcd8739ae039);

var $4XH08 = parcelRequire("4XH08");

var $gm1iz = parcelRequire("gm1iz");

var $iN8DD = parcelRequire("iN8DD");

var $57jd0 = parcelRequire("57jd0");

var $h9CAN = parcelRequire("h9CAN");

var $aH9xj = parcelRequire("aH9xj");

var $3KAH7 = parcelRequire("3KAH7");
"use strict";
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $11af7cda3ed64f8c$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $4XH08.default).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $4XH08.default).trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $11af7cda3ed64f8c$var$defaults = {
    transitional: (0, $iN8DD.default),
    adapter: [
        "xhr",
        "http",
        "fetch"
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || "";
            const hasJSONContentType = contentType.indexOf("application/json") > -1;
            const isObjectPayload = (0, $4XH08.default).isObject(data);
            if (isObjectPayload && (0, $4XH08.default).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $4XH08.default).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $3KAH7.default)(data)) : data;
            if ((0, $4XH08.default).isArrayBuffer(data) || (0, $4XH08.default).isBuffer(data) || (0, $4XH08.default).isStream(data) || (0, $4XH08.default).isFile(data) || (0, $4XH08.default).isBlob(data) || (0, $4XH08.default).isReadableStream(data)) return data;
            if ((0, $4XH08.default).isArrayBufferView(data)) return data.buffer;
            if ((0, $4XH08.default).isURLSearchParams(data)) {
                headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf("application/x-www-form-urlencoded") > -1) return (0, $h9CAN.default)(data, this.formSerializer).toString();
                if ((isFileList = (0, $4XH08.default).isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $57jd0.default)(isFileList ? {
                        "files[]": data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType("application/json", false);
                return $11af7cda3ed64f8c$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $11af7cda3ed64f8c$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === "json";
            if ((0, $4XH08.default).isResponse(data) || (0, $4XH08.default).isReadableStream(data)) return data;
            if (data && (0, $4XH08.default).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === "SyntaxError") throw (0, $gm1iz.default).from(e, (0, $gm1iz.default).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $aH9xj.default).classes.FormData,
        Blob: (0, $aH9xj.default).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*",
            "Content-Type": undefined
        }
    }
};
(0, $4XH08.default).forEach([
    "delete",
    "get",
    "head",
    "post",
    "put",
    "patch"
], (method)=>{
    $11af7cda3ed64f8c$var$defaults.headers[method] = {};
});
var $11af7cda3ed64f8c$export$2e2bcd8739ae039 = $11af7cda3ed64f8c$var$defaults;

});
parcelRegister("iN8DD", function(module, exports) {

$parcel$export(module.exports, "default", () => $dae380f5fba26152$export$2e2bcd8739ae039);
"use strict";
var $dae380f5fba26152$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};

});

parcelRegister("h9CAN", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7d13699b033c625$export$2e2bcd8739ae039);

var $4XH08 = parcelRequire("4XH08");

var $57jd0 = parcelRequire("57jd0");

var $aH9xj = parcelRequire("aH9xj");
"use strict";
function $c7d13699b033c625$export$2e2bcd8739ae039(data, options) {
    return (0, $57jd0.default)(data, new (0, $aH9xj.default).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $aH9xj.default).isNode && (0, $4XH08.default).isBuffer(value)) {
                this.append(key, value.toString("base64"));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}

});
parcelRegister("aH9xj", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c9551414ff314a6$export$2e2bcd8739ae039);

var $5oiWk = parcelRequire("5oiWk");

var $dbh1C = parcelRequire("dbh1C");
var $7c9551414ff314a6$export$2e2bcd8739ae039 = {
    ...$dbh1C,
    ...(0, $5oiWk.default)
};

});
parcelRegister("5oiWk", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ecde2aeaa80af24$export$2e2bcd8739ae039);

var $jMvex = parcelRequire("jMvex");

var $kdnaS = parcelRequire("kdnaS");

var $e3dZN = parcelRequire("e3dZN");
var $3ecde2aeaa80af24$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $jMvex.default,
        FormData: $kdnaS.default,
        Blob: $e3dZN.default
    },
    protocols: [
        "http",
        "https",
        "file",
        "blob",
        "url",
        "data"
    ]
};

});
parcelRegister("jMvex", function(module, exports) {

$parcel$export(module.exports, "default", () => $e66aba59179fe80d$export$2e2bcd8739ae039);

var $7vTLH = parcelRequire("7vTLH");
"use strict";
var $e66aba59179fe80d$export$2e2bcd8739ae039 = typeof URLSearchParams !== "undefined" ? URLSearchParams : (0, $7vTLH.default);

});

parcelRegister("kdnaS", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb76ff873a457510$export$2e2bcd8739ae039);
"use strict";
var $eb76ff873a457510$export$2e2bcd8739ae039 = typeof FormData !== "undefined" ? FormData : null;

});

parcelRegister("e3dZN", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3ac33c5585d6011$export$2e2bcd8739ae039);
"use strict";
var $a3ac33c5585d6011$export$2e2bcd8739ae039 = typeof Blob !== "undefined" ? Blob : null;

});


parcelRegister("dbh1C", function(module, exports) {

$parcel$export(module.exports, "hasBrowserEnv", () => $998982488263bc93$export$c4996c4b7b93b0bf);
$parcel$export(module.exports, "navigator", () => $998982488263bc93$export$ec7c8efa7f5790ae);
$parcel$export(module.exports, "hasStandardBrowserEnv", () => $998982488263bc93$export$c0bcc9250309d66);
$parcel$export(module.exports, "hasStandardBrowserWebWorkerEnv", () => $998982488263bc93$export$c81692cf5af97dac);
$parcel$export(module.exports, "origin", () => $998982488263bc93$export$f710a83a91838a36);
const $998982488263bc93$export$c4996c4b7b93b0bf = typeof window !== "undefined" && typeof document !== "undefined";
const $998982488263bc93$export$ec7c8efa7f5790ae = typeof navigator === "object" && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $998982488263bc93$export$c0bcc9250309d66 = $998982488263bc93$export$c4996c4b7b93b0bf && (!$998982488263bc93$export$ec7c8efa7f5790ae || [
    "ReactNative",
    "NativeScript",
    "NS"
].indexOf($998982488263bc93$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $998982488263bc93$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
})();
const $998982488263bc93$export$f710a83a91838a36 = $998982488263bc93$export$c4996c4b7b93b0bf && window.location.href || "http://localhost";

});



parcelRegister("3KAH7", function(module, exports) {

$parcel$export(module.exports, "default", () => $2bb221c15e7a6ed7$export$2e2bcd8739ae039);

var $4XH08 = parcelRequire("4XH08");
"use strict";
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $2bb221c15e7a6ed7$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $4XH08.default).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === "[]" ? "" : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $2bb221c15e7a6ed7$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $2bb221c15e7a6ed7$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === "__proto__") return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $4XH08.default).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $4XH08.default).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $4XH08.default).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $4XH08.default).isArray(target[name])) target[name] = $2bb221c15e7a6ed7$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $4XH08.default).isFormData(formData) && (0, $4XH08.default).isFunction(formData.entries)) {
        const obj = {};
        (0, $4XH08.default).forEachEntry(formData, (name, value)=>{
            buildPath($2bb221c15e7a6ed7$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $2bb221c15e7a6ed7$export$2e2bcd8739ae039 = $2bb221c15e7a6ed7$var$formDataToJSON;

});


parcelRegister("7RmVV", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b8f45b45ade66a7$export$2e2bcd8739ae039);

var $4XH08 = parcelRequire("4XH08");

var $67QN2 = parcelRequire("67QN2");
"use strict";
const $5b8f45b45ade66a7$var$$internals = Symbol("internals");
function $5b8f45b45ade66a7$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $5b8f45b45ade66a7$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $4XH08.default).isArray(value) ? value.map($5b8f45b45ade66a7$var$normalizeValue) : String(value);
}
function $5b8f45b45ade66a7$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $5b8f45b45ade66a7$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $5b8f45b45ade66a7$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $4XH08.default).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $4XH08.default).isString(value)) return;
    if ((0, $4XH08.default).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $4XH08.default).isRegExp(filter)) return filter.test(value);
}
function $5b8f45b45ade66a7$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $5b8f45b45ade66a7$var$buildAccessors(obj, header) {
    const accessorName = (0, $4XH08.default).toCamelCase(" " + header);
    [
        "get",
        "set",
        "has"
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $5b8f45b45ade66a7$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $5b8f45b45ade66a7$var$normalizeHeader(_header);
            if (!lHeader) throw new Error("header name must be a non-empty string");
            const key = (0, $4XH08.default).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $5b8f45b45ade66a7$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $4XH08.default).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $4XH08.default).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $4XH08.default).isString(header) && (header = header.trim()) && !$5b8f45b45ade66a7$var$isValidHeaderName(header)) setHeaders((0, $67QN2.default)(header), valueOrRewrite);
        else if ((0, $4XH08.default).isHeaders(header)) for (const [key, value] of header.entries())setHeader(value, key, rewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $5b8f45b45ade66a7$var$normalizeHeader(header);
        if (header) {
            const key = (0, $4XH08.default).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $5b8f45b45ade66a7$var$parseTokens(value);
                if ((0, $4XH08.default).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $4XH08.default).isRegExp(parser)) return parser.exec(value);
                throw new TypeError("parser must be boolean|regexp|function");
            }
        }
    }
    has(header, matcher) {
        header = $5b8f45b45ade66a7$var$normalizeHeader(header);
        if (header) {
            const key = (0, $4XH08.default).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $5b8f45b45ade66a7$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $5b8f45b45ade66a7$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $4XH08.default).findKey(self, _header);
                if (key && (!matcher || $5b8f45b45ade66a7$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $4XH08.default).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $5b8f45b45ade66a7$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $4XH08.default).forEach(this, (value, header)=>{
            const key = (0, $4XH08.default).findKey(headers, header);
            if (key) {
                self[key] = $5b8f45b45ade66a7$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $5b8f45b45ade66a7$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $5b8f45b45ade66a7$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $4XH08.default).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $4XH08.default).isArray(value) ? value.join(", ") : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ": " + value).join("\n");
    }
    get [Symbol.toStringTag]() {
        return "AxiosHeaders";
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$5b8f45b45ade66a7$var$$internals] = this[$5b8f45b45ade66a7$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $5b8f45b45ade66a7$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $5b8f45b45ade66a7$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $4XH08.default).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$5b8f45b45ade66a7$var$AxiosHeaders.accessor([
    "Content-Type",
    "Content-Length",
    "Accept",
    "Accept-Encoding",
    "User-Agent",
    "Authorization"
]);
// reserved names hotfix
(0, $4XH08.default).reduceDescriptors($5b8f45b45ade66a7$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $4XH08.default).freezeMethods($5b8f45b45ade66a7$var$AxiosHeaders);
var $5b8f45b45ade66a7$export$2e2bcd8739ae039 = $5b8f45b45ade66a7$var$AxiosHeaders;

});
parcelRegister("67QN2", function(module, exports) {

$parcel$export(module.exports, "default", () => $475c588455397138$export$2e2bcd8739ae039);

var $4XH08 = parcelRequire("4XH08");
"use strict";
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $475c588455397138$var$ignoreDuplicateOf = (0, $4XH08.default).toObjectSet([
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $475c588455397138$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
        i = line.indexOf(":");
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $475c588455397138$var$ignoreDuplicateOf[key]) return;
        if (key === "set-cookie") {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    });
    return parsed;
};

});



parcelRegister("2A3ns", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e11903746177fad$export$2e2bcd8739ae039);
"use strict";
function $1e11903746177fad$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}

});

parcelRegister("kQSDV", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2e30ce9244ba9cd$export$2e2bcd8739ae039);

var $gm1iz = parcelRequire("gm1iz");

var $4XH08 = parcelRequire("4XH08");
"use strict";
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $f2e30ce9244ba9cd$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $gm1iz.default).call(this, message == null ? "canceled" : message, (0, $gm1iz.default).ERR_CANCELED, config, request);
    this.name = "CanceledError";
}
(0, $4XH08.default).inherits($f2e30ce9244ba9cd$var$CanceledError, (0, $gm1iz.default), {
    __CANCEL__: true
});
var $f2e30ce9244ba9cd$export$2e2bcd8739ae039 = $f2e30ce9244ba9cd$var$CanceledError;

});

parcelRegister("5fP8B", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d360555ee134d2f$export$2e2bcd8739ae039);

var $4XH08 = parcelRequire("4XH08");

var $is9h8 = parcelRequire("is9h8");

var $eRXrG = parcelRequire("eRXrG");

var $3dGH2 = parcelRequire("3dGH2");

var $gm1iz = parcelRequire("gm1iz");
const $3d360555ee134d2f$var$knownAdapters = {
    http: (0, $is9h8.default),
    xhr: (0, $eRXrG.default),
    fetch: (0, $3dGH2.default)
};
(0, $4XH08.default).forEach($3d360555ee134d2f$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, "name", {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, "adapterName", {
            value: value
        });
    }
});
const $3d360555ee134d2f$var$renderReason = (reason)=>`- ${reason}`;
const $3d360555ee134d2f$var$isResolvedHandle = (adapter)=>(0, $4XH08.default).isFunction(adapter) || adapter === null || adapter === false;
var $3d360555ee134d2f$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $4XH08.default).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!$3d360555ee134d2f$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $3d360555ee134d2f$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $gm1iz.default)(`Unknown adapter '${id}'`);
            }
            if (adapter) break;
            rejectedReasons[id || "#" + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? "is not supported by the environment" : "is not available in the build"));
            let s = length ? reasons.length > 1 ? "since :\n" + reasons.map($3d360555ee134d2f$var$renderReason).join("\n") : " " + $3d360555ee134d2f$var$renderReason(reasons[0]) : "as no adapter specified";
            throw new (0, $gm1iz.default)(`There is no suitable adapter to dispatch the request ` + s, "ERR_NOT_SUPPORT");
        }
        return adapter;
    },
    adapters: $3d360555ee134d2f$var$knownAdapters
};

});
parcelRegister("eRXrG", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad34209053e18c8a$export$2e2bcd8739ae039);

var $4XH08 = parcelRequire("4XH08");

var $4L2nE = parcelRequire("4L2nE");

var $iN8DD = parcelRequire("iN8DD");

var $gm1iz = parcelRequire("gm1iz");

var $kQSDV = parcelRequire("kQSDV");

var $2yUrs = parcelRequire("2yUrs");

var $aH9xj = parcelRequire("aH9xj");

var $7RmVV = parcelRequire("7RmVV");

var $10Rd6 = parcelRequire("10Rd6");

var $5Blh4 = parcelRequire("5Blh4");
const $ad34209053e18c8a$var$isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
var $ad34209053e18c8a$export$2e2bcd8739ae039 = $ad34209053e18c8a$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $5Blh4.default)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $7RmVV.default).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener("abort", onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $7RmVV.default).from("getAllResponseHeaders" in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $4L2nE.default)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $gm1iz.default)("Request aborted", (0, $gm1iz.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $gm1iz.default)("Network Error", (0, $gm1iz.default).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? "timeout of " + _config.timeout + "ms exceeded" : "timeout exceeded";
            const transitional = _config.transitional || (0, $iN8DD.default);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $gm1iz.default)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $gm1iz.default).ETIMEDOUT : (0, $gm1iz.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ("setRequestHeader" in request) (0, $4XH08.default).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $4XH08.default).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $10Rd6.progressEventReducer)(onDownloadProgress, true);
            request.addEventListener("progress", downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $10Rd6.progressEventReducer)(onUploadProgress);
            request.upload.addEventListener("progress", uploadThrottled);
            request.upload.addEventListener("loadend", flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $kQSDV.default)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener("abort", onCanceled);
        }
        const protocol = (0, $2yUrs.default)(_config.url);
        if (protocol && (0, $aH9xj.default).protocols.indexOf(protocol) === -1) {
            reject(new (0, $gm1iz.default)("Unsupported protocol " + protocol + ":", (0, $gm1iz.default).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};

});
parcelRegister("4L2nE", function(module, exports) {

$parcel$export(module.exports, "default", () => $376d65e91f5a39ed$export$2e2bcd8739ae039);

var $gm1iz = parcelRequire("gm1iz");
"use strict";
function $376d65e91f5a39ed$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $gm1iz.default)("Request failed with status code " + response.status, [
        (0, $gm1iz.default).ERR_BAD_REQUEST,
        (0, $gm1iz.default).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}

});

parcelRegister("2yUrs", function(module, exports) {

$parcel$export(module.exports, "default", () => $1dda89f2a14823bb$export$2e2bcd8739ae039);
"use strict";
function $1dda89f2a14823bb$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
}

});

parcelRegister("10Rd6", function(module, exports) {

$parcel$export(module.exports, "progressEventReducer", () => $0bcf10f88352ce3c$export$c1b28109d46c3592);
$parcel$export(module.exports, "progressEventDecorator", () => $0bcf10f88352ce3c$export$d9fadd12586c18d6);
$parcel$export(module.exports, "asyncDecorator", () => $0bcf10f88352ce3c$export$5d35863c355a22a9);

var $T7Twj = parcelRequire("T7Twj");

var $lYewA = parcelRequire("lYewA");

var $4XH08 = parcelRequire("4XH08");
const $0bcf10f88352ce3c$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $T7Twj.default)(50, 250);
    return (0, $lYewA.default)((e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? "download" : "upload"]: true
        };
        listener(data);
    }, freq);
};
const $0bcf10f88352ce3c$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $0bcf10f88352ce3c$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $4XH08.default).asap(()=>fn(...args));

});
parcelRegister("T7Twj", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a5b42d97e95a7ad$export$2e2bcd8739ae039);
"use strict";
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $0a5b42d97e95a7ad$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $0a5b42d97e95a7ad$export$2e2bcd8739ae039 = $0a5b42d97e95a7ad$var$speedometer;

});

parcelRegister("lYewA", function(module, exports) {

$parcel$export(module.exports, "default", () => $ffea77dd9b0845b9$export$2e2bcd8739ae039);
/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $ffea77dd9b0845b9$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn.apply(null, args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $ffea77dd9b0845b9$export$2e2bcd8739ae039 = $ffea77dd9b0845b9$var$throttle;

});


parcelRegister("5Blh4", function(module, exports) {

$parcel$export(module.exports, "default", () => $4140e919c3457d05$export$2e2bcd8739ae039);

var $aH9xj = parcelRequire("aH9xj");

var $4XH08 = parcelRequire("4XH08");

var $2BETr = parcelRequire("2BETr");

var $7hQTF = parcelRequire("7hQTF");

var $hYteF = parcelRequire("hYteF");

var $luOh9 = parcelRequire("luOh9");

var $7RmVV = parcelRequire("7RmVV");

var $iy0lg = parcelRequire("iy0lg");
var $4140e919c3457d05$export$2e2bcd8739ae039 = (config)=>{
    const newConfig = (0, $luOh9.default)({}, config);
    let { data: data, withXSRFToken: withXSRFToken, xsrfHeaderName: xsrfHeaderName, xsrfCookieName: xsrfCookieName, headers: headers, auth: auth } = newConfig;
    newConfig.headers = headers = (0, $7RmVV.default).from(headers);
    newConfig.url = (0, $iy0lg.default)((0, $hYteF.default)(newConfig.baseURL, newConfig.url), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set("Authorization", "Basic " + btoa((auth.username || "") + ":" + (auth.password ? unescape(encodeURIComponent(auth.password)) : "")));
    let contentType;
    if ((0, $4XH08.default).isFormData(data)) {
        if ((0, $aH9xj.default).hasStandardBrowserEnv || (0, $aH9xj.default).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // Let the browser set it
        else if ((contentType = headers.getContentType()) !== false) {
            // fix semicolon duplication issue for ReactNative FormData implementation
            const [type, ...tokens] = contentType ? contentType.split(";").map((token)=>token.trim()).filter(Boolean) : [];
            headers.setContentType([
                type || "multipart/form-data",
                ...tokens
            ].join("; "));
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $aH9xj.default).hasStandardBrowserEnv) {
        withXSRFToken && (0, $4XH08.default).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, $2BETr.default)(newConfig.url)) {
            // Add xsrf header
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $7hQTF.default).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};

});
parcelRegister("2BETr", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e5ec1fe117501f8$export$2e2bcd8739ae039);

var $4XH08 = parcelRequire("4XH08");

var $aH9xj = parcelRequire("aH9xj");
"use strict";
var $1e5ec1fe117501f8$export$2e2bcd8739ae039 = (0, $aH9xj.default).hasStandardBrowserEnv ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    const msie = (0, $aH9xj.default).navigator && /(msie|trident)/i.test((0, $aH9xj.default).navigator.userAgent);
    const urlParsingNode = document.createElement("a");
    let originURL;
    /**
    * Parse a URL to discover its components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        let href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        const parsed = (0, $4XH08.default).isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});

parcelRegister("7hQTF", function(module, exports) {

$parcel$export(module.exports, "default", () => $54e32721502ae935$export$2e2bcd8739ae039);

var $4XH08 = parcelRequire("4XH08");

var $aH9xj = parcelRequire("aH9xj");
var $54e32721502ae935$export$2e2bcd8739ae039 = (0, $aH9xj.default).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + "=" + encodeURIComponent(value)
        ];
        (0, $4XH08.default).isNumber(expires) && cookie.push("expires=" + new Date(expires).toGMTString());
        (0, $4XH08.default).isString(path) && cookie.push("path=" + path);
        (0, $4XH08.default).isString(domain) && cookie.push("domain=" + domain);
        secure === true && cookie.push("secure");
        document.cookie = cookie.join("; ");
    },
    read (name) {
        const match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, "", Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};

});

parcelRegister("hYteF", function(module, exports) {

$parcel$export(module.exports, "default", () => $d15eb7d89e50b14a$export$2e2bcd8739ae039);

var $iq039 = parcelRequire("iq039");

var $cpxAY = parcelRequire("cpxAY");
"use strict";
function $d15eb7d89e50b14a$export$2e2bcd8739ae039(baseURL, requestedURL) {
    if (baseURL && !(0, $iq039.default)(requestedURL)) return (0, $cpxAY.default)(baseURL, requestedURL);
    return requestedURL;
}

});
parcelRegister("iq039", function(module, exports) {

$parcel$export(module.exports, "default", () => $d68ab19cc0d1a4ef$export$2e2bcd8739ae039);
"use strict";
function $d68ab19cc0d1a4ef$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

});

parcelRegister("cpxAY", function(module, exports) {

$parcel$export(module.exports, "default", () => $9091e13093f9dc39$export$2e2bcd8739ae039);
"use strict";
function $9091e13093f9dc39$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}

});


parcelRegister("luOh9", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa636600bb56bc37$export$2e2bcd8739ae039);

var $4XH08 = parcelRequire("4XH08");

var $7RmVV = parcelRequire("7RmVV");
"use strict";
const $fa636600bb56bc37$var$headersToObject = (thing)=>thing instanceof (0, $7RmVV.default) ? {
        ...thing
    } : thing;
function $fa636600bb56bc37$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, caseless) {
        if ((0, $4XH08.default).isPlainObject(target) && (0, $4XH08.default).isPlainObject(source)) return (0, $4XH08.default).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $4XH08.default).isPlainObject(source)) return (0, $4XH08.default).merge({}, source);
        else if ((0, $4XH08.default).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, caseless) {
        if (!(0, $4XH08.default).isUndefined(b)) return getMergedValue(a, b, caseless);
        else if (!(0, $4XH08.default).isUndefined(a)) return getMergedValue(undefined, a, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $4XH08.default).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $4XH08.default).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $4XH08.default).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b)=>mergeDeepProperties($fa636600bb56bc37$var$headersToObject(a), $fa636600bb56bc37$var$headersToObject(b), true)
    };
    (0, $4XH08.default).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $4XH08.default).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}

});



parcelRegister("3dGH2", function(module, exports) {

$parcel$export(module.exports, "default", () => $2583b3f297f75589$export$2e2bcd8739ae039);

var $aH9xj = parcelRequire("aH9xj");

var $4XH08 = parcelRequire("4XH08");

var $gm1iz = parcelRequire("gm1iz");

var $5Xbm2 = parcelRequire("5Xbm2");

var $8Mm9e = parcelRequire("8Mm9e");

var $7RmVV = parcelRequire("7RmVV");

var $10Rd6 = parcelRequire("10Rd6");

var $5Blh4 = parcelRequire("5Blh4");

var $4L2nE = parcelRequire("4L2nE");
const $2583b3f297f75589$var$isFetchSupported = typeof fetch === "function" && typeof Request === "function" && typeof Response === "function";
const $2583b3f297f75589$var$isReadableStreamSupported = $2583b3f297f75589$var$isFetchSupported && typeof ReadableStream === "function";
// used only inside the fetch adapter
const $2583b3f297f75589$var$encodeText = $2583b3f297f75589$var$isFetchSupported && (typeof TextEncoder === "function" ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Response(str).arrayBuffer()));
const $2583b3f297f75589$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $2583b3f297f75589$var$supportsRequestStream = $2583b3f297f75589$var$isReadableStreamSupported && $2583b3f297f75589$var$test(()=>{
    let duplexAccessed = false;
    const hasContentType = new Request((0, $aH9xj.default).origin, {
        body: new ReadableStream(),
        method: "POST",
        get duplex () {
            duplexAccessed = true;
            return "half";
        }
    }).headers.has("Content-Type");
    return duplexAccessed && !hasContentType;
});
const $2583b3f297f75589$var$DEFAULT_CHUNK_SIZE = 65536;
const $2583b3f297f75589$var$supportsResponseStream = $2583b3f297f75589$var$isReadableStreamSupported && $2583b3f297f75589$var$test(()=>(0, $4XH08.default).isReadableStream(new Response("").body));
const $2583b3f297f75589$var$resolvers = {
    stream: $2583b3f297f75589$var$supportsResponseStream && ((res)=>res.body)
};
$2583b3f297f75589$var$isFetchSupported && ((res)=>{
    [
        "text",
        "arrayBuffer",
        "blob",
        "formData",
        "stream"
    ].forEach((type)=>{
        !$2583b3f297f75589$var$resolvers[type] && ($2583b3f297f75589$var$resolvers[type] = (0, $4XH08.default).isFunction(res[type]) ? (res)=>res[type]() : (_, config)=>{
            throw new (0, $gm1iz.default)(`Response type '${type}' is not supported`, (0, $gm1iz.default).ERR_NOT_SUPPORT, config);
        });
    });
})(new Response);
const $2583b3f297f75589$var$getBodyLength = async (body)=>{
    if (body == null) return 0;
    if ((0, $4XH08.default).isBlob(body)) return body.size;
    if ((0, $4XH08.default).isSpecCompliantForm(body)) {
        const _request = new Request((0, $aH9xj.default).origin, {
            method: "POST",
            body: body
        });
        return (await _request.arrayBuffer()).byteLength;
    }
    if ((0, $4XH08.default).isArrayBufferView(body) || (0, $4XH08.default).isArrayBuffer(body)) return body.byteLength;
    if ((0, $4XH08.default).isURLSearchParams(body)) body = body + "";
    if ((0, $4XH08.default).isString(body)) return (await $2583b3f297f75589$var$encodeText(body)).byteLength;
};
const $2583b3f297f75589$var$resolveBodyLength = async (headers, body)=>{
    const length = (0, $4XH08.default).toFiniteNumber(headers.getContentLength());
    return length == null ? $2583b3f297f75589$var$getBodyLength(body) : length;
};
var $2583b3f297f75589$export$2e2bcd8739ae039 = $2583b3f297f75589$var$isFetchSupported && (async (config)=>{
    let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = "same-origin", fetchOptions: fetchOptions } = (0, $5Blh4.default)(config);
    responseType = responseType ? (responseType + "").toLowerCase() : "text";
    let composedSignal = (0, $5Xbm2.default)([
        signal,
        cancelToken && cancelToken.toAbortSignal()
    ], timeout);
    let request;
    const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
        composedSignal.unsubscribe();
    });
    let requestContentLength;
    try {
        if (onUploadProgress && $2583b3f297f75589$var$supportsRequestStream && method !== "get" && method !== "head" && (requestContentLength = await $2583b3f297f75589$var$resolveBodyLength(headers, data)) !== 0) {
            let _request = new Request(url, {
                method: "POST",
                body: data,
                duplex: "half"
            });
            let contentTypeHeader;
            if ((0, $4XH08.default).isFormData(data) && (contentTypeHeader = _request.headers.get("content-type"))) headers.setContentType(contentTypeHeader);
            if (_request.body) {
                const [onProgress, flush] = (0, $10Rd6.progressEventDecorator)(requestContentLength, (0, $10Rd6.progressEventReducer)((0, $10Rd6.asyncDecorator)(onUploadProgress)));
                data = (0, $8Mm9e.trackStream)(_request.body, $2583b3f297f75589$var$DEFAULT_CHUNK_SIZE, onProgress, flush);
            }
        }
        if (!(0, $4XH08.default).isString(withCredentials)) withCredentials = withCredentials ? "include" : "omit";
        // Cloudflare Workers throws when credentials are defined
        // see https://github.com/cloudflare/workerd/issues/902
        const isCredentialsSupported = "credentials" in Request.prototype;
        request = new Request(url, {
            ...fetchOptions,
            signal: composedSignal,
            method: method.toUpperCase(),
            headers: headers.normalize().toJSON(),
            body: data,
            duplex: "half",
            credentials: isCredentialsSupported ? withCredentials : undefined
        });
        let response = await fetch(request);
        const isStreamResponse = $2583b3f297f75589$var$supportsResponseStream && (responseType === "stream" || responseType === "response");
        if ($2583b3f297f75589$var$supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
            const options = {};
            [
                "status",
                "statusText",
                "headers"
            ].forEach((prop)=>{
                options[prop] = response[prop];
            });
            const responseContentLength = (0, $4XH08.default).toFiniteNumber(response.headers.get("content-length"));
            const [onProgress, flush] = onDownloadProgress && (0, $10Rd6.progressEventDecorator)(responseContentLength, (0, $10Rd6.progressEventReducer)((0, $10Rd6.asyncDecorator)(onDownloadProgress), true)) || [];
            response = new Response((0, $8Mm9e.trackStream)(response.body, $2583b3f297f75589$var$DEFAULT_CHUNK_SIZE, onProgress, ()=>{
                flush && flush();
                unsubscribe && unsubscribe();
            }), options);
        }
        responseType = responseType || "text";
        let responseData = await $2583b3f297f75589$var$resolvers[(0, $4XH08.default).findKey($2583b3f297f75589$var$resolvers, responseType) || "text"](response, config);
        !isStreamResponse && unsubscribe && unsubscribe();
        return await new Promise((resolve, reject)=>{
            (0, $4L2nE.default)(resolve, reject, {
                data: responseData,
                headers: (0, $7RmVV.default).from(response.headers),
                status: response.status,
                statusText: response.statusText,
                config: config,
                request: request
            });
        });
    } catch (err) {
        unsubscribe && unsubscribe();
        if (err && err.name === "TypeError" && /fetch/i.test(err.message)) throw Object.assign(new (0, $gm1iz.default)("Network Error", (0, $gm1iz.default).ERR_NETWORK, config, request), {
            cause: err.cause || err
        });
        throw (0, $gm1iz.default).from(err, err && err.code, config, request);
    }
});

});
parcelRegister("5Xbm2", function(module, exports) {

$parcel$export(module.exports, "default", () => $455b452de7491cd9$export$2e2bcd8739ae039);

var $kQSDV = parcelRequire("kQSDV");

var $gm1iz = parcelRequire("gm1iz");

var $4XH08 = parcelRequire("4XH08");
const $455b452de7491cd9$var$composeSignals = (signals, timeout)=>{
    const { length: length } = signals = signals ? signals.filter(Boolean) : [];
    if (timeout || length) {
        let controller = new AbortController();
        let aborted;
        const onabort = function(reason) {
            if (!aborted) {
                aborted = true;
                unsubscribe();
                const err = reason instanceof Error ? reason : this.reason;
                controller.abort(err instanceof (0, $gm1iz.default) ? err : new (0, $kQSDV.default)(err instanceof Error ? err.message : err));
            }
        };
        let timer = timeout && setTimeout(()=>{
            timer = null;
            onabort(new (0, $gm1iz.default)(`timeout ${timeout} of ms exceeded`, (0, $gm1iz.default).ETIMEDOUT));
        }, timeout);
        const unsubscribe = ()=>{
            if (signals) {
                timer && clearTimeout(timer);
                timer = null;
                signals.forEach((signal)=>{
                    signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener("abort", onabort);
                });
                signals = null;
            }
        };
        signals.forEach((signal)=>signal.addEventListener("abort", onabort));
        const { signal: signal } = controller;
        signal.unsubscribe = ()=>(0, $4XH08.default).asap(unsubscribe);
        return signal;
    }
};
var $455b452de7491cd9$export$2e2bcd8739ae039 = $455b452de7491cd9$var$composeSignals;

});

parcelRegister("8Mm9e", function(module, exports) {

$parcel$export(module.exports, "trackStream", () => $6643fc84c3024a18$export$b0119225647bd83);
const $6643fc84c3024a18$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $6643fc84c3024a18$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $6643fc84c3024a18$var$readStream(iterable))yield* $6643fc84c3024a18$export$71b051935044bd5d(chunk, chunkSize);
};
const $6643fc84c3024a18$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $6643fc84c3024a18$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $6643fc84c3024a18$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};

});




parcelRegister("6oDno", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a83874552e07095$export$2e2bcd8739ae039);

var $dcZVy = parcelRequire("dcZVy");

var $gm1iz = parcelRequire("gm1iz");
"use strict";
const $4a83874552e07095$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach((type, i)=>{
    $4a83874552e07095$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
const $4a83874552e07095$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $4a83874552e07095$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + (0, $dcZVy.VERSION) + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $gm1iz.default)(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), (0, $gm1iz.default).ERR_DEPRECATED);
        if (version && !$4a83874552e07095$var$deprecatedWarnings[opt]) {
            $4a83874552e07095$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $4a83874552e07095$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new (0, $gm1iz.default)("options must be an object", (0, $gm1iz.default).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $gm1iz.default)("option " + opt + " must be " + result, (0, $gm1iz.default).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $gm1iz.default)("Unknown option " + opt, (0, $gm1iz.default).ERR_BAD_OPTION);
    }
}
var $4a83874552e07095$export$2e2bcd8739ae039 = {
    assertOptions: $4a83874552e07095$var$assertOptions,
    validators: $4a83874552e07095$var$validators
};

});
parcelRegister("dcZVy", function(module, exports) {

$parcel$export(module.exports, "VERSION", () => $99dc6ecee0493099$export$a4ad2735b021c132);
const $99dc6ecee0493099$export$a4ad2735b021c132 = "1.7.7";

});



parcelRegister("aQQwb", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e677fbadf58a29e$export$2e2bcd8739ae039);

var $kQSDV = parcelRequire("kQSDV");
"use strict";
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $7e677fbadf58a29e$var$CancelToken {
    constructor(executor){
        if (typeof executor !== "function") throw new TypeError("executor must be a function.");
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $kQSDV.default)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $7e677fbadf58a29e$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $7e677fbadf58a29e$export$2e2bcd8739ae039 = $7e677fbadf58a29e$var$CancelToken;

});

parcelRegister("axAZq", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ac9add1cc2975b8$export$2e2bcd8739ae039);
"use strict";
function $7ac9add1cc2975b8$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}

});

parcelRegister("dX7P5", function(module, exports) {

$parcel$export(module.exports, "default", () => $a286da891064e8e2$export$2e2bcd8739ae039);

var $4XH08 = parcelRequire("4XH08");
"use strict";
function $a286da891064e8e2$export$2e2bcd8739ae039(payload) {
    return (0, $4XH08.default).isObject(payload) && payload.isAxiosError === true;
}

});

parcelRegister("aM2we", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d80574a4273cef4$export$2e2bcd8739ae039);
const $7d80574a4273cef4$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($7d80574a4273cef4$var$HttpStatusCode).forEach(([key, value])=>{
    $7d80574a4273cef4$var$HttpStatusCode[value] = key;
});
var $7d80574a4273cef4$export$2e2bcd8739ae039 = $7d80574a4273cef4$var$HttpStatusCode;

});



parcelRegister("5I3lV", function(module, exports) {

$parcel$export(module.exports, "default", () => $4283a997586d8ed3$export$2e2bcd8739ae039);

var $j41N8 = parcelRequire("j41N8");

var $kLyDc = parcelRequire("kLyDc");
parcelRequire("9hhok");

var $cdzNP = parcelRequire("cdzNP");


(0, (/*@__PURE__*/$parcel$interopDefault($j41N8))).plugins.unregister((0, (/*@__PURE__*/$parcel$interopDefault($kLyDc))));
var $4283a997586d8ed3$export$2e2bcd8739ae039 = {
    dataBaseUrl: "https://data.basil-ladder.net/",
    eloToMmr (elo) {
        return elo - 1300;
    },
    formatDateTime: function(epochSecond) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($cdzNP))).unix(epochSecond).format("YYYY.MM.DD hh:mm a");
    },
    formatDate: function(epochSecond) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($cdzNP))).unix(epochSecond).format("YYYY.MM.DD");
    },
    racecol: function(race) {
        switch(race){
            case "PROTOSS":
            case "P":
                return "race_protoss";
            case "ZERG":
            case "Z":
                return "race_zerg";
            case "TERRAN":
            case "T":
                return "race_terran";
            case "RANDOM":
            case "R":
                return "race_random";
            default:
                return "race_unknown";
        }
    },
    racename: function(race) {
        switch(race){
            case "PROTOSS":
            case "P":
                return "Protoss";
            case "ZERG":
            case "Z":
                return "Zerg";
            case "TERRAN":
            case "T":
                return "Terran";
            case "RANDOM":
            case "R":
                return "Random";
            default:
                return "Unknown";
        }
    },
    percentFormat: function(value, digits) {
        return new Intl.NumberFormat(undefined, {
            style: "percent",
            minimumFractionDigits: digits || 2
        }).format(value);
    },
    sortByRank: function(data) {
        data.sort(function(a, b) {
            if (a.enabled != b.enabled) {
                if (a.enabled) return -1;
                else return 1;
            }
            let aPlayed = a.won + a.lost;
            let bPlayed = b.won + b.lost;
            if (aPlayed < 30 && bPlayed >= 30) return 1;
            if (bPlayed < 30 && aPlayed >= 30) return -1;
            if (a.rating !== b.rating) return b.rating - a.rating;
            if (a.winRate !== b.winRate) return b.winRate - a.winRate;
            return b.won - a.won;
        });
    },
    rankcol: function(rank) {
        return "rank_" + rank.toLowerCase();
    },
    rankCmp (oldRank, newRank) {
        if (!oldRank || !newRank) return 0;
        return this.rankValue(newRank) - this.rankValue(oldRank);
    },
    percentFormat: function(value, digits) {
        return new Intl.NumberFormat(undefined, {
            style: "percent",
            minimumFractionDigits: digits || 2
        }).format(value);
    },
    rankValue: function(rank) {
        switch(rank){
            case "S":
                return 0;
            case "A":
                return 1;
            case "B":
                return 2;
            case "C":
                return 3;
            case "D":
                return 4;
            case "E":
                return 5;
            case "F":
                return 6;
            case "U":
            case "UNRANKED":
                return 99999;
        }
    },
    sortByRank: function(data) {
        let self = this;
        data.sort(function(a, b) {
            if (a.enabled != b.enabled) {
                if (a.enabled) return -1;
                else return 1;
            }
            let aPlayed = a.won + a.lost;
            let bPlayed = b.won + b.lost;
            if (aPlayed < 30 && bPlayed >= 30) return 1;
            if (bPlayed < 30 && aPlayed >= 30) return -1;
            if (self.rankValue(a.rank) != self.rankValue(b.rank)) return self.rankValue(a.rank) - self.rankValue(b.rank);
            if (a.rating !== b.rating) return b.rating - a.rating;
            if (a.winRate !== b.winRate) return b.winRate - a.winRate;
            return b.won - a.won;
        });
    }
};

});
parcelRegister("j41N8", function(module, exports) {

/*!
 * Chart.js v2.9.4
 * https://www.chartjs.org
 * (c) 2020 Chart.js Contributors
 * Released under the MIT License
 */ (function(global, factory) {
    module.exports = factory(function() {
        try {
            return (parcelRequire("cdzNP"));
        } catch (e) {}
    }());
})(module.exports, function(moment) {
    "use strict";
    moment = moment && moment.hasOwnProperty("default") ? moment["default"] : moment;
    function createCommonjsModule(fn, module1) {
        return module1 = {
            exports: {}
        }, fn(module1, module1.exports), module1.exports;
    }
    function getCjsExportFromNamespace(n) {
        return n && n["default"] || n;
    }
    var colorName = {
        "aliceblue": [
            240,
            248,
            255
        ],
        "antiquewhite": [
            250,
            235,
            215
        ],
        "aqua": [
            0,
            255,
            255
        ],
        "aquamarine": [
            127,
            255,
            212
        ],
        "azure": [
            240,
            255,
            255
        ],
        "beige": [
            245,
            245,
            220
        ],
        "bisque": [
            255,
            228,
            196
        ],
        "black": [
            0,
            0,
            0
        ],
        "blanchedalmond": [
            255,
            235,
            205
        ],
        "blue": [
            0,
            0,
            255
        ],
        "blueviolet": [
            138,
            43,
            226
        ],
        "brown": [
            165,
            42,
            42
        ],
        "burlywood": [
            222,
            184,
            135
        ],
        "cadetblue": [
            95,
            158,
            160
        ],
        "chartreuse": [
            127,
            255,
            0
        ],
        "chocolate": [
            210,
            105,
            30
        ],
        "coral": [
            255,
            127,
            80
        ],
        "cornflowerblue": [
            100,
            149,
            237
        ],
        "cornsilk": [
            255,
            248,
            220
        ],
        "crimson": [
            220,
            20,
            60
        ],
        "cyan": [
            0,
            255,
            255
        ],
        "darkblue": [
            0,
            0,
            139
        ],
        "darkcyan": [
            0,
            139,
            139
        ],
        "darkgoldenrod": [
            184,
            134,
            11
        ],
        "darkgray": [
            169,
            169,
            169
        ],
        "darkgreen": [
            0,
            100,
            0
        ],
        "darkgrey": [
            169,
            169,
            169
        ],
        "darkkhaki": [
            189,
            183,
            107
        ],
        "darkmagenta": [
            139,
            0,
            139
        ],
        "darkolivegreen": [
            85,
            107,
            47
        ],
        "darkorange": [
            255,
            140,
            0
        ],
        "darkorchid": [
            153,
            50,
            204
        ],
        "darkred": [
            139,
            0,
            0
        ],
        "darksalmon": [
            233,
            150,
            122
        ],
        "darkseagreen": [
            143,
            188,
            143
        ],
        "darkslateblue": [
            72,
            61,
            139
        ],
        "darkslategray": [
            47,
            79,
            79
        ],
        "darkslategrey": [
            47,
            79,
            79
        ],
        "darkturquoise": [
            0,
            206,
            209
        ],
        "darkviolet": [
            148,
            0,
            211
        ],
        "deeppink": [
            255,
            20,
            147
        ],
        "deepskyblue": [
            0,
            191,
            255
        ],
        "dimgray": [
            105,
            105,
            105
        ],
        "dimgrey": [
            105,
            105,
            105
        ],
        "dodgerblue": [
            30,
            144,
            255
        ],
        "firebrick": [
            178,
            34,
            34
        ],
        "floralwhite": [
            255,
            250,
            240
        ],
        "forestgreen": [
            34,
            139,
            34
        ],
        "fuchsia": [
            255,
            0,
            255
        ],
        "gainsboro": [
            220,
            220,
            220
        ],
        "ghostwhite": [
            248,
            248,
            255
        ],
        "gold": [
            255,
            215,
            0
        ],
        "goldenrod": [
            218,
            165,
            32
        ],
        "gray": [
            128,
            128,
            128
        ],
        "green": [
            0,
            128,
            0
        ],
        "greenyellow": [
            173,
            255,
            47
        ],
        "grey": [
            128,
            128,
            128
        ],
        "honeydew": [
            240,
            255,
            240
        ],
        "hotpink": [
            255,
            105,
            180
        ],
        "indianred": [
            205,
            92,
            92
        ],
        "indigo": [
            75,
            0,
            130
        ],
        "ivory": [
            255,
            255,
            240
        ],
        "khaki": [
            240,
            230,
            140
        ],
        "lavender": [
            230,
            230,
            250
        ],
        "lavenderblush": [
            255,
            240,
            245
        ],
        "lawngreen": [
            124,
            252,
            0
        ],
        "lemonchiffon": [
            255,
            250,
            205
        ],
        "lightblue": [
            173,
            216,
            230
        ],
        "lightcoral": [
            240,
            128,
            128
        ],
        "lightcyan": [
            224,
            255,
            255
        ],
        "lightgoldenrodyellow": [
            250,
            250,
            210
        ],
        "lightgray": [
            211,
            211,
            211
        ],
        "lightgreen": [
            144,
            238,
            144
        ],
        "lightgrey": [
            211,
            211,
            211
        ],
        "lightpink": [
            255,
            182,
            193
        ],
        "lightsalmon": [
            255,
            160,
            122
        ],
        "lightseagreen": [
            32,
            178,
            170
        ],
        "lightskyblue": [
            135,
            206,
            250
        ],
        "lightslategray": [
            119,
            136,
            153
        ],
        "lightslategrey": [
            119,
            136,
            153
        ],
        "lightsteelblue": [
            176,
            196,
            222
        ],
        "lightyellow": [
            255,
            255,
            224
        ],
        "lime": [
            0,
            255,
            0
        ],
        "limegreen": [
            50,
            205,
            50
        ],
        "linen": [
            250,
            240,
            230
        ],
        "magenta": [
            255,
            0,
            255
        ],
        "maroon": [
            128,
            0,
            0
        ],
        "mediumaquamarine": [
            102,
            205,
            170
        ],
        "mediumblue": [
            0,
            0,
            205
        ],
        "mediumorchid": [
            186,
            85,
            211
        ],
        "mediumpurple": [
            147,
            112,
            219
        ],
        "mediumseagreen": [
            60,
            179,
            113
        ],
        "mediumslateblue": [
            123,
            104,
            238
        ],
        "mediumspringgreen": [
            0,
            250,
            154
        ],
        "mediumturquoise": [
            72,
            209,
            204
        ],
        "mediumvioletred": [
            199,
            21,
            133
        ],
        "midnightblue": [
            25,
            25,
            112
        ],
        "mintcream": [
            245,
            255,
            250
        ],
        "mistyrose": [
            255,
            228,
            225
        ],
        "moccasin": [
            255,
            228,
            181
        ],
        "navajowhite": [
            255,
            222,
            173
        ],
        "navy": [
            0,
            0,
            128
        ],
        "oldlace": [
            253,
            245,
            230
        ],
        "olive": [
            128,
            128,
            0
        ],
        "olivedrab": [
            107,
            142,
            35
        ],
        "orange": [
            255,
            165,
            0
        ],
        "orangered": [
            255,
            69,
            0
        ],
        "orchid": [
            218,
            112,
            214
        ],
        "palegoldenrod": [
            238,
            232,
            170
        ],
        "palegreen": [
            152,
            251,
            152
        ],
        "paleturquoise": [
            175,
            238,
            238
        ],
        "palevioletred": [
            219,
            112,
            147
        ],
        "papayawhip": [
            255,
            239,
            213
        ],
        "peachpuff": [
            255,
            218,
            185
        ],
        "peru": [
            205,
            133,
            63
        ],
        "pink": [
            255,
            192,
            203
        ],
        "plum": [
            221,
            160,
            221
        ],
        "powderblue": [
            176,
            224,
            230
        ],
        "purple": [
            128,
            0,
            128
        ],
        "rebeccapurple": [
            102,
            51,
            153
        ],
        "red": [
            255,
            0,
            0
        ],
        "rosybrown": [
            188,
            143,
            143
        ],
        "royalblue": [
            65,
            105,
            225
        ],
        "saddlebrown": [
            139,
            69,
            19
        ],
        "salmon": [
            250,
            128,
            114
        ],
        "sandybrown": [
            244,
            164,
            96
        ],
        "seagreen": [
            46,
            139,
            87
        ],
        "seashell": [
            255,
            245,
            238
        ],
        "sienna": [
            160,
            82,
            45
        ],
        "silver": [
            192,
            192,
            192
        ],
        "skyblue": [
            135,
            206,
            235
        ],
        "slateblue": [
            106,
            90,
            205
        ],
        "slategray": [
            112,
            128,
            144
        ],
        "slategrey": [
            112,
            128,
            144
        ],
        "snow": [
            255,
            250,
            250
        ],
        "springgreen": [
            0,
            255,
            127
        ],
        "steelblue": [
            70,
            130,
            180
        ],
        "tan": [
            210,
            180,
            140
        ],
        "teal": [
            0,
            128,
            128
        ],
        "thistle": [
            216,
            191,
            216
        ],
        "tomato": [
            255,
            99,
            71
        ],
        "turquoise": [
            64,
            224,
            208
        ],
        "violet": [
            238,
            130,
            238
        ],
        "wheat": [
            245,
            222,
            179
        ],
        "white": [
            255,
            255,
            255
        ],
        "whitesmoke": [
            245,
            245,
            245
        ],
        "yellow": [
            255,
            255,
            0
        ],
        "yellowgreen": [
            154,
            205,
            50
        ]
    };
    var conversions = createCommonjsModule(function(module1) {
        /* MIT license */ // NOTE: conversions should only return primitive values (i.e. arrays, or
        //       values that give correct `typeof` results).
        //       do not use box values types (i.e. Number(), String(), etc.)
        var reverseKeywords = {};
        for(var key in colorName)if (colorName.hasOwnProperty(key)) reverseKeywords[colorName[key]] = key;
        var convert = module1.exports = {
            rgb: {
                channels: 3,
                labels: "rgb"
            },
            hsl: {
                channels: 3,
                labels: "hsl"
            },
            hsv: {
                channels: 3,
                labels: "hsv"
            },
            hwb: {
                channels: 3,
                labels: "hwb"
            },
            cmyk: {
                channels: 4,
                labels: "cmyk"
            },
            xyz: {
                channels: 3,
                labels: "xyz"
            },
            lab: {
                channels: 3,
                labels: "lab"
            },
            lch: {
                channels: 3,
                labels: "lch"
            },
            hex: {
                channels: 1,
                labels: [
                    "hex"
                ]
            },
            keyword: {
                channels: 1,
                labels: [
                    "keyword"
                ]
            },
            ansi16: {
                channels: 1,
                labels: [
                    "ansi16"
                ]
            },
            ansi256: {
                channels: 1,
                labels: [
                    "ansi256"
                ]
            },
            hcg: {
                channels: 3,
                labels: [
                    "h",
                    "c",
                    "g"
                ]
            },
            apple: {
                channels: 3,
                labels: [
                    "r16",
                    "g16",
                    "b16"
                ]
            },
            gray: {
                channels: 1,
                labels: [
                    "gray"
                ]
            }
        };
        // hide .channels and .labels properties
        for(var model in convert)if (convert.hasOwnProperty(model)) {
            if (!("channels" in convert[model])) throw new Error("missing channels property: " + model);
            if (!("labels" in convert[model])) throw new Error("missing channel labels property: " + model);
            if (convert[model].labels.length !== convert[model].channels) throw new Error("channel and label counts mismatch: " + model);
            var channels = convert[model].channels;
            var labels = convert[model].labels;
            delete convert[model].channels;
            delete convert[model].labels;
            Object.defineProperty(convert[model], "channels", {
                value: channels
            });
            Object.defineProperty(convert[model], "labels", {
                value: labels
            });
        }
        convert.rgb.hsl = function(rgb) {
            var r = rgb[0] / 255;
            var g = rgb[1] / 255;
            var b = rgb[2] / 255;
            var min = Math.min(r, g, b);
            var max = Math.max(r, g, b);
            var delta = max - min;
            var h;
            var s;
            var l;
            if (max === min) h = 0;
            else if (r === max) h = (g - b) / delta;
            else if (g === max) h = 2 + (b - r) / delta;
            else if (b === max) h = 4 + (r - g) / delta;
            h = Math.min(h * 60, 360);
            if (h < 0) h += 360;
            l = (min + max) / 2;
            if (max === min) s = 0;
            else if (l <= 0.5) s = delta / (max + min);
            else s = delta / (2 - max - min);
            return [
                h,
                s * 100,
                l * 100
            ];
        };
        convert.rgb.hsv = function(rgb) {
            var rdif;
            var gdif;
            var bdif;
            var h;
            var s;
            var r = rgb[0] / 255;
            var g = rgb[1] / 255;
            var b = rgb[2] / 255;
            var v = Math.max(r, g, b);
            var diff = v - Math.min(r, g, b);
            var diffc = function(c) {
                return (v - c) / 6 / diff + 0.5;
            };
            if (diff === 0) h = s = 0;
            else {
                s = diff / v;
                rdif = diffc(r);
                gdif = diffc(g);
                bdif = diffc(b);
                if (r === v) h = bdif - gdif;
                else if (g === v) h = 1 / 3 + rdif - bdif;
                else if (b === v) h = 2 / 3 + gdif - rdif;
                if (h < 0) h += 1;
                else if (h > 1) h -= 1;
            }
            return [
                h * 360,
                s * 100,
                v * 100
            ];
        };
        convert.rgb.hwb = function(rgb) {
            var r = rgb[0];
            var g = rgb[1];
            var b = rgb[2];
            var h = convert.rgb.hsl(rgb)[0];
            var w = 1 / 255 * Math.min(r, Math.min(g, b));
            b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));
            return [
                h,
                w * 100,
                b * 100
            ];
        };
        convert.rgb.cmyk = function(rgb) {
            var r = rgb[0] / 255;
            var g = rgb[1] / 255;
            var b = rgb[2] / 255;
            var c;
            var m;
            var y;
            var k;
            k = Math.min(1 - r, 1 - g, 1 - b);
            c = (1 - r - k) / (1 - k) || 0;
            m = (1 - g - k) / (1 - k) || 0;
            y = (1 - b - k) / (1 - k) || 0;
            return [
                c * 100,
                m * 100,
                y * 100,
                k * 100
            ];
        };
        /**
 * See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
 * */ function comparativeDistance(x, y) {
            return Math.pow(x[0] - y[0], 2) + Math.pow(x[1] - y[1], 2) + Math.pow(x[2] - y[2], 2);
        }
        convert.rgb.keyword = function(rgb) {
            var reversed = reverseKeywords[rgb];
            if (reversed) return reversed;
            var currentClosestDistance = Infinity;
            var currentClosestKeyword;
            for(var keyword in colorName)if (colorName.hasOwnProperty(keyword)) {
                var value = colorName[keyword];
                // Compute comparative distance
                var distance = comparativeDistance(rgb, value);
                // Check if its less, if so set as closest
                if (distance < currentClosestDistance) {
                    currentClosestDistance = distance;
                    currentClosestKeyword = keyword;
                }
            }
            return currentClosestKeyword;
        };
        convert.keyword.rgb = function(keyword) {
            return colorName[keyword];
        };
        convert.rgb.xyz = function(rgb) {
            var r = rgb[0] / 255;
            var g = rgb[1] / 255;
            var b = rgb[2] / 255;
            // assume sRGB
            r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
            g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
            b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
            var x = r * 0.4124 + g * 0.3576 + b * 0.1805;
            var y = r * 0.2126 + g * 0.7152 + b * 0.0722;
            var z = r * 0.0193 + g * 0.1192 + b * 0.9505;
            return [
                x * 100,
                y * 100,
                z * 100
            ];
        };
        convert.rgb.lab = function(rgb) {
            var xyz = convert.rgb.xyz(rgb);
            var x = xyz[0];
            var y = xyz[1];
            var z = xyz[2];
            var l;
            var a;
            var b;
            x /= 95.047;
            y /= 100;
            z /= 108.883;
            x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
            y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
            z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
            l = 116 * y - 16;
            a = 500 * (x - y);
            b = 200 * (y - z);
            return [
                l,
                a,
                b
            ];
        };
        convert.hsl.rgb = function(hsl) {
            var h = hsl[0] / 360;
            var s = hsl[1] / 100;
            var l = hsl[2] / 100;
            var t1;
            var t2;
            var t3;
            var rgb;
            var val;
            if (s === 0) {
                val = l * 255;
                return [
                    val,
                    val,
                    val
                ];
            }
            if (l < 0.5) t2 = l * (1 + s);
            else t2 = l + s - l * s;
            t1 = 2 * l - t2;
            rgb = [
                0,
                0,
                0
            ];
            for(var i = 0; i < 3; i++){
                t3 = h + 1 / 3 * -(i - 1);
                if (t3 < 0) t3++;
                if (t3 > 1) t3--;
                if (6 * t3 < 1) val = t1 + (t2 - t1) * 6 * t3;
                else if (2 * t3 < 1) val = t2;
                else if (3 * t3 < 2) val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
                else val = t1;
                rgb[i] = val * 255;
            }
            return rgb;
        };
        convert.hsl.hsv = function(hsl) {
            var h = hsl[0];
            var s = hsl[1] / 100;
            var l = hsl[2] / 100;
            var smin = s;
            var lmin = Math.max(l, 0.01);
            var sv;
            var v;
            l *= 2;
            s *= l <= 1 ? l : 2 - l;
            smin *= lmin <= 1 ? lmin : 2 - lmin;
            v = (l + s) / 2;
            sv = l === 0 ? 2 * smin / (lmin + smin) : 2 * s / (l + s);
            return [
                h,
                sv * 100,
                v * 100
            ];
        };
        convert.hsv.rgb = function(hsv) {
            var h = hsv[0] / 60;
            var s = hsv[1] / 100;
            var v = hsv[2] / 100;
            var hi = Math.floor(h) % 6;
            var f = h - Math.floor(h);
            var p = 255 * v * (1 - s);
            var q = 255 * v * (1 - s * f);
            var t = 255 * v * (1 - s * (1 - f));
            v *= 255;
            switch(hi){
                case 0:
                    return [
                        v,
                        t,
                        p
                    ];
                case 1:
                    return [
                        q,
                        v,
                        p
                    ];
                case 2:
                    return [
                        p,
                        v,
                        t
                    ];
                case 3:
                    return [
                        p,
                        q,
                        v
                    ];
                case 4:
                    return [
                        t,
                        p,
                        v
                    ];
                case 5:
                    return [
                        v,
                        p,
                        q
                    ];
            }
        };
        convert.hsv.hsl = function(hsv) {
            var h = hsv[0];
            var s = hsv[1] / 100;
            var v = hsv[2] / 100;
            var vmin = Math.max(v, 0.01);
            var lmin;
            var sl;
            var l;
            l = (2 - s) * v;
            lmin = (2 - s) * vmin;
            sl = s * vmin;
            sl /= lmin <= 1 ? lmin : 2 - lmin;
            sl = sl || 0;
            l /= 2;
            return [
                h,
                sl * 100,
                l * 100
            ];
        };
        // http://dev.w3.org/csswg/css-color/#hwb-to-rgb
        convert.hwb.rgb = function(hwb) {
            var h = hwb[0] / 360;
            var wh = hwb[1] / 100;
            var bl = hwb[2] / 100;
            var ratio = wh + bl;
            var i;
            var v;
            var f;
            var n;
            // wh + bl cant be > 1
            if (ratio > 1) {
                wh /= ratio;
                bl /= ratio;
            }
            i = Math.floor(6 * h);
            v = 1 - bl;
            f = 6 * h - i;
            if ((i & 0x01) !== 0) f = 1 - f;
            n = wh + f * (v - wh); // linear interpolation
            var r;
            var g;
            var b;
            switch(i){
                default:
                case 6:
                case 0:
                    r = v;
                    g = n;
                    b = wh;
                    break;
                case 1:
                    r = n;
                    g = v;
                    b = wh;
                    break;
                case 2:
                    r = wh;
                    g = v;
                    b = n;
                    break;
                case 3:
                    r = wh;
                    g = n;
                    b = v;
                    break;
                case 4:
                    r = n;
                    g = wh;
                    b = v;
                    break;
                case 5:
                    r = v;
                    g = wh;
                    b = n;
                    break;
            }
            return [
                r * 255,
                g * 255,
                b * 255
            ];
        };
        convert.cmyk.rgb = function(cmyk) {
            var c = cmyk[0] / 100;
            var m = cmyk[1] / 100;
            var y = cmyk[2] / 100;
            var k = cmyk[3] / 100;
            var r;
            var g;
            var b;
            r = 1 - Math.min(1, c * (1 - k) + k);
            g = 1 - Math.min(1, m * (1 - k) + k);
            b = 1 - Math.min(1, y * (1 - k) + k);
            return [
                r * 255,
                g * 255,
                b * 255
            ];
        };
        convert.xyz.rgb = function(xyz) {
            var x = xyz[0] / 100;
            var y = xyz[1] / 100;
            var z = xyz[2] / 100;
            var r;
            var g;
            var b;
            r = x * 3.2406 + y * -1.5372 + z * -0.4986;
            g = x * -0.9689 + y * 1.8758 + z * 0.0415;
            b = x * 0.0557 + y * -0.204 + z * 1.0570;
            // assume sRGB
            r = r > 0.0031308 ? 1.055 * Math.pow(r, 1.0 / 2.4) - 0.055 : r * 12.92;
            g = g > 0.0031308 ? 1.055 * Math.pow(g, 1.0 / 2.4) - 0.055 : g * 12.92;
            b = b > 0.0031308 ? 1.055 * Math.pow(b, 1.0 / 2.4) - 0.055 : b * 12.92;
            r = Math.min(Math.max(0, r), 1);
            g = Math.min(Math.max(0, g), 1);
            b = Math.min(Math.max(0, b), 1);
            return [
                r * 255,
                g * 255,
                b * 255
            ];
        };
        convert.xyz.lab = function(xyz) {
            var x = xyz[0];
            var y = xyz[1];
            var z = xyz[2];
            var l;
            var a;
            var b;
            x /= 95.047;
            y /= 100;
            z /= 108.883;
            x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
            y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
            z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
            l = 116 * y - 16;
            a = 500 * (x - y);
            b = 200 * (y - z);
            return [
                l,
                a,
                b
            ];
        };
        convert.lab.xyz = function(lab) {
            var l = lab[0];
            var a = lab[1];
            var b = lab[2];
            var x;
            var y;
            var z;
            y = (l + 16) / 116;
            x = a / 500 + y;
            z = y - b / 200;
            var y2 = Math.pow(y, 3);
            var x2 = Math.pow(x, 3);
            var z2 = Math.pow(z, 3);
            y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
            x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
            z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;
            x *= 95.047;
            y *= 100;
            z *= 108.883;
            return [
                x,
                y,
                z
            ];
        };
        convert.lab.lch = function(lab) {
            var l = lab[0];
            var a = lab[1];
            var b = lab[2];
            var hr;
            var h;
            var c;
            hr = Math.atan2(b, a);
            h = hr * 360 / 2 / Math.PI;
            if (h < 0) h += 360;
            c = Math.sqrt(a * a + b * b);
            return [
                l,
                c,
                h
            ];
        };
        convert.lch.lab = function(lch) {
            var l = lch[0];
            var c = lch[1];
            var h = lch[2];
            var a;
            var b;
            var hr;
            hr = h / 360 * 2 * Math.PI;
            a = c * Math.cos(hr);
            b = c * Math.sin(hr);
            return [
                l,
                a,
                b
            ];
        };
        convert.rgb.ansi16 = function(args) {
            var r = args[0];
            var g = args[1];
            var b = args[2];
            var value = 1 in arguments ? arguments[1] : convert.rgb.hsv(args)[2]; // hsv -> ansi16 optimization
            value = Math.round(value / 50);
            if (value === 0) return 30;
            var ansi = 30 + (Math.round(b / 255) << 2 | Math.round(g / 255) << 1 | Math.round(r / 255));
            if (value === 2) ansi += 60;
            return ansi;
        };
        convert.hsv.ansi16 = function(args) {
            // optimization here; we already know the value and don't need to get
            // it converted for us.
            return convert.rgb.ansi16(convert.hsv.rgb(args), args[2]);
        };
        convert.rgb.ansi256 = function(args) {
            var r = args[0];
            var g = args[1];
            var b = args[2];
            // we use the extended greyscale palette here, with the exception of
            // black and white. normal palette only has 4 greyscale shades.
            if (r === g && g === b) {
                if (r < 8) return 16;
                if (r > 248) return 231;
                return Math.round((r - 8) / 247 * 24) + 232;
            }
            var ansi = 16 + 36 * Math.round(r / 255 * 5) + 6 * Math.round(g / 255 * 5) + Math.round(b / 255 * 5);
            return ansi;
        };
        convert.ansi16.rgb = function(args) {
            var color = args % 10;
            // handle greyscale
            if (color === 0 || color === 7) {
                if (args > 50) color += 3.5;
                color = color / 10.5 * 255;
                return [
                    color,
                    color,
                    color
                ];
            }
            var mult = (~~(args > 50) + 1) * 0.5;
            var r = (color & 1) * mult * 255;
            var g = (color >> 1 & 1) * mult * 255;
            var b = (color >> 2 & 1) * mult * 255;
            return [
                r,
                g,
                b
            ];
        };
        convert.ansi256.rgb = function(args) {
            // handle greyscale
            if (args >= 232) {
                var c = (args - 232) * 10 + 8;
                return [
                    c,
                    c,
                    c
                ];
            }
            args -= 16;
            var rem;
            var r = Math.floor(args / 36) / 5 * 255;
            var g = Math.floor((rem = args % 36) / 6) / 5 * 255;
            var b = rem % 6 / 5 * 255;
            return [
                r,
                g,
                b
            ];
        };
        convert.rgb.hex = function(args) {
            var integer = ((Math.round(args[0]) & 0xFF) << 16) + ((Math.round(args[1]) & 0xFF) << 8) + (Math.round(args[2]) & 0xFF);
            var string = integer.toString(16).toUpperCase();
            return "000000".substring(string.length) + string;
        };
        convert.hex.rgb = function(args) {
            var match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
            if (!match) return [
                0,
                0,
                0
            ];
            var colorString = match[0];
            if (match[0].length === 3) colorString = colorString.split("").map(function(char) {
                return char + char;
            }).join("");
            var integer = parseInt(colorString, 16);
            var r = integer >> 16 & 0xFF;
            var g = integer >> 8 & 0xFF;
            var b = integer & 0xFF;
            return [
                r,
                g,
                b
            ];
        };
        convert.rgb.hcg = function(rgb) {
            var r = rgb[0] / 255;
            var g = rgb[1] / 255;
            var b = rgb[2] / 255;
            var max = Math.max(Math.max(r, g), b);
            var min = Math.min(Math.min(r, g), b);
            var chroma = max - min;
            var grayscale;
            var hue;
            if (chroma < 1) grayscale = min / (1 - chroma);
            else grayscale = 0;
            if (chroma <= 0) hue = 0;
            else if (max === r) hue = (g - b) / chroma % 6;
            else if (max === g) hue = 2 + (b - r) / chroma;
            else hue = 4 + (r - g) / chroma + 4;
            hue /= 6;
            hue %= 1;
            return [
                hue * 360,
                chroma * 100,
                grayscale * 100
            ];
        };
        convert.hsl.hcg = function(hsl) {
            var s = hsl[1] / 100;
            var l = hsl[2] / 100;
            var c = 1;
            var f = 0;
            if (l < 0.5) c = 2.0 * s * l;
            else c = 2.0 * s * (1.0 - l);
            if (c < 1.0) f = (l - 0.5 * c) / (1.0 - c);
            return [
                hsl[0],
                c * 100,
                f * 100
            ];
        };
        convert.hsv.hcg = function(hsv) {
            var s = hsv[1] / 100;
            var v = hsv[2] / 100;
            var c = s * v;
            var f = 0;
            if (c < 1.0) f = (v - c) / (1 - c);
            return [
                hsv[0],
                c * 100,
                f * 100
            ];
        };
        convert.hcg.rgb = function(hcg) {
            var h = hcg[0] / 360;
            var c = hcg[1] / 100;
            var g = hcg[2] / 100;
            if (c === 0.0) return [
                g * 255,
                g * 255,
                g * 255
            ];
            var pure = [
                0,
                0,
                0
            ];
            var hi = h % 1 * 6;
            var v = hi % 1;
            var w = 1 - v;
            var mg = 0;
            switch(Math.floor(hi)){
                case 0:
                    pure[0] = 1;
                    pure[1] = v;
                    pure[2] = 0;
                    break;
                case 1:
                    pure[0] = w;
                    pure[1] = 1;
                    pure[2] = 0;
                    break;
                case 2:
                    pure[0] = 0;
                    pure[1] = 1;
                    pure[2] = v;
                    break;
                case 3:
                    pure[0] = 0;
                    pure[1] = w;
                    pure[2] = 1;
                    break;
                case 4:
                    pure[0] = v;
                    pure[1] = 0;
                    pure[2] = 1;
                    break;
                default:
                    pure[0] = 1;
                    pure[1] = 0;
                    pure[2] = w;
            }
            mg = (1.0 - c) * g;
            return [
                (c * pure[0] + mg) * 255,
                (c * pure[1] + mg) * 255,
                (c * pure[2] + mg) * 255
            ];
        };
        convert.hcg.hsv = function(hcg) {
            var c = hcg[1] / 100;
            var g = hcg[2] / 100;
            var v = c + g * (1.0 - c);
            var f = 0;
            if (v > 0.0) f = c / v;
            return [
                hcg[0],
                f * 100,
                v * 100
            ];
        };
        convert.hcg.hsl = function(hcg) {
            var c = hcg[1] / 100;
            var g = hcg[2] / 100;
            var l = g * (1.0 - c) + 0.5 * c;
            var s = 0;
            if (l > 0.0 && l < 0.5) s = c / (2 * l);
            else if (l >= 0.5 && l < 1.0) s = c / (2 * (1 - l));
            return [
                hcg[0],
                s * 100,
                l * 100
            ];
        };
        convert.hcg.hwb = function(hcg) {
            var c = hcg[1] / 100;
            var g = hcg[2] / 100;
            var v = c + g * (1.0 - c);
            return [
                hcg[0],
                (v - c) * 100,
                (1 - v) * 100
            ];
        };
        convert.hwb.hcg = function(hwb) {
            var w = hwb[1] / 100;
            var b = hwb[2] / 100;
            var v = 1 - b;
            var c = v - w;
            var g = 0;
            if (c < 1) g = (v - c) / (1 - c);
            return [
                hwb[0],
                c * 100,
                g * 100
            ];
        };
        convert.apple.rgb = function(apple) {
            return [
                apple[0] / 65535 * 255,
                apple[1] / 65535 * 255,
                apple[2] / 65535 * 255
            ];
        };
        convert.rgb.apple = function(rgb) {
            return [
                rgb[0] / 255 * 65535,
                rgb[1] / 255 * 65535,
                rgb[2] / 255 * 65535
            ];
        };
        convert.gray.rgb = function(args) {
            return [
                args[0] / 100 * 255,
                args[0] / 100 * 255,
                args[0] / 100 * 255
            ];
        };
        convert.gray.hsl = convert.gray.hsv = function(args) {
            return [
                0,
                0,
                args[0]
            ];
        };
        convert.gray.hwb = function(gray) {
            return [
                0,
                100,
                gray[0]
            ];
        };
        convert.gray.cmyk = function(gray) {
            return [
                0,
                0,
                0,
                gray[0]
            ];
        };
        convert.gray.lab = function(gray) {
            return [
                gray[0],
                0,
                0
            ];
        };
        convert.gray.hex = function(gray) {
            var val = Math.round(gray[0] / 100 * 255) & 0xFF;
            var integer = (val << 16) + (val << 8) + val;
            var string = integer.toString(16).toUpperCase();
            return "000000".substring(string.length) + string;
        };
        convert.rgb.gray = function(rgb) {
            var val = (rgb[0] + rgb[1] + rgb[2]) / 3;
            return [
                val / 255 * 100
            ];
        };
    });
    var conversions_1 = conversions.rgb;
    var conversions_2 = conversions.hsl;
    var conversions_3 = conversions.hsv;
    var conversions_4 = conversions.hwb;
    var conversions_5 = conversions.cmyk;
    var conversions_6 = conversions.xyz;
    var conversions_7 = conversions.lab;
    var conversions_8 = conversions.lch;
    var conversions_9 = conversions.hex;
    var conversions_10 = conversions.keyword;
    var conversions_11 = conversions.ansi16;
    var conversions_12 = conversions.ansi256;
    var conversions_13 = conversions.hcg;
    var conversions_14 = conversions.apple;
    var conversions_15 = conversions.gray;
    /*
	this function routes a model to all other models.

	all functions that are routed have a property `.conversion` attached
	to the returned synthetic function. This property is an array
	of strings, each with the steps in between the 'from' and 'to'
	color models (inclusive).

	conversions that are not possible simply are not included.
*/ function buildGraph() {
        var graph = {};
        // https://jsperf.com/object-keys-vs-for-in-with-closure/3
        var models = Object.keys(conversions);
        for(var len = models.length, i = 0; i < len; i++)graph[models[i]] = {
            // http://jsperf.com/1-vs-infinity
            // micro-opt, but this is simple.
            distance: -1,
            parent: null
        };
        return graph;
    }
    // https://en.wikipedia.org/wiki/Breadth-first_search
    function deriveBFS(fromModel) {
        var graph = buildGraph();
        var queue = [
            fromModel
        ]; // unshift -> queue -> pop
        graph[fromModel].distance = 0;
        while(queue.length){
            var current = queue.pop();
            var adjacents = Object.keys(conversions[current]);
            for(var len = adjacents.length, i = 0; i < len; i++){
                var adjacent = adjacents[i];
                var node = graph[adjacent];
                if (node.distance === -1) {
                    node.distance = graph[current].distance + 1;
                    node.parent = current;
                    queue.unshift(adjacent);
                }
            }
        }
        return graph;
    }
    function link(from, to) {
        return function(args) {
            return to(from(args));
        };
    }
    function wrapConversion(toModel, graph) {
        var path = [
            graph[toModel].parent,
            toModel
        ];
        var fn = conversions[graph[toModel].parent][toModel];
        var cur = graph[toModel].parent;
        while(graph[cur].parent){
            path.unshift(graph[cur].parent);
            fn = link(conversions[graph[cur].parent][cur], fn);
            cur = graph[cur].parent;
        }
        fn.conversion = path;
        return fn;
    }
    var route = function(fromModel) {
        var graph = deriveBFS(fromModel);
        var conversion = {};
        var models = Object.keys(graph);
        for(var len = models.length, i = 0; i < len; i++){
            var toModel = models[i];
            var node = graph[toModel];
            if (node.parent === null) continue;
            conversion[toModel] = wrapConversion(toModel, graph);
        }
        return conversion;
    };
    var convert = {};
    var models = Object.keys(conversions);
    function wrapRaw(fn) {
        var wrappedFn = function(args) {
            if (args === undefined || args === null) return args;
            if (arguments.length > 1) args = Array.prototype.slice.call(arguments);
            return fn(args);
        };
        // preserve .conversion property if there is one
        if ("conversion" in fn) wrappedFn.conversion = fn.conversion;
        return wrappedFn;
    }
    function wrapRounded(fn) {
        var wrappedFn = function(args) {
            if (args === undefined || args === null) return args;
            if (arguments.length > 1) args = Array.prototype.slice.call(arguments);
            var result = fn(args);
            // we're assuming the result is an array here.
            // see notice in conversions.js; don't use box types
            // in conversion functions.
            if (typeof result === "object") for(var len = result.length, i = 0; i < len; i++)result[i] = Math.round(result[i]);
            return result;
        };
        // preserve .conversion property if there is one
        if ("conversion" in fn) wrappedFn.conversion = fn.conversion;
        return wrappedFn;
    }
    models.forEach(function(fromModel) {
        convert[fromModel] = {};
        Object.defineProperty(convert[fromModel], "channels", {
            value: conversions[fromModel].channels
        });
        Object.defineProperty(convert[fromModel], "labels", {
            value: conversions[fromModel].labels
        });
        var routes = route(fromModel);
        var routeModels = Object.keys(routes);
        routeModels.forEach(function(toModel) {
            var fn = routes[toModel];
            convert[fromModel][toModel] = wrapRounded(fn);
            convert[fromModel][toModel].raw = wrapRaw(fn);
        });
    });
    var colorConvert = convert;
    var colorName$1 = {
        "aliceblue": [
            240,
            248,
            255
        ],
        "antiquewhite": [
            250,
            235,
            215
        ],
        "aqua": [
            0,
            255,
            255
        ],
        "aquamarine": [
            127,
            255,
            212
        ],
        "azure": [
            240,
            255,
            255
        ],
        "beige": [
            245,
            245,
            220
        ],
        "bisque": [
            255,
            228,
            196
        ],
        "black": [
            0,
            0,
            0
        ],
        "blanchedalmond": [
            255,
            235,
            205
        ],
        "blue": [
            0,
            0,
            255
        ],
        "blueviolet": [
            138,
            43,
            226
        ],
        "brown": [
            165,
            42,
            42
        ],
        "burlywood": [
            222,
            184,
            135
        ],
        "cadetblue": [
            95,
            158,
            160
        ],
        "chartreuse": [
            127,
            255,
            0
        ],
        "chocolate": [
            210,
            105,
            30
        ],
        "coral": [
            255,
            127,
            80
        ],
        "cornflowerblue": [
            100,
            149,
            237
        ],
        "cornsilk": [
            255,
            248,
            220
        ],
        "crimson": [
            220,
            20,
            60
        ],
        "cyan": [
            0,
            255,
            255
        ],
        "darkblue": [
            0,
            0,
            139
        ],
        "darkcyan": [
            0,
            139,
            139
        ],
        "darkgoldenrod": [
            184,
            134,
            11
        ],
        "darkgray": [
            169,
            169,
            169
        ],
        "darkgreen": [
            0,
            100,
            0
        ],
        "darkgrey": [
            169,
            169,
            169
        ],
        "darkkhaki": [
            189,
            183,
            107
        ],
        "darkmagenta": [
            139,
            0,
            139
        ],
        "darkolivegreen": [
            85,
            107,
            47
        ],
        "darkorange": [
            255,
            140,
            0
        ],
        "darkorchid": [
            153,
            50,
            204
        ],
        "darkred": [
            139,
            0,
            0
        ],
        "darksalmon": [
            233,
            150,
            122
        ],
        "darkseagreen": [
            143,
            188,
            143
        ],
        "darkslateblue": [
            72,
            61,
            139
        ],
        "darkslategray": [
            47,
            79,
            79
        ],
        "darkslategrey": [
            47,
            79,
            79
        ],
        "darkturquoise": [
            0,
            206,
            209
        ],
        "darkviolet": [
            148,
            0,
            211
        ],
        "deeppink": [
            255,
            20,
            147
        ],
        "deepskyblue": [
            0,
            191,
            255
        ],
        "dimgray": [
            105,
            105,
            105
        ],
        "dimgrey": [
            105,
            105,
            105
        ],
        "dodgerblue": [
            30,
            144,
            255
        ],
        "firebrick": [
            178,
            34,
            34
        ],
        "floralwhite": [
            255,
            250,
            240
        ],
        "forestgreen": [
            34,
            139,
            34
        ],
        "fuchsia": [
            255,
            0,
            255
        ],
        "gainsboro": [
            220,
            220,
            220
        ],
        "ghostwhite": [
            248,
            248,
            255
        ],
        "gold": [
            255,
            215,
            0
        ],
        "goldenrod": [
            218,
            165,
            32
        ],
        "gray": [
            128,
            128,
            128
        ],
        "green": [
            0,
            128,
            0
        ],
        "greenyellow": [
            173,
            255,
            47
        ],
        "grey": [
            128,
            128,
            128
        ],
        "honeydew": [
            240,
            255,
            240
        ],
        "hotpink": [
            255,
            105,
            180
        ],
        "indianred": [
            205,
            92,
            92
        ],
        "indigo": [
            75,
            0,
            130
        ],
        "ivory": [
            255,
            255,
            240
        ],
        "khaki": [
            240,
            230,
            140
        ],
        "lavender": [
            230,
            230,
            250
        ],
        "lavenderblush": [
            255,
            240,
            245
        ],
        "lawngreen": [
            124,
            252,
            0
        ],
        "lemonchiffon": [
            255,
            250,
            205
        ],
        "lightblue": [
            173,
            216,
            230
        ],
        "lightcoral": [
            240,
            128,
            128
        ],
        "lightcyan": [
            224,
            255,
            255
        ],
        "lightgoldenrodyellow": [
            250,
            250,
            210
        ],
        "lightgray": [
            211,
            211,
            211
        ],
        "lightgreen": [
            144,
            238,
            144
        ],
        "lightgrey": [
            211,
            211,
            211
        ],
        "lightpink": [
            255,
            182,
            193
        ],
        "lightsalmon": [
            255,
            160,
            122
        ],
        "lightseagreen": [
            32,
            178,
            170
        ],
        "lightskyblue": [
            135,
            206,
            250
        ],
        "lightslategray": [
            119,
            136,
            153
        ],
        "lightslategrey": [
            119,
            136,
            153
        ],
        "lightsteelblue": [
            176,
            196,
            222
        ],
        "lightyellow": [
            255,
            255,
            224
        ],
        "lime": [
            0,
            255,
            0
        ],
        "limegreen": [
            50,
            205,
            50
        ],
        "linen": [
            250,
            240,
            230
        ],
        "magenta": [
            255,
            0,
            255
        ],
        "maroon": [
            128,
            0,
            0
        ],
        "mediumaquamarine": [
            102,
            205,
            170
        ],
        "mediumblue": [
            0,
            0,
            205
        ],
        "mediumorchid": [
            186,
            85,
            211
        ],
        "mediumpurple": [
            147,
            112,
            219
        ],
        "mediumseagreen": [
            60,
            179,
            113
        ],
        "mediumslateblue": [
            123,
            104,
            238
        ],
        "mediumspringgreen": [
            0,
            250,
            154
        ],
        "mediumturquoise": [
            72,
            209,
            204
        ],
        "mediumvioletred": [
            199,
            21,
            133
        ],
        "midnightblue": [
            25,
            25,
            112
        ],
        "mintcream": [
            245,
            255,
            250
        ],
        "mistyrose": [
            255,
            228,
            225
        ],
        "moccasin": [
            255,
            228,
            181
        ],
        "navajowhite": [
            255,
            222,
            173
        ],
        "navy": [
            0,
            0,
            128
        ],
        "oldlace": [
            253,
            245,
            230
        ],
        "olive": [
            128,
            128,
            0
        ],
        "olivedrab": [
            107,
            142,
            35
        ],
        "orange": [
            255,
            165,
            0
        ],
        "orangered": [
            255,
            69,
            0
        ],
        "orchid": [
            218,
            112,
            214
        ],
        "palegoldenrod": [
            238,
            232,
            170
        ],
        "palegreen": [
            152,
            251,
            152
        ],
        "paleturquoise": [
            175,
            238,
            238
        ],
        "palevioletred": [
            219,
            112,
            147
        ],
        "papayawhip": [
            255,
            239,
            213
        ],
        "peachpuff": [
            255,
            218,
            185
        ],
        "peru": [
            205,
            133,
            63
        ],
        "pink": [
            255,
            192,
            203
        ],
        "plum": [
            221,
            160,
            221
        ],
        "powderblue": [
            176,
            224,
            230
        ],
        "purple": [
            128,
            0,
            128
        ],
        "rebeccapurple": [
            102,
            51,
            153
        ],
        "red": [
            255,
            0,
            0
        ],
        "rosybrown": [
            188,
            143,
            143
        ],
        "royalblue": [
            65,
            105,
            225
        ],
        "saddlebrown": [
            139,
            69,
            19
        ],
        "salmon": [
            250,
            128,
            114
        ],
        "sandybrown": [
            244,
            164,
            96
        ],
        "seagreen": [
            46,
            139,
            87
        ],
        "seashell": [
            255,
            245,
            238
        ],
        "sienna": [
            160,
            82,
            45
        ],
        "silver": [
            192,
            192,
            192
        ],
        "skyblue": [
            135,
            206,
            235
        ],
        "slateblue": [
            106,
            90,
            205
        ],
        "slategray": [
            112,
            128,
            144
        ],
        "slategrey": [
            112,
            128,
            144
        ],
        "snow": [
            255,
            250,
            250
        ],
        "springgreen": [
            0,
            255,
            127
        ],
        "steelblue": [
            70,
            130,
            180
        ],
        "tan": [
            210,
            180,
            140
        ],
        "teal": [
            0,
            128,
            128
        ],
        "thistle": [
            216,
            191,
            216
        ],
        "tomato": [
            255,
            99,
            71
        ],
        "turquoise": [
            64,
            224,
            208
        ],
        "violet": [
            238,
            130,
            238
        ],
        "wheat": [
            245,
            222,
            179
        ],
        "white": [
            255,
            255,
            255
        ],
        "whitesmoke": [
            245,
            245,
            245
        ],
        "yellow": [
            255,
            255,
            0
        ],
        "yellowgreen": [
            154,
            205,
            50
        ]
    };
    /* MIT license */ var colorString = {
        getRgba: getRgba,
        getHsla: getHsla,
        getRgb: getRgb,
        getHsl: getHsl,
        getHwb: getHwb,
        getAlpha: getAlpha,
        hexString: hexString,
        rgbString: rgbString,
        rgbaString: rgbaString,
        percentString: percentString,
        percentaString: percentaString,
        hslString: hslString,
        hslaString: hslaString,
        hwbString: hwbString,
        keyword: keyword
    };
    function getRgba(string) {
        if (!string) return;
        var abbr = /^#([a-fA-F0-9]{3,4})$/i, hex = /^#([a-fA-F0-9]{6}([a-fA-F0-9]{2})?)$/i, rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i, per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i, keyword = /(\w+)/;
        var rgb = [
            0,
            0,
            0
        ], a = 1, match = string.match(abbr), hexAlpha = "";
        if (match) {
            match = match[1];
            hexAlpha = match[3];
            for(var i = 0; i < rgb.length; i++)rgb[i] = parseInt(match[i] + match[i], 16);
            if (hexAlpha) a = Math.round(parseInt(hexAlpha + hexAlpha, 16) / 255 * 100) / 100;
        } else if (match = string.match(hex)) {
            hexAlpha = match[2];
            match = match[1];
            for(var i = 0; i < rgb.length; i++)rgb[i] = parseInt(match.slice(i * 2, i * 2 + 2), 16);
            if (hexAlpha) a = Math.round(parseInt(hexAlpha, 16) / 255 * 100) / 100;
        } else if (match = string.match(rgba)) {
            for(var i = 0; i < rgb.length; i++)rgb[i] = parseInt(match[i + 1]);
            a = parseFloat(match[4]);
        } else if (match = string.match(per)) {
            for(var i = 0; i < rgb.length; i++)rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
            a = parseFloat(match[4]);
        } else if (match = string.match(keyword)) {
            if (match[1] == "transparent") return [
                0,
                0,
                0,
                0
            ];
            rgb = colorName$1[match[1]];
            if (!rgb) return;
        }
        for(var i = 0; i < rgb.length; i++)rgb[i] = scale(rgb[i], 0, 255);
        if (!a && a != 0) a = 1;
        else a = scale(a, 0, 1);
        rgb[3] = a;
        return rgb;
    }
    function getHsla(string) {
        if (!string) return;
        var hsl = /^hsla?\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
        var match = string.match(hsl);
        if (match) {
            var alpha = parseFloat(match[4]);
            var h = scale(parseInt(match[1]), 0, 360), s = scale(parseFloat(match[2]), 0, 100), l = scale(parseFloat(match[3]), 0, 100), a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
            return [
                h,
                s,
                l,
                a
            ];
        }
    }
    function getHwb(string) {
        if (!string) return;
        var hwb = /^hwb\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
        var match = string.match(hwb);
        if (match) {
            var alpha = parseFloat(match[4]);
            var h = scale(parseInt(match[1]), 0, 360), w = scale(parseFloat(match[2]), 0, 100), b = scale(parseFloat(match[3]), 0, 100), a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
            return [
                h,
                w,
                b,
                a
            ];
        }
    }
    function getRgb(string) {
        var rgba = getRgba(string);
        return rgba && rgba.slice(0, 3);
    }
    function getHsl(string) {
        var hsla = getHsla(string);
        return hsla && hsla.slice(0, 3);
    }
    function getAlpha(string) {
        var vals = getRgba(string);
        if (vals) return vals[3];
        else if (vals = getHsla(string)) return vals[3];
        else if (vals = getHwb(string)) return vals[3];
    }
    // generators
    function hexString(rgba, a) {
        var a = a !== undefined && rgba.length === 3 ? a : rgba[3];
        return "#" + hexDouble(rgba[0]) + hexDouble(rgba[1]) + hexDouble(rgba[2]) + (a >= 0 && a < 1 ? hexDouble(Math.round(a * 255)) : "");
    }
    function rgbString(rgba, alpha) {
        if (alpha < 1 || rgba[3] && rgba[3] < 1) return rgbaString(rgba, alpha);
        return "rgb(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ")";
    }
    function rgbaString(rgba, alpha) {
        if (alpha === undefined) alpha = rgba[3] !== undefined ? rgba[3] : 1;
        return "rgba(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ", " + alpha + ")";
    }
    function percentString(rgba, alpha) {
        if (alpha < 1 || rgba[3] && rgba[3] < 1) return percentaString(rgba, alpha);
        var r = Math.round(rgba[0] / 255 * 100), g = Math.round(rgba[1] / 255 * 100), b = Math.round(rgba[2] / 255 * 100);
        return "rgb(" + r + "%, " + g + "%, " + b + "%)";
    }
    function percentaString(rgba, alpha) {
        var r = Math.round(rgba[0] / 255 * 100), g = Math.round(rgba[1] / 255 * 100), b = Math.round(rgba[2] / 255 * 100);
        return "rgba(" + r + "%, " + g + "%, " + b + "%, " + (alpha || rgba[3] || 1) + ")";
    }
    function hslString(hsla, alpha) {
        if (alpha < 1 || hsla[3] && hsla[3] < 1) return hslaString(hsla, alpha);
        return "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)";
    }
    function hslaString(hsla, alpha) {
        if (alpha === undefined) alpha = hsla[3] !== undefined ? hsla[3] : 1;
        return "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, " + alpha + ")";
    }
    // hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
    // (hwb have alpha optional & 1 is default value)
    function hwbString(hwb, alpha) {
        if (alpha === undefined) alpha = hwb[3] !== undefined ? hwb[3] : 1;
        return "hwb(" + hwb[0] + ", " + hwb[1] + "%, " + hwb[2] + "%" + (alpha !== undefined && alpha !== 1 ? ", " + alpha : "") + ")";
    }
    function keyword(rgb) {
        return reverseNames[rgb.slice(0, 3)];
    }
    // helpers
    function scale(num, min, max) {
        return Math.min(Math.max(min, num), max);
    }
    function hexDouble(num) {
        var str = num.toString(16).toUpperCase();
        return str.length < 2 ? "0" + str : str;
    }
    //create a list of reverse color names
    var reverseNames = {};
    for(var name in colorName$1)reverseNames[colorName$1[name]] = name;
    /* MIT license */ var Color = function(obj) {
        if (obj instanceof Color) return obj;
        if (!(this instanceof Color)) return new Color(obj);
        this.valid = false;
        this.values = {
            rgb: [
                0,
                0,
                0
            ],
            hsl: [
                0,
                0,
                0
            ],
            hsv: [
                0,
                0,
                0
            ],
            hwb: [
                0,
                0,
                0
            ],
            cmyk: [
                0,
                0,
                0,
                0
            ],
            alpha: 1
        };
        // parse Color() argument
        var vals;
        if (typeof obj === "string") {
            vals = colorString.getRgba(obj);
            if (vals) this.setValues("rgb", vals);
            else if (vals = colorString.getHsla(obj)) this.setValues("hsl", vals);
            else if (vals = colorString.getHwb(obj)) this.setValues("hwb", vals);
        } else if (typeof obj === "object") {
            vals = obj;
            if (vals.r !== undefined || vals.red !== undefined) this.setValues("rgb", vals);
            else if (vals.l !== undefined || vals.lightness !== undefined) this.setValues("hsl", vals);
            else if (vals.v !== undefined || vals.value !== undefined) this.setValues("hsv", vals);
            else if (vals.w !== undefined || vals.whiteness !== undefined) this.setValues("hwb", vals);
            else if (vals.c !== undefined || vals.cyan !== undefined) this.setValues("cmyk", vals);
        }
    };
    Color.prototype = {
        isValid: function() {
            return this.valid;
        },
        rgb: function() {
            return this.setSpace("rgb", arguments);
        },
        hsl: function() {
            return this.setSpace("hsl", arguments);
        },
        hsv: function() {
            return this.setSpace("hsv", arguments);
        },
        hwb: function() {
            return this.setSpace("hwb", arguments);
        },
        cmyk: function() {
            return this.setSpace("cmyk", arguments);
        },
        rgbArray: function() {
            return this.values.rgb;
        },
        hslArray: function() {
            return this.values.hsl;
        },
        hsvArray: function() {
            return this.values.hsv;
        },
        hwbArray: function() {
            var values = this.values;
            if (values.alpha !== 1) return values.hwb.concat([
                values.alpha
            ]);
            return values.hwb;
        },
        cmykArray: function() {
            return this.values.cmyk;
        },
        rgbaArray: function() {
            var values = this.values;
            return values.rgb.concat([
                values.alpha
            ]);
        },
        hslaArray: function() {
            var values = this.values;
            return values.hsl.concat([
                values.alpha
            ]);
        },
        alpha: function(val) {
            if (val === undefined) return this.values.alpha;
            this.setValues("alpha", val);
            return this;
        },
        red: function(val) {
            return this.setChannel("rgb", 0, val);
        },
        green: function(val) {
            return this.setChannel("rgb", 1, val);
        },
        blue: function(val) {
            return this.setChannel("rgb", 2, val);
        },
        hue: function(val) {
            if (val) {
                val %= 360;
                val = val < 0 ? 360 + val : val;
            }
            return this.setChannel("hsl", 0, val);
        },
        saturation: function(val) {
            return this.setChannel("hsl", 1, val);
        },
        lightness: function(val) {
            return this.setChannel("hsl", 2, val);
        },
        saturationv: function(val) {
            return this.setChannel("hsv", 1, val);
        },
        whiteness: function(val) {
            return this.setChannel("hwb", 1, val);
        },
        blackness: function(val) {
            return this.setChannel("hwb", 2, val);
        },
        value: function(val) {
            return this.setChannel("hsv", 2, val);
        },
        cyan: function(val) {
            return this.setChannel("cmyk", 0, val);
        },
        magenta: function(val) {
            return this.setChannel("cmyk", 1, val);
        },
        yellow: function(val) {
            return this.setChannel("cmyk", 2, val);
        },
        black: function(val) {
            return this.setChannel("cmyk", 3, val);
        },
        hexString: function() {
            return colorString.hexString(this.values.rgb);
        },
        rgbString: function() {
            return colorString.rgbString(this.values.rgb, this.values.alpha);
        },
        rgbaString: function() {
            return colorString.rgbaString(this.values.rgb, this.values.alpha);
        },
        percentString: function() {
            return colorString.percentString(this.values.rgb, this.values.alpha);
        },
        hslString: function() {
            return colorString.hslString(this.values.hsl, this.values.alpha);
        },
        hslaString: function() {
            return colorString.hslaString(this.values.hsl, this.values.alpha);
        },
        hwbString: function() {
            return colorString.hwbString(this.values.hwb, this.values.alpha);
        },
        keyword: function() {
            return colorString.keyword(this.values.rgb, this.values.alpha);
        },
        rgbNumber: function() {
            var rgb = this.values.rgb;
            return rgb[0] << 16 | rgb[1] << 8 | rgb[2];
        },
        luminosity: function() {
            // http://www.w3.org/TR/WCAG20/#relativeluminancedef
            var rgb = this.values.rgb;
            var lum = [];
            for(var i = 0; i < rgb.length; i++){
                var chan = rgb[i] / 255;
                lum[i] = chan <= 0.03928 ? chan / 12.92 : Math.pow((chan + 0.055) / 1.055, 2.4);
            }
            return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
        },
        contrast: function(color2) {
            // http://www.w3.org/TR/WCAG20/#contrast-ratiodef
            var lum1 = this.luminosity();
            var lum2 = color2.luminosity();
            if (lum1 > lum2) return (lum1 + 0.05) / (lum2 + 0.05);
            return (lum2 + 0.05) / (lum1 + 0.05);
        },
        level: function(color2) {
            var contrastRatio = this.contrast(color2);
            if (contrastRatio >= 7.1) return "AAA";
            return contrastRatio >= 4.5 ? "AA" : "";
        },
        dark: function() {
            // YIQ equation from http://24ways.org/2010/calculating-color-contrast
            var rgb = this.values.rgb;
            var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
            return yiq < 128;
        },
        light: function() {
            return !this.dark();
        },
        negate: function() {
            var rgb = [];
            for(var i = 0; i < 3; i++)rgb[i] = 255 - this.values.rgb[i];
            this.setValues("rgb", rgb);
            return this;
        },
        lighten: function(ratio) {
            var hsl = this.values.hsl;
            hsl[2] += hsl[2] * ratio;
            this.setValues("hsl", hsl);
            return this;
        },
        darken: function(ratio) {
            var hsl = this.values.hsl;
            hsl[2] -= hsl[2] * ratio;
            this.setValues("hsl", hsl);
            return this;
        },
        saturate: function(ratio) {
            var hsl = this.values.hsl;
            hsl[1] += hsl[1] * ratio;
            this.setValues("hsl", hsl);
            return this;
        },
        desaturate: function(ratio) {
            var hsl = this.values.hsl;
            hsl[1] -= hsl[1] * ratio;
            this.setValues("hsl", hsl);
            return this;
        },
        whiten: function(ratio) {
            var hwb = this.values.hwb;
            hwb[1] += hwb[1] * ratio;
            this.setValues("hwb", hwb);
            return this;
        },
        blacken: function(ratio) {
            var hwb = this.values.hwb;
            hwb[2] += hwb[2] * ratio;
            this.setValues("hwb", hwb);
            return this;
        },
        greyscale: function() {
            var rgb = this.values.rgb;
            // http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
            var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
            this.setValues("rgb", [
                val,
                val,
                val
            ]);
            return this;
        },
        clearer: function(ratio) {
            var alpha = this.values.alpha;
            this.setValues("alpha", alpha - alpha * ratio);
            return this;
        },
        opaquer: function(ratio) {
            var alpha = this.values.alpha;
            this.setValues("alpha", alpha + alpha * ratio);
            return this;
        },
        rotate: function(degrees) {
            var hsl = this.values.hsl;
            var hue = (hsl[0] + degrees) % 360;
            hsl[0] = hue < 0 ? 360 + hue : hue;
            this.setValues("hsl", hsl);
            return this;
        },
        /**
	 * Ported from sass implementation in C
	 * https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
	 */ mix: function(mixinColor, weight) {
            var color1 = this;
            var color2 = mixinColor;
            var p = weight === undefined ? 0.5 : weight;
            var w = 2 * p - 1;
            var a = color1.alpha() - color2.alpha();
            var w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
            var w2 = 1 - w1;
            return this.rgb(w1 * color1.red() + w2 * color2.red(), w1 * color1.green() + w2 * color2.green(), w1 * color1.blue() + w2 * color2.blue()).alpha(color1.alpha() * p + color2.alpha() * (1 - p));
        },
        toJSON: function() {
            return this.rgb();
        },
        clone: function() {
            // NOTE(SB): using node-clone creates a dependency to Buffer when using browserify,
            // making the final build way to big to embed in Chart.js. So let's do it manually,
            // assuming that values to clone are 1 dimension arrays containing only numbers,
            // except 'alpha' which is a number.
            var result = new Color();
            var source = this.values;
            var target = result.values;
            var value, type;
            for(var prop in source)if (source.hasOwnProperty(prop)) {
                value = source[prop];
                type = ({}).toString.call(value);
                if (type === "[object Array]") target[prop] = value.slice(0);
                else if (type === "[object Number]") target[prop] = value;
                else console.error("unexpected color value:", value);
            }
            return result;
        }
    };
    Color.prototype.spaces = {
        rgb: [
            "red",
            "green",
            "blue"
        ],
        hsl: [
            "hue",
            "saturation",
            "lightness"
        ],
        hsv: [
            "hue",
            "saturation",
            "value"
        ],
        hwb: [
            "hue",
            "whiteness",
            "blackness"
        ],
        cmyk: [
            "cyan",
            "magenta",
            "yellow",
            "black"
        ]
    };
    Color.prototype.maxes = {
        rgb: [
            255,
            255,
            255
        ],
        hsl: [
            360,
            100,
            100
        ],
        hsv: [
            360,
            100,
            100
        ],
        hwb: [
            360,
            100,
            100
        ],
        cmyk: [
            100,
            100,
            100,
            100
        ]
    };
    Color.prototype.getValues = function(space) {
        var values = this.values;
        var vals = {};
        for(var i = 0; i < space.length; i++)vals[space.charAt(i)] = values[space][i];
        if (values.alpha !== 1) vals.a = values.alpha;
        // {r: 255, g: 255, b: 255, a: 0.4}
        return vals;
    };
    Color.prototype.setValues = function(space, vals) {
        var values = this.values;
        var spaces = this.spaces;
        var maxes = this.maxes;
        var alpha = 1;
        var i;
        this.valid = true;
        if (space === "alpha") alpha = vals;
        else if (vals.length) {
            // [10, 10, 10]
            values[space] = vals.slice(0, space.length);
            alpha = vals[space.length];
        } else if (vals[space.charAt(0)] !== undefined) {
            // {r: 10, g: 10, b: 10}
            for(i = 0; i < space.length; i++)values[space][i] = vals[space.charAt(i)];
            alpha = vals.a;
        } else if (vals[spaces[space][0]] !== undefined) {
            // {red: 10, green: 10, blue: 10}
            var chans = spaces[space];
            for(i = 0; i < space.length; i++)values[space][i] = vals[chans[i]];
            alpha = vals.alpha;
        }
        values.alpha = Math.max(0, Math.min(1, alpha === undefined ? values.alpha : alpha));
        if (space === "alpha") return false;
        var capped;
        // cap values of the space prior converting all values
        for(i = 0; i < space.length; i++){
            capped = Math.max(0, Math.min(maxes[space][i], values[space][i]));
            values[space][i] = Math.round(capped);
        }
        // convert to all the other color spaces
        for(var sname in spaces)if (sname !== space) values[sname] = colorConvert[space][sname](values[space]);
        return true;
    };
    Color.prototype.setSpace = function(space, args) {
        var vals = args[0];
        if (vals === undefined) // color.rgb()
        return this.getValues(space);
        // color.rgb(10, 10, 10)
        if (typeof vals === "number") vals = Array.prototype.slice.call(args);
        this.setValues(space, vals);
        return this;
    };
    Color.prototype.setChannel = function(space, index, val) {
        var svalues = this.values[space];
        if (val === undefined) // color.red()
        return svalues[index];
        else if (val === svalues[index]) // color.red(color.red())
        return this;
        // color.red(100)
        svalues[index] = val;
        this.setValues(space, svalues);
        return this;
    };
    if (typeof window !== "undefined") window.Color = Color;
    var chartjsColor = Color;
    function isValidKey(key) {
        return [
            "__proto__",
            "prototype",
            "constructor"
        ].indexOf(key) === -1;
    }
    /**
 * @namespace Chart.helpers
 */ var helpers = {
        /**
	 * An empty function that can be used, for example, for optional callback.
	 */ noop: function() {},
        /**
	 * Returns a unique id, sequentially generated from a global variable.
	 * @returns {number}
	 * @function
	 */ uid: function() {
            var id = 0;
            return function() {
                return id++;
            };
        }(),
        /**
	 * Returns true if `value` is neither null nor undefined, else returns false.
	 * @param {*} value - The value to test.
	 * @returns {boolean}
	 * @since 2.7.0
	 */ isNullOrUndef: function(value) {
            return value === null || typeof value === "undefined";
        },
        /**
	 * Returns true if `value` is an array (including typed arrays), else returns false.
	 * @param {*} value - The value to test.
	 * @returns {boolean}
	 * @function
	 */ isArray: function(value) {
            if (Array.isArray && Array.isArray(value)) return true;
            var type = Object.prototype.toString.call(value);
            if (type.substr(0, 7) === "[object" && type.substr(-6) === "Array]") return true;
            return false;
        },
        /**
	 * Returns true if `value` is an object (excluding null), else returns false.
	 * @param {*} value - The value to test.
	 * @returns {boolean}
	 * @since 2.7.0
	 */ isObject: function(value) {
            return value !== null && Object.prototype.toString.call(value) === "[object Object]";
        },
        /**
	 * Returns true if `value` is a finite number, else returns false
	 * @param {*} value  - The value to test.
	 * @returns {boolean}
	 */ isFinite: function(value) {
            return (typeof value === "number" || value instanceof Number) && isFinite(value);
        },
        /**
	 * Returns `value` if defined, else returns `defaultValue`.
	 * @param {*} value - The value to return if defined.
	 * @param {*} defaultValue - The value to return if `value` is undefined.
	 * @returns {*}
	 */ valueOrDefault: function(value, defaultValue) {
            return typeof value === "undefined" ? defaultValue : value;
        },
        /**
	 * Returns value at the given `index` in array if defined, else returns `defaultValue`.
	 * @param {Array} value - The array to lookup for value at `index`.
	 * @param {number} index - The index in `value` to lookup for value.
	 * @param {*} defaultValue - The value to return if `value[index]` is undefined.
	 * @returns {*}
	 */ valueAtIndexOrDefault: function(value, index, defaultValue) {
            return helpers.valueOrDefault(helpers.isArray(value) ? value[index] : value, defaultValue);
        },
        /**
	 * Calls `fn` with the given `args` in the scope defined by `thisArg` and returns the
	 * value returned by `fn`. If `fn` is not a function, this method returns undefined.
	 * @param {function} fn - The function to call.
	 * @param {Array|undefined|null} args - The arguments with which `fn` should be called.
	 * @param {object} [thisArg] - The value of `this` provided for the call to `fn`.
	 * @returns {*}
	 */ callback: function(fn, args, thisArg) {
            if (fn && typeof fn.call === "function") return fn.apply(thisArg, args);
        },
        /**
	 * Note(SB) for performance sake, this method should only be used when loopable type
	 * is unknown or in none intensive code (not called often and small loopable). Else
	 * it's preferable to use a regular for() loop and save extra function calls.
	 * @param {object|Array} loopable - The object or array to be iterated.
	 * @param {function} fn - The function to call for each item.
	 * @param {object} [thisArg] - The value of `this` provided for the call to `fn`.
	 * @param {boolean} [reverse] - If true, iterates backward on the loopable.
	 */ each: function(loopable, fn, thisArg, reverse) {
            var i, len, keys;
            if (helpers.isArray(loopable)) {
                len = loopable.length;
                if (reverse) for(i = len - 1; i >= 0; i--)fn.call(thisArg, loopable[i], i);
                else for(i = 0; i < len; i++)fn.call(thisArg, loopable[i], i);
            } else if (helpers.isObject(loopable)) {
                keys = Object.keys(loopable);
                len = keys.length;
                for(i = 0; i < len; i++)fn.call(thisArg, loopable[keys[i]], keys[i]);
            }
        },
        /**
	 * Returns true if the `a0` and `a1` arrays have the same content, else returns false.
	 * @see https://stackoverflow.com/a/14853974
	 * @param {Array} a0 - The array to compare
	 * @param {Array} a1 - The array to compare
	 * @returns {boolean}
	 */ arrayEquals: function(a0, a1) {
            var i, ilen, v0, v1;
            if (!a0 || !a1 || a0.length !== a1.length) return false;
            for(i = 0, ilen = a0.length; i < ilen; ++i){
                v0 = a0[i];
                v1 = a1[i];
                if (v0 instanceof Array && v1 instanceof Array) {
                    if (!helpers.arrayEquals(v0, v1)) return false;
                } else if (v0 !== v1) // NOTE: two different object instances will never be equal: {x:20} != {x:20}
                return false;
            }
            return true;
        },
        /**
	 * Returns a deep copy of `source` without keeping references on objects and arrays.
	 * @param {*} source - The value to clone.
	 * @returns {*}
	 */ clone: function(source) {
            if (helpers.isArray(source)) return source.map(helpers.clone);
            if (helpers.isObject(source)) {
                var target = Object.create(source);
                var keys = Object.keys(source);
                var klen = keys.length;
                var k = 0;
                for(; k < klen; ++k)target[keys[k]] = helpers.clone(source[keys[k]]);
                return target;
            }
            return source;
        },
        /**
	 * The default merger when Chart.helpers.merge is called without merger option.
	 * Note(SB): also used by mergeConfig and mergeScaleConfig as fallback.
	 * @private
	 */ _merger: function(key, target, source, options) {
            if (!isValidKey(key)) // We want to ensure we do not copy prototypes over
            // as this can pollute global namespaces
            return;
            var tval = target[key];
            var sval = source[key];
            if (helpers.isObject(tval) && helpers.isObject(sval)) helpers.merge(tval, sval, options);
            else target[key] = helpers.clone(sval);
        },
        /**
	 * Merges source[key] in target[key] only if target[key] is undefined.
	 * @private
	 */ _mergerIf: function(key, target, source) {
            if (!isValidKey(key)) // We want to ensure we do not copy prototypes over
            // as this can pollute global namespaces
            return;
            var tval = target[key];
            var sval = source[key];
            if (helpers.isObject(tval) && helpers.isObject(sval)) helpers.mergeIf(tval, sval);
            else if (!target.hasOwnProperty(key)) target[key] = helpers.clone(sval);
        },
        /**
	 * Recursively deep copies `source` properties into `target` with the given `options`.
	 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
	 * @param {object} target - The target object in which all sources are merged into.
	 * @param {object|object[]} source - Object(s) to merge into `target`.
	 * @param {object} [options] - Merging options:
	 * @param {function} [options.merger] - The merge method (key, target, source, options)
	 * @returns {object} The `target` object.
	 */ merge: function(target, source, options) {
            var sources = helpers.isArray(source) ? source : [
                source
            ];
            var ilen = sources.length;
            var merge, i, keys, klen, k;
            if (!helpers.isObject(target)) return target;
            options = options || {};
            merge = options.merger || helpers._merger;
            for(i = 0; i < ilen; ++i){
                source = sources[i];
                if (!helpers.isObject(source)) continue;
                keys = Object.keys(source);
                for(k = 0, klen = keys.length; k < klen; ++k)merge(keys[k], target, source, options);
            }
            return target;
        },
        /**
	 * Recursively deep copies `source` properties into `target` *only* if not defined in target.
	 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
	 * @param {object} target - The target object in which all sources are merged into.
	 * @param {object|object[]} source - Object(s) to merge into `target`.
	 * @returns {object} The `target` object.
	 */ mergeIf: function(target, source) {
            return helpers.merge(target, source, {
                merger: helpers._mergerIf
            });
        },
        /**
	 * Applies the contents of two or more objects together into the first object.
	 * @param {object} target - The target object in which all objects are merged into.
	 * @param {object} arg1 - Object containing additional properties to merge in target.
	 * @param {object} argN - Additional objects containing properties to merge in target.
	 * @returns {object} The `target` object.
	 */ extend: Object.assign || function(target) {
            return helpers.merge(target, [].slice.call(arguments, 1), {
                merger: function(key, dst, src) {
                    dst[key] = src[key];
                }
            });
        },
        /**
	 * Basic javascript inheritance based on the model created in Backbone.js
	 */ inherits: function(extensions) {
            var me = this;
            var ChartElement = extensions && extensions.hasOwnProperty("constructor") ? extensions.constructor : function() {
                return me.apply(this, arguments);
            };
            var Surrogate = function() {
                this.constructor = ChartElement;
            };
            Surrogate.prototype = me.prototype;
            ChartElement.prototype = new Surrogate();
            ChartElement.extend = helpers.inherits;
            if (extensions) helpers.extend(ChartElement.prototype, extensions);
            ChartElement.__super__ = me.prototype;
            return ChartElement;
        },
        _deprecated: function(scope, value, previous, current) {
            if (value !== undefined) console.warn(scope + ': "' + previous + '" is deprecated. Please use "' + current + '" instead');
        }
    };
    var helpers_core = helpers;
    // DEPRECATIONS
    /**
 * Provided for backward compatibility, use Chart.helpers.callback instead.
 * @function Chart.helpers.callCallback
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 * @private
 */ helpers.callCallback = helpers.callback;
    /**
 * Provided for backward compatibility, use Array.prototype.indexOf instead.
 * Array.prototype.indexOf compatibility: Chrome, Opera, Safari, FF1.5+, IE9+
 * @function Chart.helpers.indexOf
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */ helpers.indexOf = function(array, item, fromIndex) {
        return Array.prototype.indexOf.call(array, item, fromIndex);
    };
    /**
 * Provided for backward compatibility, use Chart.helpers.valueOrDefault instead.
 * @function Chart.helpers.getValueOrDefault
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */ helpers.getValueOrDefault = helpers.valueOrDefault;
    /**
 * Provided for backward compatibility, use Chart.helpers.valueAtIndexOrDefault instead.
 * @function Chart.helpers.getValueAtIndexOrDefault
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */ helpers.getValueAtIndexOrDefault = helpers.valueAtIndexOrDefault;
    /**
 * Easing functions adapted from Robert Penner's easing equations.
 * @namespace Chart.helpers.easingEffects
 * @see http://www.robertpenner.com/easing/
 */ var effects = {
        linear: function(t) {
            return t;
        },
        easeInQuad: function(t) {
            return t * t;
        },
        easeOutQuad: function(t) {
            return -t * (t - 2);
        },
        easeInOutQuad: function(t) {
            if ((t /= 0.5) < 1) return 0.5 * t * t;
            return -0.5 * (--t * (t - 2) - 1);
        },
        easeInCubic: function(t) {
            return t * t * t;
        },
        easeOutCubic: function(t) {
            return (t = t - 1) * t * t + 1;
        },
        easeInOutCubic: function(t) {
            if ((t /= 0.5) < 1) return 0.5 * t * t * t;
            return 0.5 * ((t -= 2) * t * t + 2);
        },
        easeInQuart: function(t) {
            return t * t * t * t;
        },
        easeOutQuart: function(t) {
            return -((t = t - 1) * t * t * t - 1);
        },
        easeInOutQuart: function(t) {
            if ((t /= 0.5) < 1) return 0.5 * t * t * t * t;
            return -0.5 * ((t -= 2) * t * t * t - 2);
        },
        easeInQuint: function(t) {
            return t * t * t * t * t;
        },
        easeOutQuint: function(t) {
            return (t = t - 1) * t * t * t * t + 1;
        },
        easeInOutQuint: function(t) {
            if ((t /= 0.5) < 1) return 0.5 * t * t * t * t * t;
            return 0.5 * ((t -= 2) * t * t * t * t + 2);
        },
        easeInSine: function(t) {
            return -Math.cos(t * (Math.PI / 2)) + 1;
        },
        easeOutSine: function(t) {
            return Math.sin(t * (Math.PI / 2));
        },
        easeInOutSine: function(t) {
            return -0.5 * (Math.cos(Math.PI * t) - 1);
        },
        easeInExpo: function(t) {
            return t === 0 ? 0 : Math.pow(2, 10 * (t - 1));
        },
        easeOutExpo: function(t) {
            return t === 1 ? 1 : -Math.pow(2, -10 * t) + 1;
        },
        easeInOutExpo: function(t) {
            if (t === 0) return 0;
            if (t === 1) return 1;
            if ((t /= 0.5) < 1) return 0.5 * Math.pow(2, 10 * (t - 1));
            return 0.5 * (-Math.pow(2, -10 * --t) + 2);
        },
        easeInCirc: function(t) {
            if (t >= 1) return t;
            return -(Math.sqrt(1 - t * t) - 1);
        },
        easeOutCirc: function(t) {
            return Math.sqrt(1 - (t = t - 1) * t);
        },
        easeInOutCirc: function(t) {
            if ((t /= 0.5) < 1) return -0.5 * (Math.sqrt(1 - t * t) - 1);
            return 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1);
        },
        easeInElastic: function(t) {
            var s = 1.70158;
            var p = 0;
            var a = 1;
            if (t === 0) return 0;
            if (t === 1) return 1;
            if (!p) p = 0.3;
            if (a < 1) {
                a = 1;
                s = p / 4;
            } else s = p / (2 * Math.PI) * Math.asin(1 / a);
            return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
        },
        easeOutElastic: function(t) {
            var s = 1.70158;
            var p = 0;
            var a = 1;
            if (t === 0) return 0;
            if (t === 1) return 1;
            if (!p) p = 0.3;
            if (a < 1) {
                a = 1;
                s = p / 4;
            } else s = p / (2 * Math.PI) * Math.asin(1 / a);
            return a * Math.pow(2, -10 * t) * Math.sin((t - s) * (2 * Math.PI) / p) + 1;
        },
        easeInOutElastic: function(t) {
            var s = 1.70158;
            var p = 0;
            var a = 1;
            if (t === 0) return 0;
            if ((t /= 0.5) === 2) return 1;
            if (!p) p = 0.45;
            if (a < 1) {
                a = 1;
                s = p / 4;
            } else s = p / (2 * Math.PI) * Math.asin(1 / a);
            if (t < 1) return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
            return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p) * 0.5 + 1;
        },
        easeInBack: function(t) {
            var s = 1.70158;
            return t * t * ((s + 1) * t - s);
        },
        easeOutBack: function(t) {
            var s = 1.70158;
            return (t = t - 1) * t * ((s + 1) * t + s) + 1;
        },
        easeInOutBack: function(t) {
            var s = 1.70158;
            if ((t /= 0.5) < 1) return 0.5 * (t * t * (((s *= 1.525) + 1) * t - s));
            return 0.5 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2);
        },
        easeInBounce: function(t) {
            return 1 - effects.easeOutBounce(1 - t);
        },
        easeOutBounce: function(t) {
            if (t < 1 / 2.75) return 7.5625 * t * t;
            if (t < 2 / 2.75) return 7.5625 * (t -= 1.5 / 2.75) * t + 0.75;
            if (t < 2.5 / 2.75) return 7.5625 * (t -= 2.25 / 2.75) * t + 0.9375;
            return 7.5625 * (t -= 2.625 / 2.75) * t + 0.984375;
        },
        easeInOutBounce: function(t) {
            if (t < 0.5) return effects.easeInBounce(t * 2) * 0.5;
            return effects.easeOutBounce(t * 2 - 1) * 0.5 + 0.5;
        }
    };
    var helpers_easing = {
        effects: effects
    };
    // DEPRECATIONS
    /**
 * Provided for backward compatibility, use Chart.helpers.easing.effects instead.
 * @function Chart.helpers.easingEffects
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */ helpers_core.easingEffects = effects;
    var PI = Math.PI;
    var RAD_PER_DEG = PI / 180;
    var DOUBLE_PI = PI * 2;
    var HALF_PI = PI / 2;
    var QUARTER_PI = PI / 4;
    var TWO_THIRDS_PI = PI * 2 / 3;
    /**
 * @namespace Chart.helpers.canvas
 */ var exports$1 = {
        /**
	 * Clears the entire canvas associated to the given `chart`.
	 * @param {Chart} chart - The chart for which to clear the canvas.
	 */ clear: function(chart) {
            chart.ctx.clearRect(0, 0, chart.width, chart.height);
        },
        /**
	 * Creates a "path" for a rectangle with rounded corners at position (x, y) with a
	 * given size (width, height) and the same `radius` for all corners.
	 * @param {CanvasRenderingContext2D} ctx - The canvas 2D Context.
	 * @param {number} x - The x axis of the coordinate for the rectangle starting point.
	 * @param {number} y - The y axis of the coordinate for the rectangle starting point.
	 * @param {number} width - The rectangle's width.
	 * @param {number} height - The rectangle's height.
	 * @param {number} radius - The rounded amount (in pixels) for the four corners.
	 * @todo handle `radius` as top-left, top-right, bottom-right, bottom-left array/object?
	 */ roundedRect: function(ctx, x, y, width, height, radius) {
            if (radius) {
                var r = Math.min(radius, height / 2, width / 2);
                var left = x + r;
                var top = y + r;
                var right = x + width - r;
                var bottom = y + height - r;
                ctx.moveTo(x, top);
                if (left < right && top < bottom) {
                    ctx.arc(left, top, r, -PI, -HALF_PI);
                    ctx.arc(right, top, r, -HALF_PI, 0);
                    ctx.arc(right, bottom, r, 0, HALF_PI);
                    ctx.arc(left, bottom, r, HALF_PI, PI);
                } else if (left < right) {
                    ctx.moveTo(left, y);
                    ctx.arc(right, top, r, -HALF_PI, HALF_PI);
                    ctx.arc(left, top, r, HALF_PI, PI + HALF_PI);
                } else if (top < bottom) {
                    ctx.arc(left, top, r, -PI, 0);
                    ctx.arc(left, bottom, r, 0, PI);
                } else ctx.arc(left, top, r, -PI, PI);
                ctx.closePath();
                ctx.moveTo(x, y);
            } else ctx.rect(x, y, width, height);
        },
        drawPoint: function(ctx, style, radius, x, y, rotation) {
            var type, xOffset, yOffset, size, cornerRadius;
            var rad = (rotation || 0) * RAD_PER_DEG;
            if (style && typeof style === "object") {
                type = style.toString();
                if (type === "[object HTMLImageElement]" || type === "[object HTMLCanvasElement]") {
                    ctx.save();
                    ctx.translate(x, y);
                    ctx.rotate(rad);
                    ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
                    ctx.restore();
                    return;
                }
            }
            if (isNaN(radius) || radius <= 0) return;
            ctx.beginPath();
            switch(style){
                // Default includes circle
                default:
                    ctx.arc(x, y, radius, 0, DOUBLE_PI);
                    ctx.closePath();
                    break;
                case "triangle":
                    ctx.moveTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
                    rad += TWO_THIRDS_PI;
                    ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
                    rad += TWO_THIRDS_PI;
                    ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
                    ctx.closePath();
                    break;
                case "rectRounded":
                    // NOTE: the rounded rect implementation changed to use `arc` instead of
                    // `quadraticCurveTo` since it generates better results when rect is
                    // almost a circle. 0.516 (instead of 0.5) produces results with visually
                    // closer proportion to the previous impl and it is inscribed in the
                    // circle with `radius`. For more details, see the following PRs:
                    // https://github.com/chartjs/Chart.js/issues/5597
                    // https://github.com/chartjs/Chart.js/issues/5858
                    cornerRadius = radius * 0.516;
                    size = radius - cornerRadius;
                    xOffset = Math.cos(rad + QUARTER_PI) * size;
                    yOffset = Math.sin(rad + QUARTER_PI) * size;
                    ctx.arc(x - xOffset, y - yOffset, cornerRadius, rad - PI, rad - HALF_PI);
                    ctx.arc(x + yOffset, y - xOffset, cornerRadius, rad - HALF_PI, rad);
                    ctx.arc(x + xOffset, y + yOffset, cornerRadius, rad, rad + HALF_PI);
                    ctx.arc(x - yOffset, y + xOffset, cornerRadius, rad + HALF_PI, rad + PI);
                    ctx.closePath();
                    break;
                case "rect":
                    if (!rotation) {
                        size = Math.SQRT1_2 * radius;
                        ctx.rect(x - size, y - size, 2 * size, 2 * size);
                        break;
                    }
                    rad += QUARTER_PI;
                /* falls through */ case "rectRot":
                    xOffset = Math.cos(rad) * radius;
                    yOffset = Math.sin(rad) * radius;
                    ctx.moveTo(x - xOffset, y - yOffset);
                    ctx.lineTo(x + yOffset, y - xOffset);
                    ctx.lineTo(x + xOffset, y + yOffset);
                    ctx.lineTo(x - yOffset, y + xOffset);
                    ctx.closePath();
                    break;
                case "crossRot":
                    rad += QUARTER_PI;
                /* falls through */ case "cross":
                    xOffset = Math.cos(rad) * radius;
                    yOffset = Math.sin(rad) * radius;
                    ctx.moveTo(x - xOffset, y - yOffset);
                    ctx.lineTo(x + xOffset, y + yOffset);
                    ctx.moveTo(x + yOffset, y - xOffset);
                    ctx.lineTo(x - yOffset, y + xOffset);
                    break;
                case "star":
                    xOffset = Math.cos(rad) * radius;
                    yOffset = Math.sin(rad) * radius;
                    ctx.moveTo(x - xOffset, y - yOffset);
                    ctx.lineTo(x + xOffset, y + yOffset);
                    ctx.moveTo(x + yOffset, y - xOffset);
                    ctx.lineTo(x - yOffset, y + xOffset);
                    rad += QUARTER_PI;
                    xOffset = Math.cos(rad) * radius;
                    yOffset = Math.sin(rad) * radius;
                    ctx.moveTo(x - xOffset, y - yOffset);
                    ctx.lineTo(x + xOffset, y + yOffset);
                    ctx.moveTo(x + yOffset, y - xOffset);
                    ctx.lineTo(x - yOffset, y + xOffset);
                    break;
                case "line":
                    xOffset = Math.cos(rad) * radius;
                    yOffset = Math.sin(rad) * radius;
                    ctx.moveTo(x - xOffset, y - yOffset);
                    ctx.lineTo(x + xOffset, y + yOffset);
                    break;
                case "dash":
                    ctx.moveTo(x, y);
                    ctx.lineTo(x + Math.cos(rad) * radius, y + Math.sin(rad) * radius);
                    break;
            }
            ctx.fill();
            ctx.stroke();
        },
        /**
	 * Returns true if the point is inside the rectangle
	 * @param {object} point - The point to test
	 * @param {object} area - The rectangle
	 * @returns {boolean}
	 * @private
	 */ _isPointInArea: function(point, area) {
            var epsilon = 1e-6; // 1e-6 is margin in pixels for accumulated error.
            return point.x > area.left - epsilon && point.x < area.right + epsilon && point.y > area.top - epsilon && point.y < area.bottom + epsilon;
        },
        clipArea: function(ctx, area) {
            ctx.save();
            ctx.beginPath();
            ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
            ctx.clip();
        },
        unclipArea: function(ctx) {
            ctx.restore();
        },
        lineTo: function(ctx, previous, target, flip) {
            var stepped = target.steppedLine;
            if (stepped) {
                if (stepped === "middle") {
                    var midpoint = (previous.x + target.x) / 2.0;
                    ctx.lineTo(midpoint, flip ? target.y : previous.y);
                    ctx.lineTo(midpoint, flip ? previous.y : target.y);
                } else if (stepped === "after" && !flip || stepped !== "after" && flip) ctx.lineTo(previous.x, target.y);
                else ctx.lineTo(target.x, previous.y);
                ctx.lineTo(target.x, target.y);
                return;
            }
            if (!target.tension) {
                ctx.lineTo(target.x, target.y);
                return;
            }
            ctx.bezierCurveTo(flip ? previous.controlPointPreviousX : previous.controlPointNextX, flip ? previous.controlPointPreviousY : previous.controlPointNextY, flip ? target.controlPointNextX : target.controlPointPreviousX, flip ? target.controlPointNextY : target.controlPointPreviousY, target.x, target.y);
        }
    };
    var helpers_canvas = exports$1;
    // DEPRECATIONS
    /**
 * Provided for backward compatibility, use Chart.helpers.canvas.clear instead.
 * @namespace Chart.helpers.clear
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */ helpers_core.clear = exports$1.clear;
    /**
 * Provided for backward compatibility, use Chart.helpers.canvas.roundedRect instead.
 * @namespace Chart.helpers.drawRoundedRectangle
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */ helpers_core.drawRoundedRectangle = function(ctx) {
        ctx.beginPath();
        exports$1.roundedRect.apply(exports$1, arguments);
    };
    var defaults = {
        /**
	 * @private
	 */ _set: function(scope, values) {
            return helpers_core.merge(this[scope] || (this[scope] = {}), values);
        }
    };
    // TODO(v3): remove 'global' from namespace.  all default are global and
    // there's inconsistency around which options are under 'global'
    defaults._set("global", {
        defaultColor: "rgba(0,0,0,0.1)",
        defaultFontColor: "#666",
        defaultFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        defaultFontSize: 12,
        defaultFontStyle: "normal",
        defaultLineHeight: 1.2,
        showLines: true
    });
    var core_defaults = defaults;
    var valueOrDefault = helpers_core.valueOrDefault;
    /**
 * Converts the given font object into a CSS font string.
 * @param {object} font - A font object.
 * @return {string} The CSS font string. See https://developer.mozilla.org/en-US/docs/Web/CSS/font
 * @private
 */ function toFontString(font) {
        if (!font || helpers_core.isNullOrUndef(font.size) || helpers_core.isNullOrUndef(font.family)) return null;
        return (font.style ? font.style + " " : "") + (font.weight ? font.weight + " " : "") + font.size + "px " + font.family;
    }
    /**
 * @alias Chart.helpers.options
 * @namespace
 */ var helpers_options = {
        /**
	 * Converts the given line height `value` in pixels for a specific font `size`.
	 * @param {number|string} value - The lineHeight to parse (eg. 1.6, '14px', '75%', '1.6em').
	 * @param {number} size - The font size (in pixels) used to resolve relative `value`.
	 * @returns {number} The effective line height in pixels (size * 1.2 if value is invalid).
	 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
	 * @since 2.7.0
	 */ toLineHeight: function(value, size) {
            var matches = ("" + value).match(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/);
            if (!matches || matches[1] === "normal") return size * 1.2;
            value = +matches[2];
            switch(matches[3]){
                case "px":
                    return value;
                case "%":
                    value /= 100;
                    break;
            }
            return size * value;
        },
        /**
	 * Converts the given value into a padding object with pre-computed width/height.
	 * @param {number|object} value - If a number, set the value to all TRBL component,
	 *  else, if and object, use defined properties and sets undefined ones to 0.
	 * @returns {object} The padding values (top, right, bottom, left, width, height)
	 * @since 2.7.0
	 */ toPadding: function(value) {
            var t, r, b, l;
            if (helpers_core.isObject(value)) {
                t = +value.top || 0;
                r = +value.right || 0;
                b = +value.bottom || 0;
                l = +value.left || 0;
            } else t = r = b = l = +value || 0;
            return {
                top: t,
                right: r,
                bottom: b,
                left: l,
                height: t + b,
                width: l + r
            };
        },
        /**
	 * Parses font options and returns the font object.
	 * @param {object} options - A object that contains font options to be parsed.
	 * @return {object} The font object.
	 * @todo Support font.* options and renamed to toFont().
	 * @private
	 */ _parseFont: function(options) {
            var globalDefaults = core_defaults.global;
            var size = valueOrDefault(options.fontSize, globalDefaults.defaultFontSize);
            var font = {
                family: valueOrDefault(options.fontFamily, globalDefaults.defaultFontFamily),
                lineHeight: helpers_core.options.toLineHeight(valueOrDefault(options.lineHeight, globalDefaults.defaultLineHeight), size),
                size: size,
                style: valueOrDefault(options.fontStyle, globalDefaults.defaultFontStyle),
                weight: null,
                string: ""
            };
            font.string = toFontString(font);
            return font;
        },
        /**
	 * Evaluates the given `inputs` sequentially and returns the first defined value.
	 * @param {Array} inputs - An array of values, falling back to the last value.
	 * @param {object} [context] - If defined and the current value is a function, the value
	 * is called with `context` as first argument and the result becomes the new input.
	 * @param {number} [index] - If defined and the current value is an array, the value
	 * at `index` become the new input.
	 * @param {object} [info] - object to return information about resolution in
	 * @param {boolean} [info.cacheable] - Will be set to `false` if option is not cacheable.
	 * @since 2.7.0
	 */ resolve: function(inputs, context, index, info) {
            var cacheable = true;
            var i, ilen, value;
            for(i = 0, ilen = inputs.length; i < ilen; ++i){
                value = inputs[i];
                if (value === undefined) continue;
                if (context !== undefined && typeof value === "function") {
                    value = value(context);
                    cacheable = false;
                }
                if (index !== undefined && helpers_core.isArray(value)) {
                    value = value[index];
                    cacheable = false;
                }
                if (value !== undefined) {
                    if (info && !cacheable) info.cacheable = false;
                    return value;
                }
            }
        }
    };
    /**
 * @alias Chart.helpers.math
 * @namespace
 */ var exports$2 = {
        /**
	 * Returns an array of factors sorted from 1 to sqrt(value)
	 * @private
	 */ _factorize: function(value) {
            var result = [];
            var sqrt = Math.sqrt(value);
            var i;
            for(i = 1; i < sqrt; i++)if (value % i === 0) {
                result.push(i);
                result.push(value / i);
            }
            if (sqrt === (sqrt | 0)) result.push(sqrt);
            result.sort(function(a, b) {
                return a - b;
            }).pop();
            return result;
        },
        log10: Math.log10 || function(x) {
            var exponent = Math.log(x) * Math.LOG10E; // Math.LOG10E = 1 / Math.LN10.
            // Check for whole powers of 10,
            // which due to floating point rounding error should be corrected.
            var powerOf10 = Math.round(exponent);
            var isPowerOf10 = x === Math.pow(10, powerOf10);
            return isPowerOf10 ? powerOf10 : exponent;
        }
    };
    var helpers_math = exports$2;
    // DEPRECATIONS
    /**
 * Provided for backward compatibility, use Chart.helpers.math.log10 instead.
 * @namespace Chart.helpers.log10
 * @deprecated since version 2.9.0
 * @todo remove at version 3
 * @private
 */ helpers_core.log10 = exports$2.log10;
    var getRtlAdapter = function(rectX, width) {
        return {
            x: function(x) {
                return rectX + rectX + width - x;
            },
            setWidth: function(w) {
                width = w;
            },
            textAlign: function(align) {
                if (align === "center") return align;
                return align === "right" ? "left" : "right";
            },
            xPlus: function(x, value) {
                return x - value;
            },
            leftForLtr: function(x, itemWidth) {
                return x - itemWidth;
            }
        };
    };
    var getLtrAdapter = function() {
        return {
            x: function(x) {
                return x;
            },
            setWidth: function(w) {},
            textAlign: function(align) {
                return align;
            },
            xPlus: function(x, value) {
                return x + value;
            },
            leftForLtr: function(x, _itemWidth) {
                return x;
            }
        };
    };
    var getAdapter = function(rtl, rectX, width) {
        return rtl ? getRtlAdapter(rectX, width) : getLtrAdapter();
    };
    var overrideTextDirection = function(ctx, direction) {
        var style, original;
        if (direction === "ltr" || direction === "rtl") {
            style = ctx.canvas.style;
            original = [
                style.getPropertyValue("direction"),
                style.getPropertyPriority("direction")
            ];
            style.setProperty("direction", direction, "important");
            ctx.prevTextDirection = original;
        }
    };
    var restoreTextDirection = function(ctx) {
        var original = ctx.prevTextDirection;
        if (original !== undefined) {
            delete ctx.prevTextDirection;
            ctx.canvas.style.setProperty("direction", original[0], original[1]);
        }
    };
    var helpers_rtl = {
        getRtlAdapter: getAdapter,
        overrideTextDirection: overrideTextDirection,
        restoreTextDirection: restoreTextDirection
    };
    var helpers$1 = helpers_core;
    var easing = helpers_easing;
    var canvas = helpers_canvas;
    var options = helpers_options;
    var math = helpers_math;
    var rtl = helpers_rtl;
    helpers$1.easing = easing;
    helpers$1.canvas = canvas;
    helpers$1.options = options;
    helpers$1.math = math;
    helpers$1.rtl = rtl;
    function interpolate(start, view, model, ease) {
        var keys = Object.keys(model);
        var i, ilen, key, actual, origin, target, type, c0, c1;
        for(i = 0, ilen = keys.length; i < ilen; ++i){
            key = keys[i];
            target = model[key];
            // if a value is added to the model after pivot() has been called, the view
            // doesn't contain it, so let's initialize the view to the target value.
            if (!view.hasOwnProperty(key)) view[key] = target;
            actual = view[key];
            if (actual === target || key[0] === "_") continue;
            if (!start.hasOwnProperty(key)) start[key] = actual;
            origin = start[key];
            type = typeof target;
            if (type === typeof origin) {
                if (type === "string") {
                    c0 = chartjsColor(origin);
                    if (c0.valid) {
                        c1 = chartjsColor(target);
                        if (c1.valid) {
                            view[key] = c1.mix(c0, ease).rgbString();
                            continue;
                        }
                    }
                } else if (helpers$1.isFinite(origin) && helpers$1.isFinite(target)) {
                    view[key] = origin + (target - origin) * ease;
                    continue;
                }
            }
            view[key] = target;
        }
    }
    var Element = function(configuration) {
        helpers$1.extend(this, configuration);
        this.initialize.apply(this, arguments);
    };
    helpers$1.extend(Element.prototype, {
        _type: undefined,
        initialize: function() {
            this.hidden = false;
        },
        pivot: function() {
            var me = this;
            if (!me._view) me._view = helpers$1.extend({}, me._model);
            me._start = {};
            return me;
        },
        transition: function(ease) {
            var me = this;
            var model = me._model;
            var start = me._start;
            var view = me._view;
            // No animation -> No Transition
            if (!model || ease === 1) {
                me._view = helpers$1.extend({}, model);
                me._start = null;
                return me;
            }
            if (!view) view = me._view = {};
            if (!start) start = me._start = {};
            interpolate(start, view, model, ease);
            return me;
        },
        tooltipPosition: function() {
            return {
                x: this._model.x,
                y: this._model.y
            };
        },
        hasValue: function() {
            return helpers$1.isNumber(this._model.x) && helpers$1.isNumber(this._model.y);
        }
    });
    Element.extend = helpers$1.inherits;
    var core_element = Element;
    var exports$3 = core_element.extend({
        chart: null,
        currentStep: 0,
        numSteps: 60,
        easing: "",
        render: null,
        onAnimationProgress: null,
        onAnimationComplete: null
    });
    var core_animation = exports$3;
    // DEPRECATIONS
    /**
 * Provided for backward compatibility, use Chart.Animation instead
 * @prop Chart.Animation#animationObject
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 */ Object.defineProperty(exports$3.prototype, "animationObject", {
        get: function() {
            return this;
        }
    });
    /**
 * Provided for backward compatibility, use Chart.Animation#chart instead
 * @prop Chart.Animation#chartInstance
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 */ Object.defineProperty(exports$3.prototype, "chartInstance", {
        get: function() {
            return this.chart;
        },
        set: function(value) {
            this.chart = value;
        }
    });
    core_defaults._set("global", {
        animation: {
            duration: 1000,
            easing: "easeOutQuart",
            onProgress: helpers$1.noop,
            onComplete: helpers$1.noop
        }
    });
    var core_animations = {
        animations: [],
        request: null,
        /**
	 * @param {Chart} chart - The chart to animate.
	 * @param {Chart.Animation} animation - The animation that we will animate.
	 * @param {number} duration - The animation duration in ms.
	 * @param {boolean} lazy - if true, the chart is not marked as animating to enable more responsive interactions
	 */ addAnimation: function(chart, animation, duration, lazy) {
            var animations = this.animations;
            var i, ilen;
            animation.chart = chart;
            animation.startTime = Date.now();
            animation.duration = duration;
            if (!lazy) chart.animating = true;
            for(i = 0, ilen = animations.length; i < ilen; ++i)if (animations[i].chart === chart) {
                animations[i] = animation;
                return;
            }
            animations.push(animation);
            // If there are no animations queued, manually kickstart a digest, for lack of a better word
            if (animations.length === 1) this.requestAnimationFrame();
        },
        cancelAnimation: function(chart) {
            var index = helpers$1.findIndex(this.animations, function(animation) {
                return animation.chart === chart;
            });
            if (index !== -1) {
                this.animations.splice(index, 1);
                chart.animating = false;
            }
        },
        requestAnimationFrame: function() {
            var me = this;
            if (me.request === null) // Skip animation frame requests until the active one is executed.
            // This can happen when processing mouse events, e.g. 'mousemove'
            // and 'mouseout' events will trigger multiple renders.
            me.request = helpers$1.requestAnimFrame.call(window, function() {
                me.request = null;
                me.startDigest();
            });
        },
        /**
	 * @private
	 */ startDigest: function() {
            var me = this;
            me.advance();
            // Do we have more stuff to animate?
            if (me.animations.length > 0) me.requestAnimationFrame();
        },
        /**
	 * @private
	 */ advance: function() {
            var animations = this.animations;
            var animation, chart, numSteps, nextStep;
            var i = 0;
            // 1 animation per chart, so we are looping charts here
            while(i < animations.length){
                animation = animations[i];
                chart = animation.chart;
                numSteps = animation.numSteps;
                // Make sure that currentStep starts at 1
                // https://github.com/chartjs/Chart.js/issues/6104
                nextStep = Math.floor((Date.now() - animation.startTime) / animation.duration * numSteps) + 1;
                animation.currentStep = Math.min(nextStep, numSteps);
                helpers$1.callback(animation.render, [
                    chart,
                    animation
                ], chart);
                helpers$1.callback(animation.onAnimationProgress, [
                    animation
                ], chart);
                if (animation.currentStep >= numSteps) {
                    helpers$1.callback(animation.onAnimationComplete, [
                        animation
                    ], chart);
                    chart.animating = false;
                    animations.splice(i, 1);
                } else ++i;
            }
        }
    };
    var resolve = helpers$1.options.resolve;
    var arrayEvents = [
        "push",
        "pop",
        "shift",
        "splice",
        "unshift"
    ];
    /**
 * Hooks the array methods that add or remove values ('push', pop', 'shift', 'splice',
 * 'unshift') and notify the listener AFTER the array has been altered. Listeners are
 * called on the 'onData*' callbacks (e.g. onDataPush, etc.) with same arguments.
 */ function listenArrayEvents(array, listener) {
        if (array._chartjs) {
            array._chartjs.listeners.push(listener);
            return;
        }
        Object.defineProperty(array, "_chartjs", {
            configurable: true,
            enumerable: false,
            value: {
                listeners: [
                    listener
                ]
            }
        });
        arrayEvents.forEach(function(key) {
            var method = "onData" + key.charAt(0).toUpperCase() + key.slice(1);
            var base = array[key];
            Object.defineProperty(array, key, {
                configurable: true,
                enumerable: false,
                value: function() {
                    var args = Array.prototype.slice.call(arguments);
                    var res = base.apply(this, args);
                    helpers$1.each(array._chartjs.listeners, function(object) {
                        if (typeof object[method] === "function") object[method].apply(object, args);
                    });
                    return res;
                }
            });
        });
    }
    /**
 * Removes the given array event listener and cleanup extra attached properties (such as
 * the _chartjs stub and overridden methods) if array doesn't have any more listeners.
 */ function unlistenArrayEvents(array, listener) {
        var stub = array._chartjs;
        if (!stub) return;
        var listeners = stub.listeners;
        var index = listeners.indexOf(listener);
        if (index !== -1) listeners.splice(index, 1);
        if (listeners.length > 0) return;
        arrayEvents.forEach(function(key) {
            delete array[key];
        });
        delete array._chartjs;
    }
    // Base class for all dataset controllers (line, bar, etc)
    var DatasetController = function(chart, datasetIndex) {
        this.initialize(chart, datasetIndex);
    };
    helpers$1.extend(DatasetController.prototype, {
        /**
	 * Element type used to generate a meta dataset (e.g. Chart.element.Line).
	 * @type {Chart.core.element}
	 */ datasetElementType: null,
        /**
	 * Element type used to generate a meta data (e.g. Chart.element.Point).
	 * @type {Chart.core.element}
	 */ dataElementType: null,
        /**
	 * Dataset element option keys to be resolved in _resolveDatasetElementOptions.
	 * A derived controller may override this to resolve controller-specific options.
	 * The keys defined here are for backward compatibility for legend styles.
	 * @private
	 */ _datasetElementOptions: [
            "backgroundColor",
            "borderCapStyle",
            "borderColor",
            "borderDash",
            "borderDashOffset",
            "borderJoinStyle",
            "borderWidth"
        ],
        /**
	 * Data element option keys to be resolved in _resolveDataElementOptions.
	 * A derived controller may override this to resolve controller-specific options.
	 * The keys defined here are for backward compatibility for legend styles.
	 * @private
	 */ _dataElementOptions: [
            "backgroundColor",
            "borderColor",
            "borderWidth",
            "pointStyle"
        ],
        initialize: function(chart, datasetIndex) {
            var me = this;
            me.chart = chart;
            me.index = datasetIndex;
            me.linkScales();
            me.addElements();
            me._type = me.getMeta().type;
        },
        updateIndex: function(datasetIndex) {
            this.index = datasetIndex;
        },
        linkScales: function() {
            var me = this;
            var meta = me.getMeta();
            var chart = me.chart;
            var scales = chart.scales;
            var dataset = me.getDataset();
            var scalesOpts = chart.options.scales;
            if (meta.xAxisID === null || !(meta.xAxisID in scales) || dataset.xAxisID) meta.xAxisID = dataset.xAxisID || scalesOpts.xAxes[0].id;
            if (meta.yAxisID === null || !(meta.yAxisID in scales) || dataset.yAxisID) meta.yAxisID = dataset.yAxisID || scalesOpts.yAxes[0].id;
        },
        getDataset: function() {
            return this.chart.data.datasets[this.index];
        },
        getMeta: function() {
            return this.chart.getDatasetMeta(this.index);
        },
        getScaleForId: function(scaleID) {
            return this.chart.scales[scaleID];
        },
        /**
	 * @private
	 */ _getValueScaleId: function() {
            return this.getMeta().yAxisID;
        },
        /**
	 * @private
	 */ _getIndexScaleId: function() {
            return this.getMeta().xAxisID;
        },
        /**
	 * @private
	 */ _getValueScale: function() {
            return this.getScaleForId(this._getValueScaleId());
        },
        /**
	 * @private
	 */ _getIndexScale: function() {
            return this.getScaleForId(this._getIndexScaleId());
        },
        reset: function() {
            this._update(true);
        },
        /**
	 * @private
	 */ destroy: function() {
            if (this._data) unlistenArrayEvents(this._data, this);
        },
        createMetaDataset: function() {
            var me = this;
            var type = me.datasetElementType;
            return type && new type({
                _chart: me.chart,
                _datasetIndex: me.index
            });
        },
        createMetaData: function(index) {
            var me = this;
            var type = me.dataElementType;
            return type && new type({
                _chart: me.chart,
                _datasetIndex: me.index,
                _index: index
            });
        },
        addElements: function() {
            var me = this;
            var meta = me.getMeta();
            var data = me.getDataset().data || [];
            var metaData = meta.data;
            var i, ilen;
            for(i = 0, ilen = data.length; i < ilen; ++i)metaData[i] = metaData[i] || me.createMetaData(i);
            meta.dataset = meta.dataset || me.createMetaDataset();
        },
        addElementAndReset: function(index) {
            var element = this.createMetaData(index);
            this.getMeta().data.splice(index, 0, element);
            this.updateElement(element, index, true);
        },
        buildOrUpdateElements: function() {
            var me = this;
            var dataset = me.getDataset();
            var data = dataset.data || (dataset.data = []);
            // In order to correctly handle data addition/deletion animation (an thus simulate
            // real-time charts), we need to monitor these data modifications and synchronize
            // the internal meta data accordingly.
            if (me._data !== data) {
                if (me._data) // This case happens when the user replaced the data array instance.
                unlistenArrayEvents(me._data, me);
                if (data && Object.isExtensible(data)) listenArrayEvents(data, me);
                me._data = data;
            }
            // Re-sync meta data in case the user replaced the data array or if we missed
            // any updates and so make sure that we handle number of datapoints changing.
            me.resyncElements();
        },
        /**
	 * Returns the merged user-supplied and default dataset-level options
	 * @private
	 */ _configure: function() {
            var me = this;
            me._config = helpers$1.merge(Object.create(null), [
                me.chart.options.datasets[me._type],
                me.getDataset()
            ], {
                merger: function(key, target, source) {
                    if (key !== "_meta" && key !== "data") helpers$1._merger(key, target, source);
                }
            });
        },
        _update: function(reset) {
            var me = this;
            me._configure();
            me._cachedDataOpts = null;
            me.update(reset);
        },
        update: helpers$1.noop,
        transition: function(easingValue) {
            var meta = this.getMeta();
            var elements = meta.data || [];
            var ilen = elements.length;
            var i = 0;
            for(; i < ilen; ++i)elements[i].transition(easingValue);
            if (meta.dataset) meta.dataset.transition(easingValue);
        },
        draw: function() {
            var meta = this.getMeta();
            var elements = meta.data || [];
            var ilen = elements.length;
            var i = 0;
            if (meta.dataset) meta.dataset.draw();
            for(; i < ilen; ++i)elements[i].draw();
        },
        /**
	 * Returns a set of predefined style properties that should be used to represent the dataset
	 * or the data if the index is specified
	 * @param {number} index - data index
	 * @return {IStyleInterface} style object
	 */ getStyle: function(index) {
            var me = this;
            var meta = me.getMeta();
            var dataset = meta.dataset;
            var style;
            me._configure();
            if (dataset && index === undefined) style = me._resolveDatasetElementOptions(dataset || {});
            else {
                index = index || 0;
                style = me._resolveDataElementOptions(meta.data[index] || {}, index);
            }
            if (style.fill === false || style.fill === null) style.backgroundColor = style.borderColor;
            return style;
        },
        /**
	 * @private
	 */ _resolveDatasetElementOptions: function(element, hover) {
            var me = this;
            var chart = me.chart;
            var datasetOpts = me._config;
            var custom = element.custom || {};
            var options = chart.options.elements[me.datasetElementType.prototype._type] || {};
            var elementOptions = me._datasetElementOptions;
            var values = {};
            var i, ilen, key, readKey;
            // Scriptable options
            var context = {
                chart: chart,
                dataset: me.getDataset(),
                datasetIndex: me.index,
                hover: hover
            };
            for(i = 0, ilen = elementOptions.length; i < ilen; ++i){
                key = elementOptions[i];
                readKey = hover ? "hover" + key.charAt(0).toUpperCase() + key.slice(1) : key;
                values[key] = resolve([
                    custom[readKey],
                    datasetOpts[readKey],
                    options[readKey]
                ], context);
            }
            return values;
        },
        /**
	 * @private
	 */ _resolveDataElementOptions: function(element, index) {
            var me = this;
            var custom = element && element.custom;
            var cached = me._cachedDataOpts;
            if (cached && !custom) return cached;
            var chart = me.chart;
            var datasetOpts = me._config;
            var options = chart.options.elements[me.dataElementType.prototype._type] || {};
            var elementOptions = me._dataElementOptions;
            var values = {};
            // Scriptable options
            var context = {
                chart: chart,
                dataIndex: index,
                dataset: me.getDataset(),
                datasetIndex: me.index
            };
            // `resolve` sets cacheable to `false` if any option is indexed or scripted
            var info = {
                cacheable: !custom
            };
            var keys, i, ilen, key;
            custom = custom || {};
            if (helpers$1.isArray(elementOptions)) for(i = 0, ilen = elementOptions.length; i < ilen; ++i){
                key = elementOptions[i];
                values[key] = resolve([
                    custom[key],
                    datasetOpts[key],
                    options[key]
                ], context, index, info);
            }
            else {
                keys = Object.keys(elementOptions);
                for(i = 0, ilen = keys.length; i < ilen; ++i){
                    key = keys[i];
                    values[key] = resolve([
                        custom[key],
                        datasetOpts[elementOptions[key]],
                        datasetOpts[key],
                        options[key]
                    ], context, index, info);
                }
            }
            if (info.cacheable) me._cachedDataOpts = Object.freeze(values);
            return values;
        },
        removeHoverStyle: function(element) {
            helpers$1.merge(element._model, element.$previousStyle || {});
            delete element.$previousStyle;
        },
        setHoverStyle: function(element) {
            var dataset = this.chart.data.datasets[element._datasetIndex];
            var index = element._index;
            var custom = element.custom || {};
            var model = element._model;
            var getHoverColor = helpers$1.getHoverColor;
            element.$previousStyle = {
                backgroundColor: model.backgroundColor,
                borderColor: model.borderColor,
                borderWidth: model.borderWidth
            };
            model.backgroundColor = resolve([
                custom.hoverBackgroundColor,
                dataset.hoverBackgroundColor,
                getHoverColor(model.backgroundColor)
            ], undefined, index);
            model.borderColor = resolve([
                custom.hoverBorderColor,
                dataset.hoverBorderColor,
                getHoverColor(model.borderColor)
            ], undefined, index);
            model.borderWidth = resolve([
                custom.hoverBorderWidth,
                dataset.hoverBorderWidth,
                model.borderWidth
            ], undefined, index);
        },
        /**
	 * @private
	 */ _removeDatasetHoverStyle: function() {
            var element = this.getMeta().dataset;
            if (element) this.removeHoverStyle(element);
        },
        /**
	 * @private
	 */ _setDatasetHoverStyle: function() {
            var element = this.getMeta().dataset;
            var prev = {};
            var i, ilen, key, keys, hoverOptions, model;
            if (!element) return;
            model = element._model;
            hoverOptions = this._resolveDatasetElementOptions(element, true);
            keys = Object.keys(hoverOptions);
            for(i = 0, ilen = keys.length; i < ilen; ++i){
                key = keys[i];
                prev[key] = model[key];
                model[key] = hoverOptions[key];
            }
            element.$previousStyle = prev;
        },
        /**
	 * @private
	 */ resyncElements: function() {
            var me = this;
            var meta = me.getMeta();
            var data = me.getDataset().data;
            var numMeta = meta.data.length;
            var numData = data.length;
            if (numData < numMeta) meta.data.splice(numData, numMeta - numData);
            else if (numData > numMeta) me.insertElements(numMeta, numData - numMeta);
        },
        /**
	 * @private
	 */ insertElements: function(start, count) {
            for(var i = 0; i < count; ++i)this.addElementAndReset(start + i);
        },
        /**
	 * @private
	 */ onDataPush: function() {
            var count = arguments.length;
            this.insertElements(this.getDataset().data.length - count, count);
        },
        /**
	 * @private
	 */ onDataPop: function() {
            this.getMeta().data.pop();
        },
        /**
	 * @private
	 */ onDataShift: function() {
            this.getMeta().data.shift();
        },
        /**
	 * @private
	 */ onDataSplice: function(start, count) {
            this.getMeta().data.splice(start, count);
            this.insertElements(start, arguments.length - 2);
        },
        /**
	 * @private
	 */ onDataUnshift: function() {
            this.insertElements(0, arguments.length);
        }
    });
    DatasetController.extend = helpers$1.inherits;
    var core_datasetController = DatasetController;
    var TAU = Math.PI * 2;
    core_defaults._set("global", {
        elements: {
            arc: {
                backgroundColor: core_defaults.global.defaultColor,
                borderColor: "#fff",
                borderWidth: 2,
                borderAlign: "center"
            }
        }
    });
    function clipArc(ctx, arc) {
        var startAngle = arc.startAngle;
        var endAngle = arc.endAngle;
        var pixelMargin = arc.pixelMargin;
        var angleMargin = pixelMargin / arc.outerRadius;
        var x = arc.x;
        var y = arc.y;
        // Draw an inner border by cliping the arc and drawing a double-width border
        // Enlarge the clipping arc by 0.33 pixels to eliminate glitches between borders
        ctx.beginPath();
        ctx.arc(x, y, arc.outerRadius, startAngle - angleMargin, endAngle + angleMargin);
        if (arc.innerRadius > pixelMargin) {
            angleMargin = pixelMargin / arc.innerRadius;
            ctx.arc(x, y, arc.innerRadius - pixelMargin, endAngle + angleMargin, startAngle - angleMargin, true);
        } else ctx.arc(x, y, pixelMargin, endAngle + Math.PI / 2, startAngle - Math.PI / 2);
        ctx.closePath();
        ctx.clip();
    }
    function drawFullCircleBorders(ctx, vm, arc, inner) {
        var endAngle = arc.endAngle;
        var i;
        if (inner) {
            arc.endAngle = arc.startAngle + TAU;
            clipArc(ctx, arc);
            arc.endAngle = endAngle;
            if (arc.endAngle === arc.startAngle && arc.fullCircles) {
                arc.endAngle += TAU;
                arc.fullCircles--;
            }
        }
        ctx.beginPath();
        ctx.arc(arc.x, arc.y, arc.innerRadius, arc.startAngle + TAU, arc.startAngle, true);
        for(i = 0; i < arc.fullCircles; ++i)ctx.stroke();
        ctx.beginPath();
        ctx.arc(arc.x, arc.y, vm.outerRadius, arc.startAngle, arc.startAngle + TAU);
        for(i = 0; i < arc.fullCircles; ++i)ctx.stroke();
    }
    function drawBorder(ctx, vm, arc) {
        var inner = vm.borderAlign === "inner";
        if (inner) {
            ctx.lineWidth = vm.borderWidth * 2;
            ctx.lineJoin = "round";
        } else {
            ctx.lineWidth = vm.borderWidth;
            ctx.lineJoin = "bevel";
        }
        if (arc.fullCircles) drawFullCircleBorders(ctx, vm, arc, inner);
        if (inner) clipArc(ctx, arc);
        ctx.beginPath();
        ctx.arc(arc.x, arc.y, vm.outerRadius, arc.startAngle, arc.endAngle);
        ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
        ctx.closePath();
        ctx.stroke();
    }
    var element_arc = core_element.extend({
        _type: "arc",
        inLabelRange: function(mouseX) {
            var vm = this._view;
            if (vm) return Math.pow(mouseX - vm.x, 2) < Math.pow(vm.radius + vm.hoverRadius, 2);
            return false;
        },
        inRange: function(chartX, chartY) {
            var vm = this._view;
            if (vm) {
                var pointRelativePosition = helpers$1.getAngleFromPoint(vm, {
                    x: chartX,
                    y: chartY
                });
                var angle = pointRelativePosition.angle;
                var distance = pointRelativePosition.distance;
                // Sanitise angle range
                var startAngle = vm.startAngle;
                var endAngle = vm.endAngle;
                while(endAngle < startAngle)endAngle += TAU;
                while(angle > endAngle)angle -= TAU;
                while(angle < startAngle)angle += TAU;
                // Check if within the range of the open/close angle
                var betweenAngles = angle >= startAngle && angle <= endAngle;
                var withinRadius = distance >= vm.innerRadius && distance <= vm.outerRadius;
                return betweenAngles && withinRadius;
            }
            return false;
        },
        getCenterPoint: function() {
            var vm = this._view;
            var halfAngle = (vm.startAngle + vm.endAngle) / 2;
            var halfRadius = (vm.innerRadius + vm.outerRadius) / 2;
            return {
                x: vm.x + Math.cos(halfAngle) * halfRadius,
                y: vm.y + Math.sin(halfAngle) * halfRadius
            };
        },
        getArea: function() {
            var vm = this._view;
            return Math.PI * ((vm.endAngle - vm.startAngle) / (2 * Math.PI)) * (Math.pow(vm.outerRadius, 2) - Math.pow(vm.innerRadius, 2));
        },
        tooltipPosition: function() {
            var vm = this._view;
            var centreAngle = vm.startAngle + (vm.endAngle - vm.startAngle) / 2;
            var rangeFromCentre = (vm.outerRadius - vm.innerRadius) / 2 + vm.innerRadius;
            return {
                x: vm.x + Math.cos(centreAngle) * rangeFromCentre,
                y: vm.y + Math.sin(centreAngle) * rangeFromCentre
            };
        },
        draw: function() {
            var ctx = this._chart.ctx;
            var vm = this._view;
            var pixelMargin = vm.borderAlign === "inner" ? 0.33 : 0;
            var arc = {
                x: vm.x,
                y: vm.y,
                innerRadius: vm.innerRadius,
                outerRadius: Math.max(vm.outerRadius - pixelMargin, 0),
                pixelMargin: pixelMargin,
                startAngle: vm.startAngle,
                endAngle: vm.endAngle,
                fullCircles: Math.floor(vm.circumference / TAU)
            };
            var i;
            ctx.save();
            ctx.fillStyle = vm.backgroundColor;
            ctx.strokeStyle = vm.borderColor;
            if (arc.fullCircles) {
                arc.endAngle = arc.startAngle + TAU;
                ctx.beginPath();
                ctx.arc(arc.x, arc.y, arc.outerRadius, arc.startAngle, arc.endAngle);
                ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
                ctx.closePath();
                for(i = 0; i < arc.fullCircles; ++i)ctx.fill();
                arc.endAngle = arc.startAngle + vm.circumference % TAU;
            }
            ctx.beginPath();
            ctx.arc(arc.x, arc.y, arc.outerRadius, arc.startAngle, arc.endAngle);
            ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
            ctx.closePath();
            ctx.fill();
            if (vm.borderWidth) drawBorder(ctx, vm, arc);
            ctx.restore();
        }
    });
    var valueOrDefault$1 = helpers$1.valueOrDefault;
    var defaultColor = core_defaults.global.defaultColor;
    core_defaults._set("global", {
        elements: {
            line: {
                tension: 0.4,
                backgroundColor: defaultColor,
                borderWidth: 3,
                borderColor: defaultColor,
                borderCapStyle: "butt",
                borderDash: [],
                borderDashOffset: 0.0,
                borderJoinStyle: "miter",
                capBezierPoints: true,
                fill: true
            }
        }
    });
    var element_line = core_element.extend({
        _type: "line",
        draw: function() {
            var me = this;
            var vm = me._view;
            var ctx = me._chart.ctx;
            var spanGaps = vm.spanGaps;
            var points = me._children.slice(); // clone array
            var globalDefaults = core_defaults.global;
            var globalOptionLineElements = globalDefaults.elements.line;
            var lastDrawnIndex = -1;
            var closePath = me._loop;
            var index, previous, currentVM;
            if (!points.length) return;
            if (me._loop) {
                for(index = 0; index < points.length; ++index){
                    previous = helpers$1.previousItem(points, index);
                    // If the line has an open path, shift the point array
                    if (!points[index]._view.skip && previous._view.skip) {
                        points = points.slice(index).concat(points.slice(0, index));
                        closePath = spanGaps;
                        break;
                    }
                }
                // If the line has a close path, add the first point again
                if (closePath) points.push(points[0]);
            }
            ctx.save();
            // Stroke Line Options
            ctx.lineCap = vm.borderCapStyle || globalOptionLineElements.borderCapStyle;
            // IE 9 and 10 do not support line dash
            if (ctx.setLineDash) ctx.setLineDash(vm.borderDash || globalOptionLineElements.borderDash);
            ctx.lineDashOffset = valueOrDefault$1(vm.borderDashOffset, globalOptionLineElements.borderDashOffset);
            ctx.lineJoin = vm.borderJoinStyle || globalOptionLineElements.borderJoinStyle;
            ctx.lineWidth = valueOrDefault$1(vm.borderWidth, globalOptionLineElements.borderWidth);
            ctx.strokeStyle = vm.borderColor || globalDefaults.defaultColor;
            // Stroke Line
            ctx.beginPath();
            // First point moves to it's starting position no matter what
            currentVM = points[0]._view;
            if (!currentVM.skip) {
                ctx.moveTo(currentVM.x, currentVM.y);
                lastDrawnIndex = 0;
            }
            for(index = 1; index < points.length; ++index){
                currentVM = points[index]._view;
                previous = lastDrawnIndex === -1 ? helpers$1.previousItem(points, index) : points[lastDrawnIndex];
                if (!currentVM.skip) {
                    if (lastDrawnIndex !== index - 1 && !spanGaps || lastDrawnIndex === -1) // There was a gap and this is the first point after the gap
                    ctx.moveTo(currentVM.x, currentVM.y);
                    else // Line to next point
                    helpers$1.canvas.lineTo(ctx, previous._view, currentVM);
                    lastDrawnIndex = index;
                }
            }
            if (closePath) ctx.closePath();
            ctx.stroke();
            ctx.restore();
        }
    });
    var valueOrDefault$2 = helpers$1.valueOrDefault;
    var defaultColor$1 = core_defaults.global.defaultColor;
    core_defaults._set("global", {
        elements: {
            point: {
                radius: 3,
                pointStyle: "circle",
                backgroundColor: defaultColor$1,
                borderColor: defaultColor$1,
                borderWidth: 1,
                // Hover
                hitRadius: 1,
                hoverRadius: 4,
                hoverBorderWidth: 1
            }
        }
    });
    function xRange(mouseX) {
        var vm = this._view;
        return vm ? Math.abs(mouseX - vm.x) < vm.radius + vm.hitRadius : false;
    }
    function yRange(mouseY) {
        var vm = this._view;
        return vm ? Math.abs(mouseY - vm.y) < vm.radius + vm.hitRadius : false;
    }
    var element_point = core_element.extend({
        _type: "point",
        inRange: function(mouseX, mouseY) {
            var vm = this._view;
            return vm ? Math.pow(mouseX - vm.x, 2) + Math.pow(mouseY - vm.y, 2) < Math.pow(vm.hitRadius + vm.radius, 2) : false;
        },
        inLabelRange: xRange,
        inXRange: xRange,
        inYRange: yRange,
        getCenterPoint: function() {
            var vm = this._view;
            return {
                x: vm.x,
                y: vm.y
            };
        },
        getArea: function() {
            return Math.PI * Math.pow(this._view.radius, 2);
        },
        tooltipPosition: function() {
            var vm = this._view;
            return {
                x: vm.x,
                y: vm.y,
                padding: vm.radius + vm.borderWidth
            };
        },
        draw: function(chartArea) {
            var vm = this._view;
            var ctx = this._chart.ctx;
            var pointStyle = vm.pointStyle;
            var rotation = vm.rotation;
            var radius = vm.radius;
            var x = vm.x;
            var y = vm.y;
            var globalDefaults = core_defaults.global;
            var defaultColor = globalDefaults.defaultColor; // eslint-disable-line no-shadow
            if (vm.skip) return;
            // Clipping for Points.
            if (chartArea === undefined || helpers$1.canvas._isPointInArea(vm, chartArea)) {
                ctx.strokeStyle = vm.borderColor || defaultColor;
                ctx.lineWidth = valueOrDefault$2(vm.borderWidth, globalDefaults.elements.point.borderWidth);
                ctx.fillStyle = vm.backgroundColor || defaultColor;
                helpers$1.canvas.drawPoint(ctx, pointStyle, radius, x, y, rotation);
            }
        }
    });
    var defaultColor$2 = core_defaults.global.defaultColor;
    core_defaults._set("global", {
        elements: {
            rectangle: {
                backgroundColor: defaultColor$2,
                borderColor: defaultColor$2,
                borderSkipped: "bottom",
                borderWidth: 0
            }
        }
    });
    function isVertical(vm) {
        return vm && vm.width !== undefined;
    }
    /**
 * Helper function to get the bounds of the bar regardless of the orientation
 * @param bar {Chart.Element.Rectangle} the bar
 * @return {Bounds} bounds of the bar
 * @private
 */ function getBarBounds(vm) {
        var x1, x2, y1, y2, half;
        if (isVertical(vm)) {
            half = vm.width / 2;
            x1 = vm.x - half;
            x2 = vm.x + half;
            y1 = Math.min(vm.y, vm.base);
            y2 = Math.max(vm.y, vm.base);
        } else {
            half = vm.height / 2;
            x1 = Math.min(vm.x, vm.base);
            x2 = Math.max(vm.x, vm.base);
            y1 = vm.y - half;
            y2 = vm.y + half;
        }
        return {
            left: x1,
            top: y1,
            right: x2,
            bottom: y2
        };
    }
    function swap(orig, v1, v2) {
        return orig === v1 ? v2 : orig === v2 ? v1 : orig;
    }
    function parseBorderSkipped(vm) {
        var edge = vm.borderSkipped;
        var res = {};
        if (!edge) return res;
        if (vm.horizontal) {
            if (vm.base > vm.x) edge = swap(edge, "left", "right");
        } else if (vm.base < vm.y) edge = swap(edge, "bottom", "top");
        res[edge] = true;
        return res;
    }
    function parseBorderWidth(vm, maxW, maxH) {
        var value = vm.borderWidth;
        var skip = parseBorderSkipped(vm);
        var t, r, b, l;
        if (helpers$1.isObject(value)) {
            t = +value.top || 0;
            r = +value.right || 0;
            b = +value.bottom || 0;
            l = +value.left || 0;
        } else t = r = b = l = +value || 0;
        return {
            t: skip.top || t < 0 ? 0 : t > maxH ? maxH : t,
            r: skip.right || r < 0 ? 0 : r > maxW ? maxW : r,
            b: skip.bottom || b < 0 ? 0 : b > maxH ? maxH : b,
            l: skip.left || l < 0 ? 0 : l > maxW ? maxW : l
        };
    }
    function boundingRects(vm) {
        var bounds = getBarBounds(vm);
        var width = bounds.right - bounds.left;
        var height = bounds.bottom - bounds.top;
        var border = parseBorderWidth(vm, width / 2, height / 2);
        return {
            outer: {
                x: bounds.left,
                y: bounds.top,
                w: width,
                h: height
            },
            inner: {
                x: bounds.left + border.l,
                y: bounds.top + border.t,
                w: width - border.l - border.r,
                h: height - border.t - border.b
            }
        };
    }
    function inRange(vm, x, y) {
        var skipX = x === null;
        var skipY = y === null;
        var bounds = !vm || skipX && skipY ? false : getBarBounds(vm);
        return bounds && (skipX || x >= bounds.left && x <= bounds.right) && (skipY || y >= bounds.top && y <= bounds.bottom);
    }
    var element_rectangle = core_element.extend({
        _type: "rectangle",
        draw: function() {
            var ctx = this._chart.ctx;
            var vm = this._view;
            var rects = boundingRects(vm);
            var outer = rects.outer;
            var inner = rects.inner;
            ctx.fillStyle = vm.backgroundColor;
            ctx.fillRect(outer.x, outer.y, outer.w, outer.h);
            if (outer.w === inner.w && outer.h === inner.h) return;
            ctx.save();
            ctx.beginPath();
            ctx.rect(outer.x, outer.y, outer.w, outer.h);
            ctx.clip();
            ctx.fillStyle = vm.borderColor;
            ctx.rect(inner.x, inner.y, inner.w, inner.h);
            ctx.fill("evenodd");
            ctx.restore();
        },
        height: function() {
            var vm = this._view;
            return vm.base - vm.y;
        },
        inRange: function(mouseX, mouseY) {
            return inRange(this._view, mouseX, mouseY);
        },
        inLabelRange: function(mouseX, mouseY) {
            var vm = this._view;
            return isVertical(vm) ? inRange(vm, mouseX, null) : inRange(vm, null, mouseY);
        },
        inXRange: function(mouseX) {
            return inRange(this._view, mouseX, null);
        },
        inYRange: function(mouseY) {
            return inRange(this._view, null, mouseY);
        },
        getCenterPoint: function() {
            var vm = this._view;
            var x, y;
            if (isVertical(vm)) {
                x = vm.x;
                y = (vm.y + vm.base) / 2;
            } else {
                x = (vm.x + vm.base) / 2;
                y = vm.y;
            }
            return {
                x: x,
                y: y
            };
        },
        getArea: function() {
            var vm = this._view;
            return isVertical(vm) ? vm.width * Math.abs(vm.y - vm.base) : vm.height * Math.abs(vm.x - vm.base);
        },
        tooltipPosition: function() {
            var vm = this._view;
            return {
                x: vm.x,
                y: vm.y
            };
        }
    });
    var elements = {};
    var Arc = element_arc;
    var Line = element_line;
    var Point = element_point;
    var Rectangle = element_rectangle;
    elements.Arc = Arc;
    elements.Line = Line;
    elements.Point = Point;
    elements.Rectangle = Rectangle;
    var deprecated = helpers$1._deprecated;
    var valueOrDefault$3 = helpers$1.valueOrDefault;
    core_defaults._set("bar", {
        hover: {
            mode: "label"
        },
        scales: {
            xAxes: [
                {
                    type: "category",
                    offset: true,
                    gridLines: {
                        offsetGridLines: true
                    }
                }
            ],
            yAxes: [
                {
                    type: "linear"
                }
            ]
        }
    });
    core_defaults._set("global", {
        datasets: {
            bar: {
                categoryPercentage: 0.8,
                barPercentage: 0.9
            }
        }
    });
    /**
 * Computes the "optimal" sample size to maintain bars equally sized while preventing overlap.
 * @private
 */ function computeMinSampleSize(scale, pixels) {
        var min = scale._length;
        var prev, curr, i, ilen;
        for(i = 1, ilen = pixels.length; i < ilen; ++i)min = Math.min(min, Math.abs(pixels[i] - pixels[i - 1]));
        for(i = 0, ilen = scale.getTicks().length; i < ilen; ++i){
            curr = scale.getPixelForTick(i);
            min = i > 0 ? Math.min(min, Math.abs(curr - prev)) : min;
            prev = curr;
        }
        return min;
    }
    /**
 * Computes an "ideal" category based on the absolute bar thickness or, if undefined or null,
 * uses the smallest interval (see computeMinSampleSize) that prevents bar overlapping. This
 * mode currently always generates bars equally sized (until we introduce scriptable options?).
 * @private
 */ function computeFitCategoryTraits(index, ruler, options) {
        var thickness = options.barThickness;
        var count = ruler.stackCount;
        var curr = ruler.pixels[index];
        var min = helpers$1.isNullOrUndef(thickness) ? computeMinSampleSize(ruler.scale, ruler.pixels) : -1;
        var size, ratio;
        if (helpers$1.isNullOrUndef(thickness)) {
            size = min * options.categoryPercentage;
            ratio = options.barPercentage;
        } else {
            // When bar thickness is enforced, category and bar percentages are ignored.
            // Note(SB): we could add support for relative bar thickness (e.g. barThickness: '50%')
            // and deprecate barPercentage since this value is ignored when thickness is absolute.
            size = thickness * count;
            ratio = 1;
        }
        return {
            chunk: size / count,
            ratio: ratio,
            start: curr - size / 2
        };
    }
    /**
 * Computes an "optimal" category that globally arranges bars side by side (no gap when
 * percentage options are 1), based on the previous and following categories. This mode
 * generates bars with different widths when data are not evenly spaced.
 * @private
 */ function computeFlexCategoryTraits(index, ruler, options) {
        var pixels = ruler.pixels;
        var curr = pixels[index];
        var prev = index > 0 ? pixels[index - 1] : null;
        var next = index < pixels.length - 1 ? pixels[index + 1] : null;
        var percent = options.categoryPercentage;
        var start, size;
        if (prev === null) // first data: its size is double based on the next point or,
        // if it's also the last data, we use the scale size.
        prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
        if (next === null) // last data: its size is also double based on the previous point.
        next = curr + curr - prev;
        start = curr - (curr - Math.min(prev, next)) / 2 * percent;
        size = Math.abs(next - prev) / 2 * percent;
        return {
            chunk: size / ruler.stackCount,
            ratio: options.barPercentage,
            start: start
        };
    }
    var controller_bar = core_datasetController.extend({
        dataElementType: elements.Rectangle,
        /**
	 * @private
	 */ _dataElementOptions: [
            "backgroundColor",
            "borderColor",
            "borderSkipped",
            "borderWidth",
            "barPercentage",
            "barThickness",
            "categoryPercentage",
            "maxBarThickness",
            "minBarLength"
        ],
        initialize: function() {
            var me = this;
            var meta, scaleOpts;
            core_datasetController.prototype.initialize.apply(me, arguments);
            meta = me.getMeta();
            meta.stack = me.getDataset().stack;
            meta.bar = true;
            scaleOpts = me._getIndexScale().options;
            deprecated("bar chart", scaleOpts.barPercentage, "scales.[x/y]Axes.barPercentage", "dataset.barPercentage");
            deprecated("bar chart", scaleOpts.barThickness, "scales.[x/y]Axes.barThickness", "dataset.barThickness");
            deprecated("bar chart", scaleOpts.categoryPercentage, "scales.[x/y]Axes.categoryPercentage", "dataset.categoryPercentage");
            deprecated("bar chart", me._getValueScale().options.minBarLength, "scales.[x/y]Axes.minBarLength", "dataset.minBarLength");
            deprecated("bar chart", scaleOpts.maxBarThickness, "scales.[x/y]Axes.maxBarThickness", "dataset.maxBarThickness");
        },
        update: function(reset) {
            var me = this;
            var rects = me.getMeta().data;
            var i, ilen;
            me._ruler = me.getRuler();
            for(i = 0, ilen = rects.length; i < ilen; ++i)me.updateElement(rects[i], i, reset);
        },
        updateElement: function(rectangle, index, reset) {
            var me = this;
            var meta = me.getMeta();
            var dataset = me.getDataset();
            var options = me._resolveDataElementOptions(rectangle, index);
            rectangle._xScale = me.getScaleForId(meta.xAxisID);
            rectangle._yScale = me.getScaleForId(meta.yAxisID);
            rectangle._datasetIndex = me.index;
            rectangle._index = index;
            rectangle._model = {
                backgroundColor: options.backgroundColor,
                borderColor: options.borderColor,
                borderSkipped: options.borderSkipped,
                borderWidth: options.borderWidth,
                datasetLabel: dataset.label,
                label: me.chart.data.labels[index]
            };
            if (helpers$1.isArray(dataset.data[index])) rectangle._model.borderSkipped = null;
            me._updateElementGeometry(rectangle, index, reset, options);
            rectangle.pivot();
        },
        /**
	 * @private
	 */ _updateElementGeometry: function(rectangle, index, reset, options) {
            var me = this;
            var model = rectangle._model;
            var vscale = me._getValueScale();
            var base = vscale.getBasePixel();
            var horizontal = vscale.isHorizontal();
            var ruler = me._ruler || me.getRuler();
            var vpixels = me.calculateBarValuePixels(me.index, index, options);
            var ipixels = me.calculateBarIndexPixels(me.index, index, ruler, options);
            model.horizontal = horizontal;
            model.base = reset ? base : vpixels.base;
            model.x = horizontal ? reset ? base : vpixels.head : ipixels.center;
            model.y = horizontal ? ipixels.center : reset ? base : vpixels.head;
            model.height = horizontal ? ipixels.size : undefined;
            model.width = horizontal ? undefined : ipixels.size;
        },
        /**
	 * Returns the stacks based on groups and bar visibility.
	 * @param {number} [last] - The dataset index
	 * @returns {string[]} The list of stack IDs
	 * @private
	 */ _getStacks: function(last) {
            var me = this;
            var scale = me._getIndexScale();
            var metasets = scale._getMatchingVisibleMetas(me._type);
            var stacked = scale.options.stacked;
            var ilen = metasets.length;
            var stacks = [];
            var i, meta;
            for(i = 0; i < ilen; ++i){
                meta = metasets[i];
                // stacked   | meta.stack
                //           | found | not found | undefined
                // false     |   x   |     x     |     x
                // true      |       |     x     |
                // undefined |       |     x     |     x
                if (stacked === false || stacks.indexOf(meta.stack) === -1 || stacked === undefined && meta.stack === undefined) stacks.push(meta.stack);
                if (meta.index === last) break;
            }
            return stacks;
        },
        /**
	 * Returns the effective number of stacks based on groups and bar visibility.
	 * @private
	 */ getStackCount: function() {
            return this._getStacks().length;
        },
        /**
	 * Returns the stack index for the given dataset based on groups and bar visibility.
	 * @param {number} [datasetIndex] - The dataset index
	 * @param {string} [name] - The stack name to find
	 * @returns {number} The stack index
	 * @private
	 */ getStackIndex: function(datasetIndex, name) {
            var stacks = this._getStacks(datasetIndex);
            var index = name !== undefined ? stacks.indexOf(name) : -1; // indexOf returns -1 if element is not present
            return index === -1 ? stacks.length - 1 : index;
        },
        /**
	 * @private
	 */ getRuler: function() {
            var me = this;
            var scale = me._getIndexScale();
            var pixels = [];
            var i, ilen;
            for(i = 0, ilen = me.getMeta().data.length; i < ilen; ++i)pixels.push(scale.getPixelForValue(null, i, me.index));
            return {
                pixels: pixels,
                start: scale._startPixel,
                end: scale._endPixel,
                stackCount: me.getStackCount(),
                scale: scale
            };
        },
        /**
	 * Note: pixel values are not clamped to the scale area.
	 * @private
	 */ calculateBarValuePixels: function(datasetIndex, index, options) {
            var me = this;
            var chart = me.chart;
            var scale = me._getValueScale();
            var isHorizontal = scale.isHorizontal();
            var datasets = chart.data.datasets;
            var metasets = scale._getMatchingVisibleMetas(me._type);
            var value = scale._parseValue(datasets[datasetIndex].data[index]);
            var minBarLength = options.minBarLength;
            var stacked = scale.options.stacked;
            var stack = me.getMeta().stack;
            var start = value.start === undefined ? 0 : value.max >= 0 && value.min >= 0 ? value.min : value.max;
            var length = value.start === undefined ? value.end : value.max >= 0 && value.min >= 0 ? value.max - value.min : value.min - value.max;
            var ilen = metasets.length;
            var i, imeta, ivalue, base, head, size, stackLength;
            if (stacked || stacked === undefined && stack !== undefined) for(i = 0; i < ilen; ++i){
                imeta = metasets[i];
                if (imeta.index === datasetIndex) break;
                if (imeta.stack === stack) {
                    stackLength = scale._parseValue(datasets[imeta.index].data[index]);
                    ivalue = stackLength.start === undefined ? stackLength.end : stackLength.min >= 0 && stackLength.max >= 0 ? stackLength.max : stackLength.min;
                    if (value.min < 0 && ivalue < 0 || value.max >= 0 && ivalue > 0) start += ivalue;
                }
            }
            base = scale.getPixelForValue(start);
            head = scale.getPixelForValue(start + length);
            size = head - base;
            if (minBarLength !== undefined && Math.abs(size) < minBarLength) {
                size = minBarLength;
                if (length >= 0 && !isHorizontal || length < 0 && isHorizontal) head = base - minBarLength;
                else head = base + minBarLength;
            }
            return {
                size: size,
                base: base,
                head: head,
                center: head + size / 2
            };
        },
        /**
	 * @private
	 */ calculateBarIndexPixels: function(datasetIndex, index, ruler, options) {
            var me = this;
            var range = options.barThickness === "flex" ? computeFlexCategoryTraits(index, ruler, options) : computeFitCategoryTraits(index, ruler, options);
            var stackIndex = me.getStackIndex(datasetIndex, me.getMeta().stack);
            var center = range.start + range.chunk * stackIndex + range.chunk / 2;
            var size = Math.min(valueOrDefault$3(options.maxBarThickness, Infinity), range.chunk * range.ratio);
            return {
                base: center - size / 2,
                head: center + size / 2,
                center: center,
                size: size
            };
        },
        draw: function() {
            var me = this;
            var chart = me.chart;
            var scale = me._getValueScale();
            var rects = me.getMeta().data;
            var dataset = me.getDataset();
            var ilen = rects.length;
            var i = 0;
            helpers$1.canvas.clipArea(chart.ctx, chart.chartArea);
            for(; i < ilen; ++i){
                var val = scale._parseValue(dataset.data[i]);
                if (!isNaN(val.min) && !isNaN(val.max)) rects[i].draw();
            }
            helpers$1.canvas.unclipArea(chart.ctx);
        },
        /**
	 * @private
	 */ _resolveDataElementOptions: function() {
            var me = this;
            var values = helpers$1.extend({}, core_datasetController.prototype._resolveDataElementOptions.apply(me, arguments));
            var indexOpts = me._getIndexScale().options;
            var valueOpts = me._getValueScale().options;
            values.barPercentage = valueOrDefault$3(indexOpts.barPercentage, values.barPercentage);
            values.barThickness = valueOrDefault$3(indexOpts.barThickness, values.barThickness);
            values.categoryPercentage = valueOrDefault$3(indexOpts.categoryPercentage, values.categoryPercentage);
            values.maxBarThickness = valueOrDefault$3(indexOpts.maxBarThickness, values.maxBarThickness);
            values.minBarLength = valueOrDefault$3(valueOpts.minBarLength, values.minBarLength);
            return values;
        }
    });
    var valueOrDefault$4 = helpers$1.valueOrDefault;
    var resolve$1 = helpers$1.options.resolve;
    core_defaults._set("bubble", {
        hover: {
            mode: "single"
        },
        scales: {
            xAxes: [
                {
                    type: "linear",
                    position: "bottom",
                    id: "x-axis-0" // need an ID so datasets can reference the scale
                }
            ],
            yAxes: [
                {
                    type: "linear",
                    position: "left",
                    id: "y-axis-0"
                }
            ]
        },
        tooltips: {
            callbacks: {
                title: function() {
                    // Title doesn't make sense for scatter since we format the data as a point
                    return "";
                },
                label: function(item, data) {
                    var datasetLabel = data.datasets[item.datasetIndex].label || "";
                    var dataPoint = data.datasets[item.datasetIndex].data[item.index];
                    return datasetLabel + ": (" + item.xLabel + ", " + item.yLabel + ", " + dataPoint.r + ")";
                }
            }
        }
    });
    var controller_bubble = core_datasetController.extend({
        /**
	 * @protected
	 */ dataElementType: elements.Point,
        /**
	 * @private
	 */ _dataElementOptions: [
            "backgroundColor",
            "borderColor",
            "borderWidth",
            "hoverBackgroundColor",
            "hoverBorderColor",
            "hoverBorderWidth",
            "hoverRadius",
            "hitRadius",
            "pointStyle",
            "rotation"
        ],
        /**
	 * @protected
	 */ update: function(reset) {
            var me = this;
            var meta = me.getMeta();
            var points = meta.data;
            // Update Points
            helpers$1.each(points, function(point, index) {
                me.updateElement(point, index, reset);
            });
        },
        /**
	 * @protected
	 */ updateElement: function(point, index, reset) {
            var me = this;
            var meta = me.getMeta();
            var custom = point.custom || {};
            var xScale = me.getScaleForId(meta.xAxisID);
            var yScale = me.getScaleForId(meta.yAxisID);
            var options = me._resolveDataElementOptions(point, index);
            var data = me.getDataset().data[index];
            var dsIndex = me.index;
            var x = reset ? xScale.getPixelForDecimal(0.5) : xScale.getPixelForValue(typeof data === "object" ? data : NaN, index, dsIndex);
            var y = reset ? yScale.getBasePixel() : yScale.getPixelForValue(data, index, dsIndex);
            point._xScale = xScale;
            point._yScale = yScale;
            point._options = options;
            point._datasetIndex = dsIndex;
            point._index = index;
            point._model = {
                backgroundColor: options.backgroundColor,
                borderColor: options.borderColor,
                borderWidth: options.borderWidth,
                hitRadius: options.hitRadius,
                pointStyle: options.pointStyle,
                rotation: options.rotation,
                radius: reset ? 0 : options.radius,
                skip: custom.skip || isNaN(x) || isNaN(y),
                x: x,
                y: y
            };
            point.pivot();
        },
        /**
	 * @protected
	 */ setHoverStyle: function(point) {
            var model = point._model;
            var options = point._options;
            var getHoverColor = helpers$1.getHoverColor;
            point.$previousStyle = {
                backgroundColor: model.backgroundColor,
                borderColor: model.borderColor,
                borderWidth: model.borderWidth,
                radius: model.radius
            };
            model.backgroundColor = valueOrDefault$4(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
            model.borderColor = valueOrDefault$4(options.hoverBorderColor, getHoverColor(options.borderColor));
            model.borderWidth = valueOrDefault$4(options.hoverBorderWidth, options.borderWidth);
            model.radius = options.radius + options.hoverRadius;
        },
        /**
	 * @private
	 */ _resolveDataElementOptions: function(point, index) {
            var me = this;
            var chart = me.chart;
            var dataset = me.getDataset();
            var custom = point.custom || {};
            var data = dataset.data[index] || {};
            var values = core_datasetController.prototype._resolveDataElementOptions.apply(me, arguments);
            // Scriptable options
            var context = {
                chart: chart,
                dataIndex: index,
                dataset: dataset,
                datasetIndex: me.index
            };
            // In case values were cached (and thus frozen), we need to clone the values
            if (me._cachedDataOpts === values) values = helpers$1.extend({}, values);
            // Custom radius resolution
            values.radius = resolve$1([
                custom.radius,
                data.r,
                me._config.radius,
                chart.options.elements.point.radius
            ], context, index);
            return values;
        }
    });
    var valueOrDefault$5 = helpers$1.valueOrDefault;
    var PI$1 = Math.PI;
    var DOUBLE_PI$1 = PI$1 * 2;
    var HALF_PI$1 = PI$1 / 2;
    core_defaults._set("doughnut", {
        animation: {
            // Boolean - Whether we animate the rotation of the Doughnut
            animateRotate: true,
            // Boolean - Whether we animate scaling the Doughnut from the centre
            animateScale: false
        },
        hover: {
            mode: "single"
        },
        legendCallback: function(chart) {
            var list = document.createElement("ul");
            var data = chart.data;
            var datasets = data.datasets;
            var labels = data.labels;
            var i, ilen, listItem, listItemSpan;
            list.setAttribute("class", chart.id + "-legend");
            if (datasets.length) for(i = 0, ilen = datasets[0].data.length; i < ilen; ++i){
                listItem = list.appendChild(document.createElement("li"));
                listItemSpan = listItem.appendChild(document.createElement("span"));
                listItemSpan.style.backgroundColor = datasets[0].backgroundColor[i];
                if (labels[i]) listItem.appendChild(document.createTextNode(labels[i]));
            }
            return list.outerHTML;
        },
        legend: {
            labels: {
                generateLabels: function(chart) {
                    var data = chart.data;
                    if (data.labels.length && data.datasets.length) return data.labels.map(function(label, i) {
                        var meta = chart.getDatasetMeta(0);
                        var style = meta.controller.getStyle(i);
                        return {
                            text: label,
                            fillStyle: style.backgroundColor,
                            strokeStyle: style.borderColor,
                            lineWidth: style.borderWidth,
                            hidden: isNaN(data.datasets[0].data[i]) || meta.data[i].hidden,
                            // Extra data used for toggling the correct item
                            index: i
                        };
                    });
                    return [];
                }
            },
            onClick: function(e, legendItem) {
                var index = legendItem.index;
                var chart = this.chart;
                var i, ilen, meta;
                for(i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i){
                    meta = chart.getDatasetMeta(i);
                    // toggle visibility of index if exists
                    if (meta.data[index]) meta.data[index].hidden = !meta.data[index].hidden;
                }
                chart.update();
            }
        },
        // The percentage of the chart that we cut out of the middle.
        cutoutPercentage: 50,
        // The rotation of the chart, where the first data arc begins.
        rotation: -HALF_PI$1,
        // The total circumference of the chart.
        circumference: DOUBLE_PI$1,
        // Need to override these to give a nice default
        tooltips: {
            callbacks: {
                title: function() {
                    return "";
                },
                label: function(tooltipItem, data) {
                    var dataLabel = data.labels[tooltipItem.index];
                    var value = ": " + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                    if (helpers$1.isArray(dataLabel)) {
                        // show value on first line of multiline label
                        // need to clone because we are changing the value
                        dataLabel = dataLabel.slice();
                        dataLabel[0] += value;
                    } else dataLabel += value;
                    return dataLabel;
                }
            }
        }
    });
    var controller_doughnut = core_datasetController.extend({
        dataElementType: elements.Arc,
        linkScales: helpers$1.noop,
        /**
	 * @private
	 */ _dataElementOptions: [
            "backgroundColor",
            "borderColor",
            "borderWidth",
            "borderAlign",
            "hoverBackgroundColor",
            "hoverBorderColor",
            "hoverBorderWidth"
        ],
        // Get index of the dataset in relation to the visible datasets. This allows determining the inner and outer radius correctly
        getRingIndex: function(datasetIndex) {
            var ringIndex = 0;
            for(var j = 0; j < datasetIndex; ++j)if (this.chart.isDatasetVisible(j)) ++ringIndex;
            return ringIndex;
        },
        update: function(reset) {
            var me = this;
            var chart = me.chart;
            var chartArea = chart.chartArea;
            var opts = chart.options;
            var ratioX = 1;
            var ratioY = 1;
            var offsetX = 0;
            var offsetY = 0;
            var meta = me.getMeta();
            var arcs = meta.data;
            var cutout = opts.cutoutPercentage / 100 || 0;
            var circumference = opts.circumference;
            var chartWeight = me._getRingWeight(me.index);
            var maxWidth, maxHeight, i, ilen;
            // If the chart's circumference isn't a full circle, calculate size as a ratio of the width/height of the arc
            if (circumference < DOUBLE_PI$1) {
                var startAngle = opts.rotation % DOUBLE_PI$1;
                startAngle += startAngle >= PI$1 ? -DOUBLE_PI$1 : startAngle < -PI$1 ? DOUBLE_PI$1 : 0;
                var endAngle = startAngle + circumference;
                var startX = Math.cos(startAngle);
                var startY = Math.sin(startAngle);
                var endX = Math.cos(endAngle);
                var endY = Math.sin(endAngle);
                var contains0 = startAngle <= 0 && endAngle >= 0 || endAngle >= DOUBLE_PI$1;
                var contains90 = startAngle <= HALF_PI$1 && endAngle >= HALF_PI$1 || endAngle >= DOUBLE_PI$1 + HALF_PI$1;
                var contains180 = startAngle === -PI$1 || endAngle >= PI$1;
                var contains270 = startAngle <= -HALF_PI$1 && endAngle >= -HALF_PI$1 || endAngle >= PI$1 + HALF_PI$1;
                var minX = contains180 ? -1 : Math.min(startX, startX * cutout, endX, endX * cutout);
                var minY = contains270 ? -1 : Math.min(startY, startY * cutout, endY, endY * cutout);
                var maxX = contains0 ? 1 : Math.max(startX, startX * cutout, endX, endX * cutout);
                var maxY = contains90 ? 1 : Math.max(startY, startY * cutout, endY, endY * cutout);
                ratioX = (maxX - minX) / 2;
                ratioY = (maxY - minY) / 2;
                offsetX = -(maxX + minX) / 2;
                offsetY = -(maxY + minY) / 2;
            }
            for(i = 0, ilen = arcs.length; i < ilen; ++i)arcs[i]._options = me._resolveDataElementOptions(arcs[i], i);
            chart.borderWidth = me.getMaxBorderWidth();
            maxWidth = (chartArea.right - chartArea.left - chart.borderWidth) / ratioX;
            maxHeight = (chartArea.bottom - chartArea.top - chart.borderWidth) / ratioY;
            chart.outerRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
            chart.innerRadius = Math.max(chart.outerRadius * cutout, 0);
            chart.radiusLength = (chart.outerRadius - chart.innerRadius) / (me._getVisibleDatasetWeightTotal() || 1);
            chart.offsetX = offsetX * chart.outerRadius;
            chart.offsetY = offsetY * chart.outerRadius;
            meta.total = me.calculateTotal();
            me.outerRadius = chart.outerRadius - chart.radiusLength * me._getRingWeightOffset(me.index);
            me.innerRadius = Math.max(me.outerRadius - chart.radiusLength * chartWeight, 0);
            for(i = 0, ilen = arcs.length; i < ilen; ++i)me.updateElement(arcs[i], i, reset);
        },
        updateElement: function(arc, index, reset) {
            var me = this;
            var chart = me.chart;
            var chartArea = chart.chartArea;
            var opts = chart.options;
            var animationOpts = opts.animation;
            var centerX = (chartArea.left + chartArea.right) / 2;
            var centerY = (chartArea.top + chartArea.bottom) / 2;
            var startAngle = opts.rotation; // non reset case handled later
            var endAngle = opts.rotation; // non reset case handled later
            var dataset = me.getDataset();
            var circumference = reset && animationOpts.animateRotate ? 0 : arc.hidden ? 0 : me.calculateCircumference(dataset.data[index]) * (opts.circumference / DOUBLE_PI$1);
            var innerRadius = reset && animationOpts.animateScale ? 0 : me.innerRadius;
            var outerRadius = reset && animationOpts.animateScale ? 0 : me.outerRadius;
            var options = arc._options || {};
            helpers$1.extend(arc, {
                // Utility
                _datasetIndex: me.index,
                _index: index,
                // Desired view properties
                _model: {
                    backgroundColor: options.backgroundColor,
                    borderColor: options.borderColor,
                    borderWidth: options.borderWidth,
                    borderAlign: options.borderAlign,
                    x: centerX + chart.offsetX,
                    y: centerY + chart.offsetY,
                    startAngle: startAngle,
                    endAngle: endAngle,
                    circumference: circumference,
                    outerRadius: outerRadius,
                    innerRadius: innerRadius,
                    label: helpers$1.valueAtIndexOrDefault(dataset.label, index, chart.data.labels[index])
                }
            });
            var model = arc._model;
            // Set correct angles if not resetting
            if (!reset || !animationOpts.animateRotate) {
                if (index === 0) model.startAngle = opts.rotation;
                else model.startAngle = me.getMeta().data[index - 1]._model.endAngle;
                model.endAngle = model.startAngle + model.circumference;
            }
            arc.pivot();
        },
        calculateTotal: function() {
            var dataset = this.getDataset();
            var meta = this.getMeta();
            var total = 0;
            var value;
            helpers$1.each(meta.data, function(element, index) {
                value = dataset.data[index];
                if (!isNaN(value) && !element.hidden) total += Math.abs(value);
            });
            /* if (total === 0) {
			total = NaN;
		}*/ return total;
        },
        calculateCircumference: function(value) {
            var total = this.getMeta().total;
            if (total > 0 && !isNaN(value)) return DOUBLE_PI$1 * (Math.abs(value) / total);
            return 0;
        },
        // gets the max border or hover width to properly scale pie charts
        getMaxBorderWidth: function(arcs) {
            var me = this;
            var max = 0;
            var chart = me.chart;
            var i, ilen, meta, arc, controller, options, borderWidth, hoverWidth;
            if (!arcs) {
                // Find the outmost visible dataset
                for(i = 0, ilen = chart.data.datasets.length; i < ilen; ++i)if (chart.isDatasetVisible(i)) {
                    meta = chart.getDatasetMeta(i);
                    arcs = meta.data;
                    if (i !== me.index) controller = meta.controller;
                    break;
                }
            }
            if (!arcs) return 0;
            for(i = 0, ilen = arcs.length; i < ilen; ++i){
                arc = arcs[i];
                if (controller) {
                    controller._configure();
                    options = controller._resolveDataElementOptions(arc, i);
                } else options = arc._options;
                if (options.borderAlign !== "inner") {
                    borderWidth = options.borderWidth;
                    hoverWidth = options.hoverBorderWidth;
                    max = borderWidth > max ? borderWidth : max;
                    max = hoverWidth > max ? hoverWidth : max;
                }
            }
            return max;
        },
        /**
	 * @protected
	 */ setHoverStyle: function(arc) {
            var model = arc._model;
            var options = arc._options;
            var getHoverColor = helpers$1.getHoverColor;
            arc.$previousStyle = {
                backgroundColor: model.backgroundColor,
                borderColor: model.borderColor,
                borderWidth: model.borderWidth
            };
            model.backgroundColor = valueOrDefault$5(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
            model.borderColor = valueOrDefault$5(options.hoverBorderColor, getHoverColor(options.borderColor));
            model.borderWidth = valueOrDefault$5(options.hoverBorderWidth, options.borderWidth);
        },
        /**
	 * Get radius length offset of the dataset in relation to the visible datasets weights. This allows determining the inner and outer radius correctly
	 * @private
	 */ _getRingWeightOffset: function(datasetIndex) {
            var ringWeightOffset = 0;
            for(var i = 0; i < datasetIndex; ++i)if (this.chart.isDatasetVisible(i)) ringWeightOffset += this._getRingWeight(i);
            return ringWeightOffset;
        },
        /**
	 * @private
	 */ _getRingWeight: function(dataSetIndex) {
            return Math.max(valueOrDefault$5(this.chart.data.datasets[dataSetIndex].weight, 1), 0);
        },
        /**
	 * Returns the sum of all visibile data set weights.  This value can be 0.
	 * @private
	 */ _getVisibleDatasetWeightTotal: function() {
            return this._getRingWeightOffset(this.chart.data.datasets.length);
        }
    });
    core_defaults._set("horizontalBar", {
        hover: {
            mode: "index",
            axis: "y"
        },
        scales: {
            xAxes: [
                {
                    type: "linear",
                    position: "bottom"
                }
            ],
            yAxes: [
                {
                    type: "category",
                    position: "left",
                    offset: true,
                    gridLines: {
                        offsetGridLines: true
                    }
                }
            ]
        },
        elements: {
            rectangle: {
                borderSkipped: "left"
            }
        },
        tooltips: {
            mode: "index",
            axis: "y"
        }
    });
    core_defaults._set("global", {
        datasets: {
            horizontalBar: {
                categoryPercentage: 0.8,
                barPercentage: 0.9
            }
        }
    });
    var controller_horizontalBar = controller_bar.extend({
        /**
	 * @private
	 */ _getValueScaleId: function() {
            return this.getMeta().xAxisID;
        },
        /**
	 * @private
	 */ _getIndexScaleId: function() {
            return this.getMeta().yAxisID;
        }
    });
    var valueOrDefault$6 = helpers$1.valueOrDefault;
    var resolve$2 = helpers$1.options.resolve;
    var isPointInArea = helpers$1.canvas._isPointInArea;
    core_defaults._set("line", {
        showLines: true,
        spanGaps: false,
        hover: {
            mode: "label"
        },
        scales: {
            xAxes: [
                {
                    type: "category",
                    id: "x-axis-0"
                }
            ],
            yAxes: [
                {
                    type: "linear",
                    id: "y-axis-0"
                }
            ]
        }
    });
    function scaleClip(scale, halfBorderWidth) {
        var tickOpts = scale && scale.options.ticks || {};
        var reverse = tickOpts.reverse;
        var min = tickOpts.min === undefined ? halfBorderWidth : 0;
        var max = tickOpts.max === undefined ? halfBorderWidth : 0;
        return {
            start: reverse ? max : min,
            end: reverse ? min : max
        };
    }
    function defaultClip(xScale, yScale, borderWidth) {
        var halfBorderWidth = borderWidth / 2;
        var x = scaleClip(xScale, halfBorderWidth);
        var y = scaleClip(yScale, halfBorderWidth);
        return {
            top: y.end,
            right: x.end,
            bottom: y.start,
            left: x.start
        };
    }
    function toClip(value) {
        var t, r, b, l;
        if (helpers$1.isObject(value)) {
            t = value.top;
            r = value.right;
            b = value.bottom;
            l = value.left;
        } else t = r = b = l = value;
        return {
            top: t,
            right: r,
            bottom: b,
            left: l
        };
    }
    var controller_line = core_datasetController.extend({
        datasetElementType: elements.Line,
        dataElementType: elements.Point,
        /**
	 * @private
	 */ _datasetElementOptions: [
            "backgroundColor",
            "borderCapStyle",
            "borderColor",
            "borderDash",
            "borderDashOffset",
            "borderJoinStyle",
            "borderWidth",
            "cubicInterpolationMode",
            "fill"
        ],
        /**
	 * @private
	 */ _dataElementOptions: {
            backgroundColor: "pointBackgroundColor",
            borderColor: "pointBorderColor",
            borderWidth: "pointBorderWidth",
            hitRadius: "pointHitRadius",
            hoverBackgroundColor: "pointHoverBackgroundColor",
            hoverBorderColor: "pointHoverBorderColor",
            hoverBorderWidth: "pointHoverBorderWidth",
            hoverRadius: "pointHoverRadius",
            pointStyle: "pointStyle",
            radius: "pointRadius",
            rotation: "pointRotation"
        },
        update: function(reset) {
            var me = this;
            var meta = me.getMeta();
            var line = meta.dataset;
            var points = meta.data || [];
            var options = me.chart.options;
            var config = me._config;
            var showLine = me._showLine = valueOrDefault$6(config.showLine, options.showLines);
            var i, ilen;
            me._xScale = me.getScaleForId(meta.xAxisID);
            me._yScale = me.getScaleForId(meta.yAxisID);
            // Update Line
            if (showLine) {
                // Compatibility: If the properties are defined with only the old name, use those values
                if (config.tension !== undefined && config.lineTension === undefined) config.lineTension = config.tension;
                // Utility
                line._scale = me._yScale;
                line._datasetIndex = me.index;
                // Data
                line._children = points;
                // Model
                line._model = me._resolveDatasetElementOptions(line);
                line.pivot();
            }
            // Update Points
            for(i = 0, ilen = points.length; i < ilen; ++i)me.updateElement(points[i], i, reset);
            if (showLine && line._model.tension !== 0) me.updateBezierControlPoints();
            // Now pivot the point for animation
            for(i = 0, ilen = points.length; i < ilen; ++i)points[i].pivot();
        },
        updateElement: function(point, index, reset) {
            var me = this;
            var meta = me.getMeta();
            var custom = point.custom || {};
            var dataset = me.getDataset();
            var datasetIndex = me.index;
            var value = dataset.data[index];
            var xScale = me._xScale;
            var yScale = me._yScale;
            var lineModel = meta.dataset._model;
            var x, y;
            var options = me._resolveDataElementOptions(point, index);
            x = xScale.getPixelForValue(typeof value === "object" ? value : NaN, index, datasetIndex);
            y = reset ? yScale.getBasePixel() : me.calculatePointY(value, index, datasetIndex);
            // Utility
            point._xScale = xScale;
            point._yScale = yScale;
            point._options = options;
            point._datasetIndex = datasetIndex;
            point._index = index;
            // Desired view properties
            point._model = {
                x: x,
                y: y,
                skip: custom.skip || isNaN(x) || isNaN(y),
                // Appearance
                radius: options.radius,
                pointStyle: options.pointStyle,
                rotation: options.rotation,
                backgroundColor: options.backgroundColor,
                borderColor: options.borderColor,
                borderWidth: options.borderWidth,
                tension: valueOrDefault$6(custom.tension, lineModel ? lineModel.tension : 0),
                steppedLine: lineModel ? lineModel.steppedLine : false,
                // Tooltip
                hitRadius: options.hitRadius
            };
        },
        /**
	 * @private
	 */ _resolveDatasetElementOptions: function(element) {
            var me = this;
            var config = me._config;
            var custom = element.custom || {};
            var options = me.chart.options;
            var lineOptions = options.elements.line;
            var values = core_datasetController.prototype._resolveDatasetElementOptions.apply(me, arguments);
            // The default behavior of lines is to break at null values, according
            // to https://github.com/chartjs/Chart.js/issues/2435#issuecomment-216718158
            // This option gives lines the ability to span gaps
            values.spanGaps = valueOrDefault$6(config.spanGaps, options.spanGaps);
            values.tension = valueOrDefault$6(config.lineTension, lineOptions.tension);
            values.steppedLine = resolve$2([
                custom.steppedLine,
                config.steppedLine,
                lineOptions.stepped
            ]);
            values.clip = toClip(valueOrDefault$6(config.clip, defaultClip(me._xScale, me._yScale, values.borderWidth)));
            return values;
        },
        calculatePointY: function(value, index, datasetIndex) {
            var me = this;
            var chart = me.chart;
            var yScale = me._yScale;
            var sumPos = 0;
            var sumNeg = 0;
            var i, ds, dsMeta, stackedRightValue, rightValue, metasets, ilen;
            if (yScale.options.stacked) {
                rightValue = +yScale.getRightValue(value);
                metasets = chart._getSortedVisibleDatasetMetas();
                ilen = metasets.length;
                for(i = 0; i < ilen; ++i){
                    dsMeta = metasets[i];
                    if (dsMeta.index === datasetIndex) break;
                    ds = chart.data.datasets[dsMeta.index];
                    if (dsMeta.type === "line" && dsMeta.yAxisID === yScale.id) {
                        stackedRightValue = +yScale.getRightValue(ds.data[index]);
                        if (stackedRightValue < 0) sumNeg += stackedRightValue || 0;
                        else sumPos += stackedRightValue || 0;
                    }
                }
                if (rightValue < 0) return yScale.getPixelForValue(sumNeg + rightValue);
                return yScale.getPixelForValue(sumPos + rightValue);
            }
            return yScale.getPixelForValue(value);
        },
        updateBezierControlPoints: function() {
            var me = this;
            var chart = me.chart;
            var meta = me.getMeta();
            var lineModel = meta.dataset._model;
            var area = chart.chartArea;
            var points = meta.data || [];
            var i, ilen, model, controlPoints;
            // Only consider points that are drawn in case the spanGaps option is used
            if (lineModel.spanGaps) points = points.filter(function(pt) {
                return !pt._model.skip;
            });
            function capControlPoint(pt, min, max) {
                return Math.max(Math.min(pt, max), min);
            }
            if (lineModel.cubicInterpolationMode === "monotone") helpers$1.splineCurveMonotone(points);
            else for(i = 0, ilen = points.length; i < ilen; ++i){
                model = points[i]._model;
                controlPoints = helpers$1.splineCurve(helpers$1.previousItem(points, i)._model, model, helpers$1.nextItem(points, i)._model, lineModel.tension);
                model.controlPointPreviousX = controlPoints.previous.x;
                model.controlPointPreviousY = controlPoints.previous.y;
                model.controlPointNextX = controlPoints.next.x;
                model.controlPointNextY = controlPoints.next.y;
            }
            if (chart.options.elements.line.capBezierPoints) for(i = 0, ilen = points.length; i < ilen; ++i){
                model = points[i]._model;
                if (isPointInArea(model, area)) {
                    if (i > 0 && isPointInArea(points[i - 1]._model, area)) {
                        model.controlPointPreviousX = capControlPoint(model.controlPointPreviousX, area.left, area.right);
                        model.controlPointPreviousY = capControlPoint(model.controlPointPreviousY, area.top, area.bottom);
                    }
                    if (i < points.length - 1 && isPointInArea(points[i + 1]._model, area)) {
                        model.controlPointNextX = capControlPoint(model.controlPointNextX, area.left, area.right);
                        model.controlPointNextY = capControlPoint(model.controlPointNextY, area.top, area.bottom);
                    }
                }
            }
        },
        draw: function() {
            var me = this;
            var chart = me.chart;
            var meta = me.getMeta();
            var points = meta.data || [];
            var area = chart.chartArea;
            var canvas = chart.canvas;
            var i = 0;
            var ilen = points.length;
            var clip;
            if (me._showLine) {
                clip = meta.dataset._model.clip;
                helpers$1.canvas.clipArea(chart.ctx, {
                    left: clip.left === false ? 0 : area.left - clip.left,
                    right: clip.right === false ? canvas.width : area.right + clip.right,
                    top: clip.top === false ? 0 : area.top - clip.top,
                    bottom: clip.bottom === false ? canvas.height : area.bottom + clip.bottom
                });
                meta.dataset.draw();
                helpers$1.canvas.unclipArea(chart.ctx);
            }
            // Draw the points
            for(; i < ilen; ++i)points[i].draw(area);
        },
        /**
	 * @protected
	 */ setHoverStyle: function(point) {
            var model = point._model;
            var options = point._options;
            var getHoverColor = helpers$1.getHoverColor;
            point.$previousStyle = {
                backgroundColor: model.backgroundColor,
                borderColor: model.borderColor,
                borderWidth: model.borderWidth,
                radius: model.radius
            };
            model.backgroundColor = valueOrDefault$6(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
            model.borderColor = valueOrDefault$6(options.hoverBorderColor, getHoverColor(options.borderColor));
            model.borderWidth = valueOrDefault$6(options.hoverBorderWidth, options.borderWidth);
            model.radius = valueOrDefault$6(options.hoverRadius, options.radius);
        }
    });
    var resolve$3 = helpers$1.options.resolve;
    core_defaults._set("polarArea", {
        scale: {
            type: "radialLinear",
            angleLines: {
                display: false
            },
            gridLines: {
                circular: true
            },
            pointLabels: {
                display: false
            },
            ticks: {
                beginAtZero: true
            }
        },
        // Boolean - Whether to animate the rotation of the chart
        animation: {
            animateRotate: true,
            animateScale: true
        },
        startAngle: -0.5 * Math.PI,
        legendCallback: function(chart) {
            var list = document.createElement("ul");
            var data = chart.data;
            var datasets = data.datasets;
            var labels = data.labels;
            var i, ilen, listItem, listItemSpan;
            list.setAttribute("class", chart.id + "-legend");
            if (datasets.length) for(i = 0, ilen = datasets[0].data.length; i < ilen; ++i){
                listItem = list.appendChild(document.createElement("li"));
                listItemSpan = listItem.appendChild(document.createElement("span"));
                listItemSpan.style.backgroundColor = datasets[0].backgroundColor[i];
                if (labels[i]) listItem.appendChild(document.createTextNode(labels[i]));
            }
            return list.outerHTML;
        },
        legend: {
            labels: {
                generateLabels: function(chart) {
                    var data = chart.data;
                    if (data.labels.length && data.datasets.length) return data.labels.map(function(label, i) {
                        var meta = chart.getDatasetMeta(0);
                        var style = meta.controller.getStyle(i);
                        return {
                            text: label,
                            fillStyle: style.backgroundColor,
                            strokeStyle: style.borderColor,
                            lineWidth: style.borderWidth,
                            hidden: isNaN(data.datasets[0].data[i]) || meta.data[i].hidden,
                            // Extra data used for toggling the correct item
                            index: i
                        };
                    });
                    return [];
                }
            },
            onClick: function(e, legendItem) {
                var index = legendItem.index;
                var chart = this.chart;
                var i, ilen, meta;
                for(i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i){
                    meta = chart.getDatasetMeta(i);
                    meta.data[index].hidden = !meta.data[index].hidden;
                }
                chart.update();
            }
        },
        // Need to override these to give a nice default
        tooltips: {
            callbacks: {
                title: function() {
                    return "";
                },
                label: function(item, data) {
                    return data.labels[item.index] + ": " + item.yLabel;
                }
            }
        }
    });
    var controller_polarArea = core_datasetController.extend({
        dataElementType: elements.Arc,
        linkScales: helpers$1.noop,
        /**
	 * @private
	 */ _dataElementOptions: [
            "backgroundColor",
            "borderColor",
            "borderWidth",
            "borderAlign",
            "hoverBackgroundColor",
            "hoverBorderColor",
            "hoverBorderWidth"
        ],
        /**
	 * @private
	 */ _getIndexScaleId: function() {
            return this.chart.scale.id;
        },
        /**
	 * @private
	 */ _getValueScaleId: function() {
            return this.chart.scale.id;
        },
        update: function(reset) {
            var me = this;
            var dataset = me.getDataset();
            var meta = me.getMeta();
            var start = me.chart.options.startAngle || 0;
            var starts = me._starts = [];
            var angles = me._angles = [];
            var arcs = meta.data;
            var i, ilen, angle;
            me._updateRadius();
            meta.count = me.countVisibleElements();
            for(i = 0, ilen = dataset.data.length; i < ilen; i++){
                starts[i] = start;
                angle = me._computeAngle(i);
                angles[i] = angle;
                start += angle;
            }
            for(i = 0, ilen = arcs.length; i < ilen; ++i){
                arcs[i]._options = me._resolveDataElementOptions(arcs[i], i);
                me.updateElement(arcs[i], i, reset);
            }
        },
        /**
	 * @private
	 */ _updateRadius: function() {
            var me = this;
            var chart = me.chart;
            var chartArea = chart.chartArea;
            var opts = chart.options;
            var minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
            chart.outerRadius = Math.max(minSize / 2, 0);
            chart.innerRadius = Math.max(opts.cutoutPercentage ? chart.outerRadius / 100 * opts.cutoutPercentage : 1, 0);
            chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();
            me.outerRadius = chart.outerRadius - chart.radiusLength * me.index;
            me.innerRadius = me.outerRadius - chart.radiusLength;
        },
        updateElement: function(arc, index, reset) {
            var me = this;
            var chart = me.chart;
            var dataset = me.getDataset();
            var opts = chart.options;
            var animationOpts = opts.animation;
            var scale = chart.scale;
            var labels = chart.data.labels;
            var centerX = scale.xCenter;
            var centerY = scale.yCenter;
            // var negHalfPI = -0.5 * Math.PI;
            var datasetStartAngle = opts.startAngle;
            var distance = arc.hidden ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
            var startAngle = me._starts[index];
            var endAngle = startAngle + (arc.hidden ? 0 : me._angles[index]);
            var resetRadius = animationOpts.animateScale ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
            var options = arc._options || {};
            helpers$1.extend(arc, {
                // Utility
                _datasetIndex: me.index,
                _index: index,
                _scale: scale,
                // Desired view properties
                _model: {
                    backgroundColor: options.backgroundColor,
                    borderColor: options.borderColor,
                    borderWidth: options.borderWidth,
                    borderAlign: options.borderAlign,
                    x: centerX,
                    y: centerY,
                    innerRadius: 0,
                    outerRadius: reset ? resetRadius : distance,
                    startAngle: reset && animationOpts.animateRotate ? datasetStartAngle : startAngle,
                    endAngle: reset && animationOpts.animateRotate ? datasetStartAngle : endAngle,
                    label: helpers$1.valueAtIndexOrDefault(labels, index, labels[index])
                }
            });
            arc.pivot();
        },
        countVisibleElements: function() {
            var dataset = this.getDataset();
            var meta = this.getMeta();
            var count = 0;
            helpers$1.each(meta.data, function(element, index) {
                if (!isNaN(dataset.data[index]) && !element.hidden) count++;
            });
            return count;
        },
        /**
	 * @protected
	 */ setHoverStyle: function(arc) {
            var model = arc._model;
            var options = arc._options;
            var getHoverColor = helpers$1.getHoverColor;
            var valueOrDefault = helpers$1.valueOrDefault;
            arc.$previousStyle = {
                backgroundColor: model.backgroundColor,
                borderColor: model.borderColor,
                borderWidth: model.borderWidth
            };
            model.backgroundColor = valueOrDefault(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
            model.borderColor = valueOrDefault(options.hoverBorderColor, getHoverColor(options.borderColor));
            model.borderWidth = valueOrDefault(options.hoverBorderWidth, options.borderWidth);
        },
        /**
	 * @private
	 */ _computeAngle: function(index) {
            var me = this;
            var count = this.getMeta().count;
            var dataset = me.getDataset();
            var meta = me.getMeta();
            if (isNaN(dataset.data[index]) || meta.data[index].hidden) return 0;
            // Scriptable options
            var context = {
                chart: me.chart,
                dataIndex: index,
                dataset: dataset,
                datasetIndex: me.index
            };
            return resolve$3([
                me.chart.options.elements.arc.angle,
                2 * Math.PI / count
            ], context, index);
        }
    });
    core_defaults._set("pie", helpers$1.clone(core_defaults.doughnut));
    core_defaults._set("pie", {
        cutoutPercentage: 0
    });
    // Pie charts are Doughnut chart with different defaults
    var controller_pie = controller_doughnut;
    var valueOrDefault$7 = helpers$1.valueOrDefault;
    core_defaults._set("radar", {
        spanGaps: false,
        scale: {
            type: "radialLinear"
        },
        elements: {
            line: {
                fill: "start",
                tension: 0 // no bezier in radar
            }
        }
    });
    var controller_radar = core_datasetController.extend({
        datasetElementType: elements.Line,
        dataElementType: elements.Point,
        linkScales: helpers$1.noop,
        /**
	 * @private
	 */ _datasetElementOptions: [
            "backgroundColor",
            "borderWidth",
            "borderColor",
            "borderCapStyle",
            "borderDash",
            "borderDashOffset",
            "borderJoinStyle",
            "fill"
        ],
        /**
	 * @private
	 */ _dataElementOptions: {
            backgroundColor: "pointBackgroundColor",
            borderColor: "pointBorderColor",
            borderWidth: "pointBorderWidth",
            hitRadius: "pointHitRadius",
            hoverBackgroundColor: "pointHoverBackgroundColor",
            hoverBorderColor: "pointHoverBorderColor",
            hoverBorderWidth: "pointHoverBorderWidth",
            hoverRadius: "pointHoverRadius",
            pointStyle: "pointStyle",
            radius: "pointRadius",
            rotation: "pointRotation"
        },
        /**
	 * @private
	 */ _getIndexScaleId: function() {
            return this.chart.scale.id;
        },
        /**
	 * @private
	 */ _getValueScaleId: function() {
            return this.chart.scale.id;
        },
        update: function(reset) {
            var me = this;
            var meta = me.getMeta();
            var line = meta.dataset;
            var points = meta.data || [];
            var scale = me.chart.scale;
            var config = me._config;
            var i, ilen;
            // Compatibility: If the properties are defined with only the old name, use those values
            if (config.tension !== undefined && config.lineTension === undefined) config.lineTension = config.tension;
            // Utility
            line._scale = scale;
            line._datasetIndex = me.index;
            // Data
            line._children = points;
            line._loop = true;
            // Model
            line._model = me._resolveDatasetElementOptions(line);
            line.pivot();
            // Update Points
            for(i = 0, ilen = points.length; i < ilen; ++i)me.updateElement(points[i], i, reset);
            // Update bezier control points
            me.updateBezierControlPoints();
            // Now pivot the point for animation
            for(i = 0, ilen = points.length; i < ilen; ++i)points[i].pivot();
        },
        updateElement: function(point, index, reset) {
            var me = this;
            var custom = point.custom || {};
            var dataset = me.getDataset();
            var scale = me.chart.scale;
            var pointPosition = scale.getPointPositionForValue(index, dataset.data[index]);
            var options = me._resolveDataElementOptions(point, index);
            var lineModel = me.getMeta().dataset._model;
            var x = reset ? scale.xCenter : pointPosition.x;
            var y = reset ? scale.yCenter : pointPosition.y;
            // Utility
            point._scale = scale;
            point._options = options;
            point._datasetIndex = me.index;
            point._index = index;
            // Desired view properties
            point._model = {
                x: x,
                y: y,
                skip: custom.skip || isNaN(x) || isNaN(y),
                // Appearance
                radius: options.radius,
                pointStyle: options.pointStyle,
                rotation: options.rotation,
                backgroundColor: options.backgroundColor,
                borderColor: options.borderColor,
                borderWidth: options.borderWidth,
                tension: valueOrDefault$7(custom.tension, lineModel ? lineModel.tension : 0),
                // Tooltip
                hitRadius: options.hitRadius
            };
        },
        /**
	 * @private
	 */ _resolveDatasetElementOptions: function() {
            var me = this;
            var config = me._config;
            var options = me.chart.options;
            var values = core_datasetController.prototype._resolveDatasetElementOptions.apply(me, arguments);
            values.spanGaps = valueOrDefault$7(config.spanGaps, options.spanGaps);
            values.tension = valueOrDefault$7(config.lineTension, options.elements.line.tension);
            return values;
        },
        updateBezierControlPoints: function() {
            var me = this;
            var meta = me.getMeta();
            var area = me.chart.chartArea;
            var points = meta.data || [];
            var i, ilen, model, controlPoints;
            // Only consider points that are drawn in case the spanGaps option is used
            if (meta.dataset._model.spanGaps) points = points.filter(function(pt) {
                return !pt._model.skip;
            });
            function capControlPoint(pt, min, max) {
                return Math.max(Math.min(pt, max), min);
            }
            for(i = 0, ilen = points.length; i < ilen; ++i){
                model = points[i]._model;
                controlPoints = helpers$1.splineCurve(helpers$1.previousItem(points, i, true)._model, model, helpers$1.nextItem(points, i, true)._model, model.tension);
                // Prevent the bezier going outside of the bounds of the graph
                model.controlPointPreviousX = capControlPoint(controlPoints.previous.x, area.left, area.right);
                model.controlPointPreviousY = capControlPoint(controlPoints.previous.y, area.top, area.bottom);
                model.controlPointNextX = capControlPoint(controlPoints.next.x, area.left, area.right);
                model.controlPointNextY = capControlPoint(controlPoints.next.y, area.top, area.bottom);
            }
        },
        setHoverStyle: function(point) {
            var model = point._model;
            var options = point._options;
            var getHoverColor = helpers$1.getHoverColor;
            point.$previousStyle = {
                backgroundColor: model.backgroundColor,
                borderColor: model.borderColor,
                borderWidth: model.borderWidth,
                radius: model.radius
            };
            model.backgroundColor = valueOrDefault$7(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
            model.borderColor = valueOrDefault$7(options.hoverBorderColor, getHoverColor(options.borderColor));
            model.borderWidth = valueOrDefault$7(options.hoverBorderWidth, options.borderWidth);
            model.radius = valueOrDefault$7(options.hoverRadius, options.radius);
        }
    });
    core_defaults._set("scatter", {
        hover: {
            mode: "single"
        },
        scales: {
            xAxes: [
                {
                    id: "x-axis-1",
                    type: "linear",
                    position: "bottom"
                }
            ],
            yAxes: [
                {
                    id: "y-axis-1",
                    type: "linear",
                    position: "left"
                }
            ]
        },
        tooltips: {
            callbacks: {
                title: function() {
                    return ""; // doesn't make sense for scatter since data are formatted as a point
                },
                label: function(item) {
                    return "(" + item.xLabel + ", " + item.yLabel + ")";
                }
            }
        }
    });
    core_defaults._set("global", {
        datasets: {
            scatter: {
                showLine: false
            }
        }
    });
    // Scatter charts use line controllers
    var controller_scatter = controller_line;
    // NOTE export a map in which the key represents the controller type, not
    // the class, and so must be CamelCase in order to be correctly retrieved
    // by the controller in core.controller.js (`controllers[meta.type]`).
    var controllers = {
        bar: controller_bar,
        bubble: controller_bubble,
        doughnut: controller_doughnut,
        horizontalBar: controller_horizontalBar,
        line: controller_line,
        polarArea: controller_polarArea,
        pie: controller_pie,
        radar: controller_radar,
        scatter: controller_scatter
    };
    /**
 * Helper function to get relative position for an event
 * @param {Event|IEvent} event - The event to get the position for
 * @param {Chart} chart - The chart
 * @returns {object} the event position
 */ function getRelativePosition(e, chart) {
        if (e.native) return {
            x: e.x,
            y: e.y
        };
        return helpers$1.getRelativePosition(e, chart);
    }
    /**
 * Helper function to traverse all of the visible elements in the chart
 * @param {Chart} chart - the chart
 * @param {function} handler - the callback to execute for each visible item
 */ function parseVisibleItems(chart, handler) {
        var metasets = chart._getSortedVisibleDatasetMetas();
        var metadata, i, j, ilen, jlen, element;
        for(i = 0, ilen = metasets.length; i < ilen; ++i){
            metadata = metasets[i].data;
            for(j = 0, jlen = metadata.length; j < jlen; ++j){
                element = metadata[j];
                if (!element._view.skip) handler(element);
            }
        }
    }
    /**
 * Helper function to get the items that intersect the event position
 * @param {ChartElement[]} items - elements to filter
 * @param {object} position - the point to be nearest to
 * @return {ChartElement[]} the nearest items
 */ function getIntersectItems(chart, position) {
        var elements = [];
        parseVisibleItems(chart, function(element) {
            if (element.inRange(position.x, position.y)) elements.push(element);
        });
        return elements;
    }
    /**
 * Helper function to get the items nearest to the event position considering all visible items in teh chart
 * @param {Chart} chart - the chart to look at elements from
 * @param {object} position - the point to be nearest to
 * @param {boolean} intersect - if true, only consider items that intersect the position
 * @param {function} distanceMetric - function to provide the distance between points
 * @return {ChartElement[]} the nearest items
 */ function getNearestItems(chart, position, intersect, distanceMetric) {
        var minDistance = Number.POSITIVE_INFINITY;
        var nearestItems = [];
        parseVisibleItems(chart, function(element) {
            if (intersect && !element.inRange(position.x, position.y)) return;
            var center = element.getCenterPoint();
            var distance = distanceMetric(position, center);
            if (distance < minDistance) {
                nearestItems = [
                    element
                ];
                minDistance = distance;
            } else if (distance === minDistance) // Can have multiple items at the same distance in which case we sort by size
            nearestItems.push(element);
        });
        return nearestItems;
    }
    /**
 * Get a distance metric function for two points based on the
 * axis mode setting
 * @param {string} axis - the axis mode. x|y|xy
 */ function getDistanceMetricForAxis(axis) {
        var useX = axis.indexOf("x") !== -1;
        var useY = axis.indexOf("y") !== -1;
        return function(pt1, pt2) {
            var deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
            var deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
            return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
        };
    }
    function indexMode(chart, e, options) {
        var position = getRelativePosition(e, chart);
        // Default axis for index mode is 'x' to match old behaviour
        options.axis = options.axis || "x";
        var distanceMetric = getDistanceMetricForAxis(options.axis);
        var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
        var elements = [];
        if (!items.length) return [];
        chart._getSortedVisibleDatasetMetas().forEach(function(meta) {
            var element = meta.data[items[0]._index];
            // don't count items that are skipped (null data)
            if (element && !element._view.skip) elements.push(element);
        });
        return elements;
    }
    /**
 * @interface IInteractionOptions
 */ /**
 * If true, only consider items that intersect the point
 * @name IInterfaceOptions#boolean
 * @type Boolean
 */ /**
 * Contains interaction related functions
 * @namespace Chart.Interaction
 */ var core_interaction = {
        // Helper function for different modes
        modes: {
            single: function(chart, e) {
                var position = getRelativePosition(e, chart);
                var elements = [];
                parseVisibleItems(chart, function(element) {
                    if (element.inRange(position.x, position.y)) {
                        elements.push(element);
                        return elements;
                    }
                });
                return elements.slice(0, 1);
            },
            /**
		 * @function Chart.Interaction.modes.label
		 * @deprecated since version 2.4.0
		 * @todo remove at version 3
		 * @private
		 */ label: indexMode,
            /**
		 * Returns items at the same index. If the options.intersect parameter is true, we only return items if we intersect something
		 * If the options.intersect mode is false, we find the nearest item and return the items at the same index as that item
		 * @function Chart.Interaction.modes.index
		 * @since v2.4.0
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use during interaction
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */ index: indexMode,
            /**
		 * Returns items in the same dataset. If the options.intersect parameter is true, we only return items if we intersect something
		 * If the options.intersect is false, we find the nearest item and return the items in that dataset
		 * @function Chart.Interaction.modes.dataset
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use during interaction
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */ dataset: function(chart, e, options) {
                var position = getRelativePosition(e, chart);
                options.axis = options.axis || "xy";
                var distanceMetric = getDistanceMetricForAxis(options.axis);
                var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
                if (items.length > 0) items = chart.getDatasetMeta(items[0]._datasetIndex).data;
                return items;
            },
            /**
		 * @function Chart.Interaction.modes.x-axis
		 * @deprecated since version 2.4.0. Use index mode and intersect == true
		 * @todo remove at version 3
		 * @private
		 */ "x-axis": function(chart, e) {
                return indexMode(chart, e, {
                    intersect: false
                });
            },
            /**
		 * Point mode returns all elements that hit test based on the event position
		 * of the event
		 * @function Chart.Interaction.modes.intersect
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */ point: function(chart, e) {
                var position = getRelativePosition(e, chart);
                return getIntersectItems(chart, position);
            },
            /**
		 * nearest mode returns the element closest to the point
		 * @function Chart.Interaction.modes.intersect
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */ nearest: function(chart, e, options) {
                var position = getRelativePosition(e, chart);
                options.axis = options.axis || "xy";
                var distanceMetric = getDistanceMetricForAxis(options.axis);
                return getNearestItems(chart, position, options.intersect, distanceMetric);
            },
            /**
		 * x mode returns the elements that hit-test at the current x coordinate
		 * @function Chart.Interaction.modes.x
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */ x: function(chart, e, options) {
                var position = getRelativePosition(e, chart);
                var items = [];
                var intersectsItem = false;
                parseVisibleItems(chart, function(element) {
                    if (element.inXRange(position.x)) items.push(element);
                    if (element.inRange(position.x, position.y)) intersectsItem = true;
                });
                // If we want to trigger on an intersect and we don't have any items
                // that intersect the position, return nothing
                if (options.intersect && !intersectsItem) items = [];
                return items;
            },
            /**
		 * y mode returns the elements that hit-test at the current y coordinate
		 * @function Chart.Interaction.modes.y
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */ y: function(chart, e, options) {
                var position = getRelativePosition(e, chart);
                var items = [];
                var intersectsItem = false;
                parseVisibleItems(chart, function(element) {
                    if (element.inYRange(position.y)) items.push(element);
                    if (element.inRange(position.x, position.y)) intersectsItem = true;
                });
                // If we want to trigger on an intersect and we don't have any items
                // that intersect the position, return nothing
                if (options.intersect && !intersectsItem) items = [];
                return items;
            }
        }
    };
    var extend = helpers$1.extend;
    function filterByPosition(array, position) {
        return helpers$1.where(array, function(v) {
            return v.pos === position;
        });
    }
    function sortByWeight(array, reverse) {
        return array.sort(function(a, b) {
            var v0 = reverse ? b : a;
            var v1 = reverse ? a : b;
            return v0.weight === v1.weight ? v0.index - v1.index : v0.weight - v1.weight;
        });
    }
    function wrapBoxes(boxes) {
        var layoutBoxes = [];
        var i, ilen, box;
        for(i = 0, ilen = (boxes || []).length; i < ilen; ++i){
            box = boxes[i];
            layoutBoxes.push({
                index: i,
                box: box,
                pos: box.position,
                horizontal: box.isHorizontal(),
                weight: box.weight
            });
        }
        return layoutBoxes;
    }
    function setLayoutDims(layouts, params) {
        var i, ilen, layout;
        for(i = 0, ilen = layouts.length; i < ilen; ++i){
            layout = layouts[i];
            // store width used instead of chartArea.w in fitBoxes
            layout.width = layout.horizontal ? layout.box.fullWidth && params.availableWidth : params.vBoxMaxWidth;
            // store height used instead of chartArea.h in fitBoxes
            layout.height = layout.horizontal && params.hBoxMaxHeight;
        }
    }
    function buildLayoutBoxes(boxes) {
        var layoutBoxes = wrapBoxes(boxes);
        var left = sortByWeight(filterByPosition(layoutBoxes, "left"), true);
        var right = sortByWeight(filterByPosition(layoutBoxes, "right"));
        var top = sortByWeight(filterByPosition(layoutBoxes, "top"), true);
        var bottom = sortByWeight(filterByPosition(layoutBoxes, "bottom"));
        return {
            leftAndTop: left.concat(top),
            rightAndBottom: right.concat(bottom),
            chartArea: filterByPosition(layoutBoxes, "chartArea"),
            vertical: left.concat(right),
            horizontal: top.concat(bottom)
        };
    }
    function getCombinedMax(maxPadding, chartArea, a, b) {
        return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
    }
    function updateDims(chartArea, params, layout) {
        var box = layout.box;
        var maxPadding = chartArea.maxPadding;
        var newWidth, newHeight;
        if (layout.size) // this layout was already counted for, lets first reduce old size
        chartArea[layout.pos] -= layout.size;
        layout.size = layout.horizontal ? box.height : box.width;
        chartArea[layout.pos] += layout.size;
        if (box.getPadding) {
            var boxPadding = box.getPadding();
            maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
            maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
            maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
            maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
        }
        newWidth = params.outerWidth - getCombinedMax(maxPadding, chartArea, "left", "right");
        newHeight = params.outerHeight - getCombinedMax(maxPadding, chartArea, "top", "bottom");
        if (newWidth !== chartArea.w || newHeight !== chartArea.h) {
            chartArea.w = newWidth;
            chartArea.h = newHeight;
            // return true if chart area changed in layout's direction
            var sizes = layout.horizontal ? [
                newWidth,
                chartArea.w
            ] : [
                newHeight,
                chartArea.h
            ];
            return sizes[0] !== sizes[1] && (!isNaN(sizes[0]) || !isNaN(sizes[1]));
        }
    }
    function handleMaxPadding(chartArea) {
        var maxPadding = chartArea.maxPadding;
        function updatePos(pos) {
            var change = Math.max(maxPadding[pos] - chartArea[pos], 0);
            chartArea[pos] += change;
            return change;
        }
        chartArea.y += updatePos("top");
        chartArea.x += updatePos("left");
        updatePos("right");
        updatePos("bottom");
    }
    function getMargins(horizontal, chartArea) {
        var maxPadding = chartArea.maxPadding;
        function marginForPositions(positions) {
            var margin = {
                left: 0,
                top: 0,
                right: 0,
                bottom: 0
            };
            positions.forEach(function(pos) {
                margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
            });
            return margin;
        }
        return horizontal ? marginForPositions([
            "left",
            "right"
        ]) : marginForPositions([
            "top",
            "bottom"
        ]);
    }
    function fitBoxes(boxes, chartArea, params) {
        var refitBoxes = [];
        var i, ilen, layout, box, refit, changed;
        for(i = 0, ilen = boxes.length; i < ilen; ++i){
            layout = boxes[i];
            box = layout.box;
            box.update(layout.width || chartArea.w, layout.height || chartArea.h, getMargins(layout.horizontal, chartArea));
            if (updateDims(chartArea, params, layout)) {
                changed = true;
                if (refitBoxes.length) // Dimensions changed and there were non full width boxes before this
                // -> we have to refit those
                refit = true;
            }
            if (!box.fullWidth) refitBoxes.push(layout);
        }
        return refit ? fitBoxes(refitBoxes, chartArea, params) || changed : changed;
    }
    function placeBoxes(boxes, chartArea, params) {
        var userPadding = params.padding;
        var x = chartArea.x;
        var y = chartArea.y;
        var i, ilen, layout, box;
        for(i = 0, ilen = boxes.length; i < ilen; ++i){
            layout = boxes[i];
            box = layout.box;
            if (layout.horizontal) {
                box.left = box.fullWidth ? userPadding.left : chartArea.left;
                box.right = box.fullWidth ? params.outerWidth - userPadding.right : chartArea.left + chartArea.w;
                box.top = y;
                box.bottom = y + box.height;
                box.width = box.right - box.left;
                y = box.bottom;
            } else {
                box.left = x;
                box.right = x + box.width;
                box.top = chartArea.top;
                box.bottom = chartArea.top + chartArea.h;
                box.height = box.bottom - box.top;
                x = box.right;
            }
        }
        chartArea.x = x;
        chartArea.y = y;
    }
    core_defaults._set("global", {
        layout: {
            padding: {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0
            }
        }
    });
    /**
 * @interface ILayoutItem
 * @prop {string} position - The position of the item in the chart layout. Possible values are
 * 'left', 'top', 'right', 'bottom', and 'chartArea'
 * @prop {number} weight - The weight used to sort the item. Higher weights are further away from the chart area
 * @prop {boolean} fullWidth - if true, and the item is horizontal, then push vertical boxes down
 * @prop {function} isHorizontal - returns true if the layout item is horizontal (ie. top or bottom)
 * @prop {function} update - Takes two parameters: width and height. Returns size of item
 * @prop {function} getPadding -  Returns an object with padding on the edges
 * @prop {number} width - Width of item. Must be valid after update()
 * @prop {number} height - Height of item. Must be valid after update()
 * @prop {number} left - Left edge of the item. Set by layout system and cannot be used in update
 * @prop {number} top - Top edge of the item. Set by layout system and cannot be used in update
 * @prop {number} right - Right edge of the item. Set by layout system and cannot be used in update
 * @prop {number} bottom - Bottom edge of the item. Set by layout system and cannot be used in update
 */ // The layout service is very self explanatory.  It's responsible for the layout within a chart.
    // Scales, Legends and Plugins all rely on the layout service and can easily register to be placed anywhere they need
    // It is this service's responsibility of carrying out that layout.
    var core_layouts = {
        defaults: {},
        /**
	 * Register a box to a chart.
	 * A box is simply a reference to an object that requires layout. eg. Scales, Legend, Title.
	 * @param {Chart} chart - the chart to use
	 * @param {ILayoutItem} item - the item to add to be layed out
	 */ addBox: function(chart, item) {
            if (!chart.boxes) chart.boxes = [];
            // initialize item with default values
            item.fullWidth = item.fullWidth || false;
            item.position = item.position || "top";
            item.weight = item.weight || 0;
            item._layers = item._layers || function() {
                return [
                    {
                        z: 0,
                        draw: function() {
                            item.draw.apply(item, arguments);
                        }
                    }
                ];
            };
            chart.boxes.push(item);
        },
        /**
	 * Remove a layoutItem from a chart
	 * @param {Chart} chart - the chart to remove the box from
	 * @param {ILayoutItem} layoutItem - the item to remove from the layout
	 */ removeBox: function(chart, layoutItem) {
            var index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
            if (index !== -1) chart.boxes.splice(index, 1);
        },
        /**
	 * Sets (or updates) options on the given `item`.
	 * @param {Chart} chart - the chart in which the item lives (or will be added to)
	 * @param {ILayoutItem} item - the item to configure with the given options
	 * @param {object} options - the new item options.
	 */ configure: function(chart, item, options) {
            var props = [
                "fullWidth",
                "position",
                "weight"
            ];
            var ilen = props.length;
            var i = 0;
            var prop;
            for(; i < ilen; ++i){
                prop = props[i];
                if (options.hasOwnProperty(prop)) item[prop] = options[prop];
            }
        },
        /**
	 * Fits boxes of the given chart into the given size by having each box measure itself
	 * then running a fitting algorithm
	 * @param {Chart} chart - the chart
	 * @param {number} width - the width to fit into
	 * @param {number} height - the height to fit into
	 */ update: function(chart, width, height) {
            if (!chart) return;
            var layoutOptions = chart.options.layout || {};
            var padding = helpers$1.options.toPadding(layoutOptions.padding);
            var availableWidth = width - padding.width;
            var availableHeight = height - padding.height;
            var boxes = buildLayoutBoxes(chart.boxes);
            var verticalBoxes = boxes.vertical;
            var horizontalBoxes = boxes.horizontal;
            // Essentially we now have any number of boxes on each of the 4 sides.
            // Our canvas looks like the following.
            // The areas L1 and L2 are the left axes. R1 is the right axis, T1 is the top axis and
            // B1 is the bottom axis
            // There are also 4 quadrant-like locations (left to right instead of clockwise) reserved for chart overlays
            // These locations are single-box locations only, when trying to register a chartArea location that is already taken,
            // an error will be thrown.
            //
            // |----------------------------------------------------|
            // |                  T1 (Full Width)                   |
            // |----------------------------------------------------|
            // |    |    |                 T2                  |    |
            // |    |----|-------------------------------------|----|
            // |    |    | C1 |                           | C2 |    |
            // |    |    |----|                           |----|    |
            // |    |    |                                     |    |
            // | L1 | L2 |           ChartArea (C0)            | R1 |
            // |    |    |                                     |    |
            // |    |    |----|                           |----|    |
            // |    |    | C3 |                           | C4 |    |
            // |    |----|-------------------------------------|----|
            // |    |    |                 B1                  |    |
            // |----------------------------------------------------|
            // |                  B2 (Full Width)                   |
            // |----------------------------------------------------|
            //
            var params = Object.freeze({
                outerWidth: width,
                outerHeight: height,
                padding: padding,
                availableWidth: availableWidth,
                vBoxMaxWidth: availableWidth / 2 / verticalBoxes.length,
                hBoxMaxHeight: availableHeight / 2
            });
            var chartArea = extend({
                maxPadding: extend({}, padding),
                w: availableWidth,
                h: availableHeight,
                x: padding.left,
                y: padding.top
            }, padding);
            setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);
            // First fit vertical boxes
            fitBoxes(verticalBoxes, chartArea, params);
            // Then fit horizontal boxes
            if (fitBoxes(horizontalBoxes, chartArea, params)) // if the area changed, re-fit vertical boxes
            fitBoxes(verticalBoxes, chartArea, params);
            handleMaxPadding(chartArea);
            // Finally place the boxes to correct coordinates
            placeBoxes(boxes.leftAndTop, chartArea, params);
            // Move to opposite side of chart
            chartArea.x += chartArea.w;
            chartArea.y += chartArea.h;
            placeBoxes(boxes.rightAndBottom, chartArea, params);
            chart.chartArea = {
                left: chartArea.left,
                top: chartArea.top,
                right: chartArea.left + chartArea.w,
                bottom: chartArea.top + chartArea.h
            };
            // Finally update boxes in chartArea (radial scale for example)
            helpers$1.each(boxes.chartArea, function(layout) {
                var box = layout.box;
                extend(box, chart.chartArea);
                box.update(chartArea.w, chartArea.h);
            });
        }
    };
    /**
 * Platform fallback implementation (minimal).
 * @see https://github.com/chartjs/Chart.js/pull/4591#issuecomment-319575939
 */ var platform_basic = {
        acquireContext: function(item) {
            if (item && item.canvas) // Support for any object associated to a canvas (including a context2d)
            item = item.canvas;
            return item && item.getContext("2d") || null;
        }
    };
    var platform_dom = "/*\r\n * DOM element rendering detection\r\n * https://davidwalsh.name/detect-node-insertion\r\n */\r\n@keyframes chartjs-render-animation {\r\n	from { opacity: 0.99; }\r\n	to { opacity: 1; }\r\n}\r\n\r\n.chartjs-render-monitor {\r\n	animation: chartjs-render-animation 0.001s;\r\n}\r\n\r\n/*\r\n * DOM element resizing detection\r\n * https://github.com/marcj/css-element-queries\r\n */\r\n.chartjs-size-monitor,\r\n.chartjs-size-monitor-expand,\r\n.chartjs-size-monitor-shrink {\r\n	position: absolute;\r\n	direction: ltr;\r\n	left: 0;\r\n	top: 0;\r\n	right: 0;\r\n	bottom: 0;\r\n	overflow: hidden;\r\n	pointer-events: none;\r\n	visibility: hidden;\r\n	z-index: -1;\r\n}\r\n\r\n.chartjs-size-monitor-expand > div {\r\n	position: absolute;\r\n	width: 1000000px;\r\n	height: 1000000px;\r\n	left: 0;\r\n	top: 0;\r\n}\r\n\r\n.chartjs-size-monitor-shrink > div {\r\n	position: absolute;\r\n	width: 200%;\r\n	height: 200%;\r\n	left: 0;\r\n	top: 0;\r\n}\r\n";
    var platform_dom$1 = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        "default": platform_dom
    });
    var stylesheet = getCjsExportFromNamespace(platform_dom$1);
    var EXPANDO_KEY = "$chartjs";
    var CSS_PREFIX = "chartjs-";
    var CSS_SIZE_MONITOR = CSS_PREFIX + "size-monitor";
    var CSS_RENDER_MONITOR = CSS_PREFIX + "render-monitor";
    var CSS_RENDER_ANIMATION = CSS_PREFIX + "render-animation";
    var ANIMATION_START_EVENTS = [
        "animationstart",
        "webkitAnimationStart"
    ];
    /**
 * DOM event types -> Chart.js event types.
 * Note: only events with different types are mapped.
 * @see https://developer.mozilla.org/en-US/docs/Web/Events
 */ var EVENT_TYPES = {
        touchstart: "mousedown",
        touchmove: "mousemove",
        touchend: "mouseup",
        pointerenter: "mouseenter",
        pointerdown: "mousedown",
        pointermove: "mousemove",
        pointerup: "mouseup",
        pointerleave: "mouseout",
        pointerout: "mouseout"
    };
    /**
 * The "used" size is the final value of a dimension property after all calculations have
 * been performed. This method uses the computed style of `element` but returns undefined
 * if the computed style is not expressed in pixels. That can happen in some cases where
 * `element` has a size relative to its parent and this last one is not yet displayed,
 * for example because of `display: none` on a parent node.
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
 * @returns {number} Size in pixels or undefined if unknown.
 */ function readUsedSize(element, property) {
        var value = helpers$1.getStyle(element, property);
        var matches = value && value.match(/^(\d+)(\.\d+)?px$/);
        return matches ? Number(matches[1]) : undefined;
    }
    /**
 * Initializes the canvas style and render size without modifying the canvas display size,
 * since responsiveness is handled by the controller.resize() method. The config is used
 * to determine the aspect ratio to apply in case no explicit height has been specified.
 */ function initCanvas(canvas, config) {
        var style = canvas.style;
        // NOTE(SB) canvas.getAttribute('width') !== canvas.width: in the first case it
        // returns null or '' if no explicit value has been set to the canvas attribute.
        var renderHeight = canvas.getAttribute("height");
        var renderWidth = canvas.getAttribute("width");
        // Chart.js modifies some canvas values that we want to restore on destroy
        canvas[EXPANDO_KEY] = {
            initial: {
                height: renderHeight,
                width: renderWidth,
                style: {
                    display: style.display,
                    height: style.height,
                    width: style.width
                }
            }
        };
        // Force canvas to display as block to avoid extra space caused by inline
        // elements, which would interfere with the responsive resize process.
        // https://github.com/chartjs/Chart.js/issues/2538
        style.display = style.display || "block";
        if (renderWidth === null || renderWidth === "") {
            var displayWidth = readUsedSize(canvas, "width");
            if (displayWidth !== undefined) canvas.width = displayWidth;
        }
        if (renderHeight === null || renderHeight === "") {
            if (canvas.style.height === "") // If no explicit render height and style height, let's apply the aspect ratio,
            // which one can be specified by the user but also by charts as default option
            // (i.e. options.aspectRatio). If not specified, use canvas aspect ratio of 2.
            canvas.height = canvas.width / (config.options.aspectRatio || 2);
            else {
                var displayHeight = readUsedSize(canvas, "height");
                if (displayWidth !== undefined) canvas.height = displayHeight;
            }
        }
        return canvas;
    }
    /**
 * Detects support for options object argument in addEventListener.
 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
 * @private
 */ var supportsEventListenerOptions = function() {
        var supports = false;
        try {
            var options = Object.defineProperty({}, "passive", {
                // eslint-disable-next-line getter-return
                get: function() {
                    supports = true;
                }
            });
            window.addEventListener("e", null, options);
        } catch (e) {
        // continue regardless of error
        }
        return supports;
    }();
    // Default passive to true as expected by Chrome for 'touchstart' and 'touchend' events.
    // https://github.com/chartjs/Chart.js/issues/4287
    var eventListenerOptions = supportsEventListenerOptions ? {
        passive: true
    } : false;
    function addListener(node, type, listener) {
        node.addEventListener(type, listener, eventListenerOptions);
    }
    function removeListener(node, type, listener) {
        node.removeEventListener(type, listener, eventListenerOptions);
    }
    function createEvent(type, chart, x, y, nativeEvent) {
        return {
            type: type,
            chart: chart,
            native: nativeEvent || null,
            x: x !== undefined ? x : null,
            y: y !== undefined ? y : null
        };
    }
    function fromNativeEvent(event, chart) {
        var type = EVENT_TYPES[event.type] || event.type;
        var pos = helpers$1.getRelativePosition(event, chart);
        return createEvent(type, chart, pos.x, pos.y, event);
    }
    function throttled(fn, thisArg) {
        var ticking = false;
        var args = [];
        return function() {
            args = Array.prototype.slice.call(arguments);
            thisArg = thisArg || this;
            if (!ticking) {
                ticking = true;
                helpers$1.requestAnimFrame.call(window, function() {
                    ticking = false;
                    fn.apply(thisArg, args);
                });
            }
        };
    }
    function createDiv(cls) {
        var el = document.createElement("div");
        el.className = cls || "";
        return el;
    }
    // Implementation based on https://github.com/marcj/css-element-queries
    function createResizer(handler) {
        var maxSize = 1000000;
        // NOTE(SB) Don't use innerHTML because it could be considered unsafe.
        // https://github.com/chartjs/Chart.js/issues/5902
        var resizer = createDiv(CSS_SIZE_MONITOR);
        var expand = createDiv(CSS_SIZE_MONITOR + "-expand");
        var shrink = createDiv(CSS_SIZE_MONITOR + "-shrink");
        expand.appendChild(createDiv());
        shrink.appendChild(createDiv());
        resizer.appendChild(expand);
        resizer.appendChild(shrink);
        resizer._reset = function() {
            expand.scrollLeft = maxSize;
            expand.scrollTop = maxSize;
            shrink.scrollLeft = maxSize;
            shrink.scrollTop = maxSize;
        };
        var onScroll = function() {
            resizer._reset();
            handler();
        };
        addListener(expand, "scroll", onScroll.bind(expand, "expand"));
        addListener(shrink, "scroll", onScroll.bind(shrink, "shrink"));
        return resizer;
    }
    // https://davidwalsh.name/detect-node-insertion
    function watchForRender(node, handler) {
        var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});
        var proxy = expando.renderProxy = function(e) {
            if (e.animationName === CSS_RENDER_ANIMATION) handler();
        };
        helpers$1.each(ANIMATION_START_EVENTS, function(type) {
            addListener(node, type, proxy);
        });
        // #4737: Chrome might skip the CSS animation when the CSS_RENDER_MONITOR class
        // is removed then added back immediately (same animation frame?). Accessing the
        // `offsetParent` property will force a reflow and re-evaluate the CSS animation.
        // https://gist.github.com/paulirish/5d52fb081b3570c81e3a#box-metrics
        // https://github.com/chartjs/Chart.js/issues/4737
        expando.reflow = !!node.offsetParent;
        node.classList.add(CSS_RENDER_MONITOR);
    }
    function unwatchForRender(node) {
        var expando = node[EXPANDO_KEY] || {};
        var proxy = expando.renderProxy;
        if (proxy) {
            helpers$1.each(ANIMATION_START_EVENTS, function(type) {
                removeListener(node, type, proxy);
            });
            delete expando.renderProxy;
        }
        node.classList.remove(CSS_RENDER_MONITOR);
    }
    function addResizeListener(node, listener, chart) {
        var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});
        // Let's keep track of this added resizer and thus avoid DOM query when removing it.
        var resizer = expando.resizer = createResizer(throttled(function() {
            if (expando.resizer) {
                var container = chart.options.maintainAspectRatio && node.parentNode;
                var w = container ? container.clientWidth : 0;
                listener(createEvent("resize", chart));
                if (container && container.clientWidth < w && chart.canvas) // If the container size shrank during chart resize, let's assume
                // scrollbar appeared. So we resize again with the scrollbar visible -
                // effectively making chart smaller and the scrollbar hidden again.
                // Because we are inside `throttled`, and currently `ticking`, scroll
                // events are ignored during this whole 2 resize process.
                // If we assumed wrong and something else happened, we are resizing
                // twice in a frame (potential performance issue)
                listener(createEvent("resize", chart));
            }
        }));
        // The resizer needs to be attached to the node parent, so we first need to be
        // sure that `node` is attached to the DOM before injecting the resizer element.
        watchForRender(node, function() {
            if (expando.resizer) {
                var container = node.parentNode;
                if (container && container !== resizer.parentNode) container.insertBefore(resizer, container.firstChild);
                // The container size might have changed, let's reset the resizer state.
                resizer._reset();
            }
        });
    }
    function removeResizeListener(node) {
        var expando = node[EXPANDO_KEY] || {};
        var resizer = expando.resizer;
        delete expando.resizer;
        unwatchForRender(node);
        if (resizer && resizer.parentNode) resizer.parentNode.removeChild(resizer);
    }
    /**
 * Injects CSS styles inline if the styles are not already present.
 * @param {HTMLDocument|ShadowRoot} rootNode - the node to contain the <style>.
 * @param {string} css - the CSS to be injected.
 */ function injectCSS(rootNode, css) {
        // https://stackoverflow.com/q/3922139
        var expando = rootNode[EXPANDO_KEY] || (rootNode[EXPANDO_KEY] = {});
        if (!expando.containsStyles) {
            expando.containsStyles = true;
            css = "/* Chart.js */\n" + css;
            var style = document.createElement("style");
            style.setAttribute("type", "text/css");
            style.appendChild(document.createTextNode(css));
            rootNode.appendChild(style);
        }
    }
    var platform_dom$2 = {
        /**
	 * When `true`, prevents the automatic injection of the stylesheet required to
	 * correctly detect when the chart is added to the DOM and then resized. This
	 * switch has been added to allow external stylesheet (`dist/Chart(.min)?.js`)
	 * to be manually imported to make this library compatible with any CSP.
	 * See https://github.com/chartjs/Chart.js/issues/5208
	 */ disableCSSInjection: false,
        /**
	 * This property holds whether this platform is enabled for the current environment.
	 * Currently used by platform.js to select the proper implementation.
	 * @private
	 */ _enabled: typeof window !== "undefined" && typeof document !== "undefined",
        /**
	 * Initializes resources that depend on platform options.
	 * @param {HTMLCanvasElement} canvas - The Canvas element.
	 * @private
	 */ _ensureLoaded: function(canvas) {
            if (!this.disableCSSInjection) {
                // If the canvas is in a shadow DOM, then the styles must also be inserted
                // into the same shadow DOM.
                // https://github.com/chartjs/Chart.js/issues/5763
                var root = canvas.getRootNode ? canvas.getRootNode() : document;
                var targetNode = root.host ? root : document.head;
                injectCSS(targetNode, stylesheet);
            }
        },
        acquireContext: function(item, config) {
            if (typeof item === "string") item = document.getElementById(item);
            else if (item.length) // Support for array based queries (such as jQuery)
            item = item[0];
            if (item && item.canvas) // Support for any object associated to a canvas (including a context2d)
            item = item.canvas;
            // To prevent canvas fingerprinting, some add-ons undefine the getContext
            // method, for example: https://github.com/kkapsner/CanvasBlocker
            // https://github.com/chartjs/Chart.js/issues/2807
            var context = item && item.getContext && item.getContext("2d");
            // `instanceof HTMLCanvasElement/CanvasRenderingContext2D` fails when the item is
            // inside an iframe or when running in a protected environment. We could guess the
            // types from their toString() value but let's keep things flexible and assume it's
            // a sufficient condition if the item has a context2D which has item as `canvas`.
            // https://github.com/chartjs/Chart.js/issues/3887
            // https://github.com/chartjs/Chart.js/issues/4102
            // https://github.com/chartjs/Chart.js/issues/4152
            if (context && context.canvas === item) {
                // Load platform resources on first chart creation, to make it possible to
                // import the library before setting platform options.
                this._ensureLoaded(item);
                initCanvas(item, config);
                return context;
            }
            return null;
        },
        releaseContext: function(context) {
            var canvas = context.canvas;
            if (!canvas[EXPANDO_KEY]) return;
            var initial = canvas[EXPANDO_KEY].initial;
            [
                "height",
                "width"
            ].forEach(function(prop) {
                var value = initial[prop];
                if (helpers$1.isNullOrUndef(value)) canvas.removeAttribute(prop);
                else canvas.setAttribute(prop, value);
            });
            helpers$1.each(initial.style || {}, function(value, key) {
                canvas.style[key] = value;
            });
            // The canvas render size might have been changed (and thus the state stack discarded),
            // we can't use save() and restore() to restore the initial state. So make sure that at
            // least the canvas context is reset to the default state by setting the canvas width.
            // https://www.w3.org/TR/2011/WD-html5-20110525/the-canvas-element.html
            // eslint-disable-next-line no-self-assign
            canvas.width = canvas.width;
            delete canvas[EXPANDO_KEY];
        },
        addEventListener: function(chart, type, listener) {
            var canvas = chart.canvas;
            if (type === "resize") {
                // Note: the resize event is not supported on all browsers.
                addResizeListener(canvas, listener, chart);
                return;
            }
            var expando = listener[EXPANDO_KEY] || (listener[EXPANDO_KEY] = {});
            var proxies = expando.proxies || (expando.proxies = {});
            var proxy = proxies[chart.id + "_" + type] = function(event) {
                listener(fromNativeEvent(event, chart));
            };
            addListener(canvas, type, proxy);
        },
        removeEventListener: function(chart, type, listener) {
            var canvas = chart.canvas;
            if (type === "resize") {
                // Note: the resize event is not supported on all browsers.
                removeResizeListener(canvas);
                return;
            }
            var expando = listener[EXPANDO_KEY] || {};
            var proxies = expando.proxies || {};
            var proxy = proxies[chart.id + "_" + type];
            if (!proxy) return;
            removeListener(canvas, type, proxy);
        }
    };
    // DEPRECATIONS
    /**
 * Provided for backward compatibility, use EventTarget.addEventListener instead.
 * EventTarget.addEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
 * @function Chart.helpers.addEvent
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */ helpers$1.addEvent = addListener;
    /**
 * Provided for backward compatibility, use EventTarget.removeEventListener instead.
 * EventTarget.removeEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/removeEventListener
 * @function Chart.helpers.removeEvent
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */ helpers$1.removeEvent = removeListener;
    // @TODO Make possible to select another platform at build time.
    var implementation = platform_dom$2._enabled ? platform_dom$2 : platform_basic;
    /**
 * @namespace Chart.platform
 * @see https://chartjs.gitbooks.io/proposals/content/Platform.html
 * @since 2.4.0
 */ var platform = helpers$1.extend({
        /**
	 * @since 2.7.0
	 */ initialize: function() {},
        /**
	 * Called at chart construction time, returns a context2d instance implementing
	 * the [W3C Canvas 2D Context API standard]{@link https://www.w3.org/TR/2dcontext/}.
	 * @param {*} item - The native item from which to acquire context (platform specific)
	 * @param {object} options - The chart options
	 * @returns {CanvasRenderingContext2D} context2d instance
	 */ acquireContext: function() {},
        /**
	 * Called at chart destruction time, releases any resources associated to the context
	 * previously returned by the acquireContext() method.
	 * @param {CanvasRenderingContext2D} context - The context2d instance
	 * @returns {boolean} true if the method succeeded, else false
	 */ releaseContext: function() {},
        /**
	 * Registers the specified listener on the given chart.
	 * @param {Chart} chart - Chart from which to listen for event
	 * @param {string} type - The ({@link IEvent}) type to listen for
	 * @param {function} listener - Receives a notification (an object that implements
	 * the {@link IEvent} interface) when an event of the specified type occurs.
	 */ addEventListener: function() {},
        /**
	 * Removes the specified listener previously registered with addEventListener.
	 * @param {Chart} chart - Chart from which to remove the listener
	 * @param {string} type - The ({@link IEvent}) type to remove
	 * @param {function} listener - The listener function to remove from the event target.
	 */ removeEventListener: function() {}
    }, implementation);
    core_defaults._set("global", {
        plugins: {}
    });
    /**
 * The plugin service singleton
 * @namespace Chart.plugins
 * @since 2.1.0
 */ var core_plugins = {
        /**
	 * Globally registered plugins.
	 * @private
	 */ _plugins: [],
        /**
	 * This identifier is used to invalidate the descriptors cache attached to each chart
	 * when a global plugin is registered or unregistered. In this case, the cache ID is
	 * incremented and descriptors are regenerated during following API calls.
	 * @private
	 */ _cacheId: 0,
        /**
	 * Registers the given plugin(s) if not already registered.
	 * @param {IPlugin[]|IPlugin} plugins plugin instance(s).
	 */ register: function(plugins) {
            var p = this._plugins;
            [].concat(plugins).forEach(function(plugin) {
                if (p.indexOf(plugin) === -1) p.push(plugin);
            });
            this._cacheId++;
        },
        /**
	 * Unregisters the given plugin(s) only if registered.
	 * @param {IPlugin[]|IPlugin} plugins plugin instance(s).
	 */ unregister: function(plugins) {
            var p = this._plugins;
            [].concat(plugins).forEach(function(plugin) {
                var idx = p.indexOf(plugin);
                if (idx !== -1) p.splice(idx, 1);
            });
            this._cacheId++;
        },
        /**
	 * Remove all registered plugins.
	 * @since 2.1.5
	 */ clear: function() {
            this._plugins = [];
            this._cacheId++;
        },
        /**
	 * Returns the number of registered plugins?
	 * @returns {number}
	 * @since 2.1.5
	 */ count: function() {
            return this._plugins.length;
        },
        /**
	 * Returns all registered plugin instances.
	 * @returns {IPlugin[]} array of plugin objects.
	 * @since 2.1.5
	 */ getAll: function() {
            return this._plugins;
        },
        /**
	 * Calls enabled plugins for `chart` on the specified hook and with the given args.
	 * This method immediately returns as soon as a plugin explicitly returns false. The
	 * returned value can be used, for instance, to interrupt the current action.
	 * @param {Chart} chart - The chart instance for which plugins should be called.
	 * @param {string} hook - The name of the plugin method to call (e.g. 'beforeUpdate').
	 * @param {Array} [args] - Extra arguments to apply to the hook call.
	 * @returns {boolean} false if any of the plugins return false, else returns true.
	 */ notify: function(chart, hook, args) {
            var descriptors = this.descriptors(chart);
            var ilen = descriptors.length;
            var i, descriptor, plugin, params, method;
            for(i = 0; i < ilen; ++i){
                descriptor = descriptors[i];
                plugin = descriptor.plugin;
                method = plugin[hook];
                if (typeof method === "function") {
                    params = [
                        chart
                    ].concat(args || []);
                    params.push(descriptor.options);
                    if (method.apply(plugin, params) === false) return false;
                }
            }
            return true;
        },
        /**
	 * Returns descriptors of enabled plugins for the given chart.
	 * @returns {object[]} [{ plugin, options }]
	 * @private
	 */ descriptors: function(chart) {
            var cache = chart.$plugins || (chart.$plugins = {});
            if (cache.id === this._cacheId) return cache.descriptors;
            var plugins = [];
            var descriptors = [];
            var config = chart && chart.config || {};
            var options = config.options && config.options.plugins || {};
            this._plugins.concat(config.plugins || []).forEach(function(plugin) {
                var idx = plugins.indexOf(plugin);
                if (idx !== -1) return;
                var id = plugin.id;
                var opts = options[id];
                if (opts === false) return;
                if (opts === true) opts = helpers$1.clone(core_defaults.global.plugins[id]);
                plugins.push(plugin);
                descriptors.push({
                    plugin: plugin,
                    options: opts || {}
                });
            });
            cache.descriptors = descriptors;
            cache.id = this._cacheId;
            return descriptors;
        },
        /**
	 * Invalidates cache for the given chart: descriptors hold a reference on plugin option,
	 * but in some cases, this reference can be changed by the user when updating options.
	 * https://github.com/chartjs/Chart.js/issues/5111#issuecomment-355934167
	 * @private
	 */ _invalidate: function(chart) {
            delete chart.$plugins;
        }
    };
    var core_scaleService = {
        // Scale registration object. Extensions can register new scale types (such as log or DB scales) and then
        // use the new chart options to grab the correct scale
        constructors: {},
        // Use a registration function so that we can move to an ES6 map when we no longer need to support
        // old browsers
        // Scale config defaults
        defaults: {},
        registerScaleType: function(type, scaleConstructor, scaleDefaults) {
            this.constructors[type] = scaleConstructor;
            this.defaults[type] = helpers$1.clone(scaleDefaults);
        },
        getScaleConstructor: function(type) {
            return this.constructors.hasOwnProperty(type) ? this.constructors[type] : undefined;
        },
        getScaleDefaults: function(type) {
            // Return the scale defaults merged with the global settings so that we always use the latest ones
            return this.defaults.hasOwnProperty(type) ? helpers$1.merge(Object.create(null), [
                core_defaults.scale,
                this.defaults[type]
            ]) : {};
        },
        updateScaleDefaults: function(type, additions) {
            var me = this;
            if (me.defaults.hasOwnProperty(type)) me.defaults[type] = helpers$1.extend(me.defaults[type], additions);
        },
        addScalesToLayout: function(chart) {
            // Adds each scale to the chart.boxes array to be sized accordingly
            helpers$1.each(chart.scales, function(scale) {
                // Set ILayoutItem parameters for backwards compatibility
                scale.fullWidth = scale.options.fullWidth;
                scale.position = scale.options.position;
                scale.weight = scale.options.weight;
                core_layouts.addBox(chart, scale);
            });
        }
    };
    var valueOrDefault$8 = helpers$1.valueOrDefault;
    var getRtlHelper = helpers$1.rtl.getRtlAdapter;
    core_defaults._set("global", {
        tooltips: {
            enabled: true,
            custom: null,
            mode: "nearest",
            position: "average",
            intersect: true,
            backgroundColor: "rgba(0,0,0,0.8)",
            titleFontStyle: "bold",
            titleSpacing: 2,
            titleMarginBottom: 6,
            titleFontColor: "#fff",
            titleAlign: "left",
            bodySpacing: 2,
            bodyFontColor: "#fff",
            bodyAlign: "left",
            footerFontStyle: "bold",
            footerSpacing: 2,
            footerMarginTop: 6,
            footerFontColor: "#fff",
            footerAlign: "left",
            yPadding: 6,
            xPadding: 6,
            caretPadding: 2,
            caretSize: 5,
            cornerRadius: 6,
            multiKeyBackground: "#fff",
            displayColors: true,
            borderColor: "rgba(0,0,0,0)",
            borderWidth: 0,
            callbacks: {
                // Args are: (tooltipItems, data)
                beforeTitle: helpers$1.noop,
                title: function(tooltipItems, data) {
                    var title = "";
                    var labels = data.labels;
                    var labelCount = labels ? labels.length : 0;
                    if (tooltipItems.length > 0) {
                        var item = tooltipItems[0];
                        if (item.label) title = item.label;
                        else if (item.xLabel) title = item.xLabel;
                        else if (labelCount > 0 && item.index < labelCount) title = labels[item.index];
                    }
                    return title;
                },
                afterTitle: helpers$1.noop,
                // Args are: (tooltipItems, data)
                beforeBody: helpers$1.noop,
                // Args are: (tooltipItem, data)
                beforeLabel: helpers$1.noop,
                label: function(tooltipItem, data) {
                    var label = data.datasets[tooltipItem.datasetIndex].label || "";
                    if (label) label += ": ";
                    if (!helpers$1.isNullOrUndef(tooltipItem.value)) label += tooltipItem.value;
                    else label += tooltipItem.yLabel;
                    return label;
                },
                labelColor: function(tooltipItem, chart) {
                    var meta = chart.getDatasetMeta(tooltipItem.datasetIndex);
                    var activeElement = meta.data[tooltipItem.index];
                    var view = activeElement._view;
                    return {
                        borderColor: view.borderColor,
                        backgroundColor: view.backgroundColor
                    };
                },
                labelTextColor: function() {
                    return this._options.bodyFontColor;
                },
                afterLabel: helpers$1.noop,
                // Args are: (tooltipItems, data)
                afterBody: helpers$1.noop,
                // Args are: (tooltipItems, data)
                beforeFooter: helpers$1.noop,
                footer: helpers$1.noop,
                afterFooter: helpers$1.noop
            }
        }
    });
    var positioners = {
        /**
	 * Average mode places the tooltip at the average position of the elements shown
	 * @function Chart.Tooltip.positioners.average
	 * @param elements {ChartElement[]} the elements being displayed in the tooltip
	 * @returns {object} tooltip position
	 */ average: function(elements) {
            if (!elements.length) return false;
            var i, len;
            var x = 0;
            var y = 0;
            var count = 0;
            for(i = 0, len = elements.length; i < len; ++i){
                var el = elements[i];
                if (el && el.hasValue()) {
                    var pos = el.tooltipPosition();
                    x += pos.x;
                    y += pos.y;
                    ++count;
                }
            }
            return {
                x: x / count,
                y: y / count
            };
        },
        /**
	 * Gets the tooltip position nearest of the item nearest to the event position
	 * @function Chart.Tooltip.positioners.nearest
	 * @param elements {Chart.Element[]} the tooltip elements
	 * @param eventPosition {object} the position of the event in canvas coordinates
	 * @returns {object} the tooltip position
	 */ nearest: function(elements, eventPosition) {
            var x = eventPosition.x;
            var y = eventPosition.y;
            var minDistance = Number.POSITIVE_INFINITY;
            var i, len, nearestElement;
            for(i = 0, len = elements.length; i < len; ++i){
                var el = elements[i];
                if (el && el.hasValue()) {
                    var center = el.getCenterPoint();
                    var d = helpers$1.distanceBetweenPoints(eventPosition, center);
                    if (d < minDistance) {
                        minDistance = d;
                        nearestElement = el;
                    }
                }
            }
            if (nearestElement) {
                var tp = nearestElement.tooltipPosition();
                x = tp.x;
                y = tp.y;
            }
            return {
                x: x,
                y: y
            };
        }
    };
    // Helper to push or concat based on if the 2nd parameter is an array or not
    function pushOrConcat(base, toPush) {
        if (toPush) {
            if (helpers$1.isArray(toPush)) // base = base.concat(toPush);
            Array.prototype.push.apply(base, toPush);
            else base.push(toPush);
        }
        return base;
    }
    /**
 * Returns array of strings split by newline
 * @param {string} value - The value to split by newline.
 * @returns {string[]} value if newline present - Returned from String split() method
 * @function
 */ function splitNewlines(str) {
        if ((typeof str === "string" || str instanceof String) && str.indexOf("\n") > -1) return str.split("\n");
        return str;
    }
    /**
 * Private helper to create a tooltip item model
 * @param element - the chart element (point, arc, bar) to create the tooltip item for
 * @return new tooltip item
 */ function createTooltipItem(element) {
        var xScale = element._xScale;
        var yScale = element._yScale || element._scale; // handle radar || polarArea charts
        var index = element._index;
        var datasetIndex = element._datasetIndex;
        var controller = element._chart.getDatasetMeta(datasetIndex).controller;
        var indexScale = controller._getIndexScale();
        var valueScale = controller._getValueScale();
        return {
            xLabel: xScale ? xScale.getLabelForIndex(index, datasetIndex) : "",
            yLabel: yScale ? yScale.getLabelForIndex(index, datasetIndex) : "",
            label: indexScale ? "" + indexScale.getLabelForIndex(index, datasetIndex) : "",
            value: valueScale ? "" + valueScale.getLabelForIndex(index, datasetIndex) : "",
            index: index,
            datasetIndex: datasetIndex,
            x: element._model.x,
            y: element._model.y
        };
    }
    /**
 * Helper to get the reset model for the tooltip
 * @param tooltipOpts {object} the tooltip options
 */ function getBaseModel(tooltipOpts) {
        var globalDefaults = core_defaults.global;
        return {
            // Positioning
            xPadding: tooltipOpts.xPadding,
            yPadding: tooltipOpts.yPadding,
            xAlign: tooltipOpts.xAlign,
            yAlign: tooltipOpts.yAlign,
            // Drawing direction and text direction
            rtl: tooltipOpts.rtl,
            textDirection: tooltipOpts.textDirection,
            // Body
            bodyFontColor: tooltipOpts.bodyFontColor,
            _bodyFontFamily: valueOrDefault$8(tooltipOpts.bodyFontFamily, globalDefaults.defaultFontFamily),
            _bodyFontStyle: valueOrDefault$8(tooltipOpts.bodyFontStyle, globalDefaults.defaultFontStyle),
            _bodyAlign: tooltipOpts.bodyAlign,
            bodyFontSize: valueOrDefault$8(tooltipOpts.bodyFontSize, globalDefaults.defaultFontSize),
            bodySpacing: tooltipOpts.bodySpacing,
            // Title
            titleFontColor: tooltipOpts.titleFontColor,
            _titleFontFamily: valueOrDefault$8(tooltipOpts.titleFontFamily, globalDefaults.defaultFontFamily),
            _titleFontStyle: valueOrDefault$8(tooltipOpts.titleFontStyle, globalDefaults.defaultFontStyle),
            titleFontSize: valueOrDefault$8(tooltipOpts.titleFontSize, globalDefaults.defaultFontSize),
            _titleAlign: tooltipOpts.titleAlign,
            titleSpacing: tooltipOpts.titleSpacing,
            titleMarginBottom: tooltipOpts.titleMarginBottom,
            // Footer
            footerFontColor: tooltipOpts.footerFontColor,
            _footerFontFamily: valueOrDefault$8(tooltipOpts.footerFontFamily, globalDefaults.defaultFontFamily),
            _footerFontStyle: valueOrDefault$8(tooltipOpts.footerFontStyle, globalDefaults.defaultFontStyle),
            footerFontSize: valueOrDefault$8(tooltipOpts.footerFontSize, globalDefaults.defaultFontSize),
            _footerAlign: tooltipOpts.footerAlign,
            footerSpacing: tooltipOpts.footerSpacing,
            footerMarginTop: tooltipOpts.footerMarginTop,
            // Appearance
            caretSize: tooltipOpts.caretSize,
            cornerRadius: tooltipOpts.cornerRadius,
            backgroundColor: tooltipOpts.backgroundColor,
            opacity: 0,
            legendColorBackground: tooltipOpts.multiKeyBackground,
            displayColors: tooltipOpts.displayColors,
            borderColor: tooltipOpts.borderColor,
            borderWidth: tooltipOpts.borderWidth
        };
    }
    /**
 * Get the size of the tooltip
 */ function getTooltipSize(tooltip, model) {
        var ctx = tooltip._chart.ctx;
        var height = model.yPadding * 2; // Tooltip Padding
        var width = 0;
        // Count of all lines in the body
        var body = model.body;
        var combinedBodyLength = body.reduce(function(count, bodyItem) {
            return count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length;
        }, 0);
        combinedBodyLength += model.beforeBody.length + model.afterBody.length;
        var titleLineCount = model.title.length;
        var footerLineCount = model.footer.length;
        var titleFontSize = model.titleFontSize;
        var bodyFontSize = model.bodyFontSize;
        var footerFontSize = model.footerFontSize;
        height += titleLineCount * titleFontSize; // Title Lines
        height += titleLineCount ? (titleLineCount - 1) * model.titleSpacing : 0; // Title Line Spacing
        height += titleLineCount ? model.titleMarginBottom : 0; // Title's bottom Margin
        height += combinedBodyLength * bodyFontSize; // Body Lines
        height += combinedBodyLength ? (combinedBodyLength - 1) * model.bodySpacing : 0; // Body Line Spacing
        height += footerLineCount ? model.footerMarginTop : 0; // Footer Margin
        height += footerLineCount * footerFontSize; // Footer Lines
        height += footerLineCount ? (footerLineCount - 1) * model.footerSpacing : 0; // Footer Line Spacing
        // Title width
        var widthPadding = 0;
        var maxLineWidth = function(line) {
            width = Math.max(width, ctx.measureText(line).width + widthPadding);
        };
        ctx.font = helpers$1.fontString(titleFontSize, model._titleFontStyle, model._titleFontFamily);
        helpers$1.each(model.title, maxLineWidth);
        // Body width
        ctx.font = helpers$1.fontString(bodyFontSize, model._bodyFontStyle, model._bodyFontFamily);
        helpers$1.each(model.beforeBody.concat(model.afterBody), maxLineWidth);
        // Body lines may include some extra width due to the color box
        widthPadding = model.displayColors ? bodyFontSize + 2 : 0;
        helpers$1.each(body, function(bodyItem) {
            helpers$1.each(bodyItem.before, maxLineWidth);
            helpers$1.each(bodyItem.lines, maxLineWidth);
            helpers$1.each(bodyItem.after, maxLineWidth);
        });
        // Reset back to 0
        widthPadding = 0;
        // Footer width
        ctx.font = helpers$1.fontString(footerFontSize, model._footerFontStyle, model._footerFontFamily);
        helpers$1.each(model.footer, maxLineWidth);
        // Add padding
        width += 2 * model.xPadding;
        return {
            width: width,
            height: height
        };
    }
    /**
 * Helper to get the alignment of a tooltip given the size
 */ function determineAlignment(tooltip, size) {
        var model = tooltip._model;
        var chart = tooltip._chart;
        var chartArea = tooltip._chart.chartArea;
        var xAlign = "center";
        var yAlign = "center";
        if (model.y < size.height) yAlign = "top";
        else if (model.y > chart.height - size.height) yAlign = "bottom";
        var lf, rf; // functions to determine left, right alignment
        var olf, orf; // functions to determine if left/right alignment causes tooltip to go outside chart
        var yf; // function to get the y alignment if the tooltip goes outside of the left or right edges
        var midX = (chartArea.left + chartArea.right) / 2;
        var midY = (chartArea.top + chartArea.bottom) / 2;
        if (yAlign === "center") {
            lf = function(x) {
                return x <= midX;
            };
            rf = function(x) {
                return x > midX;
            };
        } else {
            lf = function(x) {
                return x <= size.width / 2;
            };
            rf = function(x) {
                return x >= chart.width - size.width / 2;
            };
        }
        olf = function(x) {
            return x + size.width + model.caretSize + model.caretPadding > chart.width;
        };
        orf = function(x) {
            return x - size.width - model.caretSize - model.caretPadding < 0;
        };
        yf = function(y) {
            return y <= midY ? "top" : "bottom";
        };
        if (lf(model.x)) {
            xAlign = "left";
            // Is tooltip too wide and goes over the right side of the chart.?
            if (olf(model.x)) {
                xAlign = "center";
                yAlign = yf(model.y);
            }
        } else if (rf(model.x)) {
            xAlign = "right";
            // Is tooltip too wide and goes outside left edge of canvas?
            if (orf(model.x)) {
                xAlign = "center";
                yAlign = yf(model.y);
            }
        }
        var opts = tooltip._options;
        return {
            xAlign: opts.xAlign ? opts.xAlign : xAlign,
            yAlign: opts.yAlign ? opts.yAlign : yAlign
        };
    }
    /**
 * Helper to get the location a tooltip needs to be placed at given the initial position (via the vm) and the size and alignment
 */ function getBackgroundPoint(vm, size, alignment, chart) {
        // Background Position
        var x = vm.x;
        var y = vm.y;
        var caretSize = vm.caretSize;
        var caretPadding = vm.caretPadding;
        var cornerRadius = vm.cornerRadius;
        var xAlign = alignment.xAlign;
        var yAlign = alignment.yAlign;
        var paddingAndSize = caretSize + caretPadding;
        var radiusAndPadding = cornerRadius + caretPadding;
        if (xAlign === "right") x -= size.width;
        else if (xAlign === "center") {
            x -= size.width / 2;
            if (x + size.width > chart.width) x = chart.width - size.width;
            if (x < 0) x = 0;
        }
        if (yAlign === "top") y += paddingAndSize;
        else if (yAlign === "bottom") y -= size.height + paddingAndSize;
        else y -= size.height / 2;
        if (yAlign === "center") {
            if (xAlign === "left") x += paddingAndSize;
            else if (xAlign === "right") x -= paddingAndSize;
        } else if (xAlign === "left") x -= radiusAndPadding;
        else if (xAlign === "right") x += radiusAndPadding;
        return {
            x: x,
            y: y
        };
    }
    function getAlignedX(vm, align) {
        return align === "center" ? vm.x + vm.width / 2 : align === "right" ? vm.x + vm.width - vm.xPadding : vm.x + vm.xPadding;
    }
    /**
 * Helper to build before and after body lines
 */ function getBeforeAfterBodyLines(callback) {
        return pushOrConcat([], splitNewlines(callback));
    }
    var exports$4 = core_element.extend({
        initialize: function() {
            this._model = getBaseModel(this._options);
            this._lastActive = [];
        },
        // Get the title
        // Args are: (tooltipItem, data)
        getTitle: function() {
            var me = this;
            var opts = me._options;
            var callbacks = opts.callbacks;
            var beforeTitle = callbacks.beforeTitle.apply(me, arguments);
            var title = callbacks.title.apply(me, arguments);
            var afterTitle = callbacks.afterTitle.apply(me, arguments);
            var lines = [];
            lines = pushOrConcat(lines, splitNewlines(beforeTitle));
            lines = pushOrConcat(lines, splitNewlines(title));
            lines = pushOrConcat(lines, splitNewlines(afterTitle));
            return lines;
        },
        // Args are: (tooltipItem, data)
        getBeforeBody: function() {
            return getBeforeAfterBodyLines(this._options.callbacks.beforeBody.apply(this, arguments));
        },
        // Args are: (tooltipItem, data)
        getBody: function(tooltipItems, data) {
            var me = this;
            var callbacks = me._options.callbacks;
            var bodyItems = [];
            helpers$1.each(tooltipItems, function(tooltipItem) {
                var bodyItem = {
                    before: [],
                    lines: [],
                    after: []
                };
                pushOrConcat(bodyItem.before, splitNewlines(callbacks.beforeLabel.call(me, tooltipItem, data)));
                pushOrConcat(bodyItem.lines, callbacks.label.call(me, tooltipItem, data));
                pushOrConcat(bodyItem.after, splitNewlines(callbacks.afterLabel.call(me, tooltipItem, data)));
                bodyItems.push(bodyItem);
            });
            return bodyItems;
        },
        // Args are: (tooltipItem, data)
        getAfterBody: function() {
            return getBeforeAfterBodyLines(this._options.callbacks.afterBody.apply(this, arguments));
        },
        // Get the footer and beforeFooter and afterFooter lines
        // Args are: (tooltipItem, data)
        getFooter: function() {
            var me = this;
            var callbacks = me._options.callbacks;
            var beforeFooter = callbacks.beforeFooter.apply(me, arguments);
            var footer = callbacks.footer.apply(me, arguments);
            var afterFooter = callbacks.afterFooter.apply(me, arguments);
            var lines = [];
            lines = pushOrConcat(lines, splitNewlines(beforeFooter));
            lines = pushOrConcat(lines, splitNewlines(footer));
            lines = pushOrConcat(lines, splitNewlines(afterFooter));
            return lines;
        },
        update: function(changed) {
            var me = this;
            var opts = me._options;
            // Need to regenerate the model because its faster than using extend and it is necessary due to the optimization in Chart.Element.transition
            // that does _view = _model if ease === 1. This causes the 2nd tooltip update to set properties in both the view and model at the same time
            // which breaks any animations.
            var existingModel = me._model;
            var model = me._model = getBaseModel(opts);
            var active = me._active;
            var data = me._data;
            // In the case where active.length === 0 we need to keep these at existing values for good animations
            var alignment = {
                xAlign: existingModel.xAlign,
                yAlign: existingModel.yAlign
            };
            var backgroundPoint = {
                x: existingModel.x,
                y: existingModel.y
            };
            var tooltipSize = {
                width: existingModel.width,
                height: existingModel.height
            };
            var tooltipPosition = {
                x: existingModel.caretX,
                y: existingModel.caretY
            };
            var i, len;
            if (active.length) {
                model.opacity = 1;
                var labelColors = [];
                var labelTextColors = [];
                tooltipPosition = positioners[opts.position].call(me, active, me._eventPosition);
                var tooltipItems = [];
                for(i = 0, len = active.length; i < len; ++i)tooltipItems.push(createTooltipItem(active[i]));
                // If the user provided a filter function, use it to modify the tooltip items
                if (opts.filter) tooltipItems = tooltipItems.filter(function(a) {
                    return opts.filter(a, data);
                });
                // If the user provided a sorting function, use it to modify the tooltip items
                if (opts.itemSort) tooltipItems = tooltipItems.sort(function(a, b) {
                    return opts.itemSort(a, b, data);
                });
                // Determine colors for boxes
                helpers$1.each(tooltipItems, function(tooltipItem) {
                    labelColors.push(opts.callbacks.labelColor.call(me, tooltipItem, me._chart));
                    labelTextColors.push(opts.callbacks.labelTextColor.call(me, tooltipItem, me._chart));
                });
                // Build the Text Lines
                model.title = me.getTitle(tooltipItems, data);
                model.beforeBody = me.getBeforeBody(tooltipItems, data);
                model.body = me.getBody(tooltipItems, data);
                model.afterBody = me.getAfterBody(tooltipItems, data);
                model.footer = me.getFooter(tooltipItems, data);
                // Initial positioning and colors
                model.x = tooltipPosition.x;
                model.y = tooltipPosition.y;
                model.caretPadding = opts.caretPadding;
                model.labelColors = labelColors;
                model.labelTextColors = labelTextColors;
                // data points
                model.dataPoints = tooltipItems;
                // We need to determine alignment of the tooltip
                tooltipSize = getTooltipSize(this, model);
                alignment = determineAlignment(this, tooltipSize);
                // Final Size and Position
                backgroundPoint = getBackgroundPoint(model, tooltipSize, alignment, me._chart);
            } else model.opacity = 0;
            model.xAlign = alignment.xAlign;
            model.yAlign = alignment.yAlign;
            model.x = backgroundPoint.x;
            model.y = backgroundPoint.y;
            model.width = tooltipSize.width;
            model.height = tooltipSize.height;
            // Point where the caret on the tooltip points to
            model.caretX = tooltipPosition.x;
            model.caretY = tooltipPosition.y;
            me._model = model;
            if (changed && opts.custom) opts.custom.call(me, model);
            return me;
        },
        drawCaret: function(tooltipPoint, size) {
            var ctx = this._chart.ctx;
            var vm = this._view;
            var caretPosition = this.getCaretPosition(tooltipPoint, size, vm);
            ctx.lineTo(caretPosition.x1, caretPosition.y1);
            ctx.lineTo(caretPosition.x2, caretPosition.y2);
            ctx.lineTo(caretPosition.x3, caretPosition.y3);
        },
        getCaretPosition: function(tooltipPoint, size, vm) {
            var x1, x2, x3, y1, y2, y3;
            var caretSize = vm.caretSize;
            var cornerRadius = vm.cornerRadius;
            var xAlign = vm.xAlign;
            var yAlign = vm.yAlign;
            var ptX = tooltipPoint.x;
            var ptY = tooltipPoint.y;
            var width = size.width;
            var height = size.height;
            if (yAlign === "center") {
                y2 = ptY + height / 2;
                if (xAlign === "left") {
                    x1 = ptX;
                    x2 = x1 - caretSize;
                    x3 = x1;
                    y1 = y2 + caretSize;
                    y3 = y2 - caretSize;
                } else {
                    x1 = ptX + width;
                    x2 = x1 + caretSize;
                    x3 = x1;
                    y1 = y2 - caretSize;
                    y3 = y2 + caretSize;
                }
            } else {
                if (xAlign === "left") {
                    x2 = ptX + cornerRadius + caretSize;
                    x1 = x2 - caretSize;
                    x3 = x2 + caretSize;
                } else if (xAlign === "right") {
                    x2 = ptX + width - cornerRadius - caretSize;
                    x1 = x2 - caretSize;
                    x3 = x2 + caretSize;
                } else {
                    x2 = vm.caretX;
                    x1 = x2 - caretSize;
                    x3 = x2 + caretSize;
                }
                if (yAlign === "top") {
                    y1 = ptY;
                    y2 = y1 - caretSize;
                    y3 = y1;
                } else {
                    y1 = ptY + height;
                    y2 = y1 + caretSize;
                    y3 = y1;
                    // invert drawing order
                    var tmp = x3;
                    x3 = x1;
                    x1 = tmp;
                }
            }
            return {
                x1: x1,
                x2: x2,
                x3: x3,
                y1: y1,
                y2: y2,
                y3: y3
            };
        },
        drawTitle: function(pt, vm, ctx) {
            var title = vm.title;
            var length = title.length;
            var titleFontSize, titleSpacing, i;
            if (length) {
                var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);
                pt.x = getAlignedX(vm, vm._titleAlign);
                ctx.textAlign = rtlHelper.textAlign(vm._titleAlign);
                ctx.textBaseline = "middle";
                titleFontSize = vm.titleFontSize;
                titleSpacing = vm.titleSpacing;
                ctx.fillStyle = vm.titleFontColor;
                ctx.font = helpers$1.fontString(titleFontSize, vm._titleFontStyle, vm._titleFontFamily);
                for(i = 0; i < length; ++i){
                    ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFontSize / 2);
                    pt.y += titleFontSize + titleSpacing; // Line Height and spacing
                    if (i + 1 === length) pt.y += vm.titleMarginBottom - titleSpacing; // If Last, add margin, remove spacing
                }
            }
        },
        drawBody: function(pt, vm, ctx) {
            var bodyFontSize = vm.bodyFontSize;
            var bodySpacing = vm.bodySpacing;
            var bodyAlign = vm._bodyAlign;
            var body = vm.body;
            var drawColorBoxes = vm.displayColors;
            var xLinePadding = 0;
            var colorX = drawColorBoxes ? getAlignedX(vm, "left") : 0;
            var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);
            var fillLineOfText = function(line) {
                ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyFontSize / 2);
                pt.y += bodyFontSize + bodySpacing;
            };
            var bodyItem, textColor, labelColors, lines, i, j, ilen, jlen;
            var bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);
            ctx.textAlign = bodyAlign;
            ctx.textBaseline = "middle";
            ctx.font = helpers$1.fontString(bodyFontSize, vm._bodyFontStyle, vm._bodyFontFamily);
            pt.x = getAlignedX(vm, bodyAlignForCalculation);
            // Before body lines
            ctx.fillStyle = vm.bodyFontColor;
            helpers$1.each(vm.beforeBody, fillLineOfText);
            xLinePadding = drawColorBoxes && bodyAlignForCalculation !== "right" ? bodyAlign === "center" ? bodyFontSize / 2 + 1 : bodyFontSize + 2 : 0;
            // Draw body lines now
            for(i = 0, ilen = body.length; i < ilen; ++i){
                bodyItem = body[i];
                textColor = vm.labelTextColors[i];
                labelColors = vm.labelColors[i];
                ctx.fillStyle = textColor;
                helpers$1.each(bodyItem.before, fillLineOfText);
                lines = bodyItem.lines;
                for(j = 0, jlen = lines.length; j < jlen; ++j){
                    // Draw Legend-like boxes if needed
                    if (drawColorBoxes) {
                        var rtlColorX = rtlHelper.x(colorX);
                        // Fill a white rect so that colours merge nicely if the opacity is < 1
                        ctx.fillStyle = vm.legendColorBackground;
                        ctx.fillRect(rtlHelper.leftForLtr(rtlColorX, bodyFontSize), pt.y, bodyFontSize, bodyFontSize);
                        // Border
                        ctx.lineWidth = 1;
                        ctx.strokeStyle = labelColors.borderColor;
                        ctx.strokeRect(rtlHelper.leftForLtr(rtlColorX, bodyFontSize), pt.y, bodyFontSize, bodyFontSize);
                        // Inner square
                        ctx.fillStyle = labelColors.backgroundColor;
                        ctx.fillRect(rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), bodyFontSize - 2), pt.y + 1, bodyFontSize - 2, bodyFontSize - 2);
                        ctx.fillStyle = textColor;
                    }
                    fillLineOfText(lines[j]);
                }
                helpers$1.each(bodyItem.after, fillLineOfText);
            }
            // Reset back to 0 for after body
            xLinePadding = 0;
            // After body lines
            helpers$1.each(vm.afterBody, fillLineOfText);
            pt.y -= bodySpacing; // Remove last body spacing
        },
        drawFooter: function(pt, vm, ctx) {
            var footer = vm.footer;
            var length = footer.length;
            var footerFontSize, i;
            if (length) {
                var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);
                pt.x = getAlignedX(vm, vm._footerAlign);
                pt.y += vm.footerMarginTop;
                ctx.textAlign = rtlHelper.textAlign(vm._footerAlign);
                ctx.textBaseline = "middle";
                footerFontSize = vm.footerFontSize;
                ctx.fillStyle = vm.footerFontColor;
                ctx.font = helpers$1.fontString(footerFontSize, vm._footerFontStyle, vm._footerFontFamily);
                for(i = 0; i < length; ++i){
                    ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFontSize / 2);
                    pt.y += footerFontSize + vm.footerSpacing;
                }
            }
        },
        drawBackground: function(pt, vm, ctx, tooltipSize) {
            ctx.fillStyle = vm.backgroundColor;
            ctx.strokeStyle = vm.borderColor;
            ctx.lineWidth = vm.borderWidth;
            var xAlign = vm.xAlign;
            var yAlign = vm.yAlign;
            var x = pt.x;
            var y = pt.y;
            var width = tooltipSize.width;
            var height = tooltipSize.height;
            var radius = vm.cornerRadius;
            ctx.beginPath();
            ctx.moveTo(x + radius, y);
            if (yAlign === "top") this.drawCaret(pt, tooltipSize);
            ctx.lineTo(x + width - radius, y);
            ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
            if (yAlign === "center" && xAlign === "right") this.drawCaret(pt, tooltipSize);
            ctx.lineTo(x + width, y + height - radius);
            ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
            if (yAlign === "bottom") this.drawCaret(pt, tooltipSize);
            ctx.lineTo(x + radius, y + height);
            ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
            if (yAlign === "center" && xAlign === "left") this.drawCaret(pt, tooltipSize);
            ctx.lineTo(x, y + radius);
            ctx.quadraticCurveTo(x, y, x + radius, y);
            ctx.closePath();
            ctx.fill();
            if (vm.borderWidth > 0) ctx.stroke();
        },
        draw: function() {
            var ctx = this._chart.ctx;
            var vm = this._view;
            if (vm.opacity === 0) return;
            var tooltipSize = {
                width: vm.width,
                height: vm.height
            };
            var pt = {
                x: vm.x,
                y: vm.y
            };
            // IE11/Edge does not like very small opacities, so snap to 0
            var opacity = Math.abs(vm.opacity < 1e-3) ? 0 : vm.opacity;
            // Truthy/falsey value for empty tooltip
            var hasTooltipContent = vm.title.length || vm.beforeBody.length || vm.body.length || vm.afterBody.length || vm.footer.length;
            if (this._options.enabled && hasTooltipContent) {
                ctx.save();
                ctx.globalAlpha = opacity;
                // Draw Background
                this.drawBackground(pt, vm, ctx, tooltipSize);
                // Draw Title, Body, and Footer
                pt.y += vm.yPadding;
                helpers$1.rtl.overrideTextDirection(ctx, vm.textDirection);
                // Titles
                this.drawTitle(pt, vm, ctx);
                // Body
                this.drawBody(pt, vm, ctx);
                // Footer
                this.drawFooter(pt, vm, ctx);
                helpers$1.rtl.restoreTextDirection(ctx, vm.textDirection);
                ctx.restore();
            }
        },
        /**
	 * Handle an event
	 * @private
	 * @param {IEvent} event - The event to handle
	 * @returns {boolean} true if the tooltip changed
	 */ handleEvent: function(e) {
            var me = this;
            var options = me._options;
            var changed = false;
            me._lastActive = me._lastActive || [];
            // Find Active Elements for tooltips
            if (e.type === "mouseout") me._active = [];
            else {
                me._active = me._chart.getElementsAtEventForMode(e, options.mode, options);
                if (options.reverse) me._active.reverse();
            }
            // Remember Last Actives
            changed = !helpers$1.arrayEquals(me._active, me._lastActive);
            // Only handle target event on tooltip change
            if (changed) {
                me._lastActive = me._active;
                if (options.enabled || options.custom) {
                    me._eventPosition = {
                        x: e.x,
                        y: e.y
                    };
                    me.update(true);
                    me.pivot();
                }
            }
            return changed;
        }
    });
    /**
 * @namespace Chart.Tooltip.positioners
 */ var positioners_1 = positioners;
    var core_tooltip = exports$4;
    core_tooltip.positioners = positioners_1;
    var valueOrDefault$9 = helpers$1.valueOrDefault;
    core_defaults._set("global", {
        elements: {},
        events: [
            "mousemove",
            "mouseout",
            "click",
            "touchstart",
            "touchmove"
        ],
        hover: {
            onHover: null,
            mode: "nearest",
            intersect: true,
            animationDuration: 400
        },
        onClick: null,
        maintainAspectRatio: true,
        responsive: true,
        responsiveAnimationDuration: 0
    });
    /**
 * Recursively merge the given config objects representing the `scales` option
 * by incorporating scale defaults in `xAxes` and `yAxes` array items, then
 * returns a deep copy of the result, thus doesn't alter inputs.
 */ function mergeScaleConfig() {
        return helpers$1.merge(Object.create(null), [].slice.call(arguments), {
            merger: function(key, target, source, options) {
                if (key === "xAxes" || key === "yAxes") {
                    var slen = source[key].length;
                    var i, type, scale;
                    if (!target[key]) target[key] = [];
                    for(i = 0; i < slen; ++i){
                        scale = source[key][i];
                        type = valueOrDefault$9(scale.type, key === "xAxes" ? "category" : "linear");
                        if (i >= target[key].length) target[key].push({});
                        if (!target[key][i].type || scale.type && scale.type !== target[key][i].type) // new/untyped scale or type changed: let's apply the new defaults
                        // then merge source scale to correctly overwrite the defaults.
                        helpers$1.merge(target[key][i], [
                            core_scaleService.getScaleDefaults(type),
                            scale
                        ]);
                        else // scales type are the same
                        helpers$1.merge(target[key][i], scale);
                    }
                } else helpers$1._merger(key, target, source, options);
            }
        });
    }
    /**
 * Recursively merge the given config objects as the root options by handling
 * default scale options for the `scales` and `scale` properties, then returns
 * a deep copy of the result, thus doesn't alter inputs.
 */ function mergeConfig() {
        return helpers$1.merge(Object.create(null), [].slice.call(arguments), {
            merger: function(key, target, source, options) {
                var tval = target[key] || Object.create(null);
                var sval = source[key];
                if (key === "scales") // scale config merging is complex. Add our own function here for that
                target[key] = mergeScaleConfig(tval, sval);
                else if (key === "scale") // used in polar area & radar charts since there is only one scale
                target[key] = helpers$1.merge(tval, [
                    core_scaleService.getScaleDefaults(sval.type),
                    sval
                ]);
                else helpers$1._merger(key, target, source, options);
            }
        });
    }
    function initConfig(config) {
        config = config || Object.create(null);
        // Do NOT use mergeConfig for the data object because this method merges arrays
        // and so would change references to labels and datasets, preventing data updates.
        var data = config.data = config.data || {};
        data.datasets = data.datasets || [];
        data.labels = data.labels || [];
        config.options = mergeConfig(core_defaults.global, core_defaults[config.type], config.options || {});
        return config;
    }
    function updateConfig(chart) {
        var newOptions = chart.options;
        helpers$1.each(chart.scales, function(scale) {
            core_layouts.removeBox(chart, scale);
        });
        newOptions = mergeConfig(core_defaults.global, core_defaults[chart.config.type], newOptions);
        chart.options = chart.config.options = newOptions;
        chart.ensureScalesHaveIDs();
        chart.buildOrUpdateScales();
        // Tooltip
        chart.tooltip._options = newOptions.tooltips;
        chart.tooltip.initialize();
    }
    function nextAvailableScaleId(axesOpts, prefix, index) {
        var id;
        var hasId = function(obj) {
            return obj.id === id;
        };
        do id = prefix + index++;
        while (helpers$1.findIndex(axesOpts, hasId) >= 0);
        return id;
    }
    function positionIsHorizontal(position) {
        return position === "top" || position === "bottom";
    }
    function compare2Level(l1, l2) {
        return function(a, b) {
            return a[l1] === b[l1] ? a[l2] - b[l2] : a[l1] - b[l1];
        };
    }
    var Chart = function(item, config) {
        this.construct(item, config);
        return this;
    };
    helpers$1.extend(Chart.prototype, /** @lends Chart */ {
        /**
	 * @private
	 */ construct: function(item, config) {
            var me = this;
            config = initConfig(config);
            var context = platform.acquireContext(item, config);
            var canvas = context && context.canvas;
            var height = canvas && canvas.height;
            var width = canvas && canvas.width;
            me.id = helpers$1.uid();
            me.ctx = context;
            me.canvas = canvas;
            me.config = config;
            me.width = width;
            me.height = height;
            me.aspectRatio = height ? width / height : null;
            me.options = config.options;
            me._bufferedRender = false;
            me._layers = [];
            /**
		 * Provided for backward compatibility, Chart and Chart.Controller have been merged,
		 * the "instance" still need to be defined since it might be called from plugins.
		 * @prop Chart#chart
		 * @deprecated since version 2.6.0
		 * @todo remove at version 3
		 * @private
		 */ me.chart = me;
            me.controller = me; // chart.chart.controller #inception
            // Add the chart instance to the global namespace
            Chart.instances[me.id] = me;
            // Define alias to the config data: `chart.data === chart.config.data`
            Object.defineProperty(me, "data", {
                get: function() {
                    return me.config.data;
                },
                set: function(value) {
                    me.config.data = value;
                }
            });
            if (!context || !canvas) {
                // The given item is not a compatible context2d element, let's return before finalizing
                // the chart initialization but after setting basic chart / controller properties that
                // can help to figure out that the chart is not valid (e.g chart.canvas !== null);
                // https://github.com/chartjs/Chart.js/issues/2807
                console.error("Failed to create chart: can't acquire context from the given item");
                return;
            }
            me.initialize();
            me.update();
        },
        /**
	 * @private
	 */ initialize: function() {
            var me = this;
            // Before init plugin notification
            core_plugins.notify(me, "beforeInit");
            helpers$1.retinaScale(me, me.options.devicePixelRatio);
            me.bindEvents();
            if (me.options.responsive) // Initial resize before chart draws (must be silent to preserve initial animations).
            me.resize(true);
            me.initToolTip();
            // After init plugin notification
            core_plugins.notify(me, "afterInit");
            return me;
        },
        clear: function() {
            helpers$1.canvas.clear(this);
            return this;
        },
        stop: function() {
            // Stops any current animation loop occurring
            core_animations.cancelAnimation(this);
            return this;
        },
        resize: function(silent) {
            var me = this;
            var options = me.options;
            var canvas = me.canvas;
            var aspectRatio = options.maintainAspectRatio && me.aspectRatio || null;
            // the canvas render width and height will be casted to integers so make sure that
            // the canvas display style uses the same integer values to avoid blurring effect.
            // Set to 0 instead of canvas.size because the size defaults to 300x150 if the element is collapsed
            var newWidth = Math.max(0, Math.floor(helpers$1.getMaximumWidth(canvas)));
            var newHeight = Math.max(0, Math.floor(aspectRatio ? newWidth / aspectRatio : helpers$1.getMaximumHeight(canvas)));
            if (me.width === newWidth && me.height === newHeight) return;
            canvas.width = me.width = newWidth;
            canvas.height = me.height = newHeight;
            canvas.style.width = newWidth + "px";
            canvas.style.height = newHeight + "px";
            helpers$1.retinaScale(me, options.devicePixelRatio);
            if (!silent) {
                // Notify any plugins about the resize
                var newSize = {
                    width: newWidth,
                    height: newHeight
                };
                core_plugins.notify(me, "resize", [
                    newSize
                ]);
                // Notify of resize
                if (options.onResize) options.onResize(me, newSize);
                me.stop();
                me.update({
                    duration: options.responsiveAnimationDuration
                });
            }
        },
        ensureScalesHaveIDs: function() {
            var options = this.options;
            var scalesOptions = options.scales || {};
            var scaleOptions = options.scale;
            helpers$1.each(scalesOptions.xAxes, function(xAxisOptions, index) {
                if (!xAxisOptions.id) xAxisOptions.id = nextAvailableScaleId(scalesOptions.xAxes, "x-axis-", index);
            });
            helpers$1.each(scalesOptions.yAxes, function(yAxisOptions, index) {
                if (!yAxisOptions.id) yAxisOptions.id = nextAvailableScaleId(scalesOptions.yAxes, "y-axis-", index);
            });
            if (scaleOptions) scaleOptions.id = scaleOptions.id || "scale";
        },
        /**
	 * Builds a map of scale ID to scale object for future lookup.
	 */ buildOrUpdateScales: function() {
            var me = this;
            var options = me.options;
            var scales = me.scales || {};
            var items = [];
            var updated = Object.keys(scales).reduce(function(obj, id) {
                obj[id] = false;
                return obj;
            }, {});
            if (options.scales) items = items.concat((options.scales.xAxes || []).map(function(xAxisOptions) {
                return {
                    options: xAxisOptions,
                    dtype: "category",
                    dposition: "bottom"
                };
            }), (options.scales.yAxes || []).map(function(yAxisOptions) {
                return {
                    options: yAxisOptions,
                    dtype: "linear",
                    dposition: "left"
                };
            }));
            if (options.scale) items.push({
                options: options.scale,
                dtype: "radialLinear",
                isDefault: true,
                dposition: "chartArea"
            });
            helpers$1.each(items, function(item) {
                var scaleOptions = item.options;
                var id = scaleOptions.id;
                var scaleType = valueOrDefault$9(scaleOptions.type, item.dtype);
                if (positionIsHorizontal(scaleOptions.position) !== positionIsHorizontal(item.dposition)) scaleOptions.position = item.dposition;
                updated[id] = true;
                var scale = null;
                if (id in scales && scales[id].type === scaleType) {
                    scale = scales[id];
                    scale.options = scaleOptions;
                    scale.ctx = me.ctx;
                    scale.chart = me;
                } else {
                    var scaleClass = core_scaleService.getScaleConstructor(scaleType);
                    if (!scaleClass) return;
                    scale = new scaleClass({
                        id: id,
                        type: scaleType,
                        options: scaleOptions,
                        ctx: me.ctx,
                        chart: me
                    });
                    scales[scale.id] = scale;
                }
                scale.mergeTicksOptions();
                // TODO(SB): I think we should be able to remove this custom case (options.scale)
                // and consider it as a regular scale part of the "scales"" map only! This would
                // make the logic easier and remove some useless? custom code.
                if (item.isDefault) me.scale = scale;
            });
            // clear up discarded scales
            helpers$1.each(updated, function(hasUpdated, id) {
                if (!hasUpdated) delete scales[id];
            });
            me.scales = scales;
            core_scaleService.addScalesToLayout(this);
        },
        buildOrUpdateControllers: function() {
            var me = this;
            var newControllers = [];
            var datasets = me.data.datasets;
            var i, ilen;
            for(i = 0, ilen = datasets.length; i < ilen; i++){
                var dataset = datasets[i];
                var meta = me.getDatasetMeta(i);
                var type = dataset.type || me.config.type;
                if (meta.type && meta.type !== type) {
                    me.destroyDatasetMeta(i);
                    meta = me.getDatasetMeta(i);
                }
                meta.type = type;
                meta.order = dataset.order || 0;
                meta.index = i;
                if (meta.controller) {
                    meta.controller.updateIndex(i);
                    meta.controller.linkScales();
                } else {
                    var ControllerClass = controllers[meta.type];
                    if (ControllerClass === undefined) throw new Error('"' + meta.type + '" is not a chart type.');
                    meta.controller = new ControllerClass(me, i);
                    newControllers.push(meta.controller);
                }
            }
            return newControllers;
        },
        /**
	 * Reset the elements of all datasets
	 * @private
	 */ resetElements: function() {
            var me = this;
            helpers$1.each(me.data.datasets, function(dataset, datasetIndex) {
                me.getDatasetMeta(datasetIndex).controller.reset();
            }, me);
        },
        /**
	* Resets the chart back to it's state before the initial animation
	*/ reset: function() {
            this.resetElements();
            this.tooltip.initialize();
        },
        update: function(config) {
            var me = this;
            var i, ilen;
            if (!config || typeof config !== "object") // backwards compatibility
            config = {
                duration: config,
                lazy: arguments[1]
            };
            updateConfig(me);
            // plugins options references might have change, let's invalidate the cache
            // https://github.com/chartjs/Chart.js/issues/5111#issuecomment-355934167
            core_plugins._invalidate(me);
            if (core_plugins.notify(me, "beforeUpdate") === false) return;
            // In case the entire data object changed
            me.tooltip._data = me.data;
            // Make sure dataset controllers are updated and new controllers are reset
            var newControllers = me.buildOrUpdateControllers();
            // Make sure all dataset controllers have correct meta data counts
            for(i = 0, ilen = me.data.datasets.length; i < ilen; i++)me.getDatasetMeta(i).controller.buildOrUpdateElements();
            me.updateLayout();
            // Can only reset the new controllers after the scales have been updated
            if (me.options.animation && me.options.animation.duration) helpers$1.each(newControllers, function(controller) {
                controller.reset();
            });
            me.updateDatasets();
            // Need to reset tooltip in case it is displayed with elements that are removed
            // after update.
            me.tooltip.initialize();
            // Last active contains items that were previously in the tooltip.
            // When we reset the tooltip, we need to clear it
            me.lastActive = [];
            // Do this before render so that any plugins that need final scale updates can use it
            core_plugins.notify(me, "afterUpdate");
            me._layers.sort(compare2Level("z", "_idx"));
            if (me._bufferedRender) me._bufferedRequest = {
                duration: config.duration,
                easing: config.easing,
                lazy: config.lazy
            };
            else me.render(config);
        },
        /**
	 * Updates the chart layout unless a plugin returns `false` to the `beforeLayout`
	 * hook, in which case, plugins will not be called on `afterLayout`.
	 * @private
	 */ updateLayout: function() {
            var me = this;
            if (core_plugins.notify(me, "beforeLayout") === false) return;
            core_layouts.update(this, this.width, this.height);
            me._layers = [];
            helpers$1.each(me.boxes, function(box) {
                // _configure is called twice, once in core.scale.update and once here.
                // Here the boxes are fully updated and at their final positions.
                if (box._configure) box._configure();
                me._layers.push.apply(me._layers, box._layers());
            }, me);
            me._layers.forEach(function(item, index) {
                item._idx = index;
            });
            /**
		 * Provided for backward compatibility, use `afterLayout` instead.
		 * @method IPlugin#afterScaleUpdate
		 * @deprecated since version 2.5.0
		 * @todo remove at version 3
		 * @private
		 */ core_plugins.notify(me, "afterScaleUpdate");
            core_plugins.notify(me, "afterLayout");
        },
        /**
	 * Updates all datasets unless a plugin returns `false` to the `beforeDatasetsUpdate`
	 * hook, in which case, plugins will not be called on `afterDatasetsUpdate`.
	 * @private
	 */ updateDatasets: function() {
            var me = this;
            if (core_plugins.notify(me, "beforeDatasetsUpdate") === false) return;
            for(var i = 0, ilen = me.data.datasets.length; i < ilen; ++i)me.updateDataset(i);
            core_plugins.notify(me, "afterDatasetsUpdate");
        },
        /**
	 * Updates dataset at index unless a plugin returns `false` to the `beforeDatasetUpdate`
	 * hook, in which case, plugins will not be called on `afterDatasetUpdate`.
	 * @private
	 */ updateDataset: function(index) {
            var me = this;
            var meta = me.getDatasetMeta(index);
            var args = {
                meta: meta,
                index: index
            };
            if (core_plugins.notify(me, "beforeDatasetUpdate", [
                args
            ]) === false) return;
            meta.controller._update();
            core_plugins.notify(me, "afterDatasetUpdate", [
                args
            ]);
        },
        render: function(config) {
            var me = this;
            if (!config || typeof config !== "object") // backwards compatibility
            config = {
                duration: config,
                lazy: arguments[1]
            };
            var animationOptions = me.options.animation;
            var duration = valueOrDefault$9(config.duration, animationOptions && animationOptions.duration);
            var lazy = config.lazy;
            if (core_plugins.notify(me, "beforeRender") === false) return;
            var onComplete = function(animation) {
                core_plugins.notify(me, "afterRender");
                helpers$1.callback(animationOptions && animationOptions.onComplete, [
                    animation
                ], me);
            };
            if (animationOptions && duration) {
                var animation = new core_animation({
                    numSteps: duration / 16.66,
                    easing: config.easing || animationOptions.easing,
                    render: function(chart, animationObject) {
                        var easingFunction = helpers$1.easing.effects[animationObject.easing];
                        var currentStep = animationObject.currentStep;
                        var stepDecimal = currentStep / animationObject.numSteps;
                        chart.draw(easingFunction(stepDecimal), stepDecimal, currentStep);
                    },
                    onAnimationProgress: animationOptions.onProgress,
                    onAnimationComplete: onComplete
                });
                core_animations.addAnimation(me, animation, duration, lazy);
            } else {
                me.draw();
                // See https://github.com/chartjs/Chart.js/issues/3781
                onComplete(new core_animation({
                    numSteps: 0,
                    chart: me
                }));
            }
            return me;
        },
        draw: function(easingValue) {
            var me = this;
            var i, layers;
            me.clear();
            if (helpers$1.isNullOrUndef(easingValue)) easingValue = 1;
            me.transition(easingValue);
            if (me.width <= 0 || me.height <= 0) return;
            if (core_plugins.notify(me, "beforeDraw", [
                easingValue
            ]) === false) return;
            // Because of plugin hooks (before/afterDatasetsDraw), datasets can't
            // currently be part of layers. Instead, we draw
            // layers <= 0 before(default, backward compat), and the rest after
            layers = me._layers;
            for(i = 0; i < layers.length && layers[i].z <= 0; ++i)layers[i].draw(me.chartArea);
            me.drawDatasets(easingValue);
            // Rest of layers
            for(; i < layers.length; ++i)layers[i].draw(me.chartArea);
            me._drawTooltip(easingValue);
            core_plugins.notify(me, "afterDraw", [
                easingValue
            ]);
        },
        /**
	 * @private
	 */ transition: function(easingValue) {
            var me = this;
            for(var i = 0, ilen = (me.data.datasets || []).length; i < ilen; ++i)if (me.isDatasetVisible(i)) me.getDatasetMeta(i).controller.transition(easingValue);
            me.tooltip.transition(easingValue);
        },
        /**
	 * @private
	 */ _getSortedDatasetMetas: function(filterVisible) {
            var me = this;
            var datasets = me.data.datasets || [];
            var result = [];
            var i, ilen;
            for(i = 0, ilen = datasets.length; i < ilen; ++i)if (!filterVisible || me.isDatasetVisible(i)) result.push(me.getDatasetMeta(i));
            result.sort(compare2Level("order", "index"));
            return result;
        },
        /**
	 * @private
	 */ _getSortedVisibleDatasetMetas: function() {
            return this._getSortedDatasetMetas(true);
        },
        /**
	 * Draws all datasets unless a plugin returns `false` to the `beforeDatasetsDraw`
	 * hook, in which case, plugins will not be called on `afterDatasetsDraw`.
	 * @private
	 */ drawDatasets: function(easingValue) {
            var me = this;
            var metasets, i;
            if (core_plugins.notify(me, "beforeDatasetsDraw", [
                easingValue
            ]) === false) return;
            metasets = me._getSortedVisibleDatasetMetas();
            for(i = metasets.length - 1; i >= 0; --i)me.drawDataset(metasets[i], easingValue);
            core_plugins.notify(me, "afterDatasetsDraw", [
                easingValue
            ]);
        },
        /**
	 * Draws dataset at index unless a plugin returns `false` to the `beforeDatasetDraw`
	 * hook, in which case, plugins will not be called on `afterDatasetDraw`.
	 * @private
	 */ drawDataset: function(meta, easingValue) {
            var me = this;
            var args = {
                meta: meta,
                index: meta.index,
                easingValue: easingValue
            };
            if (core_plugins.notify(me, "beforeDatasetDraw", [
                args
            ]) === false) return;
            meta.controller.draw(easingValue);
            core_plugins.notify(me, "afterDatasetDraw", [
                args
            ]);
        },
        /**
	 * Draws tooltip unless a plugin returns `false` to the `beforeTooltipDraw`
	 * hook, in which case, plugins will not be called on `afterTooltipDraw`.
	 * @private
	 */ _drawTooltip: function(easingValue) {
            var me = this;
            var tooltip = me.tooltip;
            var args = {
                tooltip: tooltip,
                easingValue: easingValue
            };
            if (core_plugins.notify(me, "beforeTooltipDraw", [
                args
            ]) === false) return;
            tooltip.draw();
            core_plugins.notify(me, "afterTooltipDraw", [
                args
            ]);
        },
        /**
	 * Get the single element that was clicked on
	 * @return An object containing the dataset index and element index of the matching element. Also contains the rectangle that was draw
	 */ getElementAtEvent: function(e) {
            return core_interaction.modes.single(this, e);
        },
        getElementsAtEvent: function(e) {
            return core_interaction.modes.label(this, e, {
                intersect: true
            });
        },
        getElementsAtXAxis: function(e) {
            return core_interaction.modes["x-axis"](this, e, {
                intersect: true
            });
        },
        getElementsAtEventForMode: function(e, mode, options) {
            var method = core_interaction.modes[mode];
            if (typeof method === "function") return method(this, e, options);
            return [];
        },
        getDatasetAtEvent: function(e) {
            return core_interaction.modes.dataset(this, e, {
                intersect: true
            });
        },
        getDatasetMeta: function(datasetIndex) {
            var me = this;
            var dataset = me.data.datasets[datasetIndex];
            if (!dataset._meta) dataset._meta = {};
            var meta = dataset._meta[me.id];
            if (!meta) meta = dataset._meta[me.id] = {
                type: null,
                data: [],
                dataset: null,
                controller: null,
                hidden: null,
                xAxisID: null,
                yAxisID: null,
                order: dataset.order || 0,
                index: datasetIndex
            };
            return meta;
        },
        getVisibleDatasetCount: function() {
            var count = 0;
            for(var i = 0, ilen = this.data.datasets.length; i < ilen; ++i)if (this.isDatasetVisible(i)) count++;
            return count;
        },
        isDatasetVisible: function(datasetIndex) {
            var meta = this.getDatasetMeta(datasetIndex);
            // meta.hidden is a per chart dataset hidden flag override with 3 states: if true or false,
            // the dataset.hidden value is ignored, else if null, the dataset hidden state is returned.
            return typeof meta.hidden === "boolean" ? !meta.hidden : !this.data.datasets[datasetIndex].hidden;
        },
        generateLegend: function() {
            return this.options.legendCallback(this);
        },
        /**
	 * @private
	 */ destroyDatasetMeta: function(datasetIndex) {
            var id = this.id;
            var dataset = this.data.datasets[datasetIndex];
            var meta = dataset._meta && dataset._meta[id];
            if (meta) {
                meta.controller.destroy();
                delete dataset._meta[id];
            }
        },
        destroy: function() {
            var me = this;
            var canvas = me.canvas;
            var i, ilen;
            me.stop();
            // dataset controllers need to cleanup associated data
            for(i = 0, ilen = me.data.datasets.length; i < ilen; ++i)me.destroyDatasetMeta(i);
            if (canvas) {
                me.unbindEvents();
                helpers$1.canvas.clear(me);
                platform.releaseContext(me.ctx);
                me.canvas = null;
                me.ctx = null;
            }
            core_plugins.notify(me, "destroy");
            delete Chart.instances[me.id];
        },
        toBase64Image: function() {
            return this.canvas.toDataURL.apply(this.canvas, arguments);
        },
        initToolTip: function() {
            var me = this;
            me.tooltip = new core_tooltip({
                _chart: me,
                _chartInstance: me,
                _data: me.data,
                _options: me.options.tooltips
            }, me);
        },
        /**
	 * @private
	 */ bindEvents: function() {
            var me = this;
            var listeners = me._listeners = {};
            var listener = function() {
                me.eventHandler.apply(me, arguments);
            };
            helpers$1.each(me.options.events, function(type) {
                platform.addEventListener(me, type, listener);
                listeners[type] = listener;
            });
            // Elements used to detect size change should not be injected for non responsive charts.
            // See https://github.com/chartjs/Chart.js/issues/2210
            if (me.options.responsive) {
                listener = function() {
                    me.resize();
                };
                platform.addEventListener(me, "resize", listener);
                listeners.resize = listener;
            }
        },
        /**
	 * @private
	 */ unbindEvents: function() {
            var me = this;
            var listeners = me._listeners;
            if (!listeners) return;
            delete me._listeners;
            helpers$1.each(listeners, function(listener, type) {
                platform.removeEventListener(me, type, listener);
            });
        },
        updateHoverStyle: function(elements, mode, enabled) {
            var prefix = enabled ? "set" : "remove";
            var element, i, ilen;
            for(i = 0, ilen = elements.length; i < ilen; ++i){
                element = elements[i];
                if (element) this.getDatasetMeta(element._datasetIndex).controller[prefix + "HoverStyle"](element);
            }
            if (mode === "dataset") this.getDatasetMeta(elements[0]._datasetIndex).controller["_" + prefix + "DatasetHoverStyle"]();
        },
        /**
	 * @private
	 */ eventHandler: function(e) {
            var me = this;
            var tooltip = me.tooltip;
            if (core_plugins.notify(me, "beforeEvent", [
                e
            ]) === false) return;
            // Buffer any update calls so that renders do not occur
            me._bufferedRender = true;
            me._bufferedRequest = null;
            var changed = me.handleEvent(e);
            // for smooth tooltip animations issue #4989
            // the tooltip should be the source of change
            // Animation check workaround:
            // tooltip._start will be null when tooltip isn't animating
            if (tooltip) changed = tooltip._start ? tooltip.handleEvent(e) : changed | tooltip.handleEvent(e);
            core_plugins.notify(me, "afterEvent", [
                e
            ]);
            var bufferedRequest = me._bufferedRequest;
            if (bufferedRequest) // If we have an update that was triggered, we need to do a normal render
            me.render(bufferedRequest);
            else if (changed && !me.animating) {
                // If entering, leaving, or changing elements, animate the change via pivot
                me.stop();
                // We only need to render at this point. Updating will cause scales to be
                // recomputed generating flicker & using more memory than necessary.
                me.render({
                    duration: me.options.hover.animationDuration,
                    lazy: true
                });
            }
            me._bufferedRender = false;
            me._bufferedRequest = null;
            return me;
        },
        /**
	 * Handle an event
	 * @private
	 * @param {IEvent} event the event to handle
	 * @return {boolean} true if the chart needs to re-render
	 */ handleEvent: function(e) {
            var me = this;
            var options = me.options || {};
            var hoverOptions = options.hover;
            var changed = false;
            me.lastActive = me.lastActive || [];
            // Find Active Elements for hover and tooltips
            if (e.type === "mouseout") me.active = [];
            else me.active = me.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions);
            // Invoke onHover hook
            // Need to call with native event here to not break backwards compatibility
            helpers$1.callback(options.onHover || options.hover.onHover, [
                e.native,
                me.active
            ], me);
            if (e.type === "mouseup" || e.type === "click") {
                if (options.onClick) // Use e.native here for backwards compatibility
                options.onClick.call(me, e.native, me.active);
            }
            // Remove styling for last active (even if it may still be active)
            if (me.lastActive.length) me.updateHoverStyle(me.lastActive, hoverOptions.mode, false);
            // Built in hover styling
            if (me.active.length && hoverOptions.mode) me.updateHoverStyle(me.active, hoverOptions.mode, true);
            changed = !helpers$1.arrayEquals(me.active, me.lastActive);
            // Remember Last Actives
            me.lastActive = me.active;
            return changed;
        }
    });
    /**
 * NOTE(SB) We actually don't use this container anymore but we need to keep it
 * for backward compatibility. Though, it can still be useful for plugins that
 * would need to work on multiple charts?!
 */ Chart.instances = {};
    var core_controller = Chart;
    // DEPRECATIONS
    /**
 * Provided for backward compatibility, use Chart instead.
 * @class Chart.Controller
 * @deprecated since version 2.6
 * @todo remove at version 3
 * @private
 */ Chart.Controller = Chart;
    /**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart
 * @deprecated since version 2.8
 * @todo remove at version 3
 * @private
 */ Chart.types = {};
    /**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart.helpers.configMerge
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 * @private
 */ helpers$1.configMerge = mergeConfig;
    /**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart.helpers.scaleMerge
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 * @private
 */ helpers$1.scaleMerge = mergeScaleConfig;
    var core_helpers = function() {
        // -- Basic js utility methods
        helpers$1.where = function(collection, filterCallback) {
            if (helpers$1.isArray(collection) && Array.prototype.filter) return collection.filter(filterCallback);
            var filtered = [];
            helpers$1.each(collection, function(item) {
                if (filterCallback(item)) filtered.push(item);
            });
            return filtered;
        };
        helpers$1.findIndex = Array.prototype.findIndex ? function(array, callback, scope) {
            return array.findIndex(callback, scope);
        } : function(array, callback, scope) {
            scope = scope === undefined ? array : scope;
            for(var i = 0, ilen = array.length; i < ilen; ++i){
                if (callback.call(scope, array[i], i, array)) return i;
            }
            return -1;
        };
        helpers$1.findNextWhere = function(arrayToSearch, filterCallback, startIndex) {
            // Default to start of the array
            if (helpers$1.isNullOrUndef(startIndex)) startIndex = -1;
            for(var i = startIndex + 1; i < arrayToSearch.length; i++){
                var currentItem = arrayToSearch[i];
                if (filterCallback(currentItem)) return currentItem;
            }
        };
        helpers$1.findPreviousWhere = function(arrayToSearch, filterCallback, startIndex) {
            // Default to end of the array
            if (helpers$1.isNullOrUndef(startIndex)) startIndex = arrayToSearch.length;
            for(var i = startIndex - 1; i >= 0; i--){
                var currentItem = arrayToSearch[i];
                if (filterCallback(currentItem)) return currentItem;
            }
        };
        // -- Math methods
        helpers$1.isNumber = function(n) {
            return !isNaN(parseFloat(n)) && isFinite(n);
        };
        helpers$1.almostEquals = function(x, y, epsilon) {
            return Math.abs(x - y) < epsilon;
        };
        helpers$1.almostWhole = function(x, epsilon) {
            var rounded = Math.round(x);
            return rounded - epsilon <= x && rounded + epsilon >= x;
        };
        helpers$1.max = function(array) {
            return array.reduce(function(max, value) {
                if (!isNaN(value)) return Math.max(max, value);
                return max;
            }, Number.NEGATIVE_INFINITY);
        };
        helpers$1.min = function(array) {
            return array.reduce(function(min, value) {
                if (!isNaN(value)) return Math.min(min, value);
                return min;
            }, Number.POSITIVE_INFINITY);
        };
        helpers$1.sign = Math.sign ? function(x) {
            return Math.sign(x);
        } : function(x) {
            x = +x; // convert to a number
            if (x === 0 || isNaN(x)) return x;
            return x > 0 ? 1 : -1;
        };
        helpers$1.toRadians = function(degrees) {
            return degrees * (Math.PI / 180);
        };
        helpers$1.toDegrees = function(radians) {
            return radians * (180 / Math.PI);
        };
        /**
	 * Returns the number of decimal places
	 * i.e. the number of digits after the decimal point, of the value of this Number.
	 * @param {number} x - A number.
	 * @returns {number} The number of decimal places.
	 * @private
	 */ helpers$1._decimalPlaces = function(x) {
            if (!helpers$1.isFinite(x)) return;
            var e = 1;
            var p = 0;
            while(Math.round(x * e) / e !== x){
                e *= 10;
                p++;
            }
            return p;
        };
        // Gets the angle from vertical upright to the point about a centre.
        helpers$1.getAngleFromPoint = function(centrePoint, anglePoint) {
            var distanceFromXCenter = anglePoint.x - centrePoint.x;
            var distanceFromYCenter = anglePoint.y - centrePoint.y;
            var radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
            var angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
            if (angle < -0.5 * Math.PI) angle += 2.0 * Math.PI; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
            return {
                angle: angle,
                distance: radialDistanceFromCenter
            };
        };
        helpers$1.distanceBetweenPoints = function(pt1, pt2) {
            return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
        };
        /**
	 * Provided for backward compatibility, not available anymore
	 * @function Chart.helpers.aliasPixel
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 */ helpers$1.aliasPixel = function(pixelWidth) {
            return pixelWidth % 2 === 0 ? 0 : 0.5;
        };
        /**
	 * Returns the aligned pixel value to avoid anti-aliasing blur
	 * @param {Chart} chart - The chart instance.
	 * @param {number} pixel - A pixel value.
	 * @param {number} width - The width of the element.
	 * @returns {number} The aligned pixel value.
	 * @private
	 */ helpers$1._alignPixel = function(chart, pixel, width) {
            var devicePixelRatio = chart.currentDevicePixelRatio;
            var halfWidth = width / 2;
            return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
        };
        helpers$1.splineCurve = function(firstPoint, middlePoint, afterPoint, t) {
            // Props to Rob Spencer at scaled innovation for his post on splining between points
            // http://scaledinnovation.com/analytics/splines/aboutSplines.html
            // This function must also respect "skipped" points
            var previous = firstPoint.skip ? middlePoint : firstPoint;
            var current = middlePoint;
            var next = afterPoint.skip ? middlePoint : afterPoint;
            var d01 = Math.sqrt(Math.pow(current.x - previous.x, 2) + Math.pow(current.y - previous.y, 2));
            var d12 = Math.sqrt(Math.pow(next.x - current.x, 2) + Math.pow(next.y - current.y, 2));
            var s01 = d01 / (d01 + d12);
            var s12 = d12 / (d01 + d12);
            // If all points are the same, s01 & s02 will be inf
            s01 = isNaN(s01) ? 0 : s01;
            s12 = isNaN(s12) ? 0 : s12;
            var fa = t * s01; // scaling factor for triangle Ta
            var fb = t * s12;
            return {
                previous: {
                    x: current.x - fa * (next.x - previous.x),
                    y: current.y - fa * (next.y - previous.y)
                },
                next: {
                    x: current.x + fb * (next.x - previous.x),
                    y: current.y + fb * (next.y - previous.y)
                }
            };
        };
        helpers$1.EPSILON = Number.EPSILON || 1e-14;
        helpers$1.splineCurveMonotone = function(points) {
            // This function calculates Bézier control points in a similar way than |splineCurve|,
            // but preserves monotonicity of the provided data and ensures no local extremums are added
            // between the dataset discrete points due to the interpolation.
            // See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation
            var pointsWithTangents = (points || []).map(function(point) {
                return {
                    model: point._model,
                    deltaK: 0,
                    mK: 0
                };
            });
            // Calculate slopes (deltaK) and initialize tangents (mK)
            var pointsLen = pointsWithTangents.length;
            var i, pointBefore, pointCurrent, pointAfter;
            for(i = 0; i < pointsLen; ++i){
                pointCurrent = pointsWithTangents[i];
                if (pointCurrent.model.skip) continue;
                pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
                pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
                if (pointAfter && !pointAfter.model.skip) {
                    var slopeDeltaX = pointAfter.model.x - pointCurrent.model.x;
                    // In the case of two points that appear at the same x pixel, slopeDeltaX is 0
                    pointCurrent.deltaK = slopeDeltaX !== 0 ? (pointAfter.model.y - pointCurrent.model.y) / slopeDeltaX : 0;
                }
                if (!pointBefore || pointBefore.model.skip) pointCurrent.mK = pointCurrent.deltaK;
                else if (!pointAfter || pointAfter.model.skip) pointCurrent.mK = pointBefore.deltaK;
                else if (this.sign(pointBefore.deltaK) !== this.sign(pointCurrent.deltaK)) pointCurrent.mK = 0;
                else pointCurrent.mK = (pointBefore.deltaK + pointCurrent.deltaK) / 2;
            }
            // Adjust tangents to ensure monotonic properties
            var alphaK, betaK, tauK, squaredMagnitude;
            for(i = 0; i < pointsLen - 1; ++i){
                pointCurrent = pointsWithTangents[i];
                pointAfter = pointsWithTangents[i + 1];
                if (pointCurrent.model.skip || pointAfter.model.skip) continue;
                if (helpers$1.almostEquals(pointCurrent.deltaK, 0, this.EPSILON)) {
                    pointCurrent.mK = pointAfter.mK = 0;
                    continue;
                }
                alphaK = pointCurrent.mK / pointCurrent.deltaK;
                betaK = pointAfter.mK / pointCurrent.deltaK;
                squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
                if (squaredMagnitude <= 9) continue;
                tauK = 3 / Math.sqrt(squaredMagnitude);
                pointCurrent.mK = alphaK * tauK * pointCurrent.deltaK;
                pointAfter.mK = betaK * tauK * pointCurrent.deltaK;
            }
            // Compute control points
            var deltaX;
            for(i = 0; i < pointsLen; ++i){
                pointCurrent = pointsWithTangents[i];
                if (pointCurrent.model.skip) continue;
                pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
                pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
                if (pointBefore && !pointBefore.model.skip) {
                    deltaX = (pointCurrent.model.x - pointBefore.model.x) / 3;
                    pointCurrent.model.controlPointPreviousX = pointCurrent.model.x - deltaX;
                    pointCurrent.model.controlPointPreviousY = pointCurrent.model.y - deltaX * pointCurrent.mK;
                }
                if (pointAfter && !pointAfter.model.skip) {
                    deltaX = (pointAfter.model.x - pointCurrent.model.x) / 3;
                    pointCurrent.model.controlPointNextX = pointCurrent.model.x + deltaX;
                    pointCurrent.model.controlPointNextY = pointCurrent.model.y + deltaX * pointCurrent.mK;
                }
            }
        };
        helpers$1.nextItem = function(collection, index, loop) {
            if (loop) return index >= collection.length - 1 ? collection[0] : collection[index + 1];
            return index >= collection.length - 1 ? collection[collection.length - 1] : collection[index + 1];
        };
        helpers$1.previousItem = function(collection, index, loop) {
            if (loop) return index <= 0 ? collection[collection.length - 1] : collection[index - 1];
            return index <= 0 ? collection[0] : collection[index - 1];
        };
        // Implementation of the nice number algorithm used in determining where axis labels will go
        helpers$1.niceNum = function(range, round) {
            var exponent = Math.floor(helpers$1.log10(range));
            var fraction = range / Math.pow(10, exponent);
            var niceFraction;
            if (round) {
                if (fraction < 1.5) niceFraction = 1;
                else if (fraction < 3) niceFraction = 2;
                else if (fraction < 7) niceFraction = 5;
                else niceFraction = 10;
            } else if (fraction <= 1.0) niceFraction = 1;
            else if (fraction <= 2) niceFraction = 2;
            else if (fraction <= 5) niceFraction = 5;
            else niceFraction = 10;
            return niceFraction * Math.pow(10, exponent);
        };
        // Request animation polyfill - https://www.paulirish.com/2011/requestanimationframe-for-smart-animating/
        helpers$1.requestAnimFrame = function() {
            if (typeof window === "undefined") return function(callback) {
                callback();
            };
            return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function(callback) {
                return window.setTimeout(callback, 1000 / 60);
            };
        }();
        // -- DOM methods
        helpers$1.getRelativePosition = function(evt, chart) {
            var mouseX, mouseY;
            var e = evt.originalEvent || evt;
            var canvas = evt.target || evt.srcElement;
            var boundingRect = canvas.getBoundingClientRect();
            var touches = e.touches;
            if (touches && touches.length > 0) {
                mouseX = touches[0].clientX;
                mouseY = touches[0].clientY;
            } else {
                mouseX = e.clientX;
                mouseY = e.clientY;
            }
            // Scale mouse coordinates into canvas coordinates
            // by following the pattern laid out by 'jerryj' in the comments of
            // https://www.html5canvastutorials.com/advanced/html5-canvas-mouse-coordinates/
            var paddingLeft = parseFloat(helpers$1.getStyle(canvas, "padding-left"));
            var paddingTop = parseFloat(helpers$1.getStyle(canvas, "padding-top"));
            var paddingRight = parseFloat(helpers$1.getStyle(canvas, "padding-right"));
            var paddingBottom = parseFloat(helpers$1.getStyle(canvas, "padding-bottom"));
            var width = boundingRect.right - boundingRect.left - paddingLeft - paddingRight;
            var height = boundingRect.bottom - boundingRect.top - paddingTop - paddingBottom;
            // We divide by the current device pixel ratio, because the canvas is scaled up by that amount in each direction. However
            // the backend model is in unscaled coordinates. Since we are going to deal with our model coordinates, we go back here
            mouseX = Math.round((mouseX - boundingRect.left - paddingLeft) / width * canvas.width / chart.currentDevicePixelRatio);
            mouseY = Math.round((mouseY - boundingRect.top - paddingTop) / height * canvas.height / chart.currentDevicePixelRatio);
            return {
                x: mouseX,
                y: mouseY
            };
        };
        // Private helper function to convert max-width/max-height values that may be percentages into a number
        function parseMaxStyle(styleValue, node, parentProperty) {
            var valueInPixels;
            if (typeof styleValue === "string") {
                valueInPixels = parseInt(styleValue, 10);
                if (styleValue.indexOf("%") !== -1) // percentage * size in dimension
                valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
            } else valueInPixels = styleValue;
            return valueInPixels;
        }
        /**
	 * Returns if the given value contains an effective constraint.
	 * @private
	 */ function isConstrainedValue(value) {
            return value !== undefined && value !== null && value !== "none";
        }
        /**
	 * Returns the max width or height of the given DOM node in a cross-browser compatible fashion
	 * @param {HTMLElement} domNode - the node to check the constraint on
	 * @param {string} maxStyle - the style that defines the maximum for the direction we are using ('max-width' / 'max-height')
	 * @param {string} percentageProperty - property of parent to use when calculating width as a percentage
	 * @see {@link https://www.nathanaeljones.com/blog/2013/reading-max-width-cross-browser}
	 */ function getConstraintDimension(domNode, maxStyle, percentageProperty) {
            var view = document.defaultView;
            var parentNode = helpers$1._getParentNode(domNode);
            var constrainedNode = view.getComputedStyle(domNode)[maxStyle];
            var constrainedContainer = view.getComputedStyle(parentNode)[maxStyle];
            var hasCNode = isConstrainedValue(constrainedNode);
            var hasCContainer = isConstrainedValue(constrainedContainer);
            var infinity = Number.POSITIVE_INFINITY;
            if (hasCNode || hasCContainer) return Math.min(hasCNode ? parseMaxStyle(constrainedNode, domNode, percentageProperty) : infinity, hasCContainer ? parseMaxStyle(constrainedContainer, parentNode, percentageProperty) : infinity);
            return "none";
        }
        // returns Number or undefined if no constraint
        helpers$1.getConstraintWidth = function(domNode) {
            return getConstraintDimension(domNode, "max-width", "clientWidth");
        };
        // returns Number or undefined if no constraint
        helpers$1.getConstraintHeight = function(domNode) {
            return getConstraintDimension(domNode, "max-height", "clientHeight");
        };
        /**
	 * @private
 	 */ helpers$1._calculatePadding = function(container, padding, parentDimension) {
            padding = helpers$1.getStyle(container, padding);
            return padding.indexOf("%") > -1 ? parentDimension * parseInt(padding, 10) / 100 : parseInt(padding, 10);
        };
        /**
	 * @private
	 */ helpers$1._getParentNode = function(domNode) {
            var parent = domNode.parentNode;
            if (parent && parent.toString() === "[object ShadowRoot]") parent = parent.host;
            return parent;
        };
        helpers$1.getMaximumWidth = function(domNode) {
            var container = helpers$1._getParentNode(domNode);
            if (!container) return domNode.clientWidth;
            var clientWidth = container.clientWidth;
            var paddingLeft = helpers$1._calculatePadding(container, "padding-left", clientWidth);
            var paddingRight = helpers$1._calculatePadding(container, "padding-right", clientWidth);
            var w = clientWidth - paddingLeft - paddingRight;
            var cw = helpers$1.getConstraintWidth(domNode);
            return isNaN(cw) ? w : Math.min(w, cw);
        };
        helpers$1.getMaximumHeight = function(domNode) {
            var container = helpers$1._getParentNode(domNode);
            if (!container) return domNode.clientHeight;
            var clientHeight = container.clientHeight;
            var paddingTop = helpers$1._calculatePadding(container, "padding-top", clientHeight);
            var paddingBottom = helpers$1._calculatePadding(container, "padding-bottom", clientHeight);
            var h = clientHeight - paddingTop - paddingBottom;
            var ch = helpers$1.getConstraintHeight(domNode);
            return isNaN(ch) ? h : Math.min(h, ch);
        };
        helpers$1.getStyle = function(el, property) {
            return el.currentStyle ? el.currentStyle[property] : document.defaultView.getComputedStyle(el, null).getPropertyValue(property);
        };
        helpers$1.retinaScale = function(chart, forceRatio) {
            var pixelRatio = chart.currentDevicePixelRatio = forceRatio || typeof window !== "undefined" && window.devicePixelRatio || 1;
            if (pixelRatio === 1) return;
            var canvas = chart.canvas;
            var height = chart.height;
            var width = chart.width;
            canvas.height = height * pixelRatio;
            canvas.width = width * pixelRatio;
            chart.ctx.scale(pixelRatio, pixelRatio);
            // If no style has been set on the canvas, the render size is used as display size,
            // making the chart visually bigger, so let's enforce it to the "correct" values.
            // See https://github.com/chartjs/Chart.js/issues/3575
            if (!canvas.style.height && !canvas.style.width) {
                canvas.style.height = height + "px";
                canvas.style.width = width + "px";
            }
        };
        // -- Canvas methods
        helpers$1.fontString = function(pixelSize, fontStyle, fontFamily) {
            return fontStyle + " " + pixelSize + "px " + fontFamily;
        };
        helpers$1.longestText = function(ctx, font, arrayOfThings, cache) {
            cache = cache || {};
            var data = cache.data = cache.data || {};
            var gc = cache.garbageCollect = cache.garbageCollect || [];
            if (cache.font !== font) {
                data = cache.data = {};
                gc = cache.garbageCollect = [];
                cache.font = font;
            }
            ctx.font = font;
            var longest = 0;
            var ilen = arrayOfThings.length;
            var i, j, jlen, thing, nestedThing;
            for(i = 0; i < ilen; i++){
                thing = arrayOfThings[i];
                // Undefined strings and arrays should not be measured
                if (thing !== undefined && thing !== null && helpers$1.isArray(thing) !== true) longest = helpers$1.measureText(ctx, data, gc, longest, thing);
                else if (helpers$1.isArray(thing)) // if it is an array lets measure each element
                // to do maybe simplify this function a bit so we can do this more recursively?
                for(j = 0, jlen = thing.length; j < jlen; j++){
                    nestedThing = thing[j];
                    // Undefined strings and arrays should not be measured
                    if (nestedThing !== undefined && nestedThing !== null && !helpers$1.isArray(nestedThing)) longest = helpers$1.measureText(ctx, data, gc, longest, nestedThing);
                }
            }
            var gcLen = gc.length / 2;
            if (gcLen > arrayOfThings.length) {
                for(i = 0; i < gcLen; i++)delete data[gc[i]];
                gc.splice(0, gcLen);
            }
            return longest;
        };
        helpers$1.measureText = function(ctx, data, gc, longest, string) {
            var textWidth = data[string];
            if (!textWidth) {
                textWidth = data[string] = ctx.measureText(string).width;
                gc.push(string);
            }
            if (textWidth > longest) longest = textWidth;
            return longest;
        };
        /**
	 * @deprecated
	 */ helpers$1.numberOfLabelLines = function(arrayOfThings) {
            var numberOfLines = 1;
            helpers$1.each(arrayOfThings, function(thing) {
                if (helpers$1.isArray(thing)) {
                    if (thing.length > numberOfLines) numberOfLines = thing.length;
                }
            });
            return numberOfLines;
        };
        helpers$1.color = !chartjsColor ? function(value) {
            console.error("Color.js not found!");
            return value;
        } : function(value) {
            /* global CanvasGradient */ if (value instanceof CanvasGradient) value = core_defaults.global.defaultColor;
            return chartjsColor(value);
        };
        helpers$1.getHoverColor = function(colorValue) {
            /* global CanvasPattern */ return colorValue instanceof CanvasPattern || colorValue instanceof CanvasGradient ? colorValue : helpers$1.color(colorValue).saturate(0.5).darken(0.1).rgbString();
        };
    };
    function abstract() {
        throw new Error("This method is not implemented: either no adapter can be found or an incomplete integration was provided.");
    }
    /**
 * Date adapter (current used by the time scale)
 * @namespace Chart._adapters._date
 * @memberof Chart._adapters
 * @private
 */ /**
 * Currently supported unit string values.
 * @typedef {('millisecond'|'second'|'minute'|'hour'|'day'|'week'|'month'|'quarter'|'year')}
 * @memberof Chart._adapters._date
 * @name Unit
 */ /**
 * @class
 */ function DateAdapter(options) {
        this.options = options || {};
    }
    helpers$1.extend(DateAdapter.prototype, /** @lends DateAdapter */ {
        /**
	 * Returns a map of time formats for the supported formatting units defined
	 * in Unit as well as 'datetime' representing a detailed date/time string.
	 * @returns {{string: string}}
	 */ formats: abstract,
        /**
	 * Parses the given `value` and return the associated timestamp.
	 * @param {any} value - the value to parse (usually comes from the data)
	 * @param {string} [format] - the expected data format
	 * @returns {(number|null)}
	 * @function
	 */ parse: abstract,
        /**
	 * Returns the formatted date in the specified `format` for a given `timestamp`.
	 * @param {number} timestamp - the timestamp to format
	 * @param {string} format - the date/time token
	 * @return {string}
	 * @function
	 */ format: abstract,
        /**
	 * Adds the specified `amount` of `unit` to the given `timestamp`.
	 * @param {number} timestamp - the input timestamp
	 * @param {number} amount - the amount to add
	 * @param {Unit} unit - the unit as string
	 * @return {number}
	 * @function
	 */ add: abstract,
        /**
	 * Returns the number of `unit` between the given timestamps.
	 * @param {number} max - the input timestamp (reference)
	 * @param {number} min - the timestamp to substract
	 * @param {Unit} unit - the unit as string
	 * @return {number}
	 * @function
	 */ diff: abstract,
        /**
	 * Returns start of `unit` for the given `timestamp`.
	 * @param {number} timestamp - the input timestamp
	 * @param {Unit} unit - the unit as string
	 * @param {number} [weekday] - the ISO day of the week with 1 being Monday
	 * and 7 being Sunday (only needed if param *unit* is `isoWeek`).
	 * @function
	 */ startOf: abstract,
        /**
	 * Returns end of `unit` for the given `timestamp`.
	 * @param {number} timestamp - the input timestamp
	 * @param {Unit} unit - the unit as string
	 * @function
	 */ endOf: abstract,
        // DEPRECATIONS
        /**
	 * Provided for backward compatibility for scale.getValueForPixel(),
	 * this method should be overridden only by the moment adapter.
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 * @private
	 */ _create: function(value) {
            return value;
        }
    });
    DateAdapter.override = function(members) {
        helpers$1.extend(DateAdapter.prototype, members);
    };
    var _date = DateAdapter;
    var core_adapters = {
        _date: _date
    };
    /**
 * Namespace to hold static tick generation functions
 * @namespace Chart.Ticks
 */ var core_ticks = {
        /**
	 * Namespace to hold formatters for different types of ticks
	 * @namespace Chart.Ticks.formatters
	 */ formatters: {
            /**
		 * Formatter for value labels
		 * @method Chart.Ticks.formatters.values
		 * @param value the value to display
		 * @return {string|string[]} the label to display
		 */ values: function(value) {
                return helpers$1.isArray(value) ? value : "" + value;
            },
            /**
		 * Formatter for linear numeric ticks
		 * @method Chart.Ticks.formatters.linear
		 * @param tickValue {number} the value to be formatted
		 * @param index {number} the position of the tickValue parameter in the ticks array
		 * @param ticks {number[]} the list of ticks being converted
		 * @return {string} string representation of the tickValue parameter
		 */ linear: function(tickValue, index, ticks) {
                // If we have lots of ticks, don't use the ones
                var delta = ticks.length > 3 ? ticks[2] - ticks[1] : ticks[1] - ticks[0];
                // If we have a number like 2.5 as the delta, figure out how many decimal places we need
                if (Math.abs(delta) > 1) {
                    if (tickValue !== Math.floor(tickValue)) // not an integer
                    delta = tickValue - Math.floor(tickValue);
                }
                var logDelta = helpers$1.log10(Math.abs(delta));
                var tickString = "";
                if (tickValue !== 0) {
                    var maxTick = Math.max(Math.abs(ticks[0]), Math.abs(ticks[ticks.length - 1]));
                    if (maxTick < 1e-4) {
                        var logTick = helpers$1.log10(Math.abs(tickValue));
                        var numExponential = Math.floor(logTick) - Math.floor(logDelta);
                        numExponential = Math.max(Math.min(numExponential, 20), 0);
                        tickString = tickValue.toExponential(numExponential);
                    } else {
                        var numDecimal = -1 * Math.floor(logDelta);
                        numDecimal = Math.max(Math.min(numDecimal, 20), 0); // toFixed has a max of 20 decimal places
                        tickString = tickValue.toFixed(numDecimal);
                    }
                } else tickString = "0"; // never show decimal places for 0
                return tickString;
            },
            logarithmic: function(tickValue, index, ticks) {
                var remain = tickValue / Math.pow(10, Math.floor(helpers$1.log10(tickValue)));
                if (tickValue === 0) return "0";
                else if (remain === 1 || remain === 2 || remain === 5 || index === 0 || index === ticks.length - 1) return tickValue.toExponential();
                return "";
            }
        }
    };
    var isArray = helpers$1.isArray;
    var isNullOrUndef = helpers$1.isNullOrUndef;
    var valueOrDefault$a = helpers$1.valueOrDefault;
    var valueAtIndexOrDefault = helpers$1.valueAtIndexOrDefault;
    core_defaults._set("scale", {
        display: true,
        position: "left",
        offset: false,
        // grid line settings
        gridLines: {
            display: true,
            color: "rgba(0,0,0,0.1)",
            lineWidth: 1,
            drawBorder: true,
            drawOnChartArea: true,
            drawTicks: true,
            tickMarkLength: 10,
            zeroLineWidth: 1,
            zeroLineColor: "rgba(0,0,0,0.25)",
            zeroLineBorderDash: [],
            zeroLineBorderDashOffset: 0.0,
            offsetGridLines: false,
            borderDash: [],
            borderDashOffset: 0.0
        },
        // scale label
        scaleLabel: {
            // display property
            display: false,
            // actual label
            labelString: "",
            // top/bottom padding
            padding: {
                top: 4,
                bottom: 4
            }
        },
        // label settings
        ticks: {
            beginAtZero: false,
            minRotation: 0,
            maxRotation: 50,
            mirror: false,
            padding: 0,
            reverse: false,
            display: true,
            autoSkip: true,
            autoSkipPadding: 0,
            labelOffset: 0,
            // We pass through arrays to be rendered as multiline labels, we convert Others to strings here.
            callback: core_ticks.formatters.values,
            minor: {},
            major: {}
        }
    });
    /** Returns a new array containing numItems from arr */ function sample(arr, numItems) {
        var result = [];
        var increment = arr.length / numItems;
        var i = 0;
        var len = arr.length;
        for(; i < len; i += increment)result.push(arr[Math.floor(i)]);
        return result;
    }
    function getPixelForGridLine(scale, index, offsetGridLines) {
        var length = scale.getTicks().length;
        var validIndex = Math.min(index, length - 1);
        var lineValue = scale.getPixelForTick(validIndex);
        var start = scale._startPixel;
        var end = scale._endPixel;
        var epsilon = 1e-6; // 1e-6 is margin in pixels for accumulated error.
        var offset;
        if (offsetGridLines) {
            if (length === 1) offset = Math.max(lineValue - start, end - lineValue);
            else if (index === 0) offset = (scale.getPixelForTick(1) - lineValue) / 2;
            else offset = (lineValue - scale.getPixelForTick(validIndex - 1)) / 2;
            lineValue += validIndex < index ? offset : -offset;
            // Return undefined if the pixel is out of the range
            if (lineValue < start - epsilon || lineValue > end + epsilon) return;
        }
        return lineValue;
    }
    function garbageCollect(caches, length) {
        helpers$1.each(caches, function(cache) {
            var gc = cache.gc;
            var gcLen = gc.length / 2;
            var i;
            if (gcLen > length) {
                for(i = 0; i < gcLen; ++i)delete cache.data[gc[i]];
                gc.splice(0, gcLen);
            }
        });
    }
    /**
 * Returns {width, height, offset} objects for the first, last, widest, highest tick
 * labels where offset indicates the anchor point offset from the top in pixels.
 */ function computeLabelSizes(ctx, tickFonts, ticks, caches) {
        var length = ticks.length;
        var widths = [];
        var heights = [];
        var offsets = [];
        var widestLabelSize = 0;
        var highestLabelSize = 0;
        var i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel, widest, highest;
        for(i = 0; i < length; ++i){
            label = ticks[i].label;
            tickFont = ticks[i].major ? tickFonts.major : tickFonts.minor;
            ctx.font = fontString = tickFont.string;
            cache = caches[fontString] = caches[fontString] || {
                data: {},
                gc: []
            };
            lineHeight = tickFont.lineHeight;
            width = height = 0;
            // Undefined labels and arrays should not be measured
            if (!isNullOrUndef(label) && !isArray(label)) {
                width = helpers$1.measureText(ctx, cache.data, cache.gc, width, label);
                height = lineHeight;
            } else if (isArray(label)) // if it is an array let's measure each element
            for(j = 0, jlen = label.length; j < jlen; ++j){
                nestedLabel = label[j];
                // Undefined labels and arrays should not be measured
                if (!isNullOrUndef(nestedLabel) && !isArray(nestedLabel)) {
                    width = helpers$1.measureText(ctx, cache.data, cache.gc, width, nestedLabel);
                    height += lineHeight;
                }
            }
            widths.push(width);
            heights.push(height);
            offsets.push(lineHeight / 2);
            widestLabelSize = Math.max(width, widestLabelSize);
            highestLabelSize = Math.max(height, highestLabelSize);
        }
        garbageCollect(caches, length);
        widest = widths.indexOf(widestLabelSize);
        highest = heights.indexOf(highestLabelSize);
        function valueAt(idx) {
            return {
                width: widths[idx] || 0,
                height: heights[idx] || 0,
                offset: offsets[idx] || 0
            };
        }
        return {
            first: valueAt(0),
            last: valueAt(length - 1),
            widest: valueAt(widest),
            highest: valueAt(highest)
        };
    }
    function getTickMarkLength(options) {
        return options.drawTicks ? options.tickMarkLength : 0;
    }
    function getScaleLabelHeight(options) {
        var font, padding;
        if (!options.display) return 0;
        font = helpers$1.options._parseFont(options);
        padding = helpers$1.options.toPadding(options.padding);
        return font.lineHeight + padding.height;
    }
    function parseFontOptions(options, nestedOpts) {
        return helpers$1.extend(helpers$1.options._parseFont({
            fontFamily: valueOrDefault$a(nestedOpts.fontFamily, options.fontFamily),
            fontSize: valueOrDefault$a(nestedOpts.fontSize, options.fontSize),
            fontStyle: valueOrDefault$a(nestedOpts.fontStyle, options.fontStyle),
            lineHeight: valueOrDefault$a(nestedOpts.lineHeight, options.lineHeight)
        }), {
            color: helpers$1.options.resolve([
                nestedOpts.fontColor,
                options.fontColor,
                core_defaults.global.defaultFontColor
            ])
        });
    }
    function parseTickFontOptions(options) {
        var minor = parseFontOptions(options, options.minor);
        var major = options.major.enabled ? parseFontOptions(options, options.major) : minor;
        return {
            minor: minor,
            major: major
        };
    }
    function nonSkipped(ticksToFilter) {
        var filtered = [];
        var item, index, len;
        for(index = 0, len = ticksToFilter.length; index < len; ++index){
            item = ticksToFilter[index];
            if (typeof item._index !== "undefined") filtered.push(item);
        }
        return filtered;
    }
    function getEvenSpacing(arr) {
        var len = arr.length;
        var i, diff;
        if (len < 2) return false;
        for(diff = arr[0], i = 1; i < len; ++i){
            if (arr[i] - arr[i - 1] !== diff) return false;
        }
        return diff;
    }
    function calculateSpacing(majorIndices, ticks, axisLength, ticksLimit) {
        var evenMajorSpacing = getEvenSpacing(majorIndices);
        var spacing = (ticks.length - 1) / ticksLimit;
        var factors, factor, i, ilen;
        // If the major ticks are evenly spaced apart, place the minor ticks
        // so that they divide the major ticks into even chunks
        if (!evenMajorSpacing) return Math.max(spacing, 1);
        factors = helpers$1.math._factorize(evenMajorSpacing);
        for(i = 0, ilen = factors.length - 1; i < ilen; i++){
            factor = factors[i];
            if (factor > spacing) return factor;
        }
        return Math.max(spacing, 1);
    }
    function getMajorIndices(ticks) {
        var result = [];
        var i, ilen;
        for(i = 0, ilen = ticks.length; i < ilen; i++)if (ticks[i].major) result.push(i);
        return result;
    }
    function skipMajors(ticks, majorIndices, spacing) {
        var count = 0;
        var next = majorIndices[0];
        var i, tick;
        spacing = Math.ceil(spacing);
        for(i = 0; i < ticks.length; i++){
            tick = ticks[i];
            if (i === next) {
                tick._index = i;
                count++;
                next = majorIndices[count * spacing];
            } else delete tick.label;
        }
    }
    function skip(ticks, spacing, majorStart, majorEnd) {
        var start = valueOrDefault$a(majorStart, 0);
        var end = Math.min(valueOrDefault$a(majorEnd, ticks.length), ticks.length);
        var count = 0;
        var length, i, tick, next;
        spacing = Math.ceil(spacing);
        if (majorEnd) {
            length = majorEnd - majorStart;
            spacing = length / Math.floor(length / spacing);
        }
        next = start;
        while(next < 0){
            count++;
            next = Math.round(start + count * spacing);
        }
        for(i = Math.max(start, 0); i < end; i++){
            tick = ticks[i];
            if (i === next) {
                tick._index = i;
                count++;
                next = Math.round(start + count * spacing);
            } else delete tick.label;
        }
    }
    var Scale = core_element.extend({
        zeroLineIndex: 0,
        /**
	 * Get the padding needed for the scale
	 * @method getPadding
	 * @private
	 * @returns {Padding} the necessary padding
	 */ getPadding: function() {
            var me = this;
            return {
                left: me.paddingLeft || 0,
                top: me.paddingTop || 0,
                right: me.paddingRight || 0,
                bottom: me.paddingBottom || 0
            };
        },
        /**
	 * Returns the scale tick objects ({label, major})
	 * @since 2.7
	 */ getTicks: function() {
            return this._ticks;
        },
        /**
	* @private
	*/ _getLabels: function() {
            var data = this.chart.data;
            return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
        },
        // These methods are ordered by lifecyle. Utilities then follow.
        // Any function defined here is inherited by all scale types.
        // Any function can be extended by the scale type
        /**
	 * Provided for backward compatibility, not available anymore
	 * @function Chart.Scale.mergeTicksOptions
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 */ mergeTicksOptions: function() {
        // noop
        },
        beforeUpdate: function() {
            helpers$1.callback(this.options.beforeUpdate, [
                this
            ]);
        },
        /**
	 * @param {number} maxWidth - the max width in pixels
	 * @param {number} maxHeight - the max height in pixels
	 * @param {object} margins - the space between the edge of the other scales and edge of the chart
	 *   This space comes from two sources:
	 *     - padding - space that's required to show the labels at the edges of the scale
	 *     - thickness of scales or legends in another orientation
	 */ update: function(maxWidth, maxHeight, margins) {
            var me = this;
            var tickOpts = me.options.ticks;
            var sampleSize = tickOpts.sampleSize;
            var i, ilen, labels, ticks, samplingEnabled;
            // Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
            me.beforeUpdate();
            // Absorb the master measurements
            me.maxWidth = maxWidth;
            me.maxHeight = maxHeight;
            me.margins = helpers$1.extend({
                left: 0,
                right: 0,
                top: 0,
                bottom: 0
            }, margins);
            me._ticks = null;
            me.ticks = null;
            me._labelSizes = null;
            me._maxLabelLines = 0;
            me.longestLabelWidth = 0;
            me.longestTextCache = me.longestTextCache || {};
            me._gridLineItems = null;
            me._labelItems = null;
            // Dimensions
            me.beforeSetDimensions();
            me.setDimensions();
            me.afterSetDimensions();
            // Data min/max
            me.beforeDataLimits();
            me.determineDataLimits();
            me.afterDataLimits();
            // Ticks - `this.ticks` is now DEPRECATED!
            // Internal ticks are now stored as objects in the PRIVATE `this._ticks` member
            // and must not be accessed directly from outside this class. `this.ticks` being
            // around for long time and not marked as private, we can't change its structure
            // without unexpected breaking changes. If you need to access the scale ticks,
            // use scale.getTicks() instead.
            me.beforeBuildTicks();
            // New implementations should return an array of objects but for BACKWARD COMPAT,
            // we still support no return (`this.ticks` internally set by calling this method).
            ticks = me.buildTicks() || [];
            // Allow modification of ticks in callback.
            ticks = me.afterBuildTicks(ticks) || ticks;
            // Ensure ticks contains ticks in new tick format
            if ((!ticks || !ticks.length) && me.ticks) {
                ticks = [];
                for(i = 0, ilen = me.ticks.length; i < ilen; ++i)ticks.push({
                    value: me.ticks[i],
                    major: false
                });
            }
            me._ticks = ticks;
            // Compute tick rotation and fit using a sampled subset of labels
            // We generally don't need to compute the size of every single label for determining scale size
            samplingEnabled = sampleSize < ticks.length;
            labels = me._convertTicksToLabels(samplingEnabled ? sample(ticks, sampleSize) : ticks);
            // _configure is called twice, once here, once from core.controller.updateLayout.
            // Here we haven't been positioned yet, but dimensions are correct.
            // Variables set in _configure are needed for calculateTickRotation, and
            // it's ok that coordinates are not correct there, only dimensions matter.
            me._configure();
            // Tick Rotation
            me.beforeCalculateTickRotation();
            me.calculateTickRotation();
            me.afterCalculateTickRotation();
            me.beforeFit();
            me.fit();
            me.afterFit();
            // Auto-skip
            me._ticksToDraw = tickOpts.display && (tickOpts.autoSkip || tickOpts.source === "auto") ? me._autoSkip(ticks) : ticks;
            if (samplingEnabled) // Generate labels using all non-skipped ticks
            labels = me._convertTicksToLabels(me._ticksToDraw);
            me.ticks = labels; // BACKWARD COMPATIBILITY
            // IMPORTANT: after this point, we consider that `this.ticks` will NEVER change!
            me.afterUpdate();
            // TODO(v3): remove minSize as a public property and return value from all layout boxes. It is unused
            // make maxWidth and maxHeight private
            return me.minSize;
        },
        /**
	 * @private
	 */ _configure: function() {
            var me = this;
            var reversePixels = me.options.ticks.reverse;
            var startPixel, endPixel;
            if (me.isHorizontal()) {
                startPixel = me.left;
                endPixel = me.right;
            } else {
                startPixel = me.top;
                endPixel = me.bottom;
                // by default vertical scales are from bottom to top, so pixels are reversed
                reversePixels = !reversePixels;
            }
            me._startPixel = startPixel;
            me._endPixel = endPixel;
            me._reversePixels = reversePixels;
            me._length = endPixel - startPixel;
        },
        afterUpdate: function() {
            helpers$1.callback(this.options.afterUpdate, [
                this
            ]);
        },
        //
        beforeSetDimensions: function() {
            helpers$1.callback(this.options.beforeSetDimensions, [
                this
            ]);
        },
        setDimensions: function() {
            var me = this;
            // Set the unconstrained dimension before label rotation
            if (me.isHorizontal()) {
                // Reset position before calculating rotation
                me.width = me.maxWidth;
                me.left = 0;
                me.right = me.width;
            } else {
                me.height = me.maxHeight;
                // Reset position before calculating rotation
                me.top = 0;
                me.bottom = me.height;
            }
            // Reset padding
            me.paddingLeft = 0;
            me.paddingTop = 0;
            me.paddingRight = 0;
            me.paddingBottom = 0;
        },
        afterSetDimensions: function() {
            helpers$1.callback(this.options.afterSetDimensions, [
                this
            ]);
        },
        // Data limits
        beforeDataLimits: function() {
            helpers$1.callback(this.options.beforeDataLimits, [
                this
            ]);
        },
        determineDataLimits: helpers$1.noop,
        afterDataLimits: function() {
            helpers$1.callback(this.options.afterDataLimits, [
                this
            ]);
        },
        //
        beforeBuildTicks: function() {
            helpers$1.callback(this.options.beforeBuildTicks, [
                this
            ]);
        },
        buildTicks: helpers$1.noop,
        afterBuildTicks: function(ticks) {
            var me = this;
            // ticks is empty for old axis implementations here
            if (isArray(ticks) && ticks.length) return helpers$1.callback(me.options.afterBuildTicks, [
                me,
                ticks
            ]);
            // Support old implementations (that modified `this.ticks` directly in buildTicks)
            me.ticks = helpers$1.callback(me.options.afterBuildTicks, [
                me,
                me.ticks
            ]) || me.ticks;
            return ticks;
        },
        beforeTickToLabelConversion: function() {
            helpers$1.callback(this.options.beforeTickToLabelConversion, [
                this
            ]);
        },
        convertTicksToLabels: function() {
            var me = this;
            // Convert ticks to strings
            var tickOpts = me.options.ticks;
            me.ticks = me.ticks.map(tickOpts.userCallback || tickOpts.callback, this);
        },
        afterTickToLabelConversion: function() {
            helpers$1.callback(this.options.afterTickToLabelConversion, [
                this
            ]);
        },
        //
        beforeCalculateTickRotation: function() {
            helpers$1.callback(this.options.beforeCalculateTickRotation, [
                this
            ]);
        },
        calculateTickRotation: function() {
            var me = this;
            var options = me.options;
            var tickOpts = options.ticks;
            var numTicks = me.getTicks().length;
            var minRotation = tickOpts.minRotation || 0;
            var maxRotation = tickOpts.maxRotation;
            var labelRotation = minRotation;
            var labelSizes, maxLabelWidth, maxLabelHeight, maxWidth, tickWidth, maxHeight, maxLabelDiagonal;
            if (!me._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !me.isHorizontal()) {
                me.labelRotation = minRotation;
                return;
            }
            labelSizes = me._getLabelSizes();
            maxLabelWidth = labelSizes.widest.width;
            maxLabelHeight = labelSizes.highest.height - labelSizes.highest.offset;
            // Estimate the width of each grid based on the canvas width, the maximum
            // label width and the number of tick intervals
            maxWidth = Math.min(me.maxWidth, me.chart.width - maxLabelWidth);
            tickWidth = options.offset ? me.maxWidth / numTicks : maxWidth / (numTicks - 1);
            // Allow 3 pixels x2 padding either side for label readability
            if (maxLabelWidth + 6 > tickWidth) {
                tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
                maxHeight = me.maxHeight - getTickMarkLength(options.gridLines) - tickOpts.padding - getScaleLabelHeight(options.scaleLabel);
                maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
                labelRotation = helpers$1.toDegrees(Math.min(Math.asin(Math.min((labelSizes.highest.height + 6) / tickWidth, 1)), Math.asin(Math.min(maxHeight / maxLabelDiagonal, 1)) - Math.asin(maxLabelHeight / maxLabelDiagonal)));
                labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
            }
            me.labelRotation = labelRotation;
        },
        afterCalculateTickRotation: function() {
            helpers$1.callback(this.options.afterCalculateTickRotation, [
                this
            ]);
        },
        //
        beforeFit: function() {
            helpers$1.callback(this.options.beforeFit, [
                this
            ]);
        },
        fit: function() {
            var me = this;
            // Reset
            var minSize = me.minSize = {
                width: 0,
                height: 0
            };
            var chart = me.chart;
            var opts = me.options;
            var tickOpts = opts.ticks;
            var scaleLabelOpts = opts.scaleLabel;
            var gridLineOpts = opts.gridLines;
            var display = me._isVisible();
            var isBottom = opts.position === "bottom";
            var isHorizontal = me.isHorizontal();
            // Width
            if (isHorizontal) minSize.width = me.maxWidth;
            else if (display) minSize.width = getTickMarkLength(gridLineOpts) + getScaleLabelHeight(scaleLabelOpts);
            // height
            if (!isHorizontal) minSize.height = me.maxHeight; // fill all the height
            else if (display) minSize.height = getTickMarkLength(gridLineOpts) + getScaleLabelHeight(scaleLabelOpts);
            // Don't bother fitting the ticks if we are not showing the labels
            if (tickOpts.display && display) {
                var tickFonts = parseTickFontOptions(tickOpts);
                var labelSizes = me._getLabelSizes();
                var firstLabelSize = labelSizes.first;
                var lastLabelSize = labelSizes.last;
                var widestLabelSize = labelSizes.widest;
                var highestLabelSize = labelSizes.highest;
                var lineSpace = tickFonts.minor.lineHeight * 0.4;
                var tickPadding = tickOpts.padding;
                if (isHorizontal) {
                    // A horizontal axis is more constrained by the height.
                    var isRotated = me.labelRotation !== 0;
                    var angleRadians = helpers$1.toRadians(me.labelRotation);
                    var cosRotation = Math.cos(angleRadians);
                    var sinRotation = Math.sin(angleRadians);
                    var labelHeight = sinRotation * widestLabelSize.width + cosRotation * (highestLabelSize.height - (isRotated ? highestLabelSize.offset : 0)) + (isRotated ? 0 : lineSpace); // padding
                    minSize.height = Math.min(me.maxHeight, minSize.height + labelHeight + tickPadding);
                    var offsetLeft = me.getPixelForTick(0) - me.left;
                    var offsetRight = me.right - me.getPixelForTick(me.getTicks().length - 1);
                    var paddingLeft, paddingRight;
                    // Ensure that our ticks are always inside the canvas. When rotated, ticks are right aligned
                    // which means that the right padding is dominated by the font height
                    if (isRotated) {
                        paddingLeft = isBottom ? cosRotation * firstLabelSize.width + sinRotation * firstLabelSize.offset : sinRotation * (firstLabelSize.height - firstLabelSize.offset);
                        paddingRight = isBottom ? sinRotation * (lastLabelSize.height - lastLabelSize.offset) : cosRotation * lastLabelSize.width + sinRotation * lastLabelSize.offset;
                    } else {
                        paddingLeft = firstLabelSize.width / 2;
                        paddingRight = lastLabelSize.width / 2;
                    }
                    // Adjust padding taking into account changes in offsets
                    // and add 3 px to move away from canvas edges
                    me.paddingLeft = Math.max((paddingLeft - offsetLeft) * me.width / (me.width - offsetLeft), 0) + 3;
                    me.paddingRight = Math.max((paddingRight - offsetRight) * me.width / (me.width - offsetRight), 0) + 3;
                } else {
                    // A vertical axis is more constrained by the width. Labels are the
                    // dominant factor here, so get that length first and account for padding
                    var labelWidth = tickOpts.mirror ? 0 : // use lineSpace for consistency with horizontal axis
                    // tickPadding is not implemented for horizontal
                    widestLabelSize.width + tickPadding + lineSpace;
                    minSize.width = Math.min(me.maxWidth, minSize.width + labelWidth);
                    me.paddingTop = firstLabelSize.height / 2;
                    me.paddingBottom = lastLabelSize.height / 2;
                }
            }
            me.handleMargins();
            if (isHorizontal) {
                me.width = me._length = chart.width - me.margins.left - me.margins.right;
                me.height = minSize.height;
            } else {
                me.width = minSize.width;
                me.height = me._length = chart.height - me.margins.top - me.margins.bottom;
            }
        },
        /**
	 * Handle margins and padding interactions
	 * @private
	 */ handleMargins: function() {
            var me = this;
            if (me.margins) {
                me.margins.left = Math.max(me.paddingLeft, me.margins.left);
                me.margins.top = Math.max(me.paddingTop, me.margins.top);
                me.margins.right = Math.max(me.paddingRight, me.margins.right);
                me.margins.bottom = Math.max(me.paddingBottom, me.margins.bottom);
            }
        },
        afterFit: function() {
            helpers$1.callback(this.options.afterFit, [
                this
            ]);
        },
        // Shared Methods
        isHorizontal: function() {
            var pos = this.options.position;
            return pos === "top" || pos === "bottom";
        },
        isFullWidth: function() {
            return this.options.fullWidth;
        },
        // Get the correct value. NaN bad inputs, If the value type is object get the x or y based on whether we are horizontal or not
        getRightValue: function(rawValue) {
            // Null and undefined values first
            if (isNullOrUndef(rawValue)) return NaN;
            // isNaN(object) returns true, so make sure NaN is checking for a number; Discard Infinite values
            if ((typeof rawValue === "number" || rawValue instanceof Number) && !isFinite(rawValue)) return NaN;
            // If it is in fact an object, dive in one more level
            if (rawValue) {
                if (this.isHorizontal()) {
                    if (rawValue.x !== undefined) return this.getRightValue(rawValue.x);
                } else if (rawValue.y !== undefined) return this.getRightValue(rawValue.y);
            }
            // Value is good, return it
            return rawValue;
        },
        _convertTicksToLabels: function(ticks) {
            var me = this;
            var labels, i, ilen;
            me.ticks = ticks.map(function(tick) {
                return tick.value;
            });
            me.beforeTickToLabelConversion();
            // New implementations should return the formatted tick labels but for BACKWARD
            // COMPAT, we still support no return (`this.ticks` internally changed by calling
            // this method and supposed to contain only string values).
            labels = me.convertTicksToLabels(ticks) || me.ticks;
            me.afterTickToLabelConversion();
            // BACKWARD COMPAT: synchronize `_ticks` with labels (so potentially `this.ticks`)
            for(i = 0, ilen = ticks.length; i < ilen; ++i)ticks[i].label = labels[i];
            return labels;
        },
        /**
	 * @private
	 */ _getLabelSizes: function() {
            var me = this;
            var labelSizes = me._labelSizes;
            if (!labelSizes) {
                me._labelSizes = labelSizes = computeLabelSizes(me.ctx, parseTickFontOptions(me.options.ticks), me.getTicks(), me.longestTextCache);
                me.longestLabelWidth = labelSizes.widest.width;
            }
            return labelSizes;
        },
        /**
	 * @private
	 */ _parseValue: function(value) {
            var start, end, min, max;
            if (isArray(value)) {
                start = +this.getRightValue(value[0]);
                end = +this.getRightValue(value[1]);
                min = Math.min(start, end);
                max = Math.max(start, end);
            } else {
                value = +this.getRightValue(value);
                start = undefined;
                end = value;
                min = value;
                max = value;
            }
            return {
                min: min,
                max: max,
                start: start,
                end: end
            };
        },
        /**
	* @private
	*/ _getScaleLabel: function(rawValue) {
            var v = this._parseValue(rawValue);
            if (v.start !== undefined) return "[" + v.start + ", " + v.end + "]";
            return +this.getRightValue(rawValue);
        },
        /**
	 * Used to get the value to display in the tooltip for the data at the given index
	 * @param index
	 * @param datasetIndex
	 */ getLabelForIndex: helpers$1.noop,
        /**
	 * Returns the location of the given data point. Value can either be an index or a numerical value
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 * @param value
	 * @param index
	 * @param datasetIndex
	 */ getPixelForValue: helpers$1.noop,
        /**
	 * Used to get the data value from a given pixel. This is the inverse of getPixelForValue
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 * @param pixel
	 */ getValueForPixel: helpers$1.noop,
        /**
	 * Returns the location of the tick at the given index
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 */ getPixelForTick: function(index) {
            var me = this;
            var offset = me.options.offset;
            var numTicks = me._ticks.length;
            var tickWidth = 1 / Math.max(numTicks - (offset ? 0 : 1), 1);
            return index < 0 || index > numTicks - 1 ? null : me.getPixelForDecimal(index * tickWidth + (offset ? tickWidth / 2 : 0));
        },
        /**
	 * Utility for getting the pixel location of a percentage of scale
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 */ getPixelForDecimal: function(decimal) {
            var me = this;
            if (me._reversePixels) decimal = 1 - decimal;
            return me._startPixel + decimal * me._length;
        },
        getDecimalForPixel: function(pixel) {
            var decimal = (pixel - this._startPixel) / this._length;
            return this._reversePixels ? 1 - decimal : decimal;
        },
        /**
	 * Returns the pixel for the minimum chart value
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 */ getBasePixel: function() {
            return this.getPixelForValue(this.getBaseValue());
        },
        getBaseValue: function() {
            var me = this;
            var min = me.min;
            var max = me.max;
            return me.beginAtZero ? 0 : min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0;
        },
        /**
	 * Returns a subset of ticks to be plotted to avoid overlapping labels.
	 * @private
	 */ _autoSkip: function(ticks) {
            var me = this;
            var tickOpts = me.options.ticks;
            var axisLength = me._length;
            var ticksLimit = tickOpts.maxTicksLimit || axisLength / me._tickSize() + 1;
            var majorIndices = tickOpts.major.enabled ? getMajorIndices(ticks) : [];
            var numMajorIndices = majorIndices.length;
            var first = majorIndices[0];
            var last = majorIndices[numMajorIndices - 1];
            var i, ilen, spacing, avgMajorSpacing;
            // If there are too many major ticks to display them all
            if (numMajorIndices > ticksLimit) {
                skipMajors(ticks, majorIndices, numMajorIndices / ticksLimit);
                return nonSkipped(ticks);
            }
            spacing = calculateSpacing(majorIndices, ticks, axisLength, ticksLimit);
            if (numMajorIndices > 0) {
                for(i = 0, ilen = numMajorIndices - 1; i < ilen; i++)skip(ticks, spacing, majorIndices[i], majorIndices[i + 1]);
                avgMajorSpacing = numMajorIndices > 1 ? (last - first) / (numMajorIndices - 1) : null;
                skip(ticks, spacing, helpers$1.isNullOrUndef(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
                skip(ticks, spacing, last, helpers$1.isNullOrUndef(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
                return nonSkipped(ticks);
            }
            skip(ticks, spacing);
            return nonSkipped(ticks);
        },
        /**
	 * @private
	 */ _tickSize: function() {
            var me = this;
            var optionTicks = me.options.ticks;
            // Calculate space needed by label in axis direction.
            var rot = helpers$1.toRadians(me.labelRotation);
            var cos = Math.abs(Math.cos(rot));
            var sin = Math.abs(Math.sin(rot));
            var labelSizes = me._getLabelSizes();
            var padding = optionTicks.autoSkipPadding || 0;
            var w = labelSizes ? labelSizes.widest.width + padding : 0;
            var h = labelSizes ? labelSizes.highest.height + padding : 0;
            // Calculate space needed for 1 tick in axis direction.
            return me.isHorizontal() ? h * cos > w * sin ? w / cos : h / sin : h * sin < w * cos ? h / cos : w / sin;
        },
        /**
	 * @private
	 */ _isVisible: function() {
            var me = this;
            var chart = me.chart;
            var display = me.options.display;
            var i, ilen, meta;
            if (display !== "auto") return !!display;
            // When 'auto', the scale is visible if at least one associated dataset is visible.
            for(i = 0, ilen = chart.data.datasets.length; i < ilen; ++i)if (chart.isDatasetVisible(i)) {
                meta = chart.getDatasetMeta(i);
                if (meta.xAxisID === me.id || meta.yAxisID === me.id) return true;
            }
            return false;
        },
        /**
	 * @private
	 */ _computeGridLineItems: function(chartArea) {
            var me = this;
            var chart = me.chart;
            var options = me.options;
            var gridLines = options.gridLines;
            var position = options.position;
            var offsetGridLines = gridLines.offsetGridLines;
            var isHorizontal = me.isHorizontal();
            var ticks = me._ticksToDraw;
            var ticksLength = ticks.length + (offsetGridLines ? 1 : 0);
            var tl = getTickMarkLength(gridLines);
            var items = [];
            var axisWidth = gridLines.drawBorder ? valueAtIndexOrDefault(gridLines.lineWidth, 0, 0) : 0;
            var axisHalfWidth = axisWidth / 2;
            var alignPixel = helpers$1._alignPixel;
            var alignBorderValue = function(pixel) {
                return alignPixel(chart, pixel, axisWidth);
            };
            var borderValue, i, tick, lineValue, alignedLineValue;
            var tx1, ty1, tx2, ty2, x1, y1, x2, y2, lineWidth, lineColor, borderDash, borderDashOffset;
            if (position === "top") {
                borderValue = alignBorderValue(me.bottom);
                ty1 = me.bottom - tl;
                ty2 = borderValue - axisHalfWidth;
                y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
                y2 = chartArea.bottom;
            } else if (position === "bottom") {
                borderValue = alignBorderValue(me.top);
                y1 = chartArea.top;
                y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
                ty1 = borderValue + axisHalfWidth;
                ty2 = me.top + tl;
            } else if (position === "left") {
                borderValue = alignBorderValue(me.right);
                tx1 = me.right - tl;
                tx2 = borderValue - axisHalfWidth;
                x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
                x2 = chartArea.right;
            } else {
                borderValue = alignBorderValue(me.left);
                x1 = chartArea.left;
                x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
                tx1 = borderValue + axisHalfWidth;
                tx2 = me.left + tl;
            }
            for(i = 0; i < ticksLength; ++i){
                tick = ticks[i] || {};
                // autoskipper skipped this tick (#4635)
                if (isNullOrUndef(tick.label) && i < ticks.length) continue;
                if (i === me.zeroLineIndex && options.offset === offsetGridLines) {
                    // Draw the first index specially
                    lineWidth = gridLines.zeroLineWidth;
                    lineColor = gridLines.zeroLineColor;
                    borderDash = gridLines.zeroLineBorderDash || [];
                    borderDashOffset = gridLines.zeroLineBorderDashOffset || 0.0;
                } else {
                    lineWidth = valueAtIndexOrDefault(gridLines.lineWidth, i, 1);
                    lineColor = valueAtIndexOrDefault(gridLines.color, i, "rgba(0,0,0,0.1)");
                    borderDash = gridLines.borderDash || [];
                    borderDashOffset = gridLines.borderDashOffset || 0.0;
                }
                lineValue = getPixelForGridLine(me, tick._index || i, offsetGridLines);
                // Skip if the pixel is out of the range
                if (lineValue === undefined) continue;
                alignedLineValue = alignPixel(chart, lineValue, lineWidth);
                if (isHorizontal) tx1 = tx2 = x1 = x2 = alignedLineValue;
                else ty1 = ty2 = y1 = y2 = alignedLineValue;
                items.push({
                    tx1: tx1,
                    ty1: ty1,
                    tx2: tx2,
                    ty2: ty2,
                    x1: x1,
                    y1: y1,
                    x2: x2,
                    y2: y2,
                    width: lineWidth,
                    color: lineColor,
                    borderDash: borderDash,
                    borderDashOffset: borderDashOffset
                });
            }
            items.ticksLength = ticksLength;
            items.borderValue = borderValue;
            return items;
        },
        /**
	 * @private
	 */ _computeLabelItems: function() {
            var me = this;
            var options = me.options;
            var optionTicks = options.ticks;
            var position = options.position;
            var isMirrored = optionTicks.mirror;
            var isHorizontal = me.isHorizontal();
            var ticks = me._ticksToDraw;
            var fonts = parseTickFontOptions(optionTicks);
            var tickPadding = optionTicks.padding;
            var tl = getTickMarkLength(options.gridLines);
            var rotation = -helpers$1.toRadians(me.labelRotation);
            var items = [];
            var i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;
            if (position === "top") {
                y = me.bottom - tl - tickPadding;
                textAlign = !rotation ? "center" : "left";
            } else if (position === "bottom") {
                y = me.top + tl + tickPadding;
                textAlign = !rotation ? "center" : "right";
            } else if (position === "left") {
                x = me.right - (isMirrored ? 0 : tl) - tickPadding;
                textAlign = isMirrored ? "left" : "right";
            } else {
                x = me.left + (isMirrored ? 0 : tl) + tickPadding;
                textAlign = isMirrored ? "right" : "left";
            }
            for(i = 0, ilen = ticks.length; i < ilen; ++i){
                tick = ticks[i];
                label = tick.label;
                // autoskipper skipped this tick (#4635)
                if (isNullOrUndef(label)) continue;
                pixel = me.getPixelForTick(tick._index || i) + optionTicks.labelOffset;
                font = tick.major ? fonts.major : fonts.minor;
                lineHeight = font.lineHeight;
                lineCount = isArray(label) ? label.length : 1;
                if (isHorizontal) {
                    x = pixel;
                    textOffset = position === "top" ? ((!rotation ? 0.5 : 1) - lineCount) * lineHeight : (!rotation ? 0.5 : 0) * lineHeight;
                } else {
                    y = pixel;
                    textOffset = (1 - lineCount) * lineHeight / 2;
                }
                items.push({
                    x: x,
                    y: y,
                    rotation: rotation,
                    label: label,
                    font: font,
                    textOffset: textOffset,
                    textAlign: textAlign
                });
            }
            return items;
        },
        /**
	 * @private
	 */ _drawGrid: function(chartArea) {
            var me = this;
            var gridLines = me.options.gridLines;
            if (!gridLines.display) return;
            var ctx = me.ctx;
            var chart = me.chart;
            var alignPixel = helpers$1._alignPixel;
            var axisWidth = gridLines.drawBorder ? valueAtIndexOrDefault(gridLines.lineWidth, 0, 0) : 0;
            var items = me._gridLineItems || (me._gridLineItems = me._computeGridLineItems(chartArea));
            var width, color, i, ilen, item;
            for(i = 0, ilen = items.length; i < ilen; ++i){
                item = items[i];
                width = item.width;
                color = item.color;
                if (width && color) {
                    ctx.save();
                    ctx.lineWidth = width;
                    ctx.strokeStyle = color;
                    if (ctx.setLineDash) {
                        ctx.setLineDash(item.borderDash);
                        ctx.lineDashOffset = item.borderDashOffset;
                    }
                    ctx.beginPath();
                    if (gridLines.drawTicks) {
                        ctx.moveTo(item.tx1, item.ty1);
                        ctx.lineTo(item.tx2, item.ty2);
                    }
                    if (gridLines.drawOnChartArea) {
                        ctx.moveTo(item.x1, item.y1);
                        ctx.lineTo(item.x2, item.y2);
                    }
                    ctx.stroke();
                    ctx.restore();
                }
            }
            if (axisWidth) {
                // Draw the line at the edge of the axis
                var firstLineWidth = axisWidth;
                var lastLineWidth = valueAtIndexOrDefault(gridLines.lineWidth, items.ticksLength - 1, 1);
                var borderValue = items.borderValue;
                var x1, x2, y1, y2;
                if (me.isHorizontal()) {
                    x1 = alignPixel(chart, me.left, firstLineWidth) - firstLineWidth / 2;
                    x2 = alignPixel(chart, me.right, lastLineWidth) + lastLineWidth / 2;
                    y1 = y2 = borderValue;
                } else {
                    y1 = alignPixel(chart, me.top, firstLineWidth) - firstLineWidth / 2;
                    y2 = alignPixel(chart, me.bottom, lastLineWidth) + lastLineWidth / 2;
                    x1 = x2 = borderValue;
                }
                ctx.lineWidth = axisWidth;
                ctx.strokeStyle = valueAtIndexOrDefault(gridLines.color, 0);
                ctx.beginPath();
                ctx.moveTo(x1, y1);
                ctx.lineTo(x2, y2);
                ctx.stroke();
            }
        },
        /**
	 * @private
	 */ _drawLabels: function() {
            var me = this;
            var optionTicks = me.options.ticks;
            if (!optionTicks.display) return;
            var ctx = me.ctx;
            var items = me._labelItems || (me._labelItems = me._computeLabelItems());
            var i, j, ilen, jlen, item, tickFont, label, y;
            for(i = 0, ilen = items.length; i < ilen; ++i){
                item = items[i];
                tickFont = item.font;
                // Make sure we draw text in the correct color and font
                ctx.save();
                ctx.translate(item.x, item.y);
                ctx.rotate(item.rotation);
                ctx.font = tickFont.string;
                ctx.fillStyle = tickFont.color;
                ctx.textBaseline = "middle";
                ctx.textAlign = item.textAlign;
                label = item.label;
                y = item.textOffset;
                if (isArray(label)) for(j = 0, jlen = label.length; j < jlen; ++j){
                    // We just make sure the multiline element is a string here..
                    ctx.fillText("" + label[j], 0, y);
                    y += tickFont.lineHeight;
                }
                else ctx.fillText(label, 0, y);
                ctx.restore();
            }
        },
        /**
	 * @private
	 */ _drawTitle: function() {
            var me = this;
            var ctx = me.ctx;
            var options = me.options;
            var scaleLabel = options.scaleLabel;
            if (!scaleLabel.display) return;
            var scaleLabelFontColor = valueOrDefault$a(scaleLabel.fontColor, core_defaults.global.defaultFontColor);
            var scaleLabelFont = helpers$1.options._parseFont(scaleLabel);
            var scaleLabelPadding = helpers$1.options.toPadding(scaleLabel.padding);
            var halfLineHeight = scaleLabelFont.lineHeight / 2;
            var position = options.position;
            var rotation = 0;
            var scaleLabelX, scaleLabelY;
            if (me.isHorizontal()) {
                scaleLabelX = me.left + me.width / 2; // midpoint of the width
                scaleLabelY = position === "bottom" ? me.bottom - halfLineHeight - scaleLabelPadding.bottom : me.top + halfLineHeight + scaleLabelPadding.top;
            } else {
                var isLeft = position === "left";
                scaleLabelX = isLeft ? me.left + halfLineHeight + scaleLabelPadding.top : me.right - halfLineHeight - scaleLabelPadding.top;
                scaleLabelY = me.top + me.height / 2;
                rotation = isLeft ? -0.5 * Math.PI : 0.5 * Math.PI;
            }
            ctx.save();
            ctx.translate(scaleLabelX, scaleLabelY);
            ctx.rotate(rotation);
            ctx.textAlign = "center";
            ctx.textBaseline = "middle";
            ctx.fillStyle = scaleLabelFontColor; // render in correct colour
            ctx.font = scaleLabelFont.string;
            ctx.fillText(scaleLabel.labelString, 0, 0);
            ctx.restore();
        },
        draw: function(chartArea) {
            var me = this;
            if (!me._isVisible()) return;
            me._drawGrid(chartArea);
            me._drawTitle();
            me._drawLabels();
        },
        /**
	 * @private
	 */ _layers: function() {
            var me = this;
            var opts = me.options;
            var tz = opts.ticks && opts.ticks.z || 0;
            var gz = opts.gridLines && opts.gridLines.z || 0;
            if (!me._isVisible() || tz === gz || me.draw !== me._draw) // backward compatibility: draw has been overridden by custom scale
            return [
                {
                    z: tz,
                    draw: function() {
                        me.draw.apply(me, arguments);
                    }
                }
            ];
            return [
                {
                    z: gz,
                    draw: function() {
                        me._drawGrid.apply(me, arguments);
                        me._drawTitle.apply(me, arguments);
                    }
                },
                {
                    z: tz,
                    draw: function() {
                        me._drawLabels.apply(me, arguments);
                    }
                }
            ];
        },
        /**
	 * @private
	 */ _getMatchingVisibleMetas: function(type) {
            var me = this;
            var isHorizontal = me.isHorizontal();
            return me.chart._getSortedVisibleDatasetMetas().filter(function(meta) {
                return (!type || meta.type === type) && (isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id);
            });
        }
    });
    Scale.prototype._draw = Scale.prototype.draw;
    var core_scale = Scale;
    var isNullOrUndef$1 = helpers$1.isNullOrUndef;
    var defaultConfig = {
        position: "bottom"
    };
    var scale_category = core_scale.extend({
        determineDataLimits: function() {
            var me = this;
            var labels = me._getLabels();
            var ticksOpts = me.options.ticks;
            var min = ticksOpts.min;
            var max = ticksOpts.max;
            var minIndex = 0;
            var maxIndex = labels.length - 1;
            var findIndex;
            if (min !== undefined) {
                // user specified min value
                findIndex = labels.indexOf(min);
                if (findIndex >= 0) minIndex = findIndex;
            }
            if (max !== undefined) {
                // user specified max value
                findIndex = labels.indexOf(max);
                if (findIndex >= 0) maxIndex = findIndex;
            }
            me.minIndex = minIndex;
            me.maxIndex = maxIndex;
            me.min = labels[minIndex];
            me.max = labels[maxIndex];
        },
        buildTicks: function() {
            var me = this;
            var labels = me._getLabels();
            var minIndex = me.minIndex;
            var maxIndex = me.maxIndex;
            // If we are viewing some subset of labels, slice the original array
            me.ticks = minIndex === 0 && maxIndex === labels.length - 1 ? labels : labels.slice(minIndex, maxIndex + 1);
        },
        getLabelForIndex: function(index, datasetIndex) {
            var me = this;
            var chart = me.chart;
            if (chart.getDatasetMeta(datasetIndex).controller._getValueScaleId() === me.id) return me.getRightValue(chart.data.datasets[datasetIndex].data[index]);
            return me._getLabels()[index];
        },
        _configure: function() {
            var me = this;
            var offset = me.options.offset;
            var ticks = me.ticks;
            core_scale.prototype._configure.call(me);
            if (!me.isHorizontal()) // For backward compatibility, vertical category scale reverse is inverted.
            me._reversePixels = !me._reversePixels;
            if (!ticks) return;
            me._startValue = me.minIndex - (offset ? 0.5 : 0);
            me._valueRange = Math.max(ticks.length - (offset ? 0 : 1), 1);
        },
        // Used to get data value locations.  Value can either be an index or a numerical value
        getPixelForValue: function(value, index, datasetIndex) {
            var me = this;
            var valueCategory, labels, idx;
            if (!isNullOrUndef$1(index) && !isNullOrUndef$1(datasetIndex)) value = me.chart.data.datasets[datasetIndex].data[index];
            // If value is a data object, then index is the index in the data array,
            // not the index of the scale. We need to change that.
            if (!isNullOrUndef$1(value)) valueCategory = me.isHorizontal() ? value.x : value.y;
            if (valueCategory !== undefined || value !== undefined && isNaN(index)) {
                labels = me._getLabels();
                value = helpers$1.valueOrDefault(valueCategory, value);
                idx = labels.indexOf(value);
                index = idx !== -1 ? idx : index;
                if (isNaN(index)) index = value;
            }
            return me.getPixelForDecimal((index - me._startValue) / me._valueRange);
        },
        getPixelForTick: function(index) {
            var ticks = this.ticks;
            return index < 0 || index > ticks.length - 1 ? null : this.getPixelForValue(ticks[index], index + this.minIndex);
        },
        getValueForPixel: function(pixel) {
            var me = this;
            var value = Math.round(me._startValue + me.getDecimalForPixel(pixel) * me._valueRange);
            return Math.min(Math.max(value, 0), me.ticks.length - 1);
        },
        getBasePixel: function() {
            return this.bottom;
        }
    });
    // INTERNAL: static default options, registered in src/index.js
    var _defaults = defaultConfig;
    scale_category._defaults = _defaults;
    var noop = helpers$1.noop;
    var isNullOrUndef$2 = helpers$1.isNullOrUndef;
    /**
 * Generate a set of linear ticks
 * @param generationOptions the options used to generate the ticks
 * @param dataRange the range of the data
 * @returns {number[]} array of tick values
 */ function generateTicks(generationOptions, dataRange) {
        var ticks = [];
        // To get a "nice" value for the tick spacing, we will use the appropriately named
        // "nice number" algorithm. See https://stackoverflow.com/questions/8506881/nice-label-algorithm-for-charts-with-minimum-ticks
        // for details.
        var MIN_SPACING = 1e-14;
        var stepSize = generationOptions.stepSize;
        var unit = stepSize || 1;
        var maxNumSpaces = generationOptions.maxTicks - 1;
        var min = generationOptions.min;
        var max = generationOptions.max;
        var precision = generationOptions.precision;
        var rmin = dataRange.min;
        var rmax = dataRange.max;
        var spacing = helpers$1.niceNum((rmax - rmin) / maxNumSpaces / unit) * unit;
        var factor, niceMin, niceMax, numSpaces;
        // Beyond MIN_SPACING floating point numbers being to lose precision
        // such that we can't do the math necessary to generate ticks
        if (spacing < MIN_SPACING && isNullOrUndef$2(min) && isNullOrUndef$2(max)) return [
            rmin,
            rmax
        ];
        numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
        if (numSpaces > maxNumSpaces) // If the calculated num of spaces exceeds maxNumSpaces, recalculate it
        spacing = helpers$1.niceNum(numSpaces * spacing / maxNumSpaces / unit) * unit;
        if (stepSize || isNullOrUndef$2(precision)) // If a precision is not specified, calculate factor based on spacing
        factor = Math.pow(10, helpers$1._decimalPlaces(spacing));
        else {
            // If the user specified a precision, round to that number of decimal places
            factor = Math.pow(10, precision);
            spacing = Math.ceil(spacing * factor) / factor;
        }
        niceMin = Math.floor(rmin / spacing) * spacing;
        niceMax = Math.ceil(rmax / spacing) * spacing;
        // If min, max and stepSize is set and they make an evenly spaced scale use it.
        if (stepSize) {
            // If very close to our whole number, use it.
            if (!isNullOrUndef$2(min) && helpers$1.almostWhole(min / spacing, spacing / 1000)) niceMin = min;
            if (!isNullOrUndef$2(max) && helpers$1.almostWhole(max / spacing, spacing / 1000)) niceMax = max;
        }
        numSpaces = (niceMax - niceMin) / spacing;
        // If very close to our rounded value, use it.
        if (helpers$1.almostEquals(numSpaces, Math.round(numSpaces), spacing / 1000)) numSpaces = Math.round(numSpaces);
        else numSpaces = Math.ceil(numSpaces);
        niceMin = Math.round(niceMin * factor) / factor;
        niceMax = Math.round(niceMax * factor) / factor;
        ticks.push(isNullOrUndef$2(min) ? niceMin : min);
        for(var j = 1; j < numSpaces; ++j)ticks.push(Math.round((niceMin + j * spacing) * factor) / factor);
        ticks.push(isNullOrUndef$2(max) ? niceMax : max);
        return ticks;
    }
    var scale_linearbase = core_scale.extend({
        getRightValue: function(value) {
            if (typeof value === "string") return +value;
            return core_scale.prototype.getRightValue.call(this, value);
        },
        handleTickRangeOptions: function() {
            var me = this;
            var opts = me.options;
            var tickOpts = opts.ticks;
            // If we are forcing it to begin at 0, but 0 will already be rendered on the chart,
            // do nothing since that would make the chart weird. If the user really wants a weird chart
            // axis, they can manually override it
            if (tickOpts.beginAtZero) {
                var minSign = helpers$1.sign(me.min);
                var maxSign = helpers$1.sign(me.max);
                if (minSign < 0 && maxSign < 0) // move the top up to 0
                me.max = 0;
                else if (minSign > 0 && maxSign > 0) // move the bottom down to 0
                me.min = 0;
            }
            var setMin = tickOpts.min !== undefined || tickOpts.suggestedMin !== undefined;
            var setMax = tickOpts.max !== undefined || tickOpts.suggestedMax !== undefined;
            if (tickOpts.min !== undefined) me.min = tickOpts.min;
            else if (tickOpts.suggestedMin !== undefined) {
                if (me.min === null) me.min = tickOpts.suggestedMin;
                else me.min = Math.min(me.min, tickOpts.suggestedMin);
            }
            if (tickOpts.max !== undefined) me.max = tickOpts.max;
            else if (tickOpts.suggestedMax !== undefined) {
                if (me.max === null) me.max = tickOpts.suggestedMax;
                else me.max = Math.max(me.max, tickOpts.suggestedMax);
            }
            if (setMin !== setMax) // We set the min or the max but not both.
            // So ensure that our range is good
            // Inverted or 0 length range can happen when
            // ticks.min is set, and no datasets are visible
            {
                if (me.min >= me.max) {
                    if (setMin) me.max = me.min + 1;
                    else me.min = me.max - 1;
                }
            }
            if (me.min === me.max) {
                me.max++;
                if (!tickOpts.beginAtZero) me.min--;
            }
        },
        getTickLimit: function() {
            var me = this;
            var tickOpts = me.options.ticks;
            var stepSize = tickOpts.stepSize;
            var maxTicksLimit = tickOpts.maxTicksLimit;
            var maxTicks;
            if (stepSize) maxTicks = Math.ceil(me.max / stepSize) - Math.floor(me.min / stepSize) + 1;
            else {
                maxTicks = me._computeTickLimit();
                maxTicksLimit = maxTicksLimit || 11;
            }
            if (maxTicksLimit) maxTicks = Math.min(maxTicksLimit, maxTicks);
            return maxTicks;
        },
        _computeTickLimit: function() {
            return Number.POSITIVE_INFINITY;
        },
        handleDirectionalChanges: noop,
        buildTicks: function() {
            var me = this;
            var opts = me.options;
            var tickOpts = opts.ticks;
            // Figure out what the max number of ticks we can support it is based on the size of
            // the axis area. For now, we say that the minimum tick spacing in pixels must be 40
            // We also limit the maximum number of ticks to 11 which gives a nice 10 squares on
            // the graph. Make sure we always have at least 2 ticks
            var maxTicks = me.getTickLimit();
            maxTicks = Math.max(2, maxTicks);
            var numericGeneratorOptions = {
                maxTicks: maxTicks,
                min: tickOpts.min,
                max: tickOpts.max,
                precision: tickOpts.precision,
                stepSize: helpers$1.valueOrDefault(tickOpts.fixedStepSize, tickOpts.stepSize)
            };
            var ticks = me.ticks = generateTicks(numericGeneratorOptions, me);
            me.handleDirectionalChanges();
            // At this point, we need to update our max and min given the tick values since we have expanded the
            // range of the scale
            me.max = helpers$1.max(ticks);
            me.min = helpers$1.min(ticks);
            if (tickOpts.reverse) {
                ticks.reverse();
                me.start = me.max;
                me.end = me.min;
            } else {
                me.start = me.min;
                me.end = me.max;
            }
        },
        convertTicksToLabels: function() {
            var me = this;
            me.ticksAsNumbers = me.ticks.slice();
            me.zeroLineIndex = me.ticks.indexOf(0);
            core_scale.prototype.convertTicksToLabels.call(me);
        },
        _configure: function() {
            var me = this;
            var ticks = me.getTicks();
            var start = me.min;
            var end = me.max;
            var offset;
            core_scale.prototype._configure.call(me);
            if (me.options.offset && ticks.length) {
                offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
                start -= offset;
                end += offset;
            }
            me._startValue = start;
            me._endValue = end;
            me._valueRange = end - start;
        }
    });
    var defaultConfig$1 = {
        position: "left",
        ticks: {
            callback: core_ticks.formatters.linear
        }
    };
    var DEFAULT_MIN = 0;
    var DEFAULT_MAX = 1;
    function getOrCreateStack(stacks, stacked, meta) {
        var key = [
            meta.type,
            // we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
            stacked === undefined && meta.stack === undefined ? meta.index : "",
            meta.stack
        ].join(".");
        if (stacks[key] === undefined) stacks[key] = {
            pos: [],
            neg: []
        };
        return stacks[key];
    }
    function stackData(scale, stacks, meta, data) {
        var opts = scale.options;
        var stacked = opts.stacked;
        var stack = getOrCreateStack(stacks, stacked, meta);
        var pos = stack.pos;
        var neg = stack.neg;
        var ilen = data.length;
        var i, value;
        for(i = 0; i < ilen; ++i){
            value = scale._parseValue(data[i]);
            if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden) continue;
            pos[i] = pos[i] || 0;
            neg[i] = neg[i] || 0;
            if (opts.relativePoints) pos[i] = 100;
            else if (value.min < 0 || value.max < 0) neg[i] += value.min;
            else pos[i] += value.max;
        }
    }
    function updateMinMax(scale, meta, data) {
        var ilen = data.length;
        var i, value;
        for(i = 0; i < ilen; ++i){
            value = scale._parseValue(data[i]);
            if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden) continue;
            scale.min = Math.min(scale.min, value.min);
            scale.max = Math.max(scale.max, value.max);
        }
    }
    var scale_linear = scale_linearbase.extend({
        determineDataLimits: function() {
            var me = this;
            var opts = me.options;
            var chart = me.chart;
            var datasets = chart.data.datasets;
            var metasets = me._getMatchingVisibleMetas();
            var hasStacks = opts.stacked;
            var stacks = {};
            var ilen = metasets.length;
            var i, meta, data, values;
            me.min = Number.POSITIVE_INFINITY;
            me.max = Number.NEGATIVE_INFINITY;
            if (hasStacks === undefined) for(i = 0; !hasStacks && i < ilen; ++i){
                meta = metasets[i];
                hasStacks = meta.stack !== undefined;
            }
            for(i = 0; i < ilen; ++i){
                meta = metasets[i];
                data = datasets[meta.index].data;
                if (hasStacks) stackData(me, stacks, meta, data);
                else updateMinMax(me, meta, data);
            }
            helpers$1.each(stacks, function(stackValues) {
                values = stackValues.pos.concat(stackValues.neg);
                me.min = Math.min(me.min, helpers$1.min(values));
                me.max = Math.max(me.max, helpers$1.max(values));
            });
            me.min = helpers$1.isFinite(me.min) && !isNaN(me.min) ? me.min : DEFAULT_MIN;
            me.max = helpers$1.isFinite(me.max) && !isNaN(me.max) ? me.max : DEFAULT_MAX;
            // Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
            me.handleTickRangeOptions();
        },
        // Returns the maximum number of ticks based on the scale dimension
        _computeTickLimit: function() {
            var me = this;
            var tickFont;
            if (me.isHorizontal()) return Math.ceil(me.width / 40);
            tickFont = helpers$1.options._parseFont(me.options.ticks);
            return Math.ceil(me.height / tickFont.lineHeight);
        },
        // Called after the ticks are built. We need
        handleDirectionalChanges: function() {
            if (!this.isHorizontal()) // We are in a vertical orientation. The top value is the highest. So reverse the array
            this.ticks.reverse();
        },
        getLabelForIndex: function(index, datasetIndex) {
            return this._getScaleLabel(this.chart.data.datasets[datasetIndex].data[index]);
        },
        // Utils
        getPixelForValue: function(value) {
            var me = this;
            return me.getPixelForDecimal((+me.getRightValue(value) - me._startValue) / me._valueRange);
        },
        getValueForPixel: function(pixel) {
            return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
        },
        getPixelForTick: function(index) {
            var ticks = this.ticksAsNumbers;
            if (index < 0 || index > ticks.length - 1) return null;
            return this.getPixelForValue(ticks[index]);
        }
    });
    // INTERNAL: static default options, registered in src/index.js
    var _defaults$1 = defaultConfig$1;
    scale_linear._defaults = _defaults$1;
    var valueOrDefault$b = helpers$1.valueOrDefault;
    var log10 = helpers$1.math.log10;
    /**
 * Generate a set of logarithmic ticks
 * @param generationOptions the options used to generate the ticks
 * @param dataRange the range of the data
 * @returns {number[]} array of tick values
 */ function generateTicks$1(generationOptions, dataRange) {
        var ticks = [];
        var tickVal = valueOrDefault$b(generationOptions.min, Math.pow(10, Math.floor(log10(dataRange.min))));
        var endExp = Math.floor(log10(dataRange.max));
        var endSignificand = Math.ceil(dataRange.max / Math.pow(10, endExp));
        var exp, significand;
        if (tickVal === 0) {
            exp = Math.floor(log10(dataRange.minNotZero));
            significand = Math.floor(dataRange.minNotZero / Math.pow(10, exp));
            ticks.push(tickVal);
            tickVal = significand * Math.pow(10, exp);
        } else {
            exp = Math.floor(log10(tickVal));
            significand = Math.floor(tickVal / Math.pow(10, exp));
        }
        var precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;
        do {
            ticks.push(tickVal);
            ++significand;
            if (significand === 10) {
                significand = 1;
                ++exp;
                precision = exp >= 0 ? 1 : precision;
            }
            tickVal = Math.round(significand * Math.pow(10, exp) * precision) / precision;
        }while (exp < endExp || exp === endExp && significand < endSignificand);
        var lastTick = valueOrDefault$b(generationOptions.max, tickVal);
        ticks.push(lastTick);
        return ticks;
    }
    var defaultConfig$2 = {
        position: "left",
        // label settings
        ticks: {
            callback: core_ticks.formatters.logarithmic
        }
    };
    // TODO(v3): change this to positiveOrDefault
    function nonNegativeOrDefault(value, defaultValue) {
        return helpers$1.isFinite(value) && value >= 0 ? value : defaultValue;
    }
    var scale_logarithmic = core_scale.extend({
        determineDataLimits: function() {
            var me = this;
            var opts = me.options;
            var chart = me.chart;
            var datasets = chart.data.datasets;
            var isHorizontal = me.isHorizontal();
            function IDMatches(meta) {
                return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
            }
            var datasetIndex, meta, value, data, i, ilen;
            // Calculate Range
            me.min = Number.POSITIVE_INFINITY;
            me.max = Number.NEGATIVE_INFINITY;
            me.minNotZero = Number.POSITIVE_INFINITY;
            var hasStacks = opts.stacked;
            if (hasStacks === undefined) for(datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++){
                meta = chart.getDatasetMeta(datasetIndex);
                if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta) && meta.stack !== undefined) {
                    hasStacks = true;
                    break;
                }
            }
            if (opts.stacked || hasStacks) {
                var valuesPerStack = {};
                for(datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++){
                    meta = chart.getDatasetMeta(datasetIndex);
                    var key = [
                        meta.type,
                        // we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
                        opts.stacked === undefined && meta.stack === undefined ? datasetIndex : "",
                        meta.stack
                    ].join(".");
                    if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
                        if (valuesPerStack[key] === undefined) valuesPerStack[key] = [];
                        data = datasets[datasetIndex].data;
                        for(i = 0, ilen = data.length; i < ilen; i++){
                            var values = valuesPerStack[key];
                            value = me._parseValue(data[i]);
                            // invalid, hidden and negative values are ignored
                            if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden || value.min < 0 || value.max < 0) continue;
                            values[i] = values[i] || 0;
                            values[i] += value.max;
                        }
                    }
                }
                helpers$1.each(valuesPerStack, function(valuesForType) {
                    if (valuesForType.length > 0) {
                        var minVal = helpers$1.min(valuesForType);
                        var maxVal = helpers$1.max(valuesForType);
                        me.min = Math.min(me.min, minVal);
                        me.max = Math.max(me.max, maxVal);
                    }
                });
            } else for(datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++){
                meta = chart.getDatasetMeta(datasetIndex);
                if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
                    data = datasets[datasetIndex].data;
                    for(i = 0, ilen = data.length; i < ilen; i++){
                        value = me._parseValue(data[i]);
                        // invalid, hidden and negative values are ignored
                        if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden || value.min < 0 || value.max < 0) continue;
                        me.min = Math.min(value.min, me.min);
                        me.max = Math.max(value.max, me.max);
                        if (value.min !== 0) me.minNotZero = Math.min(value.min, me.minNotZero);
                    }
                }
            }
            me.min = helpers$1.isFinite(me.min) ? me.min : null;
            me.max = helpers$1.isFinite(me.max) ? me.max : null;
            me.minNotZero = helpers$1.isFinite(me.minNotZero) ? me.minNotZero : null;
            // Common base implementation to handle ticks.min, ticks.max
            this.handleTickRangeOptions();
        },
        handleTickRangeOptions: function() {
            var me = this;
            var tickOpts = me.options.ticks;
            var DEFAULT_MIN = 1;
            var DEFAULT_MAX = 10;
            me.min = nonNegativeOrDefault(tickOpts.min, me.min);
            me.max = nonNegativeOrDefault(tickOpts.max, me.max);
            if (me.min === me.max) {
                if (me.min !== 0 && me.min !== null) {
                    me.min = Math.pow(10, Math.floor(log10(me.min)) - 1);
                    me.max = Math.pow(10, Math.floor(log10(me.max)) + 1);
                } else {
                    me.min = DEFAULT_MIN;
                    me.max = DEFAULT_MAX;
                }
            }
            if (me.min === null) me.min = Math.pow(10, Math.floor(log10(me.max)) - 1);
            if (me.max === null) me.max = me.min !== 0 ? Math.pow(10, Math.floor(log10(me.min)) + 1) : DEFAULT_MAX;
            if (me.minNotZero === null) {
                if (me.min > 0) me.minNotZero = me.min;
                else if (me.max < 1) me.minNotZero = Math.pow(10, Math.floor(log10(me.max)));
                else me.minNotZero = DEFAULT_MIN;
            }
        },
        buildTicks: function() {
            var me = this;
            var tickOpts = me.options.ticks;
            var reverse = !me.isHorizontal();
            var generationOptions = {
                min: nonNegativeOrDefault(tickOpts.min),
                max: nonNegativeOrDefault(tickOpts.max)
            };
            var ticks = me.ticks = generateTicks$1(generationOptions, me);
            // At this point, we need to update our max and min given the tick values since we have expanded the
            // range of the scale
            me.max = helpers$1.max(ticks);
            me.min = helpers$1.min(ticks);
            if (tickOpts.reverse) {
                reverse = !reverse;
                me.start = me.max;
                me.end = me.min;
            } else {
                me.start = me.min;
                me.end = me.max;
            }
            if (reverse) ticks.reverse();
        },
        convertTicksToLabels: function() {
            this.tickValues = this.ticks.slice();
            core_scale.prototype.convertTicksToLabels.call(this);
        },
        // Get the correct tooltip label
        getLabelForIndex: function(index, datasetIndex) {
            return this._getScaleLabel(this.chart.data.datasets[datasetIndex].data[index]);
        },
        getPixelForTick: function(index) {
            var ticks = this.tickValues;
            if (index < 0 || index > ticks.length - 1) return null;
            return this.getPixelForValue(ticks[index]);
        },
        /**
	 * Returns the value of the first tick.
	 * @param {number} value - The minimum not zero value.
	 * @return {number} The first tick value.
	 * @private
	 */ _getFirstTickValue: function(value) {
            var exp = Math.floor(log10(value));
            var significand = Math.floor(value / Math.pow(10, exp));
            return significand * Math.pow(10, exp);
        },
        _configure: function() {
            var me = this;
            var start = me.min;
            var offset = 0;
            core_scale.prototype._configure.call(me);
            if (start === 0) {
                start = me._getFirstTickValue(me.minNotZero);
                offset = valueOrDefault$b(me.options.ticks.fontSize, core_defaults.global.defaultFontSize) / me._length;
            }
            me._startValue = log10(start);
            me._valueOffset = offset;
            me._valueRange = (log10(me.max) - log10(start)) / (1 - offset);
        },
        getPixelForValue: function(value) {
            var me = this;
            var decimal = 0;
            value = +me.getRightValue(value);
            if (value > me.min && value > 0) decimal = (log10(value) - me._startValue) / me._valueRange + me._valueOffset;
            return me.getPixelForDecimal(decimal);
        },
        getValueForPixel: function(pixel) {
            var me = this;
            var decimal = me.getDecimalForPixel(pixel);
            return decimal === 0 && me.min === 0 ? 0 : Math.pow(10, me._startValue + (decimal - me._valueOffset) * me._valueRange);
        }
    });
    // INTERNAL: static default options, registered in src/index.js
    var _defaults$2 = defaultConfig$2;
    scale_logarithmic._defaults = _defaults$2;
    var valueOrDefault$c = helpers$1.valueOrDefault;
    var valueAtIndexOrDefault$1 = helpers$1.valueAtIndexOrDefault;
    var resolve$4 = helpers$1.options.resolve;
    var defaultConfig$3 = {
        display: true,
        // Boolean - Whether to animate scaling the chart from the centre
        animate: true,
        position: "chartArea",
        angleLines: {
            display: true,
            color: "rgba(0,0,0,0.1)",
            lineWidth: 1,
            borderDash: [],
            borderDashOffset: 0.0
        },
        gridLines: {
            circular: false
        },
        // label settings
        ticks: {
            // Boolean - Show a backdrop to the scale label
            showLabelBackdrop: true,
            // String - The colour of the label backdrop
            backdropColor: "rgba(255,255,255,0.75)",
            // Number - The backdrop padding above & below the label in pixels
            backdropPaddingY: 2,
            // Number - The backdrop padding to the side of the label in pixels
            backdropPaddingX: 2,
            callback: core_ticks.formatters.linear
        },
        pointLabels: {
            // Boolean - if true, show point labels
            display: true,
            // Number - Point label font size in pixels
            fontSize: 10,
            // Function - Used to convert point labels
            callback: function(label) {
                return label;
            }
        }
    };
    function getTickBackdropHeight(opts) {
        var tickOpts = opts.ticks;
        if (tickOpts.display && opts.display) return valueOrDefault$c(tickOpts.fontSize, core_defaults.global.defaultFontSize) + tickOpts.backdropPaddingY * 2;
        return 0;
    }
    function measureLabelSize(ctx, lineHeight, label) {
        if (helpers$1.isArray(label)) return {
            w: helpers$1.longestText(ctx, ctx.font, label),
            h: label.length * lineHeight
        };
        return {
            w: ctx.measureText(label).width,
            h: lineHeight
        };
    }
    function determineLimits(angle, pos, size, min, max) {
        if (angle === min || angle === max) return {
            start: pos - size / 2,
            end: pos + size / 2
        };
        else if (angle < min || angle > max) return {
            start: pos - size,
            end: pos
        };
        return {
            start: pos,
            end: pos + size
        };
    }
    /**
 * Helper function to fit a radial linear scale with point labels
 */ function fitWithPointLabels(scale) {
        // Right, this is really confusing and there is a lot of maths going on here
        // The gist of the problem is here: https://gist.github.com/nnnick/696cc9c55f4b0beb8fe9
        //
        // Reaction: https://dl.dropboxusercontent.com/u/34601363/toomuchscience.gif
        //
        // Solution:
        //
        // We assume the radius of the polygon is half the size of the canvas at first
        // at each index we check if the text overlaps.
        //
        // Where it does, we store that angle and that index.
        //
        // After finding the largest index and angle we calculate how much we need to remove
        // from the shape radius to move the point inwards by that x.
        //
        // We average the left and right distances to get the maximum shape radius that can fit in the box
        // along with labels.
        //
        // Once we have that, we can find the centre point for the chart, by taking the x text protrusion
        // on each side, removing that from the size, halving it and adding the left x protrusion width.
        //
        // This will mean we have a shape fitted to the canvas, as large as it can be with the labels
        // and position it in the most space efficient manner
        //
        // https://dl.dropboxusercontent.com/u/34601363/yeahscience.gif
        var plFont = helpers$1.options._parseFont(scale.options.pointLabels);
        // Get maximum radius of the polygon. Either half the height (minus the text width) or half the width.
        // Use this to calculate the offset + change. - Make sure L/R protrusion is at least 0 to stop issues with centre points
        var furthestLimits = {
            l: 0,
            r: scale.width,
            t: 0,
            b: scale.height - scale.paddingTop
        };
        var furthestAngles = {};
        var i, textSize, pointPosition;
        scale.ctx.font = plFont.string;
        scale._pointLabelSizes = [];
        var valueCount = scale.chart.data.labels.length;
        for(i = 0; i < valueCount; i++){
            pointPosition = scale.getPointPosition(i, scale.drawingArea + 5);
            textSize = measureLabelSize(scale.ctx, plFont.lineHeight, scale.pointLabels[i]);
            scale._pointLabelSizes[i] = textSize;
            // Add quarter circle to make degree 0 mean top of circle
            var angleRadians = scale.getIndexAngle(i);
            var angle = helpers$1.toDegrees(angleRadians) % 360;
            var hLimits = determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
            var vLimits = determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
            if (hLimits.start < furthestLimits.l) {
                furthestLimits.l = hLimits.start;
                furthestAngles.l = angleRadians;
            }
            if (hLimits.end > furthestLimits.r) {
                furthestLimits.r = hLimits.end;
                furthestAngles.r = angleRadians;
            }
            if (vLimits.start < furthestLimits.t) {
                furthestLimits.t = vLimits.start;
                furthestAngles.t = angleRadians;
            }
            if (vLimits.end > furthestLimits.b) {
                furthestLimits.b = vLimits.end;
                furthestAngles.b = angleRadians;
            }
        }
        scale.setReductions(scale.drawingArea, furthestLimits, furthestAngles);
    }
    function getTextAlignForAngle(angle) {
        if (angle === 0 || angle === 180) return "center";
        else if (angle < 180) return "left";
        return "right";
    }
    function fillText(ctx, text, position, lineHeight) {
        var y = position.y + lineHeight / 2;
        var i, ilen;
        if (helpers$1.isArray(text)) for(i = 0, ilen = text.length; i < ilen; ++i){
            ctx.fillText(text[i], position.x, y);
            y += lineHeight;
        }
        else ctx.fillText(text, position.x, y);
    }
    function adjustPointPositionForLabelHeight(angle, textSize, position) {
        if (angle === 90 || angle === 270) position.y -= textSize.h / 2;
        else if (angle > 270 || angle < 90) position.y -= textSize.h;
    }
    function drawPointLabels(scale) {
        var ctx = scale.ctx;
        var opts = scale.options;
        var pointLabelOpts = opts.pointLabels;
        var tickBackdropHeight = getTickBackdropHeight(opts);
        var outerDistance = scale.getDistanceFromCenterForValue(opts.ticks.reverse ? scale.min : scale.max);
        var plFont = helpers$1.options._parseFont(pointLabelOpts);
        ctx.save();
        ctx.font = plFont.string;
        ctx.textBaseline = "middle";
        for(var i = scale.chart.data.labels.length - 1; i >= 0; i--){
            // Extra pixels out for some label spacing
            var extra = i === 0 ? tickBackdropHeight / 2 : 0;
            var pointLabelPosition = scale.getPointPosition(i, outerDistance + extra + 5);
            // Keep this in loop since we may support array properties here
            var pointLabelFontColor = valueAtIndexOrDefault$1(pointLabelOpts.fontColor, i, core_defaults.global.defaultFontColor);
            ctx.fillStyle = pointLabelFontColor;
            var angleRadians = scale.getIndexAngle(i);
            var angle = helpers$1.toDegrees(angleRadians);
            ctx.textAlign = getTextAlignForAngle(angle);
            adjustPointPositionForLabelHeight(angle, scale._pointLabelSizes[i], pointLabelPosition);
            fillText(ctx, scale.pointLabels[i], pointLabelPosition, plFont.lineHeight);
        }
        ctx.restore();
    }
    function drawRadiusLine(scale, gridLineOpts, radius, index) {
        var ctx = scale.ctx;
        var circular = gridLineOpts.circular;
        var valueCount = scale.chart.data.labels.length;
        var lineColor = valueAtIndexOrDefault$1(gridLineOpts.color, index - 1);
        var lineWidth = valueAtIndexOrDefault$1(gridLineOpts.lineWidth, index - 1);
        var pointPosition;
        if (!circular && !valueCount || !lineColor || !lineWidth) return;
        ctx.save();
        ctx.strokeStyle = lineColor;
        ctx.lineWidth = lineWidth;
        if (ctx.setLineDash) {
            ctx.setLineDash(gridLineOpts.borderDash || []);
            ctx.lineDashOffset = gridLineOpts.borderDashOffset || 0.0;
        }
        ctx.beginPath();
        if (circular) // Draw circular arcs between the points
        ctx.arc(scale.xCenter, scale.yCenter, radius, 0, Math.PI * 2);
        else {
            // Draw straight lines connecting each index
            pointPosition = scale.getPointPosition(0, radius);
            ctx.moveTo(pointPosition.x, pointPosition.y);
            for(var i = 1; i < valueCount; i++){
                pointPosition = scale.getPointPosition(i, radius);
                ctx.lineTo(pointPosition.x, pointPosition.y);
            }
        }
        ctx.closePath();
        ctx.stroke();
        ctx.restore();
    }
    function numberOrZero(param) {
        return helpers$1.isNumber(param) ? param : 0;
    }
    var scale_radialLinear = scale_linearbase.extend({
        setDimensions: function() {
            var me = this;
            // Set the unconstrained dimension before label rotation
            me.width = me.maxWidth;
            me.height = me.maxHeight;
            me.paddingTop = getTickBackdropHeight(me.options) / 2;
            me.xCenter = Math.floor(me.width / 2);
            me.yCenter = Math.floor((me.height - me.paddingTop) / 2);
            me.drawingArea = Math.min(me.height - me.paddingTop, me.width) / 2;
        },
        determineDataLimits: function() {
            var me = this;
            var chart = me.chart;
            var min = Number.POSITIVE_INFINITY;
            var max = Number.NEGATIVE_INFINITY;
            helpers$1.each(chart.data.datasets, function(dataset, datasetIndex) {
                if (chart.isDatasetVisible(datasetIndex)) {
                    var meta = chart.getDatasetMeta(datasetIndex);
                    helpers$1.each(dataset.data, function(rawValue, index) {
                        var value = +me.getRightValue(rawValue);
                        if (isNaN(value) || meta.data[index].hidden) return;
                        min = Math.min(value, min);
                        max = Math.max(value, max);
                    });
                }
            });
            me.min = min === Number.POSITIVE_INFINITY ? 0 : min;
            me.max = max === Number.NEGATIVE_INFINITY ? 0 : max;
            // Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
            me.handleTickRangeOptions();
        },
        // Returns the maximum number of ticks based on the scale dimension
        _computeTickLimit: function() {
            return Math.ceil(this.drawingArea / getTickBackdropHeight(this.options));
        },
        convertTicksToLabels: function() {
            var me = this;
            scale_linearbase.prototype.convertTicksToLabels.call(me);
            // Point labels
            me.pointLabels = me.chart.data.labels.map(function() {
                var label = helpers$1.callback(me.options.pointLabels.callback, arguments, me);
                return label || label === 0 ? label : "";
            });
        },
        getLabelForIndex: function(index, datasetIndex) {
            return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
        },
        fit: function() {
            var me = this;
            var opts = me.options;
            if (opts.display && opts.pointLabels.display) fitWithPointLabels(me);
            else me.setCenterPoint(0, 0, 0, 0);
        },
        /**
	 * Set radius reductions and determine new radius and center point
	 * @private
	 */ setReductions: function(largestPossibleRadius, furthestLimits, furthestAngles) {
            var me = this;
            var radiusReductionLeft = furthestLimits.l / Math.sin(furthestAngles.l);
            var radiusReductionRight = Math.max(furthestLimits.r - me.width, 0) / Math.sin(furthestAngles.r);
            var radiusReductionTop = -furthestLimits.t / Math.cos(furthestAngles.t);
            var radiusReductionBottom = -Math.max(furthestLimits.b - (me.height - me.paddingTop), 0) / Math.cos(furthestAngles.b);
            radiusReductionLeft = numberOrZero(radiusReductionLeft);
            radiusReductionRight = numberOrZero(radiusReductionRight);
            radiusReductionTop = numberOrZero(radiusReductionTop);
            radiusReductionBottom = numberOrZero(radiusReductionBottom);
            me.drawingArea = Math.min(Math.floor(largestPossibleRadius - (radiusReductionLeft + radiusReductionRight) / 2), Math.floor(largestPossibleRadius - (radiusReductionTop + radiusReductionBottom) / 2));
            me.setCenterPoint(radiusReductionLeft, radiusReductionRight, radiusReductionTop, radiusReductionBottom);
        },
        setCenterPoint: function(leftMovement, rightMovement, topMovement, bottomMovement) {
            var me = this;
            var maxRight = me.width - rightMovement - me.drawingArea;
            var maxLeft = leftMovement + me.drawingArea;
            var maxTop = topMovement + me.drawingArea;
            var maxBottom = me.height - me.paddingTop - bottomMovement - me.drawingArea;
            me.xCenter = Math.floor((maxLeft + maxRight) / 2 + me.left);
            me.yCenter = Math.floor((maxTop + maxBottom) / 2 + me.top + me.paddingTop);
        },
        getIndexAngle: function(index) {
            var chart = this.chart;
            var angleMultiplier = 360 / chart.data.labels.length;
            var options = chart.options || {};
            var startAngle = options.startAngle || 0;
            // Start from the top instead of right, so remove a quarter of the circle
            var angle = (index * angleMultiplier + startAngle) % 360;
            return (angle < 0 ? angle + 360 : angle) * Math.PI * 2 / 360;
        },
        getDistanceFromCenterForValue: function(value) {
            var me = this;
            if (helpers$1.isNullOrUndef(value)) return NaN;
            // Take into account half font size + the yPadding of the top value
            var scalingFactor = me.drawingArea / (me.max - me.min);
            if (me.options.ticks.reverse) return (me.max - value) * scalingFactor;
            return (value - me.min) * scalingFactor;
        },
        getPointPosition: function(index, distanceFromCenter) {
            var me = this;
            var thisAngle = me.getIndexAngle(index) - Math.PI / 2;
            return {
                x: Math.cos(thisAngle) * distanceFromCenter + me.xCenter,
                y: Math.sin(thisAngle) * distanceFromCenter + me.yCenter
            };
        },
        getPointPositionForValue: function(index, value) {
            return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
        },
        getBasePosition: function(index) {
            var me = this;
            var min = me.min;
            var max = me.max;
            return me.getPointPositionForValue(index || 0, me.beginAtZero ? 0 : min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0);
        },
        /**
	 * @private
	 */ _drawGrid: function() {
            var me = this;
            var ctx = me.ctx;
            var opts = me.options;
            var gridLineOpts = opts.gridLines;
            var angleLineOpts = opts.angleLines;
            var lineWidth = valueOrDefault$c(angleLineOpts.lineWidth, gridLineOpts.lineWidth);
            var lineColor = valueOrDefault$c(angleLineOpts.color, gridLineOpts.color);
            var i, offset, position;
            if (opts.pointLabels.display) drawPointLabels(me);
            if (gridLineOpts.display) helpers$1.each(me.ticks, function(label, index) {
                if (index !== 0) {
                    offset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);
                    drawRadiusLine(me, gridLineOpts, offset, index);
                }
            });
            if (angleLineOpts.display && lineWidth && lineColor) {
                ctx.save();
                ctx.lineWidth = lineWidth;
                ctx.strokeStyle = lineColor;
                if (ctx.setLineDash) {
                    ctx.setLineDash(resolve$4([
                        angleLineOpts.borderDash,
                        gridLineOpts.borderDash,
                        []
                    ]));
                    ctx.lineDashOffset = resolve$4([
                        angleLineOpts.borderDashOffset,
                        gridLineOpts.borderDashOffset,
                        0.0
                    ]);
                }
                for(i = me.chart.data.labels.length - 1; i >= 0; i--){
                    offset = me.getDistanceFromCenterForValue(opts.ticks.reverse ? me.min : me.max);
                    position = me.getPointPosition(i, offset);
                    ctx.beginPath();
                    ctx.moveTo(me.xCenter, me.yCenter);
                    ctx.lineTo(position.x, position.y);
                    ctx.stroke();
                }
                ctx.restore();
            }
        },
        /**
	 * @private
	 */ _drawLabels: function() {
            var me = this;
            var ctx = me.ctx;
            var opts = me.options;
            var tickOpts = opts.ticks;
            if (!tickOpts.display) return;
            var startAngle = me.getIndexAngle(0);
            var tickFont = helpers$1.options._parseFont(tickOpts);
            var tickFontColor = valueOrDefault$c(tickOpts.fontColor, core_defaults.global.defaultFontColor);
            var offset, width;
            ctx.save();
            ctx.font = tickFont.string;
            ctx.translate(me.xCenter, me.yCenter);
            ctx.rotate(startAngle);
            ctx.textAlign = "center";
            ctx.textBaseline = "middle";
            helpers$1.each(me.ticks, function(label, index) {
                if (index === 0 && !tickOpts.reverse) return;
                offset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);
                if (tickOpts.showLabelBackdrop) {
                    width = ctx.measureText(label).width;
                    ctx.fillStyle = tickOpts.backdropColor;
                    ctx.fillRect(-width / 2 - tickOpts.backdropPaddingX, -offset - tickFont.size / 2 - tickOpts.backdropPaddingY, width + tickOpts.backdropPaddingX * 2, tickFont.size + tickOpts.backdropPaddingY * 2);
                }
                ctx.fillStyle = tickFontColor;
                ctx.fillText(label, 0, -offset);
            });
            ctx.restore();
        },
        /**
	 * @private
	 */ _drawTitle: helpers$1.noop
    });
    // INTERNAL: static default options, registered in src/index.js
    var _defaults$3 = defaultConfig$3;
    scale_radialLinear._defaults = _defaults$3;
    var deprecated$1 = helpers$1._deprecated;
    var resolve$5 = helpers$1.options.resolve;
    var valueOrDefault$d = helpers$1.valueOrDefault;
    // Integer constants are from the ES6 spec.
    var MIN_INTEGER = Number.MIN_SAFE_INTEGER || -9007199254740991;
    var MAX_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;
    var INTERVALS = {
        millisecond: {
            common: true,
            size: 1,
            steps: 1000
        },
        second: {
            common: true,
            size: 1000,
            steps: 60
        },
        minute: {
            common: true,
            size: 60000,
            steps: 60
        },
        hour: {
            common: true,
            size: 3600000,
            steps: 24
        },
        day: {
            common: true,
            size: 86400000,
            steps: 30
        },
        week: {
            common: false,
            size: 604800000,
            steps: 4
        },
        month: {
            common: true,
            size: 2.628e9,
            steps: 12
        },
        quarter: {
            common: false,
            size: 7.884e9,
            steps: 4
        },
        year: {
            common: true,
            size: 3.154e10
        }
    };
    var UNITS = Object.keys(INTERVALS);
    function sorter(a, b) {
        return a - b;
    }
    function arrayUnique(items) {
        var hash = {};
        var out = [];
        var i, ilen, item;
        for(i = 0, ilen = items.length; i < ilen; ++i){
            item = items[i];
            if (!hash[item]) {
                hash[item] = true;
                out.push(item);
            }
        }
        return out;
    }
    function getMin(options) {
        return helpers$1.valueOrDefault(options.time.min, options.ticks.min);
    }
    function getMax(options) {
        return helpers$1.valueOrDefault(options.time.max, options.ticks.max);
    }
    /**
 * Returns an array of {time, pos} objects used to interpolate a specific `time` or position
 * (`pos`) on the scale, by searching entries before and after the requested value. `pos` is
 * a decimal between 0 and 1: 0 being the start of the scale (left or top) and 1 the other
 * extremity (left + width or top + height). Note that it would be more optimized to directly
 * store pre-computed pixels, but the scale dimensions are not guaranteed at the time we need
 * to create the lookup table. The table ALWAYS contains at least two items: min and max.
 *
 * @param {number[]} timestamps - timestamps sorted from lowest to highest.
 * @param {string} distribution - If 'linear', timestamps will be spread linearly along the min
 * and max range, so basically, the table will contains only two items: {min, 0} and {max, 1}.
 * If 'series', timestamps will be positioned at the same distance from each other. In this
 * case, only timestamps that break the time linearity are registered, meaning that in the
 * best case, all timestamps are linear, the table contains only min and max.
 */ function buildLookupTable(timestamps, min, max, distribution) {
        if (distribution === "linear" || !timestamps.length) return [
            {
                time: min,
                pos: 0
            },
            {
                time: max,
                pos: 1
            }
        ];
        var table = [];
        var items = [
            min
        ];
        var i, ilen, prev, curr, next;
        for(i = 0, ilen = timestamps.length; i < ilen; ++i){
            curr = timestamps[i];
            if (curr > min && curr < max) items.push(curr);
        }
        items.push(max);
        for(i = 0, ilen = items.length; i < ilen; ++i){
            next = items[i + 1];
            prev = items[i - 1];
            curr = items[i];
            // only add points that breaks the scale linearity
            if (prev === undefined || next === undefined || Math.round((next + prev) / 2) !== curr) table.push({
                time: curr,
                pos: i / (ilen - 1)
            });
        }
        return table;
    }
    // @see adapted from https://www.anujgakhar.com/2014/03/01/binary-search-in-javascript/
    function lookup(table, key, value) {
        var lo = 0;
        var hi = table.length - 1;
        var mid, i0, i1;
        while(lo >= 0 && lo <= hi){
            mid = lo + hi >> 1;
            i0 = table[mid - 1] || null;
            i1 = table[mid];
            if (!i0) // given value is outside table (before first item)
            return {
                lo: null,
                hi: i1
            };
            else if (i1[key] < value) lo = mid + 1;
            else if (i0[key] > value) hi = mid - 1;
            else return {
                lo: i0,
                hi: i1
            };
        }
        // given value is outside table (after last item)
        return {
            lo: i1,
            hi: null
        };
    }
    /**
 * Linearly interpolates the given source `value` using the table items `skey` values and
 * returns the associated `tkey` value. For example, interpolate(table, 'time', 42, 'pos')
 * returns the position for a timestamp equal to 42. If value is out of bounds, values at
 * index [0, 1] or [n - 1, n] are used for the interpolation.
 */ function interpolate$1(table, skey, sval, tkey) {
        var range = lookup(table, skey, sval);
        // Note: the lookup table ALWAYS contains at least 2 items (min and max)
        var prev = !range.lo ? table[0] : !range.hi ? table[table.length - 2] : range.lo;
        var next = !range.lo ? table[1] : !range.hi ? table[table.length - 1] : range.hi;
        var span = next[skey] - prev[skey];
        var ratio = span ? (sval - prev[skey]) / span : 0;
        var offset = (next[tkey] - prev[tkey]) * ratio;
        return prev[tkey] + offset;
    }
    function toTimestamp(scale, input) {
        var adapter = scale._adapter;
        var options = scale.options.time;
        var parser = options.parser;
        var format = parser || options.format;
        var value = input;
        if (typeof parser === "function") value = parser(value);
        // Only parse if its not a timestamp already
        if (!helpers$1.isFinite(value)) value = typeof format === "string" ? adapter.parse(value, format) : adapter.parse(value);
        if (value !== null) return +value;
        // Labels are in an incompatible format and no `parser` has been provided.
        // The user might still use the deprecated `format` option for parsing.
        if (!parser && typeof format === "function") {
            value = format(input);
            // `format` could return something else than a timestamp, if so, parse it
            if (!helpers$1.isFinite(value)) value = adapter.parse(value);
        }
        return value;
    }
    function parse(scale, input) {
        if (helpers$1.isNullOrUndef(input)) return null;
        var options = scale.options.time;
        var value = toTimestamp(scale, scale.getRightValue(input));
        if (value === null) return value;
        if (options.round) value = +scale._adapter.startOf(value, options.round);
        return value;
    }
    /**
 * Figures out what unit results in an appropriate number of auto-generated ticks
 */ function determineUnitForAutoTicks(minUnit, min, max, capacity) {
        var ilen = UNITS.length;
        var i, interval, factor;
        for(i = UNITS.indexOf(minUnit); i < ilen - 1; ++i){
            interval = INTERVALS[UNITS[i]];
            factor = interval.steps ? interval.steps : MAX_INTEGER;
            if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) return UNITS[i];
        }
        return UNITS[ilen - 1];
    }
    /**
 * Figures out what unit to format a set of ticks with
 */ function determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
        var i, unit;
        for(i = UNITS.length - 1; i >= UNITS.indexOf(minUnit); i--){
            unit = UNITS[i];
            if (INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) return unit;
        }
        return UNITS[minUnit ? UNITS.indexOf(minUnit) : 0];
    }
    function determineMajorUnit(unit) {
        for(var i = UNITS.indexOf(unit) + 1, ilen = UNITS.length; i < ilen; ++i){
            if (INTERVALS[UNITS[i]].common) return UNITS[i];
        }
    }
    /**
 * Generates a maximum of `capacity` timestamps between min and max, rounded to the
 * `minor` unit using the given scale time `options`.
 * Important: this method can return ticks outside the min and max range, it's the
 * responsibility of the calling code to clamp values if needed.
 */ function generate(scale, min, max, capacity) {
        var adapter = scale._adapter;
        var options = scale.options;
        var timeOpts = options.time;
        var minor = timeOpts.unit || determineUnitForAutoTicks(timeOpts.minUnit, min, max, capacity);
        var stepSize = resolve$5([
            timeOpts.stepSize,
            timeOpts.unitStepSize,
            1
        ]);
        var weekday = minor === "week" ? timeOpts.isoWeekday : false;
        var first = min;
        var ticks = [];
        var time;
        // For 'week' unit, handle the first day of week option
        if (weekday) first = +adapter.startOf(first, "isoWeek", weekday);
        // Align first ticks on unit
        first = +adapter.startOf(first, weekday ? "day" : minor);
        // Prevent browser from freezing in case user options request millions of milliseconds
        if (adapter.diff(max, min, minor) > 100000 * stepSize) throw min + " and " + max + " are too far apart with stepSize of " + stepSize + " " + minor;
        for(time = first; time < max; time = +adapter.add(time, stepSize, minor))ticks.push(time);
        if (time === max || options.bounds === "ticks") ticks.push(time);
        return ticks;
    }
    /**
 * Returns the start and end offsets from edges in the form of {start, end}
 * where each value is a relative width to the scale and ranges between 0 and 1.
 * They add extra margins on the both sides by scaling down the original scale.
 * Offsets are added when the `offset` option is true.
 */ function computeOffsets(table, ticks, min, max, options) {
        var start = 0;
        var end = 0;
        var first, last;
        if (options.offset && ticks.length) {
            first = interpolate$1(table, "time", ticks[0], "pos");
            if (ticks.length === 1) start = 1 - first;
            else start = (interpolate$1(table, "time", ticks[1], "pos") - first) / 2;
            last = interpolate$1(table, "time", ticks[ticks.length - 1], "pos");
            if (ticks.length === 1) end = last;
            else end = (last - interpolate$1(table, "time", ticks[ticks.length - 2], "pos")) / 2;
        }
        return {
            start: start,
            end: end,
            factor: 1 / (start + 1 + end)
        };
    }
    function setMajorTicks(scale, ticks, map, majorUnit) {
        var adapter = scale._adapter;
        var first = +adapter.startOf(ticks[0].value, majorUnit);
        var last = ticks[ticks.length - 1].value;
        var major, index;
        for(major = first; major <= last; major = +adapter.add(major, 1, majorUnit)){
            index = map[major];
            if (index >= 0) ticks[index].major = true;
        }
        return ticks;
    }
    function ticksFromTimestamps(scale, values, majorUnit) {
        var ticks = [];
        var map = {};
        var ilen = values.length;
        var i, value;
        for(i = 0; i < ilen; ++i){
            value = values[i];
            map[value] = i;
            ticks.push({
                value: value,
                major: false
            });
        }
        // We set the major ticks separately from the above loop because calling startOf for every tick
        // is expensive when there is a large number of ticks
        return ilen === 0 || !majorUnit ? ticks : setMajorTicks(scale, ticks, map, majorUnit);
    }
    var defaultConfig$4 = {
        position: "bottom",
        /**
	 * Data distribution along the scale:
	 * - 'linear': data are spread according to their time (distances can vary),
	 * - 'series': data are spread at the same distance from each other.
	 * @see https://github.com/chartjs/Chart.js/pull/4507
	 * @since 2.7.0
	 */ distribution: "linear",
        /**
	 * Scale boundary strategy (bypassed by min/max time options)
	 * - `data`: make sure data are fully visible, ticks outside are removed
	 * - `ticks`: make sure ticks are fully visible, data outside are truncated
	 * @see https://github.com/chartjs/Chart.js/pull/4556
	 * @since 2.7.0
	 */ bounds: "data",
        adapters: {},
        time: {
            parser: false,
            unit: false,
            round: false,
            displayFormat: false,
            isoWeekday: false,
            minUnit: "millisecond",
            displayFormats: {}
        },
        ticks: {
            autoSkip: false,
            /**
		 * Ticks generation input values:
		 * - 'auto': generates "optimal" ticks based on scale size and time options.
		 * - 'data': generates ticks from data (including labels from data {t|x|y} objects).
		 * - 'labels': generates ticks from user given `data.labels` values ONLY.
		 * @see https://github.com/chartjs/Chart.js/pull/4507
		 * @since 2.7.0
		 */ source: "auto",
            major: {
                enabled: false
            }
        }
    };
    var scale_time = core_scale.extend({
        initialize: function() {
            this.mergeTicksOptions();
            core_scale.prototype.initialize.call(this);
        },
        update: function() {
            var me = this;
            var options = me.options;
            var time = options.time || (options.time = {});
            var adapter = me._adapter = new core_adapters._date(options.adapters.date);
            // DEPRECATIONS: output a message only one time per update
            deprecated$1("time scale", time.format, "time.format", "time.parser");
            deprecated$1("time scale", time.min, "time.min", "ticks.min");
            deprecated$1("time scale", time.max, "time.max", "ticks.max");
            // Backward compatibility: before introducing adapter, `displayFormats` was
            // supposed to contain *all* unit/string pairs but this can't be resolved
            // when loading the scale (adapters are loaded afterward), so let's populate
            // missing formats on update
            helpers$1.mergeIf(time.displayFormats, adapter.formats());
            return core_scale.prototype.update.apply(me, arguments);
        },
        /**
	 * Allows data to be referenced via 't' attribute
	 */ getRightValue: function(rawValue) {
            if (rawValue && rawValue.t !== undefined) rawValue = rawValue.t;
            return core_scale.prototype.getRightValue.call(this, rawValue);
        },
        determineDataLimits: function() {
            var me = this;
            var chart = me.chart;
            var adapter = me._adapter;
            var options = me.options;
            var unit = options.time.unit || "day";
            var min = MAX_INTEGER;
            var max = MIN_INTEGER;
            var timestamps = [];
            var datasets = [];
            var labels = [];
            var i, j, ilen, jlen, data, timestamp, labelsAdded;
            var dataLabels = me._getLabels();
            for(i = 0, ilen = dataLabels.length; i < ilen; ++i)labels.push(parse(me, dataLabels[i]));
            for(i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i)if (chart.isDatasetVisible(i)) {
                data = chart.data.datasets[i].data;
                // Let's consider that all data have the same format.
                if (helpers$1.isObject(data[0])) {
                    datasets[i] = [];
                    for(j = 0, jlen = data.length; j < jlen; ++j){
                        timestamp = parse(me, data[j]);
                        timestamps.push(timestamp);
                        datasets[i][j] = timestamp;
                    }
                } else {
                    datasets[i] = labels.slice(0);
                    if (!labelsAdded) {
                        timestamps = timestamps.concat(labels);
                        labelsAdded = true;
                    }
                }
            } else datasets[i] = [];
            if (labels.length) {
                min = Math.min(min, labels[0]);
                max = Math.max(max, labels[labels.length - 1]);
            }
            if (timestamps.length) {
                timestamps = ilen > 1 ? arrayUnique(timestamps).sort(sorter) : timestamps.sort(sorter);
                min = Math.min(min, timestamps[0]);
                max = Math.max(max, timestamps[timestamps.length - 1]);
            }
            min = parse(me, getMin(options)) || min;
            max = parse(me, getMax(options)) || max;
            // In case there is no valid min/max, set limits based on unit time option
            min = min === MAX_INTEGER ? +adapter.startOf(Date.now(), unit) : min;
            max = max === MIN_INTEGER ? +adapter.endOf(Date.now(), unit) + 1 : max;
            // Make sure that max is strictly higher than min (required by the lookup table)
            me.min = Math.min(min, max);
            me.max = Math.max(min + 1, max);
            // PRIVATE
            me._table = [];
            me._timestamps = {
                data: timestamps,
                datasets: datasets,
                labels: labels
            };
        },
        buildTicks: function() {
            var me = this;
            var min = me.min;
            var max = me.max;
            var options = me.options;
            var tickOpts = options.ticks;
            var timeOpts = options.time;
            var timestamps = me._timestamps;
            var ticks = [];
            var capacity = me.getLabelCapacity(min);
            var source = tickOpts.source;
            var distribution = options.distribution;
            var i, ilen, timestamp;
            if (source === "data" || source === "auto" && distribution === "series") timestamps = timestamps.data;
            else if (source === "labels") timestamps = timestamps.labels;
            else timestamps = generate(me, min, max, capacity);
            if (options.bounds === "ticks" && timestamps.length) {
                min = timestamps[0];
                max = timestamps[timestamps.length - 1];
            }
            // Enforce limits with user min/max options
            min = parse(me, getMin(options)) || min;
            max = parse(me, getMax(options)) || max;
            // Remove ticks outside the min/max range
            for(i = 0, ilen = timestamps.length; i < ilen; ++i){
                timestamp = timestamps[i];
                if (timestamp >= min && timestamp <= max) ticks.push(timestamp);
            }
            me.min = min;
            me.max = max;
            // PRIVATE
            // determineUnitForFormatting relies on the number of ticks so we don't use it when
            // autoSkip is enabled because we don't yet know what the final number of ticks will be
            me._unit = timeOpts.unit || (tickOpts.autoSkip ? determineUnitForAutoTicks(timeOpts.minUnit, me.min, me.max, capacity) : determineUnitForFormatting(me, ticks.length, timeOpts.minUnit, me.min, me.max));
            me._majorUnit = !tickOpts.major.enabled || me._unit === "year" ? undefined : determineMajorUnit(me._unit);
            me._table = buildLookupTable(me._timestamps.data, min, max, distribution);
            me._offsets = computeOffsets(me._table, ticks, min, max, options);
            if (tickOpts.reverse) ticks.reverse();
            return ticksFromTimestamps(me, ticks, me._majorUnit);
        },
        getLabelForIndex: function(index, datasetIndex) {
            var me = this;
            var adapter = me._adapter;
            var data = me.chart.data;
            var timeOpts = me.options.time;
            var label = data.labels && index < data.labels.length ? data.labels[index] : "";
            var value = data.datasets[datasetIndex].data[index];
            if (helpers$1.isObject(value)) label = me.getRightValue(value);
            if (timeOpts.tooltipFormat) return adapter.format(toTimestamp(me, label), timeOpts.tooltipFormat);
            if (typeof label === "string") return label;
            return adapter.format(toTimestamp(me, label), timeOpts.displayFormats.datetime);
        },
        /**
	 * Function to format an individual tick mark
	 * @private
	 */ tickFormatFunction: function(time, index, ticks, format) {
            var me = this;
            var adapter = me._adapter;
            var options = me.options;
            var formats = options.time.displayFormats;
            var minorFormat = formats[me._unit];
            var majorUnit = me._majorUnit;
            var majorFormat = formats[majorUnit];
            var tick = ticks[index];
            var tickOpts = options.ticks;
            var major = majorUnit && majorFormat && tick && tick.major;
            var label = adapter.format(time, format ? format : major ? majorFormat : minorFormat);
            var nestedTickOpts = major ? tickOpts.major : tickOpts.minor;
            var formatter = resolve$5([
                nestedTickOpts.callback,
                nestedTickOpts.userCallback,
                tickOpts.callback,
                tickOpts.userCallback
            ]);
            return formatter ? formatter(label, index, ticks) : label;
        },
        convertTicksToLabels: function(ticks) {
            var labels = [];
            var i, ilen;
            for(i = 0, ilen = ticks.length; i < ilen; ++i)labels.push(this.tickFormatFunction(ticks[i].value, i, ticks));
            return labels;
        },
        /**
	 * @private
	 */ getPixelForOffset: function(time) {
            var me = this;
            var offsets = me._offsets;
            var pos = interpolate$1(me._table, "time", time, "pos");
            return me.getPixelForDecimal((offsets.start + pos) * offsets.factor);
        },
        getPixelForValue: function(value, index, datasetIndex) {
            var me = this;
            var time = null;
            if (index !== undefined && datasetIndex !== undefined) time = me._timestamps.datasets[datasetIndex][index];
            if (time === null) time = parse(me, value);
            if (time !== null) return me.getPixelForOffset(time);
        },
        getPixelForTick: function(index) {
            var ticks = this.getTicks();
            return index >= 0 && index < ticks.length ? this.getPixelForOffset(ticks[index].value) : null;
        },
        getValueForPixel: function(pixel) {
            var me = this;
            var offsets = me._offsets;
            var pos = me.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
            var time = interpolate$1(me._table, "pos", pos, "time");
            // DEPRECATION, we should return time directly
            return me._adapter._create(time);
        },
        /**
	 * @private
	 */ _getLabelSize: function(label) {
            var me = this;
            var ticksOpts = me.options.ticks;
            var tickLabelWidth = me.ctx.measureText(label).width;
            var angle = helpers$1.toRadians(me.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
            var cosRotation = Math.cos(angle);
            var sinRotation = Math.sin(angle);
            var tickFontSize = valueOrDefault$d(ticksOpts.fontSize, core_defaults.global.defaultFontSize);
            return {
                w: tickLabelWidth * cosRotation + tickFontSize * sinRotation,
                h: tickLabelWidth * sinRotation + tickFontSize * cosRotation
            };
        },
        /**
	 * Crude approximation of what the label width might be
	 * @private
	 */ getLabelWidth: function(label) {
            return this._getLabelSize(label).w;
        },
        /**
	 * @private
	 */ getLabelCapacity: function(exampleTime) {
            var me = this;
            var timeOpts = me.options.time;
            var displayFormats = timeOpts.displayFormats;
            // pick the longest format (milliseconds) for guestimation
            var format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
            var exampleLabel = me.tickFormatFunction(exampleTime, 0, ticksFromTimestamps(me, [
                exampleTime
            ], me._majorUnit), format);
            var size = me._getLabelSize(exampleLabel);
            var capacity = Math.floor(me.isHorizontal() ? me.width / size.w : me.height / size.h);
            if (me.options.offset) capacity--;
            return capacity > 0 ? capacity : 1;
        }
    });
    // INTERNAL: static default options, registered in src/index.js
    var _defaults$4 = defaultConfig$4;
    scale_time._defaults = _defaults$4;
    var scales = {
        category: scale_category,
        linear: scale_linear,
        logarithmic: scale_logarithmic,
        radialLinear: scale_radialLinear,
        time: scale_time
    };
    var FORMATS = {
        datetime: "MMM D, YYYY, h:mm:ss a",
        millisecond: "h:mm:ss.SSS a",
        second: "h:mm:ss a",
        minute: "h:mm a",
        hour: "hA",
        day: "MMM D",
        week: "ll",
        month: "MMM YYYY",
        quarter: "[Q]Q - YYYY",
        year: "YYYY"
    };
    core_adapters._date.override(typeof moment === "function" ? {
        _id: "moment",
        formats: function() {
            return FORMATS;
        },
        parse: function(value, format) {
            if (typeof value === "string" && typeof format === "string") value = moment(value, format);
            else if (!(value instanceof moment)) value = moment(value);
            return value.isValid() ? value.valueOf() : null;
        },
        format: function(time, format) {
            return moment(time).format(format);
        },
        add: function(time, amount, unit) {
            return moment(time).add(amount, unit).valueOf();
        },
        diff: function(max, min, unit) {
            return moment(max).diff(moment(min), unit);
        },
        startOf: function(time, unit, weekday) {
            time = moment(time);
            if (unit === "isoWeek") return time.isoWeekday(weekday).valueOf();
            return time.startOf(unit).valueOf();
        },
        endOf: function(time, unit) {
            return moment(time).endOf(unit).valueOf();
        },
        // DEPRECATIONS
        /**
	 * Provided for backward compatibility with scale.getValueForPixel().
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 * @private
	 */ _create: function(time) {
            return moment(time);
        }
    } : {});
    core_defaults._set("global", {
        plugins: {
            filler: {
                propagate: true
            }
        }
    });
    var mappers = {
        dataset: function(source) {
            var index = source.fill;
            var chart = source.chart;
            var meta = chart.getDatasetMeta(index);
            var visible = meta && chart.isDatasetVisible(index);
            var points = visible && meta.dataset._children || [];
            var length = points.length || 0;
            return !length ? null : function(point, i) {
                return i < length && points[i]._view || null;
            };
        },
        boundary: function(source) {
            var boundary = source.boundary;
            var x = boundary ? boundary.x : null;
            var y = boundary ? boundary.y : null;
            if (helpers$1.isArray(boundary)) return function(point, i) {
                return boundary[i];
            };
            return function(point) {
                return {
                    x: x === null ? point.x : x,
                    y: y === null ? point.y : y
                };
            };
        }
    };
    // @todo if (fill[0] === '#')
    function decodeFill(el, index, count) {
        var model = el._model || {};
        var fill = model.fill;
        var target;
        if (fill === undefined) fill = !!model.backgroundColor;
        if (fill === false || fill === null) return false;
        if (fill === true) return "origin";
        target = parseFloat(fill, 10);
        if (isFinite(target) && Math.floor(target) === target) {
            if (fill[0] === "-" || fill[0] === "+") target = index + target;
            if (target === index || target < 0 || target >= count) return false;
            return target;
        }
        switch(fill){
            // compatibility
            case "bottom":
                return "start";
            case "top":
                return "end";
            case "zero":
                return "origin";
            // supported boundaries
            case "origin":
            case "start":
            case "end":
                return fill;
            // invalid fill values
            default:
                return false;
        }
    }
    function computeLinearBoundary(source) {
        var model = source.el._model || {};
        var scale = source.el._scale || {};
        var fill = source.fill;
        var target = null;
        var horizontal;
        if (isFinite(fill)) return null;
        // Backward compatibility: until v3, we still need to support boundary values set on
        // the model (scaleTop, scaleBottom and scaleZero) because some external plugins and
        // controllers might still use it (e.g. the Smith chart).
        if (fill === "start") target = model.scaleBottom === undefined ? scale.bottom : model.scaleBottom;
        else if (fill === "end") target = model.scaleTop === undefined ? scale.top : model.scaleTop;
        else if (model.scaleZero !== undefined) target = model.scaleZero;
        else if (scale.getBasePixel) target = scale.getBasePixel();
        if (target !== undefined && target !== null) {
            if (target.x !== undefined && target.y !== undefined) return target;
            if (helpers$1.isFinite(target)) {
                horizontal = scale.isHorizontal();
                return {
                    x: horizontal ? target : null,
                    y: horizontal ? null : target
                };
            }
        }
        return null;
    }
    function computeCircularBoundary(source) {
        var scale = source.el._scale;
        var options = scale.options;
        var length = scale.chart.data.labels.length;
        var fill = source.fill;
        var target = [];
        var start, end, center, i, point;
        if (!length) return null;
        start = options.ticks.reverse ? scale.max : scale.min;
        end = options.ticks.reverse ? scale.min : scale.max;
        center = scale.getPointPositionForValue(0, start);
        for(i = 0; i < length; ++i){
            point = fill === "start" || fill === "end" ? scale.getPointPositionForValue(i, fill === "start" ? start : end) : scale.getBasePosition(i);
            if (options.gridLines.circular) {
                point.cx = center.x;
                point.cy = center.y;
                point.angle = scale.getIndexAngle(i) - Math.PI / 2;
            }
            target.push(point);
        }
        return target;
    }
    function computeBoundary(source) {
        var scale = source.el._scale || {};
        if (scale.getPointPositionForValue) return computeCircularBoundary(source);
        return computeLinearBoundary(source);
    }
    function resolveTarget(sources, index, propagate) {
        var source = sources[index];
        var fill = source.fill;
        var visited = [
            index
        ];
        var target;
        if (!propagate) return fill;
        while(fill !== false && visited.indexOf(fill) === -1){
            if (!isFinite(fill)) return fill;
            target = sources[fill];
            if (!target) return false;
            if (target.visible) return fill;
            visited.push(fill);
            fill = target.fill;
        }
        return false;
    }
    function createMapper(source) {
        var fill = source.fill;
        var type = "dataset";
        if (fill === false) return null;
        if (!isFinite(fill)) type = "boundary";
        return mappers[type](source);
    }
    function isDrawable(point) {
        return point && !point.skip;
    }
    function drawArea(ctx, curve0, curve1, len0, len1) {
        var i, cx, cy, r;
        if (!len0 || !len1) return;
        // building first area curve (normal)
        ctx.moveTo(curve0[0].x, curve0[0].y);
        for(i = 1; i < len0; ++i)helpers$1.canvas.lineTo(ctx, curve0[i - 1], curve0[i]);
        if (curve1[0].angle !== undefined) {
            cx = curve1[0].cx;
            cy = curve1[0].cy;
            r = Math.sqrt(Math.pow(curve1[0].x - cx, 2) + Math.pow(curve1[0].y - cy, 2));
            for(i = len1 - 1; i > 0; --i)ctx.arc(cx, cy, r, curve1[i].angle, curve1[i - 1].angle, true);
            return;
        }
        // joining the two area curves
        ctx.lineTo(curve1[len1 - 1].x, curve1[len1 - 1].y);
        // building opposite area curve (reverse)
        for(i = len1 - 1; i > 0; --i)helpers$1.canvas.lineTo(ctx, curve1[i], curve1[i - 1], true);
    }
    function doFill(ctx, points, mapper, view, color, loop) {
        var count = points.length;
        var span = view.spanGaps;
        var curve0 = [];
        var curve1 = [];
        var len0 = 0;
        var len1 = 0;
        var i, ilen, index, p0, p1, d0, d1, loopOffset;
        ctx.beginPath();
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i % count;
            p0 = points[index]._view;
            p1 = mapper(p0, index, view);
            d0 = isDrawable(p0);
            d1 = isDrawable(p1);
            if (loop && loopOffset === undefined && d0) {
                loopOffset = i + 1;
                ilen = count + loopOffset;
            }
            if (d0 && d1) {
                len0 = curve0.push(p0);
                len1 = curve1.push(p1);
            } else if (len0 && len1) {
                if (!span) {
                    drawArea(ctx, curve0, curve1, len0, len1);
                    len0 = len1 = 0;
                    curve0 = [];
                    curve1 = [];
                } else {
                    if (d0) curve0.push(p0);
                    if (d1) curve1.push(p1);
                }
            }
        }
        drawArea(ctx, curve0, curve1, len0, len1);
        ctx.closePath();
        ctx.fillStyle = color;
        ctx.fill();
    }
    var plugin_filler = {
        id: "filler",
        afterDatasetsUpdate: function(chart, options) {
            var count = (chart.data.datasets || []).length;
            var propagate = options.propagate;
            var sources = [];
            var meta, i, el, source;
            for(i = 0; i < count; ++i){
                meta = chart.getDatasetMeta(i);
                el = meta.dataset;
                source = null;
                if (el && el._model && el instanceof elements.Line) source = {
                    visible: chart.isDatasetVisible(i),
                    fill: decodeFill(el, i, count),
                    chart: chart,
                    el: el
                };
                meta.$filler = source;
                sources.push(source);
            }
            for(i = 0; i < count; ++i){
                source = sources[i];
                if (!source) continue;
                source.fill = resolveTarget(sources, i, propagate);
                source.boundary = computeBoundary(source);
                source.mapper = createMapper(source);
            }
        },
        beforeDatasetsDraw: function(chart) {
            var metasets = chart._getSortedVisibleDatasetMetas();
            var ctx = chart.ctx;
            var meta, i, el, view, points, mapper, color;
            for(i = metasets.length - 1; i >= 0; --i){
                meta = metasets[i].$filler;
                if (!meta || !meta.visible) continue;
                el = meta.el;
                view = el._view;
                points = el._children || [];
                mapper = meta.mapper;
                color = view.backgroundColor || core_defaults.global.defaultColor;
                if (mapper && color && points.length) {
                    helpers$1.canvas.clipArea(ctx, chart.chartArea);
                    doFill(ctx, points, mapper, view, color, el._loop);
                    helpers$1.canvas.unclipArea(ctx);
                }
            }
        }
    };
    var getRtlHelper$1 = helpers$1.rtl.getRtlAdapter;
    var noop$1 = helpers$1.noop;
    var valueOrDefault$e = helpers$1.valueOrDefault;
    core_defaults._set("global", {
        legend: {
            display: true,
            position: "top",
            align: "center",
            fullWidth: true,
            reverse: false,
            weight: 1000,
            // a callback that will handle
            onClick: function(e, legendItem) {
                var index = legendItem.datasetIndex;
                var ci = this.chart;
                var meta = ci.getDatasetMeta(index);
                // See controller.isDatasetVisible comment
                meta.hidden = meta.hidden === null ? !ci.data.datasets[index].hidden : null;
                // We hid a dataset ... rerender the chart
                ci.update();
            },
            onHover: null,
            onLeave: null,
            labels: {
                boxWidth: 40,
                padding: 10,
                // Generates labels shown in the legend
                // Valid properties to return:
                // text : text to display
                // fillStyle : fill of coloured box
                // strokeStyle: stroke of coloured box
                // hidden : if this legend item refers to a hidden item
                // lineCap : cap style for line
                // lineDash
                // lineDashOffset :
                // lineJoin :
                // lineWidth :
                generateLabels: function(chart) {
                    var datasets = chart.data.datasets;
                    var options = chart.options.legend || {};
                    var usePointStyle = options.labels && options.labels.usePointStyle;
                    return chart._getSortedDatasetMetas().map(function(meta) {
                        var style = meta.controller.getStyle(usePointStyle ? 0 : undefined);
                        return {
                            text: datasets[meta.index].label,
                            fillStyle: style.backgroundColor,
                            hidden: !chart.isDatasetVisible(meta.index),
                            lineCap: style.borderCapStyle,
                            lineDash: style.borderDash,
                            lineDashOffset: style.borderDashOffset,
                            lineJoin: style.borderJoinStyle,
                            lineWidth: style.borderWidth,
                            strokeStyle: style.borderColor,
                            pointStyle: style.pointStyle,
                            rotation: style.rotation,
                            // Below is extra data used for toggling the datasets
                            datasetIndex: meta.index
                        };
                    }, this);
                }
            }
        },
        legendCallback: function(chart) {
            var list = document.createElement("ul");
            var datasets = chart.data.datasets;
            var i, ilen, listItem, listItemSpan;
            list.setAttribute("class", chart.id + "-legend");
            for(i = 0, ilen = datasets.length; i < ilen; i++){
                listItem = list.appendChild(document.createElement("li"));
                listItemSpan = listItem.appendChild(document.createElement("span"));
                listItemSpan.style.backgroundColor = datasets[i].backgroundColor;
                if (datasets[i].label) listItem.appendChild(document.createTextNode(datasets[i].label));
            }
            return list.outerHTML;
        }
    });
    /**
 * Helper function to get the box width based on the usePointStyle option
 * @param {object} labelopts - the label options on the legend
 * @param {number} fontSize - the label font size
 * @return {number} width of the color box area
 */ function getBoxWidth(labelOpts, fontSize) {
        return labelOpts.usePointStyle && labelOpts.boxWidth > fontSize ? fontSize : labelOpts.boxWidth;
    }
    /**
 * IMPORTANT: this class is exposed publicly as Chart.Legend, backward compatibility required!
 */ var Legend = core_element.extend({
        initialize: function(config) {
            var me = this;
            helpers$1.extend(me, config);
            // Contains hit boxes for each dataset (in dataset order)
            me.legendHitBoxes = [];
            /**
 		 * @private
 		 */ me._hoveredItem = null;
            // Are we in doughnut mode which has a different data type
            me.doughnutMode = false;
        },
        // These methods are ordered by lifecycle. Utilities then follow.
        // Any function defined here is inherited by all legend types.
        // Any function can be extended by the legend type
        beforeUpdate: noop$1,
        update: function(maxWidth, maxHeight, margins) {
            var me = this;
            // Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
            me.beforeUpdate();
            // Absorb the master measurements
            me.maxWidth = maxWidth;
            me.maxHeight = maxHeight;
            me.margins = margins;
            // Dimensions
            me.beforeSetDimensions();
            me.setDimensions();
            me.afterSetDimensions();
            // Labels
            me.beforeBuildLabels();
            me.buildLabels();
            me.afterBuildLabels();
            // Fit
            me.beforeFit();
            me.fit();
            me.afterFit();
            //
            me.afterUpdate();
            return me.minSize;
        },
        afterUpdate: noop$1,
        //
        beforeSetDimensions: noop$1,
        setDimensions: function() {
            var me = this;
            // Set the unconstrained dimension before label rotation
            if (me.isHorizontal()) {
                // Reset position before calculating rotation
                me.width = me.maxWidth;
                me.left = 0;
                me.right = me.width;
            } else {
                me.height = me.maxHeight;
                // Reset position before calculating rotation
                me.top = 0;
                me.bottom = me.height;
            }
            // Reset padding
            me.paddingLeft = 0;
            me.paddingTop = 0;
            me.paddingRight = 0;
            me.paddingBottom = 0;
            // Reset minSize
            me.minSize = {
                width: 0,
                height: 0
            };
        },
        afterSetDimensions: noop$1,
        //
        beforeBuildLabels: noop$1,
        buildLabels: function() {
            var me = this;
            var labelOpts = me.options.labels || {};
            var legendItems = helpers$1.callback(labelOpts.generateLabels, [
                me.chart
            ], me) || [];
            if (labelOpts.filter) legendItems = legendItems.filter(function(item) {
                return labelOpts.filter(item, me.chart.data);
            });
            if (me.options.reverse) legendItems.reverse();
            me.legendItems = legendItems;
        },
        afterBuildLabels: noop$1,
        //
        beforeFit: noop$1,
        fit: function() {
            var me = this;
            var opts = me.options;
            var labelOpts = opts.labels;
            var display = opts.display;
            var ctx = me.ctx;
            var labelFont = helpers$1.options._parseFont(labelOpts);
            var fontSize = labelFont.size;
            // Reset hit boxes
            var hitboxes = me.legendHitBoxes = [];
            var minSize = me.minSize;
            var isHorizontal = me.isHorizontal();
            if (isHorizontal) {
                minSize.width = me.maxWidth; // fill all the width
                minSize.height = display ? 10 : 0;
            } else {
                minSize.width = display ? 10 : 0;
                minSize.height = me.maxHeight; // fill all the height
            }
            // Increase sizes here
            if (!display) {
                me.width = minSize.width = me.height = minSize.height = 0;
                return;
            }
            ctx.font = labelFont.string;
            if (isHorizontal) {
                // Labels
                // Width of each line of legend boxes. Labels wrap onto multiple lines when there are too many to fit on one
                var lineWidths = me.lineWidths = [
                    0
                ];
                var totalHeight = 0;
                ctx.textAlign = "left";
                ctx.textBaseline = "middle";
                helpers$1.each(me.legendItems, function(legendItem, i) {
                    var boxWidth = getBoxWidth(labelOpts, fontSize);
                    var width = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
                    if (i === 0 || lineWidths[lineWidths.length - 1] + width + 2 * labelOpts.padding > minSize.width) {
                        totalHeight += fontSize + labelOpts.padding;
                        lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
                    }
                    // Store the hitbox width and height here. Final position will be updated in `draw`
                    hitboxes[i] = {
                        left: 0,
                        top: 0,
                        width: width,
                        height: fontSize
                    };
                    lineWidths[lineWidths.length - 1] += width + labelOpts.padding;
                });
                minSize.height += totalHeight;
            } else {
                var vPadding = labelOpts.padding;
                var columnWidths = me.columnWidths = [];
                var columnHeights = me.columnHeights = [];
                var totalWidth = labelOpts.padding;
                var currentColWidth = 0;
                var currentColHeight = 0;
                helpers$1.each(me.legendItems, function(legendItem, i) {
                    var boxWidth = getBoxWidth(labelOpts, fontSize);
                    var itemWidth = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
                    // If too tall, go to new column
                    if (i > 0 && currentColHeight + fontSize + 2 * vPadding > minSize.height) {
                        totalWidth += currentColWidth + labelOpts.padding;
                        columnWidths.push(currentColWidth); // previous column width
                        columnHeights.push(currentColHeight);
                        currentColWidth = 0;
                        currentColHeight = 0;
                    }
                    // Get max width
                    currentColWidth = Math.max(currentColWidth, itemWidth);
                    currentColHeight += fontSize + vPadding;
                    // Store the hitbox width and height here. Final position will be updated in `draw`
                    hitboxes[i] = {
                        left: 0,
                        top: 0,
                        width: itemWidth,
                        height: fontSize
                    };
                });
                totalWidth += currentColWidth;
                columnWidths.push(currentColWidth);
                columnHeights.push(currentColHeight);
                minSize.width += totalWidth;
            }
            me.width = minSize.width;
            me.height = minSize.height;
        },
        afterFit: noop$1,
        // Shared Methods
        isHorizontal: function() {
            return this.options.position === "top" || this.options.position === "bottom";
        },
        // Actually draw the legend on the canvas
        draw: function() {
            var me = this;
            var opts = me.options;
            var labelOpts = opts.labels;
            var globalDefaults = core_defaults.global;
            var defaultColor = globalDefaults.defaultColor;
            var lineDefault = globalDefaults.elements.line;
            var legendHeight = me.height;
            var columnHeights = me.columnHeights;
            var legendWidth = me.width;
            var lineWidths = me.lineWidths;
            if (!opts.display) return;
            var rtlHelper = getRtlHelper$1(opts.rtl, me.left, me.minSize.width);
            var ctx = me.ctx;
            var fontColor = valueOrDefault$e(labelOpts.fontColor, globalDefaults.defaultFontColor);
            var labelFont = helpers$1.options._parseFont(labelOpts);
            var fontSize = labelFont.size;
            var cursor;
            // Canvas setup
            ctx.textAlign = rtlHelper.textAlign("left");
            ctx.textBaseline = "middle";
            ctx.lineWidth = 0.5;
            ctx.strokeStyle = fontColor; // for strikethrough effect
            ctx.fillStyle = fontColor; // render in correct colour
            ctx.font = labelFont.string;
            var boxWidth = getBoxWidth(labelOpts, fontSize);
            var hitboxes = me.legendHitBoxes;
            // current position
            var drawLegendBox = function(x, y, legendItem) {
                if (isNaN(boxWidth) || boxWidth <= 0) return;
                // Set the ctx for the box
                ctx.save();
                var lineWidth = valueOrDefault$e(legendItem.lineWidth, lineDefault.borderWidth);
                ctx.fillStyle = valueOrDefault$e(legendItem.fillStyle, defaultColor);
                ctx.lineCap = valueOrDefault$e(legendItem.lineCap, lineDefault.borderCapStyle);
                ctx.lineDashOffset = valueOrDefault$e(legendItem.lineDashOffset, lineDefault.borderDashOffset);
                ctx.lineJoin = valueOrDefault$e(legendItem.lineJoin, lineDefault.borderJoinStyle);
                ctx.lineWidth = lineWidth;
                ctx.strokeStyle = valueOrDefault$e(legendItem.strokeStyle, defaultColor);
                if (ctx.setLineDash) // IE 9 and 10 do not support line dash
                ctx.setLineDash(valueOrDefault$e(legendItem.lineDash, lineDefault.borderDash));
                if (labelOpts && labelOpts.usePointStyle) {
                    // Recalculate x and y for drawPoint() because its expecting
                    // x and y to be center of figure (instead of top left)
                    var radius = boxWidth * Math.SQRT2 / 2;
                    var centerX = rtlHelper.xPlus(x, boxWidth / 2);
                    var centerY = y + fontSize / 2;
                    // Draw pointStyle as legend symbol
                    helpers$1.canvas.drawPoint(ctx, legendItem.pointStyle, radius, centerX, centerY, legendItem.rotation);
                } else {
                    // Draw box as legend symbol
                    ctx.fillRect(rtlHelper.leftForLtr(x, boxWidth), y, boxWidth, fontSize);
                    if (lineWidth !== 0) ctx.strokeRect(rtlHelper.leftForLtr(x, boxWidth), y, boxWidth, fontSize);
                }
                ctx.restore();
            };
            var fillText = function(x, y, legendItem, textWidth) {
                var halfFontSize = fontSize / 2;
                var xLeft = rtlHelper.xPlus(x, boxWidth + halfFontSize);
                var yMiddle = y + halfFontSize;
                ctx.fillText(legendItem.text, xLeft, yMiddle);
                if (legendItem.hidden) {
                    // Strikethrough the text if hidden
                    ctx.beginPath();
                    ctx.lineWidth = 2;
                    ctx.moveTo(xLeft, yMiddle);
                    ctx.lineTo(rtlHelper.xPlus(xLeft, textWidth), yMiddle);
                    ctx.stroke();
                }
            };
            var alignmentOffset = function(dimension, blockSize) {
                switch(opts.align){
                    case "start":
                        return labelOpts.padding;
                    case "end":
                        return dimension - blockSize;
                    default:
                        return (dimension - blockSize + labelOpts.padding) / 2;
                }
            };
            // Horizontal
            var isHorizontal = me.isHorizontal();
            if (isHorizontal) cursor = {
                x: me.left + alignmentOffset(legendWidth, lineWidths[0]),
                y: me.top + labelOpts.padding,
                line: 0
            };
            else cursor = {
                x: me.left + labelOpts.padding,
                y: me.top + alignmentOffset(legendHeight, columnHeights[0]),
                line: 0
            };
            helpers$1.rtl.overrideTextDirection(me.ctx, opts.textDirection);
            var itemHeight = fontSize + labelOpts.padding;
            helpers$1.each(me.legendItems, function(legendItem, i) {
                var textWidth = ctx.measureText(legendItem.text).width;
                var width = boxWidth + fontSize / 2 + textWidth;
                var x = cursor.x;
                var y = cursor.y;
                rtlHelper.setWidth(me.minSize.width);
                // Use (me.left + me.minSize.width) and (me.top + me.minSize.height)
                // instead of me.right and me.bottom because me.width and me.height
                // may have been changed since me.minSize was calculated
                if (isHorizontal) {
                    if (i > 0 && x + width + labelOpts.padding > me.left + me.minSize.width) {
                        y = cursor.y += itemHeight;
                        cursor.line++;
                        x = cursor.x = me.left + alignmentOffset(legendWidth, lineWidths[cursor.line]);
                    }
                } else if (i > 0 && y + itemHeight > me.top + me.minSize.height) {
                    x = cursor.x = x + me.columnWidths[cursor.line] + labelOpts.padding;
                    cursor.line++;
                    y = cursor.y = me.top + alignmentOffset(legendHeight, columnHeights[cursor.line]);
                }
                var realX = rtlHelper.x(x);
                drawLegendBox(realX, y, legendItem);
                hitboxes[i].left = rtlHelper.leftForLtr(realX, hitboxes[i].width);
                hitboxes[i].top = y;
                // Fill the actual label
                fillText(realX, y, legendItem, textWidth);
                if (isHorizontal) cursor.x += width + labelOpts.padding;
                else cursor.y += itemHeight;
            });
            helpers$1.rtl.restoreTextDirection(me.ctx, opts.textDirection);
        },
        /**
	 * @private
	 */ _getLegendItemAt: function(x, y) {
            var me = this;
            var i, hitBox, lh;
            if (x >= me.left && x <= me.right && y >= me.top && y <= me.bottom) {
                // See if we are touching one of the dataset boxes
                lh = me.legendHitBoxes;
                for(i = 0; i < lh.length; ++i){
                    hitBox = lh[i];
                    if (x >= hitBox.left && x <= hitBox.left + hitBox.width && y >= hitBox.top && y <= hitBox.top + hitBox.height) // Touching an element
                    return me.legendItems[i];
                }
            }
            return null;
        },
        /**
	 * Handle an event
	 * @private
	 * @param {IEvent} event - The event to handle
	 */ handleEvent: function(e) {
            var me = this;
            var opts = me.options;
            var type = e.type === "mouseup" ? "click" : e.type;
            var hoveredItem;
            if (type === "mousemove") {
                if (!opts.onHover && !opts.onLeave) return;
            } else if (type === "click") {
                if (!opts.onClick) return;
            } else return;
            // Chart event already has relative position in it
            hoveredItem = me._getLegendItemAt(e.x, e.y);
            if (type === "click") {
                if (hoveredItem && opts.onClick) // use e.native for backwards compatibility
                opts.onClick.call(me, e.native, hoveredItem);
            } else {
                if (opts.onLeave && hoveredItem !== me._hoveredItem) {
                    if (me._hoveredItem) opts.onLeave.call(me, e.native, me._hoveredItem);
                    me._hoveredItem = hoveredItem;
                }
                if (opts.onHover && hoveredItem) // use e.native for backwards compatibility
                opts.onHover.call(me, e.native, hoveredItem);
            }
        }
    });
    function createNewLegendAndAttach(chart, legendOpts) {
        var legend = new Legend({
            ctx: chart.ctx,
            options: legendOpts,
            chart: chart
        });
        core_layouts.configure(chart, legend, legendOpts);
        core_layouts.addBox(chart, legend);
        chart.legend = legend;
    }
    var plugin_legend = {
        id: "legend",
        /**
	 * Backward compatibility: since 2.1.5, the legend is registered as a plugin, making
	 * Chart.Legend obsolete. To avoid a breaking change, we export the Legend as part of
	 * the plugin, which one will be re-exposed in the chart.js file.
	 * https://github.com/chartjs/Chart.js/pull/2640
	 * @private
	 */ _element: Legend,
        beforeInit: function(chart) {
            var legendOpts = chart.options.legend;
            if (legendOpts) createNewLegendAndAttach(chart, legendOpts);
        },
        beforeUpdate: function(chart) {
            var legendOpts = chart.options.legend;
            var legend = chart.legend;
            if (legendOpts) {
                helpers$1.mergeIf(legendOpts, core_defaults.global.legend);
                if (legend) {
                    core_layouts.configure(chart, legend, legendOpts);
                    legend.options = legendOpts;
                } else createNewLegendAndAttach(chart, legendOpts);
            } else if (legend) {
                core_layouts.removeBox(chart, legend);
                delete chart.legend;
            }
        },
        afterEvent: function(chart, e) {
            var legend = chart.legend;
            if (legend) legend.handleEvent(e);
        }
    };
    var noop$2 = helpers$1.noop;
    core_defaults._set("global", {
        title: {
            display: false,
            fontStyle: "bold",
            fullWidth: true,
            padding: 10,
            position: "top",
            text: "",
            weight: 2000 // by default greater than legend (1000) to be above
        }
    });
    /**
 * IMPORTANT: this class is exposed publicly as Chart.Legend, backward compatibility required!
 */ var Title = core_element.extend({
        initialize: function(config) {
            var me = this;
            helpers$1.extend(me, config);
            // Contains hit boxes for each dataset (in dataset order)
            me.legendHitBoxes = [];
        },
        // These methods are ordered by lifecycle. Utilities then follow.
        beforeUpdate: noop$2,
        update: function(maxWidth, maxHeight, margins) {
            var me = this;
            // Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
            me.beforeUpdate();
            // Absorb the master measurements
            me.maxWidth = maxWidth;
            me.maxHeight = maxHeight;
            me.margins = margins;
            // Dimensions
            me.beforeSetDimensions();
            me.setDimensions();
            me.afterSetDimensions();
            // Labels
            me.beforeBuildLabels();
            me.buildLabels();
            me.afterBuildLabels();
            // Fit
            me.beforeFit();
            me.fit();
            me.afterFit();
            //
            me.afterUpdate();
            return me.minSize;
        },
        afterUpdate: noop$2,
        //
        beforeSetDimensions: noop$2,
        setDimensions: function() {
            var me = this;
            // Set the unconstrained dimension before label rotation
            if (me.isHorizontal()) {
                // Reset position before calculating rotation
                me.width = me.maxWidth;
                me.left = 0;
                me.right = me.width;
            } else {
                me.height = me.maxHeight;
                // Reset position before calculating rotation
                me.top = 0;
                me.bottom = me.height;
            }
            // Reset padding
            me.paddingLeft = 0;
            me.paddingTop = 0;
            me.paddingRight = 0;
            me.paddingBottom = 0;
            // Reset minSize
            me.minSize = {
                width: 0,
                height: 0
            };
        },
        afterSetDimensions: noop$2,
        //
        beforeBuildLabels: noop$2,
        buildLabels: noop$2,
        afterBuildLabels: noop$2,
        //
        beforeFit: noop$2,
        fit: function() {
            var me = this;
            var opts = me.options;
            var minSize = me.minSize = {};
            var isHorizontal = me.isHorizontal();
            var lineCount, textSize;
            if (!opts.display) {
                me.width = minSize.width = me.height = minSize.height = 0;
                return;
            }
            lineCount = helpers$1.isArray(opts.text) ? opts.text.length : 1;
            textSize = lineCount * helpers$1.options._parseFont(opts).lineHeight + opts.padding * 2;
            me.width = minSize.width = isHorizontal ? me.maxWidth : textSize;
            me.height = minSize.height = isHorizontal ? textSize : me.maxHeight;
        },
        afterFit: noop$2,
        // Shared Methods
        isHorizontal: function() {
            var pos = this.options.position;
            return pos === "top" || pos === "bottom";
        },
        // Actually draw the title block on the canvas
        draw: function() {
            var me = this;
            var ctx = me.ctx;
            var opts = me.options;
            if (!opts.display) return;
            var fontOpts = helpers$1.options._parseFont(opts);
            var lineHeight = fontOpts.lineHeight;
            var offset = lineHeight / 2 + opts.padding;
            var rotation = 0;
            var top = me.top;
            var left = me.left;
            var bottom = me.bottom;
            var right = me.right;
            var maxWidth, titleX, titleY;
            ctx.fillStyle = helpers$1.valueOrDefault(opts.fontColor, core_defaults.global.defaultFontColor); // render in correct colour
            ctx.font = fontOpts.string;
            // Horizontal
            if (me.isHorizontal()) {
                titleX = left + (right - left) / 2; // midpoint of the width
                titleY = top + offset;
                maxWidth = right - left;
            } else {
                titleX = opts.position === "left" ? left + offset : right - offset;
                titleY = top + (bottom - top) / 2;
                maxWidth = bottom - top;
                rotation = Math.PI * (opts.position === "left" ? -0.5 : 0.5);
            }
            ctx.save();
            ctx.translate(titleX, titleY);
            ctx.rotate(rotation);
            ctx.textAlign = "center";
            ctx.textBaseline = "middle";
            var text = opts.text;
            if (helpers$1.isArray(text)) {
                var y = 0;
                for(var i = 0; i < text.length; ++i){
                    ctx.fillText(text[i], 0, y, maxWidth);
                    y += lineHeight;
                }
            } else ctx.fillText(text, 0, 0, maxWidth);
            ctx.restore();
        }
    });
    function createNewTitleBlockAndAttach(chart, titleOpts) {
        var title = new Title({
            ctx: chart.ctx,
            options: titleOpts,
            chart: chart
        });
        core_layouts.configure(chart, title, titleOpts);
        core_layouts.addBox(chart, title);
        chart.titleBlock = title;
    }
    var plugin_title = {
        id: "title",
        /**
	 * Backward compatibility: since 2.1.5, the title is registered as a plugin, making
	 * Chart.Title obsolete. To avoid a breaking change, we export the Title as part of
	 * the plugin, which one will be re-exposed in the chart.js file.
	 * https://github.com/chartjs/Chart.js/pull/2640
	 * @private
	 */ _element: Title,
        beforeInit: function(chart) {
            var titleOpts = chart.options.title;
            if (titleOpts) createNewTitleBlockAndAttach(chart, titleOpts);
        },
        beforeUpdate: function(chart) {
            var titleOpts = chart.options.title;
            var titleBlock = chart.titleBlock;
            if (titleOpts) {
                helpers$1.mergeIf(titleOpts, core_defaults.global.title);
                if (titleBlock) {
                    core_layouts.configure(chart, titleBlock, titleOpts);
                    titleBlock.options = titleOpts;
                } else createNewTitleBlockAndAttach(chart, titleOpts);
            } else if (titleBlock) {
                core_layouts.removeBox(chart, titleBlock);
                delete chart.titleBlock;
            }
        }
    };
    var plugins = {};
    var filler = plugin_filler;
    var legend = plugin_legend;
    var title = plugin_title;
    plugins.filler = filler;
    plugins.legend = legend;
    plugins.title = title;
    /**
 * @namespace Chart
 */ core_controller.helpers = helpers$1;
    // @todo dispatch these helpers into appropriated helpers/helpers.* file and write unit tests!
    core_helpers();
    core_controller._adapters = core_adapters;
    core_controller.Animation = core_animation;
    core_controller.animationService = core_animations;
    core_controller.controllers = controllers;
    core_controller.DatasetController = core_datasetController;
    core_controller.defaults = core_defaults;
    core_controller.Element = core_element;
    core_controller.elements = elements;
    core_controller.Interaction = core_interaction;
    core_controller.layouts = core_layouts;
    core_controller.platform = platform;
    core_controller.plugins = core_plugins;
    core_controller.Scale = core_scale;
    core_controller.scaleService = core_scaleService;
    core_controller.Ticks = core_ticks;
    core_controller.Tooltip = core_tooltip;
    // Register built-in scales
    core_controller.helpers.each(scales, function(scale, type) {
        core_controller.scaleService.registerScaleType(type, scale, scale._defaults);
    });
    // Load to register built-in adapters (as side effects)
    // Loading built-in plugins
    for(var k in plugins)if (plugins.hasOwnProperty(k)) core_controller.plugins.register(plugins[k]);
    core_controller.platform.initialize();
    var src = core_controller;
    if (typeof window !== "undefined") window.Chart = core_controller;
    // DEPRECATIONS
    /**
 * Provided for backward compatibility, not available anymore
 * @namespace Chart.Chart
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 * @private
 */ core_controller.Chart = core_controller;
    /**
 * Provided for backward compatibility, not available anymore
 * @namespace Chart.Legend
 * @deprecated since version 2.1.5
 * @todo remove at version 3
 * @private
 */ core_controller.Legend = plugins.legend._element;
    /**
 * Provided for backward compatibility, not available anymore
 * @namespace Chart.Title
 * @deprecated since version 2.1.5
 * @todo remove at version 3
 * @private
 */ core_controller.Title = plugins.title._element;
    /**
 * Provided for backward compatibility, use Chart.plugins instead
 * @namespace Chart.pluginService
 * @deprecated since version 2.1.5
 * @todo remove at version 3
 * @private
 */ core_controller.pluginService = core_controller.plugins;
    /**
 * Provided for backward compatibility, inheriting from Chart.PlugingBase has no
 * effect, instead simply create/register plugins via plain JavaScript objects.
 * @interface Chart.PluginBase
 * @deprecated since version 2.5.0
 * @todo remove at version 3
 * @private
 */ core_controller.PluginBase = core_controller.Element.extend({});
    /**
 * Provided for backward compatibility, use Chart.helpers.canvas instead.
 * @namespace Chart.canvasHelpers
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 * @private
 */ core_controller.canvasHelpers = core_controller.helpers.canvas;
    /**
 * Provided for backward compatibility, use Chart.layouts instead.
 * @namespace Chart.layoutService
 * @deprecated since version 2.7.3
 * @todo remove at version 3
 * @private
 */ core_controller.layoutService = core_controller.layouts;
    /**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart.LinearScaleBase
 * @deprecated since version 2.8
 * @todo remove at version 3
 * @private
 */ core_controller.LinearScaleBase = scale_linearbase;
    /**
 * Provided for backward compatibility, instead we should create a new Chart
 * by setting the type in the config (`new Chart(id, {type: '{chart-type}'}`).
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 */ core_controller.helpers.each([
        "Bar",
        "Bubble",
        "Doughnut",
        "Line",
        "PolarArea",
        "Radar",
        "Scatter"
    ], function(klass) {
        core_controller[klass] = function(ctx, cfg) {
            return new core_controller(ctx, core_controller.helpers.merge(cfg || {}, {
                type: klass.charAt(0).toLowerCase() + klass.slice(1)
            }));
        };
    });
    return src;
});

});
parcelRegister("cdzNP", function(module, exports) {
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    "use strict";
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === "[object Array]";
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === "[object Object]";
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === "number" || Object.prototype.toString.call(input) === "[object Number]";
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === "[object Date]";
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, "toString")) a.toString = b.toString;
        if (hasOwnProp(b, "valueOf")) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            });
            isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
        else return isNowValid;
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== "undefined" && console.warn) console.warn("Deprecation warning: " + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = "";
                    if (typeof arguments[i] === "object") {
                        arg += "\n[" + i + "] ";
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ": " + arguments[0][key] + ", ";
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + "\nArguments: " + Array.prototype.slice.call(args).join("") + "\n" + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== "undefined" && input instanceof Function || Object.prototype.toString.call(input) === "[object Function]";
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this["_" + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: "[Today at] LT",
        nextDay: "[Tomorrow at] LT",
        nextWeek: "dddd [at] LT",
        lastDay: "[Yesterday at] LT",
        lastWeek: "[Last] dddd [at] LT",
        sameElse: "L"
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar["sameElse"];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = "" + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? "+" : "" : "-") + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === "string") func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, "");
        return input.replace(/\\/g, "");
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = "", i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === "MMMM" || tok === "MM" || tok === "DD" || tok === "dddd") return tok.slice(1);
            return tok;
        }).join("");
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = "Invalid date";
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = "%d", defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace("%d", number);
    }
    var defaultRelativeTime = {
        future: "in %s",
        past: "%s ago",
        s: "a few seconds",
        ss: "%d seconds",
        m: "a minute",
        mm: "%d minutes",
        h: "an hour",
        hh: "%d hours",
        d: "a day",
        dd: "%d days",
        w: "a week",
        ww: "%d weeks",
        M: "a month",
        MM: "%d months",
        y: "a year",
        yy: "%d years"
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? "future" : "past"];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {
        D: "date",
        dates: "date",
        date: "date",
        d: "day",
        days: "day",
        day: "day",
        e: "weekday",
        weekdays: "weekday",
        weekday: "weekday",
        E: "isoWeekday",
        isoweekdays: "isoWeekday",
        isoweekday: "isoWeekday",
        DDD: "dayOfYear",
        dayofyears: "dayOfYear",
        dayofyear: "dayOfYear",
        h: "hour",
        hours: "hour",
        hour: "hour",
        ms: "millisecond",
        milliseconds: "millisecond",
        millisecond: "millisecond",
        m: "minute",
        minutes: "minute",
        minute: "minute",
        M: "month",
        months: "month",
        month: "month",
        Q: "quarter",
        quarters: "quarter",
        quarter: "quarter",
        s: "second",
        seconds: "second",
        second: "second",
        gg: "weekYear",
        weekyears: "weekYear",
        weekyear: "weekYear",
        GG: "isoWeekYear",
        isoweekyears: "isoWeekYear",
        isoweekyear: "isoWeekYear",
        w: "week",
        weeks: "week",
        week: "week",
        W: "isoWeek",
        isoweeks: "isoWeek",
        isoweek: "isoWeek",
        y: "year",
        years: "year",
        year: "year"
    };
    function normalizeUnits(units) {
        return typeof units === "string" ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1
    };
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace("\\", "").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === "string") token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    // FORMATTING
    addFormatToken("Y", 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : "+" + y;
    });
    addFormatToken(0, [
        "YY",
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        "YYYY",
        4
    ], 0, "year");
    addFormatToken(0, [
        "YYYYY",
        5
    ], 0, "year");
    addFormatToken(0, [
        "YYYYYY",
        6,
        true
    ], 0, "year");
    // PARSING
    addRegexToken("Y", matchSigned);
    addRegexToken("YY", match1to2, match2);
    addRegexToken("YYYY", match1to4, match4);
    addRegexToken("YYYYY", match1to6, match6);
    addRegexToken("YYYYYY", match1to6, match6);
    addParseToken([
        "YYYYY",
        "YYYYYY"
    ], YEAR);
    addParseToken("YYYY", function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken("YY", function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken("Y", function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet("FullYear", true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        if (!mom.isValid()) return NaN;
        var d = mom._d, isUTC = mom._isUTC;
        switch(unit){
            case "Milliseconds":
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case "Seconds":
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case "Minutes":
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case "Hours":
                return isUTC ? d.getUTCHours() : d.getHours();
            case "Date":
                return isUTC ? d.getUTCDate() : d.getDate();
            case "Day":
                return isUTC ? d.getUTCDay() : d.getDay();
            case "Month":
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case "FullYear":
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }
    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;
        if (!mom.isValid() || isNaN(value)) return;
        d = mom._d;
        isUTC = mom._isUTC;
        switch(unit){
            case "Milliseconds":
                return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
            case "Seconds":
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case "Minutes":
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case "Hours":
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case "Date":
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case "FullYear":
                break; // See below ...
            default:
                return; // Just in case
        }
        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date);
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === "object") {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken("M", [
        "MM",
        2
    ], "Mo", function() {
        return this.month() + 1;
    });
    addFormatToken("MMM", 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken("MMMM", 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // PARSING
    addRegexToken("M", match1to2, match1to2NoLeadingZero);
    addRegexToken("MM", match1to2, match2);
    addRegexToken("MMM", function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken("MMMM", function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        "M",
        "MM"
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        "MMM",
        "MMMM"
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), defaultLocaleMonthsShort = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months["standalone"];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? "format" : "standalone"][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort["standalone"];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? "format" : "standalone"][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, "").toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "MMM") {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === "MMM") {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp("^" + this.months(mom, "").replace(".", "") + "$", "i");
                this._shortMonthsParse[i] = new RegExp("^" + this.monthsShort(mom, "").replace(".", "") + "$", "i");
            }
            if (!strict && !this._monthsParse[i]) {
                regex = "^" + this.months(mom, "") + "|^" + this.monthsShort(mom, "");
                this._monthsParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "MMMM" && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === "MMM" && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === "string") {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        var month = value, date = mom.date();
        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, "Month");
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, "_monthsShortRegex")) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, "_monthsRegex")) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortP = regexEscape(this.monthsShort(mom, ""));
            longP = regexEscape(this.months(mom, ""));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._monthsRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._monthsShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken("w", [
        "ww",
        2
    ], "wo", "week");
    addFormatToken("W", [
        "WW",
        2
    ], "Wo", "isoWeek");
    // PARSING
    addRegexToken("w", match1to2, match1to2NoLeadingZero);
    addRegexToken("ww", match1to2, match2);
    addRegexToken("W", match1to2, match1to2NoLeadingZero);
    addRegexToken("WW", match1to2, match2);
    addWeekParseToken([
        "w",
        "ww",
        "W",
        "WW"
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    // FORMATTING
    addFormatToken("d", 0, "do", "day");
    addFormatToken("dd", 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken("ddd", 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken("dddd", 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken("e", 0, 0, "weekday");
    addFormatToken("E", 0, 0, "isoWeekday");
    // PARSING
    addRegexToken("d", match1to2);
    addRegexToken("e", match1to2);
    addRegexToken("E", match1to2);
    addRegexToken("dd", function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken("ddd", function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken("dddd", function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        "dd",
        "ddd",
        "dddd"
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        "d",
        "e",
        "E"
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== "string") return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === "number") return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === "string") return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), defaultLocaleWeekdaysShort = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), defaultLocaleWeekdaysMin = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? "format" : "standalone"];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, "").toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, "").toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp("^" + this.weekdays(mom, "").replace(".", "\\.?") + "$", "i");
                this._shortWeekdaysParse[i] = new RegExp("^" + this.weekdaysShort(mom, "").replace(".", "\\.?") + "$", "i");
                this._minWeekdaysParse[i] = new RegExp("^" + this.weekdaysMin(mom, "").replace(".", "\\.?") + "$", "i");
            }
            if (!this._weekdaysParse[i]) {
                regex = "^" + this.weekdays(mom, "") + "|^" + this.weekdaysShort(mom, "") + "|^" + this.weekdaysMin(mom, "");
                this._weekdaysParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "dddd" && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "ddd" && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "dd" && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = get(this, "Day");
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, "d");
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, "d");
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysRegex")) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysShortRegex")) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysMinRegex")) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ""));
            shortp = regexEscape(this.weekdaysShort(mom, ""));
            longp = regexEscape(this.weekdays(mom, ""));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._weekdaysShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
        this._weekdaysMinStrictRegex = new RegExp("^(" + minPieces.join("|") + ")", "i");
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken("H", [
        "HH",
        2
    ], 0, "hour");
    addFormatToken("h", [
        "hh",
        2
    ], 0, hFormat);
    addFormatToken("k", [
        "kk",
        2
    ], 0, kFormat);
    addFormatToken("hmm", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken("hmmss", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken("Hmm", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken("Hmmss", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem("a", true);
    meridiem("A", false);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken("a", matchMeridiem);
    addRegexToken("A", matchMeridiem);
    addRegexToken("H", match1to2, match1to2HasZero);
    addRegexToken("h", match1to2, match1to2NoLeadingZero);
    addRegexToken("k", match1to2, match1to2NoLeadingZero);
    addRegexToken("HH", match1to2, match2);
    addRegexToken("hh", match1to2, match2);
    addRegexToken("kk", match1to2, match2);
    addRegexToken("hmm", match3to4);
    addRegexToken("hmmss", match5to6);
    addRegexToken("Hmm", match3to4);
    addRegexToken("Hmmss", match5to6);
    addParseToken([
        "H",
        "HH"
    ], HOUR);
    addParseToken([
        "k",
        "kk"
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        "a",
        "A"
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        "h",
        "hh"
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("Hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken("Hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + "").toLowerCase().charAt(0) === "p";
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet("Hours", true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? "pm" : "PM";
        else return isLower ? "am" : "AM";
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace("_", "-") : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split("-");
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split("-") : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join("-"));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match("^[^/\\\\]*$"));
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire("./locale/" + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== "undefined" && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn("Locale " + key + " not found. Did you forget to load it?");
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple("defineLocaleOverride", "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            "YYYYYY-MM-DD",
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            "YYYY-MM-DD",
            /\d{4}-\d\d-\d\d/
        ],
        [
            "GGGG-[W]WW-E",
            /\d{4}-W\d\d-\d/
        ],
        [
            "GGGG-[W]WW",
            /\d{4}-W\d\d/,
            false
        ],
        [
            "YYYY-DDD",
            /\d{4}-\d{3}/
        ],
        [
            "YYYY-MM",
            /\d{4}-\d\d/,
            false
        ],
        [
            "YYYYYYMMDD",
            /[+-]\d{10}/
        ],
        [
            "YYYYMMDD",
            /\d{8}/
        ],
        [
            "GGGG[W]WWE",
            /\d{4}W\d{3}/
        ],
        [
            "GGGG[W]WW",
            /\d{4}W\d{2}/,
            false
        ],
        [
            "YYYYDDD",
            /\d{7}/
        ],
        [
            "YYYYMM",
            /\d{6}/,
            false
        ],
        [
            "YYYY",
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            "HH:mm:ss.SSSS",
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            "HH:mm:ss,SSSS",
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            "HH:mm:ss",
            /\d\d:\d\d:\d\d/
        ],
        [
            "HH:mm",
            /\d\d:\d\d/
        ],
        [
            "HHmmss.SSSS",
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            "HHmmss,SSSS",
            /\d\d\d\d\d\d,\d+/
        ],
        [
            "HHmmss",
            /\d\d\d\d\d\d/
        ],
        [
            "HHmm",
            /\d\d\d\d/
        ],
        [
            "HH",
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || " ") + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = "Z";
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || "") + (tzFormat || "");
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? " UTC" : ""));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== "undefined" && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = "" + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, "d");
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === "") return createInvalid({
            nullInput: true
        });
        if (typeof input === "string") config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === "string") configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isBefore", args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isAfter", args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        "year",
        "quarter",
        "month",
        "week",
        "day",
        "hour",
        "minute",
        "second",
        "millisecond"
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = "+";
            if (offset < 0) {
                offset = -offset;
                sign = "-";
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset("Z", ":");
    offset("ZZ", "");
    // PARSING
    addRegexToken("Z", matchShortOffset);
    addRegexToken("ZZ", matchShortOffset);
    addParseToken([
        "Z",
        "ZZ"
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || "").match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + "").match(chunkOffset) || [
            "-",
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === "+" ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === "string") {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, "m");
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, "m"), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== "string") input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), "m");
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === "string") {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === "object" && ("from" in duration || "to" in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, "_locale")) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, "_isValid")) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(",", "."));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, "M").isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, "M");
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, "moment()." + name + "(period, number) is deprecated. Please use moment()." + name + "(number, period). " + "See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.");
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, "Month") + months * isAdding);
        if (days) set$1(mom, "Date", get(mom, "Date") + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, "add"), subtract = createAdder(-1, "subtract");
    function isString(input) {
        return typeof input === "string" || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "years",
            "year",
            "y",
            "months",
            "month",
            "M",
            "days",
            "day",
            "d",
            "dates",
            "date",
            "D",
            "hours",
            "hour",
            "h",
            "minutes",
            "minute",
            "m",
            "seconds",
            "second",
            "s",
            "milliseconds",
            "millisecond",
            "ms"
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "sameDay",
            "nextDay",
            "lastDay",
            "nextWeek",
            "lastWeek",
            "sameElse"
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, "days", true);
        return diff < -6 ? "sameElse" : diff < -1 ? "lastWeek" : diff < 0 ? "lastDay" : diff < 1 ? "sameDay" : diff < 2 ? "nextDay" : diff < 7 ? "nextWeek" : "sameElse";
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf("day"), format = hooks.calendarFormat(this, sod) || "sameElse", output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || "()";
        return (inclusivity[0] === "(" ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ")" ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case "year":
                output = monthDiff(this, that) / 12;
                break;
            case "month":
                output = monthDiff(this, that);
                break;
            case "quarter":
                output = monthDiff(this, that) / 3;
                break;
            case "second":
                output = (this - that) / 1e3;
                break; // 1000
            case "minute":
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case "hour":
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case "day":
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case "week":
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, "months"), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
    hooks.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
    function toString() {
        return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ");
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace("Z", formatMoment(m, "Z"));
        }
        return formatMoment(m, utc ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ");
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return "moment.invalid(/* " + this._i + " */)";
        var func = "moment", zone = "", prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone";
            zone = "Z";
        }
        prefix = "[" + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY";
        datetime = "-MM-DD[T]HH:mm:ss.SSS";
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.", function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year(), 0, 1);
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case "month":
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case "hour":
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case "minute":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case "second":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case "month":
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case "hour":
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case "minute":
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case "second":
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken("N", 0, 0, "eraAbbr");
    addFormatToken("NN", 0, 0, "eraAbbr");
    addFormatToken("NNN", 0, 0, "eraAbbr");
    addFormatToken("NNNN", 0, 0, "eraName");
    addFormatToken("NNNNN", 0, 0, "eraNarrow");
    addFormatToken("y", [
        "y",
        1
    ], "yo", "eraYear");
    addFormatToken("y", [
        "yy",
        2
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyy",
        3
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyyy",
        4
    ], 0, "eraYear");
    addRegexToken("N", matchEraAbbr);
    addRegexToken("NN", matchEraAbbr);
    addRegexToken("NNN", matchEraAbbr);
    addRegexToken("NNNN", matchEraName);
    addRegexToken("NNNNN", matchEraNarrow);
    addParseToken([
        "N",
        "NN",
        "NNN",
        "NNNN",
        "NNNNN"
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken("y", matchUnsigned);
    addRegexToken("yy", matchUnsigned);
    addRegexToken("yyy", matchUnsigned);
    addRegexToken("yyyy", matchUnsigned);
    addRegexToken("yo", matchEraYearOrdinal);
    addParseToken([
        "y",
        "yy",
        "yyy",
        "yyyy"
    ], YEAR);
    addParseToken([
        "yo"
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale("en")._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case "string":
                    // truncate time
                    date = hooks(eras[i].since).startOf("day");
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case "undefined":
                    eras[i].until = Infinity;
                    break;
                case "string":
                    // truncate time
                    date = hooks(eras[i].until).startOf("day").valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case "N":
                case "NN":
                case "NNN":
                    if (abbr === eraName) return eras[i];
                    break;
                case "NNNN":
                    if (name === eraName) return eras[i];
                    break;
                case "NNNNN":
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return "";
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return "";
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return "";
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNameRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, "_erasAbbrRegex")) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNarrowRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);
            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }
        this._erasRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._erasNameRegex = new RegExp("^(" + namePieces.join("|") + ")", "i");
        this._erasAbbrRegex = new RegExp("^(" + abbrPieces.join("|") + ")", "i");
        this._erasNarrowRegex = new RegExp("^(" + narrowPieces.join("|") + ")", "i");
    }
    // FORMATTING
    addFormatToken(0, [
        "gg",
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        "GG",
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken("gggg", "weekYear");
    addWeekYearFormatToken("ggggg", "weekYear");
    addWeekYearFormatToken("GGGG", "isoWeekYear");
    addWeekYearFormatToken("GGGGG", "isoWeekYear");
    // ALIASES
    // PARSING
    addRegexToken("G", matchSigned);
    addRegexToken("g", matchSigned);
    addRegexToken("GG", match1to2, match2);
    addRegexToken("gg", match1to2, match2);
    addRegexToken("GGGG", match1to4, match4);
    addRegexToken("gggg", match1to4, match4);
    addRegexToken("GGGGG", match1to6, match6);
    addRegexToken("ggggg", match1to6, match6);
    addWeekParseToken([
        "gggg",
        "ggggg",
        "GGGG",
        "GGGGG"
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        "gg",
        "GG"
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken("Q", 0, "Qo", "quarter");
    // PARSING
    addRegexToken("Q", match1);
    addParseToken("Q", function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken("D", [
        "DD",
        2
    ], "Do", "date");
    // PARSING
    addRegexToken("D", match1to2, match1to2NoLeadingZero);
    addRegexToken("DD", match1to2, match2);
    addRegexToken("Do", function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        "D",
        "DD"
    ], DATE);
    addParseToken("Do", function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet("Date", true);
    // FORMATTING
    addFormatToken("DDD", [
        "DDDD",
        3
    ], "DDDo", "dayOfYear");
    // PARSING
    addRegexToken("DDD", match1to3);
    addRegexToken("DDDD", match3);
    addParseToken([
        "DDD",
        "DDDD"
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf("day") - this.clone().startOf("year")) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, "d");
    }
    // FORMATTING
    addFormatToken("m", [
        "mm",
        2
    ], 0, "minute");
    // PARSING
    addRegexToken("m", match1to2, match1to2HasZero);
    addRegexToken("mm", match1to2, match2);
    addParseToken([
        "m",
        "mm"
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet("Minutes", false);
    // FORMATTING
    addFormatToken("s", [
        "ss",
        2
    ], 0, "second");
    // PARSING
    addRegexToken("s", match1to2, match1to2HasZero);
    addRegexToken("ss", match1to2, match2);
    addParseToken([
        "s",
        "ss"
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet("Seconds", false);
    // FORMATTING
    addFormatToken("S", 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        "SS",
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        "SSS",
        3
    ], 0, "millisecond");
    addFormatToken(0, [
        "SSSS",
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        "SSSSS",
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        "SSSSSS",
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        "SSSSSSS",
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        "SSSSSSSS",
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        "SSSSSSSSS",
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // PARSING
    addRegexToken("S", match1to3, match1);
    addRegexToken("SS", match1to3, match2);
    addRegexToken("SSS", match1to3, match3);
    var token, getSetMillisecond;
    for(token = "SSSS"; token.length <= 9; token += "S")addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(("0." + input) * 1000);
    }
    for(token = "S"; token.length <= 9; token += "S")addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet("Milliseconds", false);
    // FORMATTING
    addFormatToken("z", 0, 0, "zoneAbbr");
    addFormatToken("zz", 0, 0, "zoneName");
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? "UTC" : "";
    }
    function getZoneName() {
        return this._isUTC ? "Coordinated Universal Time" : "";
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== "undefined" && Symbol.for != null) proto[Symbol.for("nodejs.util.inspect.custom")] = function() {
        return "Moment<" + this.format() + ">";
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate("dates accessor is deprecated. Use date instead.", getSetDayOfMonth);
    proto.months = deprecate("months accessor is deprecated. Use month instead", getSetMonth);
    proto.years = deprecate("years accessor is deprecated. Use year instead", getSetYear);
    proto.zone = deprecate("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/", getSetZone);
    proto.isDSTShifted = deprecate("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information", isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || "";
        if (index != null) return get$1(format, index, field, "month");
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, "month");
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === "boolean") {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, "day");
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, "day");
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, "months");
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, "monthsShort");
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdays");
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysShort");
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysMin");
    }
    getSetGlobalLocale("en", {
        eras: [
            {
                since: "0001-01-01",
                until: Infinity,
                offset: 1,
                name: "Anno Domini",
                narrow: "AD",
                abbr: "AD"
            },
            {
                since: "0000-12-31",
                until: -Infinity,
                offset: 1,
                name: "Before Christ",
                narrow: "BC",
                abbr: "BC"
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate("moment.lang is deprecated. Use moment.locale instead.", getSetGlobalLocale);
    hooks.langData = deprecate("moment.langData is deprecated. Use moment.localeData instead.", getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === "month" || units === "quarter" || units === "year") {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case "month":
                    return months;
                case "quarter":
                    return months / 3;
                case "year":
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case "week":
                    return days / 7 + milliseconds / 6048e5;
                case "day":
                    return days + milliseconds / 864e5;
                case "hour":
                    return days * 24 + milliseconds / 36e5;
                case "minute":
                    return days * 1440 + milliseconds / 6e4;
                case "second":
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case "millisecond":
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error("Unknown unit " + units);
            }
        }
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs("ms"), asSeconds = makeAs("s"), asMinutes = makeAs("m"), asHours = makeAs("h"), asDays = makeAs("d"), asWeeks = makeAs("w"), asMonths = makeAs("M"), asQuarters = makeAs("Q"), asYears = makeAs("y"), valueOf$1 = asMilliseconds;
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + "s"]() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter("milliseconds"), seconds = makeGetter("seconds"), minutes = makeGetter("minutes"), hours = makeGetter("hours"), days = makeGetter("days"), months = makeGetter("months"), years = makeGetter("years");
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as("s")), minutes = round(duration.as("m")), hours = round(duration.as("h")), days = round(duration.as("d")), months = round(duration.as("M")), weeks = round(duration.as("w")), years = round(duration.as("y")), a = seconds <= thresholds.ss && [
            "s",
            seconds
        ] || seconds < thresholds.s && [
            "ss",
            seconds
        ] || minutes <= 1 && [
            "m"
        ] || minutes < thresholds.m && [
            "mm",
            minutes
        ] || hours <= 1 && [
            "h"
        ] || hours < thresholds.h && [
            "hh",
            hours
        ] || days <= 1 && [
            "d"
        ] || days < thresholds.d && [
            "dd",
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            "w"
        ] || weeks < thresholds.w && [
            "ww",
            weeks
        ];
        a = a || months <= 1 && [
            "M"
        ] || months < thresholds.M && [
            "MM",
            months
        ] || years <= 1 && [
            "y"
        ] || [
            "yy",
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === "function") {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === "s") thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === "object") {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === "boolean") withSuffix = argWithSuffix;
        if (typeof argThresholds === "object") {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return "P0D";
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, "") : "";
        totalSign = total < 0 ? "-" : "";
        ymSign = sign(this._months) !== sign(total) ? "-" : "";
        daysSign = sign(this._days) !== sign(total) ? "-" : "";
        hmsSign = sign(this._milliseconds) !== sign(total) ? "-" : "";
        return totalSign + "P" + (years ? ymSign + years + "Y" : "") + (months ? ymSign + months + "M" : "") + (days ? daysSign + days + "D" : "") + (hours || minutes || seconds ? "T" : "") + (hours ? hmsSign + hours + "H" : "") + (minutes ? hmsSign + minutes + "M" : "") + (seconds ? hmsSign + s + "S" : "");
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)", toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken("X", 0, 0, "unix");
    addFormatToken("x", 0, 0, "valueOf");
    // PARSING
    addRegexToken("x", matchSigned);
    addRegexToken("X", matchTimestamp);
    addParseToken("X", function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken("x", function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = "2.30.1";
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
        DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
        DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
        DATE: "YYYY-MM-DD",
        TIME: "HH:mm",
        TIME_SECONDS: "HH:mm:ss",
        TIME_MS: "HH:mm:ss.SSS",
        WEEK: "GGGG-[W]WW",
        MONTH: "YYYY-MM"
    };
    return hooks;
});

});


parcelRegister("kLyDc", function(module, exports) {

/*!
 * chartjs-plugin-datalabels v0.7.0
 * https://chartjs-plugin-datalabels.netlify.com
 * (c) 2019 Chart.js Contributors
 * Released under the MIT license
 */ (function(global, factory) {
    module.exports = factory((parcelRequire("j41N8")));
})(module.exports, function(Chart) {
    "use strict";
    Chart = Chart && Chart.hasOwnProperty("default") ? Chart["default"] : Chart;
    var helpers = Chart.helpers;
    var devicePixelRatio = function() {
        if (typeof window !== "undefined") {
            if (window.devicePixelRatio) return window.devicePixelRatio;
            // devicePixelRatio is undefined on IE10
            // https://stackoverflow.com/a/20204180/8837887
            // https://github.com/chartjs/chartjs-plugin-datalabels/issues/85
            var screen = window.screen;
            if (screen) return (screen.deviceXDPI || 1) / (screen.logicalXDPI || 1);
        }
        return 1;
    }();
    var utils = {
        // @todo move this in Chart.helpers.toTextLines
        toTextLines: function(inputs) {
            var lines = [];
            var input;
            inputs = [].concat(inputs);
            while(inputs.length){
                input = inputs.pop();
                if (typeof input === "string") lines.unshift.apply(lines, input.split("\n"));
                else if (Array.isArray(input)) inputs.push.apply(inputs, input);
                else if (!helpers.isNullOrUndef(inputs)) lines.unshift("" + input);
            }
            return lines;
        },
        // @todo move this method in Chart.helpers.canvas.toFont (deprecates helpers.fontString)
        // @see https://developer.mozilla.org/en-US/docs/Web/CSS/font
        toFontString: function(font) {
            if (!font || helpers.isNullOrUndef(font.size) || helpers.isNullOrUndef(font.family)) return null;
            return (font.style ? font.style + " " : "") + (font.weight ? font.weight + " " : "") + font.size + "px " + font.family;
        },
        // @todo move this in Chart.helpers.canvas.textSize
        // @todo cache calls of measureText if font doesn't change?!
        textSize: function(ctx, lines, font) {
            var items = [].concat(lines);
            var ilen = items.length;
            var prev = ctx.font;
            var width = 0;
            var i;
            ctx.font = font.string;
            for(i = 0; i < ilen; ++i)width = Math.max(ctx.measureText(items[i]).width, width);
            ctx.font = prev;
            return {
                height: ilen * font.lineHeight,
                width: width
            };
        },
        // @todo move this method in Chart.helpers.options.toFont
        parseFont: function(value) {
            var global = Chart.defaults.global;
            var size = helpers.valueOrDefault(value.size, global.defaultFontSize);
            var font = {
                family: helpers.valueOrDefault(value.family, global.defaultFontFamily),
                lineHeight: helpers.options.toLineHeight(value.lineHeight, size),
                size: size,
                style: helpers.valueOrDefault(value.style, global.defaultFontStyle),
                weight: helpers.valueOrDefault(value.weight, null),
                string: ""
            };
            font.string = utils.toFontString(font);
            return font;
        },
        /**
	 * Returns value bounded by min and max. This is equivalent to max(min, min(value, max)).
	 * @todo move this method in Chart.helpers.bound
	 * https://doc.qt.io/qt-5/qtglobal.html#qBound
	 */ bound: function(min, value, max) {
            return Math.max(min, Math.min(value, max));
        },
        /**
	 * Returns an array of pair [value, state] where state is:
	 * * -1: value is only in a0 (removed)
	 * *  1: value is only in a1 (added)
	 */ arrayDiff: function(a0, a1) {
            var prev = a0.slice();
            var updates = [];
            var i, j, ilen, v;
            for(i = 0, ilen = a1.length; i < ilen; ++i){
                v = a1[i];
                j = prev.indexOf(v);
                if (j === -1) updates.push([
                    v,
                    1
                ]);
                else prev.splice(j, 1);
            }
            for(i = 0, ilen = prev.length; i < ilen; ++i)updates.push([
                prev[i],
                -1
            ]);
            return updates;
        },
        /**
	 * https://github.com/chartjs/chartjs-plugin-datalabels/issues/70
	 */ rasterize: function(v) {
            return Math.round(v * devicePixelRatio) / devicePixelRatio;
        }
    };
    function orient(point, origin) {
        var x0 = origin.x;
        var y0 = origin.y;
        if (x0 === null) return {
            x: 0,
            y: -1
        };
        if (y0 === null) return {
            x: 1,
            y: 0
        };
        var dx = point.x - x0;
        var dy = point.y - y0;
        var ln = Math.sqrt(dx * dx + dy * dy);
        return {
            x: ln ? dx / ln : 0,
            y: ln ? dy / ln : -1
        };
    }
    function aligned(x, y, vx, vy, align) {
        switch(align){
            case "center":
                vx = vy = 0;
                break;
            case "bottom":
                vx = 0;
                vy = 1;
                break;
            case "right":
                vx = 1;
                vy = 0;
                break;
            case "left":
                vx = -1;
                vy = 0;
                break;
            case "top":
                vx = 0;
                vy = -1;
                break;
            case "start":
                vx = -vx;
                vy = -vy;
                break;
            case "end":
                break;
            default:
                // clockwise rotation (in degree)
                align *= Math.PI / 180;
                vx = Math.cos(align);
                vy = Math.sin(align);
                break;
        }
        return {
            x: x,
            y: y,
            vx: vx,
            vy: vy
        };
    }
    // Line clipping (Cohen–Sutherland algorithm)
    // https://en.wikipedia.org/wiki/Cohen–Sutherland_algorithm
    var R_INSIDE = 0;
    var R_LEFT = 1;
    var R_RIGHT = 2;
    var R_BOTTOM = 4;
    var R_TOP = 8;
    function region(x, y, rect) {
        var res = R_INSIDE;
        if (x < rect.left) res |= R_LEFT;
        else if (x > rect.right) res |= R_RIGHT;
        if (y < rect.top) res |= R_TOP;
        else if (y > rect.bottom) res |= R_BOTTOM;
        return res;
    }
    function clipped(segment, area) {
        var x0 = segment.x0;
        var y0 = segment.y0;
        var x1 = segment.x1;
        var y1 = segment.y1;
        var r0 = region(x0, y0, area);
        var r1 = region(x1, y1, area);
        var r, x, y;
        // eslint-disable-next-line no-constant-condition
        while(true){
            if (!(r0 | r1) || r0 & r1) break;
            // at least one point is outside
            r = r0 || r1;
            if (r & R_TOP) {
                x = x0 + (x1 - x0) * (area.top - y0) / (y1 - y0);
                y = area.top;
            } else if (r & R_BOTTOM) {
                x = x0 + (x1 - x0) * (area.bottom - y0) / (y1 - y0);
                y = area.bottom;
            } else if (r & R_RIGHT) {
                y = y0 + (y1 - y0) * (area.right - x0) / (x1 - x0);
                x = area.right;
            } else if (r & R_LEFT) {
                y = y0 + (y1 - y0) * (area.left - x0) / (x1 - x0);
                x = area.left;
            }
            if (r === r0) {
                x0 = x;
                y0 = y;
                r0 = region(x0, y0, area);
            } else {
                x1 = x;
                y1 = y;
                r1 = region(x1, y1, area);
            }
        }
        return {
            x0: x0,
            x1: x1,
            y0: y0,
            y1: y1
        };
    }
    function compute(range, config) {
        var anchor = config.anchor;
        var segment = range;
        var x, y;
        if (config.clamp) segment = clipped(segment, config.area);
        if (anchor === "start") {
            x = segment.x0;
            y = segment.y0;
        } else if (anchor === "end") {
            x = segment.x1;
            y = segment.y1;
        } else {
            x = (segment.x0 + segment.x1) / 2;
            y = (segment.y0 + segment.y1) / 2;
        }
        return aligned(x, y, range.vx, range.vy, config.align);
    }
    var positioners = {
        arc: function(vm, config) {
            var angle = (vm.startAngle + vm.endAngle) / 2;
            var vx = Math.cos(angle);
            var vy = Math.sin(angle);
            var r0 = vm.innerRadius;
            var r1 = vm.outerRadius;
            return compute({
                x0: vm.x + vx * r0,
                y0: vm.y + vy * r0,
                x1: vm.x + vx * r1,
                y1: vm.y + vy * r1,
                vx: vx,
                vy: vy
            }, config);
        },
        point: function(vm, config) {
            var v = orient(vm, config.origin);
            var rx = v.x * vm.radius;
            var ry = v.y * vm.radius;
            return compute({
                x0: vm.x - rx,
                y0: vm.y - ry,
                x1: vm.x + rx,
                y1: vm.y + ry,
                vx: v.x,
                vy: v.y
            }, config);
        },
        rect: function(vm, config) {
            var v = orient(vm, config.origin);
            var x = vm.x;
            var y = vm.y;
            var sx = 0;
            var sy = 0;
            if (vm.horizontal) {
                x = Math.min(vm.x, vm.base);
                sx = Math.abs(vm.base - vm.x);
            } else {
                y = Math.min(vm.y, vm.base);
                sy = Math.abs(vm.base - vm.y);
            }
            return compute({
                x0: x,
                y0: y + sy,
                x1: x + sx,
                y1: y,
                vx: v.x,
                vy: v.y
            }, config);
        },
        fallback: function(vm, config) {
            var v = orient(vm, config.origin);
            return compute({
                x0: vm.x,
                y0: vm.y,
                x1: vm.x,
                y1: vm.y,
                vx: v.x,
                vy: v.y
            }, config);
        }
    };
    var helpers$1 = Chart.helpers;
    var rasterize = utils.rasterize;
    function boundingRects(model) {
        var borderWidth = model.borderWidth || 0;
        var padding = model.padding;
        var th = model.size.height;
        var tw = model.size.width;
        var tx = -tw / 2;
        var ty = -th / 2;
        return {
            frame: {
                x: tx - padding.left - borderWidth,
                y: ty - padding.top - borderWidth,
                w: tw + padding.width + borderWidth * 2,
                h: th + padding.height + borderWidth * 2
            },
            text: {
                x: tx,
                y: ty,
                w: tw,
                h: th
            }
        };
    }
    function getScaleOrigin(el) {
        var horizontal = el._model.horizontal;
        var scale = el._scale || horizontal && el._xScale || el._yScale;
        if (!scale) return null;
        if (scale.xCenter !== undefined && scale.yCenter !== undefined) return {
            x: scale.xCenter,
            y: scale.yCenter
        };
        var pixel = scale.getBasePixel();
        return horizontal ? {
            x: pixel,
            y: null
        } : {
            x: null,
            y: pixel
        };
    }
    function getPositioner(el) {
        if (el instanceof Chart.elements.Arc) return positioners.arc;
        if (el instanceof Chart.elements.Point) return positioners.point;
        if (el instanceof Chart.elements.Rectangle) return positioners.rect;
        return positioners.fallback;
    }
    function drawFrame(ctx, rect, model) {
        var bgColor = model.backgroundColor;
        var borderColor = model.borderColor;
        var borderWidth = model.borderWidth;
        if (!bgColor && (!borderColor || !borderWidth)) return;
        ctx.beginPath();
        helpers$1.canvas.roundedRect(ctx, rasterize(rect.x) + borderWidth / 2, rasterize(rect.y) + borderWidth / 2, rasterize(rect.w) - borderWidth, rasterize(rect.h) - borderWidth, model.borderRadius);
        ctx.closePath();
        if (bgColor) {
            ctx.fillStyle = bgColor;
            ctx.fill();
        }
        if (borderColor && borderWidth) {
            ctx.strokeStyle = borderColor;
            ctx.lineWidth = borderWidth;
            ctx.lineJoin = "miter";
            ctx.stroke();
        }
    }
    function textGeometry(rect, align, font) {
        var h = font.lineHeight;
        var w = rect.w;
        var x = rect.x;
        var y = rect.y + h / 2;
        if (align === "center") x += w / 2;
        else if (align === "end" || align === "right") x += w;
        return {
            h: h,
            w: w,
            x: x,
            y: y
        };
    }
    function drawTextLine(ctx, text, cfg) {
        var shadow = ctx.shadowBlur;
        var stroked = cfg.stroked;
        var x = rasterize(cfg.x);
        var y = rasterize(cfg.y);
        var w = rasterize(cfg.w);
        if (stroked) ctx.strokeText(text, x, y, w);
        if (cfg.filled) {
            if (shadow && stroked) // Prevent drawing shadow on both the text stroke and fill, so
            // if the text is stroked, remove the shadow for the text fill.
            ctx.shadowBlur = 0;
            ctx.fillText(text, x, y, w);
            if (shadow && stroked) ctx.shadowBlur = shadow;
        }
    }
    function drawText(ctx, lines, rect, model) {
        var align = model.textAlign;
        var color = model.color;
        var filled = !!color;
        var font = model.font;
        var ilen = lines.length;
        var strokeColor = model.textStrokeColor;
        var strokeWidth = model.textStrokeWidth;
        var stroked = strokeColor && strokeWidth;
        var i;
        if (!ilen || !filled && !stroked) return;
        // Adjust coordinates based on text alignment and line height
        rect = textGeometry(rect, align, font);
        ctx.font = font.string;
        ctx.textAlign = align;
        ctx.textBaseline = "middle";
        ctx.shadowBlur = model.textShadowBlur;
        ctx.shadowColor = model.textShadowColor;
        if (filled) ctx.fillStyle = color;
        if (stroked) {
            ctx.lineJoin = "round";
            ctx.lineWidth = strokeWidth;
            ctx.strokeStyle = strokeColor;
        }
        for(i = 0, ilen = lines.length; i < ilen; ++i)drawTextLine(ctx, lines[i], {
            stroked: stroked,
            filled: filled,
            w: rect.w,
            x: rect.x,
            y: rect.y + rect.h * i
        });
    }
    var Label = function(config, ctx, el, index) {
        var me = this;
        me._config = config;
        me._index = index;
        me._model = null;
        me._rects = null;
        me._ctx = ctx;
        me._el = el;
    };
    helpers$1.extend(Label.prototype, {
        /**
	 * @private
	 */ _modelize: function(display, lines, config, context) {
            var me = this;
            var index = me._index;
            var resolve = helpers$1.options.resolve;
            var font = utils.parseFont(resolve([
                config.font,
                {}
            ], context, index));
            var color = resolve([
                config.color,
                Chart.defaults.global.defaultFontColor
            ], context, index);
            return {
                align: resolve([
                    config.align,
                    "center"
                ], context, index),
                anchor: resolve([
                    config.anchor,
                    "center"
                ], context, index),
                area: context.chart.chartArea,
                backgroundColor: resolve([
                    config.backgroundColor,
                    null
                ], context, index),
                borderColor: resolve([
                    config.borderColor,
                    null
                ], context, index),
                borderRadius: resolve([
                    config.borderRadius,
                    0
                ], context, index),
                borderWidth: resolve([
                    config.borderWidth,
                    0
                ], context, index),
                clamp: resolve([
                    config.clamp,
                    false
                ], context, index),
                clip: resolve([
                    config.clip,
                    false
                ], context, index),
                color: color,
                display: display,
                font: font,
                lines: lines,
                offset: resolve([
                    config.offset,
                    0
                ], context, index),
                opacity: resolve([
                    config.opacity,
                    1
                ], context, index),
                origin: getScaleOrigin(me._el),
                padding: helpers$1.options.toPadding(resolve([
                    config.padding,
                    0
                ], context, index)),
                positioner: getPositioner(me._el),
                rotation: resolve([
                    config.rotation,
                    0
                ], context, index) * (Math.PI / 180),
                size: utils.textSize(me._ctx, lines, font),
                textAlign: resolve([
                    config.textAlign,
                    "start"
                ], context, index),
                textShadowBlur: resolve([
                    config.textShadowBlur,
                    0
                ], context, index),
                textShadowColor: resolve([
                    config.textShadowColor,
                    color
                ], context, index),
                textStrokeColor: resolve([
                    config.textStrokeColor,
                    color
                ], context, index),
                textStrokeWidth: resolve([
                    config.textStrokeWidth,
                    0
                ], context, index)
            };
        },
        update: function(context) {
            var me = this;
            var model = null;
            var rects = null;
            var index = me._index;
            var config = me._config;
            var value, label, lines;
            // We first resolve the display option (separately) to avoid computing
            // other options in case the label is hidden (i.e. display: false).
            var display = helpers$1.options.resolve([
                config.display,
                true
            ], context, index);
            if (display) {
                value = context.dataset.data[index];
                label = helpers$1.valueOrDefault(helpers$1.callback(config.formatter, [
                    value,
                    context
                ]), value);
                lines = helpers$1.isNullOrUndef(label) ? [] : utils.toTextLines(label);
                if (lines.length) {
                    model = me._modelize(display, lines, config, context);
                    rects = boundingRects(model);
                }
            }
            me._model = model;
            me._rects = rects;
        },
        geometry: function() {
            return this._rects ? this._rects.frame : {};
        },
        rotation: function() {
            return this._model ? this._model.rotation : 0;
        },
        visible: function() {
            return this._model && this._model.opacity;
        },
        model: function() {
            return this._model;
        },
        draw: function(chart, center) {
            var me = this;
            var ctx = chart.ctx;
            var model = me._model;
            var rects = me._rects;
            var area;
            if (!this.visible()) return;
            ctx.save();
            if (model.clip) {
                area = model.area;
                ctx.beginPath();
                ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
                ctx.clip();
            }
            ctx.globalAlpha = utils.bound(0, model.opacity, 1);
            ctx.translate(rasterize(center.x), rasterize(center.y));
            ctx.rotate(model.rotation);
            drawFrame(ctx, rects.frame, model);
            drawText(ctx, model.lines, rects.text, model);
            ctx.restore();
        }
    });
    var helpers$2 = Chart.helpers;
    var MIN_INTEGER = Number.MIN_SAFE_INTEGER || -9007199254740991; // eslint-disable-line es/no-number-minsafeinteger
    var MAX_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991; // eslint-disable-line es/no-number-maxsafeinteger
    function rotated(point, center, angle) {
        var cos = Math.cos(angle);
        var sin = Math.sin(angle);
        var cx = center.x;
        var cy = center.y;
        return {
            x: cx + cos * (point.x - cx) - sin * (point.y - cy),
            y: cy + sin * (point.x - cx) + cos * (point.y - cy)
        };
    }
    function projected(points, axis) {
        var min = MAX_INTEGER;
        var max = MIN_INTEGER;
        var origin = axis.origin;
        var i, pt, vx, vy, dp;
        for(i = 0; i < points.length; ++i){
            pt = points[i];
            vx = pt.x - origin.x;
            vy = pt.y - origin.y;
            dp = axis.vx * vx + axis.vy * vy;
            min = Math.min(min, dp);
            max = Math.max(max, dp);
        }
        return {
            min: min,
            max: max
        };
    }
    function toAxis(p0, p1) {
        var vx = p1.x - p0.x;
        var vy = p1.y - p0.y;
        var ln = Math.sqrt(vx * vx + vy * vy);
        return {
            vx: (p1.x - p0.x) / ln,
            vy: (p1.y - p0.y) / ln,
            origin: p0,
            ln: ln
        };
    }
    var HitBox = function() {
        this._rotation = 0;
        this._rect = {
            x: 0,
            y: 0,
            w: 0,
            h: 0
        };
    };
    helpers$2.extend(HitBox.prototype, {
        center: function() {
            var r = this._rect;
            return {
                x: r.x + r.w / 2,
                y: r.y + r.h / 2
            };
        },
        update: function(center, rect, rotation) {
            this._rotation = rotation;
            this._rect = {
                x: rect.x + center.x,
                y: rect.y + center.y,
                w: rect.w,
                h: rect.h
            };
        },
        contains: function(point) {
            var me = this;
            var margin = 1;
            var rect = me._rect;
            point = rotated(point, me.center(), -me._rotation);
            return !(point.x < rect.x - margin || point.y < rect.y - margin || point.x > rect.x + rect.w + margin * 2 || point.y > rect.y + rect.h + margin * 2);
        },
        // Separating Axis Theorem
        // https://gamedevelopment.tutsplus.com/tutorials/collision-detection-using-the-separating-axis-theorem--gamedev-169
        intersects: function(other) {
            var r0 = this._points();
            var r1 = other._points();
            var axes = [
                toAxis(r0[0], r0[1]),
                toAxis(r0[0], r0[3])
            ];
            var i, pr0, pr1;
            if (this._rotation !== other._rotation) // Only separate with r1 axis if the rotation is different,
            // else it's enough to separate r0 and r1 with r0 axis only!
            axes.push(toAxis(r1[0], r1[1]), toAxis(r1[0], r1[3]));
            for(i = 0; i < axes.length; ++i){
                pr0 = projected(r0, axes[i]);
                pr1 = projected(r1, axes[i]);
                if (pr0.max < pr1.min || pr1.max < pr0.min) return false;
            }
            return true;
        },
        /**
	 * @private
	 */ _points: function() {
            var me = this;
            var rect = me._rect;
            var angle = me._rotation;
            var center = me.center();
            return [
                rotated({
                    x: rect.x,
                    y: rect.y
                }, center, angle),
                rotated({
                    x: rect.x + rect.w,
                    y: rect.y
                }, center, angle),
                rotated({
                    x: rect.x + rect.w,
                    y: rect.y + rect.h
                }, center, angle),
                rotated({
                    x: rect.x,
                    y: rect.y + rect.h
                }, center, angle)
            ];
        }
    });
    function coordinates(view, model, geometry) {
        var point = model.positioner(view, model);
        var vx = point.vx;
        var vy = point.vy;
        if (!vx && !vy) // if aligned center, we don't want to offset the center point
        return {
            x: point.x,
            y: point.y
        };
        var w = geometry.w;
        var h = geometry.h;
        // take in account the label rotation
        var rotation = model.rotation;
        var dx = Math.abs(w / 2 * Math.cos(rotation)) + Math.abs(h / 2 * Math.sin(rotation));
        var dy = Math.abs(w / 2 * Math.sin(rotation)) + Math.abs(h / 2 * Math.cos(rotation));
        // scale the unit vector (vx, vy) to get at least dx or dy equal to
        // w or h respectively (else we would calculate the distance to the
        // ellipse inscribed in the bounding rect)
        var vs = 1 / Math.max(Math.abs(vx), Math.abs(vy));
        dx *= vx * vs;
        dy *= vy * vs;
        // finally, include the explicit offset
        dx += model.offset * vx;
        dy += model.offset * vy;
        return {
            x: point.x + dx,
            y: point.y + dy
        };
    }
    function collide(labels, collider) {
        var i, j, s0, s1;
        // IMPORTANT Iterate in the reverse order since items at the end of the
        // list have an higher weight/priority and thus should be less impacted
        // by the overlapping strategy.
        for(i = labels.length - 1; i >= 0; --i){
            s0 = labels[i].$layout;
            for(j = i - 1; j >= 0 && s0._visible; --j){
                s1 = labels[j].$layout;
                if (s1._visible && s0._box.intersects(s1._box)) collider(s0, s1);
            }
        }
        return labels;
    }
    function compute$1(labels) {
        var i, ilen, label, state, geometry, center;
        // Initialize labels for overlap detection
        for(i = 0, ilen = labels.length; i < ilen; ++i){
            label = labels[i];
            state = label.$layout;
            if (state._visible) {
                geometry = label.geometry();
                center = coordinates(label._el._model, label.model(), geometry);
                state._box.update(center, geometry, label.rotation());
            }
        }
        // Auto hide overlapping labels
        return collide(labels, function(s0, s1) {
            var h0 = s0._hidable;
            var h1 = s1._hidable;
            if (h0 && h1 || h1) s1._visible = false;
            else if (h0) s0._visible = false;
        });
    }
    var layout = {
        prepare: function(datasets) {
            var labels = [];
            var i, j, ilen, jlen, label;
            for(i = 0, ilen = datasets.length; i < ilen; ++i)for(j = 0, jlen = datasets[i].length; j < jlen; ++j){
                label = datasets[i][j];
                labels.push(label);
                label.$layout = {
                    _box: new HitBox(),
                    _hidable: false,
                    _visible: true,
                    _set: i,
                    _idx: j
                };
            }
            // TODO New `z` option: labels with a higher z-index are drawn
            // of top of the ones with a lower index. Lowest z-index labels
            // are also discarded first when hiding overlapping labels.
            labels.sort(function(a, b) {
                var sa = a.$layout;
                var sb = b.$layout;
                return sa._idx === sb._idx ? sb._set - sa._set : sb._idx - sa._idx;
            });
            this.update(labels);
            return labels;
        },
        update: function(labels) {
            var dirty = false;
            var i, ilen, label, model, state;
            for(i = 0, ilen = labels.length; i < ilen; ++i){
                label = labels[i];
                model = label.model();
                state = label.$layout;
                state._hidable = model && model.display === "auto";
                state._visible = label.visible();
                dirty |= state._hidable;
            }
            if (dirty) compute$1(labels);
        },
        lookup: function(labels, point) {
            var i, state;
            // IMPORTANT Iterate in the reverse order since items at the end of
            // the list have an higher z-index, thus should be picked first.
            for(i = labels.length - 1; i >= 0; --i){
                state = labels[i].$layout;
                if (state && state._visible && state._box.contains(point)) return labels[i];
            }
            return null;
        },
        draw: function(chart, labels) {
            var i, ilen, label, state, geometry, center;
            for(i = 0, ilen = labels.length; i < ilen; ++i){
                label = labels[i];
                state = label.$layout;
                if (state._visible) {
                    geometry = label.geometry();
                    center = coordinates(label._el._view, label.model(), geometry);
                    state._box.update(center, geometry, label.rotation());
                    label.draw(chart, center);
                }
            }
        }
    };
    var helpers$3 = Chart.helpers;
    var formatter = function(value) {
        if (helpers$3.isNullOrUndef(value)) return null;
        var label = value;
        var keys, klen, k;
        if (helpers$3.isObject(value)) {
            if (!helpers$3.isNullOrUndef(value.label)) label = value.label;
            else if (!helpers$3.isNullOrUndef(value.r)) label = value.r;
            else {
                label = "";
                keys = Object.keys(value);
                for(k = 0, klen = keys.length; k < klen; ++k)label += (k !== 0 ? ", " : "") + keys[k] + ": " + value[keys[k]];
            }
        }
        return "" + label;
    };
    /**
 * IMPORTANT: make sure to also update tests and TypeScript definition
 * files (`/test/specs/defaults.spec.js` and `/types/options.d.ts`)
 */ var defaults = {
        align: "center",
        anchor: "center",
        backgroundColor: null,
        borderColor: null,
        borderRadius: 0,
        borderWidth: 0,
        clamp: false,
        clip: false,
        color: undefined,
        display: true,
        font: {
            family: undefined,
            lineHeight: 1.2,
            size: undefined,
            style: undefined,
            weight: null
        },
        formatter: formatter,
        labels: undefined,
        listeners: {},
        offset: 4,
        opacity: 1,
        padding: {
            top: 4,
            right: 4,
            bottom: 4,
            left: 4
        },
        rotation: 0,
        textAlign: "start",
        textStrokeColor: undefined,
        textStrokeWidth: 0,
        textShadowBlur: 0,
        textShadowColor: undefined
    };
    /**
 * @see https://github.com/chartjs/Chart.js/issues/4176
 */ var helpers$4 = Chart.helpers;
    var EXPANDO_KEY = "$datalabels";
    var DEFAULT_KEY = "$default";
    function configure(dataset, options) {
        var override = dataset.datalabels;
        var listeners = {};
        var configs = [];
        var labels, keys;
        if (override === false) return null;
        if (override === true) override = {};
        options = helpers$4.merge({}, [
            options,
            override
        ]);
        labels = options.labels || {};
        keys = Object.keys(labels);
        delete options.labels;
        if (keys.length) keys.forEach(function(key) {
            if (labels[key]) configs.push(helpers$4.merge({}, [
                options,
                labels[key],
                {
                    _key: key
                }
            ]));
        });
        else // Default label if no "named" label defined.
        configs.push(options);
        // listeners: {<event-type>: {<label-key>: <fn>}}
        listeners = configs.reduce(function(target, config) {
            helpers$4.each(config.listeners || {}, function(fn, event) {
                target[event] = target[event] || {};
                target[event][config._key || DEFAULT_KEY] = fn;
            });
            delete config.listeners;
            return target;
        }, {});
        return {
            labels: configs,
            listeners: listeners
        };
    }
    function dispatchEvent(chart, listeners, label) {
        if (!listeners) return;
        var context = label.$context;
        var groups = label.$groups;
        var callback;
        if (!listeners[groups._set]) return;
        callback = listeners[groups._set][groups._key];
        if (!callback) return;
        if (helpers$4.callback(callback, [
            context
        ]) === true) {
            // Users are allowed to tweak the given context by injecting values that can be
            // used in scriptable options to display labels differently based on the current
            // event (e.g. highlight an hovered label). That's why we update the label with
            // the output context and schedule a new chart render by setting it dirty.
            chart[EXPANDO_KEY]._dirty = true;
            label.update(context);
        }
    }
    function dispatchMoveEvents(chart, listeners, previous, label) {
        var enter, leave;
        if (!previous && !label) return;
        if (!previous) enter = true;
        else if (!label) leave = true;
        else if (previous !== label) leave = enter = true;
        if (leave) dispatchEvent(chart, listeners.leave, previous);
        if (enter) dispatchEvent(chart, listeners.enter, label);
    }
    function handleMoveEvents(chart, event) {
        var expando = chart[EXPANDO_KEY];
        var listeners = expando._listeners;
        var previous, label;
        if (!listeners.enter && !listeners.leave) return;
        if (event.type === "mousemove") label = layout.lookup(expando._labels, event);
        else if (event.type !== "mouseout") return;
        previous = expando._hovered;
        expando._hovered = label;
        dispatchMoveEvents(chart, listeners, previous, label);
    }
    function handleClickEvents(chart, event) {
        var expando = chart[EXPANDO_KEY];
        var handlers = expando._listeners.click;
        var label = handlers && layout.lookup(expando._labels, event);
        if (label) dispatchEvent(chart, handlers, label);
    }
    // https://github.com/chartjs/chartjs-plugin-datalabels/issues/108
    function invalidate(chart) {
        if (chart.animating) return;
        // `chart.animating` can be `false` even if there is animation in progress,
        // so let's iterate all animations to find if there is one for the `chart`.
        var animations = Chart.animationService.animations;
        for(var i = 0, ilen = animations.length; i < ilen; ++i){
            if (animations[i].chart === chart) return;
        }
        // No render scheduled: trigger a "lazy" render that can be canceled in case
        // of hover interactions. The 1ms duration is a workaround to make sure an
        // animation is created so the controller can stop it before any transition.
        chart.render({
            duration: 1,
            lazy: true
        });
    }
    Chart.defaults.global.plugins.datalabels = defaults;
    var plugin = {
        id: "datalabels",
        beforeInit: function(chart) {
            chart[EXPANDO_KEY] = {
                _actives: []
            };
        },
        beforeUpdate: function(chart) {
            var expando = chart[EXPANDO_KEY];
            expando._listened = false;
            expando._listeners = {}; // {<event-type>: {<dataset-index>: {<label-key>: <fn>}}}
            expando._datasets = []; // per dataset labels: [Label[]]
            expando._labels = []; // layouted labels: Label[]
        },
        afterDatasetUpdate: function(chart, args, options) {
            var datasetIndex = args.index;
            var expando = chart[EXPANDO_KEY];
            var labels = expando._datasets[datasetIndex] = [];
            var visible = chart.isDatasetVisible(datasetIndex);
            var dataset = chart.data.datasets[datasetIndex];
            var config = configure(dataset, options);
            var elements = args.meta.data || [];
            var ctx = chart.ctx;
            var i, j, ilen, jlen, cfg, key, el, label;
            ctx.save();
            for(i = 0, ilen = elements.length; i < ilen; ++i){
                el = elements[i];
                el[EXPANDO_KEY] = [];
                if (visible && el && !el.hidden && !el._model.skip) for(j = 0, jlen = config.labels.length; j < jlen; ++j){
                    cfg = config.labels[j];
                    key = cfg._key;
                    label = new Label(cfg, ctx, el, i);
                    label.$groups = {
                        _set: datasetIndex,
                        _key: key || DEFAULT_KEY
                    };
                    label.$context = {
                        active: false,
                        chart: chart,
                        dataIndex: i,
                        dataset: dataset,
                        datasetIndex: datasetIndex
                    };
                    label.update(label.$context);
                    el[EXPANDO_KEY].push(label);
                    labels.push(label);
                }
            }
            ctx.restore();
            // Store listeners at the chart level and per event type to optimize
            // cases where no listeners are registered for a specific event.
            helpers$4.merge(expando._listeners, config.listeners, {
                merger: function(event, target, source) {
                    target[event] = target[event] || {};
                    target[event][args.index] = source[event];
                    expando._listened = true;
                }
            });
        },
        afterUpdate: function(chart, options) {
            chart[EXPANDO_KEY]._labels = layout.prepare(chart[EXPANDO_KEY]._datasets, options);
        },
        // Draw labels on top of all dataset elements
        // https://github.com/chartjs/chartjs-plugin-datalabels/issues/29
        // https://github.com/chartjs/chartjs-plugin-datalabels/issues/32
        afterDatasetsDraw: function(chart) {
            layout.draw(chart, chart[EXPANDO_KEY]._labels);
        },
        beforeEvent: function(chart, event) {
            // If there is no listener registered for this chart, `listened` will be false,
            // meaning we can immediately ignore the incoming event and avoid useless extra
            // computation for users who don't implement label interactions.
            if (chart[EXPANDO_KEY]._listened) switch(event.type){
                case "mousemove":
                case "mouseout":
                    handleMoveEvents(chart, event);
                    break;
                case "click":
                    handleClickEvents(chart, event);
                    break;
                default:
            }
        },
        afterEvent: function(chart) {
            var expando = chart[EXPANDO_KEY];
            var previous = expando._actives;
            var actives = expando._actives = chart.lastActive || []; // public API?!
            var updates = utils.arrayDiff(previous, actives);
            var i, ilen, j, jlen, update, label, labels;
            for(i = 0, ilen = updates.length; i < ilen; ++i){
                update = updates[i];
                if (update[1]) {
                    labels = update[0][EXPANDO_KEY] || [];
                    for(j = 0, jlen = labels.length; j < jlen; ++j){
                        label = labels[j];
                        label.$context.active = update[1] === 1;
                        label.update(label.$context);
                    }
                }
            }
            if (expando._dirty || updates.length) {
                layout.update(expando._labels);
                invalidate(chart);
            }
            delete expando._dirty;
        }
    };
    // TODO Remove at version 1, we shouldn't automatically register plugins.
    // https://github.com/chartjs/chartjs-plugin-datalabels/issues/42
    Chart.plugins.register(plugin);
    return plugin;
});

});

parcelRegister("9hhok", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c13312359e6c310$export$2e2bcd8739ae039);

var $kLwj3 = parcelRequire("kLwj3");

var $3Iynq = parcelRequire("3Iynq");

var $l2VaP = parcelRequire("l2VaP");

var $e9p9b = parcelRequire("e9p9b");

var $8Hr3t = parcelRequire("8Hr3t");

var $f5y5D = parcelRequire("f5y5D");
parcelRequire("3KkRp");
var $6c13312359e6c310$var$__assign = undefined && undefined.__assign || function() {
    $6c13312359e6c310$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6c13312359e6c310$var$__assign.apply(this, arguments);
};
var $6c13312359e6c310$var$__spreadArrays = undefined && undefined.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
var $6c13312359e6c310$var$DEBOUNCED_CHANGE_MS = 300;
function $6c13312359e6c310$var$FlatpickrInstance(element, instanceConfig) {
    var self = {
        config: $6c13312359e6c310$var$__assign($6c13312359e6c310$var$__assign({}, (0, $kLwj3.defaults)), $6c13312359e6c310$var$flatpickr.defaultConfig),
        l10n: (0, $3Iynq.default)
    };
    self.parseDate = (0, $8Hr3t.createDateParser)({
        config: self.config,
        l10n: self.l10n
    });
    self._handlers = [];
    self.pluginElements = [];
    self.loadedPlugins = [];
    self._bind = bind;
    self._setHoursFromDate = setHoursFromDate;
    self._positionCalendar = positionCalendar;
    self.changeMonth = changeMonth;
    self.changeYear = changeYear;
    self.clear = clear;
    self.close = close;
    self.onMouseOver = onMouseOver;
    self._createElement = (0, $e9p9b.createElement);
    self.createDay = createDay;
    self.destroy = destroy;
    self.isEnabled = isEnabled;
    self.jumpToDate = jumpToDate;
    self.updateValue = updateValue;
    self.open = open;
    self.redraw = redraw;
    self.set = set;
    self.setDate = setDate;
    self.toggle = toggle;
    function setupHelperFunctions() {
        self.utils = {
            getDaysInMonth: function(month, yr) {
                if (month === void 0) month = self.currentMonth;
                if (yr === void 0) yr = self.currentYear;
                if (month === 1 && (yr % 4 === 0 && yr % 100 !== 0 || yr % 400 === 0)) return 29;
                return self.l10n.daysInMonth[month];
            }
        };
    }
    function init() {
        self.element = self.input = element;
        self.isOpen = false;
        parseConfig();
        setupLocale();
        setupInputs();
        setupDates();
        setupHelperFunctions();
        if (!self.isMobile) build();
        bindEvents();
        if (self.selectedDates.length || self.config.noCalendar) {
            if (self.config.enableTime) setHoursFromDate(self.config.noCalendar ? self.latestSelectedDateObj : undefined);
            updateValue(false);
        }
        setCalendarWidth();
        var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        if (!self.isMobile && isSafari) positionCalendar();
        triggerEvent("onReady");
    }
    function getClosestActiveElement() {
        var _a;
        return ((_a = self.calendarContainer) === null || _a === void 0 ? void 0 : _a.getRootNode()).activeElement || document.activeElement;
    }
    function bindToInstance(fn) {
        return fn.bind(self);
    }
    function setCalendarWidth() {
        var config = self.config;
        if (config.weekNumbers === false && config.showMonths === 1) return;
        else if (config.noCalendar !== true) window.requestAnimationFrame(function() {
            if (self.calendarContainer !== undefined) {
                self.calendarContainer.style.visibility = "hidden";
                self.calendarContainer.style.display = "block";
            }
            if (self.daysContainer !== undefined) {
                var daysWidth = (self.days.offsetWidth + 1) * config.showMonths;
                self.daysContainer.style.width = daysWidth + "px";
                self.calendarContainer.style.width = daysWidth + (self.weekWrapper !== undefined ? self.weekWrapper.offsetWidth : 0) + "px";
                self.calendarContainer.style.removeProperty("visibility");
                self.calendarContainer.style.removeProperty("display");
            }
        });
    }
    function updateTime(e) {
        if (self.selectedDates.length === 0) {
            var defaultDate = self.config.minDate === undefined || (0, $8Hr3t.compareDates)(new Date(), self.config.minDate) >= 0 ? new Date() : new Date(self.config.minDate.getTime());
            var defaults = (0, $8Hr3t.getDefaultHours)(self.config);
            defaultDate.setHours(defaults.hours, defaults.minutes, defaults.seconds, defaultDate.getMilliseconds());
            self.selectedDates = [
                defaultDate
            ];
            self.latestSelectedDateObj = defaultDate;
        }
        if (e !== undefined && e.type !== "blur") timeWrapper(e);
        var prevValue = self._input.value;
        setHoursFromInputs();
        updateValue();
        if (self._input.value !== prevValue) self._debouncedChange();
    }
    function ampm2military(hour, amPM) {
        return hour % 12 + 12 * (0, $l2VaP.int)(amPM === self.l10n.amPM[1]);
    }
    function military2ampm(hour) {
        switch(hour % 24){
            case 0:
            case 12:
                return 12;
            default:
                return hour % 12;
        }
    }
    function setHoursFromInputs() {
        if (self.hourElement === undefined || self.minuteElement === undefined) return;
        var hours = (parseInt(self.hourElement.value.slice(-2), 10) || 0) % 24, minutes = (parseInt(self.minuteElement.value, 10) || 0) % 60, seconds = self.secondElement !== undefined ? (parseInt(self.secondElement.value, 10) || 0) % 60 : 0;
        if (self.amPM !== undefined) hours = ampm2military(hours, self.amPM.textContent);
        var limitMinHours = self.config.minTime !== undefined || self.config.minDate && self.minDateHasTime && self.latestSelectedDateObj && (0, $8Hr3t.compareDates)(self.latestSelectedDateObj, self.config.minDate, true) === 0;
        var limitMaxHours = self.config.maxTime !== undefined || self.config.maxDate && self.maxDateHasTime && self.latestSelectedDateObj && (0, $8Hr3t.compareDates)(self.latestSelectedDateObj, self.config.maxDate, true) === 0;
        if (self.config.maxTime !== undefined && self.config.minTime !== undefined && self.config.minTime > self.config.maxTime) {
            var minBound = (0, $8Hr3t.calculateSecondsSinceMidnight)(self.config.minTime.getHours(), self.config.minTime.getMinutes(), self.config.minTime.getSeconds());
            var maxBound = (0, $8Hr3t.calculateSecondsSinceMidnight)(self.config.maxTime.getHours(), self.config.maxTime.getMinutes(), self.config.maxTime.getSeconds());
            var currentTime = (0, $8Hr3t.calculateSecondsSinceMidnight)(hours, minutes, seconds);
            if (currentTime > maxBound && currentTime < minBound) {
                var result = (0, $8Hr3t.parseSeconds)(minBound);
                hours = result[0];
                minutes = result[1];
                seconds = result[2];
            }
        } else {
            if (limitMaxHours) {
                var maxTime = self.config.maxTime !== undefined ? self.config.maxTime : self.config.maxDate;
                hours = Math.min(hours, maxTime.getHours());
                if (hours === maxTime.getHours()) minutes = Math.min(minutes, maxTime.getMinutes());
                if (minutes === maxTime.getMinutes()) seconds = Math.min(seconds, maxTime.getSeconds());
            }
            if (limitMinHours) {
                var minTime = self.config.minTime !== undefined ? self.config.minTime : self.config.minDate;
                hours = Math.max(hours, minTime.getHours());
                if (hours === minTime.getHours() && minutes < minTime.getMinutes()) minutes = minTime.getMinutes();
                if (minutes === minTime.getMinutes()) seconds = Math.max(seconds, minTime.getSeconds());
            }
        }
        setHours(hours, minutes, seconds);
    }
    function setHoursFromDate(dateObj) {
        var date = dateObj || self.latestSelectedDateObj;
        if (date && date instanceof Date) setHours(date.getHours(), date.getMinutes(), date.getSeconds());
    }
    function setHours(hours, minutes, seconds) {
        if (self.latestSelectedDateObj !== undefined) self.latestSelectedDateObj.setHours(hours % 24, minutes, seconds || 0, 0);
        if (!self.hourElement || !self.minuteElement || self.isMobile) return;
        self.hourElement.value = (0, $l2VaP.pad)(!self.config.time_24hr ? (12 + hours) % 12 + 12 * (0, $l2VaP.int)(hours % 12 === 0) : hours);
        self.minuteElement.value = (0, $l2VaP.pad)(minutes);
        if (self.amPM !== undefined) self.amPM.textContent = self.l10n.amPM[(0, $l2VaP.int)(hours >= 12)];
        if (self.secondElement !== undefined) self.secondElement.value = (0, $l2VaP.pad)(seconds);
    }
    function onYearInput(event) {
        var eventTarget = (0, $e9p9b.getEventTarget)(event);
        var year = parseInt(eventTarget.value) + (event.delta || 0);
        if (year / 1000 > 1 || event.key === "Enter" && !/[^\d]/.test(year.toString())) changeYear(year);
    }
    function bind(element, event, handler, options) {
        if (event instanceof Array) return event.forEach(function(ev) {
            return bind(element, ev, handler, options);
        });
        if (element instanceof Array) return element.forEach(function(el) {
            return bind(el, event, handler, options);
        });
        element.addEventListener(event, handler, options);
        self._handlers.push({
            remove: function() {
                return element.removeEventListener(event, handler, options);
            }
        });
    }
    function triggerChange() {
        triggerEvent("onChange");
    }
    function bindEvents() {
        if (self.config.wrap) [
            "open",
            "close",
            "toggle",
            "clear"
        ].forEach(function(evt) {
            Array.prototype.forEach.call(self.element.querySelectorAll("[data-" + evt + "]"), function(el) {
                return bind(el, "click", self[evt]);
            });
        });
        if (self.isMobile) {
            setupMobile();
            return;
        }
        var debouncedResize = (0, $l2VaP.debounce)(onResize, 50);
        self._debouncedChange = (0, $l2VaP.debounce)(triggerChange, $6c13312359e6c310$var$DEBOUNCED_CHANGE_MS);
        if (self.daysContainer && !/iPhone|iPad|iPod/i.test(navigator.userAgent)) bind(self.daysContainer, "mouseover", function(e) {
            if (self.config.mode === "range") onMouseOver((0, $e9p9b.getEventTarget)(e));
        });
        bind(self._input, "keydown", onKeyDown);
        if (self.calendarContainer !== undefined) bind(self.calendarContainer, "keydown", onKeyDown);
        if (!self.config.inline && !self.config.static) bind(window, "resize", debouncedResize);
        if (window.ontouchstart !== undefined) bind(window.document, "touchstart", documentClick);
        else bind(window.document, "mousedown", documentClick);
        bind(window.document, "focus", documentClick, {
            capture: true
        });
        if (self.config.clickOpens === true) {
            bind(self._input, "focus", self.open);
            bind(self._input, "click", self.open);
        }
        if (self.daysContainer !== undefined) {
            bind(self.monthNav, "click", onMonthNavClick);
            bind(self.monthNav, [
                "keyup",
                "increment"
            ], onYearInput);
            bind(self.daysContainer, "click", selectDate);
        }
        if (self.timeContainer !== undefined && self.minuteElement !== undefined && self.hourElement !== undefined) {
            var selText = function(e) {
                return (0, $e9p9b.getEventTarget)(e).select();
            };
            bind(self.timeContainer, [
                "increment"
            ], updateTime);
            bind(self.timeContainer, "blur", updateTime, {
                capture: true
            });
            bind(self.timeContainer, "click", timeIncrement);
            bind([
                self.hourElement,
                self.minuteElement
            ], [
                "focus",
                "click"
            ], selText);
            if (self.secondElement !== undefined) bind(self.secondElement, "focus", function() {
                return self.secondElement && self.secondElement.select();
            });
            if (self.amPM !== undefined) bind(self.amPM, "click", function(e) {
                updateTime(e);
            });
        }
        if (self.config.allowInput) bind(self._input, "blur", onBlur);
    }
    function jumpToDate(jumpDate, triggerChange) {
        var jumpTo = jumpDate !== undefined ? self.parseDate(jumpDate) : self.latestSelectedDateObj || (self.config.minDate && self.config.minDate > self.now ? self.config.minDate : self.config.maxDate && self.config.maxDate < self.now ? self.config.maxDate : self.now);
        var oldYear = self.currentYear;
        var oldMonth = self.currentMonth;
        try {
            if (jumpTo !== undefined) {
                self.currentYear = jumpTo.getFullYear();
                self.currentMonth = jumpTo.getMonth();
            }
        } catch (e) {
            e.message = "Invalid date supplied: " + jumpTo;
            self.config.errorHandler(e);
        }
        if (triggerChange && self.currentYear !== oldYear) {
            triggerEvent("onYearChange");
            buildMonthSwitch();
        }
        if (triggerChange && (self.currentYear !== oldYear || self.currentMonth !== oldMonth)) triggerEvent("onMonthChange");
        self.redraw();
    }
    function timeIncrement(e) {
        var eventTarget = (0, $e9p9b.getEventTarget)(e);
        if (~eventTarget.className.indexOf("arrow")) incrementNumInput(e, eventTarget.classList.contains("arrowUp") ? 1 : -1);
    }
    function incrementNumInput(e, delta, inputElem) {
        var target = e && (0, $e9p9b.getEventTarget)(e);
        var input = inputElem || target && target.parentNode && target.parentNode.firstChild;
        var event = createEvent("increment");
        event.delta = delta;
        input && input.dispatchEvent(event);
    }
    function build() {
        var fragment = window.document.createDocumentFragment();
        self.calendarContainer = (0, $e9p9b.createElement)("div", "flatpickr-calendar");
        self.calendarContainer.tabIndex = -1;
        if (!self.config.noCalendar) {
            fragment.appendChild(buildMonthNav());
            self.innerContainer = (0, $e9p9b.createElement)("div", "flatpickr-innerContainer");
            if (self.config.weekNumbers) {
                var _a = buildWeeks(), weekWrapper = _a.weekWrapper, weekNumbers = _a.weekNumbers;
                self.innerContainer.appendChild(weekWrapper);
                self.weekNumbers = weekNumbers;
                self.weekWrapper = weekWrapper;
            }
            self.rContainer = (0, $e9p9b.createElement)("div", "flatpickr-rContainer");
            self.rContainer.appendChild(buildWeekdays());
            if (!self.daysContainer) {
                self.daysContainer = (0, $e9p9b.createElement)("div", "flatpickr-days");
                self.daysContainer.tabIndex = -1;
            }
            buildDays();
            self.rContainer.appendChild(self.daysContainer);
            self.innerContainer.appendChild(self.rContainer);
            fragment.appendChild(self.innerContainer);
        }
        if (self.config.enableTime) fragment.appendChild(buildTime());
        (0, $e9p9b.toggleClass)(self.calendarContainer, "rangeMode", self.config.mode === "range");
        (0, $e9p9b.toggleClass)(self.calendarContainer, "animate", self.config.animate === true);
        (0, $e9p9b.toggleClass)(self.calendarContainer, "multiMonth", self.config.showMonths > 1);
        self.calendarContainer.appendChild(fragment);
        var customAppend = self.config.appendTo !== undefined && self.config.appendTo.nodeType !== undefined;
        if (self.config.inline || self.config.static) {
            self.calendarContainer.classList.add(self.config.inline ? "inline" : "static");
            if (self.config.inline) {
                if (!customAppend && self.element.parentNode) self.element.parentNode.insertBefore(self.calendarContainer, self._input.nextSibling);
                else if (self.config.appendTo !== undefined) self.config.appendTo.appendChild(self.calendarContainer);
            }
            if (self.config.static) {
                var wrapper = (0, $e9p9b.createElement)("div", "flatpickr-wrapper");
                if (self.element.parentNode) self.element.parentNode.insertBefore(wrapper, self.element);
                wrapper.appendChild(self.element);
                if (self.altInput) wrapper.appendChild(self.altInput);
                wrapper.appendChild(self.calendarContainer);
            }
        }
        if (!self.config.static && !self.config.inline) (self.config.appendTo !== undefined ? self.config.appendTo : window.document.body).appendChild(self.calendarContainer);
    }
    function createDay(className, date, _dayNumber, i) {
        var dateIsEnabled = isEnabled(date, true), dayElement = (0, $e9p9b.createElement)("span", className, date.getDate().toString());
        dayElement.dateObj = date;
        dayElement.$i = i;
        dayElement.setAttribute("aria-label", self.formatDate(date, self.config.ariaDateFormat));
        if (className.indexOf("hidden") === -1 && (0, $8Hr3t.compareDates)(date, self.now) === 0) {
            self.todayDateElem = dayElement;
            dayElement.classList.add("today");
            dayElement.setAttribute("aria-current", "date");
        }
        if (dateIsEnabled) {
            dayElement.tabIndex = -1;
            if (isDateSelected(date)) {
                dayElement.classList.add("selected");
                self.selectedDateElem = dayElement;
                if (self.config.mode === "range") {
                    (0, $e9p9b.toggleClass)(dayElement, "startRange", self.selectedDates[0] && (0, $8Hr3t.compareDates)(date, self.selectedDates[0], true) === 0);
                    (0, $e9p9b.toggleClass)(dayElement, "endRange", self.selectedDates[1] && (0, $8Hr3t.compareDates)(date, self.selectedDates[1], true) === 0);
                    if (className === "nextMonthDay") dayElement.classList.add("inRange");
                }
            }
        } else dayElement.classList.add("flatpickr-disabled");
        if (self.config.mode === "range") {
            if (isDateInRange(date) && !isDateSelected(date)) dayElement.classList.add("inRange");
        }
        if (self.weekNumbers && self.config.showMonths === 1 && className !== "prevMonthDay" && i % 7 === 6) self.weekNumbers.insertAdjacentHTML("beforeend", "<span class='flatpickr-day'>" + self.config.getWeek(date) + "</span>");
        triggerEvent("onDayCreate", dayElement);
        return dayElement;
    }
    function focusOnDayElem(targetNode) {
        targetNode.focus();
        if (self.config.mode === "range") onMouseOver(targetNode);
    }
    function getFirstAvailableDay(delta) {
        var startMonth = delta > 0 ? 0 : self.config.showMonths - 1;
        var endMonth = delta > 0 ? self.config.showMonths : -1;
        for(var m = startMonth; m != endMonth; m += delta){
            var month = self.daysContainer.children[m];
            var startIndex = delta > 0 ? 0 : month.children.length - 1;
            var endIndex = delta > 0 ? month.children.length : -1;
            for(var i = startIndex; i != endIndex; i += delta){
                var c = month.children[i];
                if (c.className.indexOf("hidden") === -1 && isEnabled(c.dateObj)) return c;
            }
        }
        return undefined;
    }
    function getNextAvailableDay(current, delta) {
        var givenMonth = current.className.indexOf("Month") === -1 ? current.dateObj.getMonth() : self.currentMonth;
        var endMonth = delta > 0 ? self.config.showMonths : -1;
        var loopDelta = delta > 0 ? 1 : -1;
        for(var m = givenMonth - self.currentMonth; m != endMonth; m += loopDelta){
            var month = self.daysContainer.children[m];
            var startIndex = givenMonth - self.currentMonth === m ? current.$i + delta : delta < 0 ? month.children.length - 1 : 0;
            var numMonthDays = month.children.length;
            for(var i = startIndex; i >= 0 && i < numMonthDays && i != (delta > 0 ? numMonthDays : -1); i += loopDelta){
                var c = month.children[i];
                if (c.className.indexOf("hidden") === -1 && isEnabled(c.dateObj) && Math.abs(current.$i - i) >= Math.abs(delta)) return focusOnDayElem(c);
            }
        }
        self.changeMonth(loopDelta);
        focusOnDay(getFirstAvailableDay(loopDelta), 0);
        return undefined;
    }
    function focusOnDay(current, offset) {
        var activeElement = getClosestActiveElement();
        var dayFocused = isInView(activeElement || document.body);
        var startElem = current !== undefined ? current : dayFocused ? activeElement : self.selectedDateElem !== undefined && isInView(self.selectedDateElem) ? self.selectedDateElem : self.todayDateElem !== undefined && isInView(self.todayDateElem) ? self.todayDateElem : getFirstAvailableDay(offset > 0 ? 1 : -1);
        if (startElem === undefined) self._input.focus();
        else if (!dayFocused) focusOnDayElem(startElem);
        else getNextAvailableDay(startElem, offset);
    }
    function buildMonthDays(year, month) {
        var firstOfMonth = (new Date(year, month, 1).getDay() - self.l10n.firstDayOfWeek + 7) % 7;
        var prevMonthDays = self.utils.getDaysInMonth((month - 1 + 12) % 12, year);
        var daysInMonth = self.utils.getDaysInMonth(month, year), days = window.document.createDocumentFragment(), isMultiMonth = self.config.showMonths > 1, prevMonthDayClass = isMultiMonth ? "prevMonthDay hidden" : "prevMonthDay", nextMonthDayClass = isMultiMonth ? "nextMonthDay hidden" : "nextMonthDay";
        var dayNumber = prevMonthDays + 1 - firstOfMonth, dayIndex = 0;
        for(; dayNumber <= prevMonthDays; dayNumber++, dayIndex++)days.appendChild(createDay("flatpickr-day " + prevMonthDayClass, new Date(year, month - 1, dayNumber), dayNumber, dayIndex));
        for(dayNumber = 1; dayNumber <= daysInMonth; dayNumber++, dayIndex++)days.appendChild(createDay("flatpickr-day", new Date(year, month, dayNumber), dayNumber, dayIndex));
        for(var dayNum = daysInMonth + 1; dayNum <= 42 - firstOfMonth && (self.config.showMonths === 1 || dayIndex % 7 !== 0); dayNum++, dayIndex++)days.appendChild(createDay("flatpickr-day " + nextMonthDayClass, new Date(year, month + 1, dayNum % daysInMonth), dayNum, dayIndex));
        var dayContainer = (0, $e9p9b.createElement)("div", "dayContainer");
        dayContainer.appendChild(days);
        return dayContainer;
    }
    function buildDays() {
        if (self.daysContainer === undefined) return;
        (0, $e9p9b.clearNode)(self.daysContainer);
        if (self.weekNumbers) (0, $e9p9b.clearNode)(self.weekNumbers);
        var frag = document.createDocumentFragment();
        for(var i = 0; i < self.config.showMonths; i++){
            var d = new Date(self.currentYear, self.currentMonth, 1);
            d.setMonth(self.currentMonth + i);
            frag.appendChild(buildMonthDays(d.getFullYear(), d.getMonth()));
        }
        self.daysContainer.appendChild(frag);
        self.days = self.daysContainer.firstChild;
        if (self.config.mode === "range" && self.selectedDates.length === 1) onMouseOver();
    }
    function buildMonthSwitch() {
        if (self.config.showMonths > 1 || self.config.monthSelectorType !== "dropdown") return;
        var shouldBuildMonth = function(month) {
            if (self.config.minDate !== undefined && self.currentYear === self.config.minDate.getFullYear() && month < self.config.minDate.getMonth()) return false;
            return !(self.config.maxDate !== undefined && self.currentYear === self.config.maxDate.getFullYear() && month > self.config.maxDate.getMonth());
        };
        self.monthsDropdownContainer.tabIndex = -1;
        self.monthsDropdownContainer.innerHTML = "";
        for(var i = 0; i < 12; i++){
            if (!shouldBuildMonth(i)) continue;
            var month = (0, $e9p9b.createElement)("option", "flatpickr-monthDropdown-month");
            month.value = new Date(self.currentYear, i).getMonth().toString();
            month.textContent = (0, $f5y5D.monthToStr)(i, self.config.shorthandCurrentMonth, self.l10n);
            month.tabIndex = -1;
            if (self.currentMonth === i) month.selected = true;
            self.monthsDropdownContainer.appendChild(month);
        }
    }
    function buildMonth() {
        var container = (0, $e9p9b.createElement)("div", "flatpickr-month");
        var monthNavFragment = window.document.createDocumentFragment();
        var monthElement;
        if (self.config.showMonths > 1 || self.config.monthSelectorType === "static") monthElement = (0, $e9p9b.createElement)("span", "cur-month");
        else {
            self.monthsDropdownContainer = (0, $e9p9b.createElement)("select", "flatpickr-monthDropdown-months");
            self.monthsDropdownContainer.setAttribute("aria-label", self.l10n.monthAriaLabel);
            bind(self.monthsDropdownContainer, "change", function(e) {
                var target = (0, $e9p9b.getEventTarget)(e);
                var selectedMonth = parseInt(target.value, 10);
                self.changeMonth(selectedMonth - self.currentMonth);
                triggerEvent("onMonthChange");
            });
            buildMonthSwitch();
            monthElement = self.monthsDropdownContainer;
        }
        var yearInput = (0, $e9p9b.createNumberInput)("cur-year", {
            tabindex: "-1"
        });
        var yearElement = yearInput.getElementsByTagName("input")[0];
        yearElement.setAttribute("aria-label", self.l10n.yearAriaLabel);
        if (self.config.minDate) yearElement.setAttribute("min", self.config.minDate.getFullYear().toString());
        if (self.config.maxDate) {
            yearElement.setAttribute("max", self.config.maxDate.getFullYear().toString());
            yearElement.disabled = !!self.config.minDate && self.config.minDate.getFullYear() === self.config.maxDate.getFullYear();
        }
        var currentMonth = (0, $e9p9b.createElement)("div", "flatpickr-current-month");
        currentMonth.appendChild(monthElement);
        currentMonth.appendChild(yearInput);
        monthNavFragment.appendChild(currentMonth);
        container.appendChild(monthNavFragment);
        return {
            container: container,
            yearElement: yearElement,
            monthElement: monthElement
        };
    }
    function buildMonths() {
        (0, $e9p9b.clearNode)(self.monthNav);
        self.monthNav.appendChild(self.prevMonthNav);
        if (self.config.showMonths) {
            self.yearElements = [];
            self.monthElements = [];
        }
        for(var m = self.config.showMonths; m--;){
            var month = buildMonth();
            self.yearElements.push(month.yearElement);
            self.monthElements.push(month.monthElement);
            self.monthNav.appendChild(month.container);
        }
        self.monthNav.appendChild(self.nextMonthNav);
    }
    function buildMonthNav() {
        self.monthNav = (0, $e9p9b.createElement)("div", "flatpickr-months");
        self.yearElements = [];
        self.monthElements = [];
        self.prevMonthNav = (0, $e9p9b.createElement)("span", "flatpickr-prev-month");
        self.prevMonthNav.innerHTML = self.config.prevArrow;
        self.nextMonthNav = (0, $e9p9b.createElement)("span", "flatpickr-next-month");
        self.nextMonthNav.innerHTML = self.config.nextArrow;
        buildMonths();
        Object.defineProperty(self, "_hidePrevMonthArrow", {
            get: function() {
                return self.__hidePrevMonthArrow;
            },
            set: function(bool) {
                if (self.__hidePrevMonthArrow !== bool) {
                    (0, $e9p9b.toggleClass)(self.prevMonthNav, "flatpickr-disabled", bool);
                    self.__hidePrevMonthArrow = bool;
                }
            }
        });
        Object.defineProperty(self, "_hideNextMonthArrow", {
            get: function() {
                return self.__hideNextMonthArrow;
            },
            set: function(bool) {
                if (self.__hideNextMonthArrow !== bool) {
                    (0, $e9p9b.toggleClass)(self.nextMonthNav, "flatpickr-disabled", bool);
                    self.__hideNextMonthArrow = bool;
                }
            }
        });
        self.currentYearElement = self.yearElements[0];
        updateNavigationCurrentMonth();
        return self.monthNav;
    }
    function buildTime() {
        self.calendarContainer.classList.add("hasTime");
        if (self.config.noCalendar) self.calendarContainer.classList.add("noCalendar");
        var defaults = (0, $8Hr3t.getDefaultHours)(self.config);
        self.timeContainer = (0, $e9p9b.createElement)("div", "flatpickr-time");
        self.timeContainer.tabIndex = -1;
        var separator = (0, $e9p9b.createElement)("span", "flatpickr-time-separator", ":");
        var hourInput = (0, $e9p9b.createNumberInput)("flatpickr-hour", {
            "aria-label": self.l10n.hourAriaLabel
        });
        self.hourElement = hourInput.getElementsByTagName("input")[0];
        var minuteInput = (0, $e9p9b.createNumberInput)("flatpickr-minute", {
            "aria-label": self.l10n.minuteAriaLabel
        });
        self.minuteElement = minuteInput.getElementsByTagName("input")[0];
        self.hourElement.tabIndex = self.minuteElement.tabIndex = -1;
        self.hourElement.value = (0, $l2VaP.pad)(self.latestSelectedDateObj ? self.latestSelectedDateObj.getHours() : self.config.time_24hr ? defaults.hours : military2ampm(defaults.hours));
        self.minuteElement.value = (0, $l2VaP.pad)(self.latestSelectedDateObj ? self.latestSelectedDateObj.getMinutes() : defaults.minutes);
        self.hourElement.setAttribute("step", self.config.hourIncrement.toString());
        self.minuteElement.setAttribute("step", self.config.minuteIncrement.toString());
        self.hourElement.setAttribute("min", self.config.time_24hr ? "0" : "1");
        self.hourElement.setAttribute("max", self.config.time_24hr ? "23" : "12");
        self.hourElement.setAttribute("maxlength", "2");
        self.minuteElement.setAttribute("min", "0");
        self.minuteElement.setAttribute("max", "59");
        self.minuteElement.setAttribute("maxlength", "2");
        self.timeContainer.appendChild(hourInput);
        self.timeContainer.appendChild(separator);
        self.timeContainer.appendChild(minuteInput);
        if (self.config.time_24hr) self.timeContainer.classList.add("time24hr");
        if (self.config.enableSeconds) {
            self.timeContainer.classList.add("hasSeconds");
            var secondInput = (0, $e9p9b.createNumberInput)("flatpickr-second");
            self.secondElement = secondInput.getElementsByTagName("input")[0];
            self.secondElement.value = (0, $l2VaP.pad)(self.latestSelectedDateObj ? self.latestSelectedDateObj.getSeconds() : defaults.seconds);
            self.secondElement.setAttribute("step", self.minuteElement.getAttribute("step"));
            self.secondElement.setAttribute("min", "0");
            self.secondElement.setAttribute("max", "59");
            self.secondElement.setAttribute("maxlength", "2");
            self.timeContainer.appendChild((0, $e9p9b.createElement)("span", "flatpickr-time-separator", ":"));
            self.timeContainer.appendChild(secondInput);
        }
        if (!self.config.time_24hr) {
            self.amPM = (0, $e9p9b.createElement)("span", "flatpickr-am-pm", self.l10n.amPM[(0, $l2VaP.int)((self.latestSelectedDateObj ? self.hourElement.value : self.config.defaultHour) > 11)]);
            self.amPM.title = self.l10n.toggleTitle;
            self.amPM.tabIndex = -1;
            self.timeContainer.appendChild(self.amPM);
        }
        return self.timeContainer;
    }
    function buildWeekdays() {
        if (!self.weekdayContainer) self.weekdayContainer = (0, $e9p9b.createElement)("div", "flatpickr-weekdays");
        else (0, $e9p9b.clearNode)(self.weekdayContainer);
        for(var i = self.config.showMonths; i--;){
            var container = (0, $e9p9b.createElement)("div", "flatpickr-weekdaycontainer");
            self.weekdayContainer.appendChild(container);
        }
        updateWeekdays();
        return self.weekdayContainer;
    }
    function updateWeekdays() {
        if (!self.weekdayContainer) return;
        var firstDayOfWeek = self.l10n.firstDayOfWeek;
        var weekdays = $6c13312359e6c310$var$__spreadArrays(self.l10n.weekdays.shorthand);
        if (firstDayOfWeek > 0 && firstDayOfWeek < weekdays.length) weekdays = $6c13312359e6c310$var$__spreadArrays(weekdays.splice(firstDayOfWeek, weekdays.length), weekdays.splice(0, firstDayOfWeek));
        for(var i = self.config.showMonths; i--;)self.weekdayContainer.children[i].innerHTML = "\n      <span class='flatpickr-weekday'>\n        " + weekdays.join("</span><span class='flatpickr-weekday'>") + "\n      </span>\n      ";
    }
    function buildWeeks() {
        self.calendarContainer.classList.add("hasWeeks");
        var weekWrapper = (0, $e9p9b.createElement)("div", "flatpickr-weekwrapper");
        weekWrapper.appendChild((0, $e9p9b.createElement)("span", "flatpickr-weekday", self.l10n.weekAbbreviation));
        var weekNumbers = (0, $e9p9b.createElement)("div", "flatpickr-weeks");
        weekWrapper.appendChild(weekNumbers);
        return {
            weekWrapper: weekWrapper,
            weekNumbers: weekNumbers
        };
    }
    function changeMonth(value, isOffset) {
        if (isOffset === void 0) isOffset = true;
        var delta = isOffset ? value : value - self.currentMonth;
        if (delta < 0 && self._hidePrevMonthArrow === true || delta > 0 && self._hideNextMonthArrow === true) return;
        self.currentMonth += delta;
        if (self.currentMonth < 0 || self.currentMonth > 11) {
            self.currentYear += self.currentMonth > 11 ? 1 : -1;
            self.currentMonth = (self.currentMonth + 12) % 12;
            triggerEvent("onYearChange");
            buildMonthSwitch();
        }
        buildDays();
        triggerEvent("onMonthChange");
        updateNavigationCurrentMonth();
    }
    function clear(triggerChangeEvent, toInitial) {
        if (triggerChangeEvent === void 0) triggerChangeEvent = true;
        if (toInitial === void 0) toInitial = true;
        self.input.value = "";
        if (self.altInput !== undefined) self.altInput.value = "";
        if (self.mobileInput !== undefined) self.mobileInput.value = "";
        self.selectedDates = [];
        self.latestSelectedDateObj = undefined;
        if (toInitial === true) {
            self.currentYear = self._initialDate.getFullYear();
            self.currentMonth = self._initialDate.getMonth();
        }
        if (self.config.enableTime === true) {
            var _a = (0, $8Hr3t.getDefaultHours)(self.config), hours = _a.hours, minutes = _a.minutes, seconds = _a.seconds;
            setHours(hours, minutes, seconds);
        }
        self.redraw();
        if (triggerChangeEvent) triggerEvent("onChange");
    }
    function close() {
        self.isOpen = false;
        if (!self.isMobile) {
            if (self.calendarContainer !== undefined) self.calendarContainer.classList.remove("open");
            if (self._input !== undefined) self._input.classList.remove("active");
        }
        triggerEvent("onClose");
    }
    function destroy() {
        if (self.config !== undefined) triggerEvent("onDestroy");
        for(var i = self._handlers.length; i--;)self._handlers[i].remove();
        self._handlers = [];
        if (self.mobileInput) {
            if (self.mobileInput.parentNode) self.mobileInput.parentNode.removeChild(self.mobileInput);
            self.mobileInput = undefined;
        } else if (self.calendarContainer && self.calendarContainer.parentNode) {
            if (self.config.static && self.calendarContainer.parentNode) {
                var wrapper = self.calendarContainer.parentNode;
                wrapper.lastChild && wrapper.removeChild(wrapper.lastChild);
                if (wrapper.parentNode) {
                    while(wrapper.firstChild)wrapper.parentNode.insertBefore(wrapper.firstChild, wrapper);
                    wrapper.parentNode.removeChild(wrapper);
                }
            } else self.calendarContainer.parentNode.removeChild(self.calendarContainer);
        }
        if (self.altInput) {
            self.input.type = "text";
            if (self.altInput.parentNode) self.altInput.parentNode.removeChild(self.altInput);
            delete self.altInput;
        }
        if (self.input) {
            self.input.type = self.input._type;
            self.input.classList.remove("flatpickr-input");
            self.input.removeAttribute("readonly");
        }
        [
            "_showTimeInput",
            "latestSelectedDateObj",
            "_hideNextMonthArrow",
            "_hidePrevMonthArrow",
            "__hideNextMonthArrow",
            "__hidePrevMonthArrow",
            "isMobile",
            "isOpen",
            "selectedDateElem",
            "minDateHasTime",
            "maxDateHasTime",
            "days",
            "daysContainer",
            "_input",
            "_positionElement",
            "innerContainer",
            "rContainer",
            "monthNav",
            "todayDateElem",
            "calendarContainer",
            "weekdayContainer",
            "prevMonthNav",
            "nextMonthNav",
            "monthsDropdownContainer",
            "currentMonthElement",
            "currentYearElement",
            "navigationCurrentMonth",
            "selectedDateElem",
            "config"
        ].forEach(function(k) {
            try {
                delete self[k];
            } catch (_) {}
        });
    }
    function isCalendarElem(elem) {
        return self.calendarContainer.contains(elem);
    }
    function documentClick(e) {
        if (self.isOpen && !self.config.inline) {
            var eventTarget_1 = (0, $e9p9b.getEventTarget)(e);
            var isCalendarElement = isCalendarElem(eventTarget_1);
            var isInput = eventTarget_1 === self.input || eventTarget_1 === self.altInput || self.element.contains(eventTarget_1) || e.path && e.path.indexOf && (~e.path.indexOf(self.input) || ~e.path.indexOf(self.altInput));
            var lostFocus = !isInput && !isCalendarElement && !isCalendarElem(e.relatedTarget);
            var isIgnored = !self.config.ignoredFocusElements.some(function(elem) {
                return elem.contains(eventTarget_1);
            });
            if (lostFocus && isIgnored) {
                if (self.config.allowInput) self.setDate(self._input.value, false, self.config.altInput ? self.config.altFormat : self.config.dateFormat);
                if (self.timeContainer !== undefined && self.minuteElement !== undefined && self.hourElement !== undefined && self.input.value !== "" && self.input.value !== undefined) updateTime();
                self.close();
                if (self.config && self.config.mode === "range" && self.selectedDates.length === 1) self.clear(false);
            }
        }
    }
    function changeYear(newYear) {
        if (!newYear || self.config.minDate && newYear < self.config.minDate.getFullYear() || self.config.maxDate && newYear > self.config.maxDate.getFullYear()) return;
        var newYearNum = newYear, isNewYear = self.currentYear !== newYearNum;
        self.currentYear = newYearNum || self.currentYear;
        if (self.config.maxDate && self.currentYear === self.config.maxDate.getFullYear()) self.currentMonth = Math.min(self.config.maxDate.getMonth(), self.currentMonth);
        else if (self.config.minDate && self.currentYear === self.config.minDate.getFullYear()) self.currentMonth = Math.max(self.config.minDate.getMonth(), self.currentMonth);
        if (isNewYear) {
            self.redraw();
            triggerEvent("onYearChange");
            buildMonthSwitch();
        }
    }
    function isEnabled(date, timeless) {
        var _a;
        if (timeless === void 0) timeless = true;
        var dateToCheck = self.parseDate(date, undefined, timeless);
        if (self.config.minDate && dateToCheck && (0, $8Hr3t.compareDates)(dateToCheck, self.config.minDate, timeless !== undefined ? timeless : !self.minDateHasTime) < 0 || self.config.maxDate && dateToCheck && (0, $8Hr3t.compareDates)(dateToCheck, self.config.maxDate, timeless !== undefined ? timeless : !self.maxDateHasTime) > 0) return false;
        if (!self.config.enable && self.config.disable.length === 0) return true;
        if (dateToCheck === undefined) return false;
        var bool = !!self.config.enable, array = (_a = self.config.enable) !== null && _a !== void 0 ? _a : self.config.disable;
        for(var i = 0, d = void 0; i < array.length; i++){
            d = array[i];
            if (typeof d === "function" && d(dateToCheck)) return bool;
            else if (d instanceof Date && dateToCheck !== undefined && d.getTime() === dateToCheck.getTime()) return bool;
            else if (typeof d === "string") {
                var parsed = self.parseDate(d, undefined, true);
                return parsed && parsed.getTime() === dateToCheck.getTime() ? bool : !bool;
            } else if (typeof d === "object" && dateToCheck !== undefined && d.from && d.to && dateToCheck.getTime() >= d.from.getTime() && dateToCheck.getTime() <= d.to.getTime()) return bool;
        }
        return !bool;
    }
    function isInView(elem) {
        if (self.daysContainer !== undefined) return elem.className.indexOf("hidden") === -1 && elem.className.indexOf("flatpickr-disabled") === -1 && self.daysContainer.contains(elem);
        return false;
    }
    function onBlur(e) {
        var isInput = e.target === self._input;
        var valueChanged = self._input.value.trimEnd() !== getDateStr();
        if (isInput && valueChanged && !(e.relatedTarget && isCalendarElem(e.relatedTarget))) self.setDate(self._input.value, true, e.target === self.altInput ? self.config.altFormat : self.config.dateFormat);
    }
    function onKeyDown(e) {
        var eventTarget = (0, $e9p9b.getEventTarget)(e);
        var isInput = self.config.wrap ? element.contains(eventTarget) : eventTarget === self._input;
        var allowInput = self.config.allowInput;
        var allowKeydown = self.isOpen && (!allowInput || !isInput);
        var allowInlineKeydown = self.config.inline && isInput && !allowInput;
        if (e.keyCode === 13 && isInput) {
            if (allowInput) {
                self.setDate(self._input.value, true, eventTarget === self.altInput ? self.config.altFormat : self.config.dateFormat);
                self.close();
                return eventTarget.blur();
            } else self.open();
        } else if (isCalendarElem(eventTarget) || allowKeydown || allowInlineKeydown) {
            var isTimeObj = !!self.timeContainer && self.timeContainer.contains(eventTarget);
            switch(e.keyCode){
                case 13:
                    if (isTimeObj) {
                        e.preventDefault();
                        updateTime();
                        focusAndClose();
                    } else selectDate(e);
                    break;
                case 27:
                    e.preventDefault();
                    focusAndClose();
                    break;
                case 8:
                case 46:
                    if (isInput && !self.config.allowInput) {
                        e.preventDefault();
                        self.clear();
                    }
                    break;
                case 37:
                case 39:
                    if (!isTimeObj && !isInput) {
                        e.preventDefault();
                        var activeElement = getClosestActiveElement();
                        if (self.daysContainer !== undefined && (allowInput === false || activeElement && isInView(activeElement))) {
                            var delta_1 = e.keyCode === 39 ? 1 : -1;
                            if (!e.ctrlKey) focusOnDay(undefined, delta_1);
                            else {
                                e.stopPropagation();
                                changeMonth(delta_1);
                                focusOnDay(getFirstAvailableDay(1), 0);
                            }
                        }
                    } else if (self.hourElement) self.hourElement.focus();
                    break;
                case 38:
                case 40:
                    e.preventDefault();
                    var delta = e.keyCode === 40 ? 1 : -1;
                    if (self.daysContainer && eventTarget.$i !== undefined || eventTarget === self.input || eventTarget === self.altInput) {
                        if (e.ctrlKey) {
                            e.stopPropagation();
                            changeYear(self.currentYear - delta);
                            focusOnDay(getFirstAvailableDay(1), 0);
                        } else if (!isTimeObj) focusOnDay(undefined, delta * 7);
                    } else if (eventTarget === self.currentYearElement) changeYear(self.currentYear - delta);
                    else if (self.config.enableTime) {
                        if (!isTimeObj && self.hourElement) self.hourElement.focus();
                        updateTime(e);
                        self._debouncedChange();
                    }
                    break;
                case 9:
                    if (isTimeObj) {
                        var elems = [
                            self.hourElement,
                            self.minuteElement,
                            self.secondElement,
                            self.amPM
                        ].concat(self.pluginElements).filter(function(x) {
                            return x;
                        });
                        var i = elems.indexOf(eventTarget);
                        if (i !== -1) {
                            var target = elems[i + (e.shiftKey ? -1 : 1)];
                            e.preventDefault();
                            (target || self._input).focus();
                        }
                    } else if (!self.config.noCalendar && self.daysContainer && self.daysContainer.contains(eventTarget) && e.shiftKey) {
                        e.preventDefault();
                        self._input.focus();
                    }
                    break;
                default:
                    break;
            }
        }
        if (self.amPM !== undefined && eventTarget === self.amPM) switch(e.key){
            case self.l10n.amPM[0].charAt(0):
            case self.l10n.amPM[0].charAt(0).toLowerCase():
                self.amPM.textContent = self.l10n.amPM[0];
                setHoursFromInputs();
                updateValue();
                break;
            case self.l10n.amPM[1].charAt(0):
            case self.l10n.amPM[1].charAt(0).toLowerCase():
                self.amPM.textContent = self.l10n.amPM[1];
                setHoursFromInputs();
                updateValue();
                break;
        }
        if (isInput || isCalendarElem(eventTarget)) triggerEvent("onKeyDown", e);
    }
    function onMouseOver(elem, cellClass) {
        if (cellClass === void 0) cellClass = "flatpickr-day";
        if (self.selectedDates.length !== 1 || elem && (!elem.classList.contains(cellClass) || elem.classList.contains("flatpickr-disabled"))) return;
        var hoverDate = elem ? elem.dateObj.getTime() : self.days.firstElementChild.dateObj.getTime(), initialDate = self.parseDate(self.selectedDates[0], undefined, true).getTime(), rangeStartDate = Math.min(hoverDate, self.selectedDates[0].getTime()), rangeEndDate = Math.max(hoverDate, self.selectedDates[0].getTime());
        var containsDisabled = false;
        var minRange = 0, maxRange = 0;
        for(var t = rangeStartDate; t < rangeEndDate; t += (0, $8Hr3t.duration).DAY)if (!isEnabled(new Date(t), true)) {
            containsDisabled = containsDisabled || t > rangeStartDate && t < rangeEndDate;
            if (t < initialDate && (!minRange || t > minRange)) minRange = t;
            else if (t > initialDate && (!maxRange || t < maxRange)) maxRange = t;
        }
        var hoverableCells = Array.from(self.rContainer.querySelectorAll("*:nth-child(-n+" + self.config.showMonths + ") > ." + cellClass));
        hoverableCells.forEach(function(dayElem) {
            var date = dayElem.dateObj;
            var timestamp = date.getTime();
            var outOfRange = minRange > 0 && timestamp < minRange || maxRange > 0 && timestamp > maxRange;
            if (outOfRange) {
                dayElem.classList.add("notAllowed");
                [
                    "inRange",
                    "startRange",
                    "endRange"
                ].forEach(function(c) {
                    dayElem.classList.remove(c);
                });
                return;
            } else if (containsDisabled && !outOfRange) return;
            [
                "startRange",
                "inRange",
                "endRange",
                "notAllowed"
            ].forEach(function(c) {
                dayElem.classList.remove(c);
            });
            if (elem !== undefined) {
                elem.classList.add(hoverDate <= self.selectedDates[0].getTime() ? "startRange" : "endRange");
                if (initialDate < hoverDate && timestamp === initialDate) dayElem.classList.add("startRange");
                else if (initialDate > hoverDate && timestamp === initialDate) dayElem.classList.add("endRange");
                if (timestamp >= minRange && (maxRange === 0 || timestamp <= maxRange) && (0, $8Hr3t.isBetween)(timestamp, initialDate, hoverDate)) dayElem.classList.add("inRange");
            }
        });
    }
    function onResize() {
        if (self.isOpen && !self.config.static && !self.config.inline) positionCalendar();
    }
    function open(e, positionElement) {
        if (positionElement === void 0) positionElement = self._positionElement;
        if (self.isMobile === true) {
            if (e) {
                e.preventDefault();
                var eventTarget = (0, $e9p9b.getEventTarget)(e);
                if (eventTarget) eventTarget.blur();
            }
            if (self.mobileInput !== undefined) {
                self.mobileInput.focus();
                self.mobileInput.click();
            }
            triggerEvent("onOpen");
            return;
        } else if (self._input.disabled || self.config.inline) return;
        var wasOpen = self.isOpen;
        self.isOpen = true;
        if (!wasOpen) {
            self.calendarContainer.classList.add("open");
            self._input.classList.add("active");
            triggerEvent("onOpen");
            positionCalendar(positionElement);
        }
        if (self.config.enableTime === true && self.config.noCalendar === true) {
            if (self.config.allowInput === false && (e === undefined || !self.timeContainer.contains(e.relatedTarget))) setTimeout(function() {
                return self.hourElement.select();
            }, 50);
        }
    }
    function minMaxDateSetter(type) {
        return function(date) {
            var dateObj = self.config["_" + type + "Date"] = self.parseDate(date, self.config.dateFormat);
            var inverseDateObj = self.config["_" + (type === "min" ? "max" : "min") + "Date"];
            if (dateObj !== undefined) self[type === "min" ? "minDateHasTime" : "maxDateHasTime"] = dateObj.getHours() > 0 || dateObj.getMinutes() > 0 || dateObj.getSeconds() > 0;
            if (self.selectedDates) {
                self.selectedDates = self.selectedDates.filter(function(d) {
                    return isEnabled(d);
                });
                if (!self.selectedDates.length && type === "min") setHoursFromDate(dateObj);
                updateValue();
            }
            if (self.daysContainer) {
                redraw();
                if (dateObj !== undefined) self.currentYearElement[type] = dateObj.getFullYear().toString();
                else self.currentYearElement.removeAttribute(type);
                self.currentYearElement.disabled = !!inverseDateObj && dateObj !== undefined && inverseDateObj.getFullYear() === dateObj.getFullYear();
            }
        };
    }
    function parseConfig() {
        var boolOpts = [
            "wrap",
            "weekNumbers",
            "allowInput",
            "allowInvalidPreload",
            "clickOpens",
            "time_24hr",
            "enableTime",
            "noCalendar",
            "altInput",
            "shorthandCurrentMonth",
            "inline",
            "static",
            "enableSeconds",
            "disableMobile"
        ];
        var userConfig = $6c13312359e6c310$var$__assign($6c13312359e6c310$var$__assign({}, JSON.parse(JSON.stringify(element.dataset || {}))), instanceConfig);
        var formats = {};
        self.config.parseDate = userConfig.parseDate;
        self.config.formatDate = userConfig.formatDate;
        Object.defineProperty(self.config, "enable", {
            get: function() {
                return self.config._enable;
            },
            set: function(dates) {
                self.config._enable = parseDateRules(dates);
            }
        });
        Object.defineProperty(self.config, "disable", {
            get: function() {
                return self.config._disable;
            },
            set: function(dates) {
                self.config._disable = parseDateRules(dates);
            }
        });
        var timeMode = userConfig.mode === "time";
        if (!userConfig.dateFormat && (userConfig.enableTime || timeMode)) {
            var defaultDateFormat = $6c13312359e6c310$var$flatpickr.defaultConfig.dateFormat || (0, $kLwj3.defaults).dateFormat;
            formats.dateFormat = userConfig.noCalendar || timeMode ? "H:i" + (userConfig.enableSeconds ? ":S" : "") : defaultDateFormat + " H:i" + (userConfig.enableSeconds ? ":S" : "");
        }
        if (userConfig.altInput && (userConfig.enableTime || timeMode) && !userConfig.altFormat) {
            var defaultAltFormat = $6c13312359e6c310$var$flatpickr.defaultConfig.altFormat || (0, $kLwj3.defaults).altFormat;
            formats.altFormat = userConfig.noCalendar || timeMode ? "h:i" + (userConfig.enableSeconds ? ":S K" : " K") : defaultAltFormat + (" h:i" + (userConfig.enableSeconds ? ":S" : "") + " K");
        }
        Object.defineProperty(self.config, "minDate", {
            get: function() {
                return self.config._minDate;
            },
            set: minMaxDateSetter("min")
        });
        Object.defineProperty(self.config, "maxDate", {
            get: function() {
                return self.config._maxDate;
            },
            set: minMaxDateSetter("max")
        });
        var minMaxTimeSetter = function(type) {
            return function(val) {
                self.config[type === "min" ? "_minTime" : "_maxTime"] = self.parseDate(val, "H:i:S");
            };
        };
        Object.defineProperty(self.config, "minTime", {
            get: function() {
                return self.config._minTime;
            },
            set: minMaxTimeSetter("min")
        });
        Object.defineProperty(self.config, "maxTime", {
            get: function() {
                return self.config._maxTime;
            },
            set: minMaxTimeSetter("max")
        });
        if (userConfig.mode === "time") {
            self.config.noCalendar = true;
            self.config.enableTime = true;
        }
        Object.assign(self.config, formats, userConfig);
        for(var i = 0; i < boolOpts.length; i++)self.config[boolOpts[i]] = self.config[boolOpts[i]] === true || self.config[boolOpts[i]] === "true";
        (0, $kLwj3.HOOKS).filter(function(hook) {
            return self.config[hook] !== undefined;
        }).forEach(function(hook) {
            self.config[hook] = (0, $l2VaP.arrayify)(self.config[hook] || []).map(bindToInstance);
        });
        self.isMobile = !self.config.disableMobile && !self.config.inline && self.config.mode === "single" && !self.config.disable.length && !self.config.enable && !self.config.weekNumbers && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        for(var i = 0; i < self.config.plugins.length; i++){
            var pluginConf = self.config.plugins[i](self) || {};
            for(var key in pluginConf){
                if ((0, $kLwj3.HOOKS).indexOf(key) > -1) self.config[key] = (0, $l2VaP.arrayify)(pluginConf[key]).map(bindToInstance).concat(self.config[key]);
                else if (typeof userConfig[key] === "undefined") self.config[key] = pluginConf[key];
            }
        }
        if (!userConfig.altInputClass) self.config.altInputClass = getInputElem().className + " " + self.config.altInputClass;
        triggerEvent("onParseConfig");
    }
    function getInputElem() {
        return self.config.wrap ? element.querySelector("[data-input]") : element;
    }
    function setupLocale() {
        if (typeof self.config.locale !== "object" && typeof $6c13312359e6c310$var$flatpickr.l10ns[self.config.locale] === "undefined") self.config.errorHandler(new Error("flatpickr: invalid locale " + self.config.locale));
        self.l10n = $6c13312359e6c310$var$__assign($6c13312359e6c310$var$__assign({}, $6c13312359e6c310$var$flatpickr.l10ns.default), typeof self.config.locale === "object" ? self.config.locale : self.config.locale !== "default" ? $6c13312359e6c310$var$flatpickr.l10ns[self.config.locale] : undefined);
        (0, $f5y5D.tokenRegex).D = "(" + self.l10n.weekdays.shorthand.join("|") + ")";
        (0, $f5y5D.tokenRegex).l = "(" + self.l10n.weekdays.longhand.join("|") + ")";
        (0, $f5y5D.tokenRegex).M = "(" + self.l10n.months.shorthand.join("|") + ")";
        (0, $f5y5D.tokenRegex).F = "(" + self.l10n.months.longhand.join("|") + ")";
        (0, $f5y5D.tokenRegex).K = "(" + self.l10n.amPM[0] + "|" + self.l10n.amPM[1] + "|" + self.l10n.amPM[0].toLowerCase() + "|" + self.l10n.amPM[1].toLowerCase() + ")";
        var userConfig = $6c13312359e6c310$var$__assign($6c13312359e6c310$var$__assign({}, instanceConfig), JSON.parse(JSON.stringify(element.dataset || {})));
        if (userConfig.time_24hr === undefined && $6c13312359e6c310$var$flatpickr.defaultConfig.time_24hr === undefined) self.config.time_24hr = self.l10n.time_24hr;
        self.formatDate = (0, $8Hr3t.createDateFormatter)(self);
        self.parseDate = (0, $8Hr3t.createDateParser)({
            config: self.config,
            l10n: self.l10n
        });
    }
    function positionCalendar(customPositionElement) {
        if (typeof self.config.position === "function") return void self.config.position(self, customPositionElement);
        if (self.calendarContainer === undefined) return;
        triggerEvent("onPreCalendarPosition");
        var positionElement = customPositionElement || self._positionElement;
        var calendarHeight = Array.prototype.reduce.call(self.calendarContainer.children, function(acc, child) {
            return acc + child.offsetHeight;
        }, 0), calendarWidth = self.calendarContainer.offsetWidth, configPos = self.config.position.split(" "), configPosVertical = configPos[0], configPosHorizontal = configPos.length > 1 ? configPos[1] : null, inputBounds = positionElement.getBoundingClientRect(), distanceFromBottom = window.innerHeight - inputBounds.bottom, showOnTop = configPosVertical === "above" || configPosVertical !== "below" && distanceFromBottom < calendarHeight && inputBounds.top > calendarHeight;
        var top = window.pageYOffset + inputBounds.top + (!showOnTop ? positionElement.offsetHeight + 2 : -calendarHeight - 2);
        (0, $e9p9b.toggleClass)(self.calendarContainer, "arrowTop", !showOnTop);
        (0, $e9p9b.toggleClass)(self.calendarContainer, "arrowBottom", showOnTop);
        if (self.config.inline) return;
        var left = window.pageXOffset + inputBounds.left;
        var isCenter = false;
        var isRight = false;
        if (configPosHorizontal === "center") {
            left -= (calendarWidth - inputBounds.width) / 2;
            isCenter = true;
        } else if (configPosHorizontal === "right") {
            left -= calendarWidth - inputBounds.width;
            isRight = true;
        }
        (0, $e9p9b.toggleClass)(self.calendarContainer, "arrowLeft", !isCenter && !isRight);
        (0, $e9p9b.toggleClass)(self.calendarContainer, "arrowCenter", isCenter);
        (0, $e9p9b.toggleClass)(self.calendarContainer, "arrowRight", isRight);
        var right = window.document.body.offsetWidth - (window.pageXOffset + inputBounds.right);
        var rightMost = left + calendarWidth > window.document.body.offsetWidth;
        var centerMost = right + calendarWidth > window.document.body.offsetWidth;
        (0, $e9p9b.toggleClass)(self.calendarContainer, "rightMost", rightMost);
        if (self.config.static) return;
        self.calendarContainer.style.top = top + "px";
        if (!rightMost) {
            self.calendarContainer.style.left = left + "px";
            self.calendarContainer.style.right = "auto";
        } else if (!centerMost) {
            self.calendarContainer.style.left = "auto";
            self.calendarContainer.style.right = right + "px";
        } else {
            var doc = getDocumentStyleSheet();
            if (doc === undefined) return;
            var bodyWidth = window.document.body.offsetWidth;
            var centerLeft = Math.max(0, bodyWidth / 2 - calendarWidth / 2);
            var centerBefore = ".flatpickr-calendar.centerMost:before";
            var centerAfter = ".flatpickr-calendar.centerMost:after";
            var centerIndex = doc.cssRules.length;
            var centerStyle = "{left:" + inputBounds.left + "px;right:auto;}";
            (0, $e9p9b.toggleClass)(self.calendarContainer, "rightMost", false);
            (0, $e9p9b.toggleClass)(self.calendarContainer, "centerMost", true);
            doc.insertRule(centerBefore + "," + centerAfter + centerStyle, centerIndex);
            self.calendarContainer.style.left = centerLeft + "px";
            self.calendarContainer.style.right = "auto";
        }
    }
    function getDocumentStyleSheet() {
        var editableSheet = null;
        for(var i = 0; i < document.styleSheets.length; i++){
            var sheet = document.styleSheets[i];
            if (!sheet.cssRules) continue;
            try {
                sheet.cssRules;
            } catch (err) {
                continue;
            }
            editableSheet = sheet;
            break;
        }
        return editableSheet != null ? editableSheet : createStyleSheet();
    }
    function createStyleSheet() {
        var style = document.createElement("style");
        document.head.appendChild(style);
        return style.sheet;
    }
    function redraw() {
        if (self.config.noCalendar || self.isMobile) return;
        buildMonthSwitch();
        updateNavigationCurrentMonth();
        buildDays();
    }
    function focusAndClose() {
        self._input.focus();
        if (window.navigator.userAgent.indexOf("MSIE") !== -1 || navigator.msMaxTouchPoints !== undefined) setTimeout(self.close, 0);
        else self.close();
    }
    function selectDate(e) {
        e.preventDefault();
        e.stopPropagation();
        var isSelectable = function(day) {
            return day.classList && day.classList.contains("flatpickr-day") && !day.classList.contains("flatpickr-disabled") && !day.classList.contains("notAllowed");
        };
        var t = (0, $e9p9b.findParent)((0, $e9p9b.getEventTarget)(e), isSelectable);
        if (t === undefined) return;
        var target = t;
        var selectedDate = self.latestSelectedDateObj = new Date(target.dateObj.getTime());
        var shouldChangeMonth = (selectedDate.getMonth() < self.currentMonth || selectedDate.getMonth() > self.currentMonth + self.config.showMonths - 1) && self.config.mode !== "range";
        self.selectedDateElem = target;
        if (self.config.mode === "single") self.selectedDates = [
            selectedDate
        ];
        else if (self.config.mode === "multiple") {
            var selectedIndex = isDateSelected(selectedDate);
            if (selectedIndex) self.selectedDates.splice(parseInt(selectedIndex), 1);
            else self.selectedDates.push(selectedDate);
        } else if (self.config.mode === "range") {
            if (self.selectedDates.length === 2) self.clear(false, false);
            self.latestSelectedDateObj = selectedDate;
            self.selectedDates.push(selectedDate);
            if ((0, $8Hr3t.compareDates)(selectedDate, self.selectedDates[0], true) !== 0) self.selectedDates.sort(function(a, b) {
                return a.getTime() - b.getTime();
            });
        }
        setHoursFromInputs();
        if (shouldChangeMonth) {
            var isNewYear = self.currentYear !== selectedDate.getFullYear();
            self.currentYear = selectedDate.getFullYear();
            self.currentMonth = selectedDate.getMonth();
            if (isNewYear) {
                triggerEvent("onYearChange");
                buildMonthSwitch();
            }
            triggerEvent("onMonthChange");
        }
        updateNavigationCurrentMonth();
        buildDays();
        updateValue();
        if (!shouldChangeMonth && self.config.mode !== "range" && self.config.showMonths === 1) focusOnDayElem(target);
        else if (self.selectedDateElem !== undefined && self.hourElement === undefined) self.selectedDateElem && self.selectedDateElem.focus();
        if (self.hourElement !== undefined) self.hourElement !== undefined && self.hourElement.focus();
        if (self.config.closeOnSelect) {
            var single = self.config.mode === "single" && !self.config.enableTime;
            var range = self.config.mode === "range" && self.selectedDates.length === 2 && !self.config.enableTime;
            if (single || range) focusAndClose();
        }
        triggerChange();
    }
    var CALLBACKS = {
        locale: [
            setupLocale,
            updateWeekdays
        ],
        showMonths: [
            buildMonths,
            setCalendarWidth,
            buildWeekdays
        ],
        minDate: [
            jumpToDate
        ],
        maxDate: [
            jumpToDate
        ],
        positionElement: [
            updatePositionElement
        ],
        clickOpens: [
            function() {
                if (self.config.clickOpens === true) {
                    bind(self._input, "focus", self.open);
                    bind(self._input, "click", self.open);
                } else {
                    self._input.removeEventListener("focus", self.open);
                    self._input.removeEventListener("click", self.open);
                }
            }
        ]
    };
    function set(option, value) {
        if (option !== null && typeof option === "object") {
            Object.assign(self.config, option);
            for(var key in option)if (CALLBACKS[key] !== undefined) CALLBACKS[key].forEach(function(x) {
                return x();
            });
        } else {
            self.config[option] = value;
            if (CALLBACKS[option] !== undefined) CALLBACKS[option].forEach(function(x) {
                return x();
            });
            else if ((0, $kLwj3.HOOKS).indexOf(option) > -1) self.config[option] = (0, $l2VaP.arrayify)(value);
        }
        self.redraw();
        updateValue(true);
    }
    function setSelectedDate(inputDate, format) {
        var dates = [];
        if (inputDate instanceof Array) dates = inputDate.map(function(d) {
            return self.parseDate(d, format);
        });
        else if (inputDate instanceof Date || typeof inputDate === "number") dates = [
            self.parseDate(inputDate, format)
        ];
        else if (typeof inputDate === "string") switch(self.config.mode){
            case "single":
            case "time":
                dates = [
                    self.parseDate(inputDate, format)
                ];
                break;
            case "multiple":
                dates = inputDate.split(self.config.conjunction).map(function(date) {
                    return self.parseDate(date, format);
                });
                break;
            case "range":
                dates = inputDate.split(self.l10n.rangeSeparator).map(function(date) {
                    return self.parseDate(date, format);
                });
                break;
            default:
                break;
        }
        else self.config.errorHandler(new Error("Invalid date supplied: " + JSON.stringify(inputDate)));
        self.selectedDates = self.config.allowInvalidPreload ? dates : dates.filter(function(d) {
            return d instanceof Date && isEnabled(d, false);
        });
        if (self.config.mode === "range") self.selectedDates.sort(function(a, b) {
            return a.getTime() - b.getTime();
        });
    }
    function setDate(date, triggerChange, format) {
        if (triggerChange === void 0) triggerChange = false;
        if (format === void 0) format = self.config.dateFormat;
        if (date !== 0 && !date || date instanceof Array && date.length === 0) return self.clear(triggerChange);
        setSelectedDate(date, format);
        self.latestSelectedDateObj = self.selectedDates[self.selectedDates.length - 1];
        self.redraw();
        jumpToDate(undefined, triggerChange);
        setHoursFromDate();
        if (self.selectedDates.length === 0) self.clear(false);
        updateValue(triggerChange);
        if (triggerChange) triggerEvent("onChange");
    }
    function parseDateRules(arr) {
        return arr.slice().map(function(rule) {
            if (typeof rule === "string" || typeof rule === "number" || rule instanceof Date) return self.parseDate(rule, undefined, true);
            else if (rule && typeof rule === "object" && rule.from && rule.to) return {
                from: self.parseDate(rule.from, undefined),
                to: self.parseDate(rule.to, undefined)
            };
            return rule;
        }).filter(function(x) {
            return x;
        });
    }
    function setupDates() {
        self.selectedDates = [];
        self.now = self.parseDate(self.config.now) || new Date();
        var preloadedDate = self.config.defaultDate || ((self.input.nodeName === "INPUT" || self.input.nodeName === "TEXTAREA") && self.input.placeholder && self.input.value === self.input.placeholder ? null : self.input.value);
        if (preloadedDate) setSelectedDate(preloadedDate, self.config.dateFormat);
        self._initialDate = self.selectedDates.length > 0 ? self.selectedDates[0] : self.config.minDate && self.config.minDate.getTime() > self.now.getTime() ? self.config.minDate : self.config.maxDate && self.config.maxDate.getTime() < self.now.getTime() ? self.config.maxDate : self.now;
        self.currentYear = self._initialDate.getFullYear();
        self.currentMonth = self._initialDate.getMonth();
        if (self.selectedDates.length > 0) self.latestSelectedDateObj = self.selectedDates[0];
        if (self.config.minTime !== undefined) self.config.minTime = self.parseDate(self.config.minTime, "H:i");
        if (self.config.maxTime !== undefined) self.config.maxTime = self.parseDate(self.config.maxTime, "H:i");
        self.minDateHasTime = !!self.config.minDate && (self.config.minDate.getHours() > 0 || self.config.minDate.getMinutes() > 0 || self.config.minDate.getSeconds() > 0);
        self.maxDateHasTime = !!self.config.maxDate && (self.config.maxDate.getHours() > 0 || self.config.maxDate.getMinutes() > 0 || self.config.maxDate.getSeconds() > 0);
    }
    function setupInputs() {
        self.input = getInputElem();
        if (!self.input) {
            self.config.errorHandler(new Error("Invalid input element specified"));
            return;
        }
        self.input._type = self.input.type;
        self.input.type = "text";
        self.input.classList.add("flatpickr-input");
        self._input = self.input;
        if (self.config.altInput) {
            self.altInput = (0, $e9p9b.createElement)(self.input.nodeName, self.config.altInputClass);
            self._input = self.altInput;
            self.altInput.placeholder = self.input.placeholder;
            self.altInput.disabled = self.input.disabled;
            self.altInput.required = self.input.required;
            self.altInput.tabIndex = self.input.tabIndex;
            self.altInput.type = "text";
            self.input.setAttribute("type", "hidden");
            if (!self.config.static && self.input.parentNode) self.input.parentNode.insertBefore(self.altInput, self.input.nextSibling);
        }
        if (!self.config.allowInput) self._input.setAttribute("readonly", "readonly");
        updatePositionElement();
    }
    function updatePositionElement() {
        self._positionElement = self.config.positionElement || self._input;
    }
    function setupMobile() {
        var inputType = self.config.enableTime ? self.config.noCalendar ? "time" : "datetime-local" : "date";
        self.mobileInput = (0, $e9p9b.createElement)("input", self.input.className + " flatpickr-mobile");
        self.mobileInput.tabIndex = 1;
        self.mobileInput.type = inputType;
        self.mobileInput.disabled = self.input.disabled;
        self.mobileInput.required = self.input.required;
        self.mobileInput.placeholder = self.input.placeholder;
        self.mobileFormatStr = inputType === "datetime-local" ? "Y-m-d\\TH:i:S" : inputType === "date" ? "Y-m-d" : "H:i:S";
        if (self.selectedDates.length > 0) self.mobileInput.defaultValue = self.mobileInput.value = self.formatDate(self.selectedDates[0], self.mobileFormatStr);
        if (self.config.minDate) self.mobileInput.min = self.formatDate(self.config.minDate, "Y-m-d");
        if (self.config.maxDate) self.mobileInput.max = self.formatDate(self.config.maxDate, "Y-m-d");
        if (self.input.getAttribute("step")) self.mobileInput.step = String(self.input.getAttribute("step"));
        self.input.type = "hidden";
        if (self.altInput !== undefined) self.altInput.type = "hidden";
        try {
            if (self.input.parentNode) self.input.parentNode.insertBefore(self.mobileInput, self.input.nextSibling);
        } catch (_a) {}
        bind(self.mobileInput, "change", function(e) {
            self.setDate((0, $e9p9b.getEventTarget)(e).value, false, self.mobileFormatStr);
            triggerEvent("onChange");
            triggerEvent("onClose");
        });
    }
    function toggle(e) {
        if (self.isOpen === true) return self.close();
        self.open(e);
    }
    function triggerEvent(event, data) {
        if (self.config === undefined) return;
        var hooks = self.config[event];
        if (hooks !== undefined && hooks.length > 0) for(var i = 0; hooks[i] && i < hooks.length; i++)hooks[i](self.selectedDates, self.input.value, self, data);
        if (event === "onChange") {
            self.input.dispatchEvent(createEvent("change"));
            self.input.dispatchEvent(createEvent("input"));
        }
    }
    function createEvent(name) {
        var e = document.createEvent("Event");
        e.initEvent(name, true, true);
        return e;
    }
    function isDateSelected(date) {
        for(var i = 0; i < self.selectedDates.length; i++){
            var selectedDate = self.selectedDates[i];
            if (selectedDate instanceof Date && (0, $8Hr3t.compareDates)(selectedDate, date) === 0) return "" + i;
        }
        return false;
    }
    function isDateInRange(date) {
        if (self.config.mode !== "range" || self.selectedDates.length < 2) return false;
        return (0, $8Hr3t.compareDates)(date, self.selectedDates[0]) >= 0 && (0, $8Hr3t.compareDates)(date, self.selectedDates[1]) <= 0;
    }
    function updateNavigationCurrentMonth() {
        if (self.config.noCalendar || self.isMobile || !self.monthNav) return;
        self.yearElements.forEach(function(yearElement, i) {
            var d = new Date(self.currentYear, self.currentMonth, 1);
            d.setMonth(self.currentMonth + i);
            if (self.config.showMonths > 1 || self.config.monthSelectorType === "static") self.monthElements[i].textContent = (0, $f5y5D.monthToStr)(d.getMonth(), self.config.shorthandCurrentMonth, self.l10n) + " ";
            else self.monthsDropdownContainer.value = d.getMonth().toString();
            yearElement.value = d.getFullYear().toString();
        });
        self._hidePrevMonthArrow = self.config.minDate !== undefined && (self.currentYear === self.config.minDate.getFullYear() ? self.currentMonth <= self.config.minDate.getMonth() : self.currentYear < self.config.minDate.getFullYear());
        self._hideNextMonthArrow = self.config.maxDate !== undefined && (self.currentYear === self.config.maxDate.getFullYear() ? self.currentMonth + 1 > self.config.maxDate.getMonth() : self.currentYear > self.config.maxDate.getFullYear());
    }
    function getDateStr(specificFormat) {
        var format = specificFormat || (self.config.altInput ? self.config.altFormat : self.config.dateFormat);
        return self.selectedDates.map(function(dObj) {
            return self.formatDate(dObj, format);
        }).filter(function(d, i, arr) {
            return self.config.mode !== "range" || self.config.enableTime || arr.indexOf(d) === i;
        }).join(self.config.mode !== "range" ? self.config.conjunction : self.l10n.rangeSeparator);
    }
    function updateValue(triggerChange) {
        if (triggerChange === void 0) triggerChange = true;
        if (self.mobileInput !== undefined && self.mobileFormatStr) self.mobileInput.value = self.latestSelectedDateObj !== undefined ? self.formatDate(self.latestSelectedDateObj, self.mobileFormatStr) : "";
        self.input.value = getDateStr(self.config.dateFormat);
        if (self.altInput !== undefined) self.altInput.value = getDateStr(self.config.altFormat);
        if (triggerChange !== false) triggerEvent("onValueUpdate");
    }
    function onMonthNavClick(e) {
        var eventTarget = (0, $e9p9b.getEventTarget)(e);
        var isPrevMonth = self.prevMonthNav.contains(eventTarget);
        var isNextMonth = self.nextMonthNav.contains(eventTarget);
        if (isPrevMonth || isNextMonth) changeMonth(isPrevMonth ? -1 : 1);
        else if (self.yearElements.indexOf(eventTarget) >= 0) eventTarget.select();
        else if (eventTarget.classList.contains("arrowUp")) self.changeYear(self.currentYear + 1);
        else if (eventTarget.classList.contains("arrowDown")) self.changeYear(self.currentYear - 1);
    }
    function timeWrapper(e) {
        e.preventDefault();
        var isKeyDown = e.type === "keydown", eventTarget = (0, $e9p9b.getEventTarget)(e), input = eventTarget;
        if (self.amPM !== undefined && eventTarget === self.amPM) self.amPM.textContent = self.l10n.amPM[(0, $l2VaP.int)(self.amPM.textContent === self.l10n.amPM[0])];
        var min = parseFloat(input.getAttribute("min")), max = parseFloat(input.getAttribute("max")), step = parseFloat(input.getAttribute("step")), curValue = parseInt(input.value, 10), delta = e.delta || (isKeyDown ? e.which === 38 ? 1 : -1 : 0);
        var newValue = curValue + step * delta;
        if (typeof input.value !== "undefined" && input.value.length === 2) {
            var isHourElem = input === self.hourElement, isMinuteElem = input === self.minuteElement;
            if (newValue < min) {
                newValue = max + newValue + (0, $l2VaP.int)(!isHourElem) + ((0, $l2VaP.int)(isHourElem) && (0, $l2VaP.int)(!self.amPM));
                if (isMinuteElem) incrementNumInput(undefined, -1, self.hourElement);
            } else if (newValue > max) {
                newValue = input === self.hourElement ? newValue - max - (0, $l2VaP.int)(!self.amPM) : min;
                if (isMinuteElem) incrementNumInput(undefined, 1, self.hourElement);
            }
            if (self.amPM && isHourElem && (step === 1 ? newValue + curValue === 23 : Math.abs(newValue - curValue) > step)) self.amPM.textContent = self.l10n.amPM[(0, $l2VaP.int)(self.amPM.textContent === self.l10n.amPM[0])];
            input.value = (0, $l2VaP.pad)(newValue);
        }
    }
    init();
    return self;
}
function $6c13312359e6c310$var$_flatpickr(nodeList, config) {
    var nodes = Array.prototype.slice.call(nodeList).filter(function(x) {
        return x instanceof HTMLElement;
    });
    var instances = [];
    for(var i = 0; i < nodes.length; i++){
        var node = nodes[i];
        try {
            if (node.getAttribute("data-fp-omit") !== null) continue;
            if (node._flatpickr !== undefined) {
                node._flatpickr.destroy();
                node._flatpickr = undefined;
            }
            node._flatpickr = $6c13312359e6c310$var$FlatpickrInstance(node, config || {});
            instances.push(node._flatpickr);
        } catch (e) {
            console.error(e);
        }
    }
    return instances.length === 1 ? instances[0] : instances;
}
if (typeof HTMLElement !== "undefined" && typeof HTMLCollection !== "undefined" && typeof NodeList !== "undefined") {
    HTMLCollection.prototype.flatpickr = NodeList.prototype.flatpickr = function(config) {
        return $6c13312359e6c310$var$_flatpickr(this, config);
    };
    HTMLElement.prototype.flatpickr = function(config) {
        return $6c13312359e6c310$var$_flatpickr([
            this
        ], config);
    };
}
var $6c13312359e6c310$var$flatpickr = function(selector, config) {
    if (typeof selector === "string") return $6c13312359e6c310$var$_flatpickr(window.document.querySelectorAll(selector), config);
    else if (selector instanceof Node) return $6c13312359e6c310$var$_flatpickr([
        selector
    ], config);
    else return $6c13312359e6c310$var$_flatpickr(selector, config);
};
$6c13312359e6c310$var$flatpickr.defaultConfig = {};
$6c13312359e6c310$var$flatpickr.l10ns = {
    en: $6c13312359e6c310$var$__assign({}, (0, $3Iynq.default)),
    default: $6c13312359e6c310$var$__assign({}, (0, $3Iynq.default))
};
$6c13312359e6c310$var$flatpickr.localize = function(l10n) {
    $6c13312359e6c310$var$flatpickr.l10ns.default = $6c13312359e6c310$var$__assign($6c13312359e6c310$var$__assign({}, $6c13312359e6c310$var$flatpickr.l10ns.default), l10n);
};
$6c13312359e6c310$var$flatpickr.setDefaults = function(config) {
    $6c13312359e6c310$var$flatpickr.defaultConfig = $6c13312359e6c310$var$__assign($6c13312359e6c310$var$__assign({}, $6c13312359e6c310$var$flatpickr.defaultConfig), config);
};
$6c13312359e6c310$var$flatpickr.parseDate = (0, $8Hr3t.createDateParser)({});
$6c13312359e6c310$var$flatpickr.formatDate = (0, $8Hr3t.createDateFormatter)({});
$6c13312359e6c310$var$flatpickr.compareDates = (0, $8Hr3t.compareDates);
if (typeof jQuery !== "undefined" && typeof jQuery.fn !== "undefined") jQuery.fn.flatpickr = function(config) {
    return $6c13312359e6c310$var$_flatpickr(this, config);
};
Date.prototype.fp_incr = function(days) {
    return new Date(this.getFullYear(), this.getMonth(), this.getDate() + (typeof days === "string" ? parseInt(days, 10) : days));
};
if (typeof window !== "undefined") window.flatpickr = $6c13312359e6c310$var$flatpickr;
var $6c13312359e6c310$export$2e2bcd8739ae039 = $6c13312359e6c310$var$flatpickr;

});
parcelRegister("kLwj3", function(module, exports) {

$parcel$export(module.exports, "HOOKS", () => $f1e141ce95743921$export$c34bb18505e1e253);
$parcel$export(module.exports, "defaults", () => $f1e141ce95743921$export$ebe90cb607ad99e);
var $f1e141ce95743921$export$c34bb18505e1e253 = [
    "onChange",
    "onClose",
    "onDayCreate",
    "onDestroy",
    "onKeyDown",
    "onMonthChange",
    "onOpen",
    "onParseConfig",
    "onReady",
    "onValueUpdate",
    "onYearChange",
    "onPreCalendarPosition"
];
var $f1e141ce95743921$export$ebe90cb607ad99e = {
    _disable: [],
    allowInput: false,
    allowInvalidPreload: false,
    altFormat: "F j, Y",
    altInput: false,
    altInputClass: "form-control input",
    animate: typeof window === "object" && window.navigator.userAgent.indexOf("MSIE") === -1,
    ariaDateFormat: "F j, Y",
    autoFillDefaultTime: true,
    clickOpens: true,
    closeOnSelect: true,
    conjunction: ", ",
    dateFormat: "Y-m-d",
    defaultHour: 12,
    defaultMinute: 0,
    defaultSeconds: 0,
    disable: [],
    disableMobile: false,
    enableSeconds: false,
    enableTime: false,
    errorHandler: function(err) {
        return typeof console !== "undefined" && console.warn(err);
    },
    getWeek: function(givenDate) {
        var date = new Date(givenDate.getTime());
        date.setHours(0, 0, 0, 0);
        date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
        var week1 = new Date(date.getFullYear(), 0, 4);
        return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7);
    },
    hourIncrement: 1,
    ignoredFocusElements: [],
    inline: false,
    locale: "default",
    minuteIncrement: 5,
    mode: "single",
    monthSelectorType: "dropdown",
    nextArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M13.207 8.472l-7.854 7.854-0.707-0.707 7.146-7.146-7.146-7.148 0.707-0.707 7.854 7.854z' /></svg>",
    noCalendar: false,
    now: new Date(),
    onChange: [],
    onClose: [],
    onDayCreate: [],
    onDestroy: [],
    onKeyDown: [],
    onMonthChange: [],
    onOpen: [],
    onParseConfig: [],
    onReady: [],
    onValueUpdate: [],
    onYearChange: [],
    onPreCalendarPosition: [],
    plugins: [],
    position: "auto",
    positionElement: undefined,
    prevArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M5.207 8.471l7.146 7.147-0.707 0.707-7.853-7.854 7.854-7.853 0.707 0.707-7.147 7.146z' /></svg>",
    shorthandCurrentMonth: false,
    showMonths: 1,
    static: false,
    time_24hr: false,
    weekNumbers: false,
    wrap: false
};

});

parcelRegister("3Iynq", function(module, exports) {

$parcel$export(module.exports, "english", () => $2b5025ac4080408d$export$33e6c23ebe2ee669);
$parcel$export(module.exports, "default", () => $2b5025ac4080408d$export$2e2bcd8739ae039);
var $2b5025ac4080408d$export$33e6c23ebe2ee669 = {
    weekdays: {
        shorthand: [
            "Sun",
            "Mon",
            "Tue",
            "Wed",
            "Thu",
            "Fri",
            "Sat"
        ],
        longhand: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday"
        ]
    },
    months: {
        shorthand: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
        ],
        longhand: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ]
    },
    daysInMonth: [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ],
    firstDayOfWeek: 0,
    ordinal: function(nth) {
        var s = nth % 100;
        if (s > 3 && s < 21) return "th";
        switch(s % 10){
            case 1:
                return "st";
            case 2:
                return "nd";
            case 3:
                return "rd";
            default:
                return "th";
        }
    },
    rangeSeparator: " to ",
    weekAbbreviation: "Wk",
    scrollTitle: "Scroll to increment",
    toggleTitle: "Click to toggle",
    amPM: [
        "AM",
        "PM"
    ],
    yearAriaLabel: "Year",
    monthAriaLabel: "Month",
    hourAriaLabel: "Hour",
    minuteAriaLabel: "Minute",
    time_24hr: false
};
var $2b5025ac4080408d$export$2e2bcd8739ae039 = $2b5025ac4080408d$export$33e6c23ebe2ee669;

});

parcelRegister("l2VaP", function(module, exports) {

$parcel$export(module.exports, "pad", () => $f52622624cefdc2d$export$5d04458e2a6c373e);
$parcel$export(module.exports, "int", () => $f52622624cefdc2d$export$7d260a2a5f8bc19e);
$parcel$export(module.exports, "debounce", () => $f52622624cefdc2d$export$61fc7d43ac8f84b0);
$parcel$export(module.exports, "arrayify", () => $f52622624cefdc2d$export$3131421a7d01b4fb);
var $f52622624cefdc2d$export$5d04458e2a6c373e = function(number, length) {
    if (length === void 0) length = 2;
    return ("000" + number).slice(length * -1);
};
var $f52622624cefdc2d$export$7d260a2a5f8bc19e = function(bool) {
    return bool === true ? 1 : 0;
};
function $f52622624cefdc2d$export$61fc7d43ac8f84b0(fn, wait) {
    var t;
    return function() {
        var _this = this;
        var args = arguments;
        clearTimeout(t);
        t = setTimeout(function() {
            return fn.apply(_this, args);
        }, wait);
    };
}
var $f52622624cefdc2d$export$3131421a7d01b4fb = function(obj) {
    return obj instanceof Array ? obj : [
        obj
    ];
};

});

parcelRegister("e9p9b", function(module, exports) {

$parcel$export(module.exports, "toggleClass", () => $a4d569a73dfb7c42$export$4a80062ca50b57c7);
$parcel$export(module.exports, "createElement", () => $a4d569a73dfb7c42$export$c8a8987d4410bf2d);
$parcel$export(module.exports, "clearNode", () => $a4d569a73dfb7c42$export$51cfe97d637c237c);
$parcel$export(module.exports, "findParent", () => $a4d569a73dfb7c42$export$25245567f53f158f);
$parcel$export(module.exports, "createNumberInput", () => $a4d569a73dfb7c42$export$afe9d610a3284048);
$parcel$export(module.exports, "getEventTarget", () => $a4d569a73dfb7c42$export$e58f029f0fbfdb29);
function $a4d569a73dfb7c42$export$4a80062ca50b57c7(elem, className, bool) {
    if (bool === true) return elem.classList.add(className);
    elem.classList.remove(className);
}
function $a4d569a73dfb7c42$export$c8a8987d4410bf2d(tag, className, content) {
    var e = window.document.createElement(tag);
    className = className || "";
    content = content || "";
    e.className = className;
    if (content !== undefined) e.textContent = content;
    return e;
}
function $a4d569a73dfb7c42$export$51cfe97d637c237c(node) {
    while(node.firstChild)node.removeChild(node.firstChild);
}
function $a4d569a73dfb7c42$export$25245567f53f158f(node, condition) {
    if (condition(node)) return node;
    else if (node.parentNode) return $a4d569a73dfb7c42$export$25245567f53f158f(node.parentNode, condition);
    return undefined;
}
function $a4d569a73dfb7c42$export$afe9d610a3284048(inputClassName, opts) {
    var wrapper = $a4d569a73dfb7c42$export$c8a8987d4410bf2d("div", "numInputWrapper"), numInput = $a4d569a73dfb7c42$export$c8a8987d4410bf2d("input", "numInput " + inputClassName), arrowUp = $a4d569a73dfb7c42$export$c8a8987d4410bf2d("span", "arrowUp"), arrowDown = $a4d569a73dfb7c42$export$c8a8987d4410bf2d("span", "arrowDown");
    if (navigator.userAgent.indexOf("MSIE 9.0") === -1) numInput.type = "number";
    else {
        numInput.type = "text";
        numInput.pattern = "\\d*";
    }
    if (opts !== undefined) for(var key in opts)numInput.setAttribute(key, opts[key]);
    wrapper.appendChild(numInput);
    wrapper.appendChild(arrowUp);
    wrapper.appendChild(arrowDown);
    return wrapper;
}
function $a4d569a73dfb7c42$export$e58f029f0fbfdb29(event) {
    try {
        if (typeof event.composedPath === "function") {
            var path = event.composedPath();
            return path[0];
        }
        return event.target;
    } catch (error) {
        return event.target;
    }
}

});

parcelRegister("8Hr3t", function(module, exports) {

$parcel$export(module.exports, "createDateFormatter", () => $65575378d8a96024$export$ff1a0b75284ac636);
$parcel$export(module.exports, "createDateParser", () => $65575378d8a96024$export$cfa2ef2687faeda2);
$parcel$export(module.exports, "compareDates", () => $65575378d8a96024$export$c4c806e061935577);
$parcel$export(module.exports, "isBetween", () => $65575378d8a96024$export$a4d69fb5f2026c35);
$parcel$export(module.exports, "calculateSecondsSinceMidnight", () => $65575378d8a96024$export$9fafc166baa96839);
$parcel$export(module.exports, "parseSeconds", () => $65575378d8a96024$export$a4ce0def660bfe9e);
$parcel$export(module.exports, "duration", () => $65575378d8a96024$export$1f34108aa9eb96ab);
$parcel$export(module.exports, "getDefaultHours", () => $65575378d8a96024$export$6df0e87d3fffbd14);

var $f5y5D = parcelRequire("f5y5D");

var $kLwj3 = parcelRequire("kLwj3");

var $3Iynq = parcelRequire("3Iynq");
var $65575378d8a96024$export$ff1a0b75284ac636 = function(_a) {
    var _b = _a.config, config = _b === void 0 ? (0, $kLwj3.defaults) : _b, _c = _a.l10n, l10n = _c === void 0 ? (0, $3Iynq.english) : _c, _d = _a.isMobile, isMobile = _d === void 0 ? false : _d;
    return function(dateObj, frmt, overrideLocale) {
        var locale = overrideLocale || l10n;
        if (config.formatDate !== undefined && !isMobile) return config.formatDate(dateObj, frmt, locale);
        return frmt.split("").map(function(c, i, arr) {
            return (0, $f5y5D.formats)[c] && arr[i - 1] !== "\\" ? (0, $f5y5D.formats)[c](dateObj, locale, config) : c !== "\\" ? c : "";
        }).join("");
    };
};
var $65575378d8a96024$export$cfa2ef2687faeda2 = function(_a) {
    var _b = _a.config, config = _b === void 0 ? (0, $kLwj3.defaults) : _b, _c = _a.l10n, l10n = _c === void 0 ? (0, $3Iynq.english) : _c;
    return function(date, givenFormat, timeless, customLocale) {
        if (date !== 0 && !date) return undefined;
        var locale = customLocale || l10n;
        var parsedDate;
        var dateOrig = date;
        if (date instanceof Date) parsedDate = new Date(date.getTime());
        else if (typeof date !== "string" && date.toFixed !== undefined) parsedDate = new Date(date);
        else if (typeof date === "string") {
            var format = givenFormat || (config || (0, $kLwj3.defaults)).dateFormat;
            var datestr = String(date).trim();
            if (datestr === "today") {
                parsedDate = new Date();
                timeless = true;
            } else if (config && config.parseDate) parsedDate = config.parseDate(date, format);
            else if (/Z$/.test(datestr) || /GMT$/.test(datestr)) parsedDate = new Date(date);
            else {
                var matched = void 0, ops = [];
                for(var i = 0, matchIndex = 0, regexStr = ""; i < format.length; i++){
                    var token = format[i];
                    var isBackSlash = token === "\\";
                    var escaped = format[i - 1] === "\\" || isBackSlash;
                    if ((0, $f5y5D.tokenRegex)[token] && !escaped) {
                        regexStr += (0, $f5y5D.tokenRegex)[token];
                        var match = new RegExp(regexStr).exec(date);
                        if (match && (matched = true)) ops[token !== "Y" ? "push" : "unshift"]({
                            fn: (0, $f5y5D.revFormat)[token],
                            val: match[++matchIndex]
                        });
                    } else if (!isBackSlash) regexStr += ".";
                }
                parsedDate = !config || !config.noCalendar ? new Date(new Date().getFullYear(), 0, 1, 0, 0, 0, 0) : new Date(new Date().setHours(0, 0, 0, 0));
                ops.forEach(function(_a) {
                    var fn = _a.fn, val = _a.val;
                    return parsedDate = fn(parsedDate, val, locale) || parsedDate;
                });
                parsedDate = matched ? parsedDate : undefined;
            }
        }
        if (!(parsedDate instanceof Date && !isNaN(parsedDate.getTime()))) {
            config.errorHandler(new Error("Invalid date provided: " + dateOrig));
            return undefined;
        }
        if (timeless === true) parsedDate.setHours(0, 0, 0, 0);
        return parsedDate;
    };
};
function $65575378d8a96024$export$c4c806e061935577(date1, date2, timeless) {
    if (timeless === void 0) timeless = true;
    if (timeless !== false) return new Date(date1.getTime()).setHours(0, 0, 0, 0) - new Date(date2.getTime()).setHours(0, 0, 0, 0);
    return date1.getTime() - date2.getTime();
}
function $65575378d8a96024$export$15d252ed5f5f8636(date1, date2) {
    return 3600 * (date1.getHours() - date2.getHours()) + 60 * (date1.getMinutes() - date2.getMinutes()) + date1.getSeconds() - date2.getSeconds();
}
var $65575378d8a96024$export$a4d69fb5f2026c35 = function(ts, ts1, ts2) {
    return ts > Math.min(ts1, ts2) && ts < Math.max(ts1, ts2);
};
var $65575378d8a96024$export$9fafc166baa96839 = function(hours, minutes, seconds) {
    return hours * 3600 + minutes * 60 + seconds;
};
var $65575378d8a96024$export$a4ce0def660bfe9e = function(secondsSinceMidnight) {
    var hours = Math.floor(secondsSinceMidnight / 3600), minutes = (secondsSinceMidnight - hours * 3600) / 60;
    return [
        hours,
        minutes,
        secondsSinceMidnight - hours * 3600 - minutes * 60
    ];
};
var $65575378d8a96024$export$1f34108aa9eb96ab = {
    DAY: 86400000
};
function $65575378d8a96024$export$6df0e87d3fffbd14(config) {
    var hours = config.defaultHour;
    var minutes = config.defaultMinute;
    var seconds = config.defaultSeconds;
    if (config.minDate !== undefined) {
        var minHour = config.minDate.getHours();
        var minMinutes = config.minDate.getMinutes();
        var minSeconds = config.minDate.getSeconds();
        if (hours < minHour) hours = minHour;
        if (hours === minHour && minutes < minMinutes) minutes = minMinutes;
        if (hours === minHour && minutes === minMinutes && seconds < minSeconds) seconds = config.minDate.getSeconds();
    }
    if (config.maxDate !== undefined) {
        var maxHr = config.maxDate.getHours();
        var maxMinutes = config.maxDate.getMinutes();
        hours = Math.min(hours, maxHr);
        if (hours === maxHr) minutes = Math.min(maxMinutes, minutes);
        if (hours === maxHr && minutes === maxMinutes) seconds = config.maxDate.getSeconds();
    }
    return {
        hours: hours,
        minutes: minutes,
        seconds: seconds
    };
}

});
parcelRegister("f5y5D", function(module, exports) {

$parcel$export(module.exports, "monthToStr", () => $afc1c431719e1f28$export$27a2dd9af757e89c);
$parcel$export(module.exports, "revFormat", () => $afc1c431719e1f28$export$9490b78b888a863f);
$parcel$export(module.exports, "tokenRegex", () => $afc1c431719e1f28$export$f5a8dc72fbf63af5);
$parcel$export(module.exports, "formats", () => $afc1c431719e1f28$export$55069460464ca7a9);

var $l2VaP = parcelRequire("l2VaP");
var $afc1c431719e1f28$var$doNothing = function() {
    return undefined;
};
var $afc1c431719e1f28$export$27a2dd9af757e89c = function(monthNumber, shorthand, locale) {
    return locale.months[shorthand ? "shorthand" : "longhand"][monthNumber];
};
var $afc1c431719e1f28$export$9490b78b888a863f = {
    D: $afc1c431719e1f28$var$doNothing,
    F: function(dateObj, monthName, locale) {
        dateObj.setMonth(locale.months.longhand.indexOf(monthName));
    },
    G: function(dateObj, hour) {
        dateObj.setHours((dateObj.getHours() >= 12 ? 12 : 0) + parseFloat(hour));
    },
    H: function(dateObj, hour) {
        dateObj.setHours(parseFloat(hour));
    },
    J: function(dateObj, day) {
        dateObj.setDate(parseFloat(day));
    },
    K: function(dateObj, amPM, locale) {
        dateObj.setHours(dateObj.getHours() % 12 + 12 * (0, $l2VaP.int)(new RegExp(locale.amPM[1], "i").test(amPM)));
    },
    M: function(dateObj, shortMonth, locale) {
        dateObj.setMonth(locale.months.shorthand.indexOf(shortMonth));
    },
    S: function(dateObj, seconds) {
        dateObj.setSeconds(parseFloat(seconds));
    },
    U: function(_, unixSeconds) {
        return new Date(parseFloat(unixSeconds) * 1000);
    },
    W: function(dateObj, weekNum, locale) {
        var weekNumber = parseInt(weekNum);
        var date = new Date(dateObj.getFullYear(), 0, 2 + (weekNumber - 1) * 7, 0, 0, 0, 0);
        date.setDate(date.getDate() - date.getDay() + locale.firstDayOfWeek);
        return date;
    },
    Y: function(dateObj, year) {
        dateObj.setFullYear(parseFloat(year));
    },
    Z: function(_, ISODate) {
        return new Date(ISODate);
    },
    d: function(dateObj, day) {
        dateObj.setDate(parseFloat(day));
    },
    h: function(dateObj, hour) {
        dateObj.setHours((dateObj.getHours() >= 12 ? 12 : 0) + parseFloat(hour));
    },
    i: function(dateObj, minutes) {
        dateObj.setMinutes(parseFloat(minutes));
    },
    j: function(dateObj, day) {
        dateObj.setDate(parseFloat(day));
    },
    l: $afc1c431719e1f28$var$doNothing,
    m: function(dateObj, month) {
        dateObj.setMonth(parseFloat(month) - 1);
    },
    n: function(dateObj, month) {
        dateObj.setMonth(parseFloat(month) - 1);
    },
    s: function(dateObj, seconds) {
        dateObj.setSeconds(parseFloat(seconds));
    },
    u: function(_, unixMillSeconds) {
        return new Date(parseFloat(unixMillSeconds));
    },
    w: $afc1c431719e1f28$var$doNothing,
    y: function(dateObj, year) {
        dateObj.setFullYear(2000 + parseFloat(year));
    }
};
var $afc1c431719e1f28$export$f5a8dc72fbf63af5 = {
    D: "",
    F: "",
    G: "(\\d\\d|\\d)",
    H: "(\\d\\d|\\d)",
    J: "(\\d\\d|\\d)\\w+",
    K: "",
    M: "",
    S: "(\\d\\d|\\d)",
    U: "(.+)",
    W: "(\\d\\d|\\d)",
    Y: "(\\d{4})",
    Z: "(.+)",
    d: "(\\d\\d|\\d)",
    h: "(\\d\\d|\\d)",
    i: "(\\d\\d|\\d)",
    j: "(\\d\\d|\\d)",
    l: "",
    m: "(\\d\\d|\\d)",
    n: "(\\d\\d|\\d)",
    s: "(\\d\\d|\\d)",
    u: "(.+)",
    w: "(\\d\\d|\\d)",
    y: "(\\d{2})"
};
var $afc1c431719e1f28$export$55069460464ca7a9 = {
    Z: function(date) {
        return date.toISOString();
    },
    D: function(date, locale, options) {
        return locale.weekdays.shorthand[$afc1c431719e1f28$export$55069460464ca7a9.w(date, locale, options)];
    },
    F: function(date, locale, options) {
        return $afc1c431719e1f28$export$27a2dd9af757e89c($afc1c431719e1f28$export$55069460464ca7a9.n(date, locale, options) - 1, false, locale);
    },
    G: function(date, locale, options) {
        return (0, $l2VaP.pad)($afc1c431719e1f28$export$55069460464ca7a9.h(date, locale, options));
    },
    H: function(date) {
        return (0, $l2VaP.pad)(date.getHours());
    },
    J: function(date, locale) {
        return locale.ordinal !== undefined ? date.getDate() + locale.ordinal(date.getDate()) : date.getDate();
    },
    K: function(date, locale) {
        return locale.amPM[(0, $l2VaP.int)(date.getHours() > 11)];
    },
    M: function(date, locale) {
        return $afc1c431719e1f28$export$27a2dd9af757e89c(date.getMonth(), true, locale);
    },
    S: function(date) {
        return (0, $l2VaP.pad)(date.getSeconds());
    },
    U: function(date) {
        return date.getTime() / 1000;
    },
    W: function(date, _, options) {
        return options.getWeek(date);
    },
    Y: function(date) {
        return (0, $l2VaP.pad)(date.getFullYear(), 4);
    },
    d: function(date) {
        return (0, $l2VaP.pad)(date.getDate());
    },
    h: function(date) {
        return date.getHours() % 12 ? date.getHours() % 12 : 12;
    },
    i: function(date) {
        return (0, $l2VaP.pad)(date.getMinutes());
    },
    j: function(date) {
        return date.getDate();
    },
    l: function(date, locale) {
        return locale.weekdays.longhand[date.getDay()];
    },
    m: function(date) {
        return (0, $l2VaP.pad)(date.getMonth() + 1);
    },
    n: function(date) {
        return date.getMonth() + 1;
    },
    s: function(date) {
        return date.getSeconds();
    },
    u: function(date) {
        return date.getTime();
    },
    w: function(date) {
        return date.getDay();
    },
    y: function(date) {
        return String(date.getFullYear()).substring(2);
    }
};

});


parcelRegister("3KkRp", function(module, exports) {
"use strict";
if (typeof Object.assign !== "function") Object.assign = function(target) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (!target) throw TypeError("Cannot convert undefined or null to object");
    var _loop_1 = function(source) {
        if (source) Object.keys(source).forEach(function(key) {
            return target[key] = source[key];
        });
    };
    for(var _a = 0, args_1 = args; _a < args_1.length; _a++){
        var source = args_1[_a];
        _loop_1(source);
    }
    return target;
};

});



parcelRegister("aPsVO", function(module, exports) {

$parcel$export(module.exports, "html", () => $7e251bfeb3894ac2$export$c0bb0b647f701bb5);
$parcel$export(module.exports, "render", () => (parcelRequire("cFPH9")).render);
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */ /**
 *
 * Main lit-html module.
 *
 * Main exports:
 *
 * -  [[html]]
 * -  [[svg]]
 * -  [[render]]
 *
 * @packageDocumentation
 */ /**
 * Do not remove this comment; it keeps typedoc from misplacing the module
 * docs.
 */ 
var $iUyab = parcelRequire("iUyab");

var $eDnSP = parcelRequire("eDnSP");

var $iYB8H = parcelRequire("iYB8H");

var $ixdbG = parcelRequire("ixdbG");

var $gIbhF = parcelRequire("gIbhF");

var $3jJxF = parcelRequire("3jJxF");

var $cFPH9 = parcelRequire("cFPH9");

var $jZRBD = parcelRequire("jZRBD");

var $lUGvn = parcelRequire("lUGvn");

var $8AGqo = parcelRequire("8AGqo");
// IMPORTANT: do not change the property name or the assignment expression.
// This line will be used in regexes to search for lit-html usage.
// TODO(justinfagnani): inject version number at build time
if (typeof window !== "undefined") (window["litHtmlVersions"] || (window["litHtmlVersions"] = [])).push("1.4.1");
const $7e251bfeb3894ac2$export$c0bb0b647f701bb5 = (strings, ...values)=>new (0, $eDnSP.TemplateResult)(strings, values, "html", (0, $iUyab.defaultTemplateProcessor));
const $7e251bfeb3894ac2$export$7ed1367e7fa1ad68 = (strings, ...values)=>new (0, $eDnSP.SVGTemplateResult)(strings, values, "svg", (0, $iUyab.defaultTemplateProcessor));

});
parcelRegister("iUyab", function(module, exports) {

$parcel$export(module.exports, "defaultTemplateProcessor", () => $dc47f51161253278$export$608256e8e6650f65);
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */ 
var $3jJxF = parcelRequire("3jJxF");
class $dc47f51161253278$export$53a556099f0fa088 {
    /**
     * Create parts for an attribute-position binding, given the event, attribute
     * name, and string literals.
     *
     * @param element The element containing the binding
     * @param name  The attribute name
     * @param strings The string literals. There are always at least two strings,
     *   event for fully-controlled bindings with a single expression.
     */ handleAttributeExpressions(element, name, strings, options) {
        const prefix = name[0];
        if (prefix === ".") {
            const committer = new (0, $3jJxF.PropertyCommitter)(element, name.slice(1), strings);
            return committer.parts;
        }
        if (prefix === "@") return [
            new (0, $3jJxF.EventPart)(element, name.slice(1), options.eventContext)
        ];
        if (prefix === "?") return [
            new (0, $3jJxF.BooleanAttributePart)(element, name.slice(1), strings)
        ];
        const committer = new (0, $3jJxF.AttributeCommitter)(element, name, strings);
        return committer.parts;
    }
    /**
     * Create parts for a text-position binding.
     * @param templateFactory
     */ handleTextExpression(options) {
        return new (0, $3jJxF.NodePart)(options);
    }
}
const $dc47f51161253278$export$608256e8e6650f65 = new $dc47f51161253278$export$53a556099f0fa088();

});
parcelRegister("3jJxF", function(module, exports) {

$parcel$export(module.exports, "AttributeCommitter", () => $26a6791f145f71d8$export$9ac9216e336e96d0);
$parcel$export(module.exports, "NodePart", () => $26a6791f145f71d8$export$a354997aeda6e93);
$parcel$export(module.exports, "BooleanAttributePart", () => $26a6791f145f71d8$export$b9df278b293d5b48);
$parcel$export(module.exports, "PropertyCommitter", () => $26a6791f145f71d8$export$2d7935a96ad7cb22);
$parcel$export(module.exports, "EventPart", () => $26a6791f145f71d8$export$b28e368652651bd7);
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */ 
var $iYB8H = parcelRequire("iYB8H");

var $ixdbG = parcelRequire("ixdbG");

var $gIbhF = parcelRequire("gIbhF");

var $lUGvn = parcelRequire("lUGvn");

var $eDnSP = parcelRequire("eDnSP");

var $8AGqo = parcelRequire("8AGqo");
const $26a6791f145f71d8$export$c3825b437cbdea5c = (value)=>{
    return value === null || !(typeof value === "object" || typeof value === "function");
};
const $26a6791f145f71d8$export$9652023d9040757 = (value)=>{
    return Array.isArray(value) || // eslint-disable-next-line @typescript-eslint/no-explicit-any
    !!(value && value[Symbol.iterator]);
};
class $26a6791f145f71d8$export$9ac9216e336e96d0 {
    constructor(element, name, strings){
        this.dirty = true;
        this.element = element;
        this.name = name;
        this.strings = strings;
        this.parts = [];
        for(let i = 0; i < strings.length - 1; i++)this.parts[i] = this._createPart();
    }
    /**
     * Creates a single part. Override this to create a differnt type of part.
     */ _createPart() {
        return new $26a6791f145f71d8$export$da9b3ca39c846561(this);
    }
    _getValue() {
        const strings = this.strings;
        const l = strings.length - 1;
        const parts = this.parts;
        // If we're assigning an attribute via syntax like:
        //    attr="${foo}"  or  attr=${foo}
        // but not
        //    attr="${foo} ${bar}" or attr="${foo} baz"
        // then we don't want to coerce the attribute value into one long
        // string. Instead we want to just return the value itself directly,
        // so that sanitizeDOMValue can get the actual value rather than
        // String(value)
        // The exception is if v is an array, in which case we do want to smash
        // it together into a string without calling String() on the array.
        //
        // This also allows trusted values (when using TrustedTypes) being
        // assigned to DOM sinks without being stringified in the process.
        if (l === 1 && strings[0] === "" && strings[1] === "") {
            const v = parts[0].value;
            if (typeof v === "symbol") return String(v);
            if (typeof v === "string" || !$26a6791f145f71d8$export$9652023d9040757(v)) return v;
        }
        let text = "";
        for(let i = 0; i < l; i++){
            text += strings[i];
            const part = parts[i];
            if (part !== undefined) {
                const v = part.value;
                if ($26a6791f145f71d8$export$c3825b437cbdea5c(v) || !$26a6791f145f71d8$export$9652023d9040757(v)) text += typeof v === "string" ? v : String(v);
                else for (const t of v)text += typeof t === "string" ? t : String(t);
            }
        }
        text += strings[l];
        return text;
    }
    commit() {
        if (this.dirty) {
            this.dirty = false;
            this.element.setAttribute(this.name, this._getValue());
        }
    }
}
class $26a6791f145f71d8$export$da9b3ca39c846561 {
    constructor(committer){
        this.value = undefined;
        this.committer = committer;
    }
    setValue(value) {
        if (value !== (0, $gIbhF.noChange) && (!$26a6791f145f71d8$export$c3825b437cbdea5c(value) || value !== this.value)) {
            this.value = value;
            // If the value is a not a directive, dirty the committer so that it'll
            // call setAttribute. If the value is a directive, it'll dirty the
            // committer if it calls setValue().
            if (!(0, $iYB8H.isDirective)(value)) this.committer.dirty = true;
        }
    }
    commit() {
        while((0, $iYB8H.isDirective)(this.value)){
            const directive = this.value;
            this.value = (0, $gIbhF.noChange);
            directive(this);
        }
        if (this.value === (0, $gIbhF.noChange)) return;
        this.committer.commit();
    }
}
class $26a6791f145f71d8$export$a354997aeda6e93 {
    constructor(options){
        this.value = undefined;
        this.__pendingValue = undefined;
        this.options = options;
    }
    /**
     * Appends this part into a container.
     *
     * This part must be empty, as its contents are not automatically moved.
     */ appendInto(container) {
        this.startNode = container.appendChild((0, $8AGqo.createMarker)());
        this.endNode = container.appendChild((0, $8AGqo.createMarker)());
    }
    /**
     * Inserts this part after the `ref` node (between `ref` and `ref`'s next
     * sibling). Both `ref` and its next sibling must be static, unchanging nodes
     * such as those that appear in a literal section of a template.
     *
     * This part must be empty, as its contents are not automatically moved.
     */ insertAfterNode(ref) {
        this.startNode = ref;
        this.endNode = ref.nextSibling;
    }
    /**
     * Appends this part into a parent part.
     *
     * This part must be empty, as its contents are not automatically moved.
     */ appendIntoPart(part) {
        part.__insert(this.startNode = (0, $8AGqo.createMarker)());
        part.__insert(this.endNode = (0, $8AGqo.createMarker)());
    }
    /**
     * Inserts this part after the `ref` part.
     *
     * This part must be empty, as its contents are not automatically moved.
     */ insertAfterPart(ref) {
        ref.__insert(this.startNode = (0, $8AGqo.createMarker)());
        this.endNode = ref.endNode;
        ref.endNode = this.startNode;
    }
    setValue(value) {
        this.__pendingValue = value;
    }
    commit() {
        if (this.startNode.parentNode === null) return;
        while((0, $iYB8H.isDirective)(this.__pendingValue)){
            const directive = this.__pendingValue;
            this.__pendingValue = (0, $gIbhF.noChange);
            directive(this);
        }
        const value = this.__pendingValue;
        if (value === (0, $gIbhF.noChange)) return;
        if ($26a6791f145f71d8$export$c3825b437cbdea5c(value)) {
            if (value !== this.value) this.__commitText(value);
        } else if (value instanceof (0, $eDnSP.TemplateResult)) this.__commitTemplateResult(value);
        else if (value instanceof Node) this.__commitNode(value);
        else if ($26a6791f145f71d8$export$9652023d9040757(value)) this.__commitIterable(value);
        else if (value === (0, $gIbhF.nothing)) {
            this.value = (0, $gIbhF.nothing);
            this.clear();
        } else // Fallback, will render the string representation
        this.__commitText(value);
    }
    __insert(node) {
        this.endNode.parentNode.insertBefore(node, this.endNode);
    }
    __commitNode(value) {
        if (this.value === value) return;
        this.clear();
        this.__insert(value);
        this.value = value;
    }
    __commitText(value) {
        const node = this.startNode.nextSibling;
        value = value == null ? "" : value;
        // If `value` isn't already a string, we explicitly convert it here in case
        // it can't be implicitly converted - i.e. it's a symbol.
        const valueAsString = typeof value === "string" ? value : String(value);
        if (node === this.endNode.previousSibling && node.nodeType === 3 /* Node.TEXT_NODE */ ) // If we only have a single text node between the markers, we can just
        // set its value, rather than replacing it.
        // TODO(justinfagnani): Can we just check if this.value is primitive?
        node.data = valueAsString;
        else this.__commitNode(document.createTextNode(valueAsString));
        this.value = value;
    }
    __commitTemplateResult(value) {
        const template = this.options.templateFactory(value);
        if (this.value instanceof (0, $lUGvn.TemplateInstance) && this.value.template === template) this.value.update(value.values);
        else {
            // Make sure we propagate the template processor from the TemplateResult
            // so that we use its syntax extension, etc. The template factory comes
            // from the render function options so that it can control template
            // caching and preprocessing.
            const instance = new (0, $lUGvn.TemplateInstance)(template, value.processor, this.options);
            const fragment = instance._clone();
            instance.update(value.values);
            this.__commitNode(fragment);
            this.value = instance;
        }
    }
    __commitIterable(value) {
        // For an Iterable, we create a new InstancePart per item, then set its
        // value to the item. This is a little bit of overhead for every item in
        // an Iterable, but it lets us recurse easily and efficiently update Arrays
        // of TemplateResults that will be commonly returned from expressions like:
        // array.map((i) => html`${i}`), by reusing existing TemplateInstances.
        // If _value is an array, then the previous render was of an
        // iterable and _value will contain the NodeParts from the previous
        // render. If _value is not an array, clear this part and make a new
        // array for NodeParts.
        if (!Array.isArray(this.value)) {
            this.value = [];
            this.clear();
        }
        // Lets us keep track of how many items we stamped so we can clear leftover
        // items from a previous render
        const itemParts = this.value;
        let partIndex = 0;
        let itemPart;
        for (const item of value){
            // Try to reuse an existing part
            itemPart = itemParts[partIndex];
            // If no existing part, create a new one
            if (itemPart === undefined) {
                itemPart = new $26a6791f145f71d8$export$a354997aeda6e93(this.options);
                itemParts.push(itemPart);
                if (partIndex === 0) itemPart.appendIntoPart(this);
                else itemPart.insertAfterPart(itemParts[partIndex - 1]);
            }
            itemPart.setValue(item);
            itemPart.commit();
            partIndex++;
        }
        if (partIndex < itemParts.length) {
            // Truncate the parts array so _value reflects the current state
            itemParts.length = partIndex;
            this.clear(itemPart && itemPart.endNode);
        }
    }
    clear(startNode = this.startNode) {
        (0, $ixdbG.removeNodes)(this.startNode.parentNode, startNode.nextSibling, this.endNode);
    }
}
class $26a6791f145f71d8$export$b9df278b293d5b48 {
    constructor(element, name, strings){
        this.value = undefined;
        this.__pendingValue = undefined;
        if (strings.length !== 2 || strings[0] !== "" || strings[1] !== "") throw new Error("Boolean attributes can only contain a single expression");
        this.element = element;
        this.name = name;
        this.strings = strings;
    }
    setValue(value) {
        this.__pendingValue = value;
    }
    commit() {
        while((0, $iYB8H.isDirective)(this.__pendingValue)){
            const directive = this.__pendingValue;
            this.__pendingValue = (0, $gIbhF.noChange);
            directive(this);
        }
        if (this.__pendingValue === (0, $gIbhF.noChange)) return;
        const value = !!this.__pendingValue;
        if (this.value !== value) {
            if (value) this.element.setAttribute(this.name, "");
            else this.element.removeAttribute(this.name);
            this.value = value;
        }
        this.__pendingValue = (0, $gIbhF.noChange);
    }
}
class $26a6791f145f71d8$export$2d7935a96ad7cb22 extends $26a6791f145f71d8$export$9ac9216e336e96d0 {
    constructor(element, name, strings){
        super(element, name, strings);
        this.single = strings.length === 2 && strings[0] === "" && strings[1] === "";
    }
    _createPart() {
        return new $26a6791f145f71d8$export$b78f5e1c476c794e(this);
    }
    _getValue() {
        if (this.single) return this.parts[0].value;
        return super._getValue();
    }
    commit() {
        if (this.dirty) {
            this.dirty = false;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this.element[this.name] = this._getValue();
        }
    }
}
class $26a6791f145f71d8$export$b78f5e1c476c794e extends $26a6791f145f71d8$export$da9b3ca39c846561 {
}
// Detect event listener options support. If the `capture` property is read
// from the options object, then options are supported. If not, then the third
// argument to add/removeEventListener is interpreted as the boolean capture
// value so we should only pass the `capture` property.
let $26a6791f145f71d8$var$eventOptionsSupported = false;
// Wrap into an IIFE because MS Edge <= v41 does not support having try/catch
// blocks right into the body of a module
(()=>{
    try {
        const options = {
            get capture () {
                $26a6791f145f71d8$var$eventOptionsSupported = true;
                return false;
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        window.addEventListener("test", options, options);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        window.removeEventListener("test", options, options);
    } catch (_e) {
    // event options not supported
    }
})();
class $26a6791f145f71d8$export$b28e368652651bd7 {
    constructor(element, eventName, eventContext){
        this.value = undefined;
        this.__pendingValue = undefined;
        this.element = element;
        this.eventName = eventName;
        this.eventContext = eventContext;
        this.__boundHandleEvent = (e)=>this.handleEvent(e);
    }
    setValue(value) {
        this.__pendingValue = value;
    }
    commit() {
        while((0, $iYB8H.isDirective)(this.__pendingValue)){
            const directive = this.__pendingValue;
            this.__pendingValue = (0, $gIbhF.noChange);
            directive(this);
        }
        if (this.__pendingValue === (0, $gIbhF.noChange)) return;
        const newListener = this.__pendingValue;
        const oldListener = this.value;
        const shouldRemoveListener = newListener == null || oldListener != null && (newListener.capture !== oldListener.capture || newListener.once !== oldListener.once || newListener.passive !== oldListener.passive);
        const shouldAddListener = newListener != null && (oldListener == null || shouldRemoveListener);
        if (shouldRemoveListener) this.element.removeEventListener(this.eventName, this.__boundHandleEvent, this.__options);
        if (shouldAddListener) {
            this.__options = $26a6791f145f71d8$var$getOptions(newListener);
            this.element.addEventListener(this.eventName, this.__boundHandleEvent, this.__options);
        }
        this.value = newListener;
        this.__pendingValue = (0, $gIbhF.noChange);
    }
    handleEvent(event) {
        if (typeof this.value === "function") this.value.call(this.eventContext || this.element, event);
        else this.value.handleEvent(event);
    }
}
// We copy options because of the inconsistent behavior of browsers when reading
// the third argument of add/removeEventListener. IE11 doesn't support options
// at all. Chrome 41 only reads `capture` if the argument is an object.
const $26a6791f145f71d8$var$getOptions = (o)=>o && ($26a6791f145f71d8$var$eventOptionsSupported ? {
        capture: o.capture,
        passive: o.passive,
        once: o.once
    } : o.capture);

});
parcelRegister("iYB8H", function(module, exports) {

$parcel$export(module.exports, "isDirective", () => $dd0aa3a9dfbe954e$export$4b5d79f26e0e3ad5);
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */ const $dd0aa3a9dfbe954e$var$directives = new WeakMap();
const $dd0aa3a9dfbe954e$export$99b43ad1ed32e735 = (f)=>(...args)=>{
        const d = f(...args);
        $dd0aa3a9dfbe954e$var$directives.set(d, true);
        return d;
    };
const $dd0aa3a9dfbe954e$export$4b5d79f26e0e3ad5 = (o)=>{
    return typeof o === "function" && $dd0aa3a9dfbe954e$var$directives.has(o);
};

});

parcelRegister("ixdbG", function(module, exports) {

$parcel$export(module.exports, "isCEPolyfill", () => $d7e589cf65bc32c0$export$52a61c3a7415f2b1);
$parcel$export(module.exports, "reparentNodes", () => $d7e589cf65bc32c0$export$4cae3494608af418);
$parcel$export(module.exports, "removeNodes", () => $d7e589cf65bc32c0$export$77f49a256021c8de);
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */ /**
 * True if the custom elements polyfill is in use.
 */ const $d7e589cf65bc32c0$export$52a61c3a7415f2b1 = typeof window !== "undefined" && window.customElements != null && window.customElements.polyfillWrapFlushCallback !== undefined;
const $d7e589cf65bc32c0$export$4cae3494608af418 = (container, start, end = null, before = null)=>{
    while(start !== end){
        const n = start.nextSibling;
        container.insertBefore(start, before);
        start = n;
    }
};
const $d7e589cf65bc32c0$export$77f49a256021c8de = (container, start, end = null)=>{
    while(start !== end){
        const n = start.nextSibling;
        container.removeChild(start);
        start = n;
    }
};

});

parcelRegister("gIbhF", function(module, exports) {

$parcel$export(module.exports, "noChange", () => $c2a9822bfcd4dafd$export$9c068ae9cc5db4e8);
$parcel$export(module.exports, "nothing", () => $c2a9822bfcd4dafd$export$45b790e32b2810ee);
/**
 * @license
 * Copyright (c) 2018 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */ /**
 * A sentinel value that signals that a value was handled by a directive and
 * should not be written to the DOM.
 */ const $c2a9822bfcd4dafd$export$9c068ae9cc5db4e8 = {};
const $c2a9822bfcd4dafd$export$45b790e32b2810ee = {};

});

parcelRegister("lUGvn", function(module, exports) {

$parcel$export(module.exports, "TemplateInstance", () => $ff3fcc8d1d913598$export$6eecef7813f38266);
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */ 
var $ixdbG = parcelRequire("ixdbG");

var $8AGqo = parcelRequire("8AGqo");
class $ff3fcc8d1d913598$export$6eecef7813f38266 {
    constructor(template, processor, options){
        this.__parts = [];
        this.template = template;
        this.processor = processor;
        this.options = options;
    }
    update(values) {
        let i = 0;
        for (const part of this.__parts){
            if (part !== undefined) part.setValue(values[i]);
            i++;
        }
        for (const part of this.__parts)if (part !== undefined) part.commit();
    }
    _clone() {
        // There are a number of steps in the lifecycle of a template instance's
        // DOM fragment:
        //  1. Clone - create the instance fragment
        //  2. Adopt - adopt into the main document
        //  3. Process - find part markers and create parts
        //  4. Upgrade - upgrade custom elements
        //  5. Update - set node, attribute, property, etc., values
        //  6. Connect - connect to the document. Optional and outside of this
        //     method.
        //
        // We have a few constraints on the ordering of these steps:
        //  * We need to upgrade before updating, so that property values will pass
        //    through any property setters.
        //  * We would like to process before upgrading so that we're sure that the
        //    cloned fragment is inert and not disturbed by self-modifying DOM.
        //  * We want custom elements to upgrade even in disconnected fragments.
        //
        // Given these constraints, with full custom elements support we would
        // prefer the order: Clone, Process, Adopt, Upgrade, Update, Connect
        //
        // But Safari does not implement CustomElementRegistry#upgrade, so we
        // can not implement that order and still have upgrade-before-update and
        // upgrade disconnected fragments. So we instead sacrifice the
        // process-before-upgrade constraint, since in Custom Elements v1 elements
        // must not modify their light DOM in the constructor. We still have issues
        // when co-existing with CEv0 elements like Polymer 1, and with polyfills
        // that don't strictly adhere to the no-modification rule because shadow
        // DOM, which may be created in the constructor, is emulated by being placed
        // in the light DOM.
        //
        // The resulting order is on native is: Clone, Adopt, Upgrade, Process,
        // Update, Connect. document.importNode() performs Clone, Adopt, and Upgrade
        // in one step.
        //
        // The Custom Elements v1 polyfill supports upgrade(), so the order when
        // polyfilled is the more ideal: Clone, Process, Adopt, Upgrade, Update,
        // Connect.
        const fragment = (0, $ixdbG.isCEPolyfill) ? this.template.element.content.cloneNode(true) : document.importNode(this.template.element.content, true);
        const stack = [];
        const parts = this.template.parts;
        // Edge needs all 4 parameters present; IE11 needs 3rd parameter to be null
        const walker = document.createTreeWalker(fragment, 133 /* NodeFilter.SHOW_{ELEMENT|COMMENT|TEXT} */ , null, false);
        let partIndex = 0;
        let nodeIndex = 0;
        let part;
        let node = walker.nextNode();
        // Loop through all the nodes and parts of a template
        while(partIndex < parts.length){
            part = parts[partIndex];
            if (!(0, $8AGqo.isTemplatePartActive)(part)) {
                this.__parts.push(undefined);
                partIndex++;
                continue;
            }
            // Progress the tree walker until we find our next part's node.
            // Note that multiple parts may share the same node (attribute parts
            // on a single element), so this loop may not run at all.
            while(nodeIndex < part.index){
                nodeIndex++;
                if (node.nodeName === "TEMPLATE") {
                    stack.push(node);
                    walker.currentNode = node.content;
                }
                if ((node = walker.nextNode()) === null) {
                    // We've exhausted the content inside a nested template element.
                    // Because we still have parts (the outer for-loop), we know:
                    // - There is a template in the stack
                    // - The walker will find a nextNode outside the template
                    walker.currentNode = stack.pop();
                    node = walker.nextNode();
                }
            }
            // We've arrived at our part's node.
            if (part.type === "node") {
                const part = this.processor.handleTextExpression(this.options);
                part.insertAfterNode(node.previousSibling);
                this.__parts.push(part);
            } else this.__parts.push(...this.processor.handleAttributeExpressions(node, part.name, part.strings, this.options));
            partIndex++;
        }
        if (0, $ixdbG.isCEPolyfill) {
            document.adoptNode(fragment);
            customElements.upgrade(fragment);
        }
        return fragment;
    }
}

});
parcelRegister("8AGqo", function(module, exports) {

$parcel$export(module.exports, "marker", () => $6412982ca3e607b0$export$ffc4d0086f1a4c9);
$parcel$export(module.exports, "nodeMarker", () => $6412982ca3e607b0$export$36b8314a2f34ed60);
$parcel$export(module.exports, "boundAttributeSuffix", () => $6412982ca3e607b0$export$552ff45b274cc170);
$parcel$export(module.exports, "Template", () => $6412982ca3e607b0$export$14416b8d99d47caa);
$parcel$export(module.exports, "lastAttributeNameRegex", () => $6412982ca3e607b0$export$a5d53adfffe6a300);
$parcel$export(module.exports, "createMarker", () => $6412982ca3e607b0$export$46b32044f78fe9b1);
$parcel$export(module.exports, "isTemplatePartActive", () => $6412982ca3e607b0$export$93919229d19012c8);
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */ /**
 * An expression marker with embedded unique key to avoid collision with
 * possible text in templates.
 */ const $6412982ca3e607b0$export$ffc4d0086f1a4c9 = `{{lit-${String(Math.random()).slice(2)}}}`;
const $6412982ca3e607b0$export$36b8314a2f34ed60 = `<!--${$6412982ca3e607b0$export$ffc4d0086f1a4c9}-->`;
const $6412982ca3e607b0$export$8c751b9db6965af4 = new RegExp(`${$6412982ca3e607b0$export$ffc4d0086f1a4c9}|${$6412982ca3e607b0$export$36b8314a2f34ed60}`);
const $6412982ca3e607b0$export$552ff45b274cc170 = "$lit$";
class $6412982ca3e607b0$export$14416b8d99d47caa {
    constructor(result, element){
        this.parts = [];
        this.element = element;
        const nodesToRemove = [];
        const stack = [];
        // Edge needs all 4 parameters present; IE11 needs 3rd parameter to be null
        const walker = document.createTreeWalker(element.content, 133 /* NodeFilter.SHOW_{ELEMENT|COMMENT|TEXT} */ , null, false);
        // Keeps track of the last index associated with a part. We try to delete
        // unnecessary nodes, but we never want to associate two different parts
        // to the same index. They must have a constant node between.
        let lastPartIndex = 0;
        let index = -1;
        let partIndex = 0;
        const { strings: strings, values: { length: length } } = result;
        while(partIndex < length){
            const node = walker.nextNode();
            if (node === null) {
                // We've exhausted the content inside a nested template element.
                // Because we still have parts (the outer for-loop), we know:
                // - There is a template in the stack
                // - The walker will find a nextNode outside the template
                walker.currentNode = stack.pop();
                continue;
            }
            index++;
            if (node.nodeType === 1 /* Node.ELEMENT_NODE */ ) {
                if (node.hasAttributes()) {
                    const attributes = node.attributes;
                    const { length: length } = attributes;
                    // Per
                    // https://developer.mozilla.org/en-US/docs/Web/API/NamedNodeMap,
                    // attributes are not guaranteed to be returned in document order.
                    // In particular, Edge/IE can return them out of order, so we cannot
                    // assume a correspondence between part index and attribute index.
                    let count = 0;
                    for(let i = 0; i < length; i++)if ($6412982ca3e607b0$var$endsWith(attributes[i].name, $6412982ca3e607b0$export$552ff45b274cc170)) count++;
                    while(count-- > 0){
                        // Get the template literal section leading up to the first
                        // expression in this attribute
                        const stringForPart = strings[partIndex];
                        // Find the attribute name
                        const name = $6412982ca3e607b0$export$a5d53adfffe6a300.exec(stringForPart)[2];
                        // Find the corresponding attribute
                        // All bound attributes have had a suffix added in
                        // TemplateResult#getHTML to opt out of special attribute
                        // handling. To look up the attribute value we also need to add
                        // the suffix.
                        const attributeLookupName = name.toLowerCase() + $6412982ca3e607b0$export$552ff45b274cc170;
                        const attributeValue = node.getAttribute(attributeLookupName);
                        node.removeAttribute(attributeLookupName);
                        const statics = attributeValue.split($6412982ca3e607b0$export$8c751b9db6965af4);
                        this.parts.push({
                            type: "attribute",
                            index: index,
                            name: name,
                            strings: statics
                        });
                        partIndex += statics.length - 1;
                    }
                }
                if (node.tagName === "TEMPLATE") {
                    stack.push(node);
                    walker.currentNode = node.content;
                }
            } else if (node.nodeType === 3 /* Node.TEXT_NODE */ ) {
                const data = node.data;
                if (data.indexOf($6412982ca3e607b0$export$ffc4d0086f1a4c9) >= 0) {
                    const parent = node.parentNode;
                    const strings = data.split($6412982ca3e607b0$export$8c751b9db6965af4);
                    const lastIndex = strings.length - 1;
                    // Generate a new text node for each literal section
                    // These nodes are also used as the markers for node parts
                    for(let i = 0; i < lastIndex; i++){
                        let insert;
                        let s = strings[i];
                        if (s === "") insert = $6412982ca3e607b0$export$46b32044f78fe9b1();
                        else {
                            const match = $6412982ca3e607b0$export$a5d53adfffe6a300.exec(s);
                            if (match !== null && $6412982ca3e607b0$var$endsWith(match[2], $6412982ca3e607b0$export$552ff45b274cc170)) s = s.slice(0, match.index) + match[1] + match[2].slice(0, -$6412982ca3e607b0$export$552ff45b274cc170.length) + match[3];
                            insert = document.createTextNode(s);
                        }
                        parent.insertBefore(insert, node);
                        this.parts.push({
                            type: "node",
                            index: ++index
                        });
                    }
                    // If there's no text, we must insert a comment to mark our place.
                    // Else, we can trust it will stick around after cloning.
                    if (strings[lastIndex] === "") {
                        parent.insertBefore($6412982ca3e607b0$export$46b32044f78fe9b1(), node);
                        nodesToRemove.push(node);
                    } else node.data = strings[lastIndex];
                    // We have a part for each match found
                    partIndex += lastIndex;
                }
            } else if (node.nodeType === 8 /* Node.COMMENT_NODE */ ) {
                if (node.data === $6412982ca3e607b0$export$ffc4d0086f1a4c9) {
                    const parent = node.parentNode;
                    // Add a new marker node to be the startNode of the Part if any of
                    // the following are true:
                    //  * We don't have a previousSibling
                    //  * The previousSibling is already the start of a previous part
                    if (node.previousSibling === null || index === lastPartIndex) {
                        index++;
                        parent.insertBefore($6412982ca3e607b0$export$46b32044f78fe9b1(), node);
                    }
                    lastPartIndex = index;
                    this.parts.push({
                        type: "node",
                        index: index
                    });
                    // If we don't have a nextSibling, keep this node so we have an end.
                    // Else, we can remove it to save future costs.
                    if (node.nextSibling === null) node.data = "";
                    else {
                        nodesToRemove.push(node);
                        index--;
                    }
                    partIndex++;
                } else {
                    let i = -1;
                    while((i = node.data.indexOf($6412982ca3e607b0$export$ffc4d0086f1a4c9, i + 1)) !== -1){
                        // Comment node has a binding marker inside, make an inactive part
                        // The binding won't work, but subsequent bindings will
                        // TODO (justinfagnani): consider whether it's even worth it to
                        // make bindings in comments work
                        this.parts.push({
                            type: "node",
                            index: -1
                        });
                        partIndex++;
                    }
                }
            }
        }
        // Remove text binding nodes after the walk to not disturb the TreeWalker
        for (const n of nodesToRemove)n.parentNode.removeChild(n);
    }
}
const $6412982ca3e607b0$var$endsWith = (str, suffix)=>{
    const index = str.length - suffix.length;
    return index >= 0 && str.slice(index) === suffix;
};
const $6412982ca3e607b0$export$93919229d19012c8 = (part)=>part.index !== -1;
const $6412982ca3e607b0$export$46b32044f78fe9b1 = ()=>document.createComment("");
const $6412982ca3e607b0$export$a5d53adfffe6a300 = // eslint-disable-next-line no-control-regex
/([ \x09\x0a\x0c\x0d])([^\0-\x1F\x7F-\x9F "'>=/]+)([ \x09\x0a\x0c\x0d]*=[ \x09\x0a\x0c\x0d]*(?:[^ \x09\x0a\x0c\x0d"'`<>=]*|"[^"]*|'[^']*))$/;

});


parcelRegister("eDnSP", function(module, exports) {

$parcel$export(module.exports, "TemplateResult", () => $aa773beb353f403b$export$ce95ebd39b69fb27);
$parcel$export(module.exports, "SVGTemplateResult", () => $aa773beb353f403b$export$36e852975bbbeae0);
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */ /**
 * @module lit-html
 */ 
var $ixdbG = parcelRequire("ixdbG");

var $8AGqo = parcelRequire("8AGqo");
/**
 * Our TrustedTypePolicy for HTML which is declared using the html template
 * tag function.
 *
 * That HTML is a developer-authored constant, and is parsed with innerHTML
 * before any untrusted expressions have been mixed in. Therefor it is
 * considered safe by construction.
 */ const $aa773beb353f403b$var$policy = window.trustedTypes && trustedTypes.createPolicy("lit-html", {
    createHTML: (s)=>s
});
const $aa773beb353f403b$var$commentMarker = ` ${(0, $8AGqo.marker)} `;
class $aa773beb353f403b$export$ce95ebd39b69fb27 {
    constructor(strings, values, type, processor){
        this.strings = strings;
        this.values = values;
        this.type = type;
        this.processor = processor;
    }
    /**
     * Returns a string of HTML used to create a `<template>` element.
     */ getHTML() {
        const l = this.strings.length - 1;
        let html = "";
        let isCommentBinding = false;
        for(let i = 0; i < l; i++){
            const s = this.strings[i];
            // For each binding we want to determine the kind of marker to insert
            // into the template source before it's parsed by the browser's HTML
            // parser. The marker type is based on whether the expression is in an
            // attribute, text, or comment position.
            //   * For node-position bindings we insert a comment with the marker
            //     sentinel as its text content, like <!--{{lit-guid}}-->.
            //   * For attribute bindings we insert just the marker sentinel for the
            //     first binding, so that we support unquoted attribute bindings.
            //     Subsequent bindings can use a comment marker because multi-binding
            //     attributes must be quoted.
            //   * For comment bindings we insert just the marker sentinel so we don't
            //     close the comment.
            //
            // The following code scans the template source, but is *not* an HTML
            // parser. We don't need to track the tree structure of the HTML, only
            // whether a binding is inside a comment, and if not, if it appears to be
            // the first binding in an attribute.
            const commentOpen = s.lastIndexOf("<!--");
            // We're in comment position if we have a comment open with no following
            // comment close. Because <-- can appear in an attribute value there can
            // be false positives.
            isCommentBinding = (commentOpen > -1 || isCommentBinding) && s.indexOf("-->", commentOpen + 1) === -1;
            // Check to see if we have an attribute-like sequence preceding the
            // expression. This can match "name=value" like structures in text,
            // comments, and attribute values, so there can be false-positives.
            const attributeMatch = (0, $8AGqo.lastAttributeNameRegex).exec(s);
            if (attributeMatch === null) // We're only in this branch if we don't have a attribute-like
            // preceding sequence. For comments, this guards against unusual
            // attribute values like <div foo="<!--${'bar'}">. Cases like
            // <!-- foo=${'bar'}--> are handled correctly in the attribute branch
            // below.
            html += s + (isCommentBinding ? $aa773beb353f403b$var$commentMarker : (0, $8AGqo.nodeMarker));
            else // For attributes we use just a marker sentinel, and also append a
            // $lit$ suffix to the name to opt-out of attribute-specific parsing
            // that IE and Edge do for style and certain SVG attributes.
            html += s.substr(0, attributeMatch.index) + attributeMatch[1] + attributeMatch[2] + (0, $8AGqo.boundAttributeSuffix) + attributeMatch[3] + (0, $8AGqo.marker);
        }
        html += this.strings[l];
        return html;
    }
    getTemplateElement() {
        const template = document.createElement("template");
        let value = this.getHTML();
        if ($aa773beb353f403b$var$policy !== undefined) // this is secure because `this.strings` is a TemplateStringsArray.
        // TODO: validate this when
        // https://github.com/tc39/proposal-array-is-template-object is
        // implemented.
        value = $aa773beb353f403b$var$policy.createHTML(value);
        template.innerHTML = value;
        return template;
    }
}
class $aa773beb353f403b$export$36e852975bbbeae0 extends $aa773beb353f403b$export$ce95ebd39b69fb27 {
    getHTML() {
        return `<svg>${super.getHTML()}</svg>`;
    }
    getTemplateElement() {
        const template = super.getTemplateElement();
        const content = template.content;
        const svgElement = content.firstChild;
        content.removeChild(svgElement);
        (0, $ixdbG.reparentNodes)(content, svgElement.firstChild);
        return template;
    }
}

});



parcelRegister("cFPH9", function(module, exports) {

$parcel$export(module.exports, "render", () => $93a169e6b1b2706d$export$b3890eb0ae9dca99);
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */ 
var $ixdbG = parcelRequire("ixdbG");

var $3jJxF = parcelRequire("3jJxF");

var $jZRBD = parcelRequire("jZRBD");
const $93a169e6b1b2706d$export$6e2410c1d27f06e7 = new WeakMap();
const $93a169e6b1b2706d$export$b3890eb0ae9dca99 = (result, container, options)=>{
    let part = $93a169e6b1b2706d$export$6e2410c1d27f06e7.get(container);
    if (part === undefined) {
        (0, $ixdbG.removeNodes)(container, container.firstChild);
        $93a169e6b1b2706d$export$6e2410c1d27f06e7.set(container, part = new (0, $3jJxF.NodePart)(Object.assign({
            templateFactory: $jZRBD.templateFactory
        }, options)));
        part.appendInto(container);
    }
    part.setValue(result);
    part.commit();
};

});
parcelRegister("jZRBD", function(module, exports) {

$parcel$export(module.exports, "templateFactory", () => $e8ed4be282ddce9c$export$ac8809ff023de002);
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */ 
var $8AGqo = parcelRequire("8AGqo");
function $e8ed4be282ddce9c$export$ac8809ff023de002(result) {
    let templateCache = $e8ed4be282ddce9c$export$f4a9a5e9f571ddee.get(result.type);
    if (templateCache === undefined) {
        templateCache = {
            stringsArray: new WeakMap(),
            keyString: new Map()
        };
        $e8ed4be282ddce9c$export$f4a9a5e9f571ddee.set(result.type, templateCache);
    }
    let template = templateCache.stringsArray.get(result.strings);
    if (template !== undefined) return template;
    // If the TemplateStringsArray is new, generate a key from the strings
    // This key is shared between all templates with identical content
    const key = result.strings.join((0, $8AGqo.marker));
    // Check if we already have a Template for this key
    template = templateCache.keyString.get(key);
    if (template === undefined) {
        // If we have not seen this key before, create a new Template
        template = new (0, $8AGqo.Template)(result, result.getTemplateElement());
        // Cache the Template for this key
        templateCache.keyString.set(key, template);
    }
    // Cache all future queries for this TemplateStringsArray
    templateCache.stringsArray.set(result.strings, template);
    return template;
}
const $e8ed4be282ddce9c$export$f4a9a5e9f571ddee = new Map();

});



parcelRegister("fcmEp", function(module, exports) {

/*! tablesorter (FORK) - updated 2024-08-13 (v2.32.0)*/ /* Includes widgets ( storage,uitheme,columns,filter,stickyHeaders,resizable,saveSort ) */ (function(factory) {
    if (typeof define === "function" && define.amd) define([
        "jquery"
    ], factory);
    else if (typeof module.exports === "object") module.exports = factory((parcelRequire("bj2Xw")));
    else factory(jQuery);
})(function(jQuery1) {
    (function($) {
        "use strict";
        var ts = $.tablesorter = {
            version: "2.32.0",
            parsers: [],
            widgets: [],
            defaults: {
                // *** appearance
                theme: "default",
                widthFixed: false,
                showProcessing: false,
                headerTemplate: "{content}",
                onRenderTemplate: null,
                onRenderHeader: null,
                // *** functionality
                cancelSelection: true,
                tabIndex: true,
                dateFormat: "mmddyyyy",
                sortMultiSortKey: "shiftKey",
                sortResetKey: "ctrlKey",
                usNumberFormat: true,
                delayInit: false,
                serverSideSorting: false,
                resort: true,
                // *** sort options
                headers: null,
                ignoreCase: true,
                sortForce: null,
                sortList: [],
                sortAppend: null,
                sortStable: false,
                sortInitialOrder: "asc",
                sortLocaleCompare: false,
                sortReset: false,
                sortRestart: false,
                emptyTo: "bottom",
                stringTo: "max",
                duplicateSpan: true,
                textExtraction: "basic",
                textAttribute: "data-text",
                textSorter: null,
                numberSorter: null,
                // *** widget options
                initWidgets: true,
                widgetClass: "widget-{name}",
                widgets: [],
                widgetOptions: {
                    zebra: [
                        "even",
                        "odd"
                    ] // zebra widget alternating row class names
                },
                // *** callbacks
                initialized: null,
                // *** extra css class names
                tableClass: "",
                cssAsc: "",
                cssDesc: "",
                cssNone: "",
                cssHeader: "",
                cssHeaderRow: "",
                cssProcessing: "",
                cssChildRow: "tablesorter-childRow",
                cssInfoBlock: "tablesorter-infoOnly",
                cssNoSort: "tablesorter-noSort",
                cssIgnoreRow: "tablesorter-ignoreRow",
                cssIcon: "tablesorter-icon",
                cssIconNone: "",
                cssIconAsc: "",
                cssIconDesc: "",
                cssIconDisabled: "",
                // *** events
                pointerClick: "click",
                pointerDown: "mousedown",
                pointerUp: "mouseup",
                // *** selectors
                selectorHeaders: "> thead th, > thead td",
                selectorSort: "th, td",
                selectorRemove: ".remove-me",
                // *** advanced
                debug: false,
                // *** Internal variables
                headerList: [],
                empties: {},
                strings: {},
                parsers: [],
                // *** parser options for validator; values must be falsy!
                globalize: 0,
                imgAttr: 0
            },
            // internal css classes - these will ALWAYS be added to
            // the table and MUST only contain one class name - fixes #381
            css: {
                table: "tablesorter",
                cssHasChild: "tablesorter-hasChildRow",
                childRow: "tablesorter-childRow",
                colgroup: "tablesorter-colgroup",
                header: "tablesorter-header",
                headerRow: "tablesorter-headerRow",
                headerIn: "tablesorter-header-inner",
                icon: "tablesorter-icon",
                processing: "tablesorter-processing",
                sortAsc: "tablesorter-headerAsc",
                sortDesc: "tablesorter-headerDesc",
                sortNone: "tablesorter-headerUnSorted"
            },
            // labels applied to sortable headers for accessibility (aria) support
            language: {
                sortAsc: "Ascending sort applied, ",
                sortDesc: "Descending sort applied, ",
                sortNone: "No sort applied, ",
                sortDisabled: "sorting is disabled",
                nextAsc: "activate to apply an ascending sort",
                nextDesc: "activate to apply a descending sort",
                nextNone: "activate to remove the sort"
            },
            regex: {
                templateContent: /\{content\}/g,
                templateIcon: /\{icon\}/g,
                templateName: /\{name\}/i,
                spaces: /\s+/g,
                nonWord: /\W/g,
                formElements: /(input|select|button|textarea)/i,
                // *** sort functions ***
                // regex used in natural sort
                // chunk/tokenize numbers & letters
                chunk: /(^([+\-]?(?:\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?)?$|^0x[0-9a-f]+$|\d+)/gi,
                // replace chunks @ ends
                chunks: /(^\\0|\\0$)/,
                hex: /^0x[0-9a-f]+$/i,
                // *** formatFloat ***
                comma: /,/g,
                digitNonUS: /[\s|\.]/g,
                digitNegativeTest: /^\s*\([.\d]+\)/,
                digitNegativeReplace: /^\s*\(([.\d]+)\)/,
                // *** isDigit ***
                digitTest: /^[\-+(]?\d+[)]?$/,
                digitReplace: /[,.'"\s]/g
            },
            // digit sort, text location
            string: {
                max: 1,
                min: -1,
                emptymin: 1,
                emptymax: -1,
                zero: 0,
                none: 0,
                "null": 0,
                top: true,
                bottom: false
            },
            keyCodes: {
                enter: 13
            },
            // placeholder date parser data (globalize)
            dates: {},
            // These methods can be applied on table.config instance
            instanceMethods: {},
            /*
		▄█████ ██████ ██████ ██  ██ █████▄
		▀█▄    ██▄▄     ██   ██  ██ ██▄▄██
		   ▀█▄ ██▀▀     ██   ██  ██ ██▀▀▀
		█████▀ ██████   ██   ▀████▀ ██
		*/ setup: function(table, c) {
                // if no thead or tbody, or tablesorter is already present, quit
                if (!table || !table.tHead || table.tBodies.length === 0 || table.hasInitialized === true) {
                    if (ts.debug(c, "core")) {
                        if (table.hasInitialized) console.warn("Stopping initialization. Tablesorter has already been initialized");
                        else console.error("Stopping initialization! No table, thead or tbody", table);
                    }
                    return;
                }
                var tmp = "", $table = $(table), meta = $.metadata;
                // initialization flag
                table.hasInitialized = false;
                // table is being processed flag
                table.isProcessing = true;
                // make sure to store the config object
                table.config = c;
                // save the settings where they read
                $.data(table, "tablesorter", c);
                if (ts.debug(c, "core")) {
                    console[console.group ? "group" : "log"]("Initializing tablesorter v" + ts.version);
                    $.data(table, "startoveralltimer", new Date());
                }
                // removing this in version 3 (only supports jQuery 1.7+)
                c.supportsDataObject = function(version) {
                    version[0] = parseInt(version[0], 10);
                    return version[0] > 1 || version[0] === 1 && parseInt(version[1], 10) >= 4;
                }($.fn.jquery.split("."));
                // ensure case insensitivity
                c.emptyTo = c.emptyTo.toLowerCase();
                c.stringTo = c.stringTo.toLowerCase();
                c.last = {
                    sortList: [],
                    clickedIndex: -1
                };
                // add table theme class only if there isn't already one there
                if (!/tablesorter\-/.test($table.attr("class"))) tmp = c.theme !== "" ? " tablesorter-" + c.theme : "";
                // give the table a unique id, which will be used in namespace binding
                if (!c.namespace) c.namespace = ".tablesorter" + Math.random().toString(16).slice(2);
                else // make sure namespace starts with a period & doesn't have weird characters
                c.namespace = "." + c.namespace.replace(ts.regex.nonWord, "");
                c.table = table;
                c.$table = $table// add namespace to table to allow bindings on extra elements to target
                // the parent table (e.g. parser-input-select)
                .addClass(ts.css.table + " " + c.tableClass + tmp + " " + c.namespace.slice(1)).attr("role", "grid");
                c.$headers = $table.find(c.selectorHeaders);
                c.$table.children().children("tr").attr("role", "row");
                c.$tbodies = $table.children("tbody:not(." + c.cssInfoBlock + ")").attr({
                    "aria-live": "polite",
                    "aria-relevant": "all"
                });
                if (c.$table.children("caption").length) {
                    tmp = c.$table.children("caption")[0];
                    if (!tmp.id) tmp.id = c.namespace.slice(1) + "caption";
                    c.$table.attr("aria-labelledby", tmp.id);
                }
                c.widgetInit = {}; // keep a list of initialized widgets
                // change textExtraction via data-attribute
                c.textExtraction = c.$table.attr("data-text-extraction") || c.textExtraction || "basic";
                // build headers
                ts.buildHeaders(c);
                // fixate columns if the users supplies the fixedWidth option
                // do this after theme has been applied
                ts.fixColumnWidth(table);
                // add widgets from class name
                ts.addWidgetFromClass(table);
                // add widget options before parsing (e.g. grouping widget has parser settings)
                ts.applyWidgetOptions(table);
                // try to auto detect column type, and store in tables config
                ts.setupParsers(c);
                // start total row count at zero
                c.totalRows = 0;
                // only validate options while debugging. See #1528
                if (c.debug) ts.validateOptions(c);
                // build the cache for the tbody cells
                // delayInit will delay building the cache until the user starts a sort
                if (!c.delayInit) ts.buildCache(c);
                // bind all header events and methods
                ts.bindEvents(table, c.$headers, true);
                ts.bindMethods(c);
                // get sort list from jQuery data or metadata
                // in jQuery < 1.4, an error occurs when calling $table.data()
                if (c.supportsDataObject && typeof $table.data().sortlist !== "undefined") c.sortList = $table.data().sortlist;
                else if (meta && $table.metadata() && $table.metadata().sortlist) c.sortList = $table.metadata().sortlist;
                // apply widget init code
                ts.applyWidget(table, true);
                // if user has supplied a sort list to constructor
                if (c.sortList.length > 0) {
                    // save sortList before any sortAppend is added
                    c.last.sortList = c.sortList;
                    ts.sortOn(c, c.sortList, {}, !c.initWidgets);
                } else {
                    ts.setHeadersCss(c);
                    if (c.initWidgets) // apply widget format
                    ts.applyWidget(table, false);
                }
                // show processesing icon
                if (c.showProcessing) $table.unbind("sortBegin" + c.namespace + " sortEnd" + c.namespace).bind("sortBegin" + c.namespace + " sortEnd" + c.namespace, function(e) {
                    clearTimeout(c.timerProcessing);
                    ts.isProcessing(table);
                    if (e.type === "sortBegin") c.timerProcessing = setTimeout(function() {
                        ts.isProcessing(table, true);
                    }, 500);
                });
                // initialized
                table.hasInitialized = true;
                table.isProcessing = false;
                if (ts.debug(c, "core")) {
                    console.log("Overall initialization time:" + ts.benchmark($.data(table, "startoveralltimer")));
                    if (ts.debug(c, "core") && console.groupEnd) console.groupEnd();
                }
                $table.triggerHandler("tablesorter-initialized", table);
                if (typeof c.initialized === "function") c.initialized(table);
            },
            bindMethods: function(c) {
                var $table = c.$table, namespace = c.namespace, events = "sortReset update updateRows updateAll updateHeaders addRows updateCell updateComplete sorton appendCache updateCache applyWidgetId applyWidgets refreshWidgets destroy mouseup mouseleave ".split(" ").join(namespace + " ");
                // apply easy methods that trigger bound events
                $table.unbind(events.replace(ts.regex.spaces, " ")).bind("sortReset" + namespace, function(e, callback) {
                    e.stopPropagation();
                    // using this.config to ensure functions are getting a non-cached version of the config
                    ts.sortReset(this.config, function(table) {
                        if (table.isApplyingWidgets) // multiple triggers in a row... filterReset, then sortReset - see #1361
                        // wait to update widgets
                        setTimeout(function() {
                            ts.applyWidget(table, "", callback);
                        }, 100);
                        else ts.applyWidget(table, "", callback);
                    });
                }).bind("updateAll" + namespace, function(e, resort, callback) {
                    e.stopPropagation();
                    ts.updateAll(this.config, resort, callback);
                }).bind("update" + namespace + " updateRows" + namespace, function(e, resort, callback) {
                    e.stopPropagation();
                    ts.update(this.config, resort, callback);
                }).bind("updateHeaders" + namespace, function(e, callback) {
                    e.stopPropagation();
                    ts.updateHeaders(this.config, callback);
                }).bind("updateCell" + namespace, function(e, cell, resort, callback) {
                    e.stopPropagation();
                    ts.updateCell(this.config, cell, resort, callback);
                }).bind("addRows" + namespace, function(e, $row, resort, callback) {
                    e.stopPropagation();
                    ts.addRows(this.config, $row, resort, callback);
                }).bind("updateComplete" + namespace, function() {
                    this.isUpdating = false;
                }).bind("sorton" + namespace, function(e, list, callback, init) {
                    e.stopPropagation();
                    ts.sortOn(this.config, list, callback, init);
                }).bind("appendCache" + namespace, function(e, callback, init) {
                    e.stopPropagation();
                    ts.appendCache(this.config, init);
                    if ($.isFunction(callback)) callback(this);
                })// $tbodies variable is used by the tbody sorting widget
                .bind("updateCache" + namespace, function(e, callback, $tbodies) {
                    e.stopPropagation();
                    ts.updateCache(this.config, callback, $tbodies);
                }).bind("applyWidgetId" + namespace, function(e, id) {
                    e.stopPropagation();
                    ts.applyWidgetId(this, id);
                }).bind("applyWidgets" + namespace, function(e, callback) {
                    e.stopPropagation();
                    // apply widgets (false = not initializing)
                    ts.applyWidget(this, false, callback);
                }).bind("refreshWidgets" + namespace, function(e, all, dontapply) {
                    e.stopPropagation();
                    ts.refreshWidgets(this, all, dontapply);
                }).bind("removeWidget" + namespace, function(e, name, refreshing) {
                    e.stopPropagation();
                    ts.removeWidget(this, name, refreshing);
                }).bind("destroy" + namespace, function(e, removeClasses, callback) {
                    e.stopPropagation();
                    ts.destroy(this, removeClasses, callback);
                }).bind("resetToLoadState" + namespace, function(e) {
                    e.stopPropagation();
                    // remove all widgets
                    ts.removeWidget(this, true, false);
                    var tmp = $.extend(true, {}, c.originalSettings);
                    // restore original settings; this clears out current settings, but does not clear
                    // values saved to storage.
                    c = $.extend(true, {}, ts.defaults, tmp);
                    c.originalSettings = tmp;
                    this.hasInitialized = false;
                    // setup the entire table again
                    ts.setup(this, c);
                });
            },
            bindEvents: function(table, $headers, core) {
                table = $(table)[0];
                var tmp, c = table.config, namespace = c.namespace, downTarget = null;
                if (core !== true) {
                    $headers.addClass(namespace.slice(1) + "_extra_headers");
                    tmp = ts.getClosest($headers, "table");
                    if (tmp.length && tmp[0].nodeName === "TABLE" && tmp[0] !== table) $(tmp[0]).addClass(namespace.slice(1) + "_extra_table");
                }
                tmp = (c.pointerDown + " " + c.pointerUp + " " + c.pointerClick + " sort keyup ").replace(ts.regex.spaces, " ").split(" ").join(namespace + " ");
                // apply event handling to headers and/or additional headers (stickyheaders, scroller, etc)
                $headers// http://stackoverflow.com/questions/5312849/jquery-find-self;
                .find(c.selectorSort).add($headers.filter(c.selectorSort)).unbind(tmp).bind(tmp, function(e, external) {
                    var $cell, cell, temp, $target = $(e.target), // wrap event type in spaces, so the match doesn't trigger on inner words
                    type = " " + e.type + " ";
                    // only recognize left clicks
                    if ((e.which || e.button) !== 1 && !type.match(" " + c.pointerClick + " | sort | keyup ") || // allow pressing enter
                    type === " keyup " && e.which !== ts.keyCodes.enter || // allow triggering a click event (e.which is undefined) & ignore physical clicks
                    type.match(" " + c.pointerClick + " ") && typeof e.which !== "undefined") return;
                    // ignore mouseup if mousedown wasn't on the same target
                    if (type.match(" " + c.pointerUp + " ") && downTarget !== e.target && external !== true) return;
                    // set target on mousedown
                    if (type.match(" " + c.pointerDown + " ")) {
                        downTarget = e.target;
                        // preventDefault needed or jQuery v1.3.2 and older throws an
                        // "Uncaught TypeError: handler.apply is not a function" error
                        temp = $target.jquery.split(".");
                        if (temp[0] === "1" && temp[1] < 4) e.preventDefault();
                        return;
                    }
                    downTarget = null;
                    $cell = ts.getClosest($(this), "." + ts.css.header);
                    // prevent sort being triggered on form elements
                    if (ts.regex.formElements.test(e.target.nodeName) || // nosort class name, or elements within a nosort container
                    $target.hasClass(c.cssNoSort) || $target.parents("." + c.cssNoSort).length > 0 || // disabled cell directly clicked
                    $cell.hasClass("sorter-false") || // elements within a button
                    $target.parents("button").length > 0) return !c.cancelSelection;
                    if (c.delayInit && ts.isEmptyObject(c.cache)) ts.buildCache(c);
                    // use column index from data-attribute or index of current row; fixes #1116
                    c.last.clickedIndex = $cell.attr("data-column") || $cell.index();
                    cell = c.$headerIndexed[c.last.clickedIndex][0];
                    if (cell && !cell.sortDisabled) ts.initSort(c, cell, e);
                });
                if (c.cancelSelection) // cancel selection
                $headers.attr("unselectable", "on").bind("selectstart", false).css({
                    "user-select": "none",
                    "MozUserSelect": "none" // not needed for jQuery 1.8+
                });
            },
            buildHeaders: function(c) {
                var $temp, icon, timer, indx;
                c.headerList = [];
                c.headerContent = [];
                c.sortVars = [];
                if (ts.debug(c, "core")) timer = new Date();
                // children tr in tfoot - see issue #196 & #547
                // don't pass table.config to computeColumnIndex here - widgets (math) pass it to "quickly" index tbody cells
                c.columns = ts.computeColumnIndex(c.$table.children("thead, tfoot").children("tr"));
                // add icon if cssIcon option exists
                icon = c.cssIcon ? '<i class="' + (c.cssIcon === ts.css.icon ? ts.css.icon : c.cssIcon + " " + ts.css.icon) + '"></i>' : "";
                // redefine c.$headers here in case of an updateAll that replaces or adds an entire header cell - see #683
                c.$headers = $($.map(c.$table.find(c.selectorHeaders), function(elem, index) {
                    var configHeaders, header, column, template, tmp, $elem = $(elem);
                    // ignore cell (don't add it to c.$headers) if row has ignoreRow class
                    if (ts.getClosest($elem, "tr").hasClass(c.cssIgnoreRow)) return;
                    // transfer data-column to element if not th/td - #1459
                    if (!/(th|td)/i.test(elem.nodeName)) {
                        tmp = ts.getClosest($elem, "th, td");
                        $elem.attr("data-column", tmp.attr("data-column"));
                    }
                    // make sure to get header cell & not column indexed cell
                    configHeaders = ts.getColumnData(c.table, c.headers, index, true);
                    // save original header content
                    c.headerContent[index] = $elem.html();
                    // if headerTemplate is empty, don't reformat the header cell
                    if (c.headerTemplate !== "" && !$elem.find("." + ts.css.headerIn).length) {
                        // set up header template
                        template = c.headerTemplate.replace(ts.regex.templateContent, $elem.html()).replace(ts.regex.templateIcon, $elem.find("." + ts.css.icon).length ? "" : icon);
                        if (c.onRenderTemplate) {
                            header = c.onRenderTemplate.apply($elem, [
                                index,
                                template
                            ]);
                            // only change t if something is returned
                            if (header && typeof header === "string") template = header;
                        }
                        $elem.html('<div class="' + ts.css.headerIn + '">' + template + "</div>"); // faster than wrapInner
                    }
                    if (c.onRenderHeader) c.onRenderHeader.apply($elem, [
                        index,
                        c,
                        c.$table
                    ]);
                    column = parseInt($elem.attr("data-column"), 10);
                    elem.column = column;
                    tmp = ts.getOrder(ts.getData($elem, configHeaders, "sortInitialOrder") || c.sortInitialOrder);
                    // this may get updated numerous times if there are multiple rows
                    c.sortVars[column] = {
                        count: -1,
                        order: tmp ? c.sortReset ? [
                            1,
                            0,
                            2
                        ] : [
                            1,
                            0
                        ] : c.sortReset ? [
                            0,
                            1,
                            2
                        ] : [
                            0,
                            1
                        ],
                        lockedOrder: false,
                        sortedBy: ""
                    };
                    tmp = ts.getData($elem, configHeaders, "lockedOrder") || false;
                    if (typeof tmp !== "undefined" && tmp !== false) {
                        c.sortVars[column].lockedOrder = true;
                        c.sortVars[column].order = ts.getOrder(tmp) ? [
                            1,
                            1
                        ] : [
                            0,
                            0
                        ];
                    }
                    // add cell to headerList
                    c.headerList[index] = elem;
                    $elem.addClass(ts.css.header + " " + c.cssHeader);
                    // add to parent in case there are multiple rows
                    ts.getClosest($elem, "tr").addClass(ts.css.headerRow + " " + c.cssHeaderRow).attr("role", "row");
                    // allow keyboard cursor to focus on element
                    if (c.tabIndex) $elem.attr("tabindex", 0);
                    return elem;
                }));
                // cache headers per column
                c.$headerIndexed = [];
                for(indx = 0; indx < c.columns; indx++){
                    // colspan in header making a column undefined
                    if (ts.isEmptyObject(c.sortVars[indx])) c.sortVars[indx] = {};
                    // Use c.$headers.parent() in case selectorHeaders doesn't point to the th/td
                    $temp = c.$headers.filter('[data-column="' + indx + '"]');
                    // target sortable column cells, unless there are none, then use non-sortable cells
                    // .last() added in jQuery 1.4; use .filter(':last') to maintain compatibility with jQuery v1.2.6
                    c.$headerIndexed[indx] = $temp.length ? $temp.not(".sorter-false").length ? $temp.not(".sorter-false").filter(":last") : $temp.filter(":last") : $();
                }
                c.$table.find(c.selectorHeaders).attr({
                    scope: "col",
                    role: "columnheader"
                });
                // enable/disable sorting
                ts.updateHeader(c);
                if (ts.debug(c, "core")) {
                    console.log("Built headers:" + ts.benchmark(timer));
                    console.log(c.$headers);
                }
            },
            // Use it to add a set of methods to table.config which will be available for all tables.
            // This should be done before table initialization
            addInstanceMethods: function(methods) {
                $.extend(ts.instanceMethods, methods);
            },
            /*
		█████▄ ▄████▄ █████▄ ▄█████ ██████ █████▄ ▄█████
		██▄▄██ ██▄▄██ ██▄▄██ ▀█▄    ██▄▄   ██▄▄██ ▀█▄
		██▀▀▀  ██▀▀██ ██▀██     ▀█▄ ██▀▀   ██▀██     ▀█▄
		██     ██  ██ ██  ██ █████▀ ██████ ██  ██ █████▀
		*/ setupParsers: function(c, $tbodies) {
                var rows, list, span, max, colIndex, indx, header, configHeaders, noParser, parser, extractor, time, tbody, len, table = c.table, tbodyIndex = 0, debug = ts.debug(c, "core"), debugOutput = {};
                // update table bodies in case we start with an empty table
                c.$tbodies = c.$table.children("tbody:not(." + c.cssInfoBlock + ")");
                tbody = typeof $tbodies === "undefined" ? c.$tbodies : $tbodies;
                len = tbody.length;
                if (len === 0) return debug ? console.warn("Warning: *Empty table!* Not building a parser cache") : "";
                else if (debug) {
                    time = new Date();
                    console[console.group ? "group" : "log"]("Detecting parsers for each column");
                }
                list = {
                    extractors: [],
                    parsers: []
                };
                while(tbodyIndex < len){
                    rows = tbody[tbodyIndex].rows;
                    if (rows.length) {
                        colIndex = 0;
                        max = c.columns;
                        for(indx = 0; indx < max; indx++){
                            header = c.$headerIndexed[colIndex];
                            if (header && header.length) {
                                // get column indexed table cell; adding true parameter fixes #1362 but
                                // it would break backwards compatibility...
                                configHeaders = ts.getColumnData(table, c.headers, colIndex); // , true );
                                // get column parser/extractor
                                extractor = ts.getParserById(ts.getData(header, configHeaders, "extractor"));
                                parser = ts.getParserById(ts.getData(header, configHeaders, "sorter"));
                                noParser = ts.getData(header, configHeaders, "parser") === "false";
                                // empty cells behaviour - keeping emptyToBottom for backwards compatibility
                                c.empties[colIndex] = (ts.getData(header, configHeaders, "empty") || c.emptyTo || (c.emptyToBottom ? "bottom" : "top")).toLowerCase();
                                // text strings behaviour in numerical sorts
                                c.strings[colIndex] = (ts.getData(header, configHeaders, "string") || c.stringTo || "max").toLowerCase();
                                if (noParser) parser = ts.getParserById("no-parser");
                                if (!extractor) // For now, maybe detect someday
                                extractor = false;
                                if (!parser) parser = ts.detectParserForColumn(c, rows, -1, colIndex);
                                if (debug) debugOutput["(" + colIndex + ") " + header.text()] = {
                                    parser: parser.id,
                                    extractor: extractor ? extractor.id : "none",
                                    string: c.strings[colIndex],
                                    empty: c.empties[colIndex]
                                };
                                list.parsers[colIndex] = parser;
                                list.extractors[colIndex] = extractor;
                                span = header[0].colSpan - 1;
                                if (span > 0) {
                                    colIndex += span;
                                    max += span;
                                    while(span + 1 > 0){
                                        // set colspan columns to use the same parsers & extractors
                                        list.parsers[colIndex - span] = parser;
                                        list.extractors[colIndex - span] = extractor;
                                        span--;
                                    }
                                }
                            }
                            colIndex++;
                        }
                    }
                    tbodyIndex += list.parsers.length ? len : 1;
                }
                if (debug) {
                    if (!ts.isEmptyObject(debugOutput)) console[console.table ? "table" : "log"](debugOutput);
                    else console.warn("  No parsers detected!");
                    console.log("Completed detecting parsers" + ts.benchmark(time));
                    if (console.groupEnd) console.groupEnd();
                }
                c.parsers = list.parsers;
                c.extractors = list.extractors;
            },
            addParser: function(parser) {
                var indx, len = ts.parsers.length, add = true;
                for(indx = 0; indx < len; indx++)if (ts.parsers[indx].id.toLowerCase() === parser.id.toLowerCase()) add = false;
                if (add) ts.parsers[ts.parsers.length] = parser;
            },
            getParserById: function(name) {
                /*jshint eqeqeq:false */ // eslint-disable-next-line eqeqeq
                if (name == "false") return false;
                var indx, len = ts.parsers.length;
                for(indx = 0; indx < len; indx++){
                    if (ts.parsers[indx].id.toLowerCase() === name.toString().toLowerCase()) return ts.parsers[indx];
                }
                return false;
            },
            detectParserForColumn: function(c, rows, rowIndex, cellIndex) {
                var cur, $node, row, indx = ts.parsers.length, node = false, nodeValue = "", debug = ts.debug(c, "core"), keepLooking = true;
                while(nodeValue === "" && keepLooking){
                    rowIndex++;
                    row = rows[rowIndex];
                    // stop looking after 50 empty rows
                    if (row && rowIndex < 50) {
                        if (row.className.indexOf(ts.cssIgnoreRow) < 0) {
                            node = rows[rowIndex].cells[cellIndex];
                            nodeValue = ts.getElementText(c, node, cellIndex);
                            $node = $(node);
                            if (debug) console.log("Checking if value was empty on row " + rowIndex + ", column: " + cellIndex + ': "' + nodeValue + '"');
                        }
                    } else keepLooking = false;
                }
                while(--indx >= 0){
                    cur = ts.parsers[indx];
                    // ignore the default text parser because it will always be true
                    if (cur && cur.id !== "text" && cur.is && cur.is(nodeValue, c.table, node, $node)) return cur;
                }
                // nothing found, return the generic parser (text)
                return ts.getParserById("text");
            },
            getElementText: function(c, node, cellIndex) {
                if (!node) return "";
                var tmp, extract = c.textExtraction || "", // node could be a jquery object
                // http://jsperf.com/jquery-vs-instanceof-jquery/2
                $node = node.jquery ? node : $(node);
                if (typeof extract === "string") {
                    // check data-attribute first when set to 'basic'; don't use node.innerText - it's really slow!
                    // http://www.kellegous.com/j/2013/02/27/innertext-vs-textcontent/
                    if (extract === "basic" && typeof (tmp = $node.attr(c.textAttribute)) !== "undefined") return $.trim(tmp);
                    return $.trim(node.textContent || $node.text());
                } else {
                    if (typeof extract === "function") return $.trim(extract($node[0], c.table, cellIndex));
                    else if (typeof (tmp = ts.getColumnData(c.table, extract, cellIndex)) === "function") return $.trim(tmp($node[0], c.table, cellIndex));
                }
                // fallback
                return $.trim($node[0].textContent || $node.text());
            },
            // centralized function to extract/parse cell contents
            getParsedText: function(c, cell, colIndex, txt) {
                if (typeof txt === "undefined") txt = ts.getElementText(c, cell, colIndex);
                // if no parser, make sure to return the txt
                var val = "" + txt, parser = c.parsers[colIndex], extractor = c.extractors[colIndex];
                if (parser) {
                    // do extract before parsing, if there is one
                    if (extractor && typeof extractor.format === "function") txt = extractor.format(txt, c.table, cell, colIndex);
                    // allow parsing if the string is empty, previously parsing would change it to zero,
                    // in case the parser needs to extract data from the table cell attributes
                    val = parser.id === "no-parser" ? "" : // make sure txt is a string (extractor may have converted it)
                    parser.format("" + txt, c.table, cell, colIndex);
                    if (c.ignoreCase && typeof val === "string") val = val.toLowerCase();
                }
                return val;
            },
            /*
		▄████▄ ▄████▄ ▄████▄ ██  ██ ██████
		██  ▀▀ ██▄▄██ ██  ▀▀ ██▄▄██ ██▄▄
		██  ▄▄ ██▀▀██ ██  ▄▄ ██▀▀██ ██▀▀
		▀████▀ ██  ██ ▀████▀ ██  ██ ██████
		*/ buildCache: function(c, callback, $tbodies) {
                var cache, val, txt, rowIndex, colIndex, tbodyIndex, $tbody, $row, cols, $cells, cell, cacheTime, totalRows, rowData, prevRowData, colMax, span, cacheIndex, hasParser, max, len, index, table = c.table, parsers = c.parsers, debug = ts.debug(c, "core");
                // update tbody variable
                c.$tbodies = c.$table.children("tbody:not(." + c.cssInfoBlock + ")");
                $tbody = typeof $tbodies === "undefined" ? c.$tbodies : $tbodies, c.cache = {};
                c.totalRows = 0;
                // if no parsers found, return - it's an empty table.
                if (!parsers) return debug ? console.warn("Warning: *Empty table!* Not building a cache") : "";
                if (debug) cacheTime = new Date();
                // processing icon
                if (c.showProcessing) ts.isProcessing(table, true);
                for(tbodyIndex = 0; tbodyIndex < $tbody.length; tbodyIndex++){
                    colMax = []; // column max value per tbody
                    cache = c.cache[tbodyIndex] = {
                        normalized: [] // array of normalized row data; last entry contains 'rowData' above
                    };
                    totalRows = $tbody[tbodyIndex] && $tbody[tbodyIndex].rows.length || 0;
                    for(rowIndex = 0; rowIndex < totalRows; ++rowIndex){
                        rowData = {
                            // order: original row order #
                            // $row : jQuery Object[]
                            child: [],
                            raw: [] // original row text
                        };
                        /** Add the table data to main data array */ $row = $($tbody[tbodyIndex].rows[rowIndex]);
                        cols = [];
                        // ignore "remove-me" rows
                        if ($row.hasClass(c.selectorRemove.slice(1))) continue;
                        // if this is a child row, add it to the last row's children and continue to the next row
                        // ignore child row class, if it is the first row
                        if ($row.hasClass(c.cssChildRow) && rowIndex !== 0) {
                            len = cache.normalized.length - 1;
                            prevRowData = cache.normalized[len][c.columns];
                            prevRowData.$row = prevRowData.$row.add($row);
                            // add 'hasChild' class name to parent row
                            if (!$row.prev().hasClass(c.cssChildRow)) $row.prev().addClass(ts.css.cssHasChild);
                            // save child row content (un-parsed!)
                            $cells = $row.children("th, td");
                            len = prevRowData.child.length;
                            prevRowData.child[len] = [];
                            // child row content does not account for colspans/rowspans; so indexing may be off
                            cacheIndex = 0;
                            max = c.columns;
                            for(colIndex = 0; colIndex < max; colIndex++){
                                cell = $cells[colIndex];
                                if (cell) {
                                    prevRowData.child[len][colIndex] = ts.getParsedText(c, cell, colIndex);
                                    span = $cells[colIndex].colSpan - 1;
                                    if (span > 0) {
                                        cacheIndex += span;
                                        max += span;
                                    }
                                }
                                cacheIndex++;
                            }
                            continue;
                        }
                        rowData.$row = $row;
                        rowData.order = rowIndex; // add original row position to rowCache
                        cacheIndex = 0;
                        max = c.columns;
                        for(colIndex = 0; colIndex < max; ++colIndex){
                            cell = $row[0].cells[colIndex];
                            if (cell && cacheIndex < c.columns) {
                                hasParser = typeof parsers[cacheIndex] !== "undefined";
                                if (!hasParser && debug) console.warn("No parser found for row: " + rowIndex + ", column: " + colIndex + '; cell containing: "' + $(cell).text() + '"; does it have a header?');
                                val = ts.getElementText(c, cell, cacheIndex);
                                rowData.raw[cacheIndex] = val; // save original row text
                                // save raw column text even if there is no parser set
                                txt = ts.getParsedText(c, cell, cacheIndex, val);
                                cols[cacheIndex] = txt;
                                if (hasParser && (parsers[cacheIndex].type || "").toLowerCase() === "numeric") // determine column max value (ignore sign)
                                colMax[cacheIndex] = Math.max(Math.abs(txt) || 0, colMax[cacheIndex] || 0);
                                // allow colSpan in tbody
                                span = cell.colSpan - 1;
                                if (span > 0) {
                                    index = 0;
                                    while(index <= span){
                                        // duplicate text (or not) to spanned columns
                                        // instead of setting duplicate span to empty string, use textExtraction to try to get a value
                                        // see http://stackoverflow.com/q/36449711/145346
                                        txt = c.duplicateSpan || index === 0 ? txt : typeof c.textExtraction !== "string" ? ts.getElementText(c, cell, cacheIndex + index) || "" : "";
                                        rowData.raw[cacheIndex + index] = txt;
                                        cols[cacheIndex + index] = txt;
                                        index++;
                                    }
                                    cacheIndex += span;
                                    max += span;
                                }
                            }
                            cacheIndex++;
                        }
                        // ensure rowData is always in the same location (after the last column)
                        cols[c.columns] = rowData;
                        cache.normalized[cache.normalized.length] = cols;
                    }
                    cache.colMax = colMax;
                    // total up rows, not including child rows
                    c.totalRows += cache.normalized.length;
                }
                if (c.showProcessing) ts.isProcessing(table); // remove processing icon
                if (debug) {
                    len = Math.min(5, c.cache[0].normalized.length);
                    console[console.group ? "group" : "log"]("Building cache for " + c.totalRows + " rows (showing " + len + " rows in log) and " + c.columns + " columns" + ts.benchmark(cacheTime));
                    val = {};
                    for(colIndex = 0; colIndex < c.columns; colIndex++)for(cacheIndex = 0; cacheIndex < len; cacheIndex++){
                        if (!val["row: " + cacheIndex]) val["row: " + cacheIndex] = {};
                        val["row: " + cacheIndex][c.$headerIndexed[colIndex].text()] = c.cache[0].normalized[cacheIndex][colIndex];
                    }
                    console[console.table ? "table" : "log"](val);
                    if (console.groupEnd) console.groupEnd();
                }
                if ($.isFunction(callback)) callback(table);
            },
            getColumnText: function(table, column, callback, rowFilter) {
                table = $(table)[0];
                var tbodyIndex, rowIndex, cache, row, tbodyLen, rowLen, raw, parsed, $cell, result, hasCallback = typeof callback === "function", allColumns = column === "all", data = {
                    raw: [],
                    parsed: [],
                    $cell: []
                }, c = table.config;
                if (ts.isEmptyObject(c)) {
                    if (ts.debug(c, "core")) console.warn("No cache found - aborting getColumnText function!");
                } else {
                    tbodyLen = c.$tbodies.length;
                    for(tbodyIndex = 0; tbodyIndex < tbodyLen; tbodyIndex++){
                        cache = c.cache[tbodyIndex].normalized;
                        rowLen = cache.length;
                        for(rowIndex = 0; rowIndex < rowLen; rowIndex++){
                            row = cache[rowIndex];
                            if (rowFilter && !row[c.columns].$row.is(rowFilter)) continue;
                            result = true;
                            parsed = allColumns ? row.slice(0, c.columns) : row[column];
                            row = row[c.columns];
                            raw = allColumns ? row.raw : row.raw[column];
                            $cell = allColumns ? row.$row.children() : row.$row.children().eq(column);
                            if (hasCallback) result = callback({
                                tbodyIndex: tbodyIndex,
                                rowIndex: rowIndex,
                                parsed: parsed,
                                raw: raw,
                                $row: row.$row,
                                $cell: $cell
                            });
                            if (result !== false) {
                                data.parsed[data.parsed.length] = parsed;
                                data.raw[data.raw.length] = raw;
                                data.$cell[data.$cell.length] = $cell;
                            }
                        }
                    }
                    // return everything
                    return data;
                }
            },
            /*
		██  ██ █████▄ █████▄ ▄████▄ ██████ ██████
		██  ██ ██▄▄██ ██  ██ ██▄▄██   ██   ██▄▄
		██  ██ ██▀▀▀  ██  ██ ██▀▀██   ██   ██▀▀
		▀████▀ ██     █████▀ ██  ██   ██   ██████
		*/ setHeadersCss: function(c) {
                var indx, column, list = c.sortList, len = list.length, none = ts.css.sortNone + " " + c.cssNone, css = [
                    ts.css.sortAsc + " " + c.cssAsc,
                    ts.css.sortDesc + " " + c.cssDesc
                ], cssIcon = [
                    c.cssIconAsc,
                    c.cssIconDesc,
                    c.cssIconNone
                ], aria = [
                    "ascending",
                    "descending"
                ], updateColumnSort = function($el, index) {
                    $el.removeClass(none).addClass(css[index]).attr("aria-sort", aria[index]).find("." + ts.css.icon).removeClass(cssIcon[2]).addClass(cssIcon[index]);
                }, // find the footer
                $extras = c.$table.find("tfoot tr").children("td, th").add($(c.namespace + "_extra_headers")).removeClass(css.join(" ")), // remove all header information
                $sorted = c.$headers.add($("thead " + c.namespace + "_extra_headers")).removeClass(css.join(" ")).addClass(none).attr("aria-sort", "none").find("." + ts.css.icon).removeClass(cssIcon.join(" ")).end();
                // add css none to all sortable headers
                $sorted.not(".sorter-false").find("." + ts.css.icon).addClass(cssIcon[2]);
                // add disabled css icon class
                if (c.cssIconDisabled) $sorted.filter(".sorter-false").find("." + ts.css.icon).addClass(c.cssIconDisabled);
                for(indx = 0; indx < len; indx++)// direction = 2 means reset!
                if (list[indx][1] !== 2) {
                    // multicolumn sorting updating - see #1005
                    // .not(function() {}) needs jQuery 1.4
                    // filter(function(i, el) {}) <- el is undefined in jQuery v1.2.6
                    $sorted = c.$headers.filter(function(i) {
                        // only include headers that are in the sortList (this includes colspans)
                        var include = true, $el = c.$headers.eq(i), col = parseInt($el.attr("data-column"), 10), end = col + ts.getClosest($el, "th, td")[0].colSpan;
                        for(; col < end; col++)include = include ? include || ts.isValueInArray(col, c.sortList) > -1 : false;
                        return include;
                    });
                    // choose the :last in case there are nested columns
                    $sorted = $sorted.not(".sorter-false").filter('[data-column="' + list[indx][0] + '"]' + (len === 1 ? ":last" : ""));
                    if ($sorted.length) {
                        for(column = 0; column < $sorted.length; column++)if (!$sorted[column].sortDisabled) updateColumnSort($sorted.eq(column), list[indx][1]);
                    }
                    // add sorted class to footer & extra headers, if they exist
                    if ($extras.length) updateColumnSort($extras.filter('[data-column="' + list[indx][0] + '"]'), list[indx][1]);
                }
                // add verbose aria labels
                len = c.$headers.length;
                for(indx = 0; indx < len; indx++)ts.setColumnAriaLabel(c, c.$headers.eq(indx));
            },
            getClosest: function($el, selector) {
                // jQuery v1.2.6 doesn't have closest()
                if ($.fn.closest) return $el.closest(selector);
                return $el.is(selector) ? $el : $el.parents(selector).filter(":first");
            },
            // nextSort (optional), lets you disable next sort text
            setColumnAriaLabel: function(c, $header, nextSort) {
                if ($header.length) {
                    var column = parseInt($header.attr("data-column"), 10), vars = c.sortVars[column], tmp = $header.hasClass(ts.css.sortAsc) ? "sortAsc" : $header.hasClass(ts.css.sortDesc) ? "sortDesc" : "sortNone", txt = $.trim($header.text()) + ": " + ts.language[tmp];
                    if ($header.hasClass("sorter-false") || nextSort === false) txt += ts.language.sortDisabled;
                    else {
                        tmp = (vars.count + 1) % vars.order.length;
                        nextSort = vars.order[tmp];
                        // if nextSort
                        txt += ts.language[nextSort === 0 ? "nextAsc" : nextSort === 1 ? "nextDesc" : "nextNone"];
                    }
                    $header.attr("aria-label", txt);
                    if (vars.sortedBy) $header.attr("data-sortedBy", vars.sortedBy);
                    else $header.removeAttr("data-sortedBy");
                }
            },
            updateHeader: function(c) {
                var index, isDisabled, $header, col, table = c.table, len = c.$headers.length;
                for(index = 0; index < len; index++){
                    $header = c.$headers.eq(index);
                    col = ts.getColumnData(table, c.headers, index, true);
                    // add 'sorter-false' class if 'parser-false' is set
                    isDisabled = ts.getData($header, col, "sorter") === "false" || ts.getData($header, col, "parser") === "false";
                    ts.setColumnSort(c, $header, isDisabled);
                }
            },
            setColumnSort: function(c, $header, isDisabled) {
                var id = c.table.id;
                $header[0].sortDisabled = isDisabled;
                $header[isDisabled ? "addClass" : "removeClass"]("sorter-false").attr("aria-disabled", "" + isDisabled);
                // disable tab index on disabled cells
                if (c.tabIndex) {
                    if (isDisabled) $header.removeAttr("tabindex");
                    else $header.attr("tabindex", "0");
                }
                // aria-controls - requires table ID
                if (id) {
                    if (isDisabled) $header.removeAttr("aria-controls");
                    else $header.attr("aria-controls", id);
                }
            },
            updateHeaderSortCount: function(c, list) {
                var col, dir, group, indx, primary, temp, val, order, sortList = list || c.sortList, len = sortList.length;
                c.sortList = [];
                for(indx = 0; indx < len; indx++){
                    val = sortList[indx];
                    // ensure all sortList values are numeric - fixes #127
                    col = parseInt(val[0], 10);
                    // prevents error if sorton array is wrong
                    if (col < c.columns) {
                        // set order if not already defined - due to colspan header without associated header cell
                        // adding this check prevents a javascript error
                        if (!c.sortVars[col].order) {
                            if (ts.getOrder(c.sortInitialOrder)) order = c.sortReset ? [
                                1,
                                0,
                                2
                            ] : [
                                1,
                                0
                            ];
                            else order = c.sortReset ? [
                                0,
                                1,
                                2
                            ] : [
                                0,
                                1
                            ];
                            c.sortVars[col].order = order;
                            c.sortVars[col].count = 0;
                        }
                        order = c.sortVars[col].order;
                        dir = ("" + val[1]).match(/^(1|d|s|o|n)/);
                        dir = dir ? dir[0] : "";
                        // 0/(a)sc (default), 1/(d)esc, (s)ame, (o)pposite, (n)ext
                        switch(dir){
                            case "1":
                            case "d":
                                dir = 1;
                                break;
                            case "s":
                                // if primary sort is set to 's', make it ascending
                                dir = primary || 0;
                                break;
                            case "o":
                                temp = order[(primary || 0) % order.length];
                                // opposite of primary column; but resets if primary resets
                                dir = temp === 0 ? 1 : temp === 1 ? 0 : 2;
                                break;
                            case "n":
                                dir = order[++c.sortVars[col].count % order.length];
                                break;
                            default:
                                dir = 0;
                                break;
                        }
                        primary = indx === 0 ? dir : primary;
                        group = [
                            col,
                            parseInt(dir, 10) || 0
                        ];
                        c.sortList[c.sortList.length] = group;
                        dir = $.inArray(group[1], order); // fixes issue #167
                        c.sortVars[col].count = dir >= 0 ? dir : group[1] % order.length;
                    }
                }
            },
            updateAll: function(c, resort, callback) {
                var table = c.table;
                table.isUpdating = true;
                ts.refreshWidgets(table, true, true);
                ts.buildHeaders(c);
                ts.bindEvents(table, c.$headers, true);
                ts.bindMethods(c);
                ts.commonUpdate(c, resort, callback);
            },
            update: function(c, resort, callback) {
                var table = c.table;
                table.isUpdating = true;
                // update sorting (if enabled/disabled)
                ts.updateHeader(c);
                ts.commonUpdate(c, resort, callback);
            },
            // simple header update - see #989
            updateHeaders: function(c, callback) {
                c.table.isUpdating = true;
                ts.buildHeaders(c);
                ts.bindEvents(c.table, c.$headers, true);
                ts.resortComplete(c, callback);
            },
            updateCell: function(c, cell, resort, callback) {
                // updateCell for child rows is a mess - we'll ignore them for now
                // eventually I'll break out the "update" row cache code to make everything consistent
                if ($(cell).closest("tr").hasClass(c.cssChildRow)) {
                    console.warn('Tablesorter Warning! "updateCell" for child row content has been disabled, use "update" instead');
                    return;
                }
                if (ts.isEmptyObject(c.cache)) {
                    // empty table, do an update instead - fixes #1099
                    ts.updateHeader(c);
                    ts.commonUpdate(c, resort, callback);
                    return;
                }
                c.table.isUpdating = true;
                c.$table.find(c.selectorRemove).remove();
                // get position from the dom
                var tmp, indx, row, icell, cache, len, $tbodies = c.$tbodies, $cell = $(cell), // update cache - format: function( s, table, cell, cellIndex )
                // no closest in jQuery v1.2.6
                tbodyIndex = $tbodies.index(ts.getClosest($cell, "tbody")), tbcache = c.cache[tbodyIndex], $row = ts.getClosest($cell, "tr");
                cell = $cell[0]; // in case cell is a jQuery object
                // tbody may not exist if update is initialized while tbody is removed for processing
                if ($tbodies.length && tbodyIndex >= 0) {
                    row = $tbodies.eq(tbodyIndex).find("tr").not("." + c.cssChildRow).index($row);
                    cache = tbcache.normalized[row];
                    len = $row[0].cells.length;
                    if (len !== c.columns) {
                        // colspan in here somewhere!
                        icell = 0;
                        tmp = false;
                        for(indx = 0; indx < len; indx++)if (!tmp && $row[0].cells[indx] !== cell) icell += $row[0].cells[indx].colSpan;
                        else tmp = true;
                    } else icell = $cell.index();
                    tmp = ts.getElementText(c, cell, icell); // raw
                    cache[c.columns].raw[icell] = tmp;
                    tmp = ts.getParsedText(c, cell, icell, tmp);
                    cache[icell] = tmp; // parsed
                    if ((c.parsers[icell].type || "").toLowerCase() === "numeric") // update column max value (ignore sign)
                    tbcache.colMax[icell] = Math.max(Math.abs(tmp) || 0, tbcache.colMax[icell] || 0);
                    tmp = resort !== "undefined" ? resort : c.resort;
                    if (tmp !== false) // widgets will be reapplied
                    ts.checkResort(c, tmp, callback);
                    else // don't reapply widgets is resort is false, just in case it causes
                    // problems with element focus
                    ts.resortComplete(c, callback);
                } else {
                    if (ts.debug(c, "core")) console.error("updateCell aborted, tbody missing or not within the indicated table");
                    c.table.isUpdating = false;
                }
            },
            addRows: function(c, $row, resort, callback) {
                var txt, val, tbodyIndex, rowIndex, rows, cellIndex, len, order, cacheIndex, rowData, cells, cell, span, // allow passing a row string if only one non-info tbody exists in the table
                valid = typeof $row === "string" && c.$tbodies.length === 1 && /<tr/.test($row || ""), table = c.table;
                if (valid) {
                    $row = $($row);
                    c.$tbodies.append($row);
                } else if (!$row || // row is a jQuery object?
                !($row instanceof $) || // row contained in the table?
                ts.getClosest($row, "table")[0] !== c.table) {
                    if (ts.debug(c, "core")) console.error("addRows method requires (1) a jQuery selector reference to rows that have already been added to the table, or (2) row HTML string to be added to a table with only one tbody");
                    return false;
                }
                table.isUpdating = true;
                if (ts.isEmptyObject(c.cache)) {
                    // empty table, do an update instead - fixes #450
                    ts.updateHeader(c);
                    ts.commonUpdate(c, resort, callback);
                } else {
                    rows = $row.filter("tr").attr("role", "row").length;
                    tbodyIndex = c.$tbodies.index($row.parents("tbody").filter(":first"));
                    // fixes adding rows to an empty table - see issue #179
                    if (!(c.parsers && c.parsers.length)) ts.setupParsers(c);
                    // add each row
                    for(rowIndex = 0; rowIndex < rows; rowIndex++){
                        cacheIndex = 0;
                        len = $row[rowIndex].cells.length;
                        order = c.cache[tbodyIndex].normalized.length;
                        cells = [];
                        rowData = {
                            child: [],
                            raw: [],
                            $row: $row.eq(rowIndex),
                            order: order
                        };
                        // add each cell
                        for(cellIndex = 0; cellIndex < len; cellIndex++){
                            cell = $row[rowIndex].cells[cellIndex];
                            txt = ts.getElementText(c, cell, cacheIndex);
                            rowData.raw[cacheIndex] = txt;
                            val = ts.getParsedText(c, cell, cacheIndex, txt);
                            cells[cacheIndex] = val;
                            if ((c.parsers[cacheIndex].type || "").toLowerCase() === "numeric") // update column max value (ignore sign)
                            c.cache[tbodyIndex].colMax[cacheIndex] = Math.max(Math.abs(val) || 0, c.cache[tbodyIndex].colMax[cacheIndex] || 0);
                            span = cell.colSpan - 1;
                            if (span > 0) cacheIndex += span;
                            cacheIndex++;
                        }
                        // add the row data to the end
                        cells[c.columns] = rowData;
                        // update cache
                        c.cache[tbodyIndex].normalized[order] = cells;
                    }
                    // resort using current settings
                    ts.checkResort(c, resort, callback);
                }
            },
            updateCache: function(c, callback, $tbodies) {
                // rebuild parsers
                if (!(c.parsers && c.parsers.length)) ts.setupParsers(c, $tbodies);
                // rebuild the cache map
                ts.buildCache(c, callback, $tbodies);
            },
            // init flag (true) used by pager plugin to prevent widget application
            // renamed from appendToTable
            appendCache: function(c, init) {
                var parsed, totalRows, $tbody, $curTbody, rowIndex, tbodyIndex, appendTime, table = c.table, $tbodies = c.$tbodies, rows = [], cache = c.cache;
                // empty table - fixes #206/#346
                if (ts.isEmptyObject(cache)) // run pager appender in case the table was just emptied
                return c.appender ? c.appender(table, rows) : table.isUpdating ? c.$table.triggerHandler("updateComplete", table) : ""; // Fixes #532
                if (ts.debug(c, "core")) appendTime = new Date();
                for(tbodyIndex = 0; tbodyIndex < $tbodies.length; tbodyIndex++){
                    $tbody = $tbodies.eq(tbodyIndex);
                    if ($tbody.length) {
                        // detach tbody for manipulation
                        $curTbody = ts.processTbody(table, $tbody, true);
                        parsed = cache[tbodyIndex].normalized;
                        totalRows = parsed.length;
                        for(rowIndex = 0; rowIndex < totalRows; rowIndex++){
                            rows[rows.length] = parsed[rowIndex][c.columns].$row;
                            // removeRows used by the pager plugin; don't render if using ajax - fixes #411
                            if (!c.appender || c.pager && !c.pager.removeRows && !c.pager.ajax) $curTbody.append(parsed[rowIndex][c.columns].$row);
                        }
                        // restore tbody
                        ts.processTbody(table, $curTbody, false);
                    }
                }
                if (c.appender) c.appender(table, rows);
                if (ts.debug(c, "core")) console.log("Rebuilt table" + ts.benchmark(appendTime));
                // apply table widgets; but not before ajax completes
                if (!init && !c.appender) ts.applyWidget(table);
                if (table.isUpdating) c.$table.triggerHandler("updateComplete", table);
            },
            commonUpdate: function(c, resort, callback) {
                // remove rows/elements before update
                c.$table.find(c.selectorRemove).remove();
                // rebuild parsers
                ts.setupParsers(c);
                // rebuild the cache map
                ts.buildCache(c);
                ts.checkResort(c, resort, callback);
            },
            /*
		▄█████ ▄████▄ █████▄ ██████ ██ █████▄ ▄████▄
		▀█▄    ██  ██ ██▄▄██   ██   ██ ██  ██ ██ ▄▄▄
		   ▀█▄ ██  ██ ██▀██    ██   ██ ██  ██ ██ ▀██
		█████▀ ▀████▀ ██  ██   ██   ██ ██  ██ ▀████▀
		*/ initSort: function(c, cell, event) {
                if (c.table.isUpdating) // let any updates complete before initializing a sort
                return setTimeout(function() {
                    ts.initSort(c, cell, event);
                }, 50);
                var arry, indx, headerIndx, dir, temp, tmp, $header, notMultiSort = !event[c.sortMultiSortKey], table = c.table, len = c.$headers.length, th = ts.getClosest($(cell), "th, td"), col = parseInt(th.attr("data-column"), 10), sortedBy = event.type === "mouseup" ? "user" : event.type, order = c.sortVars[col].order;
                th = th[0];
                // Only call sortStart if sorting is enabled
                c.$table.triggerHandler("sortStart", table);
                // get current column sort order
                tmp = (c.sortVars[col].count + 1) % order.length;
                c.sortVars[col].count = event[c.sortResetKey] ? 2 : tmp;
                // reset all sorts on non-current column - issue #30
                if (c.sortRestart) for(headerIndx = 0; headerIndx < len; headerIndx++){
                    $header = c.$headers.eq(headerIndx);
                    tmp = parseInt($header.attr("data-column"), 10);
                    // only reset counts on columns that weren't just clicked on and if not included in a multisort
                    if (col !== tmp && (notMultiSort || $header.hasClass(ts.css.sortNone))) c.sortVars[tmp].count = -1;
                }
                // user only wants to sort on one column
                if (notMultiSort) {
                    $.each(c.sortVars, function(i) {
                        c.sortVars[i].sortedBy = "";
                    });
                    // flush the sort list
                    c.sortList = [];
                    c.last.sortList = [];
                    if (c.sortForce !== null) {
                        arry = c.sortForce;
                        for(indx = 0; indx < arry.length; indx++)if (arry[indx][0] !== col) {
                            c.sortList[c.sortList.length] = arry[indx];
                            c.sortVars[arry[indx][0]].sortedBy = "sortForce";
                        }
                    }
                    // add column to sort list
                    dir = order[c.sortVars[col].count];
                    if (dir < 2) {
                        c.sortList[c.sortList.length] = [
                            col,
                            dir
                        ];
                        c.sortVars[col].sortedBy = sortedBy;
                        // add other columns if header spans across multiple
                        if (th.colSpan > 1) for(indx = 1; indx < th.colSpan; indx++){
                            c.sortList[c.sortList.length] = [
                                col + indx,
                                dir
                            ];
                            // update count on columns in colSpan
                            c.sortVars[col + indx].count = $.inArray(dir, order);
                            c.sortVars[col + indx].sortedBy = sortedBy;
                        }
                    }
                // multi column sorting
                } else {
                    // get rid of the sortAppend before adding more - fixes issue #115 & #523
                    c.sortList = $.extend([], c.last.sortList);
                    // the user has clicked on an already sorted column
                    if (ts.isValueInArray(col, c.sortList) >= 0) {
                        // reverse the sorting direction
                        c.sortVars[col].sortedBy = sortedBy;
                        for(indx = 0; indx < c.sortList.length; indx++){
                            tmp = c.sortList[indx];
                            if (tmp[0] === col) {
                                // order.count seems to be incorrect when compared to cell.count
                                tmp[1] = order[c.sortVars[col].count];
                                if (tmp[1] === 2) {
                                    c.sortList.splice(indx, 1);
                                    c.sortVars[col].count = -1;
                                }
                            }
                        }
                    } else {
                        // add column to sort list array
                        dir = order[c.sortVars[col].count];
                        c.sortVars[col].sortedBy = sortedBy;
                        if (dir < 2) {
                            c.sortList[c.sortList.length] = [
                                col,
                                dir
                            ];
                            // add other columns if header spans across multiple
                            if (th.colSpan > 1) for(indx = 1; indx < th.colSpan; indx++){
                                c.sortList[c.sortList.length] = [
                                    col + indx,
                                    dir
                                ];
                                // update count on columns in colSpan
                                c.sortVars[col + indx].count = $.inArray(dir, order);
                                c.sortVars[col + indx].sortedBy = sortedBy;
                            }
                        }
                    }
                }
                // save sort before applying sortAppend
                c.last.sortList = $.extend([], c.sortList);
                if (c.sortList.length && c.sortAppend) {
                    arry = $.isArray(c.sortAppend) ? c.sortAppend : c.sortAppend[c.sortList[0][0]];
                    if (!ts.isEmptyObject(arry)) {
                        for(indx = 0; indx < arry.length; indx++)if (arry[indx][0] !== col && ts.isValueInArray(arry[indx][0], c.sortList) < 0) {
                            dir = arry[indx][1];
                            temp = ("" + dir).match(/^(a|d|s|o|n)/);
                            if (temp) {
                                tmp = c.sortList[0][1];
                                switch(temp[0]){
                                    case "d":
                                        dir = 1;
                                        break;
                                    case "s":
                                        dir = tmp;
                                        break;
                                    case "o":
                                        dir = tmp === 0 ? 1 : 0;
                                        break;
                                    case "n":
                                        dir = (tmp + 1) % order.length;
                                        break;
                                    default:
                                        dir = 0;
                                        break;
                                }
                            }
                            c.sortList[c.sortList.length] = [
                                arry[indx][0],
                                dir
                            ];
                            c.sortVars[arry[indx][0]].sortedBy = "sortAppend";
                        }
                    }
                }
                // sortBegin event triggered immediately before the sort
                c.$table.triggerHandler("sortBegin", table);
                // setTimeout needed so the processing icon shows up
                setTimeout(function() {
                    // set css for headers
                    ts.setHeadersCss(c);
                    ts.multisort(c);
                    ts.appendCache(c);
                    c.$table.triggerHandler("sortBeforeEnd", table);
                    c.$table.triggerHandler("sortEnd", table);
                }, 1);
            },
            // sort multiple columns
            multisort: function(c) {
                var tbodyIndex, sortTime, colMax, rows, tmp, table = c.table, sorter = [], dir = 0, textSorter = c.textSorter || "", sortList = c.sortList, sortLen = sortList.length, len = c.$tbodies.length;
                if (c.serverSideSorting || ts.isEmptyObject(c.cache)) // empty table - fixes #206/#346
                return;
                if (ts.debug(c, "core")) sortTime = new Date();
                // cache textSorter to optimize speed
                if (typeof textSorter === "object") {
                    colMax = c.columns;
                    while(colMax--){
                        tmp = ts.getColumnData(table, textSorter, colMax);
                        if (typeof tmp === "function") sorter[colMax] = tmp;
                    }
                }
                for(tbodyIndex = 0; tbodyIndex < len; tbodyIndex++){
                    colMax = c.cache[tbodyIndex].colMax;
                    rows = c.cache[tbodyIndex].normalized;
                    rows.sort(function(a, b) {
                        var sortIndex, num, col, order, sort, x, y;
                        // rows is undefined here in IE, so don't use it!
                        for(sortIndex = 0; sortIndex < sortLen; sortIndex++){
                            col = sortList[sortIndex][0];
                            order = sortList[sortIndex][1];
                            // sort direction, true = asc, false = desc
                            dir = order === 0;
                            if (c.sortStable && a[col] === b[col] && sortLen === 1) return a[c.columns].order - b[c.columns].order;
                            // fallback to natural sort since it is more robust
                            num = /n/i.test(ts.getSortType(c.parsers, col));
                            if (num && c.strings[col]) {
                                // sort strings in numerical columns
                                if (typeof ts.string[c.strings[col]] === "boolean") num = (dir ? 1 : -1) * (ts.string[c.strings[col]] ? -1 : 1);
                                else num = c.strings[col] ? ts.string[c.strings[col]] || 0 : 0;
                                // fall back to built-in numeric sort
                                // var sort = $.tablesorter['sort' + s]( a[col], b[col], dir, colMax[col], table );
                                sort = c.numberSorter ? c.numberSorter(a[col], b[col], dir, colMax[col], table) : ts["sortNumeric" + (dir ? "Asc" : "Desc")](a[col], b[col], num, colMax[col], col, c);
                            } else {
                                // set a & b depending on sort direction
                                x = dir ? a : b;
                                y = dir ? b : a;
                                // text sort function
                                if (typeof textSorter === "function") // custom OVERALL text sorter
                                sort = textSorter(x[col], y[col], dir, col, table);
                                else if (typeof sorter[col] === "function") // custom text sorter for a SPECIFIC COLUMN
                                sort = sorter[col](x[col], y[col], dir, col, table);
                                else // fall back to natural sort
                                sort = ts["sortNatural" + (dir ? "Asc" : "Desc")](a[col] || "", b[col] || "", col, c);
                            }
                            if (sort) return sort;
                        }
                        return a[c.columns].order - b[c.columns].order;
                    });
                }
                if (ts.debug(c, "core")) console.log("Applying sort " + sortList.toString() + ts.benchmark(sortTime));
            },
            resortComplete: function(c, callback) {
                if (c.table.isUpdating) c.$table.triggerHandler("updateComplete", c.table);
                if ($.isFunction(callback)) callback(c.table);
            },
            checkResort: function(c, resort, callback) {
                var sortList = $.isArray(resort) ? resort : c.sortList, // if no resort parameter is passed, fallback to config.resort (true by default)
                resrt = typeof resort === "undefined" ? c.resort : resort;
                // don't try to resort if the table is still processing
                // this will catch spamming of the updateCell method
                if (resrt !== false && !c.serverSideSorting && !c.table.isProcessing) {
                    if (sortList.length) ts.sortOn(c, sortList, function() {
                        ts.resortComplete(c, callback);
                    }, true);
                    else ts.sortReset(c, function() {
                        ts.resortComplete(c, callback);
                        ts.applyWidget(c.table, false);
                    });
                } else {
                    ts.resortComplete(c, callback);
                    ts.applyWidget(c.table, false);
                }
            },
            sortOn: function(c, list, callback, init) {
                var indx, table = c.table;
                c.$table.triggerHandler("sortStart", table);
                for(indx = 0; indx < c.columns; indx++)c.sortVars[indx].sortedBy = ts.isValueInArray(indx, list) > -1 ? "sorton" : "";
                // update header count index
                ts.updateHeaderSortCount(c, list);
                // set css for headers
                ts.setHeadersCss(c);
                // fixes #346
                if (c.delayInit && ts.isEmptyObject(c.cache)) ts.buildCache(c);
                c.$table.triggerHandler("sortBegin", table);
                // sort the table and append it to the dom
                ts.multisort(c);
                ts.appendCache(c, init);
                c.$table.triggerHandler("sortBeforeEnd", table);
                c.$table.triggerHandler("sortEnd", table);
                ts.applyWidget(table);
                if ($.isFunction(callback)) callback(table);
            },
            sortReset: function(c, callback) {
                c.sortList = [];
                var indx;
                for(indx = 0; indx < c.columns; indx++){
                    c.sortVars[indx].count = -1;
                    c.sortVars[indx].sortedBy = "";
                }
                ts.setHeadersCss(c);
                ts.multisort(c);
                ts.appendCache(c);
                if ($.isFunction(callback)) callback(c.table);
            },
            getSortType: function(parsers, column) {
                return parsers && parsers[column] ? parsers[column].type || "" : "";
            },
            getOrder: function(val) {
                // look for 'd' in 'desc' order; return true
                return /^d/i.test(val) || val === 1;
            },
            // Natural sort - https://github.com/overset/javascript-natural-sort (date sorting removed)
            sortNatural: function(a, b) {
                if (a === b) return 0;
                a = (a || "").toString();
                b = (b || "").toString();
                var aNum, bNum, aFloat, bFloat, indx, max, regex = ts.regex;
                // first try and sort Hex codes
                if (regex.hex.test(b)) {
                    aNum = parseInt(a.match(regex.hex), 16);
                    bNum = parseInt(b.match(regex.hex), 16);
                    if (aNum < bNum) return -1;
                    if (aNum > bNum) return 1;
                }
                // chunk/tokenize
                aNum = a.replace(regex.chunk, "\\0$1\\0").replace(regex.chunks, "").split("\\0");
                bNum = b.replace(regex.chunk, "\\0$1\\0").replace(regex.chunks, "").split("\\0");
                max = Math.max(aNum.length, bNum.length);
                // natural sorting through split numeric strings and default strings
                for(indx = 0; indx < max; indx++){
                    // find floats not starting with '0', string or 0 if not defined
                    aFloat = isNaN(aNum[indx]) ? aNum[indx] || 0 : parseFloat(aNum[indx]) || 0;
                    bFloat = isNaN(bNum[indx]) ? bNum[indx] || 0 : parseFloat(bNum[indx]) || 0;
                    // handle numeric vs string comparison - number < string - (Kyle Adams)
                    if (isNaN(aFloat) !== isNaN(bFloat)) return isNaN(aFloat) ? 1 : -1;
                    // rely on string comparison if different types - i.e. '02' < 2 != '02' < '2'
                    if (typeof aFloat !== typeof bFloat) {
                        aFloat += "";
                        bFloat += "";
                    }
                    if (aFloat < bFloat) return -1;
                    if (aFloat > bFloat) return 1;
                }
                return 0;
            },
            sortNaturalAsc: function(a, b, col, c) {
                if (a === b) return 0;
                var empty = ts.string[c.empties[col] || c.emptyTo];
                if (a === "" && empty !== 0) return typeof empty === "boolean" ? empty ? -1 : 1 : -empty || -1;
                if (b === "" && empty !== 0) return typeof empty === "boolean" ? empty ? 1 : -1 : empty || 1;
                return ts.sortNatural(a, b);
            },
            sortNaturalDesc: function(a, b, col, c) {
                if (a === b) return 0;
                var empty = ts.string[c.empties[col] || c.emptyTo];
                if (a === "" && empty !== 0) return typeof empty === "boolean" ? empty ? -1 : 1 : empty || 1;
                if (b === "" && empty !== 0) return typeof empty === "boolean" ? empty ? 1 : -1 : -empty || -1;
                return ts.sortNatural(b, a);
            },
            // basic alphabetical sort
            sortText: function(a, b) {
                return a > b ? 1 : a < b ? -1 : 0;
            },
            // return text string value by adding up ascii value
            // so the text is somewhat sorted when using a digital sort
            // this is NOT an alphanumeric sort
            getTextValue: function(val, num, max) {
                if (max) {
                    // make sure the text value is greater than the max numerical value (max)
                    var indx, len = val ? val.length : 0, n = max + num;
                    for(indx = 0; indx < len; indx++)n += val.charCodeAt(indx);
                    return num * n;
                }
                return 0;
            },
            sortNumericAsc: function(a, b, num, max, col, c) {
                if (a === b) return 0;
                var empty = ts.string[c.empties[col] || c.emptyTo];
                if (a === "" && empty !== 0) return typeof empty === "boolean" ? empty ? -1 : 1 : -empty || -1;
                if (b === "" && empty !== 0) return typeof empty === "boolean" ? empty ? 1 : -1 : empty || 1;
                if (isNaN(a)) a = ts.getTextValue(a, num, max);
                if (isNaN(b)) b = ts.getTextValue(b, num, max);
                return a - b;
            },
            sortNumericDesc: function(a, b, num, max, col, c) {
                if (a === b) return 0;
                var empty = ts.string[c.empties[col] || c.emptyTo];
                if (a === "" && empty !== 0) return typeof empty === "boolean" ? empty ? -1 : 1 : empty || 1;
                if (b === "" && empty !== 0) return typeof empty === "boolean" ? empty ? 1 : -1 : -empty || -1;
                if (isNaN(a)) a = ts.getTextValue(a, num, max);
                if (isNaN(b)) b = ts.getTextValue(b, num, max);
                return b - a;
            },
            sortNumeric: function(a, b) {
                return a - b;
            },
            /*
		██ ██ ██ ██ █████▄ ▄████▄ ██████ ██████ ▄█████
		██ ██ ██ ██ ██  ██ ██ ▄▄▄ ██▄▄     ██   ▀█▄
		██ ██ ██ ██ ██  ██ ██ ▀██ ██▀▀     ██      ▀█▄
		███████▀ ██ █████▀ ▀████▀ ██████   ██   █████▀
		*/ addWidget: function(widget) {
                if (widget.id && !ts.isEmptyObject(ts.getWidgetById(widget.id))) console.warn('"' + widget.id + '" widget was loaded more than once!');
                ts.widgets[ts.widgets.length] = widget;
            },
            hasWidget: function($table, name) {
                $table = $($table);
                return $table.length && $table[0].config && $table[0].config.widgetInit[name] || false;
            },
            getWidgetById: function(name) {
                var indx, widget, len = ts.widgets.length;
                for(indx = 0; indx < len; indx++){
                    widget = ts.widgets[indx];
                    if (widget && widget.id && widget.id.toLowerCase() === name.toLowerCase()) return widget;
                }
            },
            applyWidgetOptions: function(table) {
                var indx, widget, wo, c = table.config, len = c.widgets.length;
                if (len) for(indx = 0; indx < len; indx++){
                    widget = ts.getWidgetById(c.widgets[indx]);
                    if (widget && widget.options) {
                        wo = $.extend(true, {}, widget.options);
                        c.widgetOptions = $.extend(true, wo, c.widgetOptions);
                        // add widgetOptions to defaults for option validator
                        $.extend(true, ts.defaults.widgetOptions, widget.options);
                    }
                }
            },
            addWidgetFromClass: function(table) {
                var len, indx, c = table.config, // look for widgets to apply from table class
                // don't match from 'ui-widget-content'; use \S instead of \w to include widgets
                // with dashes in the name, e.g. "widget-test-2" extracts out "test-2"
                regex = "^" + c.widgetClass.replace(ts.regex.templateName, "(\\S+)+") + "$", widgetClass = new RegExp(regex, "g"), // split up table class (widget id's can include dashes) - stop using match
                // otherwise only one widget gets extracted, see #1109
                widgets = (table.className || "").split(ts.regex.spaces);
                if (widgets.length) {
                    len = widgets.length;
                    for(indx = 0; indx < len; indx++)if (widgets[indx].match(widgetClass)) c.widgets[c.widgets.length] = widgets[indx].replace(widgetClass, "$1");
                }
            },
            applyWidgetId: function(table, id, init) {
                table = $(table)[0];
                var applied, time, name, c = table.config, wo = c.widgetOptions, debug = ts.debug(c, "core"), widget = ts.getWidgetById(id);
                if (widget) {
                    name = widget.id;
                    applied = false;
                    // add widget name to option list so it gets reapplied after sorting, filtering, etc
                    if ($.inArray(name, c.widgets) < 0) c.widgets[c.widgets.length] = name;
                    if (debug) time = new Date();
                    if (init || !c.widgetInit[name]) {
                        // set init flag first to prevent calling init more than once (e.g. pager)
                        c.widgetInit[name] = true;
                        if (table.hasInitialized) // don't reapply widget options on tablesorter init
                        ts.applyWidgetOptions(table);
                        if (typeof widget.init === "function") {
                            applied = true;
                            if (debug) console[console.group ? "group" : "log"]("Initializing " + name + " widget");
                            widget.init(table, widget, c, wo);
                        }
                    }
                    if (!init && typeof widget.format === "function") {
                        applied = true;
                        if (debug) console[console.group ? "group" : "log"]("Updating " + name + " widget");
                        widget.format(table, c, wo, false);
                    }
                    if (debug) {
                        if (applied) {
                            console.log("Completed " + (init ? "initializing " : "applying ") + name + " widget" + ts.benchmark(time));
                            if (console.groupEnd) console.groupEnd();
                        }
                    }
                }
            },
            applyWidget: function(table, init, callback) {
                table = $(table)[0]; // in case this is called externally
                var indx, len, names, widget, time, c = table.config, debug = ts.debug(c, "core"), widgets = [];
                // prevent numerous consecutive widget applications
                if (init !== false && table.hasInitialized && (table.isApplyingWidgets || table.isUpdating)) return;
                if (debug) time = new Date();
                ts.addWidgetFromClass(table);
                // prevent "tablesorter-ready" from firing multiple times in a row
                clearTimeout(c.timerReady);
                if (c.widgets.length) {
                    table.isApplyingWidgets = true;
                    // ensure unique widget ids
                    c.widgets = $.grep(c.widgets, function(val, index) {
                        return $.inArray(val, c.widgets) === index;
                    });
                    names = c.widgets || [];
                    len = names.length;
                    // build widget array & add priority as needed
                    for(indx = 0; indx < len; indx++){
                        widget = ts.getWidgetById(names[indx]);
                        if (widget && widget.id) {
                            // set priority to 10 if not defined
                            if (!widget.priority) widget.priority = 10;
                            widgets[indx] = widget;
                        } else if (debug) console.warn('"' + names[indx] + '" was enabled, but the widget code has not been loaded!');
                    }
                    // sort widgets by priority
                    widgets.sort(function(a, b) {
                        return a.priority < b.priority ? -1 : a.priority === b.priority ? 0 : 1;
                    });
                    // add/update selected widgets
                    len = widgets.length;
                    if (debug) console[console.group ? "group" : "log"]("Start " + (init ? "initializing" : "applying") + " widgets");
                    for(indx = 0; indx < len; indx++){
                        widget = widgets[indx];
                        if (widget && widget.id) ts.applyWidgetId(table, widget.id, init);
                    }
                    if (debug && console.groupEnd) console.groupEnd();
                }
                c.timerReady = setTimeout(function() {
                    table.isApplyingWidgets = false;
                    $.data(table, "lastWidgetApplication", new Date());
                    c.$table.triggerHandler("tablesorter-ready");
                    // callback executed on init only
                    if (!init && typeof callback === "function") callback(table);
                    if (debug) {
                        widget = c.widgets.length;
                        console.log("Completed " + (init === true ? "initializing " : "applying ") + widget + " widget" + (widget !== 1 ? "s" : "") + ts.benchmark(time));
                    }
                }, 10);
            },
            removeWidget: function(table, name, refreshing) {
                table = $(table)[0];
                var index, widget, indx, len, c = table.config;
                // if name === true, add all widgets from $.tablesorter.widgets
                if (name === true) {
                    name = [];
                    len = ts.widgets.length;
                    for(indx = 0; indx < len; indx++){
                        widget = ts.widgets[indx];
                        if (widget && widget.id) name[name.length] = widget.id;
                    }
                } else // name can be either an array of widgets names,
                // or a space/comma separated list of widget names
                name = ($.isArray(name) ? name.join(",") : name || "").toLowerCase().split(/[\s,]+/);
                len = name.length;
                for(index = 0; index < len; index++){
                    widget = ts.getWidgetById(name[index]);
                    indx = $.inArray(name[index], c.widgets);
                    // don't remove the widget from config.widget if refreshing
                    if (indx >= 0 && refreshing !== true) c.widgets.splice(indx, 1);
                    if (widget && widget.remove) {
                        if (ts.debug(c, "core")) console.log((refreshing ? "Refreshing" : "Removing") + ' "' + name[index] + '" widget');
                        widget.remove(table, c, c.widgetOptions, refreshing);
                        c.widgetInit[name[index]] = false;
                    }
                }
                c.$table.triggerHandler("widgetRemoveEnd", table);
            },
            refreshWidgets: function(table, doAll, dontapply) {
                table = $(table)[0]; // see issue #243
                var indx, widget, c = table.config, curWidgets = c.widgets, widgets = ts.widgets, len = widgets.length, list = [], callback = function(table) {
                    $(table).triggerHandler("refreshComplete");
                };
                // remove widgets not defined in config.widgets, unless doAll is true
                for(indx = 0; indx < len; indx++){
                    widget = widgets[indx];
                    if (widget && widget.id && (doAll || $.inArray(widget.id, curWidgets) < 0)) list[list.length] = widget.id;
                }
                ts.removeWidget(table, list.join(","), true);
                if (dontapply !== true) {
                    // call widget init if
                    ts.applyWidget(table, doAll || false, callback);
                    if (doAll) // apply widget format
                    ts.applyWidget(table, false, callback);
                } else callback(table);
            },
            /*
		██  ██ ██████ ██ ██     ██ ██████ ██ ██████ ▄█████
		██  ██   ██   ██ ██     ██   ██   ██ ██▄▄   ▀█▄
		██  ██   ██   ██ ██     ██   ██   ██ ██▀▀      ▀█▄
		▀████▀   ██   ██ ██████ ██   ██   ██ ██████ █████▀
		*/ benchmark: function(diff) {
                return " (" + (new Date().getTime() - diff.getTime()) + " ms)";
            },
            // deprecated ts.log
            log: function() {
                console.log(arguments);
            },
            debug: function(c, name) {
                return c && (c.debug === true || typeof c.debug === "string" && c.debug.indexOf(name) > -1);
            },
            // $.isEmptyObject from jQuery v1.4
            isEmptyObject: function(obj) {
                /*jshint forin: false */ for(var name in obj)return false;
                return true;
            },
            isValueInArray: function(column, arry) {
                var indx, len = arry && arry.length || 0;
                for(indx = 0; indx < len; indx++){
                    if (arry[indx][0] === column) return indx;
                }
                return -1;
            },
            formatFloat: function(str, table) {
                if (typeof str !== "string" || str === "") return str;
                // allow using formatFloat without a table; defaults to US number format
                var num, usFormat = table && table.config ? table.config.usNumberFormat !== false : typeof table !== "undefined" ? table : true;
                if (usFormat) // US Format - 1,234,567.89 -> 1234567.89
                str = str.replace(ts.regex.comma, "");
                else // German Format = 1.234.567,89 -> 1234567.89
                // French Format = 1 234 567,89 -> 1234567.89
                str = str.replace(ts.regex.digitNonUS, "").replace(ts.regex.comma, ".");
                if (ts.regex.digitNegativeTest.test(str)) // make (#) into a negative number -> (10) = -10
                str = str.replace(ts.regex.digitNegativeReplace, "-$1");
                num = parseFloat(str);
                // return the text instead of zero
                return isNaN(num) ? $.trim(str) : num;
            },
            isDigit: function(str) {
                // replace all unwanted chars and match
                return isNaN(str) ? ts.regex.digitTest.test(str.toString().replace(ts.regex.digitReplace, "")) : str !== "";
            },
            // computeTableHeaderCellIndexes from:
            // http://www.javascripttoolbox.com/lib/table/examples.php
            // http://www.javascripttoolbox.com/temp/table_cellindex.html
            computeColumnIndex: function($rows, c) {
                var i, j, k, l, cell, cells, rowIndex, rowSpan, colSpan, firstAvailCol, // total columns has been calculated, use it to set the matrixrow
                columns = c && c.columns || 0, matrix = [], matrixrow = new Array(columns);
                for(i = 0; i < $rows.length; i++){
                    cells = $rows[i].cells;
                    for(j = 0; j < cells.length; j++){
                        cell = cells[j];
                        rowIndex = i;
                        rowSpan = cell.rowSpan || 1;
                        colSpan = cell.colSpan || 1;
                        if (typeof matrix[rowIndex] === "undefined") matrix[rowIndex] = [];
                        // Find first available column in the first row
                        for(k = 0; k < matrix[rowIndex].length + 1; k++)if (typeof matrix[rowIndex][k] === "undefined") {
                            firstAvailCol = k;
                            break;
                        }
                        // jscs:disable disallowEmptyBlocks
                        if (columns && cell.cellIndex === firstAvailCol) ;
                        else if (cell.setAttribute) // jscs:enable disallowEmptyBlocks
                        // add data-column (setAttribute = IE8+)
                        cell.setAttribute("data-column", firstAvailCol);
                        else // remove once we drop support for IE7 - 1/12/2016
                        $(cell).attr("data-column", firstAvailCol);
                        for(k = rowIndex; k < rowIndex + rowSpan; k++){
                            if (typeof matrix[k] === "undefined") matrix[k] = [];
                            matrixrow = matrix[k];
                            for(l = firstAvailCol; l < firstAvailCol + colSpan; l++)matrixrow[l] = "x";
                        }
                    }
                }
                ts.checkColumnCount($rows, matrix, matrixrow.length);
                return matrixrow.length;
            },
            checkColumnCount: function($rows, matrix, columns) {
                // this DOES NOT report any tbody column issues, except for the math and
                // and column selector widgets
                var i, len, valid = true, cells = [];
                for(i = 0; i < matrix.length; i++)// some matrix entries are undefined when testing the footer because
                // it is using the rowIndex property
                if (matrix[i]) {
                    len = matrix[i].length;
                    if (matrix[i].length !== columns) {
                        valid = false;
                        break;
                    }
                }
                if (!valid) {
                    $rows.each(function(indx, el) {
                        var cell = el.parentElement.nodeName;
                        if (cells.indexOf(cell) < 0) cells.push(cell);
                    });
                    console.error("Invalid or incorrect number of columns in the " + cells.join(" or ") + "; expected " + columns + ", but found " + len + " columns");
                }
            },
            // automatically add a colgroup with col elements set to a percentage width
            fixColumnWidth: function(table) {
                table = $(table)[0];
                var overallWidth, percent, $tbodies, len, index, c = table.config, $colgroup = c.$table.children("colgroup");
                // remove plugin-added colgroup, in case we need to refresh the widths
                if ($colgroup.length && $colgroup.hasClass(ts.css.colgroup)) $colgroup.remove();
                if (c.widthFixed && c.$table.children("colgroup").length === 0) {
                    $colgroup = $('<colgroup class="' + ts.css.colgroup + '">');
                    overallWidth = c.$table.width();
                    // only add col for visible columns - fixes #371
                    $tbodies = c.$tbodies.find("tr:first").children(":visible");
                    len = $tbodies.length;
                    for(index = 0; index < len; index++){
                        percent = parseInt($tbodies.eq(index).width() / overallWidth * 1000, 10) / 10 + "%";
                        $colgroup.append($("<col>").css("width", percent));
                    }
                    c.$table.prepend($colgroup);
                }
            },
            // get sorter, string, empty, etc options for each column from
            // jQuery data, metadata, header option or header class name ('sorter-false')
            // priority = jQuery data > meta > headers option > header class name
            getData: function(header, configHeader, key) {
                var meta, cl4ss, val = "", $header = $(header);
                if (!$header.length) return "";
                meta = $.metadata ? $header.metadata() : false;
                cl4ss = " " + ($header.attr("class") || "");
                if (typeof $header.data(key) !== "undefined" || typeof $header.data(key.toLowerCase()) !== "undefined") // 'data-lockedOrder' is assigned to 'lockedorder'; but 'data-locked-order' is assigned to 'lockedOrder'
                // 'data-sort-initial-order' is assigned to 'sortInitialOrder'
                val += $header.data(key) || $header.data(key.toLowerCase());
                else if (meta && typeof meta[key] !== "undefined") val += meta[key];
                else if (configHeader && typeof configHeader[key] !== "undefined") val += configHeader[key];
                else if (cl4ss !== " " && cl4ss.match(" " + key + "-")) // include sorter class name 'sorter-text', etc; now works with 'sorter-my-custom-parser'
                val = cl4ss.match(new RegExp("\\s" + key + "-([\\w-]+)"))[1] || "";
                return $.trim(val);
            },
            getColumnData: function(table, obj, indx, getCell, $headers) {
                if (typeof obj !== "object" || obj === null) return obj;
                table = $(table)[0];
                var $header, key, c = table.config, $cells = $headers || c.$headers, // c.$headerIndexed is not defined initially
                $cell = c.$headerIndexed && c.$headerIndexed[indx] || $cells.find('[data-column="' + indx + '"]:last');
                if (typeof obj[indx] !== "undefined") return getCell ? obj[indx] : obj[$cells.index($cell)];
                for(key in obj)if (typeof key === "string") {
                    $header = $cell// header cell with class/id
                    .filter(key)// find elements within the header cell with cell/id
                    .add($cell.find(key));
                    if ($header.length) return obj[key];
                }
                return;
            },
            // *** Process table ***
            // add processing indicator
            isProcessing: function($table, toggle, $headers) {
                $table = $($table);
                var c = $table[0].config, // default to all headers
                $header = $headers || $table.find("." + ts.css.header);
                if (toggle) {
                    // don't use sortList if custom $headers used
                    if (typeof $headers !== "undefined" && c.sortList.length > 0) // get headers from the sortList
                    $header = $header.filter(function() {
                        // get data-column from attr to keep compatibility with jQuery 1.2.6
                        return this.sortDisabled ? false : ts.isValueInArray(parseFloat($(this).attr("data-column")), c.sortList) >= 0;
                    });
                    $table.add($header).addClass(ts.css.processing + " " + c.cssProcessing);
                } else $table.add($header).removeClass(ts.css.processing + " " + c.cssProcessing);
            },
            // detach tbody but save the position
            // don't use tbody because there are portions that look for a tbody index (updateCell)
            processTbody: function(table, $tb, getIt) {
                table = $(table)[0];
                if (getIt) {
                    table.isProcessing = true;
                    $tb.before('<colgroup class="tablesorter-savemyplace"/>');
                    return $.fn.detach ? $tb.detach() : $tb.remove();
                }
                var holdr = $(table).find("colgroup.tablesorter-savemyplace");
                $tb.insertAfter(holdr);
                holdr.remove();
                table.isProcessing = false;
            },
            clearTableBody: function(table) {
                $(table)[0].config.$tbodies.children().detach();
            },
            // used when replacing accented characters during sorting
            characterEquivalents: {
                "a": "\xe1\xe0\xe2\xe3\xe4\u0105\xe5",
                "A": "\xc1\xc0\xc2\xc3\xc4\u0104\xc5",
                "c": "\xe7\u0107\u010D",
                "C": "\xc7\u0106\u010C",
                "e": "\xe9\xe8\xea\xeb\u011B\u0119",
                "E": "\xc9\xc8\xca\xcb\u011A\u0118",
                "i": "\xed\xec\u0130\xee\xef\u0131",
                "I": "\xcd\xcc\u0130\xce\xcf",
                "o": "\xf3\xf2\xf4\xf5\xf6\u014D",
                "O": "\xd3\xd2\xd4\xd5\xd6\u014C",
                "ss": "\xdf",
                "SS": "\u1E9E",
                "u": "\xfa\xf9\xfb\xfc\u016F",
                "U": "\xda\xd9\xdb\xdc\u016E" // ÚÙÛÜŮ
            },
            replaceAccents: function(str) {
                var chr, acc = "[", eq = ts.characterEquivalents;
                if (!ts.characterRegex) {
                    ts.characterRegexArray = {};
                    for(chr in eq)if (typeof chr === "string") {
                        acc += eq[chr];
                        ts.characterRegexArray[chr] = new RegExp("[" + eq[chr] + "]", "g");
                    }
                    ts.characterRegex = new RegExp(acc + "]");
                }
                if (ts.characterRegex.test(str)) {
                    for(chr in eq)if (typeof chr === "string") str = str.replace(ts.characterRegexArray[chr], chr);
                }
                return str;
            },
            validateOptions: function(c) {
                var setting, setting2, typ, timer, // ignore options containing an array
                ignore = "headers sortForce sortList sortAppend widgets".split(" "), orig = c.originalSettings;
                if (orig) {
                    if (ts.debug(c, "core")) timer = new Date();
                    for(setting in orig){
                        typ = typeof ts.defaults[setting];
                        if (typ === "undefined") console.warn('Tablesorter Warning! "table.config.' + setting + '" option not recognized');
                        else if (typ === "object") for(setting2 in orig[setting]){
                            typ = ts.defaults[setting] && typeof ts.defaults[setting][setting2];
                            if ($.inArray(setting, ignore) < 0 && typ === "undefined") console.warn('Tablesorter Warning! "table.config.' + setting + "." + setting2 + '" option not recognized');
                        }
                    }
                    if (ts.debug(c, "core")) console.log("validate options time:" + ts.benchmark(timer));
                }
            },
            // restore headers
            restoreHeaders: function(table) {
                var index, $cell, c = $(table)[0].config, $headers = c.$table.find(c.selectorHeaders), len = $headers.length;
                // don't use c.$headers here in case header cells were swapped
                for(index = 0; index < len; index++){
                    $cell = $headers.eq(index);
                    // only restore header cells if it is wrapped
                    // because this is also used by the updateAll method
                    if ($cell.find("." + ts.css.headerIn).length) $cell.html(c.headerContent[index]);
                }
            },
            destroy: function(table, removeClasses, callback) {
                table = $(table)[0];
                if (!table.hasInitialized) return;
                // remove all widgets
                ts.removeWidget(table, true, false);
                var events, $t = $(table), c = table.config, $h = $t.find("thead:first"), $r = $h.find("tr." + ts.css.headerRow).removeClass(ts.css.headerRow + " " + c.cssHeaderRow), $f = $t.find("tfoot:first > tr").children("th, td");
                if (removeClasses === false && $.inArray("uitheme", c.widgets) >= 0) {
                    // reapply uitheme classes, in case we want to maintain appearance
                    $t.triggerHandler("applyWidgetId", [
                        "uitheme"
                    ]);
                    $t.triggerHandler("applyWidgetId", [
                        "zebra"
                    ]);
                }
                // remove widget added rows, just in case
                $h.find("tr").not($r).remove();
                // disable tablesorter - not using .unbind( namespace ) because namespacing was
                // added in jQuery v1.4.3 - see http://api.jquery.com/event.namespace/
                events = "sortReset update updateRows updateAll updateHeaders updateCell addRows updateComplete sorton appendCache updateCache applyWidgetId applyWidgets refreshWidgets removeWidget destroy mouseup mouseleave " + "keypress sortBegin sortEnd resetToLoadState ".split(" ").join(c.namespace + " ");
                $t.removeData("tablesorter").unbind(events.replace(ts.regex.spaces, " "));
                c.$headers.add($f).removeClass([
                    ts.css.header,
                    c.cssHeader,
                    c.cssAsc,
                    c.cssDesc,
                    ts.css.sortAsc,
                    ts.css.sortDesc,
                    ts.css.sortNone
                ].join(" ")).removeAttr("data-column").removeAttr("aria-label").attr("aria-disabled", "true");
                $r.find(c.selectorSort).unbind("mousedown mouseup keypress ".split(" ").join(c.namespace + " ").replace(ts.regex.spaces, " "));
                ts.restoreHeaders(table);
                $t.toggleClass(ts.css.table + " " + c.tableClass + " tablesorter-" + c.theme, removeClasses === false);
                $t.removeClass(c.namespace.slice(1));
                // clear flag in case the plugin is initialized again
                table.hasInitialized = false;
                delete table.config.cache;
                if (typeof callback === "function") callback(table);
                if (ts.debug(c, "core")) console.log("tablesorter has been removed");
            }
        };
        $.fn.tablesorter = function(settings) {
            return this.each(function() {
                var table = this, // merge & extend config options
                c = $.extend(true, {}, ts.defaults, settings, ts.instanceMethods);
                // save initial settings
                c.originalSettings = settings;
                // create a table from data (build table widget)
                if (!table.hasInitialized && ts.buildTable && this.nodeName !== "TABLE") // return the table (in case the original target is the table's container)
                ts.buildTable(table, c);
                else ts.setup(table, c);
            });
        };
        // set up debug logs
        if (!(window.console && window.console.log)) {
            // access $.tablesorter.logs for browsers that don't have a console...
            ts.logs = [];
            /*jshint -W020 */ console = {};
            console.log = console.warn = console.error = console.table = function() {
                var arg = arguments.length > 1 ? arguments : arguments[0];
                ts.logs[ts.logs.length] = {
                    date: Date.now(),
                    log: arg
                };
            };
        }
        // add default parsers
        ts.addParser({
            id: "no-parser",
            is: function() {
                return false;
            },
            format: function() {
                return "";
            },
            type: "text"
        });
        ts.addParser({
            id: "text",
            is: function() {
                return true;
            },
            format: function(str, table) {
                var c = table.config;
                if (str) {
                    str = $.trim(c.ignoreCase ? str.toLocaleLowerCase() : str);
                    str = c.sortLocaleCompare ? ts.replaceAccents(str) : str;
                }
                return str;
            },
            type: "text"
        });
        ts.regex.nondigit = /[^\w,. \-()]/g;
        ts.addParser({
            id: "digit",
            is: function(str) {
                return ts.isDigit(str);
            },
            format: function(str, table) {
                var num = ts.formatFloat((str || "").replace(ts.regex.nondigit, ""), table);
                return str && typeof num === "number" ? num : str ? $.trim(str && table.config.ignoreCase ? str.toLocaleLowerCase() : str) : str;
            },
            type: "numeric"
        });
        ts.regex.currencyReplace = /[+\-,. ]/g;
        ts.regex.currencyTest = /^\(?\d+[\u00a3$\u20ac\u00a4\u00a5\u00a2?.]|[\u00a3$\u20ac\u00a4\u00a5\u00a2?.]\d+\)?$/;
        ts.addParser({
            id: "currency",
            is: function(str) {
                str = (str || "").replace(ts.regex.currencyReplace, "");
                // test for £$€¤¥¢
                return ts.regex.currencyTest.test(str);
            },
            format: function(str, table) {
                var num = ts.formatFloat((str || "").replace(ts.regex.nondigit, ""), table);
                return str && typeof num === "number" ? num : str ? $.trim(str && table.config.ignoreCase ? str.toLocaleLowerCase() : str) : str;
            },
            type: "numeric"
        });
        // too many protocols to add them all https://en.wikipedia.org/wiki/URI_scheme
        // now, this regex can be updated before initialization
        ts.regex.urlProtocolTest = /^(https?|ftp|file):\/\//;
        ts.regex.urlProtocolReplace = /(https?|ftp|file):\/\/(www\.)?/;
        ts.addParser({
            id: "url",
            is: function(str) {
                return ts.regex.urlProtocolTest.test(str);
            },
            format: function(str) {
                return str ? $.trim(str.replace(ts.regex.urlProtocolReplace, "")) : str;
            },
            type: "text"
        });
        ts.regex.dash = /-/g;
        ts.regex.isoDate = /^\d{4}[\/\-]\d{1,2}[\/\-]\d{1,2}/;
        ts.addParser({
            id: "isoDate",
            is: function(str) {
                return ts.regex.isoDate.test(str);
            },
            format: function(str) {
                var date = str ? new Date(str.replace(ts.regex.dash, "/")) : str;
                return date instanceof Date && isFinite(date) ? date.getTime() : str;
            },
            type: "numeric"
        });
        ts.regex.percent = /%/g;
        ts.regex.percentTest = /(\d\s*?%|%\s*?\d)/;
        ts.addParser({
            id: "percent",
            is: function(str) {
                return ts.regex.percentTest.test(str) && str.length < 15;
            },
            format: function(str, table) {
                return str ? ts.formatFloat(str.replace(ts.regex.percent, ""), table) : str;
            },
            type: "numeric"
        });
        // added image parser to core v2.17.9
        ts.addParser({
            id: "image",
            is: function(str, table, node, $node) {
                return $node.find("img").length > 0;
            },
            format: function(str, table, cell) {
                return $(cell).find("img").attr(table.config.imgAttr || "alt") || str;
            },
            parsed: true,
            type: "text"
        });
        ts.regex.dateReplace = /(\S)([AP]M)$/i; // used by usLongDate & time parser
        ts.regex.usLongDateTest1 = /^[A-Z]{3,10}\.?\s+\d{1,2},?\s+(\d{4})(\s+\d{1,2}:\d{2}(:\d{2})?(\s+[AP]M)?)?$/i;
        ts.regex.usLongDateTest2 = /^\d{1,2}\s+[A-Z]{3,10}\s+\d{4}/i;
        ts.addParser({
            id: "usLongDate",
            is: function(str) {
                // two digit years are not allowed cross-browser
                // Jan 01, 2013 12:34:56 PM or 01 Jan 2013
                return ts.regex.usLongDateTest1.test(str) || ts.regex.usLongDateTest2.test(str);
            },
            format: function(str) {
                var date = str ? new Date(str.replace(ts.regex.dateReplace, "$1 $2")) : str;
                return date instanceof Date && isFinite(date) ? date.getTime() : str;
            },
            type: "numeric"
        });
        // testing for ##-##-#### or ####-##-##, so it's not perfect; time can be included
        ts.regex.shortDateTest = /(^\d{1,2}[\/\s]\d{1,2}[\/\s]\d{4})|(^\d{4}[\/\s]\d{1,2}[\/\s]\d{1,2})/;
        // escaped "-" because JSHint in Firefox was showing it as an error
        ts.regex.shortDateReplace = /[\-.,]/g;
        // XXY covers MDY & DMY formats
        ts.regex.shortDateXXY = /(\d{1,2})[\/\s](\d{1,2})[\/\s](\d{4})/;
        ts.regex.shortDateYMD = /(\d{4})[\/\s](\d{1,2})[\/\s](\d{1,2})/;
        ts.convertFormat = function(dateString, format) {
            dateString = (dateString || "").replace(ts.regex.spaces, " ").replace(ts.regex.shortDateReplace, "/");
            if (format === "mmddyyyy") dateString = dateString.replace(ts.regex.shortDateXXY, "$3/$1/$2");
            else if (format === "ddmmyyyy") dateString = dateString.replace(ts.regex.shortDateXXY, "$3/$2/$1");
            else if (format === "yyyymmdd") dateString = dateString.replace(ts.regex.shortDateYMD, "$1/$2/$3");
            var date = new Date(dateString);
            return date instanceof Date && isFinite(date) ? date.getTime() : "";
        };
        ts.addParser({
            id: "shortDate",
            is: function(str) {
                str = (str || "").replace(ts.regex.spaces, " ").replace(ts.regex.shortDateReplace, "/");
                return ts.regex.shortDateTest.test(str);
            },
            format: function(str, table, cell, cellIndex) {
                if (str) {
                    var c = table.config, $header = c.$headerIndexed[cellIndex], format = $header.length && $header.data("dateFormat") || ts.getData($header, ts.getColumnData(table, c.headers, cellIndex), "dateFormat") || c.dateFormat;
                    // save format because getData can be slow...
                    if ($header.length) $header.data("dateFormat", format);
                    return ts.convertFormat(str, format) || str;
                }
                return str;
            },
            type: "numeric"
        });
        // match 24 hour time & 12 hours time + am/pm - see http://regexr.com/3c3tk
        ts.regex.timeTest = /^(0?[1-9]|1[0-2]):([0-5]\d)(\s[AP]M)$|^((?:[01]\d|[2][0-4]):[0-5]\d)$/i;
        ts.regex.timeMatch = /(0?[1-9]|1[0-2]):([0-5]\d)(\s[AP]M)|((?:[01]\d|[2][0-4]):[0-5]\d)/i;
        ts.addParser({
            id: "time",
            is: function(str) {
                return ts.regex.timeTest.test(str);
            },
            format: function(str) {
                // isolate time... ignore month, day and year
                var temp, timePart = (str || "").match(ts.regex.timeMatch), orig = new Date(str), // no time component? default to 00:00 by leaving it out, but only if str is defined
                time = str && (timePart !== null ? timePart[0] : "00:00 AM"), date = time ? new Date("2000/01/01 " + time.replace(ts.regex.dateReplace, "$1 $2")) : time;
                if (date instanceof Date && isFinite(date)) {
                    temp = orig instanceof Date && isFinite(orig) ? orig.getTime() : 0;
                    // if original string was a valid date, add it to the decimal so the column sorts in some kind of order
                    // luckily new Date() ignores the decimals
                    return temp ? parseFloat(date.getTime() + "." + orig.getTime()) : date.getTime();
                }
                return str;
            },
            type: "numeric"
        });
        ts.addParser({
            id: "metadata",
            is: function() {
                return false;
            },
            format: function(str, table, cell) {
                var c = table.config, p = !c.parserMetadataName ? "sortValue" : c.parserMetadataName;
                return $(cell).metadata()[p];
            },
            type: "numeric"
        });
        /*
		██████ ██████ █████▄ █████▄ ▄████▄
		  ▄█▀  ██▄▄   ██▄▄██ ██▄▄██ ██▄▄██
		▄█▀    ██▀▀   ██▀▀██ ██▀▀█  ██▀▀██
		██████ ██████ █████▀ ██  ██ ██  ██
		*/ // add default widgets
        ts.addWidget({
            id: "zebra",
            priority: 90,
            format: function(table, c, wo) {
                var $visibleRows, $row, count, isEven, tbodyIndex, rowIndex, len, child = new RegExp(c.cssChildRow, "i"), $tbodies = c.$tbodies.add($(c.namespace + "_extra_table").children("tbody:not(." + c.cssInfoBlock + ")"));
                for(tbodyIndex = 0; tbodyIndex < $tbodies.length; tbodyIndex++){
                    // loop through the visible rows
                    count = 0;
                    $visibleRows = $tbodies.eq(tbodyIndex).children("tr:visible").not(c.selectorRemove);
                    len = $visibleRows.length;
                    for(rowIndex = 0; rowIndex < len; rowIndex++){
                        $row = $visibleRows.eq(rowIndex);
                        // style child rows the same way the parent row was styled
                        if (!child.test($row[0].className)) count++;
                        isEven = count % 2 === 0;
                        $row.removeClass(wo.zebra[isEven ? 1 : 0]).addClass(wo.zebra[isEven ? 0 : 1]);
                    }
                }
            },
            remove: function(table, c, wo, refreshing) {
                if (refreshing) return;
                var tbodyIndex, $tbody, $tbodies = c.$tbodies, toRemove = (wo.zebra || [
                    "even",
                    "odd"
                ]).join(" ");
                for(tbodyIndex = 0; tbodyIndex < $tbodies.length; tbodyIndex++){
                    $tbody = ts.processTbody(table, $tbodies.eq(tbodyIndex), true); // remove tbody
                    $tbody.children().removeClass(toRemove);
                    ts.processTbody(table, $tbody, false); // restore tbody
                }
            }
        });
    })(jQuery1); /*global JSON:false */ 
    (function($, window1, document1) {
        "use strict";
        var ts = $.tablesorter || {};
        // update defaults for validator; these values must be falsy!
        $.extend(true, ts.defaults, {
            fixedUrl: "",
            widgetOptions: {
                storage_fixedUrl: "",
                storage_group: "",
                storage_page: "",
                storage_storageType: "",
                storage_tableId: "",
                storage_useSessionStorage: ""
            }
        });
        // *** Store data in local storage, with a cookie fallback ***
        /* IE7 needs JSON library for JSON.stringify - (http://caniuse.com/#search=json)
	   if you need it, then include https://github.com/douglascrockford/JSON-js

	   $.parseJSON is not available is jQuery versions older than 1.4.1, using older
	   versions will only allow storing information for one page at a time

	   // *** Save data (JSON format only) ***
	   // val must be valid JSON... use http://jsonlint.com/ to ensure it is valid
	   var val = { "mywidget" : "data1" }; // valid JSON uses double quotes
	   // $.tablesorter.storage(table, key, val);
	   $.tablesorter.storage(table, 'tablesorter-mywidget', val);

	   // *** Get data: $.tablesorter.storage(table, key); ***
	   v = $.tablesorter.storage(table, 'tablesorter-mywidget');
	   // val may be empty, so also check for your data
	   val = (v && v.hasOwnProperty('mywidget')) ? v.mywidget : '';
	   alert(val); // 'data1' if saved, or '' if not
	*/ ts.storage = function(table, key, value, options) {
            table = $(table)[0];
            var cookieIndex, cookies, date, hasStorage = false, values = {}, c = table.config, wo = c && c.widgetOptions, debug = ts.debug(c, "storage"), storageType = (options && options.storageType || wo && wo.storage_storageType).toString().charAt(0).toLowerCase(), // deprecating "useSessionStorage"; any storageType setting overrides it
            session = storageType ? "" : options && options.useSessionStorage || wo && wo.storage_useSessionStorage, $table = $(table), // id from (1) options ID, (2) table 'data-table-group' attribute, (3) widgetOptions.storage_tableId,
            // (4) table ID, then (5) table index
            id = options && options.id || $table.attr(options && options.group || wo && wo.storage_group || "data-table-group") || wo && wo.storage_tableId || table.id || $(".tablesorter").index($table), // url from (1) options url, (2) table 'data-table-page' attribute, (3) widgetOptions.storage_fixedUrl,
            // (4) table.config.fixedUrl (deprecated), then (5) window location path
            url = options && options.url || $table.attr(options && options.page || wo && wo.storage_page || "data-table-page") || wo && wo.storage_fixedUrl || c && c.fixedUrl || window1.location.pathname;
            // skip if using cookies
            if (storageType !== "c") {
                storageType = storageType === "s" || session ? "sessionStorage" : "localStorage";
                // https://gist.github.com/paulirish/5558557
                if (storageType in window1) try {
                    window1[storageType].setItem("_tmptest", "temp");
                    hasStorage = true;
                    window1[storageType].removeItem("_tmptest");
                } catch (error) {
                    console.warn(storageType + " is not supported in this browser");
                }
            }
            if (debug) console.log("Storage >> Using", hasStorage ? storageType : "cookies");
            // *** get value ***
            if ($.parseJSON) {
                if (hasStorage) values = $.parseJSON(window1[storageType][key] || "null") || {};
                else {
                    // old browser, using cookies
                    cookies = document1.cookie.split(/[;\s|=]/);
                    // add one to get from the key to the value
                    cookieIndex = $.inArray(key, cookies) + 1;
                    values = cookieIndex !== 0 ? $.parseJSON(cookies[cookieIndex] || "null") || {} : {};
                }
            }
            // allow value to be an empty string too
            if (typeof value !== "undefined" && window1.JSON && JSON.hasOwnProperty("stringify")) {
                // add unique identifiers = url pathname > table ID/index on page > data
                if (!values[url]) values[url] = {};
                values[url][id] = value;
                // *** set value ***
                if (hasStorage) window1[storageType][key] = JSON.stringify(values);
                else {
                    date = new Date();
                    date.setTime(date.getTime() + 31536e+6); // 365 days
                    document1.cookie = key + "=" + JSON.stringify(values).replace(/\"/g, '"') + "; expires=" + date.toGMTString() + "; path=/";
                }
            } else return values && values[url] ? values[url][id] : "";
        };
    })(jQuery1, window, document); /*! Widget: uitheme - updated 2018-03-18 (v2.30.0) */ 
    (function($) {
        "use strict";
        var ts = $.tablesorter || {};
        ts.themes = {
            "bootstrap": {
                table: "table table-bordered table-striped",
                caption: "caption",
                // header class names
                header: "bootstrap-header",
                sortNone: "",
                sortAsc: "",
                sortDesc: "",
                active: "",
                hover: "",
                // icon class names
                icons: "",
                iconSortNone: "bootstrap-icon-unsorted",
                iconSortAsc: "glyphicon glyphicon-chevron-up",
                iconSortDesc: "glyphicon glyphicon-chevron-down",
                filterRow: "",
                footerRow: "",
                footerCells: "",
                even: "",
                odd: "" // odd row zebra striping
            },
            "jui": {
                table: "ui-widget ui-widget-content ui-corner-all",
                caption: "ui-widget-content",
                // header class names
                header: "ui-widget-header ui-corner-all ui-state-default",
                sortNone: "",
                sortAsc: "",
                sortDesc: "",
                active: "ui-state-active",
                hover: "ui-state-hover",
                // icon class names
                icons: "ui-icon",
                iconSortNone: "ui-icon-carat-2-n-s ui-icon-caret-2-n-s",
                iconSortAsc: "ui-icon-carat-1-n ui-icon-caret-1-n",
                iconSortDesc: "ui-icon-carat-1-s ui-icon-caret-1-s",
                filterRow: "",
                footerRow: "",
                footerCells: "",
                even: "ui-widget-content",
                odd: "ui-state-default" // odd row zebra striping
            }
        };
        $.extend(ts.css, {
            wrapper: "tablesorter-wrapper" // ui theme & resizable
        });
        ts.addWidget({
            id: "uitheme",
            priority: 10,
            format: function(table, c, wo) {
                var i, tmp, hdr, icon, time, $header, $icon, $tfoot, $h, oldtheme, oldremove, oldIconRmv, hasOldTheme, themesAll = ts.themes, $table = c.$table.add($(c.namespace + "_extra_table")), $headers = c.$headers.add($(c.namespace + "_extra_headers")), theme = c.theme || "jui", themes = themesAll[theme] || {}, remove = $.trim([
                    themes.sortNone,
                    themes.sortDesc,
                    themes.sortAsc,
                    themes.active
                ].join(" ")), iconRmv = $.trim([
                    themes.iconSortNone,
                    themes.iconSortDesc,
                    themes.iconSortAsc
                ].join(" ")), debug = ts.debug(c, "uitheme");
                if (debug) time = new Date();
                // initialization code - run once
                if (!$table.hasClass("tablesorter-" + theme) || c.theme !== c.appliedTheme || !wo.uitheme_applied) {
                    wo.uitheme_applied = true;
                    oldtheme = themesAll[c.appliedTheme] || {};
                    hasOldTheme = !$.isEmptyObject(oldtheme);
                    oldremove = hasOldTheme ? [
                        oldtheme.sortNone,
                        oldtheme.sortDesc,
                        oldtheme.sortAsc,
                        oldtheme.active
                    ].join(" ") : "";
                    oldIconRmv = hasOldTheme ? [
                        oldtheme.iconSortNone,
                        oldtheme.iconSortDesc,
                        oldtheme.iconSortAsc
                    ].join(" ") : "";
                    if (hasOldTheme) {
                        wo.zebra[0] = $.trim(" " + wo.zebra[0].replace(" " + oldtheme.even, ""));
                        wo.zebra[1] = $.trim(" " + wo.zebra[1].replace(" " + oldtheme.odd, ""));
                        c.$tbodies.children().removeClass([
                            oldtheme.even,
                            oldtheme.odd
                        ].join(" "));
                    }
                    // update zebra stripes
                    if (themes.even) wo.zebra[0] += " " + themes.even;
                    if (themes.odd) wo.zebra[1] += " " + themes.odd;
                    // add caption style
                    $table.children("caption").removeClass(oldtheme.caption || "").addClass(themes.caption);
                    // add table/footer class names
                    $tfoot = $table// remove other selected themes
                    .removeClass((c.appliedTheme ? "tablesorter-" + (c.appliedTheme || "") : "") + " " + (oldtheme.table || "")).addClass("tablesorter-" + theme + " " + (themes.table || "")) // add theme widget class name
                    .children("tfoot");
                    c.appliedTheme = c.theme;
                    if ($tfoot.length) $tfoot// if oldtheme.footerRow or oldtheme.footerCells are undefined, all class names are removed
                    .children("tr").removeClass(oldtheme.footerRow || "").addClass(themes.footerRow).children("th, td").removeClass(oldtheme.footerCells || "").addClass(themes.footerCells);
                    // update header classes
                    $headers.removeClass((hasOldTheme ? [
                        oldtheme.header,
                        oldtheme.hover,
                        oldremove
                    ].join(" ") : "") || "").addClass(themes.header).not(".sorter-false").unbind("mouseenter.tsuitheme mouseleave.tsuitheme").bind("mouseenter.tsuitheme mouseleave.tsuitheme", function(event) {
                        // toggleClass with switch added in jQuery 1.3
                        $(this)[event.type === "mouseenter" ? "addClass" : "removeClass"](themes.hover || "");
                    });
                    $headers.each(function() {
                        var $this = $(this);
                        if (!$this.find("." + ts.css.wrapper).length) // Firefox needs this inner div to position the icon & resizer correctly
                        $this.wrapInner('<div class="' + ts.css.wrapper + '" style="position:relative;height:100%;width:100%"></div>');
                    });
                    if (c.cssIcon) // if c.cssIcon is '', then no <i> is added to the header
                    $headers.find("." + ts.css.icon).removeClass(hasOldTheme ? [
                        oldtheme.icons,
                        oldIconRmv
                    ].join(" ") : "").addClass(themes.icons || "");
                    // filter widget initializes after uitheme
                    if (ts.hasWidget(c.table, "filter")) {
                        tmp = function() {
                            $table.children("thead").children("." + ts.css.filterRow).removeClass(hasOldTheme ? oldtheme.filterRow || "" : "").addClass(themes.filterRow || "");
                        };
                        if (wo.filter_initialized) tmp();
                        else $table.one("filterInit", function() {
                            tmp();
                        });
                    }
                }
                for(i = 0; i < c.columns; i++){
                    $header = c.$headers.add($(c.namespace + "_extra_headers")).not(".sorter-false").filter('[data-column="' + i + '"]');
                    $icon = ts.css.icon ? $header.find("." + ts.css.icon) : $();
                    $h = $headers.not(".sorter-false").filter('[data-column="' + i + '"]:last');
                    if ($h.length) {
                        $header.removeClass(remove);
                        $icon.removeClass(iconRmv);
                        if ($h[0].sortDisabled) // no sort arrows for disabled columns!
                        $icon.removeClass(themes.icons || "");
                        else {
                            hdr = themes.sortNone;
                            icon = themes.iconSortNone;
                            if ($h.hasClass(ts.css.sortAsc)) {
                                hdr = [
                                    themes.sortAsc,
                                    themes.active
                                ].join(" ");
                                icon = themes.iconSortAsc;
                            } else if ($h.hasClass(ts.css.sortDesc)) {
                                hdr = [
                                    themes.sortDesc,
                                    themes.active
                                ].join(" ");
                                icon = themes.iconSortDesc;
                            }
                            $header.addClass(hdr);
                            $icon.addClass(icon || "");
                        }
                    }
                }
                if (debug) console.log("uitheme >> Applied " + theme + " theme" + ts.benchmark(time));
            },
            remove: function(table, c, wo, refreshing) {
                if (!wo.uitheme_applied) return;
                var $table = c.$table, theme = c.appliedTheme || "jui", themes = ts.themes[theme] || ts.themes.jui, $headers = $table.children("thead").children(), remove = themes.sortNone + " " + themes.sortDesc + " " + themes.sortAsc, iconRmv = themes.iconSortNone + " " + themes.iconSortDesc + " " + themes.iconSortAsc;
                $table.removeClass("tablesorter-" + theme + " " + themes.table);
                wo.uitheme_applied = false;
                if (refreshing) return;
                $table.find(ts.css.header).removeClass(themes.header);
                $headers.unbind("mouseenter.tsuitheme mouseleave.tsuitheme") // remove hover
                .removeClass(themes.hover + " " + remove + " " + themes.active).filter("." + ts.css.filterRow).removeClass(themes.filterRow);
                $headers.find("." + ts.css.icon).removeClass(themes.icons + " " + iconRmv);
            }
        });
    })(jQuery1); /*! Widget: columns - updated 5/24/2017 (v2.28.11) */ 
    (function($) {
        "use strict";
        var ts = $.tablesorter || {};
        ts.addWidget({
            id: "columns",
            priority: 65,
            options: {
                columns: [
                    "primary",
                    "secondary",
                    "tertiary"
                ]
            },
            format: function(table, c, wo) {
                var $tbody, tbodyIndex, $rows, rows, $row, $cells, remove, indx, $table = c.$table, $tbodies = c.$tbodies, sortList = c.sortList, len = sortList.length, // removed c.widgetColumns support
                css = wo && wo.columns || [
                    "primary",
                    "secondary",
                    "tertiary"
                ], last = css.length - 1;
                remove = css.join(" ");
                // check if there is a sort (on initialization there may not be one)
                for(tbodyIndex = 0; tbodyIndex < $tbodies.length; tbodyIndex++){
                    $tbody = ts.processTbody(table, $tbodies.eq(tbodyIndex), true); // detach tbody
                    $rows = $tbody.children("tr");
                    // loop through the visible rows
                    $rows.each(function() {
                        $row = $(this);
                        if (this.style.display !== "none") {
                            // remove all columns class names
                            $cells = $row.children().removeClass(remove);
                            // add appropriate column class names
                            if (sortList && sortList[0]) {
                                // primary sort column class
                                $cells.eq(sortList[0][0]).addClass(css[0]);
                                if (len > 1) for(indx = 1; indx < len; indx++)// secondary, tertiary, etc sort column classes
                                $cells.eq(sortList[indx][0]).addClass(css[indx] || css[last]);
                            }
                        }
                    });
                    ts.processTbody(table, $tbody, false);
                }
                // add classes to thead and tfoot
                rows = wo.columns_thead !== false ? [
                    "thead tr"
                ] : [];
                if (wo.columns_tfoot !== false) rows.push("tfoot tr");
                if (rows.length) {
                    $rows = $table.find(rows.join(",")).children().removeClass(remove);
                    if (len) for(indx = 0; indx < len; indx++)// add primary. secondary, tertiary, etc sort column classes
                    $rows.filter('[data-column="' + sortList[indx][0] + '"]').addClass(css[indx] || css[last]);
                }
            },
            remove: function(table, c, wo) {
                var tbodyIndex, $tbody, $tbodies = c.$tbodies, remove = (wo.columns || [
                    "primary",
                    "secondary",
                    "tertiary"
                ]).join(" ");
                c.$headers.removeClass(remove);
                c.$table.children("tfoot").children("tr").children("th, td").removeClass(remove);
                for(tbodyIndex = 0; tbodyIndex < $tbodies.length; tbodyIndex++){
                    $tbody = ts.processTbody(table, $tbodies.eq(tbodyIndex), true); // remove tbody
                    $tbody.children("tr").each(function() {
                        $(this).children().removeClass(remove);
                    });
                    ts.processTbody(table, $tbody, false); // restore tbody
                }
            }
        });
    })(jQuery1); /*
 * Requires tablesorter v2.8+ and jQuery 1.7+
 * by Rob Garrison
 */ 
    (function($) {
        "use strict";
        var tsf, tsfRegex, ts = $.tablesorter || {}, tscss = ts.css, tskeyCodes = ts.keyCodes;
        $.extend(tscss, {
            filterRow: "tablesorter-filter-row",
            filter: "tablesorter-filter",
            filterDisabled: "disabled",
            filterRowHide: "hideme"
        });
        $.extend(tskeyCodes, {
            backSpace: 8,
            escape: 27,
            space: 32,
            left: 37,
            down: 40
        });
        ts.addWidget({
            id: "filter",
            priority: 50,
            options: {
                filter_cellFilter: "",
                filter_childRows: false,
                filter_childByColumn: false,
                filter_childWithSibs: true,
                filter_columnAnyMatch: true,
                filter_columnFilters: true,
                filter_cssFilter: "",
                filter_defaultAttrib: "data-value",
                filter_defaultFilter: {},
                filter_excludeFilter: {},
                filter_external: "",
                filter_filteredRow: "filtered",
                filter_filterLabel: 'Filter "{{label}}" column by...',
                filter_formatter: null,
                filter_functions: null,
                filter_hideEmpty: true,
                filter_hideFilters: false,
                filter_ignoreCase: true,
                filter_liveSearch: true,
                filter_matchType: {
                    "input": "exact",
                    "select": "exact"
                },
                filter_onlyAvail: "filter-onlyAvail",
                filter_placeholder: {
                    search: "",
                    select: ""
                },
                filter_reset: null,
                filter_resetOnEsc: true,
                filter_saveFilters: false,
                filter_searchDelay: 300,
                filter_searchFiltered: true,
                filter_selectSource: null,
                filter_selectSourceSeparator: "|",
                filter_serversideFiltering: false,
                filter_startsWith: false,
                filter_useParsedData: false // filter all data using parsed content
            },
            format: function(table, c, wo) {
                if (!c.$table.hasClass("hasFilters")) tsf.init(table, c, wo);
            },
            remove: function(table, c, wo, refreshing) {
                var tbodyIndex, $tbody, $table = c.$table, $tbodies = c.$tbodies, events = "addRows updateCell update updateRows updateComplete appendCache filterReset filterAndSortReset filterFomatterUpdate filterEnd search stickyHeadersInit ".split(" ").join(c.namespace + "filter ");
                $table.removeClass("hasFilters")// add filter namespace to all BUT search
                .unbind(events.replace(ts.regex.spaces, " "))// remove the filter row even if refreshing, because the column might have been moved
                .find("." + tscss.filterRow).remove();
                wo.filter_initialized = false;
                if (refreshing) return;
                for(tbodyIndex = 0; tbodyIndex < $tbodies.length; tbodyIndex++){
                    $tbody = ts.processTbody(table, $tbodies.eq(tbodyIndex), true); // remove tbody
                    $tbody.children().removeClass(wo.filter_filteredRow).show();
                    ts.processTbody(table, $tbody, false); // restore tbody
                }
                if (wo.filter_reset) $(document).undelegate(wo.filter_reset, "click" + c.namespace + "filter");
            }
        });
        tsf = ts.filter = {
            // regex used in filter 'check' functions - not for general use and not documented
            regex: {
                regex: /^\/((?:\\\/|[^\/])+)\/([migyu]{0,5})?$/,
                child: /tablesorter-childRow/,
                filtered: /filtered/,
                type: /undefined|number/,
                exact: /(^[\"\'=]+)|([\"\'=]+$)/g,
                operators: /[<>=]/g,
                query: "(q|query)",
                wild01: /\?/g,
                wild0More: /\*/g,
                quote: /\"/g,
                isNeg1: /(>=?\s*-\d)/,
                isNeg2: /(<=?\s*\d)/
            },
            // function( c, data ) { }
            // c = table.config
            // data.$row = jQuery object of the row currently being processed
            // data.$cells = jQuery object of all cells within the current row
            // data.filters = array of filters for all columns ( some may be undefined )
            // data.filter = filter for the current column
            // data.iFilter = same as data.filter, except lowercase ( if wo.filter_ignoreCase is true )
            // data.exact = table cell text ( or parsed data if column parser enabled; may be a number & not a string )
            // data.iExact = same as data.exact, except lowercase ( if wo.filter_ignoreCase is true; may be a number & not a string )
            // data.cache = table cell text from cache, so it has been parsed ( & in all lower case if c.ignoreCase is true )
            // data.cacheArray = An array of parsed content from each table cell in the row being processed
            // data.index = column index; table = table element ( DOM )
            // data.parsed = array ( by column ) of boolean values ( from filter_useParsedData or 'filter-parsed' class )
            types: {
                or: function(c, data, vars) {
                    // look for "|", but not if it is inside of a regular expression
                    if ((tsfRegex.orTest.test(data.iFilter) || tsfRegex.orSplit.test(data.filter)) && // this test for regex has potential to slow down the overall search
                    !tsfRegex.regex.test(data.filter)) {
                        var indx, filterMatched, query, regex, // duplicate data but split filter
                        data2 = $.extend({}, data), filter = data.filter.split(tsfRegex.orSplit), iFilter = data.iFilter.split(tsfRegex.orSplit), len = filter.length;
                        for(indx = 0; indx < len; indx++){
                            data2.nestedFilters = true;
                            data2.filter = "" + (tsf.parseFilter(c, filter[indx], data) || "");
                            data2.iFilter = "" + (tsf.parseFilter(c, iFilter[indx], data) || "");
                            query = "(" + (tsf.parseFilter(c, data2.filter, data) || "") + ")";
                            try {
                                // use try/catch, because query may not be a valid regex if "|" is contained within a partial regex search,
                                // e.g "/(Alex|Aar" -> Uncaught SyntaxError: Invalid regular expression: /(/(Alex)/: Unterminated group
                                regex = new RegExp(data.isMatch ? query : "^" + query + "$", c.widgetOptions.filter_ignoreCase ? "i" : "");
                                // filterMatched = data2.filter === '' && indx > 0 ? true
                                // look for an exact match with the 'or' unless the 'filter-match' class is found
                                filterMatched = regex.test(data2.exact) || tsf.processTypes(c, data2, vars);
                                if (filterMatched) return filterMatched;
                            } catch (error) {
                                return null;
                            }
                        }
                        // may be null from processing types
                        return filterMatched || false;
                    }
                    return null;
                },
                // Look for an AND or && operator ( logical and )
                and: function(c, data, vars) {
                    if (tsfRegex.andTest.test(data.filter)) {
                        var indx, filterMatched, result, query, regex, // duplicate data but split filter
                        data2 = $.extend({}, data), filter = data.filter.split(tsfRegex.andSplit), iFilter = data.iFilter.split(tsfRegex.andSplit), len = filter.length;
                        for(indx = 0; indx < len; indx++){
                            data2.nestedFilters = true;
                            data2.filter = "" + (tsf.parseFilter(c, filter[indx], data) || "");
                            data2.iFilter = "" + (tsf.parseFilter(c, iFilter[indx], data) || "");
                            query = ("(" + (tsf.parseFilter(c, data2.filter, data) || "") + ")")// replace wild cards since /(a*)/i will match anything
                            .replace(tsfRegex.wild01, "\\S{1}").replace(tsfRegex.wild0More, "\\S*");
                            try {
                                // use try/catch just in case RegExp is invalid
                                regex = new RegExp(data.isMatch ? query : "^" + query + "$", c.widgetOptions.filter_ignoreCase ? "i" : "");
                                // look for an exact match with the 'and' unless the 'filter-match' class is found
                                result = regex.test(data2.exact) || tsf.processTypes(c, data2, vars);
                                if (indx === 0) filterMatched = result;
                                else filterMatched = filterMatched && result;
                            } catch (error) {
                                return null;
                            }
                        }
                        // may be null from processing types
                        return filterMatched || false;
                    }
                    return null;
                },
                // Look for regex
                regex: function(c, data) {
                    if (tsfRegex.regex.test(data.filter)) {
                        var matches, // cache regex per column for optimal speed
                        regex = data.filter_regexCache[data.index] || tsfRegex.regex.exec(data.filter), isRegex = regex instanceof RegExp;
                        try {
                            if (!isRegex) // force case insensitive search if ignoreCase option set?
                            // if ( c.ignoreCase && !regex[2] ) { regex[2] = 'i'; }
                            data.filter_regexCache[data.index] = regex = new RegExp(regex[1], regex[2]);
                            matches = regex.test(data.exact);
                        } catch (error) {
                            matches = false;
                        }
                        return matches;
                    }
                    return null;
                },
                // Look for operators >, >=, < or <=
                operators: function(c, data) {
                    // ignore empty strings... because '' < 10 is true
                    if (tsfRegex.operTest.test(data.iFilter) && data.iExact !== "") {
                        var cachedValue, result, txt, table = c.table, parsed = data.parsed[data.index], query = ts.formatFloat(data.iFilter.replace(tsfRegex.operators, ""), table), parser = c.parsers[data.index] || {}, savedSearch = query;
                        // parse filter value in case we're comparing numbers ( dates )
                        if (parsed || parser.type === "numeric") {
                            txt = $.trim("" + data.iFilter.replace(tsfRegex.operators, ""));
                            result = tsf.parseFilter(c, txt, data, true);
                            query = typeof result === "number" && result !== "" && !isNaN(result) ? result : query;
                        }
                        // iExact may be numeric - see issue #149;
                        // check if cached is defined, because sometimes j goes out of range? ( numeric columns )
                        if ((parsed || parser.type === "numeric") && !isNaN(query) && typeof data.cache !== "undefined") cachedValue = data.cache;
                        else {
                            txt = isNaN(data.iExact) ? data.iExact.replace(ts.regex.nondigit, "") : data.iExact;
                            cachedValue = ts.formatFloat(txt, table);
                        }
                        if (tsfRegex.gtTest.test(data.iFilter)) result = tsfRegex.gteTest.test(data.iFilter) ? cachedValue >= query : cachedValue > query;
                        else if (tsfRegex.ltTest.test(data.iFilter)) result = tsfRegex.lteTest.test(data.iFilter) ? cachedValue <= query : cachedValue < query;
                        // keep showing all rows if nothing follows the operator
                        if (!result && savedSearch === "") result = true;
                        return result;
                    }
                    return null;
                },
                // Look for a not match
                notMatch: function(c, data) {
                    if (tsfRegex.notTest.test(data.iFilter)) {
                        var indx, txt = data.iFilter.replace("!", ""), filter = tsf.parseFilter(c, txt, data) || "";
                        if (tsfRegex.exact.test(filter)) {
                            // look for exact not matches - see #628
                            filter = filter.replace(tsfRegex.exact, "");
                            return filter === "" ? true : $.trim(filter) !== data.iExact;
                        } else {
                            indx = data.iExact.search($.trim(filter));
                            return filter === "" ? true : // return true if not found
                            data.anyMatch ? indx < 0 : // return false if found
                            !(c.widgetOptions.filter_startsWith ? indx === 0 : indx >= 0);
                        }
                    }
                    return null;
                },
                // Look for quotes or equals to get an exact match; ignore type since iExact could be numeric
                exact: function(c, data) {
                    /*jshint eqeqeq:false */ if (tsfRegex.exact.test(data.iFilter)) {
                        var txt = data.iFilter.replace(tsfRegex.exact, ""), filter = tsf.parseFilter(c, txt, data) || "";
                        // eslint-disable-next-line eqeqeq
                        return data.anyMatch ? $.inArray(filter, data.rowArray) >= 0 : filter == data.iExact;
                    }
                    return null;
                },
                // Look for a range ( using ' to ' or ' - ' ) - see issue #166; thanks matzhu!
                range: function(c, data) {
                    if (tsfRegex.toTest.test(data.iFilter)) {
                        var result, tmp, range1, range2, table = c.table, index = data.index, parsed = data.parsed[index], // make sure the dash is for a range and not indicating a negative number
                        query = data.iFilter.split(tsfRegex.toSplit);
                        tmp = query[0].replace(ts.regex.nondigit, "") || "";
                        range1 = ts.formatFloat(tsf.parseFilter(c, tmp, data), table);
                        tmp = query[1].replace(ts.regex.nondigit, "") || "";
                        range2 = ts.formatFloat(tsf.parseFilter(c, tmp, data), table);
                        // parse filter value in case we're comparing numbers ( dates )
                        if (parsed || c.parsers[index].type === "numeric") {
                            result = c.parsers[index].format("" + query[0], table, c.$headers.eq(index), index);
                            range1 = result !== "" && !isNaN(result) ? result : range1;
                            result = c.parsers[index].format("" + query[1], table, c.$headers.eq(index), index);
                            range2 = result !== "" && !isNaN(result) ? result : range2;
                        }
                        if ((parsed || c.parsers[index].type === "numeric") && !isNaN(range1) && !isNaN(range2)) result = data.cache;
                        else {
                            tmp = isNaN(data.iExact) ? data.iExact.replace(ts.regex.nondigit, "") : data.iExact;
                            result = ts.formatFloat(tmp, table);
                        }
                        if (range1 > range2) {
                            tmp = range1;
                            range1 = range2;
                            range2 = tmp; // swap
                        }
                        return result >= range1 && result <= range2 || range1 === "" || range2 === "";
                    }
                    return null;
                },
                // Look for wild card: ? = single, * = multiple, or | = logical OR
                wild: function(c, data) {
                    if (tsfRegex.wildOrTest.test(data.iFilter)) {
                        var query = "" + (tsf.parseFilter(c, data.iFilter, data) || "");
                        // look for an exact match with the 'or' unless the 'filter-match' class is found
                        if (!tsfRegex.wildTest.test(query) && data.nestedFilters) query = data.isMatch ? query : "^(" + query + ")$";
                        // parsing the filter may not work properly when using wildcards =/
                        try {
                            return new RegExp(query.replace(tsfRegex.wild01, "\\S{1}").replace(tsfRegex.wild0More, "\\S*"), c.widgetOptions.filter_ignoreCase ? "i" : "").test(data.exact);
                        } catch (error) {
                            return null;
                        }
                    }
                    return null;
                },
                // fuzzy text search; modified from https://github.com/mattyork/fuzzy ( MIT license )
                fuzzy: function(c, data) {
                    if (tsfRegex.fuzzyTest.test(data.iFilter)) {
                        var indx, patternIndx = 0, len = data.iExact.length, txt = data.iFilter.slice(1), pattern = tsf.parseFilter(c, txt, data) || "";
                        for(indx = 0; indx < len; indx++)if (data.iExact[indx] === pattern[patternIndx]) patternIndx += 1;
                        return patternIndx === pattern.length;
                    }
                    return null;
                }
            },
            init: function(table) {
                // filter language options
                ts.language = $.extend(true, {}, {
                    to: "to",
                    or: "or",
                    and: "and"
                }, ts.language);
                var options, string, txt, $header, column, val, fxn, noSelect, c = table.config, wo = c.widgetOptions, processStr = function(prefix, str, suffix) {
                    str = str.trim();
                    // don't include prefix/suffix if str is empty
                    return str === "" ? "" : (prefix || "") + str + (suffix || "");
                };
                c.$table.addClass("hasFilters");
                c.lastSearch = [];
                // define timers so using clearTimeout won't cause an undefined error
                wo.filter_searchTimer = null;
                wo.filter_initTimer = null;
                wo.filter_formatterCount = 0;
                wo.filter_formatterInit = [];
                wo.filter_anyColumnSelector = '[data-column="all"],[data-column="any"]';
                wo.filter_multipleColumnSelector = '[data-column*="-"],[data-column*=","]';
                val = "\\{" + tsfRegex.query + "\\}";
                $.extend(tsfRegex, {
                    child: new RegExp(c.cssChildRow),
                    filtered: new RegExp(wo.filter_filteredRow),
                    alreadyFiltered: new RegExp("(\\s+(-" + processStr("|", ts.language.or) + processStr("|", ts.language.to) + ")\\s+)", "i"),
                    toTest: new RegExp("\\s+(-" + processStr("|", ts.language.to) + ")\\s+", "i"),
                    toSplit: new RegExp("(?:\\s+(?:-" + processStr("|", ts.language.to) + ")\\s+)", "gi"),
                    andTest: new RegExp("\\s+(" + processStr("", ts.language.and, "|") + "&&)\\s+", "i"),
                    andSplit: new RegExp("(?:\\s+(?:" + processStr("", ts.language.and, "|") + "&&)\\s+)", "gi"),
                    orTest: new RegExp("(\\|" + processStr("|\\s+", ts.language.or, "\\s+") + ")", "i"),
                    orSplit: new RegExp("(?:\\|" + processStr("|\\s+(?:", ts.language.or, ")\\s+") + ")", "gi"),
                    iQuery: new RegExp(val, "i"),
                    igQuery: new RegExp(val, "ig"),
                    operTest: /^[<>]=?/,
                    gtTest: />/,
                    gteTest: />=/,
                    ltTest: /</,
                    lteTest: /<=/,
                    notTest: /^\!/,
                    wildOrTest: /[\?\*\|]/,
                    wildTest: /\?\*/,
                    fuzzyTest: /^~/,
                    exactTest: /[=\"\|!]/
                });
                // don't build filter row if columnFilters is false or all columns are set to 'filter-false'
                // see issue #156
                val = c.$headers.filter(".filter-false, .parser-false").length;
                if (wo.filter_columnFilters !== false && val !== c.$headers.length) // build filter row
                tsf.buildRow(table, c, wo);
                txt = "addRows updateCell update updateRows updateComplete appendCache filterReset " + "filterAndSortReset filterResetSaved filterEnd search ".split(" ").join(c.namespace + "filter ");
                c.$table.bind(txt, function(event, filter) {
                    val = wo.filter_hideEmpty && $.isEmptyObject(c.cache) && !(c.delayInit && event.type === "appendCache");
                    // hide filter row using the 'filtered' class name
                    c.$table.find("." + tscss.filterRow).toggleClass(wo.filter_filteredRow, val); // fixes #450
                    if (!/(search|filter)/.test(event.type)) {
                        event.stopPropagation();
                        tsf.buildDefault(table, true);
                    }
                    // Add filterAndSortReset - see #1361
                    if (event.type === "filterReset" || event.type === "filterAndSortReset") {
                        c.$table.find("." + tscss.filter).add(wo.filter_$externalFilters).val("");
                        if (event.type === "filterAndSortReset") ts.sortReset(this.config, function() {
                            tsf.searching(table, []);
                        });
                        else tsf.searching(table, []);
                    } else if (event.type === "filterResetSaved") ts.storage(table, "tablesorter-filters", "");
                    else if (event.type === "filterEnd") tsf.buildDefault(table, true);
                    else {
                        // send false argument to force a new search; otherwise if the filter hasn't changed,
                        // it will return
                        filter = event.type === "search" ? filter : event.type === "updateComplete" ? c.$table.data("lastSearch") : "";
                        if (/(update|add)/.test(event.type) && event.type !== "updateComplete") {
                            // force a new search since content has changed
                            c.lastCombinedFilter = null;
                            c.lastSearch = [];
                            // update filterFormatters after update (& small delay) - Fixes #1237
                            setTimeout(function() {
                                c.$table.triggerHandler("filterFomatterUpdate");
                            }, 100);
                        }
                        // pass true ( skipFirst ) to prevent the tablesorter.setFilters function from skipping the first
                        // input ensures all inputs are updated when a search is triggered on the table
                        // $( 'table' ).trigger( 'search', [...] );
                        tsf.searching(table, filter, true);
                    }
                    return false;
                });
                // reset button/link
                if (wo.filter_reset) {
                    if (wo.filter_reset instanceof $) // reset contains a jQuery object, bind to it
                    wo.filter_reset.click(function() {
                        c.$table.triggerHandler("filterReset");
                    });
                    else if ($(wo.filter_reset).length) // reset is a jQuery selector, use event delegation
                    $(document).undelegate(wo.filter_reset, "click" + c.namespace + "filter").delegate(wo.filter_reset, "click" + c.namespace + "filter", function() {
                        // trigger a reset event, so other functions ( filter_formatter ) know when to reset
                        c.$table.triggerHandler("filterReset");
                    });
                }
                if (wo.filter_functions) for(column = 0; column < c.columns; column++){
                    fxn = ts.getColumnData(table, wo.filter_functions, column);
                    if (fxn) {
                        // remove 'filter-select' from header otherwise the options added here are replaced with
                        // all options
                        $header = c.$headerIndexed[column].removeClass("filter-select");
                        // don't build select if 'filter-false' or 'parser-false' set
                        noSelect = !($header.hasClass("filter-false") || $header.hasClass("parser-false"));
                        options = "";
                        if (fxn === true && noSelect) tsf.buildSelect(table, column);
                        else if (typeof fxn === "object" && noSelect) {
                            // add custom drop down list
                            for(string in fxn)if (typeof string === "string") {
                                options += options === "" ? '<option value="">' + ($header.data("placeholder") || $header.attr("data-placeholder") || wo.filter_placeholder.select || "") + "</option>" : "";
                                val = string;
                                txt = string;
                                if (string.indexOf(wo.filter_selectSourceSeparator) >= 0) {
                                    val = string.split(wo.filter_selectSourceSeparator);
                                    txt = val[1];
                                    val = val[0];
                                }
                                options += "<option " + (txt === val ? "" : 'data-function-name="' + string + '" ') + 'value="' + val + '">' + txt + "</option>";
                            }
                            c.$table.find("thead").find("select." + tscss.filter + '[data-column="' + column + '"]').append(options);
                            txt = wo.filter_selectSource;
                            fxn = typeof txt === "function" ? true : ts.getColumnData(table, txt, column);
                            if (fxn) // updating so the extra options are appended
                            tsf.buildSelect(c.table, column, "", true, $header.hasClass(wo.filter_onlyAvail));
                        }
                    }
                }
                // not really updating, but if the column has both the 'filter-select' class &
                // filter_functions set to true, it would append the same options twice.
                tsf.buildDefault(table, true);
                tsf.bindSearch(table, c.$table.find("." + tscss.filter), true);
                if (wo.filter_external) tsf.bindSearch(table, wo.filter_external);
                if (wo.filter_hideFilters) tsf.hideFilters(c);
                // show processing icon
                if (c.showProcessing) {
                    txt = "filterStart filterEnd ".split(" ").join(c.namespace + "filter-sp ");
                    c.$table.unbind(txt.replace(ts.regex.spaces, " ")).bind(txt, function(event, columns) {
                        // only add processing to certain columns to all columns
                        $header = columns ? c.$table.find("." + tscss.header).filter("[data-column]").filter(function() {
                            return columns[$(this).data("column")] !== "";
                        }) : "";
                        ts.isProcessing(table, event.type === "filterStart", columns ? $header : "");
                    });
                }
                // set filtered rows count ( intially unfiltered )
                c.filteredRows = c.totalRows;
                // add default values
                txt = "tablesorter-initialized pagerBeforeInitialized ".split(" ").join(c.namespace + "filter ");
                c.$table.unbind(txt.replace(ts.regex.spaces, " ")).bind(txt, function() {
                    tsf.completeInit(this);
                });
                // if filter widget is added after pager has initialized; then set filter init flag
                if (c.pager && c.pager.initialized && !wo.filter_initialized) {
                    c.$table.triggerHandler("filterFomatterUpdate");
                    setTimeout(function() {
                        tsf.filterInitComplete(c);
                    }, 100);
                } else if (!wo.filter_initialized) tsf.completeInit(table);
            },
            completeInit: function(table) {
                // redefine 'c' & 'wo' so they update properly inside this callback
                var c = table.config, wo = c.widgetOptions, filters = tsf.setDefaults(table, c, wo) || [];
                if (filters.length) // prevent delayInit from triggering a cache build if filters are empty
                {
                    if (!(c.delayInit && filters.join("") === "")) ts.setFilters(table, filters, true);
                }
                c.$table.triggerHandler("filterFomatterUpdate");
                // trigger init after setTimeout to prevent multiple filterStart/End/Init triggers
                setTimeout(function() {
                    if (!wo.filter_initialized) tsf.filterInitComplete(c);
                }, 100);
            },
            // $cell parameter, but not the config, is passed to the filter_formatters,
            // so we have to work with it instead
            formatterUpdated: function($cell, column) {
                // prevent error if $cell is undefined - see #1056
                var $table = $cell && $cell.closest("table");
                var config = $table.length && $table[0].config, wo = config && config.widgetOptions;
                if (wo && !wo.filter_initialized) // add updates by column since this function
                // may be called numerous times before initialization
                wo.filter_formatterInit[column] = 1;
            },
            filterInitComplete: function(c) {
                var indx, len, wo = c.widgetOptions, count = 0, completed = function() {
                    wo.filter_initialized = true;
                    // update lastSearch - it gets cleared often
                    c.lastSearch = c.$table.data("lastSearch");
                    c.$table.triggerHandler("filterInit", c);
                    tsf.findRows(c.table, c.lastSearch || []);
                    if (ts.debug(c, "filter")) console.log("Filter >> Widget initialized");
                };
                if ($.isEmptyObject(wo.filter_formatter)) completed();
                else {
                    len = wo.filter_formatterInit.length;
                    for(indx = 0; indx < len; indx++)if (wo.filter_formatterInit[indx] === 1) count++;
                    clearTimeout(wo.filter_initTimer);
                    if (!wo.filter_initialized && count === wo.filter_formatterCount) // filter widget initialized
                    completed();
                    else if (!wo.filter_initialized) // fall back in case a filter_formatter doesn't call
                    // $.tablesorter.filter.formatterUpdated( $cell, column ), and the count is off
                    wo.filter_initTimer = setTimeout(function() {
                        completed();
                    }, 500);
                }
            },
            // encode or decode filters for storage; see #1026
            processFilters: function(filters, encode) {
                var indx, // fixes #1237; previously returning an encoded "filters" value
                result = [], mode = encode ? encodeURIComponent : decodeURIComponent, len = filters.length;
                for(indx = 0; indx < len; indx++)if (filters[indx]) result[indx] = mode(filters[indx]);
                return result;
            },
            setDefaults: function(table, c, wo) {
                var isArray, saved, indx, col, $filters, // get current ( default ) filters
                filters = ts.getFilters(table) || [];
                if (wo.filter_saveFilters && ts.storage) {
                    saved = ts.storage(table, "tablesorter-filters") || [];
                    isArray = $.isArray(saved);
                    // make sure we're not just getting an empty array
                    if (!(isArray && saved.join("") === "" || !isArray)) filters = tsf.processFilters(saved);
                }
                // if no filters saved, then check default settings
                if (filters.join("") === "") {
                    // allow adding default setting to external filters
                    $filters = c.$headers.add(wo.filter_$externalFilters).filter("[" + wo.filter_defaultAttrib + "]");
                    for(indx = 0; indx <= c.columns; indx++){
                        // include data-column='all' external filters
                        col = indx === c.columns ? "all" : indx;
                        filters[indx] = $filters.filter('[data-column="' + col + '"]').attr(wo.filter_defaultAttrib) || filters[indx] || "";
                    }
                }
                c.$table.data("lastSearch", filters);
                return filters;
            },
            parseFilter: function(c, filter, data, parsed) {
                return parsed || data.parsed[data.index] ? c.parsers[data.index].format(filter, c.table, [], data.index) : filter;
            },
            buildRow: function(table, c, wo) {
                var $filter, col, column, $header, makeSelect, disabled, name, ffxn, tmp, // c.columns defined in computeThIndexes()
                cellFilter = wo.filter_cellFilter, columns = c.columns, arry = $.isArray(cellFilter), buildFilter = '<tr role="search" class="' + tscss.filterRow + " " + c.cssIgnoreRow + '">';
                for(column = 0; column < columns; column++)if (c.$headerIndexed[column].length) {
                    // account for entire column set with colspan. See #1047
                    tmp = c.$headerIndexed[column] && c.$headerIndexed[column][0].colSpan || 0;
                    if (tmp > 1) buildFilter += '<td data-column="' + column + "-" + (column + tmp - 1) + '" colspan="' + tmp + '"';
                    else buildFilter += '<td data-column="' + column + '"';
                    if (arry) buildFilter += cellFilter[column] ? ' class="' + cellFilter[column] + '"' : "";
                    else buildFilter += cellFilter !== "" ? ' class="' + cellFilter + '"' : "";
                    buildFilter += "></td>";
                }
                c.$filters = $(buildFilter += "</tr>").appendTo(c.$table.children("thead").eq(0)).children("td");
                // build each filter input
                for(column = 0; column < columns; column++){
                    disabled = false;
                    // assuming last cell of a column is the main column
                    $header = c.$headerIndexed[column];
                    if ($header && $header.length) {
                        // $filter = c.$filters.filter( '[data-column="' + column + '"]' );
                        $filter = tsf.getColumnElm(c, c.$filters, column);
                        ffxn = ts.getColumnData(table, wo.filter_functions, column);
                        makeSelect = wo.filter_functions && ffxn && typeof ffxn !== "function" || $header.hasClass("filter-select");
                        // get data from jQuery data, metadata, headers option or header class name
                        col = ts.getColumnData(table, c.headers, column);
                        disabled = ts.getData($header[0], col, "filter") === "false" || ts.getData($header[0], col, "parser") === "false";
                        if (makeSelect) buildFilter = $("<select>").appendTo($filter);
                        else {
                            ffxn = ts.getColumnData(table, wo.filter_formatter, column);
                            if (ffxn) {
                                wo.filter_formatterCount++;
                                buildFilter = ffxn($filter, column);
                                // no element returned, so lets go find it
                                if (buildFilter && buildFilter.length === 0) buildFilter = $filter.children("input");
                                // element not in DOM, so lets attach it
                                if (buildFilter && (buildFilter.parent().length === 0 || buildFilter.parent().length && buildFilter.parent()[0] !== $filter[0])) $filter.append(buildFilter);
                            } else buildFilter = $('<input type="search">').appendTo($filter);
                            if (buildFilter) {
                                tmp = $header.data("placeholder") || $header.attr("data-placeholder") || wo.filter_placeholder.search || "";
                                buildFilter.attr("placeholder", tmp);
                            }
                        }
                        if (buildFilter) {
                            // add filter class name
                            name = ($.isArray(wo.filter_cssFilter) ? typeof wo.filter_cssFilter[column] !== "undefined" ? wo.filter_cssFilter[column] || "" : "" : wo.filter_cssFilter) || "";
                            // copy data-column from table cell (it will include colspan)
                            buildFilter.addClass(tscss.filter + " " + name);
                            name = wo.filter_filterLabel;
                            tmp = name.match(/{{([^}]+?)}}/g);
                            if (!tmp) tmp = [
                                "{{label}}"
                            ];
                            $.each(tmp, function(indx, attr) {
                                var regex = new RegExp(attr, "g"), data = $header.attr("data-" + attr.replace(/{{|}}/g, "")), text = typeof data === "undefined" ? $header.text() : data;
                                name = name.replace(regex, $.trim(text));
                            });
                            buildFilter.attr({
                                "data-column": $filter.attr("data-column"),
                                "aria-label": name
                            });
                            if (disabled) buildFilter.attr("placeholder", "").addClass(tscss.filterDisabled)[0].disabled = true;
                        }
                    }
                }
            },
            bindSearch: function(table, $el, internal) {
                table = $(table)[0];
                $el = $($el); // allow passing a selector string
                if (!$el.length) return;
                var tmp, c = table.config, wo = c.widgetOptions, namespace = c.namespace + "filter", $ext = wo.filter_$externalFilters;
                if (internal !== true) {
                    // save anyMatch element
                    tmp = wo.filter_anyColumnSelector + "," + wo.filter_multipleColumnSelector;
                    wo.filter_$anyMatch = $el.filter(tmp);
                    if ($ext && $ext.length) wo.filter_$externalFilters = wo.filter_$externalFilters.add($el);
                    else wo.filter_$externalFilters = $el;
                    // update values ( external filters added after table initialization )
                    ts.setFilters(table, c.$table.data("lastSearch") || [], internal === false);
                }
                // unbind events
                tmp = "keypress keyup keydown search change input ".split(" ").join(namespace + " ");
                $el// use data attribute instead of jQuery data since the head is cloned without including
                // the data/binding
                .attr("data-lastSearchTime", new Date().getTime()).unbind(tmp.replace(ts.regex.spaces, " ")).bind("keydown" + namespace, function(event) {
                    if (event.which === tskeyCodes.escape && !table.config.widgetOptions.filter_resetOnEsc) // prevent keypress event
                    return false;
                }).bind("keyup" + namespace, function(event) {
                    wo = table.config.widgetOptions; // make sure "wo" isn't cached
                    var column = parseInt($(this).attr("data-column"), 10), liveSearch = typeof wo.filter_liveSearch === "boolean" ? wo.filter_liveSearch : ts.getColumnData(table, wo.filter_liveSearch, column);
                    if (typeof liveSearch === "undefined") liveSearch = wo.filter_liveSearch.fallback || false;
                    $(this).attr("data-lastSearchTime", new Date().getTime());
                    // emulate what webkit does.... escape clears the filter
                    if (event.which === tskeyCodes.escape) // make sure to restore the last value on escape
                    this.value = wo.filter_resetOnEsc ? "" : c.lastSearch[column];
                    else if (this.value !== "" && (// liveSearch can contain a min value length; ignore arrow and meta keys, but allow backspace
                    typeof liveSearch === "number" && this.value.length < liveSearch || // let return & backspace continue on, but ignore arrows & non-valid characters
                    event.which !== tskeyCodes.enter && event.which !== tskeyCodes.backSpace && (event.which < tskeyCodes.space || event.which >= tskeyCodes.left && event.which <= tskeyCodes.down))) return;
                    else if (liveSearch === false) {
                        if (this.value !== "" && event.which !== tskeyCodes.enter) return;
                    }
                    // change event = no delay; last true flag tells getFilters to skip newest timed input
                    tsf.searching(table, true, true, column);
                })// include change for select - fixes #473
                .bind("search change keypress input blur ".split(" ").join(namespace + " "), function(event) {
                    // don't get cached data, in case data-column changes dynamically
                    var column = parseInt($(this).attr("data-column"), 10), eventType = event.type, liveSearch = typeof wo.filter_liveSearch === "boolean" ? wo.filter_liveSearch : ts.getColumnData(table, wo.filter_liveSearch, column);
                    if (table.config.widgetOptions.filter_initialized && // immediate search if user presses enter
                    (event.which === tskeyCodes.enter || // immediate search if a "search" or "blur" is triggered on the input
                    eventType === "search" || eventType === "blur" || // change & input events must be ignored if liveSearch !== true
                    (eventType === "change" || eventType === "input") && // prevent search if liveSearch is a number
                    (liveSearch === true || liveSearch !== true && event.target.nodeName !== "INPUT") && // don't allow 'change' or 'input' event to process if the input value
                    // is the same - fixes #685
                    this.value !== c.lastSearch[column])) {
                        event.preventDefault();
                        // init search with no delay
                        $(this).attr("data-lastSearchTime", new Date().getTime());
                        tsf.searching(table, eventType !== "keypress" || event.which === tskeyCodes.enter, true, column);
                    }
                });
            },
            searching: function(table, filter, skipFirst, column) {
                var liveSearch, wo = table.config.widgetOptions;
                if (typeof column === "undefined") // no delay
                liveSearch = false;
                else {
                    liveSearch = typeof wo.filter_liveSearch === "boolean" ? wo.filter_liveSearch : // get column setting, or set to fallback value, or default to false
                    ts.getColumnData(table, wo.filter_liveSearch, column);
                    if (typeof liveSearch === "undefined") liveSearch = wo.filter_liveSearch.fallback || false;
                }
                clearTimeout(wo.filter_searchTimer);
                if (typeof filter === "undefined" || filter === true) // delay filtering
                wo.filter_searchTimer = setTimeout(function() {
                    tsf.checkFilters(table, filter, skipFirst);
                }, liveSearch ? wo.filter_searchDelay : 10);
                else // skip delay
                tsf.checkFilters(table, filter, skipFirst);
            },
            equalFilters: function(c, filter1, filter2) {
                var indx, f1 = [], f2 = [], len = c.columns + 1; // add one to include anyMatch filter
                filter1 = $.isArray(filter1) ? filter1 : [];
                filter2 = $.isArray(filter2) ? filter2 : [];
                for(indx = 0; indx < len; indx++){
                    f1[indx] = filter1[indx] || "";
                    f2[indx] = filter2[indx] || "";
                }
                return f1.join(",") === f2.join(",");
            },
            checkFilters: function(table, filter, skipFirst) {
                var c = table.config, wo = c.widgetOptions, filterArray = $.isArray(filter), filters = filterArray ? filter : ts.getFilters(table, true), currentFilters = filters || []; // current filter values
                // prevent errors if delay init is set
                if ($.isEmptyObject(c.cache)) {
                    // update cache if delayInit set & pager has initialized ( after user initiates a search )
                    if (c.delayInit && (!c.pager || c.pager && c.pager.initialized)) ts.updateCache(c, function() {
                        tsf.checkFilters(table, false, skipFirst);
                    });
                    return;
                }
                // add filter array back into inputs
                if (filterArray) {
                    ts.setFilters(table, filters, false, skipFirst !== true);
                    if (!wo.filter_initialized) {
                        c.lastSearch = [];
                        c.lastCombinedFilter = "";
                    }
                }
                if (wo.filter_hideFilters) // show/hide filter row as needed
                c.$table.find("." + tscss.filterRow).triggerHandler(tsf.hideFiltersCheck(c) ? "mouseleave" : "mouseenter");
                // return if the last search is the same; but filter === false when updating the search
                // see example-widget-filter.html filter toggle buttons
                if (tsf.equalFilters(c, c.lastSearch, currentFilters)) {
                    if (filter !== false) return;
                    else {
                        // force filter refresh
                        c.lastCombinedFilter = "";
                        c.lastSearch = [];
                    }
                }
                // define filter inside it is false
                filters = filters || [];
                // convert filters to strings - see #1070
                filters = Array.prototype.map ? filters.map(String) : // for IE8 & older browsers - maybe not the best method
                filters.join("\uFFFD").split("\uFFFD");
                if (wo.filter_initialized) c.$table.triggerHandler("filterStart", [
                    filters
                ]);
                if (c.showProcessing) // give it time for the processing icon to kick in
                setTimeout(function() {
                    tsf.findRows(table, filters, currentFilters);
                    return false;
                }, 30);
                else {
                    tsf.findRows(table, filters, currentFilters);
                    return false;
                }
            },
            hideFiltersCheck: function(c) {
                if (typeof c.widgetOptions.filter_hideFilters === "function") {
                    var val = c.widgetOptions.filter_hideFilters(c);
                    if (typeof val === "boolean") return val;
                }
                return ts.getFilters(c.$table).join("") === "";
            },
            hideFilters: function(c, $table) {
                var timer;
                ($table || c.$table).find("." + tscss.filterRow).addClass(tscss.filterRowHide).bind("mouseenter mouseleave", function(e) {
                    // save event object - http://bugs.jquery.com/ticket/12140
                    var event = e, $row = $(this);
                    clearTimeout(timer);
                    timer = setTimeout(function() {
                        if (/enter|over/.test(event.type)) $row.removeClass(tscss.filterRowHide);
                        else // don't hide if input has focus
                        // $( ':focus' ) needs jQuery 1.6+
                        if ($(document.activeElement).closest("tr")[0] !== $row[0]) // don't hide row if any filter has a value
                        $row.toggleClass(tscss.filterRowHide, tsf.hideFiltersCheck(c));
                    }, 200);
                }).find("input, select").bind("focus blur", function(e) {
                    var event = e, $row = $(this).closest("tr");
                    clearTimeout(timer);
                    timer = setTimeout(function() {
                        clearTimeout(timer);
                        // don't hide row if any filter has a value
                        $row.toggleClass(tscss.filterRowHide, tsf.hideFiltersCheck(c) && event.type !== "focus");
                    }, 200);
                });
            },
            defaultFilter: function(filter, mask) {
                if (filter === "") return filter;
                var regex = tsfRegex.iQuery, maskLen = mask.match(tsfRegex.igQuery).length, query = maskLen > 1 ? $.trim(filter).split(/\s/) : [
                    $.trim(filter)
                ], len = query.length - 1, indx = 0, val = mask;
                if (len < 1 && maskLen > 1) // only one 'word' in query but mask has >1 slots
                query[1] = query[0];
                // replace all {query} with query words...
                // if query = 'Bob', then convert mask from '!{query}' to '!Bob'
                // if query = 'Bob Joe Frank', then convert mask '{q} OR {q}' to 'Bob OR Joe OR Frank'
                while(regex.test(val)){
                    val = val.replace(regex, query[indx++] || "");
                    if (regex.test(val) && indx < len && (query[indx] || "") !== "") val = mask.replace(regex, val);
                }
                return val;
            },
            getLatestSearch: function($input) {
                if ($input) return $input.sort(function(a, b) {
                    return $(b).attr("data-lastSearchTime") - $(a).attr("data-lastSearchTime");
                });
                return $input || $();
            },
            findRange: function(c, val, ignoreRanges) {
                // look for multiple columns '1-3,4-6,8' in data-column
                var temp, ranges, range, start, end, singles, i, indx, len, columns = [];
                if (/^[0-9]+$/.test(val)) // always return an array
                return [
                    parseInt(val, 10)
                ];
                // process column range
                if (!ignoreRanges && /-/.test(val)) {
                    ranges = val.match(/(\d+)\s*-\s*(\d+)/g);
                    len = ranges ? ranges.length : 0;
                    for(indx = 0; indx < len; indx++){
                        range = ranges[indx].split(/\s*-\s*/);
                        start = parseInt(range[0], 10) || 0;
                        end = parseInt(range[1], 10) || c.columns - 1;
                        if (start > end) {
                            temp = start;
                            start = end;
                            end = temp; // swap
                        }
                        if (end >= c.columns) end = c.columns - 1;
                        for(; start <= end; start++)columns[columns.length] = start;
                        // remove processed range from val
                        val = val.replace(ranges[indx], "");
                    }
                }
                // process single columns
                if (!ignoreRanges && /,/.test(val)) {
                    singles = val.split(/\s*,\s*/);
                    len = singles.length;
                    for(i = 0; i < len; i++)if (singles[i] !== "") {
                        indx = parseInt(singles[i], 10);
                        if (indx < c.columns) columns[columns.length] = indx;
                    }
                }
                // return all columns
                if (!columns.length) for(indx = 0; indx < c.columns; indx++)columns[columns.length] = indx;
                return columns;
            },
            getColumnElm: function(c, $elements, column) {
                // data-column may contain multiple columns '1-3,5-6,8'
                // replaces: c.$filters.filter( '[data-column="' + column + '"]' );
                return $elements.filter(function() {
                    var cols = tsf.findRange(c, $(this).attr("data-column"));
                    return $.inArray(column, cols) > -1;
                });
            },
            multipleColumns: function(c, $input) {
                // look for multiple columns '1-3,4-6,8' in data-column
                var wo = c.widgetOptions, // only target 'all' column inputs on initialization
                // & don't target 'all' column inputs if they don't exist
                targets = wo.filter_initialized || !$input.filter(wo.filter_anyColumnSelector).length, val = $.trim(tsf.getLatestSearch($input).attr("data-column") || "");
                return tsf.findRange(c, val, !targets);
            },
            processTypes: function(c, data, vars) {
                var ffxn, filterMatched = null, matches = null;
                for(ffxn in tsf.types)if ($.inArray(ffxn, vars.excludeMatch) < 0 && matches === null) {
                    matches = tsf.types[ffxn](c, data, vars);
                    if (matches !== null) {
                        data.matchedOn = ffxn;
                        filterMatched = matches;
                    }
                }
                return filterMatched;
            },
            matchType: function(c, columnIndex) {
                var isMatch, wo = c.widgetOptions, $el = c.$headerIndexed[columnIndex];
                // filter-exact > filter-match > filter_matchType for type
                if ($el.hasClass("filter-exact")) isMatch = false;
                else if ($el.hasClass("filter-match")) isMatch = true;
                else {
                    // filter-select is not applied when filter_functions are used, so look for a select
                    if (wo.filter_columnFilters) $el = c.$filters.find("." + tscss.filter).add(wo.filter_$externalFilters).filter('[data-column="' + columnIndex + '"]');
                    else if (wo.filter_$externalFilters) $el = wo.filter_$externalFilters.filter('[data-column="' + columnIndex + '"]');
                    isMatch = $el.length ? c.widgetOptions.filter_matchType[($el[0].nodeName || "").toLowerCase()] === "match" : // default to exact, if no inputs found
                    false;
                }
                return isMatch;
            },
            processRow: function(c, data, vars) {
                var result, filterMatched, fxn, ffxn, txt, wo = c.widgetOptions, showRow = true, hasAnyMatchInput = wo.filter_$anyMatch && wo.filter_$anyMatch.length, // if wo.filter_$anyMatch data-column attribute is changed dynamically
                // we don't want to do an "anyMatch" search on one column using data
                // for the entire row - see #998
                columnIndex = wo.filter_$anyMatch && wo.filter_$anyMatch.length ? // look for multiple columns '1-3,4-6,8'
                tsf.multipleColumns(c, wo.filter_$anyMatch) : [];
                data.$cells = data.$row.children();
                data.matchedOn = null;
                if (data.anyMatchFlag && columnIndex.length > 1 || data.anyMatchFilter && !hasAnyMatchInput) {
                    data.anyMatch = true;
                    data.isMatch = true;
                    data.rowArray = data.$cells.map(function(i) {
                        if ($.inArray(i, columnIndex) > -1 || data.anyMatchFilter && !hasAnyMatchInput) {
                            if (data.parsed[i]) txt = data.cacheArray[i];
                            else {
                                txt = data.rawArray[i];
                                txt = $.trim(wo.filter_ignoreCase ? txt.toLowerCase() : txt);
                                if (c.sortLocaleCompare) txt = ts.replaceAccents(txt);
                            }
                            return txt;
                        }
                    }).get();
                    data.filter = data.anyMatchFilter;
                    data.iFilter = data.iAnyMatchFilter;
                    data.exact = data.rowArray.join(" ");
                    data.iExact = wo.filter_ignoreCase ? data.exact.toLowerCase() : data.exact;
                    data.cache = data.cacheArray.slice(0, -1).join(" ");
                    vars.excludeMatch = vars.noAnyMatch;
                    filterMatched = tsf.processTypes(c, data, vars);
                    if (filterMatched !== null) showRow = filterMatched;
                    else if (wo.filter_startsWith) {
                        showRow = false;
                        // data.rowArray may not contain all columns
                        columnIndex = Math.min(c.columns, data.rowArray.length);
                        while(!showRow && columnIndex > 0){
                            columnIndex--;
                            showRow = showRow || data.rowArray[columnIndex].indexOf(data.iFilter) === 0;
                        }
                    } else showRow = (data.iExact + data.childRowText).indexOf(data.iFilter) >= 0;
                    data.anyMatch = false;
                    // no other filters to process
                    if (data.filters.join("") === data.filter) return showRow;
                }
                for(columnIndex = 0; columnIndex < c.columns; columnIndex++){
                    data.filter = data.filters[columnIndex];
                    data.index = columnIndex;
                    // filter types to exclude, per column
                    vars.excludeMatch = vars.excludeFilter[columnIndex];
                    // ignore if filter is empty or disabled
                    if (data.filter) {
                        data.cache = data.cacheArray[columnIndex];
                        result = data.parsed[columnIndex] ? data.cache : data.rawArray[columnIndex] || "";
                        data.exact = c.sortLocaleCompare ? ts.replaceAccents(result) : result; // issue #405
                        data.iExact = !tsfRegex.type.test(typeof data.exact) && wo.filter_ignoreCase ? data.exact.toLowerCase() : data.exact;
                        data.isMatch = tsf.matchType(c, columnIndex);
                        result = showRow; // if showRow is true, show that row
                        // in case select filter option has a different value vs text 'a - z|A through Z'
                        ffxn = wo.filter_columnFilters ? c.$filters.add(wo.filter_$externalFilters).filter('[data-column="' + columnIndex + '"]').find("select option:selected").attr("data-function-name") || "" : "";
                        // replace accents - see #357
                        if (c.sortLocaleCompare) data.filter = ts.replaceAccents(data.filter);
                        // replace column specific default filters - see #1088
                        if (wo.filter_defaultFilter && tsfRegex.iQuery.test(vars.defaultColFilter[columnIndex])) data.filter = tsf.defaultFilter(data.filter, vars.defaultColFilter[columnIndex]);
                        // data.iFilter = case insensitive ( if wo.filter_ignoreCase is true ),
                        // data.filter = case sensitive
                        data.iFilter = wo.filter_ignoreCase ? (data.filter || "").toLowerCase() : data.filter;
                        fxn = vars.functions[columnIndex];
                        filterMatched = null;
                        if (fxn) {
                            if (typeof fxn === "function") // filter callback( exact cell content, parser normalized content,
                            // filter input value, column index, jQuery row object )
                            filterMatched = fxn(data.exact, data.cache, data.filter, columnIndex, data.$row, c, data);
                            else if (typeof fxn[ffxn || data.filter] === "function") {
                                // selector option function
                                txt = ffxn || data.filter;
                                filterMatched = fxn[txt](data.exact, data.cache, data.filter, columnIndex, data.$row, c, data);
                            }
                        }
                        if (filterMatched === null) {
                            // cycle through the different filters
                            // filters return a boolean or null if nothing matches
                            filterMatched = tsf.processTypes(c, data, vars);
                            // select with exact match; ignore "and" or "or" within the text; fixes #1486
                            txt = fxn === true && (data.matchedOn === "and" || data.matchedOn === "or");
                            if (filterMatched !== null && !txt) result = filterMatched;
                            else // check fxn (filter-select in header) after filter types are checked
                            // without this, the filter + jQuery UI selectmenu demo was breaking
                            if (fxn === true) // default selector uses exact match unless 'filter-match' class is found
                            result = data.isMatch ? // data.iExact may be a number
                            ("" + data.iExact).search(data.iFilter) >= 0 : data.filter === data.exact;
                            else {
                                txt = (data.iExact + data.childRowText).indexOf(tsf.parseFilter(c, data.iFilter, data));
                                result = !wo.filter_startsWith && txt >= 0 || wo.filter_startsWith && txt === 0;
                            }
                        } else result = filterMatched;
                        showRow = result ? showRow : false;
                    }
                }
                return showRow;
            },
            findRows: function(table, filters, currentFilters) {
                if (tsf.equalFilters(table.config, table.config.lastSearch, currentFilters) || !table.config.widgetOptions.filter_initialized) return;
                var len, norm_rows, rowData, $rows, $row, rowIndex, tbodyIndex, $tbody, columnIndex, isChild, childRow, lastSearch, showRow, showParent, time, val, indx, notFiltered, searchFiltered, query, injected, res, id, txt, storedFilters = $.extend([], filters), c = table.config, wo = c.widgetOptions, debug = ts.debug(c, "filter"), // data object passed to filters; anyMatch is a flag for the filters
                data = {
                    anyMatch: false,
                    filters: filters,
                    // regex filter type cache
                    filter_regexCache: []
                }, vars = {
                    // anyMatch really screws up with these types of filters
                    noAnyMatch: [
                        "range",
                        "operators"
                    ],
                    // cache filter variables that use ts.getColumnData in the main loop
                    functions: [],
                    excludeFilter: [],
                    defaultColFilter: [],
                    defaultAnyFilter: ts.getColumnData(table, wo.filter_defaultFilter, c.columns, true) || ""
                };
                // parse columns after formatter, in case the class is added at that point
                data.parsed = [];
                for(columnIndex = 0; columnIndex < c.columns; columnIndex++){
                    data.parsed[columnIndex] = wo.filter_useParsedData || // parser has a "parsed" parameter
                    c.parsers && c.parsers[columnIndex] && c.parsers[columnIndex].parsed || // getData may not return 'parsed' if other 'filter-' class names exist
                    // ( e.g. <th class="filter-select filter-parsed"> )
                    ts.getData && ts.getData(c.$headerIndexed[columnIndex], ts.getColumnData(table, c.headers, columnIndex), "filter") === "parsed" || c.$headerIndexed[columnIndex].hasClass("filter-parsed");
                    vars.functions[columnIndex] = ts.getColumnData(table, wo.filter_functions, columnIndex) || c.$headerIndexed[columnIndex].hasClass("filter-select");
                    vars.defaultColFilter[columnIndex] = ts.getColumnData(table, wo.filter_defaultFilter, columnIndex) || "";
                    vars.excludeFilter[columnIndex] = (ts.getColumnData(table, wo.filter_excludeFilter, columnIndex, true) || "").split(/\s+/);
                }
                if (debug) {
                    console.log("Filter >> Starting filter widget search", filters);
                    time = new Date();
                }
                // filtered rows count
                c.filteredRows = 0;
                c.totalRows = 0;
                currentFilters = storedFilters || [];
                for(tbodyIndex = 0; tbodyIndex < c.$tbodies.length; tbodyIndex++){
                    $tbody = ts.processTbody(table, c.$tbodies.eq(tbodyIndex), true);
                    // skip child rows & widget added ( removable ) rows - fixes #448 thanks to @hempel!
                    // $rows = $tbody.children( 'tr' ).not( c.selectorRemove );
                    columnIndex = c.columns;
                    // convert stored rows into a jQuery object
                    norm_rows = c.cache[tbodyIndex].normalized;
                    $rows = $($.map(norm_rows, function(el) {
                        return el[columnIndex].$row.get();
                    }));
                    if (currentFilters.join("") === "" || wo.filter_serversideFiltering) $rows.removeClass(wo.filter_filteredRow).not("." + c.cssChildRow).css("display", "");
                    else {
                        // filter out child rows
                        $rows = $rows.not("." + c.cssChildRow);
                        len = $rows.length;
                        if (wo.filter_$anyMatch && wo.filter_$anyMatch.length || typeof filters[c.columns] !== "undefined") {
                            data.anyMatchFlag = true;
                            data.anyMatchFilter = "" + (filters[c.columns] || wo.filter_$anyMatch && tsf.getLatestSearch(wo.filter_$anyMatch).val() || "");
                            if (wo.filter_columnAnyMatch) {
                                // specific columns search
                                query = data.anyMatchFilter.split(tsfRegex.andSplit);
                                injected = false;
                                for(indx = 0; indx < query.length; indx++){
                                    res = query[indx].split(":");
                                    if (res.length > 1) {
                                        // make the column a one-based index ( non-developers start counting from one :P )
                                        if (isNaN(res[0])) $.each(c.headerContent, function(i, txt) {
                                            // multiple matches are possible
                                            if (txt.toLowerCase().indexOf(res[0]) > -1) {
                                                id = i;
                                                filters[id] = res[1];
                                            }
                                        });
                                        else id = parseInt(res[0], 10) - 1;
                                        if (id >= 0 && id < c.columns) {
                                            filters[id] = res[1];
                                            query.splice(indx, 1);
                                            indx--;
                                            injected = true;
                                        }
                                    }
                                }
                                if (injected) data.anyMatchFilter = query.join(" && ");
                            }
                        }
                        // optimize searching only through already filtered rows - see #313
                        searchFiltered = wo.filter_searchFiltered;
                        lastSearch = c.lastSearch || c.$table.data("lastSearch") || [];
                        if (searchFiltered) // cycle through all filters; include last ( columnIndex + 1 = match any column ). Fixes #669
                        for(indx = 0; indx < columnIndex + 1; indx++){
                            val = filters[indx] || "";
                            // break out of loop if we've already determined not to search filtered rows
                            if (!searchFiltered) indx = columnIndex;
                            // search already filtered rows if...
                            searchFiltered = searchFiltered && lastSearch.length && // there are no changes from beginning of filter
                            val.indexOf(lastSearch[indx] || "") === 0 && // if there is NOT a logical 'or', or range ( 'to' or '-' ) in the string
                            !tsfRegex.alreadyFiltered.test(val) && // if we are not doing exact matches, using '|' ( logical or ) or not '!'
                            !tsfRegex.exactTest.test(val) && // don't search only filtered if the value is negative
                            // ( '> -10' => '> -100' will ignore hidden rows )
                            !(tsfRegex.isNeg1.test(val) || tsfRegex.isNeg2.test(val)) && // if filtering using a select without a 'filter-match' class ( exact match ) - fixes #593
                            !(val !== "" && c.$filters && c.$filters.filter('[data-column="' + indx + '"]').find("select").length && !tsf.matchType(c, indx));
                        }
                        notFiltered = $rows.not("." + wo.filter_filteredRow).length;
                        // can't search when all rows are hidden - this happens when looking for exact matches
                        if (searchFiltered && notFiltered === 0) searchFiltered = false;
                        if (debug) console.log("Filter >> Searching through " + (searchFiltered && notFiltered < len ? notFiltered : "all") + " rows");
                        if (data.anyMatchFlag) {
                            if (c.sortLocaleCompare) // replace accents
                            data.anyMatchFilter = ts.replaceAccents(data.anyMatchFilter);
                            if (wo.filter_defaultFilter && tsfRegex.iQuery.test(vars.defaultAnyFilter)) {
                                data.anyMatchFilter = tsf.defaultFilter(data.anyMatchFilter, vars.defaultAnyFilter);
                                // clear search filtered flag because default filters are not saved to the last search
                                searchFiltered = false;
                            }
                            // make iAnyMatchFilter lowercase unless both filter widget & core ignoreCase options are true
                            // when c.ignoreCase is true, the cache contains all lower case data
                            data.iAnyMatchFilter = !(wo.filter_ignoreCase && c.ignoreCase) ? data.anyMatchFilter : data.anyMatchFilter.toLowerCase();
                        }
                        // loop through the rows
                        for(rowIndex = 0; rowIndex < len; rowIndex++){
                            txt = $rows[rowIndex].className;
                            // the first row can never be a child row
                            isChild = rowIndex && tsfRegex.child.test(txt);
                            // skip child rows & already filtered rows
                            if (isChild || searchFiltered && tsfRegex.filtered.test(txt)) continue;
                            data.$row = $rows.eq(rowIndex);
                            data.rowIndex = rowIndex;
                            data.cacheArray = norm_rows[rowIndex];
                            rowData = data.cacheArray[c.columns];
                            data.rawArray = rowData.raw;
                            data.childRowText = "";
                            if (!wo.filter_childByColumn) {
                                txt = "";
                                // child row cached text
                                childRow = rowData.child;
                                // so, if 'table.config.widgetOptions.filter_childRows' is true and there is
                                // a match anywhere in the child row, then it will make the row visible
                                // checked here so the option can be changed dynamically
                                for(indx = 0; indx < childRow.length; indx++)txt += " " + childRow[indx].join(" ");
                                data.childRowText = wo.filter_childRows ? wo.filter_ignoreCase ? txt.toLowerCase() : txt : "";
                            }
                            showRow = false;
                            showParent = tsf.processRow(c, data, vars);
                            $row = rowData.$row;
                            // don't pass reference to val
                            val = showParent ? true : false;
                            childRow = rowData.$row.filter(":gt(0)");
                            if (wo.filter_childRows && childRow.length) {
                                if (wo.filter_childByColumn) {
                                    if (!wo.filter_childWithSibs) {
                                        // hide all child rows
                                        childRow.addClass(wo.filter_filteredRow);
                                        // if only showing resulting child row, only include parent
                                        $row = $row.eq(0);
                                    }
                                    // cycle through each child row
                                    for(indx = 0; indx < childRow.length; indx++){
                                        data.$row = childRow.eq(indx);
                                        data.cacheArray = rowData.child[indx];
                                        data.rawArray = data.cacheArray;
                                        val = tsf.processRow(c, data, vars);
                                        // use OR comparison on child rows
                                        showRow = showRow || val;
                                        if (!wo.filter_childWithSibs && val) childRow.eq(indx).removeClass(wo.filter_filteredRow);
                                    }
                                }
                                // keep parent row match even if no child matches... see #1020
                                showRow = showRow || showParent;
                            } else showRow = val;
                            $row.toggleClass(wo.filter_filteredRow, !showRow)[0].display = showRow ? "" : "none";
                        }
                    }
                    c.filteredRows += $rows.not("." + wo.filter_filteredRow).length;
                    c.totalRows += $rows.length;
                    ts.processTbody(table, $tbody, false);
                }
                // lastCombinedFilter is no longer used internally
                c.lastCombinedFilter = storedFilters.join(""); // save last search
                // don't save 'filters' directly since it may have altered ( AnyMatch column searches )
                c.lastSearch = storedFilters;
                c.$table.data("lastSearch", storedFilters);
                if (wo.filter_saveFilters && ts.storage) ts.storage(table, "tablesorter-filters", tsf.processFilters(storedFilters, true));
                if (debug) console.log("Filter >> Completed search" + ts.benchmark(time));
                if (wo.filter_initialized) {
                    c.$table.triggerHandler("filterBeforeEnd", c);
                    c.$table.triggerHandler("filterEnd", c);
                }
                setTimeout(function() {
                    ts.applyWidget(c.table); // make sure zebra widget is applied
                }, 0);
            },
            getOptionSource: function(table, column, onlyAvail) {
                table = $(table)[0];
                var c = table.config, wo = c.widgetOptions, arry = false, source = wo.filter_selectSource, last = c.$table.data("lastSearch") || [], fxn = typeof source === "function" ? true : ts.getColumnData(table, source, column);
                if (onlyAvail && last[column] !== "") onlyAvail = false;
                // filter select source option
                if (fxn === true) // OVERALL source
                arry = source(table, column, onlyAvail);
                else if (fxn instanceof $ || $.type(fxn) === "string" && fxn.indexOf("</option>") >= 0) // selectSource is a jQuery object or string of options
                return fxn;
                else if ($.isArray(fxn)) arry = fxn;
                else if ($.type(source) === "object" && fxn) {
                    // custom select source function for a SPECIFIC COLUMN
                    arry = fxn(table, column, onlyAvail);
                    // abort - updating the selects from an external method
                    if (arry === null) return null;
                }
                if (arry === false) // fall back to original method
                arry = tsf.getOptions(table, column, onlyAvail);
                return tsf.processOptions(table, column, arry);
            },
            processOptions: function(table, column, arry) {
                if (!$.isArray(arry)) return false;
                table = $(table)[0];
                var cts, txt, indx, len, parsedTxt, str, c = table.config, validColumn = typeof column !== "undefined" && column !== null && column >= 0 && column < c.columns, direction = validColumn ? c.$headerIndexed[column].hasClass("filter-select-sort-desc") : false, parsed = [];
                // get unique elements and sort the list
                // if $.tablesorter.sortText exists ( not in the original tablesorter ),
                // then natural sort the list otherwise use a basic sort
                arry = $.grep(arry, function(value, indx) {
                    if (value.text) return true;
                    return $.inArray(value, arry) === indx;
                });
                if (validColumn && c.$headerIndexed[column].hasClass("filter-select-nosort")) // unsorted select options
                return arry;
                else {
                    len = arry.length;
                    // parse select option values
                    for(indx = 0; indx < len; indx++){
                        txt = arry[indx];
                        // check for object
                        str = txt.text ? txt.text : txt;
                        // sortNatural breaks if you don't pass it strings
                        parsedTxt = (validColumn && c.parsers && c.parsers.length && c.parsers[column].format(str, table, [], column) || str).toString();
                        parsedTxt = c.widgetOptions.filter_ignoreCase ? parsedTxt.toLowerCase() : parsedTxt;
                        // parse array data using set column parser; this DOES NOT pass the original
                        // table cell to the parser format function
                        if (txt.text) {
                            txt.parsed = parsedTxt;
                            parsed[parsed.length] = txt;
                        } else parsed[parsed.length] = {
                            text: txt,
                            // check parser length - fixes #934
                            parsed: parsedTxt
                        };
                    }
                    // sort parsed select options
                    cts = c.textSorter || "";
                    parsed.sort(function(a, b) {
                        var x = direction ? b.parsed : a.parsed, y = direction ? a.parsed : b.parsed;
                        if (validColumn && typeof cts === "function") // custom OVERALL text sorter
                        return cts(x, y, true, column, table);
                        else if (validColumn && typeof cts === "object" && cts.hasOwnProperty(column)) // custom text sorter for a SPECIFIC COLUMN
                        return cts[column](x, y, true, column, table);
                        else if (ts.sortNatural) // fall back to natural sort
                        return ts.sortNatural(x, y);
                        // using an older version! do a basic sort
                        return true;
                    });
                    // rebuild arry from sorted parsed data
                    arry = [];
                    len = parsed.length;
                    for(indx = 0; indx < len; indx++)arry[arry.length] = parsed[indx];
                    return arry;
                }
            },
            getOptions: function(table, column, onlyAvail) {
                table = $(table)[0];
                var rowIndex, tbodyIndex, len, row, cache, indx, child, childLen, c = table.config, wo = c.widgetOptions, arry = [];
                for(tbodyIndex = 0; tbodyIndex < c.$tbodies.length; tbodyIndex++){
                    cache = c.cache[tbodyIndex];
                    len = c.cache[tbodyIndex].normalized.length;
                    // loop through the rows
                    for(rowIndex = 0; rowIndex < len; rowIndex++){
                        // get cached row from cache.row ( old ) or row data object
                        // ( new; last item in normalized array )
                        row = cache.row ? cache.row[rowIndex] : cache.normalized[rowIndex][c.columns].$row[0];
                        // check if has class filtered
                        if (onlyAvail && row.className.match(wo.filter_filteredRow)) continue;
                        // get non-normalized cell content
                        if (wo.filter_useParsedData || c.parsers[column].parsed || c.$headerIndexed[column].hasClass("filter-parsed")) {
                            arry[arry.length] = "" + cache.normalized[rowIndex][column];
                            // child row parsed data
                            if (wo.filter_childRows && wo.filter_childByColumn) {
                                childLen = cache.normalized[rowIndex][c.columns].$row.length - 1;
                                for(indx = 0; indx < childLen; indx++)arry[arry.length] = "" + cache.normalized[rowIndex][c.columns].child[indx][column];
                            }
                        } else {
                            // get raw cached data instead of content directly from the cells
                            arry[arry.length] = cache.normalized[rowIndex][c.columns].raw[column];
                            // child row unparsed data
                            if (wo.filter_childRows && wo.filter_childByColumn) {
                                childLen = cache.normalized[rowIndex][c.columns].$row.length;
                                for(indx = 1; indx < childLen; indx++){
                                    child = cache.normalized[rowIndex][c.columns].$row.eq(indx).children().eq(column);
                                    arry[arry.length] = "" + ts.getElementText(c, child, column);
                                }
                            }
                        }
                    }
                }
                return arry;
            },
            buildSelect: function(table, column, arry, updating, onlyAvail) {
                table = $(table)[0];
                column = parseInt(column, 10);
                if (!table.config.cache || $.isEmptyObject(table.config.cache)) return;
                var indx, val, txt, t, $filters, $filter, option, c = table.config, wo = c.widgetOptions, node = c.$headerIndexed[column], // t.data( 'placeholder' ) won't work in jQuery older than 1.4.3
                options = '<option value="">' + (node.data("placeholder") || node.attr("data-placeholder") || wo.filter_placeholder.select || "") + "</option>", // Get curent filter value
                currentValue = c.$table.find("thead").find("select." + tscss.filter + '[data-column="' + column + '"]').val();
                // nothing included in arry ( external source ), so get the options from
                // filter_selectSource or column data
                if (typeof arry === "undefined" || arry === "") {
                    arry = tsf.getOptionSource(table, column, onlyAvail);
                    // abort, selects are updated by an external method
                    if (arry === null) return;
                }
                if ($.isArray(arry)) {
                    // build option list
                    for(indx = 0; indx < arry.length; indx++){
                        option = arry[indx];
                        if (option.text) {
                            // OBJECT!! add data-function-name in case the value is set in filter_functions
                            option["data-function-name"] = typeof option.value === "undefined" ? option.text : option.value;
                            // support jQuery < v1.8, otherwise the below code could be shortened to
                            // options += $( '<option>', option )[ 0 ].outerHTML;
                            options += "<option";
                            for(val in option)if (option.hasOwnProperty(val) && val !== "text") options += " " + val + '="' + option[val].replace(tsfRegex.quote, "&quot;") + '"';
                            if (!option.value) options += ' value="' + option.text.replace(tsfRegex.quote, "&quot;") + '"';
                            options += ">" + option.text.replace(tsfRegex.quote, "&quot;") + "</option>";
                        // above code is needed in jQuery < v1.8
                        // make sure we don't turn an object into a string (objects without a "text" property)
                        } else if ("" + option !== "[object Object]") {
                            txt = option = ("" + option).replace(tsfRegex.quote, "&quot;");
                            val = txt;
                            // allow including a symbol in the selectSource array
                            // 'a-z|A through Z' so that 'a-z' becomes the option value
                            // and 'A through Z' becomes the option text
                            if (txt.indexOf(wo.filter_selectSourceSeparator) >= 0) {
                                t = txt.split(wo.filter_selectSourceSeparator);
                                val = t[0];
                                txt = t[1];
                            }
                            // replace quotes - fixes #242 & ignore empty strings
                            // see http://stackoverflow.com/q/14990971/145346
                            options += option !== "" ? "<option " + (val === txt ? "" : 'data-function-name="' + option + '" ') + 'value="' + val + '">' + txt + "</option>" : "";
                        }
                    }
                    // clear arry so it doesn't get appended twice
                    arry = [];
                }
                // update all selects in the same column ( clone thead in sticky headers &
                // any external selects ) - fixes 473
                $filters = (c.$filters ? c.$filters : c.$table.children("thead")).find("." + tscss.filter);
                if (wo.filter_$externalFilters) $filters = $filters && $filters.length ? $filters.add(wo.filter_$externalFilters) : wo.filter_$externalFilters;
                $filter = $filters.filter('select[data-column="' + column + '"]');
                // make sure there is a select there!
                if ($filter.length) {
                    $filter[updating ? "html" : "append"](options);
                    if (!$.isArray(arry)) // append options if arry is provided externally as a string or jQuery object
                    // options ( default value ) was already added
                    $filter.append(arry).val(currentValue);
                    $filter.val(currentValue);
                }
            },
            buildDefault: function(table, updating) {
                var columnIndex, $header, noSelect, c = table.config, wo = c.widgetOptions, columns = c.columns;
                // build default select dropdown
                for(columnIndex = 0; columnIndex < columns; columnIndex++){
                    $header = c.$headerIndexed[columnIndex];
                    noSelect = !($header.hasClass("filter-false") || $header.hasClass("parser-false"));
                    // look for the filter-select class; build/update it if found
                    if (($header.hasClass("filter-select") || ts.getColumnData(table, wo.filter_functions, columnIndex) === true) && noSelect) tsf.buildSelect(table, columnIndex, "", updating, $header.hasClass(wo.filter_onlyAvail));
                }
            }
        };
        // filter regex variable
        tsfRegex = tsf.regex;
        ts.getFilters = function(table, getRaw, setFilters, skipFirst) {
            var i, $filters, $column, cols, filters = [], c = table ? $(table)[0].config : "", wo = c ? c.widgetOptions : "";
            if (getRaw !== true && wo && !wo.filter_columnFilters || // setFilters called, but last search is exactly the same as the current
            // fixes issue #733 & #903 where calling update causes the input values to reset
            $.isArray(setFilters) && tsf.equalFilters(c, setFilters, c.lastSearch)) return $(table).data("lastSearch") || [];
            if (c) {
                if (c.$filters) $filters = c.$filters.find("." + tscss.filter);
                if (wo.filter_$externalFilters) $filters = $filters && $filters.length ? $filters.add(wo.filter_$externalFilters) : wo.filter_$externalFilters;
                if ($filters && $filters.length) {
                    filters = setFilters || [];
                    for(i = 0; i < c.columns + 1; i++){
                        cols = i === c.columns ? // 'all' columns can now include a range or set of columms ( data-column='0-2,4,6-7' )
                        wo.filter_anyColumnSelector + "," + wo.filter_multipleColumnSelector : '[data-column="' + i + '"]';
                        $column = $filters.filter(cols);
                        if ($column.length) {
                            // move the latest search to the first slot in the array
                            $column = tsf.getLatestSearch($column);
                            if ($.isArray(setFilters)) {
                                // skip first ( latest input ) to maintain cursor position while typing
                                if (skipFirst && $column.length > 1) $column = $column.slice(1);
                                if (i === c.columns) {
                                    // prevent data-column='all' from filling data-column='0,1' ( etc )
                                    cols = $column.filter(wo.filter_anyColumnSelector);
                                    $column = cols.length ? cols : $column;
                                }
                                $column.val(setFilters[i])// must include a namespace here; but not c.namespace + 'filter'?
                                .trigger("change" + c.namespace);
                            } else {
                                filters[i] = $column.val() || "";
                                // don't change the first... it will move the cursor
                                if (i === c.columns) // don't update range columns from 'all' setting
                                $column.slice(1).filter('[data-column*="' + $column.attr("data-column") + '"]').val(filters[i]);
                                else $column.slice(1).val(filters[i]);
                            }
                            // save any match input dynamically
                            if (i === c.columns && $column.length) wo.filter_$anyMatch = $column;
                        }
                    }
                }
            }
            return filters;
        };
        ts.setFilters = function(table, filter, apply, skipFirst) {
            var c = table ? $(table)[0].config : "", valid = ts.getFilters(table, true, filter, skipFirst);
            // default apply to "true"
            if (typeof apply === "undefined") apply = true;
            if (c && apply) {
                // ensure new set filters are applied, even if the search is the same
                c.lastCombinedFilter = null;
                c.lastSearch = [];
                tsf.searching(c.table, filter, skipFirst);
                c.$table.triggerHandler("filterFomatterUpdate");
            }
            return valid.length !== 0;
        };
    })(jQuery1); /*
 * Requires tablesorter v2.8+ and jQuery 1.4.3+
 * by Rob Garrison
 */ 
    (function($, window1) {
        "use strict";
        var ts = $.tablesorter || {};
        $.extend(ts.css, {
            sticky: "tablesorter-stickyHeader",
            stickyVis: "tablesorter-sticky-visible",
            stickyHide: "tablesorter-sticky-hidden",
            stickyWrap: "tablesorter-sticky-wrapper"
        });
        // Add a resize event to table headers
        ts.addHeaderResizeEvent = function(table, disable, settings) {
            table = $(table)[0]; // make sure we're using a dom element
            if (!table.config) return;
            var defaults = {
                timer: 250
            }, options = $.extend({}, defaults, settings), c = table.config, wo = c.widgetOptions, checkSizes = function(triggerEvent) {
                var index, headers, $header, sizes, width, height, len = c.$headers.length;
                wo.resize_flag = true;
                headers = [];
                for(index = 0; index < len; index++){
                    $header = c.$headers.eq(index);
                    sizes = $header.data("savedSizes") || [
                        0,
                        0
                    ]; // fixes #394
                    width = $header[0].offsetWidth;
                    height = $header[0].offsetHeight;
                    if (width !== sizes[0] || height !== sizes[1]) {
                        $header.data("savedSizes", [
                            width,
                            height
                        ]);
                        headers.push($header[0]);
                    }
                }
                if (headers.length && triggerEvent !== false) c.$table.triggerHandler("resize", [
                    headers
                ]);
                wo.resize_flag = false;
            };
            clearInterval(wo.resize_timer);
            if (disable) {
                wo.resize_flag = false;
                return false;
            }
            checkSizes(false);
            wo.resize_timer = setInterval(function() {
                if (wo.resize_flag) return;
                checkSizes();
            }, options.timer);
        };
        function getStickyOffset(c, wo) {
            var $el = isNaN(wo.stickyHeaders_offset) ? $(wo.stickyHeaders_offset) : [];
            return $el.length ? $el.height() || 0 : parseInt(wo.stickyHeaders_offset, 10) || 0;
        }
        // Sticky headers based on this awesome article:
        // http://css-tricks.com/13465-persistent-headers/
        // and https://github.com/jmosbech/StickyTableHeaders by Jonas Mosbech
        // **************************
        ts.addWidget({
            id: "stickyHeaders",
            priority: 54,
            options: {
                stickyHeaders: "",
                stickyHeaders_appendTo: null,
                stickyHeaders_attachTo: null,
                stickyHeaders_xScroll: null,
                stickyHeaders_yScroll: null,
                stickyHeaders_offset: 0,
                stickyHeaders_filteredToTop: true,
                stickyHeaders_cloneId: "-sticky",
                stickyHeaders_addResizeEvent: true,
                stickyHeaders_includeCaption: true,
                stickyHeaders_zIndex: 2 // The zIndex of the stickyHeaders, allows the user to adjust this to their needs
            },
            format: function(table, c, wo) {
                // filter widget doesn't initialize on an empty table. Fixes #449
                if (c.$table.hasClass("hasStickyHeaders") || $.inArray("filter", c.widgets) >= 0 && !c.$table.hasClass("hasFilters")) return;
                var index, len, $t, $table = c.$table, // add position: relative to attach element, hopefully it won't cause trouble.
                $attach = $(wo.stickyHeaders_attachTo || wo.stickyHeaders_appendTo), namespace = c.namespace + "stickyheaders ", // element to watch for the scroll event
                $yScroll = $(wo.stickyHeaders_yScroll || wo.stickyHeaders_attachTo || window1), $xScroll = $(wo.stickyHeaders_xScroll || wo.stickyHeaders_attachTo || window1), $thead = $table.children("thead:first"), $header = $thead.children("tr").not(".sticky-false").children(), $tfoot = $table.children("tfoot"), stickyOffset = getStickyOffset(c, wo), // is this table nested? If so, find parent sticky header wrapper (div, not table)
                $nestedSticky = $table.parent().closest("." + ts.css.table).hasClass("hasStickyHeaders") ? $table.parent().closest("table.tablesorter")[0].config.widgetOptions.$sticky.parent() : [], nestedStickyTop = $nestedSticky.length ? $nestedSticky.height() : 0, // clone table, then wrap to make sticky header
                $stickyTable = wo.$sticky = $table.clone().addClass("containsStickyHeaders " + ts.css.sticky + " " + wo.stickyHeaders + " " + c.namespace.slice(1) + "_extra_table").wrap('<div class="' + ts.css.stickyWrap + '">'), $stickyWrap = $stickyTable.parent().addClass(ts.css.stickyHide).css({
                    position: $attach.length ? "absolute" : "fixed",
                    padding: parseInt($stickyTable.parent().parent().css("padding-left"), 10),
                    top: stickyOffset + nestedStickyTop,
                    left: 0,
                    visibility: "hidden",
                    zIndex: wo.stickyHeaders_zIndex || 2
                }), $stickyThead = $stickyTable.children("thead:first"), $stickyCells, laststate = "", setWidth = function($orig, $clone) {
                    var index, width, border, $cell, $this, $cells = $orig.filter(":visible"), len = $cells.length;
                    for(index = 0; index < len; index++){
                        $cell = $clone.filter(":visible").eq(index);
                        $this = $cells.eq(index);
                        // code from https://github.com/jmosbech/StickyTableHeaders
                        if ($this.css("box-sizing") === "border-box") width = $this.outerWidth();
                        else if ($cell.css("border-collapse") === "collapse") {
                            if (window1.getComputedStyle) width = parseFloat(window1.getComputedStyle($this[0], null).width);
                            else {
                                // ie8 only
                                border = parseFloat($this.css("border-width"));
                                width = $this.outerWidth() - parseFloat($this.css("padding-left")) - parseFloat($this.css("padding-right")) - border;
                            }
                        } else width = $this.width();
                        $cell.css({
                            "width": width,
                            "min-width": width,
                            "max-width": width
                        });
                    }
                }, getLeftPosition = function(yWindow) {
                    if (yWindow === false && $nestedSticky.length) return $table.position().left;
                    return $attach.length ? parseInt($attach.css("padding-left"), 10) || 0 : $table.offset().left - parseInt($table.css("margin-left"), 10) - $(window1).scrollLeft();
                }, resizeHeader = function() {
                    $stickyWrap.css({
                        left: getLeftPosition(),
                        width: $table.outerWidth()
                    });
                    setWidth($table, $stickyTable);
                    setWidth($header, $stickyCells);
                }, scrollSticky = function(resizing) {
                    if (!$table.is(":visible")) return;
                     // fixes #278
                    // Detect nested tables - fixes #724
                    nestedStickyTop = $nestedSticky.length ? $nestedSticky.offset().top - $yScroll.scrollTop() + $nestedSticky.height() : 0;
                    var tmp, offset = $table.offset(), stickyOffset = getStickyOffset(c, wo), yWindow = $.isWindow($yScroll[0]), yScroll = yWindow ? $yScroll.scrollTop() : // use parent sticky position if nested AND inside of a scrollable element - see #1512
                    $nestedSticky.length ? parseInt($nestedSticky[0].style.top, 10) : $yScroll.offset().top, attachTop = $attach.length ? yScroll : $yScroll.scrollTop(), captionHeight = wo.stickyHeaders_includeCaption ? 0 : $table.children("caption").height() || 0, scrollTop = attachTop + stickyOffset + nestedStickyTop - captionHeight, tableHeight = $table.height() - ($stickyWrap.height() + ($tfoot.height() || 0)) - captionHeight, isVisible = scrollTop > offset.top && scrollTop < offset.top + tableHeight ? "visible" : "hidden", state = isVisible === "visible" ? ts.css.stickyVis : ts.css.stickyHide, needsUpdating = !$stickyWrap.hasClass(state), cssSettings = {
                        visibility: isVisible
                    };
                    if ($attach.length) {
                        // attached sticky headers always need updating
                        needsUpdating = true;
                        cssSettings.top = yWindow ? scrollTop - $attach.offset().top : $attach.scrollTop();
                    }
                    // adjust when scrolling horizontally - fixes issue #143
                    tmp = getLeftPosition(yWindow);
                    if (tmp !== parseInt($stickyWrap.css("left"), 10)) {
                        needsUpdating = true;
                        cssSettings.left = tmp;
                    }
                    cssSettings.top = (cssSettings.top || 0) + // If nested AND inside of a scrollable element, only add parent sticky height
                    (!yWindow && $nestedSticky.length ? $nestedSticky.height() : stickyOffset + nestedStickyTop);
                    if (needsUpdating) $stickyWrap.removeClass(ts.css.stickyVis + " " + ts.css.stickyHide).addClass(state).css(cssSettings);
                    if (isVisible !== laststate || resizing) {
                        // make sure the column widths match
                        resizeHeader();
                        laststate = isVisible;
                    }
                };
                // only add a position relative if a position isn't already defined
                if ($attach.length && !$attach.css("position")) $attach.css("position", "relative");
                // fix clone ID, if it exists - fixes #271
                if ($stickyTable.attr("id")) $stickyTable[0].id += wo.stickyHeaders_cloneId;
                // clear out cloned table, except for sticky header
                // include caption & filter row (fixes #126 & #249) - don't remove cells to get correct cell indexing
                $stickyTable.find("> thead:gt(0), tr.sticky-false").hide();
                $stickyTable.find("> tbody, > tfoot").remove();
                $stickyTable.find("caption").toggle(wo.stickyHeaders_includeCaption);
                // issue #172 - find td/th in sticky header
                $stickyCells = $stickyThead.children().children();
                $stickyTable.css({
                    height: 0,
                    width: 0,
                    margin: 0
                });
                // remove resizable block
                $stickyCells.find("." + ts.css.resizer).remove();
                // update sticky header class names to match real header after sorting
                $table.addClass("hasStickyHeaders").bind("pagerComplete" + namespace, function() {
                    resizeHeader();
                });
                ts.bindEvents(table, $stickyThead.children().children("." + ts.css.header));
                if (wo.stickyHeaders_appendTo) $(wo.stickyHeaders_appendTo).append($stickyWrap);
                else // add stickyheaders AFTER the table. If the table is selected by ID, the original one (first) will be returned.
                $table.after($stickyWrap);
                // onRenderHeader is defined, we need to do something about it (fixes #641)
                if (c.onRenderHeader) {
                    $t = $stickyThead.children("tr").children();
                    len = $t.length;
                    for(index = 0; index < len; index++)// send second parameter
                    c.onRenderHeader.apply($t.eq(index), [
                        index,
                        c,
                        $stickyTable
                    ]);
                }
                // make it sticky!
                $xScroll.add($yScroll).unbind("scroll resize ".split(" ").join(namespace).replace(/\s+/g, " ")).bind("scroll resize ".split(" ").join(namespace), function(event) {
                    scrollSticky(event.type === "resize");
                });
                c.$table.unbind("stickyHeadersUpdate" + namespace).bind("stickyHeadersUpdate" + namespace, function() {
                    scrollSticky(true);
                });
                if (wo.stickyHeaders_addResizeEvent) ts.addHeaderResizeEvent(table);
                // look for filter widget
                if ($table.hasClass("hasFilters") && wo.filter_columnFilters) {
                    // scroll table into view after filtering, if sticky header is active - #482
                    $table.bind("filterEnd" + namespace, function() {
                        // $(':focus') needs jQuery 1.6+
                        var $td = $(document.activeElement).closest("td"), column = $td.parent().children().index($td);
                        // only scroll if sticky header is active
                        if ($stickyWrap.hasClass(ts.css.stickyVis) && wo.stickyHeaders_filteredToTop) {
                            // scroll to original table (not sticky clone)
                            window1.scrollTo(0, $table.position().top);
                            // give same input/select focus; check if c.$filters exists; fixes #594
                            if (column >= 0 && c.$filters) c.$filters.eq(column).find("a, select, input").filter(":visible").focus();
                        }
                    });
                    ts.filter.bindSearch($table, $stickyCells.find("." + ts.css.filter));
                    // support hideFilters
                    if (wo.filter_hideFilters) ts.filter.hideFilters(c, $stickyTable);
                }
                // resize table (Firefox)
                if (wo.stickyHeaders_addResizeEvent) $table.bind("resize" + c.namespace + "stickyheaders", function() {
                    resizeHeader();
                });
                // make sure sticky is visible if page is partially scrolled
                scrollSticky(true);
                $table.triggerHandler("stickyHeadersInit");
            },
            remove: function(table, c, wo) {
                var namespace = c.namespace + "stickyheaders ";
                c.$table.removeClass("hasStickyHeaders").unbind("pagerComplete resize filterEnd stickyHeadersUpdate ".split(" ").join(namespace).replace(/\s+/g, " ")).next("." + ts.css.stickyWrap).remove();
                if (wo.$sticky && wo.$sticky.length) wo.$sticky.remove();
                 // remove cloned table
                $(window1).add(wo.stickyHeaders_xScroll).add(wo.stickyHeaders_yScroll).add(wo.stickyHeaders_attachTo).unbind("scroll resize ".split(" ").join(namespace).replace(/\s+/g, " "));
                ts.addHeaderResizeEvent(table, true);
            }
        });
    })(jQuery1, window); /*jshint browser:true, jquery:true, unused:false */ 
    (function($, window1) {
        "use strict";
        var ts = $.tablesorter || {};
        $.extend(ts.css, {
            resizableContainer: "tablesorter-resizable-container",
            resizableHandle: "tablesorter-resizable-handle",
            resizableNoSelect: "tablesorter-disableSelection",
            resizableStorage: "tablesorter-resizable"
        });
        // Add extra scroller css
        $(function() {
            var s = "<style>body." + ts.css.resizableNoSelect + " { -ms-user-select: none; -moz-user-select: -moz-none;" + "-khtml-user-select: none; -webkit-user-select: none; user-select: none; }" + "." + ts.css.resizableContainer + " { position: relative; height: 1px; }" + // make handle z-index > than stickyHeader z-index, so the handle stays above sticky header
            "." + ts.css.resizableHandle + " { position: absolute; display: inline-block; width: 8px;" + "top: 1px; cursor: ew-resize; z-index: 3; user-select: none; -moz-user-select: none; }" + "</style>";
            $("head").append(s);
        });
        ts.resizable = {
            init: function(c, wo) {
                if (c.$table.hasClass("hasResizable")) return;
                c.$table.addClass("hasResizable");
                var noResize, $header, column, storedSizes, tmp, $table = c.$table, $parent = $table.parent(), marginTop = parseInt($table.css("margin-top"), 10), // internal variables
                vars = wo.resizable_vars = {
                    useStorage: ts.storage && wo.resizable !== false,
                    $wrap: $parent,
                    mouseXPosition: 0,
                    $target: null,
                    $next: null,
                    overflow: $parent.css("overflow") === "auto" || $parent.css("overflow") === "scroll" || $parent.css("overflow-x") === "auto" || $parent.css("overflow-x") === "scroll",
                    storedSizes: []
                };
                // set default widths
                ts.resizableReset(c.table, true);
                // now get measurements!
                vars.tableWidth = $table.width();
                // attempt to autodetect
                vars.fullWidth = Math.abs($parent.width() - vars.tableWidth) < 20;
                /*
			// Hacky method to determine if table width is set to 'auto'
			// http://stackoverflow.com/a/20892048/145346
			if ( !vars.fullWidth ) {
				tmp = $table.width();
				$header = $table.wrap('<span>').parent(); // temp variable
				storedSizes = parseInt( $table.css( 'margin-left' ), 10 ) || 0;
				$table.css( 'margin-left', storedSizes + 50 );
				vars.tableWidth = $header.width() > tmp ? 'auto' : tmp;
				$table.css( 'margin-left', storedSizes ? storedSizes : '' );
				$header = null;
				$table.unwrap('<span>');
			}
			*/ if (vars.useStorage && vars.overflow) {
                    // save table width
                    ts.storage(c.table, "tablesorter-table-original-css-width", vars.tableWidth);
                    tmp = ts.storage(c.table, "tablesorter-table-resized-width") || "auto";
                    ts.resizable.setWidth($table, tmp, true);
                }
                wo.resizable_vars.storedSizes = storedSizes = (vars.useStorage ? ts.storage(c.table, ts.css.resizableStorage) : []) || [];
                ts.resizable.setWidths(c, wo, storedSizes);
                ts.resizable.updateStoredSizes(c, wo);
                wo.$resizable_container = $('<div class="' + ts.css.resizableContainer + '">').css({
                    top: marginTop
                }).insertBefore($table);
                // add container
                for(column = 0; column < c.columns; column++){
                    $header = c.$headerIndexed[column];
                    tmp = ts.getColumnData(c.table, c.headers, column);
                    noResize = ts.getData($header, tmp, "resizable") === "false";
                    if (!noResize) $('<div class="' + ts.css.resizableHandle + '">').appendTo(wo.$resizable_container).attr({
                        "data-column": column,
                        "unselectable": "on"
                    }).data("header", $header).bind("selectstart", false);
                }
                ts.resizable.bindings(c, wo);
            },
            updateStoredSizes: function(c, wo) {
                var column, $header, len = c.columns, vars = wo.resizable_vars;
                vars.storedSizes = [];
                for(column = 0; column < len; column++){
                    $header = c.$headerIndexed[column];
                    vars.storedSizes[column] = $header.is(":visible") ? $header.width() : 0;
                }
            },
            setWidth: function($el, width, overflow) {
                // overflow tables need min & max width set as well
                $el.css({
                    "width": width,
                    "min-width": overflow ? width : "",
                    "max-width": overflow ? width : ""
                });
            },
            setWidths: function(c, wo, storedSizes) {
                var column, $temp, vars = wo.resizable_vars, $extra = $(c.namespace + "_extra_headers"), $col = c.$table.children("colgroup").children("col");
                storedSizes = storedSizes || vars.storedSizes || [];
                // process only if table ID or url match
                if (storedSizes.length) {
                    for(column = 0; column < c.columns; column++){
                        // set saved resizable widths
                        ts.resizable.setWidth(c.$headerIndexed[column], storedSizes[column], vars.overflow);
                        if ($extra.length) {
                            // stickyHeaders needs to modify min & max width as well
                            $temp = $extra.eq(column).add($col.eq(column));
                            ts.resizable.setWidth($temp, storedSizes[column], vars.overflow);
                        }
                    }
                    $temp = $(c.namespace + "_extra_table");
                    if ($temp.length && !ts.hasWidget(c.table, "scroller")) ts.resizable.setWidth($temp, c.$table.outerWidth(), vars.overflow);
                }
            },
            setHandlePosition: function(c, wo) {
                var startPosition, tableHeight = c.$table.height(), $handles = wo.$resizable_container.children(), handleCenter = Math.floor($handles.width() / 2);
                if (ts.hasWidget(c.table, "scroller")) {
                    tableHeight = 0;
                    c.$table.closest("." + ts.css.scrollerWrap).children().each(function() {
                        var $this = $(this);
                        // center table has a max-height set
                        tableHeight += $this.filter('[style*="height"]').length ? $this.height() : $this.children("table").height();
                    });
                }
                if (!wo.resizable_includeFooter && c.$table.children("tfoot").length) tableHeight -= c.$table.children("tfoot").height();
                // subtract out table left position from resizable handles. Fixes #864
                // jQuery v3.3.0+ appears to include the start position with the $header.position().left; see #1544
                startPosition = parseFloat($.fn.jquery) >= 3.3 ? 0 : c.$table.position().left;
                $handles.each(function() {
                    var $this = $(this), column = parseInt($this.attr("data-column"), 10), columns = c.columns - 1, $header = $this.data("header");
                    if (!$header) return;
                     // see #859
                    if (!$header.is(":visible") || !wo.resizable_addLastColumn && ts.resizable.checkVisibleColumns(c, column)) $this.hide();
                    else if (column < columns || column === columns && wo.resizable_addLastColumn) $this.css({
                        display: "inline-block",
                        height: tableHeight,
                        left: $header.position().left - startPosition + $header.outerWidth() - handleCenter
                    });
                });
            },
            // Fixes #1485
            checkVisibleColumns: function(c, column) {
                var i, len = 0;
                for(i = column + 1; i < c.columns; i++)len += c.$headerIndexed[i].is(":visible") ? 1 : 0;
                return len === 0;
            },
            // prevent text selection while dragging resize bar
            toggleTextSelection: function(c, wo, toggle) {
                var namespace = c.namespace + "tsresize";
                wo.resizable_vars.disabled = toggle;
                $("body").toggleClass(ts.css.resizableNoSelect, toggle);
                if (toggle) $("body").attr("unselectable", "on").bind("selectstart" + namespace, false);
                else $("body").removeAttr("unselectable").unbind("selectstart" + namespace);
            },
            bindings: function(c, wo) {
                var namespace = c.namespace + "tsresize";
                wo.$resizable_container.children().bind("mousedown", function(event) {
                    // save header cell and mouse position
                    var column, vars = wo.resizable_vars, $extras = $(c.namespace + "_extra_headers"), $header = $(event.target).data("header");
                    column = parseInt($header.attr("data-column"), 10);
                    vars.$target = $header = $header.add($extras.filter('[data-column="' + column + '"]'));
                    vars.target = column;
                    // if table is not as wide as it's parent, then resize the table
                    vars.$next = event.shiftKey || wo.resizable_targetLast ? $header.parent().children().not(".resizable-false").filter(":last") : $header.nextAll(":not(.resizable-false)").eq(0);
                    column = parseInt(vars.$next.attr("data-column"), 10);
                    vars.$next = vars.$next.add($extras.filter('[data-column="' + column + '"]'));
                    vars.next = column;
                    vars.mouseXPosition = event.pageX;
                    ts.resizable.updateStoredSizes(c, wo);
                    ts.resizable.toggleTextSelection(c, wo, true);
                });
                $(document).bind("mousemove" + namespace, function(event) {
                    var vars = wo.resizable_vars;
                    // ignore mousemove if no mousedown
                    if (!vars.disabled || vars.mouseXPosition === 0 || !vars.$target) return;
                    if (wo.resizable_throttle) {
                        clearTimeout(vars.timer);
                        vars.timer = setTimeout(function() {
                            ts.resizable.mouseMove(c, wo, event);
                        }, isNaN(wo.resizable_throttle) ? 5 : wo.resizable_throttle);
                    } else ts.resizable.mouseMove(c, wo, event);
                }).bind("mouseup" + namespace, function() {
                    if (!wo.resizable_vars.disabled) return;
                    ts.resizable.toggleTextSelection(c, wo, false);
                    ts.resizable.stopResize(c, wo);
                    ts.resizable.setHandlePosition(c, wo);
                });
                // resizeEnd event triggered by scroller widget
                $(window1).bind("resize" + namespace + " resizeEnd" + namespace, function() {
                    ts.resizable.setHandlePosition(c, wo);
                });
                // right click to reset columns to default widths
                c.$table.bind("columnUpdate pagerComplete resizableUpdate ".split(" ").join(namespace + " "), function() {
                    ts.resizable.setHandlePosition(c, wo);
                }).bind("resizableReset" + namespace, function() {
                    ts.resizableReset(c.table);
                }).find("thead:first").add($(c.namespace + "_extra_table").find("thead:first")).bind("contextmenu" + namespace, function() {
                    // $.isEmptyObject() needs jQuery 1.4+; allow right click if already reset
                    var allowClick = wo.resizable_vars.storedSizes.length === 0;
                    ts.resizableReset(c.table);
                    ts.resizable.setHandlePosition(c, wo);
                    wo.resizable_vars.storedSizes = [];
                    return allowClick;
                });
            },
            mouseMove: function(c, wo, event) {
                if (wo.resizable_vars.mouseXPosition === 0 || !wo.resizable_vars.$target) return;
                // resize columns
                var column, total = 0, vars = wo.resizable_vars, $next = vars.$next, tar = vars.storedSizes[vars.target], leftEdge = event.pageX - vars.mouseXPosition;
                if (vars.overflow) {
                    if (tar + leftEdge > 0) {
                        vars.storedSizes[vars.target] += leftEdge;
                        ts.resizable.setWidth(vars.$target, vars.storedSizes[vars.target], true);
                        // update the entire table width
                        for(column = 0; column < c.columns; column++)total += vars.storedSizes[column];
                        ts.resizable.setWidth(c.$table.add($(c.namespace + "_extra_table")), total);
                    }
                    if (!$next.length) // if expanding right-most column, scroll the wrapper
                    vars.$wrap[0].scrollLeft = c.$table.width();
                } else if (vars.fullWidth) {
                    vars.storedSizes[vars.target] += leftEdge;
                    vars.storedSizes[vars.next] -= leftEdge;
                    ts.resizable.setWidths(c, wo);
                } else {
                    vars.storedSizes[vars.target] += leftEdge;
                    ts.resizable.setWidths(c, wo);
                }
                vars.mouseXPosition = event.pageX;
                // dynamically update sticky header widths
                c.$table.triggerHandler("stickyHeadersUpdate");
            },
            stopResize: function(c, wo) {
                var vars = wo.resizable_vars;
                ts.resizable.updateStoredSizes(c, wo);
                if (vars.useStorage) {
                    // save all column widths
                    ts.storage(c.table, ts.css.resizableStorage, vars.storedSizes);
                    ts.storage(c.table, "tablesorter-table-resized-width", c.$table.width());
                }
                vars.mouseXPosition = 0;
                vars.$target = vars.$next = null;
                // will update stickyHeaders, just in case, see #912
                c.$table.triggerHandler("stickyHeadersUpdate");
                c.$table.triggerHandler("resizableComplete");
            }
        };
        // this widget saves the column widths if
        // $.tablesorter.storage function is included
        // **************************
        ts.addWidget({
            id: "resizable",
            priority: 40,
            options: {
                resizable: true,
                resizable_addLastColumn: false,
                resizable_includeFooter: true,
                resizable_widths: [],
                resizable_throttle: false,
                resizable_targetLast: false
            },
            init: function(table, thisWidget, c, wo) {
                ts.resizable.init(c, wo);
            },
            format: function(table, c, wo) {
                ts.resizable.setHandlePosition(c, wo);
            },
            remove: function(table, c, wo, refreshing) {
                if (wo.$resizable_container) {
                    var namespace = c.namespace + "tsresize";
                    c.$table.add($(c.namespace + "_extra_table")).removeClass("hasResizable").children("thead").unbind("contextmenu" + namespace);
                    wo.$resizable_container.remove();
                    ts.resizable.toggleTextSelection(c, wo, false);
                    ts.resizableReset(table, refreshing);
                    $(document).unbind("mousemove" + namespace + " mouseup" + namespace);
                }
            }
        });
        ts.resizableReset = function(table, refreshing) {
            $(table).each(function() {
                var index, $t, c = this.config, wo = c && c.widgetOptions, vars = wo.resizable_vars;
                if (table && c && c.$headerIndexed.length) {
                    // restore the initial table width
                    if (vars.overflow && vars.tableWidth) {
                        ts.resizable.setWidth(c.$table, vars.tableWidth, true);
                        if (vars.useStorage) ts.storage(table, "tablesorter-table-resized-width", vars.tableWidth);
                    }
                    for(index = 0; index < c.columns; index++){
                        $t = c.$headerIndexed[index];
                        if (wo.resizable_widths && wo.resizable_widths[index]) ts.resizable.setWidth($t, wo.resizable_widths[index], vars.overflow);
                        else if (!$t.hasClass("resizable-false")) // don't clear the width of any column that is not resizable
                        ts.resizable.setWidth($t, "", vars.overflow);
                    }
                    // reset stickyHeader widths
                    c.$table.triggerHandler("stickyHeadersUpdate");
                    if (ts.storage && !refreshing) ts.storage(this, ts.css.resizableStorage, []);
                }
            });
        };
    })(jQuery1, window); /*
* Requires tablesorter v2.16+
* by Rob Garrison
*/ 
    (function($) {
        "use strict";
        var ts = $.tablesorter || {};
        function getStoredSortList(c) {
            var stored = ts.storage(c.table, "tablesorter-savesort");
            return stored && stored.hasOwnProperty("sortList") && $.isArray(stored.sortList) ? stored.sortList : [];
        }
        function sortListChanged(c, sortList) {
            return (sortList || getStoredSortList(c)).join(",") !== c.sortList.join(",");
        }
        // this widget saves the last sort only if the
        // saveSort widget option is true AND the
        // $.tablesorter.storage function is included
        // **************************
        ts.addWidget({
            id: "saveSort",
            priority: 20,
            options: {
                saveSort: true
            },
            init: function(table, thisWidget, c, wo) {
                // run widget format before all other widgets are applied to the table
                thisWidget.format(table, c, wo, true);
            },
            format: function(table, c, wo, init) {
                var time, $table = c.$table, saveSort = wo.saveSort !== false, sortList = {
                    "sortList": c.sortList
                }, debug = ts.debug(c, "saveSort");
                if (debug) time = new Date();
                if ($table.hasClass("hasSaveSort")) {
                    if (saveSort && table.hasInitialized && ts.storage && sortListChanged(c)) {
                        ts.storage(table, "tablesorter-savesort", sortList);
                        if (debug) console.log("saveSort >> Saving last sort: " + c.sortList + ts.benchmark(time));
                    }
                } else {
                    // set table sort on initial run of the widget
                    $table.addClass("hasSaveSort");
                    sortList = "";
                    // get data
                    if (ts.storage) {
                        sortList = getStoredSortList(c);
                        if (debug) console.log('saveSort >> Last sort loaded: "' + sortList + '"' + ts.benchmark(time));
                        $table.bind("saveSortReset", function(event) {
                            event.stopPropagation();
                            ts.storage(table, "tablesorter-savesort", "");
                        });
                    }
                    // init is true when widget init is run, this will run this widget before all other widgets have initialized
                    // this method allows using this widget in the original tablesorter plugin; but then it will run all widgets twice.
                    if (init && sortList && sortList.length > 0) c.sortList = sortList;
                    else if (table.hasInitialized && sortList && sortList.length > 0) // update sort change
                    {
                        if (sortListChanged(c, sortList)) ts.sortOn(c, sortList);
                    }
                }
            },
            remove: function(table, c) {
                c.$table.removeClass("hasSaveSort");
                // clear storage
                if (ts.storage) ts.storage(table, "tablesorter-savesort", "");
            }
        });
    })(jQuery1);
    return jQuery1.tablesorter;
});

});
parcelRegister("bj2Xw", function(module, exports) {
/*!
 * jQuery JavaScript Library v3.7.1
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-08-28T13:37Z
 */ (function(global, factory) {
    "use strict";
    if (typeof module.exports === "object") // For CommonJS and CommonJS-like environments where a proper `window`
    // is present, execute the factory and get jQuery.
    // For environments that do not have a `window` with a `document`
    // (such as Node.js), expose a factory as module.exports.
    // This accentuates the need for the creation of a real `window`.
    // e.g. var jQuery = require("jquery")(window);
    // See ticket trac-14549 for more info.
    module.exports = global.document ? factory(global, true) : function(w) {
        if (!w.document) throw new Error("jQuery requires a window with a document");
        return factory(w);
    };
    else factory(global);
// Pass this if window is not defined yet
})(typeof window !== "undefined" ? window : module.exports, function(window1, noGlobal) {
    // Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
    // throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
    // arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
    // enough that all such attempts are guarded in a try block.
    "use strict";
    var arr = [];
    var getProto = Object.getPrototypeOf;
    var slice = arr.slice;
    var flat = arr.flat ? function(array) {
        return arr.flat.call(array);
    } : function(array) {
        return arr.concat.apply([], array);
    };
    var push = arr.push;
    var indexOf = arr.indexOf;
    var class2type = {};
    var toString = class2type.toString;
    var hasOwn = class2type.hasOwnProperty;
    var fnToString = hasOwn.toString;
    var ObjectFunctionString = fnToString.call(Object);
    var support = {};
    var isFunction = function isFunction(obj) {
        // Support: Chrome <=57, Firefox <=52
        // In some browsers, typeof returns "function" for HTML <object> elements
        // (i.e., `typeof document.createElement( "object" ) === "function"`).
        // We don't want to classify *any* DOM node as a function.
        // Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
        // Plus for old WebKit, typeof returns "function" for HTML collections
        // (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
        return typeof obj === "function" && typeof obj.nodeType !== "number" && typeof obj.item !== "function";
    };
    var isWindow = function isWindow(obj) {
        return obj != null && obj === obj.window;
    };
    var document = window1.document;
    var preservedScriptAttributes = {
        type: true,
        src: true,
        nonce: true,
        noModule: true
    };
    function DOMEval(code, node, doc) {
        doc = doc || document;
        var i, val, script = doc.createElement("script");
        script.text = code;
        if (node) for(i in preservedScriptAttributes){
            // Support: Firefox 64+, Edge 18+
            // Some browsers don't support the "nonce" property on scripts.
            // On the other hand, just using `getAttribute` is not enough as
            // the `nonce` attribute is reset to an empty string whenever it
            // becomes browsing-context connected.
            // See https://github.com/whatwg/html/issues/2369
            // See https://html.spec.whatwg.org/#nonce-attributes
            // The `node.getAttribute` check was added for the sake of
            // `jQuery.globalEval` so that it can fake a nonce-containing node
            // via an object.
            val = node[i] || node.getAttribute && node.getAttribute(i);
            if (val) script.setAttribute(i, val);
        }
        doc.head.appendChild(script).parentNode.removeChild(script);
    }
    function toType(obj) {
        if (obj == null) return obj + "";
        // Support: Android <=2.3 only (functionish RegExp)
        return typeof obj === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj;
    }
    /* global Symbol */ // Defining this global in .eslintrc.json would create a danger of using the global
    // unguarded in another place, it seems safer to define global only for this module
    var version = "3.7.1", rhtmlSuffix = /HTML$/i, // Define a local copy of jQuery
    jQuery = function(selector, context) {
        // The jQuery object is actually just the init constructor 'enhanced'
        // Need init if jQuery is called (just allow error to be thrown if not included)
        return new jQuery.fn.init(selector, context);
    };
    jQuery.fn = jQuery.prototype = {
        // The current version of jQuery being used
        jquery: version,
        constructor: jQuery,
        // The default length of a jQuery object is 0
        length: 0,
        toArray: function() {
            return slice.call(this);
        },
        // Get the Nth element in the matched element set OR
        // Get the whole matched element set as a clean array
        get: function(num) {
            // Return all the elements in a clean array
            if (num == null) return slice.call(this);
            // Return just the one element from the set
            return num < 0 ? this[num + this.length] : this[num];
        },
        // Take an array of elements and push it onto the stack
        // (returning the new matched element set)
        pushStack: function(elems) {
            // Build a new jQuery matched element set
            var ret = jQuery.merge(this.constructor(), elems);
            // Add the old object onto the stack (as a reference)
            ret.prevObject = this;
            // Return the newly-formed element set
            return ret;
        },
        // Execute a callback for every element in the matched set.
        each: function(callback) {
            return jQuery.each(this, callback);
        },
        map: function(callback) {
            return this.pushStack(jQuery.map(this, function(elem, i) {
                return callback.call(elem, i, elem);
            }));
        },
        slice: function() {
            return this.pushStack(slice.apply(this, arguments));
        },
        first: function() {
            return this.eq(0);
        },
        last: function() {
            return this.eq(-1);
        },
        even: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return (i + 1) % 2;
            }));
        },
        odd: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return i % 2;
            }));
        },
        eq: function(i) {
            var len = this.length, j = +i + (i < 0 ? len : 0);
            return this.pushStack(j >= 0 && j < len ? [
                this[j]
            ] : []);
        },
        end: function() {
            return this.prevObject || this.constructor();
        },
        // For internal use only.
        // Behaves like an Array's method, not like a jQuery method.
        push: push,
        sort: arr.sort,
        splice: arr.splice
    };
    jQuery.extend = jQuery.fn.extend = function() {
        var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
        // Handle a deep copy situation
        if (typeof target === "boolean") {
            deep = target;
            // Skip the boolean and the target
            target = arguments[i] || {};
            i++;
        }
        // Handle case when target is a string or something (possible in deep copy)
        if (typeof target !== "object" && !isFunction(target)) target = {};
        // Extend jQuery itself if only one argument is passed
        if (i === length) {
            target = this;
            i--;
        }
        for(; i < length; i++){
            // Only deal with non-null/undefined values
            if ((options = arguments[i]) != null) // Extend the base object
            for(name in options){
                copy = options[name];
                // Prevent Object.prototype pollution
                // Prevent never-ending loop
                if (name === "__proto__" || target === copy) continue;
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
                    src = target[name];
                    // Ensure proper type for the source value
                    if (copyIsArray && !Array.isArray(src)) clone = [];
                    else if (!copyIsArray && !jQuery.isPlainObject(src)) clone = {};
                    else clone = src;
                    copyIsArray = false;
                    // Never move original objects, clone them
                    target[name] = jQuery.extend(deep, clone, copy);
                // Don't bring in undefined values
                } else if (copy !== undefined) target[name] = copy;
            }
        }
        // Return the modified object
        return target;
    };
    jQuery.extend({
        // Unique for each copy of jQuery on the page
        expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
        // Assume jQuery is ready without the ready module
        isReady: true,
        error: function(msg) {
            throw new Error(msg);
        },
        noop: function() {},
        isPlainObject: function(obj) {
            var proto, Ctor;
            // Detect obvious negatives
            // Use toString instead of jQuery.type to catch host objects
            if (!obj || toString.call(obj) !== "[object Object]") return false;
            proto = getProto(obj);
            // Objects with no prototype (e.g., `Object.create( null )`) are plain
            if (!proto) return true;
            // Objects with prototype are plain iff they were constructed by a global Object function
            Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
            return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
        },
        isEmptyObject: function(obj) {
            var name;
            for(name in obj)return false;
            return true;
        },
        // Evaluates a script in a provided context; falls back to the global one
        // if not specified.
        globalEval: function(code, options, doc) {
            DOMEval(code, {
                nonce: options && options.nonce
            }, doc);
        },
        each: function(obj, callback) {
            var length, i = 0;
            if (isArrayLike(obj)) {
                length = obj.length;
                for(; i < length; i++){
                    if (callback.call(obj[i], i, obj[i]) === false) break;
                }
            } else for(i in obj){
                if (callback.call(obj[i], i, obj[i]) === false) break;
            }
            return obj;
        },
        // Retrieve the text value of an array of DOM nodes
        text: function(elem) {
            var node, ret = "", i = 0, nodeType = elem.nodeType;
            if (!nodeType) // If no nodeType, this is expected to be an array
            while(node = elem[i++])// Do not traverse comment nodes
            ret += jQuery.text(node);
            if (nodeType === 1 || nodeType === 11) return elem.textContent;
            if (nodeType === 9) return elem.documentElement.textContent;
            if (nodeType === 3 || nodeType === 4) return elem.nodeValue;
            // Do not include comment or processing instruction nodes
            return ret;
        },
        // results is for internal usage only
        makeArray: function(arr, results) {
            var ret = results || [];
            if (arr != null) {
                if (isArrayLike(Object(arr))) jQuery.merge(ret, typeof arr === "string" ? [
                    arr
                ] : arr);
                else push.call(ret, arr);
            }
            return ret;
        },
        inArray: function(elem, arr, i) {
            return arr == null ? -1 : indexOf.call(arr, elem, i);
        },
        isXMLDoc: function(elem) {
            var namespace = elem && elem.namespaceURI, docElem = elem && (elem.ownerDocument || elem).documentElement;
            // Assume HTML when documentElement doesn't yet exist, such as inside
            // document fragments.
            return !rhtmlSuffix.test(namespace || docElem && docElem.nodeName || "HTML");
        },
        // Support: Android <=4.0 only, PhantomJS 1 only
        // push.apply(_, arraylike) throws on ancient WebKit
        merge: function(first, second) {
            var len = +second.length, j = 0, i = first.length;
            for(; j < len; j++)first[i++] = second[j];
            first.length = i;
            return first;
        },
        grep: function(elems, callback, invert) {
            var callbackInverse, matches = [], i = 0, length = elems.length, callbackExpect = !invert;
            // Go through the array, only saving the items
            // that pass the validator function
            for(; i < length; i++){
                callbackInverse = !callback(elems[i], i);
                if (callbackInverse !== callbackExpect) matches.push(elems[i]);
            }
            return matches;
        },
        // arg is for internal usage only
        map: function(elems, callback, arg) {
            var length, value, i = 0, ret = [];
            // Go through the array, translating each of the items to their new values
            if (isArrayLike(elems)) {
                length = elems.length;
                for(; i < length; i++){
                    value = callback(elems[i], i, arg);
                    if (value != null) ret.push(value);
                }
            // Go through every key on the object,
            } else for(i in elems){
                value = callback(elems[i], i, arg);
                if (value != null) ret.push(value);
            }
            // Flatten any nested arrays
            return flat(ret);
        },
        // A global GUID counter for objects
        guid: 1,
        // jQuery.support is not used in Core but other projects attach their
        // properties to it so it needs to exist.
        support: support
    });
    if (typeof Symbol === "function") jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
    // Populate the class2type map
    jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(_i, name) {
        class2type["[object " + name + "]"] = name.toLowerCase();
    });
    function isArrayLike(obj) {
        // Support: real iOS 8.2 only (not reproducible in simulator)
        // `in` check used to prevent JIT error (gh-2145)
        // hasOwn isn't used here due to false negatives
        // regarding Nodelist length in IE
        var length = !!obj && "length" in obj && obj.length, type = toType(obj);
        if (isFunction(obj) || isWindow(obj)) return false;
        return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
    }
    function nodeName(elem, name) {
        return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
    }
    var pop = arr.pop;
    var sort = arr.sort;
    var splice = arr.splice;
    var whitespace = "[\\x20\\t\\r\\n\\f]";
    var rtrimCSS = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g");
    // Note: an element does not contain itself
    jQuery.contains = function(a, b) {
        var bup = b && b.parentNode;
        return a === bup || !!(bup && bup.nodeType === 1 && // Support: IE 9 - 11+
        // IE doesn't have `contains` on SVG.
        (a.contains ? a.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
    };
    // CSS string/identifier serialization
    // https://drafts.csswg.org/cssom/#common-serializing-idioms
    var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
    function fcssescape(ch, asCodePoint) {
        if (asCodePoint) {
            // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
            if (ch === "\0") return "\uFFFD";
            // Control characters and (dependent upon position) numbers get escaped as code points
            return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
        }
        // Other potentially-special ASCII characters get backslash-escaped
        return "\\" + ch;
    }
    jQuery.escapeSelector = function(sel) {
        return (sel + "").replace(rcssescape, fcssescape);
    };
    var preferredDoc = document, pushNative = push;
    (function() {
        var i, Expr, outermostContext, sortInput, hasDuplicate, push = pushNative, // Local document vars
        document, documentElement, documentIsHTML, rbuggyQSA, matches, // Instance-specific data
        expando = jQuery.expando, dirruns = 0, done = 0, classCache = createCache(), tokenCache = createCache(), compilerCache = createCache(), nonnativeSelectorCache = createCache(), sortOrder = function(a, b) {
            if (a === b) hasDuplicate = true;
            return 0;
        }, booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", // Regular expressions
        // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
        identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+", // Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
        attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + // Operator (capture 2)
        "*([*^$|!~]?=)" + whitespace + // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
        "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]", pseudos = ":(" + identifier + ")(?:\\((" + // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
        // 1. quoted (capture 3; capture 4 or capture 5)
        "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" + // 2. simple (capture 6)
        "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" + // 3. anything else (capture 2)
        ".*" + ")\\)|)", // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
        rwhitespace = new RegExp(whitespace + "+", "g"), rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"), rleadingCombinator = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"), rdescend = new RegExp(whitespace + "|>"), rpseudo = new RegExp(pseudos), ridentifier = new RegExp("^" + identifier + "$"), matchExpr = {
            ID: new RegExp("^#(" + identifier + ")"),
            CLASS: new RegExp("^\\.(" + identifier + ")"),
            TAG: new RegExp("^(" + identifier + "|[*])"),
            ATTR: new RegExp("^" + attributes),
            PSEUDO: new RegExp("^" + pseudos),
            CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
            bool: new RegExp("^(?:" + booleans + ")$", "i"),
            // For use in libraries implementing .is()
            // We use this for POS matching in `select`
            needsContext: new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
        }, rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, // Easily-parseable/retrievable ID or TAG or CLASS selectors
        rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, rsibling = /[+~]/, // CSS escapes
        // https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
        runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"), funescape = function(escape, nonHex) {
            var high = "0x" + escape.slice(1) - 0x10000;
            if (nonHex) // Strip the backslash prefix from a non-hex escape sequence
            return nonHex;
            // Replace a hexadecimal escape sequence with the encoded Unicode code point
            // Support: IE <=11+
            // For values outside the Basic Multilingual Plane (BMP), manually construct a
            // surrogate pair
            return high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
        }, // Used for iframes; see `setDocument`.
        // Support: IE 9 - 11+, Edge 12 - 18+
        // Removing the function wrapper causes a "Permission Denied"
        // error in IE/Edge.
        unloadHandler = function() {
            setDocument();
        }, inDisabledFieldset = addCombinator(function(elem) {
            return elem.disabled === true && nodeName(elem, "fieldset");
        }, {
            dir: "parentNode",
            next: "legend"
        });
        // Support: IE <=9 only
        // Accessing document.activeElement can throw unexpectedly
        // https://bugs.jquery.com/ticket/13393
        function safeActiveElement() {
            try {
                return document.activeElement;
            } catch (err) {}
        }
        // Optimize for push.apply( _, NodeList )
        try {
            push.apply(arr = slice.call(preferredDoc.childNodes), preferredDoc.childNodes);
            // Support: Android <=4.0
            // Detect silently failing push.apply
            // eslint-disable-next-line no-unused-expressions
            arr[preferredDoc.childNodes.length].nodeType;
        } catch (e) {
            push = {
                apply: function(target, els) {
                    pushNative.apply(target, slice.call(els));
                },
                call: function(target) {
                    pushNative.apply(target, slice.call(arguments, 1));
                }
            };
        }
        function find(selector, context, results, seed) {
            var m, i, elem, nid, match, groups, newSelector, newContext = context && context.ownerDocument, // nodeType defaults to 9, since context defaults to document
            nodeType = context ? context.nodeType : 9;
            results = results || [];
            // Return early from calls with invalid selector or context
            if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) return results;
            // Try to shortcut find operations (as opposed to filters) in HTML documents
            if (!seed) {
                setDocument(context);
                context = context || document;
                if (documentIsHTML) {
                    // If the selector is sufficiently simple, try using a "get*By*" DOM method
                    // (excepting DocumentFragment context, where the methods don't exist)
                    if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {
                        // ID selector
                        if (m = match[1]) {
                            // Document context
                            if (nodeType === 9) {
                                if (elem = context.getElementById(m)) // Support: IE 9 only
                                // getElementById can match elements by name instead of ID
                                {
                                    if (elem.id === m) {
                                        push.call(results, elem);
                                        return results;
                                    }
                                } else return results;
                            // Element context
                            } else // Support: IE 9 only
                            // getElementById can match elements by name instead of ID
                            if (newContext && (elem = newContext.getElementById(m)) && find.contains(context, elem) && elem.id === m) {
                                push.call(results, elem);
                                return results;
                            }
                        // Type selector
                        } else if (match[2]) {
                            push.apply(results, context.getElementsByTagName(selector));
                            return results;
                        // Class selector
                        } else if ((m = match[3]) && context.getElementsByClassName) {
                            push.apply(results, context.getElementsByClassName(m));
                            return results;
                        }
                    }
                    // Take advantage of querySelectorAll
                    if (!nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
                        newSelector = selector;
                        newContext = context;
                        // qSA considers elements outside a scoping root when evaluating child or
                        // descendant combinators, which is not what we want.
                        // In such cases, we work around the behavior by prefixing every selector in the
                        // list with an ID selector referencing the scope context.
                        // The technique has to be used as well when a leading combinator is used
                        // as such selectors are not recognized by querySelectorAll.
                        // Thanks to Andrew Dupont for this technique.
                        if (nodeType === 1 && (rdescend.test(selector) || rleadingCombinator.test(selector))) {
                            // Expand context for sibling selectors
                            newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
                            // We can use :scope instead of the ID hack if the browser
                            // supports it & if we're not changing the context.
                            // Support: IE 11+, Edge 17 - 18+
                            // IE/Edge sometimes throw a "Permission denied" error when
                            // strict-comparing two documents; shallow comparisons work.
                            // eslint-disable-next-line eqeqeq
                            if (newContext != context || !support.scope) {
                                // Capture the context ID, setting it first if necessary
                                if (nid = context.getAttribute("id")) nid = jQuery.escapeSelector(nid);
                                else context.setAttribute("id", nid = expando);
                            }
                            // Prefix every selector in the list
                            groups = tokenize(selector);
                            i = groups.length;
                            while(i--)groups[i] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i]);
                            newSelector = groups.join(",");
                        }
                        try {
                            push.apply(results, newContext.querySelectorAll(newSelector));
                            return results;
                        } catch (qsaError) {
                            nonnativeSelectorCache(selector, true);
                        } finally{
                            if (nid === expando) context.removeAttribute("id");
                        }
                    }
                }
            }
            // All others
            return select(selector.replace(rtrimCSS, "$1"), context, results, seed);
        }
        /**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */ function createCache() {
            var keys = [];
            function cache(key, value) {
                // Use (key + " ") to avoid collision with native prototype properties
                // (see https://github.com/jquery/sizzle/issues/157)
                if (keys.push(key + " ") > Expr.cacheLength) // Only keep the most recent entries
                delete cache[keys.shift()];
                return cache[key + " "] = value;
            }
            return cache;
        }
        /**
 * Mark a function for special use by jQuery selector module
 * @param {Function} fn The function to mark
 */ function markFunction(fn) {
            fn[expando] = true;
            return fn;
        }
        /**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */ function assert(fn) {
            var el = document.createElement("fieldset");
            try {
                return !!fn(el);
            } catch (e) {
                return false;
            } finally{
                // Remove from its parent by default
                if (el.parentNode) el.parentNode.removeChild(el);
                // release memory in IE
                el = null;
            }
        }
        /**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */ function createInputPseudo(type) {
            return function(elem) {
                return nodeName(elem, "input") && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */ function createButtonPseudo(type) {
            return function(elem) {
                return (nodeName(elem, "input") || nodeName(elem, "button")) && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */ function createDisabledPseudo(disabled) {
            // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
            return function(elem) {
                // Only certain elements can match :enabled or :disabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
                if ("form" in elem) {
                    // Check for inherited disabledness on relevant non-disabled elements:
                    // * listed form-associated elements in a disabled fieldset
                    //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
                    // * option elements in a disabled optgroup
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
                    // All such elements have a "form" property.
                    if (elem.parentNode && elem.disabled === false) {
                        // Option elements defer to a parent optgroup if present
                        if ("label" in elem) {
                            if ("label" in elem.parentNode) return elem.parentNode.disabled === disabled;
                            else return elem.disabled === disabled;
                        }
                        // Support: IE 6 - 11+
                        // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                        return elem.isDisabled === disabled || // Where there is no isDisabled, check manually
                        elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
                    }
                    return elem.disabled === disabled;
                // Try to winnow out elements that can't be disabled before trusting the disabled property.
                // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
                // even exist on them, let alone have a boolean value.
                } else if ("label" in elem) return elem.disabled === disabled;
                // Remaining elements are neither :enabled nor :disabled
                return false;
            };
        }
        /**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */ function createPositionalPseudo(fn) {
            return markFunction(function(argument) {
                argument = +argument;
                return markFunction(function(seed, matches) {
                    var j, matchIndexes = fn([], seed.length, argument), i = matchIndexes.length;
                    // Match elements found at the specified indexes
                    while(i--)if (seed[j = matchIndexes[i]]) seed[j] = !(matches[j] = seed[j]);
                });
            });
        }
        /**
 * Checks a node for validity as a jQuery selector context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */ function testContext(context) {
            return context && typeof context.getElementsByTagName !== "undefined" && context;
        }
        /**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [node] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */ function setDocument(node) {
            var subWindow, doc = node ? node.ownerDocument || node : preferredDoc;
            // Return early if doc is invalid or already selected
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (doc == document || doc.nodeType !== 9 || !doc.documentElement) return document;
            // Update global variables
            document = doc;
            documentElement = document.documentElement;
            documentIsHTML = !jQuery.isXMLDoc(document);
            // Support: iOS 7 only, IE 9 - 11+
            // Older browsers didn't support unprefixed `matches`.
            matches = documentElement.matches || documentElement.webkitMatchesSelector || documentElement.msMatchesSelector;
            // Support: IE 9 - 11+, Edge 12 - 18+
            // Accessing iframe documents after unload throws "permission denied" errors
            // (see trac-13936).
            // Limit the fix to IE & Edge Legacy; despite Edge 15+ implementing `matches`,
            // all IE 9+ and Edge Legacy versions implement `msMatchesSelector` as well.
            if (documentElement.msMatchesSelector && // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            preferredDoc != document && (subWindow = document.defaultView) && subWindow.top !== subWindow) // Support: IE 9 - 11+, Edge 12 - 18+
            subWindow.addEventListener("unload", unloadHandler);
            // Support: IE <10
            // Check if getElementById returns elements by name
            // The broken getElementById methods don't pick up programmatically-set names,
            // so use a roundabout getElementsByName test
            support.getById = assert(function(el) {
                documentElement.appendChild(el).id = jQuery.expando;
                return !document.getElementsByName || !document.getElementsByName(jQuery.expando).length;
            });
            // Support: IE 9 only
            // Check to see if it's possible to do matchesSelector
            // on a disconnected node.
            support.disconnectedMatch = assert(function(el) {
                return matches.call(el, "*");
            });
            // Support: IE 9 - 11+, Edge 12 - 18+
            // IE/Edge don't support the :scope pseudo-class.
            support.scope = assert(function() {
                return document.querySelectorAll(":scope");
            });
            // Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
            // Make sure the `:has()` argument is parsed unforgivingly.
            // We include `*` in the test to detect buggy implementations that are
            // _selectively_ forgiving (specifically when the list includes at least
            // one valid selector).
            // Note that we treat complete lack of support for `:has()` as if it were
            // spec-compliant support, which is fine because use of `:has()` in such
            // environments will fail in the qSA path and fall back to jQuery traversal
            // anyway.
            support.cssHas = assert(function() {
                try {
                    document.querySelector(":has(*,:jqfake)");
                    return false;
                } catch (e) {
                    return true;
                }
            });
            // ID filter and find
            if (support.getById) {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        return elem.getAttribute("id") === attrId;
                    };
                };
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var elem = context.getElementById(id);
                        return elem ? [
                            elem
                        ] : [];
                    }
                };
            } else {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
                        return node && node.value === attrId;
                    };
                };
                // Support: IE 6 - 7 only
                // getElementById is not reliable as a find shortcut
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var node, i, elems, elem = context.getElementById(id);
                        if (elem) {
                            // Verify the id attribute
                            node = elem.getAttributeNode("id");
                            if (node && node.value === id) return [
                                elem
                            ];
                            // Fall back on getElementsByName
                            elems = context.getElementsByName(id);
                            i = 0;
                            while(elem = elems[i++]){
                                node = elem.getAttributeNode("id");
                                if (node && node.value === id) return [
                                    elem
                                ];
                            }
                        }
                        return [];
                    }
                };
            }
            // Tag
            Expr.find.TAG = function(tag, context) {
                if (typeof context.getElementsByTagName !== "undefined") return context.getElementsByTagName(tag);
                else return context.querySelectorAll(tag);
            };
            // Class
            Expr.find.CLASS = function(className, context) {
                if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) return context.getElementsByClassName(className);
            };
            /* QSA/matchesSelector
	---------------------------------------------------------------------- */ // QSA and matchesSelector support
            rbuggyQSA = [];
            // Build QSA regex
            // Regex strategy adopted from Diego Perini
            assert(function(el) {
                var input;
                documentElement.appendChild(el).innerHTML = "<a id='" + expando + "' href='' disabled='disabled'></a>" + "<select id='" + expando + "-\r\\' disabled='disabled'>" + "<option selected=''></option></select>";
                // Support: iOS <=7 - 8 only
                // Boolean attributes and "value" are not treated correctly in some XML documents
                if (!el.querySelectorAll("[selected]").length) rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
                // Support: iOS <=7 - 8 only
                if (!el.querySelectorAll("[id~=" + expando + "-]").length) rbuggyQSA.push("~=");
                // Support: iOS 8 only
                // https://bugs.webkit.org/show_bug.cgi?id=136851
                // In-page `selector#id sibling-combinator selector` fails
                if (!el.querySelectorAll("a#" + expando + "+*").length) rbuggyQSA.push(".#.+[+~]");
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                if (!el.querySelectorAll(":checked").length) rbuggyQSA.push(":checked");
                // Support: Windows 8 Native Apps
                // The type and name attributes are restricted during .innerHTML assignment
                input = document.createElement("input");
                input.setAttribute("type", "hidden");
                el.appendChild(input).setAttribute("name", "D");
                // Support: IE 9 - 11+
                // IE's :disabled selector does not pick up the children of disabled fieldsets
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                documentElement.appendChild(el).disabled = true;
                if (el.querySelectorAll(":disabled").length !== 2) rbuggyQSA.push(":enabled", ":disabled");
                // Support: IE 11+, Edge 15 - 18+
                // IE 11/Edge don't find elements on a `[name='']` query in some cases.
                // Adding a temporary attribute to the document before the selection works
                // around the issue.
                // Interestingly, IE 10 & older don't seem to have the issue.
                input = document.createElement("input");
                input.setAttribute("name", "");
                el.appendChild(input);
                if (!el.querySelectorAll("[name='']").length) rbuggyQSA.push("\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + "*(?:''|\"\")");
            });
            if (!support.cssHas) // Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
            // Our regular `try-catch` mechanism fails to detect natively-unsupported
            // pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
            // in browsers that parse the `:has()` argument as a forgiving selector list.
            // https://drafts.csswg.org/selectors/#relational now requires the argument
            // to be parsed unforgivingly, but browsers have not yet fully adjusted.
            rbuggyQSA.push(":has");
            rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
            /* Sorting
	---------------------------------------------------------------------- */ // Document order sorting
            sortOrder = function(a, b) {
                // Flag for duplicate removal
                if (a === b) {
                    hasDuplicate = true;
                    return 0;
                }
                // Sort on method existence if only one input has compareDocumentPosition
                var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
                if (compare) return compare;
                // Calculate position if both inputs belong to the same document
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                compare = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) : // Otherwise we know they are disconnected
                1;
                // Disconnected nodes
                if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
                    // Choose the first element that is related to our preferred document
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (a === document || a.ownerDocument == preferredDoc && find.contains(preferredDoc, a)) return -1;
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (b === document || b.ownerDocument == preferredDoc && find.contains(preferredDoc, b)) return 1;
                    // Maintain original order
                    return sortInput ? indexOf.call(sortInput, a) - indexOf.call(sortInput, b) : 0;
                }
                return compare & 4 ? -1 : 1;
            };
            return document;
        }
        find.matches = function(expr, elements) {
            return find(expr, null, null, elements);
        };
        find.matchesSelector = function(elem, expr) {
            setDocument(elem);
            if (documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyQSA || !rbuggyQSA.test(expr))) try {
                var ret = matches.call(elem, expr);
                // IE 9's matchesSelector returns false on disconnected nodes
                if (ret || support.disconnectedMatch || // As well, disconnected nodes are said to be in a document
                // fragment in IE 9
                elem.document && elem.document.nodeType !== 11) return ret;
            } catch (e) {
                nonnativeSelectorCache(expr, true);
            }
            return find(expr, document, null, [
                elem
            ]).length > 0;
        };
        find.contains = function(context, elem) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((context.ownerDocument || context) != document) setDocument(context);
            return jQuery.contains(context, elem);
        };
        find.attr = function(elem, name) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((elem.ownerDocument || elem) != document) setDocument(elem);
            var fn = Expr.attrHandle[name.toLowerCase()], // Don't get fooled by Object.prototype properties (see trac-13807)
            val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
            if (val !== undefined) return val;
            return elem.getAttribute(name);
        };
        find.error = function(msg) {
            throw new Error("Syntax error, unrecognized expression: " + msg);
        };
        /**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */ jQuery.uniqueSort = function(results) {
            var elem, duplicates = [], j = 0, i = 0;
            // Unless we *know* we can detect duplicates, assume their presence
            //
            // Support: Android <=4.0+
            // Testing for detecting duplicates is unpredictable so instead assume we can't
            // depend on duplicate detection in all browsers without a stable sort.
            hasDuplicate = !support.sortStable;
            sortInput = !support.sortStable && slice.call(results, 0);
            sort.call(results, sortOrder);
            if (hasDuplicate) {
                while(elem = results[i++])if (elem === results[i]) j = duplicates.push(i);
                while(j--)splice.call(results, duplicates[j], 1);
            }
            // Clear input after sorting to release objects
            // See https://github.com/jquery/sizzle/pull/225
            sortInput = null;
            return results;
        };
        jQuery.fn.uniqueSort = function() {
            return this.pushStack(jQuery.uniqueSort(slice.apply(this)));
        };
        Expr = jQuery.expr = {
            // Can be adjusted by the user
            cacheLength: 50,
            createPseudo: markFunction,
            match: matchExpr,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: true
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: true
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                ATTR: function(match) {
                    match[1] = match[1].replace(runescape, funescape);
                    // Move the given value to match[3] whether quoted or unquoted
                    match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
                    if (match[2] === "~=") match[3] = " " + match[3] + " ";
                    return match.slice(0, 4);
                },
                CHILD: function(match) {
                    /* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/ match[1] = match[1].toLowerCase();
                    if (match[1].slice(0, 3) === "nth") {
                        // nth-* requires argument
                        if (!match[3]) find.error(match[0]);
                        // numeric x and y parameters for Expr.filter.CHILD
                        // remember that false/true cast respectively to 0/1
                        match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
                        match[5] = +(match[7] + match[8] || match[3] === "odd");
                    // other types prohibit arguments
                    } else if (match[3]) find.error(match[0]);
                    return match;
                },
                PSEUDO: function(match) {
                    var excess, unquoted = !match[6] && match[2];
                    if (matchExpr.CHILD.test(match[0])) return null;
                    // Accept quoted arguments as-is
                    if (match[3]) match[2] = match[4] || match[5] || "";
                    else if (unquoted && rpseudo.test(unquoted) && // Get excess from tokenize (recursively)
                    (excess = tokenize(unquoted, true)) && // advance to the next closing parenthesis
                    (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
                        // excess is a negative index
                        match[0] = match[0].slice(0, excess);
                        match[2] = unquoted.slice(0, excess);
                    }
                    // Return only captures needed by the pseudo filter method (type and argument)
                    return match.slice(0, 3);
                }
            },
            filter: {
                TAG: function(nodeNameSelector) {
                    var expectedNodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
                    return nodeNameSelector === "*" ? function() {
                        return true;
                    } : function(elem) {
                        return nodeName(elem, expectedNodeName);
                    };
                },
                CLASS: function(className) {
                    var pattern = classCache[className + " "];
                    return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)"), classCache(className, function(elem) {
                        return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
                    }));
                },
                ATTR: function(name, operator, check) {
                    return function(elem) {
                        var result = find.attr(elem, name);
                        if (result == null) return operator === "!=";
                        if (!operator) return true;
                        result += "";
                        if (operator === "=") return result === check;
                        if (operator === "!=") return result !== check;
                        if (operator === "^=") return check && result.indexOf(check) === 0;
                        if (operator === "*=") return check && result.indexOf(check) > -1;
                        if (operator === "$=") return check && result.slice(-check.length) === check;
                        if (operator === "~=") return (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1;
                        if (operator === "|=") return result === check || result.slice(0, check.length + 1) === check + "-";
                        return false;
                    };
                },
                CHILD: function(type, what, _argument, first, last) {
                    var simple = type.slice(0, 3) !== "nth", forward = type.slice(-4) !== "last", ofType = what === "of-type";
                    return first === 1 && last === 0 ? // Shortcut for :nth-*(n)
                    function(elem) {
                        return !!elem.parentNode;
                    } : function(elem, _context, xml) {
                        var cache, outerCache, node, nodeIndex, start, dir = simple !== forward ? "nextSibling" : "previousSibling", parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType, diff = false;
                        if (parent) {
                            // :(first|last|only)-(child|of-type)
                            if (simple) {
                                while(dir){
                                    node = elem;
                                    while(node = node[dir]){
                                        if (ofType ? nodeName(node, name) : node.nodeType === 1) return false;
                                    }
                                    // Reverse direction for :only-* (if we haven't yet done so)
                                    start = dir = type === "only" && !start && "nextSibling";
                                }
                                return true;
                            }
                            start = [
                                forward ? parent.firstChild : parent.lastChild
                            ];
                            // non-xml :nth-child(...) stores cache data on `parent`
                            if (forward && useCache) {
                                // Seek `elem` from a previously-cached index
                                outerCache = parent[expando] || (parent[expando] = {});
                                cache = outerCache[type] || [];
                                nodeIndex = cache[0] === dirruns && cache[1];
                                diff = nodeIndex && cache[2];
                                node = nodeIndex && parent.childNodes[nodeIndex];
                                while(node = ++nodeIndex && node && node[dir] || // Fallback to seeking `elem` from the start
                                (diff = nodeIndex = 0) || start.pop())// When found, cache indexes on `parent` and break
                                if (node.nodeType === 1 && ++diff && node === elem) {
                                    outerCache[type] = [
                                        dirruns,
                                        nodeIndex,
                                        diff
                                    ];
                                    break;
                                }
                            } else {
                                // Use previously-cached element index if available
                                if (useCache) {
                                    outerCache = elem[expando] || (elem[expando] = {});
                                    cache = outerCache[type] || [];
                                    nodeIndex = cache[0] === dirruns && cache[1];
                                    diff = nodeIndex;
                                }
                                // xml :nth-child(...)
                                // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                                if (diff === false) {
                                    // Use the same loop as above to seek `elem` from the start
                                    while(node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop())if ((ofType ? nodeName(node, name) : node.nodeType === 1) && ++diff) {
                                        // Cache the index of each encountered element
                                        if (useCache) {
                                            outerCache = node[expando] || (node[expando] = {});
                                            outerCache[type] = [
                                                dirruns,
                                                diff
                                            ];
                                        }
                                        if (node === elem) break;
                                    }
                                }
                            }
                            // Incorporate the offset, then check against cycle size
                            diff -= last;
                            return diff === first || diff % first === 0 && diff / first >= 0;
                        }
                    };
                },
                PSEUDO: function(pseudo, argument) {
                    // pseudo-class names are case-insensitive
                    // https://www.w3.org/TR/selectors/#pseudo-classes
                    // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                    // Remember that setFilters inherits from pseudos
                    var args, fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || find.error("unsupported pseudo: " + pseudo);
                    // The user may use createPseudo to indicate that
                    // arguments are needed to create the filter function
                    // just as jQuery does
                    if (fn[expando]) return fn(argument);
                    // But maintain support for old signatures
                    if (fn.length > 1) {
                        args = [
                            pseudo,
                            pseudo,
                            "",
                            argument
                        ];
                        return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function(seed, matches) {
                            var idx, matched = fn(seed, argument), i = matched.length;
                            while(i--){
                                idx = indexOf.call(seed, matched[i]);
                                seed[idx] = !(matches[idx] = matched[i]);
                            }
                        }) : function(elem) {
                            return fn(elem, 0, args);
                        };
                    }
                    return fn;
                }
            },
            pseudos: {
                // Potentially complex pseudos
                not: markFunction(function(selector) {
                    // Trim the selector passed to compile
                    // to avoid treating leading and trailing
                    // spaces as combinators
                    var input = [], results = [], matcher = compile(selector.replace(rtrimCSS, "$1"));
                    return matcher[expando] ? markFunction(function(seed, matches, _context, xml) {
                        var elem, unmatched = matcher(seed, null, xml, []), i = seed.length;
                        // Match elements unmatched by `matcher`
                        while(i--)if (elem = unmatched[i]) seed[i] = !(matches[i] = elem);
                    }) : function(elem, _context, xml) {
                        input[0] = elem;
                        matcher(input, null, xml, results);
                        // Don't keep the element
                        // (see https://github.com/jquery/sizzle/issues/299)
                        input[0] = null;
                        return !results.pop();
                    };
                }),
                has: markFunction(function(selector) {
                    return function(elem) {
                        return find(selector, elem).length > 0;
                    };
                }),
                contains: markFunction(function(text) {
                    text = text.replace(runescape, funescape);
                    return function(elem) {
                        return (elem.textContent || jQuery.text(elem)).indexOf(text) > -1;
                    };
                }),
                // "Whether an element is represented by a :lang() selector
                // is based solely on the element's language value
                // being equal to the identifier C,
                // or beginning with the identifier C immediately followed by "-".
                // The matching of C against the element's language value is performed case-insensitively.
                // The identifier C does not have to be a valid language name."
                // https://www.w3.org/TR/selectors/#lang-pseudo
                lang: markFunction(function(lang) {
                    // lang value must be a valid identifier
                    if (!ridentifier.test(lang || "")) find.error("unsupported lang: " + lang);
                    lang = lang.replace(runescape, funescape).toLowerCase();
                    return function(elem) {
                        var elemLang;
                        do if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
                            elemLang = elemLang.toLowerCase();
                            return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
                        }
                        while ((elem = elem.parentNode) && elem.nodeType === 1);
                        return false;
                    };
                }),
                // Miscellaneous
                target: function(elem) {
                    var hash = window1.location && window1.location.hash;
                    return hash && hash.slice(1) === elem.id;
                },
                root: function(elem) {
                    return elem === documentElement;
                },
                focus: function(elem) {
                    return elem === safeActiveElement() && document.hasFocus() && !!(elem.type || elem.href || ~elem.tabIndex);
                },
                // Boolean properties
                enabled: createDisabledPseudo(false),
                disabled: createDisabledPseudo(true),
                checked: function(elem) {
                    // In CSS3, :checked should return both checked and selected elements
                    // https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    return nodeName(elem, "input") && !!elem.checked || nodeName(elem, "option") && !!elem.selected;
                },
                selected: function(elem) {
                    // Support: IE <=11+
                    // Accessing the selectedIndex property
                    // forces the browser to treat the default option as
                    // selected when in an optgroup.
                    if (elem.parentNode) // eslint-disable-next-line no-unused-expressions
                    elem.parentNode.selectedIndex;
                    return elem.selected === true;
                },
                // Contents
                empty: function(elem) {
                    // https://www.w3.org/TR/selectors/#empty-pseudo
                    // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                    //   but not by others (comment: 8; processing instruction: 7; etc.)
                    // nodeType < 6 works because attributes (2) do not appear as children
                    for(elem = elem.firstChild; elem; elem = elem.nextSibling){
                        if (elem.nodeType < 6) return false;
                    }
                    return true;
                },
                parent: function(elem) {
                    return !Expr.pseudos.empty(elem);
                },
                // Element/input types
                header: function(elem) {
                    return rheader.test(elem.nodeName);
                },
                input: function(elem) {
                    return rinputs.test(elem.nodeName);
                },
                button: function(elem) {
                    return nodeName(elem, "input") && elem.type === "button" || nodeName(elem, "button");
                },
                text: function(elem) {
                    var attr;
                    return nodeName(elem, "input") && elem.type === "text" && // Support: IE <10 only
                    // New HTML5 attribute values (e.g., "search") appear
                    // with elem.type === "text"
                    ((attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
                },
                // Position-in-collection
                first: createPositionalPseudo(function() {
                    return [
                        0
                    ];
                }),
                last: createPositionalPseudo(function(_matchIndexes, length) {
                    return [
                        length - 1
                    ];
                }),
                eq: createPositionalPseudo(function(_matchIndexes, length, argument) {
                    return [
                        argument < 0 ? argument + length : argument
                    ];
                }),
                even: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 0;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                odd: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 1;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                lt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i;
                    if (argument < 0) i = argument + length;
                    else if (argument > length) i = length;
                    else i = argument;
                    for(; --i >= 0;)matchIndexes.push(i);
                    return matchIndexes;
                }),
                gt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i = argument < 0 ? argument + length : argument;
                    for(; ++i < length;)matchIndexes.push(i);
                    return matchIndexes;
                })
            }
        };
        Expr.pseudos.nth = Expr.pseudos.eq;
        // Add button/input type pseudos
        for(i in {
            radio: true,
            checkbox: true,
            file: true,
            password: true,
            image: true
        })Expr.pseudos[i] = createInputPseudo(i);
        for(i in {
            submit: true,
            reset: true
        })Expr.pseudos[i] = createButtonPseudo(i);
        // Easy API for creating new setFilters
        function setFilters() {}
        setFilters.prototype = Expr.filters = Expr.pseudos;
        Expr.setFilters = new setFilters();
        function tokenize(selector, parseOnly) {
            var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + " "];
            if (cached) return parseOnly ? 0 : cached.slice(0);
            soFar = selector;
            groups = [];
            preFilters = Expr.preFilter;
            while(soFar){
                // Comma and first run
                if (!matched || (match = rcomma.exec(soFar))) {
                    if (match) // Don't consume trailing commas as valid
                    soFar = soFar.slice(match[0].length) || soFar;
                    groups.push(tokens = []);
                }
                matched = false;
                // Combinators
                if (match = rleadingCombinator.exec(soFar)) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        // Cast descendant combinators to space
                        type: match[0].replace(rtrimCSS, " ")
                    });
                    soFar = soFar.slice(matched.length);
                }
                // Filters
                for(type in Expr.filter)if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        type: type,
                        matches: match
                    });
                    soFar = soFar.slice(matched.length);
                }
                if (!matched) break;
            }
            // Return the length of the invalid excess
            // if we're just parsing
            // Otherwise, throw an error or return tokens
            if (parseOnly) return soFar.length;
            return soFar ? find.error(selector) : // Cache the tokens
            tokenCache(selector, groups).slice(0);
        }
        function toSelector(tokens) {
            var i = 0, len = tokens.length, selector = "";
            for(; i < len; i++)selector += tokens[i].value;
            return selector;
        }
        function addCombinator(matcher, combinator, base) {
            var dir = combinator.dir, skip = combinator.next, key = skip || dir, checkNonElements = base && key === "parentNode", doneName = done++;
            return combinator.first ? // Check against closest ancestor/preceding element
            function(elem, context, xml) {
                while(elem = elem[dir]){
                    if (elem.nodeType === 1 || checkNonElements) return matcher(elem, context, xml);
                }
                return false;
            } : // Check against all ancestor/preceding elements
            function(elem, context, xml) {
                var oldCache, outerCache, newCache = [
                    dirruns,
                    doneName
                ];
                // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
                if (xml) {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        if (matcher(elem, context, xml)) return true;
                    }
                } else {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        outerCache = elem[expando] || (elem[expando] = {});
                        if (skip && nodeName(elem, skip)) elem = elem[dir] || elem;
                        else if ((oldCache = outerCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) // Assign to newCache so results back-propagate to previous elements
                        return newCache[2] = oldCache[2];
                        else {
                            // Reuse newcache so results back-propagate to previous elements
                            outerCache[key] = newCache;
                            // A match means we're done; a fail means we have to keep checking
                            if (newCache[2] = matcher(elem, context, xml)) return true;
                        }
                    }
                }
                return false;
            };
        }
        function elementMatcher(matchers) {
            return matchers.length > 1 ? function(elem, context, xml) {
                var i = matchers.length;
                while(i--){
                    if (!matchers[i](elem, context, xml)) return false;
                }
                return true;
            } : matchers[0];
        }
        function multipleContexts(selector, contexts, results) {
            var i = 0, len = contexts.length;
            for(; i < len; i++)find(selector, contexts[i], results);
            return results;
        }
        function condense(unmatched, map, filter, context, xml) {
            var elem, newUnmatched = [], i = 0, len = unmatched.length, mapped = map != null;
            for(; i < len; i++){
                if (elem = unmatched[i]) {
                    if (!filter || filter(elem, context, xml)) {
                        newUnmatched.push(elem);
                        if (mapped) map.push(i);
                    }
                }
            }
            return newUnmatched;
        }
        function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
            if (postFilter && !postFilter[expando]) postFilter = setMatcher(postFilter);
            if (postFinder && !postFinder[expando]) postFinder = setMatcher(postFinder, postSelector);
            return markFunction(function(seed, results, context, xml) {
                var temp, i, elem, matcherOut, preMap = [], postMap = [], preexisting = results.length, // Get initial elements from seed or context
                elems = seed || multipleContexts(selector || "*", context.nodeType ? [
                    context
                ] : context, []), // Prefilter to get matcher input, preserving a map for seed-results synchronization
                matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems;
                if (matcher) {
                    // If we have a postFinder, or filtered seed, or non-seed postFilter
                    // or preexisting results,
                    matcherOut = postFinder || (seed ? preFilter : preexisting || postFilter) ? // ...intermediate processing is necessary
                    [] : // ...otherwise use results directly
                    results;
                    // Find primary matches
                    matcher(matcherIn, matcherOut, context, xml);
                } else matcherOut = matcherIn;
                // Apply postFilter
                if (postFilter) {
                    temp = condense(matcherOut, postMap);
                    postFilter(temp, [], context, xml);
                    // Un-match failing elements by moving them back to matcherIn
                    i = temp.length;
                    while(i--)if (elem = temp[i]) matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
                }
                if (seed) {
                    if (postFinder || preFilter) {
                        if (postFinder) {
                            // Get the final matcherOut by condensing this intermediate into postFinder contexts
                            temp = [];
                            i = matcherOut.length;
                            while(i--)if (elem = matcherOut[i]) // Restore matcherIn since elem is not yet a final match
                            temp.push(matcherIn[i] = elem);
                            postFinder(null, matcherOut = [], temp, xml);
                        }
                        // Move matched elements from seed to results to keep them synchronized
                        i = matcherOut.length;
                        while(i--)if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf.call(seed, elem) : preMap[i]) > -1) seed[temp] = !(results[temp] = elem);
                    }
                } else {
                    matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
                    if (postFinder) postFinder(null, results, matcherOut, xml);
                    else push.apply(results, matcherOut);
                }
            });
        }
        function matcherFromTokens(tokens) {
            var checkContext, matcher, j, len = tokens.length, leadingRelative = Expr.relative[tokens[0].type], implicitRelative = leadingRelative || Expr.relative[" "], i = leadingRelative ? 1 : 0, // The foundational matcher ensures that elements are reachable from top-level context(s)
            matchContext = addCombinator(function(elem) {
                return elem === checkContext;
            }, implicitRelative, true), matchAnyContext = addCombinator(function(elem) {
                return indexOf.call(checkContext, elem) > -1;
            }, implicitRelative, true), matchers = [
                function(elem, context, xml) {
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    var ret = !leadingRelative && (xml || context != outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
                    // Avoid hanging onto element
                    // (see https://github.com/jquery/sizzle/issues/299)
                    checkContext = null;
                    return ret;
                }
            ];
            for(; i < len; i++)if (matcher = Expr.relative[tokens[i].type]) matchers = [
                addCombinator(elementMatcher(matchers), matcher)
            ];
            else {
                matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);
                // Return special upon seeing a positional matcher
                if (matcher[expando]) {
                    // Find the next relative operator (if any) for proper handling
                    j = ++i;
                    for(; j < len; j++){
                        if (Expr.relative[tokens[j].type]) break;
                    }
                    return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(// If the preceding token was a descendant combinator, insert an implicit any-element `*`
                    tokens.slice(0, i - 1).concat({
                        value: tokens[i - 2].type === " " ? "*" : ""
                    })).replace(rtrimCSS, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
                }
                matchers.push(matcher);
            }
            return elementMatcher(matchers);
        }
        function matcherFromGroupMatchers(elementMatchers, setMatchers) {
            var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function(seed, context, xml, results, outermost) {
                var elem, j, matcher, matchedCount = 0, i = "0", unmatched = seed && [], setMatched = [], contextBackup = outermostContext, // We must always have either seed elements or outermost context
                elems = seed || byElement && Expr.find.TAG("*", outermost), // Use integer dirruns iff this is the outermost matcher
                dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1, len = elems.length;
                if (outermost) // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                outermostContext = context == document || context || outermost;
                // Add elements passing elementMatchers directly to results
                // Support: iOS <=7 - 9 only
                // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
                // elements by id. (see trac-14142)
                for(; i !== len && (elem = elems[i]) != null; i++){
                    if (byElement && elem) {
                        j = 0;
                        // Support: IE 11+, Edge 17 - 18+
                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        // eslint-disable-next-line eqeqeq
                        if (!context && elem.ownerDocument != document) {
                            setDocument(elem);
                            xml = !documentIsHTML;
                        }
                        while(matcher = elementMatchers[j++])if (matcher(elem, context || document, xml)) {
                            push.call(results, elem);
                            break;
                        }
                        if (outermost) dirruns = dirrunsUnique;
                    }
                    // Track unmatched elements for set filters
                    if (bySet) {
                        // They will have gone through all possible matchers
                        if (elem = !matcher && elem) matchedCount--;
                        // Lengthen the array for every element, matched or not
                        if (seed) unmatched.push(elem);
                    }
                }
                // `i` is now the count of elements visited above, and adding it to `matchedCount`
                // makes the latter nonnegative.
                matchedCount += i;
                // Apply set filters to unmatched elements
                // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
                // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
                // no element matchers and no seed.
                // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
                // case, which will result in a "00" `matchedCount` that differs from `i` but is also
                // numerically zero.
                if (bySet && i !== matchedCount) {
                    j = 0;
                    while(matcher = setMatchers[j++])matcher(unmatched, setMatched, context, xml);
                    if (seed) {
                        // Reintegrate element matches to eliminate the need for sorting
                        if (matchedCount > 0) {
                            while(i--)if (!(unmatched[i] || setMatched[i])) setMatched[i] = pop.call(results);
                        }
                        // Discard index placeholder values to get only actual matches
                        setMatched = condense(setMatched);
                    }
                    // Add matches to results
                    push.apply(results, setMatched);
                    // Seedless set matches succeeding multiple successful matchers stipulate sorting
                    if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) jQuery.uniqueSort(results);
                }
                // Override manipulation of globals by nested matchers
                if (outermost) {
                    dirruns = dirrunsUnique;
                    outermostContext = contextBackup;
                }
                return unmatched;
            };
            return bySet ? markFunction(superMatcher) : superMatcher;
        }
        function compile(selector, match /* Internal Use Only */ ) {
            var i, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + " "];
            if (!cached) {
                // Generate a function of recursive functions that can be used to check each element
                if (!match) match = tokenize(selector);
                i = match.length;
                while(i--){
                    cached = matcherFromTokens(match[i]);
                    if (cached[expando]) setMatchers.push(cached);
                    else elementMatchers.push(cached);
                }
                // Cache the compiled function
                cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
                // Save selector and tokenization
                cached.selector = selector;
            }
            return cached;
        }
        /**
 * A low-level selection function that works with jQuery's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with jQuery selector compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */ function select(selector, context, results, seed) {
            var i, tokens, token, type, find, compiled = typeof selector === "function" && selector, match = !seed && tokenize(selector = compiled.selector || selector);
            results = results || [];
            // Try to minimize operations if there is only one selector in the list and no seed
            // (the latter of which guarantees us context)
            if (match.length === 1) {
                // Reduce context if the leading compound selector is an ID
                tokens = match[0] = match[0].slice(0);
                if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
                    context = (Expr.find.ID(token.matches[0].replace(runescape, funescape), context) || [])[0];
                    if (!context) return results;
                    else if (compiled) context = context.parentNode;
                    selector = selector.slice(tokens.shift().value.length);
                }
                // Fetch a seed set for right-to-left matching
                i = matchExpr.needsContext.test(selector) ? 0 : tokens.length;
                while(i--){
                    token = tokens[i];
                    // Abort if we hit a combinator
                    if (Expr.relative[type = token.type]) break;
                    if (find = Expr.find[type]) // Search, expanding context for leading sibling combinators
                    {
                        if (seed = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
                            // If seed is empty or no tokens remain, we can return early
                            tokens.splice(i, 1);
                            selector = seed.length && toSelector(tokens);
                            if (!selector) {
                                push.apply(results, seed);
                                return results;
                            }
                            break;
                        }
                    }
                }
            }
            // Compile and execute a filtering function if one is not provided
            // Provide `match` to avoid retokenization if we modified the selector above
            (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
            return results;
        }
        // One-time assignments
        // Support: Android <=4.0 - 4.1+
        // Sort stability
        support.sortStable = expando.split("").sort(sortOrder).join("") === expando;
        // Initialize against the default document
        setDocument();
        // Support: Android <=4.0 - 4.1+
        // Detached nodes confoundingly follow *each other*
        support.sortDetached = assert(function(el) {
            // Should return 1, but returns 4 (following)
            return el.compareDocumentPosition(document.createElement("fieldset")) & 1;
        });
        jQuery.find = find;
        // Deprecated
        jQuery.expr[":"] = jQuery.expr.pseudos;
        jQuery.unique = jQuery.uniqueSort;
        // These have always been private, but they used to be documented as part of
        // Sizzle so let's maintain them for now for backwards compatibility purposes.
        find.compile = compile;
        find.select = select;
        find.setDocument = setDocument;
        find.tokenize = tokenize;
        find.escape = jQuery.escapeSelector;
        find.getText = jQuery.text;
        find.isXML = jQuery.isXMLDoc;
        find.selectors = jQuery.expr;
        find.support = jQuery.support;
        find.uniqueSort = jQuery.uniqueSort;
    /* eslint-enable */ })();
    var dir = function(elem, dir, until) {
        var matched = [], truncate = until !== undefined;
        while((elem = elem[dir]) && elem.nodeType !== 9)if (elem.nodeType === 1) {
            if (truncate && jQuery(elem).is(until)) break;
            matched.push(elem);
        }
        return matched;
    };
    var siblings = function(n, elem) {
        var matched = [];
        for(; n; n = n.nextSibling)if (n.nodeType === 1 && n !== elem) matched.push(n);
        return matched;
    };
    var rneedsContext = jQuery.expr.match.needsContext;
    var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    // Implement the identical functionality for filter and not
    function winnow(elements, qualifier, not) {
        if (isFunction(qualifier)) return jQuery.grep(elements, function(elem, i) {
            return !!qualifier.call(elem, i, elem) !== not;
        });
        // Single element
        if (qualifier.nodeType) return jQuery.grep(elements, function(elem) {
            return elem === qualifier !== not;
        });
        // Arraylike of elements (jQuery, arguments, Array)
        if (typeof qualifier !== "string") return jQuery.grep(elements, function(elem) {
            return indexOf.call(qualifier, elem) > -1 !== not;
        });
        // Filtered directly for both simple and complex selectors
        return jQuery.filter(qualifier, elements, not);
    }
    jQuery.filter = function(expr, elems, not) {
        var elem = elems[0];
        if (not) expr = ":not(" + expr + ")";
        if (elems.length === 1 && elem.nodeType === 1) return jQuery.find.matchesSelector(elem, expr) ? [
            elem
        ] : [];
        return jQuery.find.matches(expr, jQuery.grep(elems, function(elem) {
            return elem.nodeType === 1;
        }));
    };
    jQuery.fn.extend({
        find: function(selector) {
            var i, ret, len = this.length, self = this;
            if (typeof selector !== "string") return this.pushStack(jQuery(selector).filter(function() {
                for(i = 0; i < len; i++){
                    if (jQuery.contains(self[i], this)) return true;
                }
            }));
            ret = this.pushStack([]);
            for(i = 0; i < len; i++)jQuery.find(selector, self[i], ret);
            return len > 1 ? jQuery.uniqueSort(ret) : ret;
        },
        filter: function(selector) {
            return this.pushStack(winnow(this, selector || [], false));
        },
        not: function(selector) {
            return this.pushStack(winnow(this, selector || [], true));
        },
        is: function(selector) {
            return !!winnow(this, // If this is a positional/relative selector, check membership in the returned set
            // so $("p:first").is("p:last") won't return true for a doc with two "p".
            typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
        }
    });
    // Initialize a jQuery object
    // A central reference to the root jQuery(document)
    var rootjQuery, // A simple way to check for HTML strings
    // Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
    // Strict HTML recognition (trac-11290: must start with <)
    // Shortcut simple #id case for speed
    rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, init = jQuery.fn.init = function(selector, context, root) {
        var match, elem;
        // HANDLE: $(""), $(null), $(undefined), $(false)
        if (!selector) return this;
        // Method init() accepts an alternate rootjQuery
        // so migrate can support jQuery.sub (gh-2101)
        root = root || rootjQuery;
        // Handle HTML strings
        if (typeof selector === "string") {
            if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) // Assume that strings that start and end with <> are HTML and skip the regex check
            match = [
                null,
                selector,
                null
            ];
            else match = rquickExpr.exec(selector);
            // Match html or make sure no context is specified for #id
            if (match && (match[1] || !context)) {
                // HANDLE: $(html) -> $(array)
                if (match[1]) {
                    context = context instanceof jQuery ? context[0] : context;
                    // Option to run scripts is true for back-compat
                    // Intentionally let the error be thrown if parseHTML is not present
                    jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true));
                    // HANDLE: $(html, props)
                    if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
                        for(match in context)// Properties of context are called as methods if possible
                        if (isFunction(this[match])) this[match](context[match]);
                        else this.attr(match, context[match]);
                    }
                    return this;
                // HANDLE: $(#id)
                } else {
                    elem = document.getElementById(match[2]);
                    if (elem) {
                        // Inject the element directly into the jQuery object
                        this[0] = elem;
                        this.length = 1;
                    }
                    return this;
                }
            } else if (!context || context.jquery) return (context || root).find(selector);
            else return this.constructor(context).find(selector);
        // HANDLE: $(DOMElement)
        } else if (selector.nodeType) {
            this[0] = selector;
            this.length = 1;
            return this;
        // HANDLE: $(function)
        // Shortcut for document ready
        } else if (isFunction(selector)) return root.ready !== undefined ? root.ready(selector) : // Execute immediately if ready is not present
        selector(jQuery);
        return jQuery.makeArray(selector, this);
    };
    // Give the init function the jQuery prototype for later instantiation
    init.prototype = jQuery.fn;
    // Initialize central reference
    rootjQuery = jQuery(document);
    var rparentsprev = /^(?:parents|prev(?:Until|All))/, // Methods guaranteed to produce a unique set when starting from a unique set
    guaranteedUnique = {
        children: true,
        contents: true,
        next: true,
        prev: true
    };
    jQuery.fn.extend({
        has: function(target) {
            var targets = jQuery(target, this), l = targets.length;
            return this.filter(function() {
                var i = 0;
                for(; i < l; i++){
                    if (jQuery.contains(this, targets[i])) return true;
                }
            });
        },
        closest: function(selectors, context) {
            var cur, i = 0, l = this.length, matched = [], targets = typeof selectors !== "string" && jQuery(selectors);
            // Positional selectors never match, since there's no _selection_ context
            if (!rneedsContext.test(selectors)) for(; i < l; i++){
                for(cur = this[i]; cur && cur !== context; cur = cur.parentNode)// Always skip document fragments
                if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 : // Don't pass non-elements to jQuery#find
                cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
                    matched.push(cur);
                    break;
                }
            }
            return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
        },
        // Determine the position of an element within the set
        index: function(elem) {
            // No argument, return index in parent
            if (!elem) return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            // Index in selector
            if (typeof elem === "string") return indexOf.call(jQuery(elem), this[0]);
            // Locate the position of the desired element
            return indexOf.call(this, // If it receives a jQuery object, the first element is used
            elem.jquery ? elem[0] : elem);
        },
        add: function(selector, context) {
            return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
        },
        addBack: function(selector) {
            return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
        }
    });
    function sibling(cur, dir) {
        while((cur = cur[dir]) && cur.nodeType !== 1);
        return cur;
    }
    jQuery.each({
        parent: function(elem) {
            var parent = elem.parentNode;
            return parent && parent.nodeType !== 11 ? parent : null;
        },
        parents: function(elem) {
            return dir(elem, "parentNode");
        },
        parentsUntil: function(elem, _i, until) {
            return dir(elem, "parentNode", until);
        },
        next: function(elem) {
            return sibling(elem, "nextSibling");
        },
        prev: function(elem) {
            return sibling(elem, "previousSibling");
        },
        nextAll: function(elem) {
            return dir(elem, "nextSibling");
        },
        prevAll: function(elem) {
            return dir(elem, "previousSibling");
        },
        nextUntil: function(elem, _i, until) {
            return dir(elem, "nextSibling", until);
        },
        prevUntil: function(elem, _i, until) {
            return dir(elem, "previousSibling", until);
        },
        siblings: function(elem) {
            return siblings((elem.parentNode || {}).firstChild, elem);
        },
        children: function(elem) {
            return siblings(elem.firstChild);
        },
        contents: function(elem) {
            if (elem.contentDocument != null && // Support: IE 11+
            // <object> elements with no `data` attribute has an object
            // `contentDocument` with a `null` prototype.
            getProto(elem.contentDocument)) return elem.contentDocument;
            // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
            // Treat the template element as a regular one in browsers that
            // don't support it.
            if (nodeName(elem, "template")) elem = elem.content || elem;
            return jQuery.merge([], elem.childNodes);
        }
    }, function(name, fn) {
        jQuery.fn[name] = function(until, selector) {
            var matched = jQuery.map(this, fn, until);
            if (name.slice(-5) !== "Until") selector = until;
            if (selector && typeof selector === "string") matched = jQuery.filter(selector, matched);
            if (this.length > 1) {
                // Remove duplicates
                if (!guaranteedUnique[name]) jQuery.uniqueSort(matched);
                // Reverse order for parents* and prev-derivatives
                if (rparentsprev.test(name)) matched.reverse();
            }
            return this.pushStack(matched);
        };
    });
    var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;
    // Convert String-formatted options into Object-formatted ones
    function createOptions(options) {
        var object = {};
        jQuery.each(options.match(rnothtmlwhite) || [], function(_, flag) {
            object[flag] = true;
        });
        return object;
    }
    /*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */ jQuery.Callbacks = function(options) {
        // Convert options from String-formatted to Object-formatted if needed
        // (we check in cache first)
        options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
        var firing, // Last fire value for non-forgettable lists
        memory, // Flag to know if list was already fired
        fired, // Flag to prevent firing
        locked, // Actual callback list
        list = [], // Queue of execution data for repeatable lists
        queue = [], // Index of currently firing callback (modified by add/remove as needed)
        firingIndex = -1, // Fire callbacks
        fire = function() {
            // Enforce single-firing
            locked = locked || options.once;
            // Execute callbacks for all pending executions,
            // respecting firingIndex overrides and runtime changes
            fired = firing = true;
            for(; queue.length; firingIndex = -1){
                memory = queue.shift();
                while(++firingIndex < list.length)// Run callback and check for early termination
                if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
                    // Jump to end and forget the data so .add doesn't re-fire
                    firingIndex = list.length;
                    memory = false;
                }
            }
            // Forget the data if we're done with it
            if (!options.memory) memory = false;
            firing = false;
            // Clean up if we're done firing for good
            if (locked) {
                // Keep an empty list if we have data for future add calls
                if (memory) list = [];
                else list = "";
            }
        }, // Actual Callbacks object
        self = {
            // Add a callback or a collection of callbacks to the list
            add: function() {
                if (list) {
                    // If we have memory from a past run, we should fire after adding
                    if (memory && !firing) {
                        firingIndex = list.length - 1;
                        queue.push(memory);
                    }
                    (function add(args) {
                        jQuery.each(args, function(_, arg) {
                            if (isFunction(arg)) {
                                if (!options.unique || !self.has(arg)) list.push(arg);
                            } else if (arg && arg.length && toType(arg) !== "string") // Inspect recursively
                            add(arg);
                        });
                    })(arguments);
                    if (memory && !firing) fire();
                }
                return this;
            },
            // Remove a callback from the list
            remove: function() {
                jQuery.each(arguments, function(_, arg) {
                    var index;
                    while((index = jQuery.inArray(arg, list, index)) > -1){
                        list.splice(index, 1);
                        // Handle firing indexes
                        if (index <= firingIndex) firingIndex--;
                    }
                });
                return this;
            },
            // Check if a given callback is in the list.
            // If no argument is given, return whether or not list has callbacks attached.
            has: function(fn) {
                return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
            },
            // Remove all callbacks from the list
            empty: function() {
                if (list) list = [];
                return this;
            },
            // Disable .fire and .add
            // Abort any current/pending executions
            // Clear all callbacks and values
            disable: function() {
                locked = queue = [];
                list = memory = "";
                return this;
            },
            disabled: function() {
                return !list;
            },
            // Disable .fire
            // Also disable .add unless we have memory (since it would have no effect)
            // Abort any pending executions
            lock: function() {
                locked = queue = [];
                if (!memory && !firing) list = memory = "";
                return this;
            },
            locked: function() {
                return !!locked;
            },
            // Call all callbacks with the given context and arguments
            fireWith: function(context, args) {
                if (!locked) {
                    args = args || [];
                    args = [
                        context,
                        args.slice ? args.slice() : args
                    ];
                    queue.push(args);
                    if (!firing) fire();
                }
                return this;
            },
            // Call all the callbacks with the given arguments
            fire: function() {
                self.fireWith(this, arguments);
                return this;
            },
            // To know if the callbacks have already been called at least once
            fired: function() {
                return !!fired;
            }
        };
        return self;
    };
    function Identity(v) {
        return v;
    }
    function Thrower(ex) {
        throw ex;
    }
    function adoptValue(value, resolve, reject, noValue) {
        var method;
        try {
            // Check for promise aspect first to privilege synchronous behavior
            if (value && isFunction(method = value.promise)) method.call(value).done(resolve).fail(reject);
            else if (value && isFunction(method = value.then)) method.call(value, resolve, reject);
            else // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
            // * false: [ value ].slice( 0 ) => resolve( value )
            // * true: [ value ].slice( 1 ) => resolve()
            resolve.apply(undefined, [
                value
            ].slice(noValue));
        // For Promises/A+, convert exceptions into rejections
        // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
        // Deferred#then to conditionally suppress rejection.
        } catch (value) {
            // Support: Android 4.0 only
            // Strict mode functions invoked without .call/.apply get global-object context
            reject.apply(undefined, [
                value
            ]);
        }
    }
    jQuery.extend({
        Deferred: function(func) {
            var tuples = [
                // action, add listener, callbacks,
                // ... .then handlers, argument index, [final state]
                [
                    "notify",
                    "progress",
                    jQuery.Callbacks("memory"),
                    jQuery.Callbacks("memory"),
                    2
                ],
                [
                    "resolve",
                    "done",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    0,
                    "resolved"
                ],
                [
                    "reject",
                    "fail",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    1,
                    "rejected"
                ]
            ], state = "pending", promise = {
                state: function() {
                    return state;
                },
                always: function() {
                    deferred.done(arguments).fail(arguments);
                    return this;
                },
                "catch": function(fn) {
                    return promise.then(null, fn);
                },
                // Keep pipe for back-compat
                pipe: function() {
                    var fns = arguments;
                    return jQuery.Deferred(function(newDefer) {
                        jQuery.each(tuples, function(_i, tuple) {
                            // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                            var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];
                            // deferred.progress(function() { bind to newDefer or newDefer.notify })
                            // deferred.done(function() { bind to newDefer or newDefer.resolve })
                            // deferred.fail(function() { bind to newDefer or newDefer.reject })
                            deferred[tuple[1]](function() {
                                var returned = fn && fn.apply(this, arguments);
                                if (returned && isFunction(returned.promise)) returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                                else newDefer[tuple[0] + "With"](this, fn ? [
                                    returned
                                ] : arguments);
                            });
                        });
                        fns = null;
                    }).promise();
                },
                then: function(onFulfilled, onRejected, onProgress) {
                    var maxDepth = 0;
                    function resolve(depth, deferred, handler, special) {
                        return function() {
                            var that = this, args = arguments, mightThrow = function() {
                                var returned, then;
                                // Support: Promises/A+ section 2.3.3.3.3
                                // https://promisesaplus.com/#point-59
                                // Ignore double-resolution attempts
                                if (depth < maxDepth) return;
                                returned = handler.apply(that, args);
                                // Support: Promises/A+ section 2.3.1
                                // https://promisesaplus.com/#point-48
                                if (returned === deferred.promise()) throw new TypeError("Thenable self-resolution");
                                // Support: Promises/A+ sections 2.3.3.1, 3.5
                                // https://promisesaplus.com/#point-54
                                // https://promisesaplus.com/#point-75
                                // Retrieve `then` only once
                                then = returned && // Support: Promises/A+ section 2.3.4
                                // https://promisesaplus.com/#point-64
                                // Only check objects and functions for thenability
                                (typeof returned === "object" || typeof returned === "function") && returned.then;
                                // Handle a returned thenable
                                if (isFunction(then)) {
                                    // Special processors (notify) just wait for resolution
                                    if (special) then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));
                                    else {
                                        // ...and disregard older resolution values
                                        maxDepth++;
                                        then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
                                    }
                                } else {
                                    // Only substitute handlers pass on context
                                    // and multiple values (non-spec behavior)
                                    if (handler !== Identity) {
                                        that = undefined;
                                        args = [
                                            returned
                                        ];
                                    }
                                    // Process the value(s)
                                    // Default process is resolve
                                    (special || deferred.resolveWith)(that, args);
                                }
                            }, // Only normal processors (resolve) catch and reject exceptions
                            process = special ? mightThrow : function() {
                                try {
                                    mightThrow();
                                } catch (e) {
                                    if (jQuery.Deferred.exceptionHook) jQuery.Deferred.exceptionHook(e, process.error);
                                    // Support: Promises/A+ section 2.3.3.3.4.1
                                    // https://promisesaplus.com/#point-61
                                    // Ignore post-resolution exceptions
                                    if (depth + 1 >= maxDepth) {
                                        // Only substitute handlers pass on context
                                        // and multiple values (non-spec behavior)
                                        if (handler !== Thrower) {
                                            that = undefined;
                                            args = [
                                                e
                                            ];
                                        }
                                        deferred.rejectWith(that, args);
                                    }
                                }
                            };
                            // Support: Promises/A+ section 2.3.3.3.1
                            // https://promisesaplus.com/#point-57
                            // Re-resolve promises immediately to dodge false rejection from
                            // subsequent errors
                            if (depth) process();
                            else {
                                // Call an optional hook to record the error, in case of exception
                                // since it's otherwise lost when execution goes async
                                if (jQuery.Deferred.getErrorHook) process.error = jQuery.Deferred.getErrorHook();
                                else if (jQuery.Deferred.getStackHook) process.error = jQuery.Deferred.getStackHook();
                                window1.setTimeout(process);
                            }
                        };
                    }
                    return jQuery.Deferred(function(newDefer) {
                        // progress_handlers.add( ... )
                        tuples[0][3].add(resolve(0, newDefer, isFunction(onProgress) ? onProgress : Identity, newDefer.notifyWith));
                        // fulfilled_handlers.add( ... )
                        tuples[1][3].add(resolve(0, newDefer, isFunction(onFulfilled) ? onFulfilled : Identity));
                        // rejected_handlers.add( ... )
                        tuples[2][3].add(resolve(0, newDefer, isFunction(onRejected) ? onRejected : Thrower));
                    }).promise();
                },
                // Get a promise for this deferred
                // If obj is provided, the promise aspect is added to the object
                promise: function(obj) {
                    return obj != null ? jQuery.extend(obj, promise) : promise;
                }
            }, deferred = {};
            // Add list-specific methods
            jQuery.each(tuples, function(i, tuple) {
                var list = tuple[2], stateString = tuple[5];
                // promise.progress = list.add
                // promise.done = list.add
                // promise.fail = list.add
                promise[tuple[1]] = list.add;
                // Handle state
                if (stateString) list.add(function() {
                    // state = "resolved" (i.e., fulfilled)
                    // state = "rejected"
                    state = stateString;
                }, // rejected_callbacks.disable
                // fulfilled_callbacks.disable
                tuples[3 - i][2].disable, // rejected_handlers.disable
                // fulfilled_handlers.disable
                tuples[3 - i][3].disable, // progress_callbacks.lock
                tuples[0][2].lock, // progress_handlers.lock
                tuples[0][3].lock);
                // progress_handlers.fire
                // fulfilled_handlers.fire
                // rejected_handlers.fire
                list.add(tuple[3].fire);
                // deferred.notify = function() { deferred.notifyWith(...) }
                // deferred.resolve = function() { deferred.resolveWith(...) }
                // deferred.reject = function() { deferred.rejectWith(...) }
                deferred[tuple[0]] = function() {
                    deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
                    return this;
                };
                // deferred.notifyWith = list.fireWith
                // deferred.resolveWith = list.fireWith
                // deferred.rejectWith = list.fireWith
                deferred[tuple[0] + "With"] = list.fireWith;
            });
            // Make the deferred a promise
            promise.promise(deferred);
            // Call given func if any
            if (func) func.call(deferred, deferred);
            // All done!
            return deferred;
        },
        // Deferred helper
        when: function(singleValue) {
            var // count of uncompleted subordinates
            remaining = arguments.length, // count of unprocessed arguments
            i = remaining, // subordinate fulfillment data
            resolveContexts = Array(i), resolveValues = slice.call(arguments), // the primary Deferred
            primary = jQuery.Deferred(), // subordinate callback factory
            updateFunc = function(i) {
                return function(value) {
                    resolveContexts[i] = this;
                    resolveValues[i] = arguments.length > 1 ? slice.call(arguments) : value;
                    if (!--remaining) primary.resolveWith(resolveContexts, resolveValues);
                };
            };
            // Single- and empty arguments are adopted like Promise.resolve
            if (remaining <= 1) {
                adoptValue(singleValue, primary.done(updateFunc(i)).resolve, primary.reject, !remaining);
                // Use .then() to unwrap secondary thenables (cf. gh-3000)
                if (primary.state() === "pending" || isFunction(resolveValues[i] && resolveValues[i].then)) return primary.then();
            }
            // Multiple arguments are aggregated like Promise.all array elements
            while(i--)adoptValue(resolveValues[i], updateFunc(i), primary.reject);
            return primary.promise();
        }
    });
    // These usually indicate a programmer mistake during development,
    // warn about them ASAP rather than swallowing them by default.
    var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    // If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
    // captured before the async barrier to get the original error cause
    // which may otherwise be hidden.
    jQuery.Deferred.exceptionHook = function(error, asyncError) {
        // Support: IE 8 - 9 only
        // Console exists when dev tools are open, which can happen at any time
        if (window1.console && window1.console.warn && error && rerrorNames.test(error.name)) window1.console.warn("jQuery.Deferred exception: " + error.message, error.stack, asyncError);
    };
    jQuery.readyException = function(error) {
        window1.setTimeout(function() {
            throw error;
        });
    };
    // The deferred used on DOM ready
    var readyList = jQuery.Deferred();
    jQuery.fn.ready = function(fn) {
        readyList.then(fn)// Wrap jQuery.readyException in a function so that the lookup
        // happens at the time of error handling instead of callback
        // registration.
        .catch(function(error) {
            jQuery.readyException(error);
        });
        return this;
    };
    jQuery.extend({
        // Is the DOM ready to be used? Set to true once it occurs.
        isReady: false,
        // A counter to track how many items to wait for before
        // the ready event fires. See trac-6781
        readyWait: 1,
        // Handle when the DOM is ready
        ready: function(wait) {
            // Abort if there are pending holds or we're already ready
            if (wait === true ? --jQuery.readyWait : jQuery.isReady) return;
            // Remember that the DOM is ready
            jQuery.isReady = true;
            // If a normal DOM Ready event fired, decrement, and wait if need be
            if (wait !== true && --jQuery.readyWait > 0) return;
            // If there are functions bound, to execute
            readyList.resolveWith(document, [
                jQuery
            ]);
        }
    });
    jQuery.ready.then = readyList.then;
    // The ready event handler and self cleanup method
    function completed() {
        document.removeEventListener("DOMContentLoaded", completed);
        window1.removeEventListener("load", completed);
        jQuery.ready();
    }
    // Catch cases where $(document).ready() is called
    // after the browser event has already occurred.
    // Support: IE <=9 - 10 only
    // Older IE sometimes signals "interactive" too soon
    if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) // Handle it asynchronously to allow scripts the opportunity to delay ready
    window1.setTimeout(jQuery.ready);
    else {
        // Use the handy event callback
        document.addEventListener("DOMContentLoaded", completed);
        // A fallback to window.onload, that will always work
        window1.addEventListener("load", completed);
    }
    // Multifunctional method to get and set values of a collection
    // The value/s can optionally be executed if it's a function
    var access = function(elems, fn, key, value, chainable, emptyGet, raw) {
        var i = 0, len = elems.length, bulk = key == null;
        // Sets many values
        if (toType(key) === "object") {
            chainable = true;
            for(i in key)access(elems, fn, i, key[i], true, emptyGet, raw);
        // Sets one value
        } else if (value !== undefined) {
            chainable = true;
            if (!isFunction(value)) raw = true;
            if (bulk) {
                // Bulk operations run against the entire set
                if (raw) {
                    fn.call(elems, value);
                    fn = null;
                // ...except when executing function values
                } else {
                    bulk = fn;
                    fn = function(elem, _key, value) {
                        return bulk.call(jQuery(elem), value);
                    };
                }
            }
            if (fn) for(; i < len; i++)fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
        }
        if (chainable) return elems;
        // Gets
        if (bulk) return fn.call(elems);
        return len ? fn(elems[0], key) : emptyGet;
    };
    // Matches dashed string for camelizing
    var rmsPrefix = /^-ms-/, rdashAlpha = /-([a-z])/g;
    // Used by camelCase as callback to replace()
    function fcamelCase(_all, letter) {
        return letter.toUpperCase();
    }
    // Convert dashed to camelCase; used by the css and data modules
    // Support: IE <=9 - 11, Edge 12 - 15
    // Microsoft forgot to hump their vendor prefix (trac-9572)
    function camelCase(string) {
        return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
    }
    var acceptData = function(owner) {
        // Accepts only:
        //  - Node
        //    - Node.ELEMENT_NODE
        //    - Node.DOCUMENT_NODE
        //  - Object
        //    - Any
        return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
    };
    function Data() {
        this.expando = jQuery.expando + Data.uid++;
    }
    Data.uid = 1;
    Data.prototype = {
        cache: function(owner) {
            // Check if the owner object already has a cache
            var value = owner[this.expando];
            // If not, create one
            if (!value) {
                value = {};
                // We can accept data for non-element nodes in modern browsers,
                // but we should not, see trac-8335.
                // Always return an empty object.
                if (acceptData(owner)) {
                    // If it is a node unlikely to be stringify-ed or looped over
                    // use plain assignment
                    if (owner.nodeType) owner[this.expando] = value;
                    else Object.defineProperty(owner, this.expando, {
                        value: value,
                        configurable: true
                    });
                }
            }
            return value;
        },
        set: function(owner, data, value) {
            var prop, cache = this.cache(owner);
            // Handle: [ owner, key, value ] args
            // Always use camelCase key (gh-2257)
            if (typeof data === "string") cache[camelCase(data)] = value;
            else // Copy the properties one-by-one to the cache object
            for(prop in data)cache[camelCase(prop)] = data[prop];
            return cache;
        },
        get: function(owner, key) {
            return key === undefined ? this.cache(owner) : // Always use camelCase key (gh-2257)
            owner[this.expando] && owner[this.expando][camelCase(key)];
        },
        access: function(owner, key, value) {
            // In cases where either:
            //
            //   1. No key was specified
            //   2. A string key was specified, but no value provided
            //
            // Take the "read" path and allow the get method to determine
            // which value to return, respectively either:
            //
            //   1. The entire cache object
            //   2. The data stored at the key
            //
            if (key === undefined || key && typeof key === "string" && value === undefined) return this.get(owner, key);
            // When the key is not a string, or both a key and value
            // are specified, set or extend (existing objects) with either:
            //
            //   1. An object of properties
            //   2. A key and value
            //
            this.set(owner, key, value);
            // Since the "set" path can have two possible entry points
            // return the expected data based on which path was taken[*]
            return value !== undefined ? value : key;
        },
        remove: function(owner, key) {
            var i, cache = owner[this.expando];
            if (cache === undefined) return;
            if (key !== undefined) {
                // Support array or space separated string of keys
                if (Array.isArray(key)) // If key is an array of keys...
                // We always set camelCase keys, so remove that.
                key = key.map(camelCase);
                else {
                    key = camelCase(key);
                    // If a key with the spaces exists, use it.
                    // Otherwise, create an array by matching non-whitespace
                    key = key in cache ? [
                        key
                    ] : key.match(rnothtmlwhite) || [];
                }
                i = key.length;
                while(i--)delete cache[key[i]];
            }
            // Remove the expando if there's no more data
            if (key === undefined || jQuery.isEmptyObject(cache)) {
                // Support: Chrome <=35 - 45
                // Webkit & Blink performance suffers when deleting properties
                // from DOM nodes, so set to undefined instead
                // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
                if (owner.nodeType) owner[this.expando] = undefined;
                else delete owner[this.expando];
            }
        },
        hasData: function(owner) {
            var cache = owner[this.expando];
            return cache !== undefined && !jQuery.isEmptyObject(cache);
        }
    };
    var dataPriv = new Data();
    var dataUser = new Data();
    //	Implementation Summary
    //
    //	1. Enforce API surface and semantic compatibility with 1.9.x branch
    //	2. Improve the module's maintainability by reducing the storage
    //		paths to a single mechanism.
    //	3. Use the same single mechanism to support "private" and "user" data.
    //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
    //	5. Avoid exposing implementation details on user objects (eg. expando properties)
    //	6. Provide a clear path for implementation upgrade to WeakMap in 2014
    var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, rmultiDash = /[A-Z]/g;
    function getData(data) {
        if (data === "true") return true;
        if (data === "false") return false;
        if (data === "null") return null;
        // Only convert to a number if it doesn't change the string
        if (data === +data + "") return +data;
        if (rbrace.test(data)) return JSON.parse(data);
        return data;
    }
    function dataAttr(elem, key, data) {
        var name;
        // If nothing was found internally, try to fetch any
        // data from the HTML5 data-* attribute
        if (data === undefined && elem.nodeType === 1) {
            name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
            data = elem.getAttribute(name);
            if (typeof data === "string") {
                try {
                    data = getData(data);
                } catch (e) {}
                // Make sure we set the data so it isn't changed later
                dataUser.set(elem, key, data);
            } else data = undefined;
        }
        return data;
    }
    jQuery.extend({
        hasData: function(elem) {
            return dataUser.hasData(elem) || dataPriv.hasData(elem);
        },
        data: function(elem, name, data) {
            return dataUser.access(elem, name, data);
        },
        removeData: function(elem, name) {
            dataUser.remove(elem, name);
        },
        // TODO: Now that all calls to _data and _removeData have been replaced
        // with direct calls to dataPriv methods, these can be deprecated.
        _data: function(elem, name, data) {
            return dataPriv.access(elem, name, data);
        },
        _removeData: function(elem, name) {
            dataPriv.remove(elem, name);
        }
    });
    jQuery.fn.extend({
        data: function(key, value) {
            var i, name, data, elem = this[0], attrs = elem && elem.attributes;
            // Gets all values
            if (key === undefined) {
                if (this.length) {
                    data = dataUser.get(elem);
                    if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
                        i = attrs.length;
                        while(i--)// Support: IE 11 only
                        // The attrs elements can be null (trac-14894)
                        if (attrs[i]) {
                            name = attrs[i].name;
                            if (name.indexOf("data-") === 0) {
                                name = camelCase(name.slice(5));
                                dataAttr(elem, name, data[name]);
                            }
                        }
                        dataPriv.set(elem, "hasDataAttrs", true);
                    }
                }
                return data;
            }
            // Sets multiple values
            if (typeof key === "object") return this.each(function() {
                dataUser.set(this, key);
            });
            return access(this, function(value) {
                var data;
                // The calling jQuery object (element matches) is not empty
                // (and therefore has an element appears at this[ 0 ]) and the
                // `value` parameter was not undefined. An empty jQuery object
                // will result in `undefined` for elem = this[ 0 ] which will
                // throw an exception if an attempt to read a data cache is made.
                if (elem && value === undefined) {
                    // Attempt to get data from the cache
                    // The key will always be camelCased in Data
                    data = dataUser.get(elem, key);
                    if (data !== undefined) return data;
                    // Attempt to "discover" the data in
                    // HTML5 custom data-* attrs
                    data = dataAttr(elem, key);
                    if (data !== undefined) return data;
                    // We tried really hard, but the data doesn't exist.
                    return;
                }
                // Set the data...
                this.each(function() {
                    // We always store the camelCased key
                    dataUser.set(this, key, value);
                });
            }, null, value, arguments.length > 1, null, true);
        },
        removeData: function(key) {
            return this.each(function() {
                dataUser.remove(this, key);
            });
        }
    });
    jQuery.extend({
        queue: function(elem, type, data) {
            var queue;
            if (elem) {
                type = (type || "fx") + "queue";
                queue = dataPriv.get(elem, type);
                // Speed up dequeue by getting out quickly if this is just a lookup
                if (data) {
                    if (!queue || Array.isArray(data)) queue = dataPriv.access(elem, type, jQuery.makeArray(data));
                    else queue.push(data);
                }
                return queue || [];
            }
        },
        dequeue: function(elem, type) {
            type = type || "fx";
            var queue = jQuery.queue(elem, type), startLength = queue.length, fn = queue.shift(), hooks = jQuery._queueHooks(elem, type), next = function() {
                jQuery.dequeue(elem, type);
            };
            // If the fx queue is dequeued, always remove the progress sentinel
            if (fn === "inprogress") {
                fn = queue.shift();
                startLength--;
            }
            if (fn) {
                // Add a progress sentinel to prevent the fx queue from being
                // automatically dequeued
                if (type === "fx") queue.unshift("inprogress");
                // Clear up the last queue stop function
                delete hooks.stop;
                fn.call(elem, next, hooks);
            }
            if (!startLength && hooks) hooks.empty.fire();
        },
        // Not public - generate a queueHooks object, or return the current one
        _queueHooks: function(elem, type) {
            var key = type + "queueHooks";
            return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
                empty: jQuery.Callbacks("once memory").add(function() {
                    dataPriv.remove(elem, [
                        type + "queue",
                        key
                    ]);
                })
            });
        }
    });
    jQuery.fn.extend({
        queue: function(type, data) {
            var setter = 2;
            if (typeof type !== "string") {
                data = type;
                type = "fx";
                setter--;
            }
            if (arguments.length < setter) return jQuery.queue(this[0], type);
            return data === undefined ? this : this.each(function() {
                var queue = jQuery.queue(this, type, data);
                // Ensure a hooks for this queue
                jQuery._queueHooks(this, type);
                if (type === "fx" && queue[0] !== "inprogress") jQuery.dequeue(this, type);
            });
        },
        dequeue: function(type) {
            return this.each(function() {
                jQuery.dequeue(this, type);
            });
        },
        clearQueue: function(type) {
            return this.queue(type || "fx", []);
        },
        // Get a promise resolved when queues of a certain type
        // are emptied (fx is the type by default)
        promise: function(type, obj) {
            var tmp, count = 1, defer = jQuery.Deferred(), elements = this, i = this.length, resolve = function() {
                if (!--count) defer.resolveWith(elements, [
                    elements
                ]);
            };
            if (typeof type !== "string") {
                obj = type;
                type = undefined;
            }
            type = type || "fx";
            while(i--){
                tmp = dataPriv.get(elements[i], type + "queueHooks");
                if (tmp && tmp.empty) {
                    count++;
                    tmp.empty.add(resolve);
                }
            }
            resolve();
            return defer.promise(obj);
        }
    });
    var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
    var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
    var cssExpand = [
        "Top",
        "Right",
        "Bottom",
        "Left"
    ];
    var documentElement = document.documentElement;
    var isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem);
    }, composed = {
        composed: true
    };
    // Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
    // Check attachment across shadow DOM boundaries when possible (gh-3504)
    // Support: iOS 10.0-10.2 only
    // Early iOS 10 versions support `attachShadow` but not `getRootNode`,
    // leading to errors. We need to check for `getRootNode`.
    if (documentElement.getRootNode) isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
    };
    var isHiddenWithinTree = function(elem, el) {
        // isHiddenWithinTree might be called from jQuery#filter function;
        // in that case, element will be second argument
        elem = el || elem;
        // Inline style trumps all
        return elem.style.display === "none" || elem.style.display === "" && // Otherwise, check computed style
        // Support: Firefox <=43 - 45
        // Disconnected elements can have computed display: none, so first confirm that elem is
        // in the document.
        isAttached(elem) && jQuery.css(elem, "display") === "none";
    };
    function adjustCSS(elem, prop, valueParts, tween) {
        var adjusted, scale, maxIterations = 20, currentValue = tween ? function() {
            return tween.cur();
        } : function() {
            return jQuery.css(elem, prop, "");
        }, initial = currentValue(), unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"), // Starting value computation is required for potential unit mismatches
        initialInUnit = elem.nodeType && (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
        if (initialInUnit && initialInUnit[3] !== unit) {
            // Support: Firefox <=54
            // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
            initial = initial / 2;
            // Trust units reported by jQuery.css
            unit = unit || initialInUnit[3];
            // Iteratively approximate from a nonzero starting point
            initialInUnit = +initial || 1;
            while(maxIterations--){
                // Evaluate and update our best guess (doubling guesses that zero out).
                // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
                jQuery.style(elem, prop, initialInUnit + unit);
                if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) maxIterations = 0;
                initialInUnit = initialInUnit / scale;
            }
            initialInUnit = initialInUnit * 2;
            jQuery.style(elem, prop, initialInUnit + unit);
            // Make sure we update the tween properties later on
            valueParts = valueParts || [];
        }
        if (valueParts) {
            initialInUnit = +initialInUnit || +initial || 0;
            // Apply relative offset (+=/-=) if specified
            adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
            if (tween) {
                tween.unit = unit;
                tween.start = initialInUnit;
                tween.end = adjusted;
            }
        }
        return adjusted;
    }
    var defaultDisplayMap = {};
    function getDefaultDisplay(elem) {
        var temp, doc = elem.ownerDocument, nodeName = elem.nodeName, display = defaultDisplayMap[nodeName];
        if (display) return display;
        temp = doc.body.appendChild(doc.createElement(nodeName));
        display = jQuery.css(temp, "display");
        temp.parentNode.removeChild(temp);
        if (display === "none") display = "block";
        defaultDisplayMap[nodeName] = display;
        return display;
    }
    function showHide(elements, show) {
        var display, elem, values = [], index = 0, length = elements.length;
        // Determine new display value for elements that need to change
        for(; index < length; index++){
            elem = elements[index];
            if (!elem.style) continue;
            display = elem.style.display;
            if (show) {
                // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
                // check is required in this first loop unless we have a nonempty display value (either
                // inline or about-to-be-restored)
                if (display === "none") {
                    values[index] = dataPriv.get(elem, "display") || null;
                    if (!values[index]) elem.style.display = "";
                }
                if (elem.style.display === "" && isHiddenWithinTree(elem)) values[index] = getDefaultDisplay(elem);
            } else if (display !== "none") {
                values[index] = "none";
                // Remember what we're overwriting
                dataPriv.set(elem, "display", display);
            }
        }
        // Set the display of the elements in a second loop to avoid constant reflow
        for(index = 0; index < length; index++)if (values[index] != null) elements[index].style.display = values[index];
        return elements;
    }
    jQuery.fn.extend({
        show: function() {
            return showHide(this, true);
        },
        hide: function() {
            return showHide(this);
        },
        toggle: function(state) {
            if (typeof state === "boolean") return state ? this.show() : this.hide();
            return this.each(function() {
                if (isHiddenWithinTree(this)) jQuery(this).show();
                else jQuery(this).hide();
            });
        }
    });
    var rcheckableType = /^(?:checkbox|radio)$/i;
    var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
    var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;
    (function() {
        var fragment = document.createDocumentFragment(), div = fragment.appendChild(document.createElement("div")), input = document.createElement("input");
        // Support: Android 4.0 - 4.3 only
        // Check state lost if the name is set (trac-11217)
        // Support: Windows Web Apps (WWA)
        // `name` and `type` must use .setAttribute for WWA (trac-14901)
        input.setAttribute("type", "radio");
        input.setAttribute("checked", "checked");
        input.setAttribute("name", "t");
        div.appendChild(input);
        // Support: Android <=4.1 only
        // Older WebKit doesn't clone checked state correctly in fragments
        support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;
        // Support: IE <=11 only
        // Make sure textarea (and checkbox) defaultValue is properly cloned
        div.innerHTML = "<textarea>x</textarea>";
        support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;
        // Support: IE <=9 only
        // IE <=9 replaces <option> tags with their contents when inserted outside of
        // the select element.
        div.innerHTML = "<option></option>";
        support.option = !!div.lastChild;
    })();
    // We have to close these tags to support XHTML (trac-13200)
    var wrapMap = {
        // XHTML parsers do not magically insert elements in the
        // same way that tag soup parsers do. So we cannot shorten
        // this by omitting <tbody> or other required elements.
        thead: [
            1,
            "<table>",
            "</table>"
        ],
        col: [
            2,
            "<table><colgroup>",
            "</colgroup></table>"
        ],
        tr: [
            2,
            "<table><tbody>",
            "</tbody></table>"
        ],
        td: [
            3,
            "<table><tbody><tr>",
            "</tr></tbody></table>"
        ],
        _default: [
            0,
            "",
            ""
        ]
    };
    wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
    wrapMap.th = wrapMap.td;
    // Support: IE <=9 only
    if (!support.option) wrapMap.optgroup = wrapMap.option = [
        1,
        "<select multiple='multiple'>",
        "</select>"
    ];
    function getAll(context, tag) {
        // Support: IE <=9 - 11 only
        // Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
        var ret;
        if (typeof context.getElementsByTagName !== "undefined") ret = context.getElementsByTagName(tag || "*");
        else if (typeof context.querySelectorAll !== "undefined") ret = context.querySelectorAll(tag || "*");
        else ret = [];
        if (tag === undefined || tag && nodeName(context, tag)) return jQuery.merge([
            context
        ], ret);
        return ret;
    }
    // Mark scripts as having already been evaluated
    function setGlobalEval(elems, refElements) {
        var i = 0, l = elems.length;
        for(; i < l; i++)dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
    }
    var rhtml = /<|&#?\w+;/;
    function buildFragment(elems, context, scripts, selection, ignored) {
        var elem, tmp, tag, wrap, attached, j, fragment = context.createDocumentFragment(), nodes = [], i = 0, l = elems.length;
        for(; i < l; i++){
            elem = elems[i];
            if (elem || elem === 0) {
                // Add nodes directly
                if (toType(elem) === "object") // Support: Android <=4.0 only, PhantomJS 1 only
                // push.apply(_, arraylike) throws on ancient WebKit
                jQuery.merge(nodes, elem.nodeType ? [
                    elem
                ] : elem);
                else if (!rhtml.test(elem)) nodes.push(context.createTextNode(elem));
                else {
                    tmp = tmp || fragment.appendChild(context.createElement("div"));
                    // Deserialize a standard representation
                    tag = (rtagName.exec(elem) || [
                        "",
                        ""
                    ])[1].toLowerCase();
                    wrap = wrapMap[tag] || wrapMap._default;
                    tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];
                    // Descend through wrappers to the right content
                    j = wrap[0];
                    while(j--)tmp = tmp.lastChild;
                    // Support: Android <=4.0 only, PhantomJS 1 only
                    // push.apply(_, arraylike) throws on ancient WebKit
                    jQuery.merge(nodes, tmp.childNodes);
                    // Remember the top-level container
                    tmp = fragment.firstChild;
                    // Ensure the created nodes are orphaned (trac-12392)
                    tmp.textContent = "";
                }
            }
        }
        // Remove wrapper from fragment
        fragment.textContent = "";
        i = 0;
        while(elem = nodes[i++]){
            // Skip elements already in the context collection (trac-4087)
            if (selection && jQuery.inArray(elem, selection) > -1) {
                if (ignored) ignored.push(elem);
                continue;
            }
            attached = isAttached(elem);
            // Append to fragment
            tmp = getAll(fragment.appendChild(elem), "script");
            // Preserve script evaluation history
            if (attached) setGlobalEval(tmp);
            // Capture executables
            if (scripts) {
                j = 0;
                while(elem = tmp[j++])if (rscriptType.test(elem.type || "")) scripts.push(elem);
            }
        }
        return fragment;
    }
    var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
    function returnTrue() {
        return true;
    }
    function returnFalse() {
        return false;
    }
    function on(elem, types, selector, data, fn, one) {
        var origFn, type;
        // Types can be a map of types/handlers
        if (typeof types === "object") {
            // ( types-Object, selector, data )
            if (typeof selector !== "string") {
                // ( types-Object, data )
                data = data || selector;
                selector = undefined;
            }
            for(type in types)on(elem, type, selector, data, types[type], one);
            return elem;
        }
        if (data == null && fn == null) {
            // ( types, fn )
            fn = selector;
            data = selector = undefined;
        } else if (fn == null) {
            if (typeof selector === "string") {
                // ( types, selector, fn )
                fn = data;
                data = undefined;
            } else {
                // ( types, data, fn )
                fn = data;
                data = selector;
                selector = undefined;
            }
        }
        if (fn === false) fn = returnFalse;
        else if (!fn) return elem;
        if (one === 1) {
            origFn = fn;
            fn = function(event) {
                // Can use an empty set, since event contains the info
                jQuery().off(event);
                return origFn.apply(this, arguments);
            };
            // Use same guid so caller can remove using origFn
            fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
        }
        return elem.each(function() {
            jQuery.event.add(this, types, fn, data, selector);
        });
    }
    /*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */ jQuery.event = {
        global: {},
        add: function(elem, types, handler, data, selector) {
            var handleObjIn, eventHandle, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.get(elem);
            // Only attach events to objects that accept data
            if (!acceptData(elem)) return;
            // Caller can pass in an object of custom data in lieu of the handler
            if (handler.handler) {
                handleObjIn = handler;
                handler = handleObjIn.handler;
                selector = handleObjIn.selector;
            }
            // Ensure that invalid selectors throw exceptions at attach time
            // Evaluate against documentElement in case elem is a non-element node (e.g., document)
            if (selector) jQuery.find.matchesSelector(documentElement, selector);
            // Make sure that the handler has a unique ID, used to find/remove it later
            if (!handler.guid) handler.guid = jQuery.guid++;
            // Init the element's event structure and main handler, if this is the first
            if (!(events = elemData.events)) events = elemData.events = Object.create(null);
            if (!(eventHandle = elemData.handle)) eventHandle = elemData.handle = function(e) {
                // Discard the second event of a jQuery.event.trigger() and
                // when an event is called after a page has unloaded
                return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
            };
            // Handle multiple events separated by a space
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // There *must* be a type, no attaching namespace-only handlers
                if (!type) continue;
                // If event changes its type, use the special event handlers for the changed type
                special = jQuery.event.special[type] || {};
                // If selector defined, determine special event api type, otherwise given type
                type = (selector ? special.delegateType : special.bindType) || type;
                // Update special based on newly reset type
                special = jQuery.event.special[type] || {};
                // handleObj is passed to all event handlers
                handleObj = jQuery.extend({
                    type: type,
                    origType: origType,
                    data: data,
                    handler: handler,
                    guid: handler.guid,
                    selector: selector,
                    needsContext: selector && jQuery.expr.match.needsContext.test(selector),
                    namespace: namespaces.join(".")
                }, handleObjIn);
                // Init the event handler queue if we're the first
                if (!(handlers = events[type])) {
                    handlers = events[type] = [];
                    handlers.delegateCount = 0;
                    // Only use addEventListener if the special events handler returns false
                    if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
                        if (elem.addEventListener) elem.addEventListener(type, eventHandle);
                    }
                }
                if (special.add) {
                    special.add.call(elem, handleObj);
                    if (!handleObj.handler.guid) handleObj.handler.guid = handler.guid;
                }
                // Add to the element's handler list, delegates in front
                if (selector) handlers.splice(handlers.delegateCount++, 0, handleObj);
                else handlers.push(handleObj);
                // Keep track of which events have ever been used, for event optimization
                jQuery.event.global[type] = true;
            }
        },
        // Detach an event or set of events from an element
        remove: function(elem, types, handler, selector, mappedTypes) {
            var j, origCount, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
            if (!elemData || !(events = elemData.events)) return;
            // Once for each type.namespace in types; type may be omitted
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // Unbind all events (on this namespace, if provided) for the element
                if (!type) {
                    for(type in events)jQuery.event.remove(elem, type + types[t], handler, selector, true);
                    continue;
                }
                special = jQuery.event.special[type] || {};
                type = (selector ? special.delegateType : special.bindType) || type;
                handlers = events[type] || [];
                tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
                // Remove matching events
                origCount = j = handlers.length;
                while(j--){
                    handleObj = handlers[j];
                    if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
                        handlers.splice(j, 1);
                        if (handleObj.selector) handlers.delegateCount--;
                        if (special.remove) special.remove.call(elem, handleObj);
                    }
                }
                // Remove generic event handler if we removed something and no more handlers exist
                // (avoids potential for endless recursion during removal of special event handlers)
                if (origCount && !handlers.length) {
                    if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) jQuery.removeEvent(elem, type, elemData.handle);
                    delete events[type];
                }
            }
            // Remove data and the expando if it's no longer used
            if (jQuery.isEmptyObject(events)) dataPriv.remove(elem, "handle events");
        },
        dispatch: function(nativeEvent) {
            var i, j, ret, matched, handleObj, handlerQueue, args = new Array(arguments.length), // Make a writable jQuery.Event from the native event object
            event = jQuery.event.fix(nativeEvent), handlers = (dataPriv.get(this, "events") || Object.create(null))[event.type] || [], special = jQuery.event.special[event.type] || {};
            // Use the fix-ed jQuery.Event rather than the (read-only) native event
            args[0] = event;
            for(i = 1; i < arguments.length; i++)args[i] = arguments[i];
            event.delegateTarget = this;
            // Call the preDispatch hook for the mapped type, and let it bail if desired
            if (special.preDispatch && special.preDispatch.call(this, event) === false) return;
            // Determine handlers
            handlerQueue = jQuery.event.handlers.call(this, event, handlers);
            // Run delegates first; they may want to stop propagation beneath us
            i = 0;
            while((matched = handlerQueue[i++]) && !event.isPropagationStopped()){
                event.currentTarget = matched.elem;
                j = 0;
                while((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped())// If the event is namespaced, then each handler is only invoked if it is
                // specially universal or its namespaces are a superset of the event's.
                if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {
                    event.handleObj = handleObj;
                    event.data = handleObj.data;
                    ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
                    if (ret !== undefined) {
                        if ((event.result = ret) === false) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    }
                }
            }
            // Call the postDispatch hook for the mapped type
            if (special.postDispatch) special.postDispatch.call(this, event);
            return event.result;
        },
        handlers: function(event, handlers) {
            var i, handleObj, sel, matchedHandlers, matchedSelectors, handlerQueue = [], delegateCount = handlers.delegateCount, cur = event.target;
            // Find delegate handlers
            if (delegateCount && // Support: IE <=9
            // Black-hole SVG <use> instance trees (trac-13180)
            cur.nodeType && // Support: Firefox <=42
            // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
            // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
            // Support: IE 11 only
            // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
            !(event.type === "click" && event.button >= 1)) {
                for(; cur !== this; cur = cur.parentNode || this)// Don't check non-elements (trac-13208)
                // Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
                if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
                    matchedHandlers = [];
                    matchedSelectors = {};
                    for(i = 0; i < delegateCount; i++){
                        handleObj = handlers[i];
                        // Don't conflict with Object.prototype properties (trac-13203)
                        sel = handleObj.selector + " ";
                        if (matchedSelectors[sel] === undefined) matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [
                            cur
                        ]).length;
                        if (matchedSelectors[sel]) matchedHandlers.push(handleObj);
                    }
                    if (matchedHandlers.length) handlerQueue.push({
                        elem: cur,
                        handlers: matchedHandlers
                    });
                }
            }
            // Add the remaining (directly-bound) handlers
            cur = this;
            if (delegateCount < handlers.length) handlerQueue.push({
                elem: cur,
                handlers: handlers.slice(delegateCount)
            });
            return handlerQueue;
        },
        addProp: function(name, hook) {
            Object.defineProperty(jQuery.Event.prototype, name, {
                enumerable: true,
                configurable: true,
                get: isFunction(hook) ? function() {
                    if (this.originalEvent) return hook(this.originalEvent);
                } : function() {
                    if (this.originalEvent) return this.originalEvent[name];
                },
                set: function(value) {
                    Object.defineProperty(this, name, {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: value
                    });
                }
            });
        },
        fix: function(originalEvent) {
            return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
        },
        special: {
            load: {
                // Prevent triggered image.load events from bubbling to window.load
                noBubble: true
            },
            click: {
                // Utilize native event to ensure correct state for checkable inputs
                setup: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Claim the first handler
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) // dataPriv.set( el, "click", ... )
                    leverageNative(el, "click", true);
                    // Return false to allow normal processing in the caller
                    return false;
                },
                trigger: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Force setup before triggering a click
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) leverageNative(el, "click");
                    // Return non-false to allow normal event-path propagation
                    return true;
                },
                // For cross-browser consistency, suppress native .click() on links
                // Also prevent it if we're currently inside a leveraged native-event stack
                _default: function(event) {
                    var target = event.target;
                    return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
                }
            },
            beforeunload: {
                postDispatch: function(event) {
                    // Support: Firefox 20+
                    // Firefox doesn't alert if the returnValue field is not set.
                    if (event.result !== undefined && event.originalEvent) event.originalEvent.returnValue = event.result;
                }
            }
        }
    };
    // Ensure the presence of an event listener that handles manually-triggered
    // synthetic events by interrupting progress until reinvoked in response to
    // *native* events that it fires directly, ensuring that state changes have
    // already occurred before other listeners are invoked.
    function leverageNative(el, type, isSetup) {
        // Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
        if (!isSetup) {
            if (dataPriv.get(el, type) === undefined) jQuery.event.add(el, type, returnTrue);
            return;
        }
        // Register the controller as a special universal handler for all event namespaces
        dataPriv.set(el, type, false);
        jQuery.event.add(el, type, {
            namespace: false,
            handler: function(event) {
                var result, saved = dataPriv.get(this, type);
                if (event.isTrigger & 1 && this[type]) {
                    // Interrupt processing of the outer synthetic .trigger()ed event
                    if (!saved) {
                        // Store arguments for use when handling the inner native event
                        // There will always be at least one argument (an event object), so this array
                        // will not be confused with a leftover capture object.
                        saved = slice.call(arguments);
                        dataPriv.set(this, type, saved);
                        // Trigger the native event and capture its result
                        this[type]();
                        result = dataPriv.get(this, type);
                        dataPriv.set(this, type, false);
                        if (saved !== result) {
                            // Cancel the outer synthetic event
                            event.stopImmediatePropagation();
                            event.preventDefault();
                            return result;
                        }
                    // If this is an inner synthetic event for an event with a bubbling surrogate
                    // (focus or blur), assume that the surrogate already propagated from triggering
                    // the native event and prevent that from happening again here.
                    // This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
                    // bubbling surrogate propagates *after* the non-bubbling base), but that seems
                    // less bad than duplication.
                    } else if ((jQuery.event.special[type] || {}).delegateType) event.stopPropagation();
                // If this is a native event triggered above, everything is now in order
                // Fire an inner synthetic event with the original arguments
                } else if (saved) {
                    // ...and capture the result
                    dataPriv.set(this, type, jQuery.event.trigger(saved[0], saved.slice(1), this));
                    // Abort handling of the native event by all jQuery handlers while allowing
                    // native handlers on the same element to run. On target, this is achieved
                    // by stopping immediate propagation just on the jQuery event. However,
                    // the native event is re-wrapped by a jQuery one on each level of the
                    // propagation so the only way to stop it for jQuery is to stop it for
                    // everyone via native `stopPropagation()`. This is not a problem for
                    // focus/blur which don't bubble, but it does also stop click on checkboxes
                    // and radios. We accept this limitation.
                    event.stopPropagation();
                    event.isImmediatePropagationStopped = returnTrue;
                }
            }
        });
    }
    jQuery.removeEvent = function(elem, type, handle) {
        // This "if" is needed for plain objects
        if (elem.removeEventListener) elem.removeEventListener(type, handle);
    };
    jQuery.Event = function(src, props) {
        // Allow instantiation without the 'new' keyword
        if (!(this instanceof jQuery.Event)) return new jQuery.Event(src, props);
        // Event object
        if (src && src.type) {
            this.originalEvent = src;
            this.type = src.type;
            // Events bubbling up the document may have been marked as prevented
            // by a handler lower down the tree; reflect the correct value.
            this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined && // Support: Android <=2.3 only
            src.returnValue === false ? returnTrue : returnFalse;
            // Create target properties
            // Support: Safari <=6 - 7 only
            // Target should not be a text node (trac-504, trac-13143)
            this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;
            this.currentTarget = src.currentTarget;
            this.relatedTarget = src.relatedTarget;
        // Event type
        } else this.type = src;
        // Put explicitly provided properties onto the event object
        if (props) jQuery.extend(this, props);
        // Create a timestamp if incoming event doesn't have one
        this.timeStamp = src && src.timeStamp || Date.now();
        // Mark it as fixed
        this[jQuery.expando] = true;
    };
    // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
    // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
    jQuery.Event.prototype = {
        constructor: jQuery.Event,
        isDefaultPrevented: returnFalse,
        isPropagationStopped: returnFalse,
        isImmediatePropagationStopped: returnFalse,
        isSimulated: false,
        preventDefault: function() {
            var e = this.originalEvent;
            this.isDefaultPrevented = returnTrue;
            if (e && !this.isSimulated) e.preventDefault();
        },
        stopPropagation: function() {
            var e = this.originalEvent;
            this.isPropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopPropagation();
        },
        stopImmediatePropagation: function() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopImmediatePropagation();
            this.stopPropagation();
        }
    };
    // Includes all common event props including KeyEvent and MouseEvent specific props
    jQuery.each({
        altKey: true,
        bubbles: true,
        cancelable: true,
        changedTouches: true,
        ctrlKey: true,
        detail: true,
        eventPhase: true,
        metaKey: true,
        pageX: true,
        pageY: true,
        shiftKey: true,
        view: true,
        "char": true,
        code: true,
        charCode: true,
        key: true,
        keyCode: true,
        button: true,
        buttons: true,
        clientX: true,
        clientY: true,
        offsetX: true,
        offsetY: true,
        pointerId: true,
        pointerType: true,
        screenX: true,
        screenY: true,
        targetTouches: true,
        toElement: true,
        touches: true,
        which: true
    }, jQuery.event.addProp);
    jQuery.each({
        focus: "focusin",
        blur: "focusout"
    }, function(type, delegateType) {
        function focusMappedHandler(nativeEvent) {
            if (document.documentMode) {
                // Support: IE 11+
                // Attach a single focusin/focusout handler on the document while someone wants
                // focus/blur. This is because the former are synchronous in IE while the latter
                // are async. In other browsers, all those handlers are invoked synchronously.
                // `handle` from private data would already wrap the event, but we need
                // to change the `type` here.
                var handle = dataPriv.get(this, "handle"), event = jQuery.event.fix(nativeEvent);
                event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
                event.isSimulated = true;
                // First, handle focusin/focusout
                handle(nativeEvent);
                // ...then, handle focus/blur
                //
                // focus/blur don't bubble while focusin/focusout do; simulate the former by only
                // invoking the handler at the lower level.
                if (event.target === event.currentTarget) // The setup part calls `leverageNative`, which, in turn, calls
                // `jQuery.event.add`, so event handle will already have been set
                // by this point.
                handle(event);
            } else // For non-IE browsers, attach a single capturing handler on the document
            // while someone wants focusin/focusout.
            jQuery.event.simulate(delegateType, nativeEvent.target, jQuery.event.fix(nativeEvent));
        }
        jQuery.event.special[type] = {
            // Utilize native event if possible so blur/focus sequence is correct
            setup: function() {
                var attaches;
                // Claim the first handler
                // dataPriv.set( this, "focus", ... )
                // dataPriv.set( this, "blur", ... )
                leverageNative(this, type, true);
                if (document.documentMode) {
                    // Support: IE 9 - 11+
                    // We use the same native handler for focusin & focus (and focusout & blur)
                    // so we need to coordinate setup & teardown parts between those events.
                    // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                    attaches = dataPriv.get(this, delegateType);
                    if (!attaches) this.addEventListener(delegateType, focusMappedHandler);
                    dataPriv.set(this, delegateType, (attaches || 0) + 1);
                } else // Return false to allow normal processing in the caller
                return false;
            },
            trigger: function() {
                // Force setup before trigger
                leverageNative(this, type);
                // Return non-false to allow normal event-path propagation
                return true;
            },
            teardown: function() {
                var attaches;
                if (document.documentMode) {
                    attaches = dataPriv.get(this, delegateType) - 1;
                    if (!attaches) {
                        this.removeEventListener(delegateType, focusMappedHandler);
                        dataPriv.remove(this, delegateType);
                    } else dataPriv.set(this, delegateType, attaches);
                } else // Return false to indicate standard teardown should be applied
                return false;
            },
            // Suppress native focus or blur if we're currently inside
            // a leveraged native-event stack
            _default: function(event) {
                return dataPriv.get(event.target, type);
            },
            delegateType: delegateType
        };
        // Support: Firefox <=44
        // Firefox doesn't have focus(in | out) events
        // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
        //
        // Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
        // focus(in | out) events fire after focus & blur events,
        // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
        // Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
        //
        // Support: IE 9 - 11+
        // To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
        // attach a single handler for both events in IE.
        jQuery.event.special[delegateType] = {
            setup: function() {
                // Handle: regular nodes (via `this.ownerDocument`), window
                // (via `this.document`) & document (via `this`).
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType);
                // Support: IE 9 - 11+
                // We use the same native handler for focusin & focus (and focusout & blur)
                // so we need to coordinate setup & teardown parts between those events.
                // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                if (!attaches) {
                    if (document.documentMode) this.addEventListener(delegateType, focusMappedHandler);
                    else doc.addEventListener(type, focusMappedHandler, true);
                }
                dataPriv.set(dataHolder, delegateType, (attaches || 0) + 1);
            },
            teardown: function() {
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType) - 1;
                if (!attaches) {
                    if (document.documentMode) this.removeEventListener(delegateType, focusMappedHandler);
                    else doc.removeEventListener(type, focusMappedHandler, true);
                    dataPriv.remove(dataHolder, delegateType);
                } else dataPriv.set(dataHolder, delegateType, attaches);
            }
        };
    });
    // Create mouseenter/leave events using mouseover/out and event-time checks
    // so that event delegation works in jQuery.
    // Do the same for pointerenter/pointerleave and pointerover/pointerout
    //
    // Support: Safari 7 only
    // Safari sends mouseenter too often; see:
    // https://bugs.chromium.org/p/chromium/issues/detail?id=470258
    // for the description of the bug (it existed in older Chrome versions as well).
    jQuery.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(orig, fix) {
        jQuery.event.special[orig] = {
            delegateType: fix,
            bindType: fix,
            handle: function(event) {
                var ret, target = this, related = event.relatedTarget, handleObj = event.handleObj;
                // For mouseenter/leave call the handler if related is outside the target.
                // NB: No relatedTarget if the mouse left/entered the browser window
                if (!related || related !== target && !jQuery.contains(target, related)) {
                    event.type = handleObj.origType;
                    ret = handleObj.handler.apply(this, arguments);
                    event.type = fix;
                }
                return ret;
            }
        };
    });
    jQuery.fn.extend({
        on: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn);
        },
        one: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn, 1);
        },
        off: function(types, selector, fn) {
            var handleObj, type;
            if (types && types.preventDefault && types.handleObj) {
                // ( event )  dispatched jQuery.Event
                handleObj = types.handleObj;
                jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
                return this;
            }
            if (typeof types === "object") {
                // ( types-object [, selector] )
                for(type in types)this.off(type, selector, types[type]);
                return this;
            }
            if (selector === false || typeof selector === "function") {
                // ( types [, fn] )
                fn = selector;
                selector = undefined;
            }
            if (fn === false) fn = returnFalse;
            return this.each(function() {
                jQuery.event.remove(this, types, fn, selector);
            });
        }
    });
    var // Support: IE <=10 - 11, Edge 12 - 13 only
    // In IE/Edge using regex groups here causes severe slowdowns.
    // See https://connect.microsoft.com/IE/feedback/details/1736512/
    rnoInnerhtml = /<script|<style|<link/i, // checked="checked" or checked
    rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i, rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
    // Prefer a tbody over its parent table for containing new rows
    function manipulationTarget(elem, content) {
        if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) return jQuery(elem).children("tbody")[0] || elem;
        return elem;
    }
    // Replace/restore the type attribute of script elements for safe DOM manipulation
    function disableScript(elem) {
        elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
        return elem;
    }
    function restoreScript(elem) {
        if ((elem.type || "").slice(0, 5) === "true/") elem.type = elem.type.slice(5);
        else elem.removeAttribute("type");
        return elem;
    }
    function cloneCopyEvent(src, dest) {
        var i, l, type, pdataOld, udataOld, udataCur, events;
        if (dest.nodeType !== 1) return;
        // 1. Copy private data: events, handlers, etc.
        if (dataPriv.hasData(src)) {
            pdataOld = dataPriv.get(src);
            events = pdataOld.events;
            if (events) {
                dataPriv.remove(dest, "handle events");
                for(type in events)for(i = 0, l = events[type].length; i < l; i++)jQuery.event.add(dest, type, events[type][i]);
            }
        }
        // 2. Copy user data
        if (dataUser.hasData(src)) {
            udataOld = dataUser.access(src);
            udataCur = jQuery.extend({}, udataOld);
            dataUser.set(dest, udataCur);
        }
    }
    // Fix IE bugs, see support tests
    function fixInput(src, dest) {
        var nodeName = dest.nodeName.toLowerCase();
        // Fails to persist the checked state of a cloned checkbox or radio button.
        if (nodeName === "input" && rcheckableType.test(src.type)) dest.checked = src.checked;
        else if (nodeName === "input" || nodeName === "textarea") dest.defaultValue = src.defaultValue;
    }
    function domManip(collection, args, callback, ignored) {
        // Flatten any nested arrays
        args = flat(args);
        var fragment, first, scripts, hasScripts, node, doc, i = 0, l = collection.length, iNoClone = l - 1, value = args[0], valueIsFunction = isFunction(value);
        // We can't cloneNode fragments that contain checked, in WebKit
        if (valueIsFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) return collection.each(function(index) {
            var self = collection.eq(index);
            if (valueIsFunction) args[0] = value.call(this, index, self.html());
            domManip(self, args, callback, ignored);
        });
        if (l) {
            fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
            first = fragment.firstChild;
            if (fragment.childNodes.length === 1) fragment = first;
            // Require either new content or an interest in ignored elements to invoke the callback
            if (first || ignored) {
                scripts = jQuery.map(getAll(fragment, "script"), disableScript);
                hasScripts = scripts.length;
                // Use the original fragment for the last item
                // instead of the first because it can end up
                // being emptied incorrectly in certain situations (trac-8070).
                for(; i < l; i++){
                    node = fragment;
                    if (i !== iNoClone) {
                        node = jQuery.clone(node, true, true);
                        // Keep references to cloned scripts for later restoration
                        if (hasScripts) // Support: Android <=4.0 only, PhantomJS 1 only
                        // push.apply(_, arraylike) throws on ancient WebKit
                        jQuery.merge(scripts, getAll(node, "script"));
                    }
                    callback.call(collection[i], node, i);
                }
                if (hasScripts) {
                    doc = scripts[scripts.length - 1].ownerDocument;
                    // Re-enable scripts
                    jQuery.map(scripts, restoreScript);
                    // Evaluate executable scripts on first document insertion
                    for(i = 0; i < hasScripts; i++){
                        node = scripts[i];
                        if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {
                            if (node.src && (node.type || "").toLowerCase() !== "module") // Optional AJAX dependency, but won't run scripts if not present
                            {
                                if (jQuery._evalUrl && !node.noModule) jQuery._evalUrl(node.src, {
                                    nonce: node.nonce || node.getAttribute("nonce")
                                }, doc);
                            } else // Unwrap a CDATA section containing script contents. This shouldn't be
                            // needed as in XML documents they're already not visible when
                            // inspecting element contents and in HTML documents they have no
                            // meaning but we're preserving that logic for backwards compatibility.
                            // This will be removed completely in 4.0. See gh-4904.
                            DOMEval(node.textContent.replace(rcleanScript, ""), node, doc);
                        }
                    }
                }
            }
        }
        return collection;
    }
    function remove(elem, selector, keepData) {
        var node, nodes = selector ? jQuery.filter(selector, elem) : elem, i = 0;
        for(; (node = nodes[i]) != null; i++){
            if (!keepData && node.nodeType === 1) jQuery.cleanData(getAll(node));
            if (node.parentNode) {
                if (keepData && isAttached(node)) setGlobalEval(getAll(node, "script"));
                node.parentNode.removeChild(node);
            }
        }
        return elem;
    }
    jQuery.extend({
        htmlPrefilter: function(html) {
            return html;
        },
        clone: function(elem, dataAndEvents, deepDataAndEvents) {
            var i, l, srcElements, destElements, clone = elem.cloneNode(true), inPage = isAttached(elem);
            // Fix IE cloning issues
            if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
                // We eschew jQuery#find here for performance reasons:
                // https://jsperf.com/getall-vs-sizzle/2
                destElements = getAll(clone);
                srcElements = getAll(elem);
                for(i = 0, l = srcElements.length; i < l; i++)fixInput(srcElements[i], destElements[i]);
            }
            // Copy the events from the original to the clone
            if (dataAndEvents) {
                if (deepDataAndEvents) {
                    srcElements = srcElements || getAll(elem);
                    destElements = destElements || getAll(clone);
                    for(i = 0, l = srcElements.length; i < l; i++)cloneCopyEvent(srcElements[i], destElements[i]);
                } else cloneCopyEvent(elem, clone);
            }
            // Preserve script evaluation history
            destElements = getAll(clone, "script");
            if (destElements.length > 0) setGlobalEval(destElements, !inPage && getAll(elem, "script"));
            // Return the cloned set
            return clone;
        },
        cleanData: function(elems) {
            var data, elem, type, special = jQuery.event.special, i = 0;
            for(; (elem = elems[i]) !== undefined; i++)if (acceptData(elem)) {
                if (data = elem[dataPriv.expando]) {
                    if (data.events) {
                        for(type in data.events)if (special[type]) jQuery.event.remove(elem, type);
                        else jQuery.removeEvent(elem, type, data.handle);
                    }
                    // Support: Chrome <=35 - 45+
                    // Assign undefined instead of using delete, see Data#remove
                    elem[dataPriv.expando] = undefined;
                }
                if (elem[dataUser.expando]) // Support: Chrome <=35 - 45+
                // Assign undefined instead of using delete, see Data#remove
                elem[dataUser.expando] = undefined;
            }
        }
    });
    jQuery.fn.extend({
        detach: function(selector) {
            return remove(this, selector, true);
        },
        remove: function(selector) {
            return remove(this, selector);
        },
        text: function(value) {
            return access(this, function(value) {
                return value === undefined ? jQuery.text(this) : this.empty().each(function() {
                    if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) this.textContent = value;
                });
            }, null, value, arguments.length);
        },
        append: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.appendChild(elem);
                }
            });
        },
        prepend: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.insertBefore(elem, target.firstChild);
                }
            });
        },
        before: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this);
            });
        },
        after: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this.nextSibling);
            });
        },
        empty: function() {
            var elem, i = 0;
            for(; (elem = this[i]) != null; i++)if (elem.nodeType === 1) {
                // Prevent memory leaks
                jQuery.cleanData(getAll(elem, false));
                // Remove any remaining nodes
                elem.textContent = "";
            }
            return this;
        },
        clone: function(dataAndEvents, deepDataAndEvents) {
            dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
            deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
            return this.map(function() {
                return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
            });
        },
        html: function(value) {
            return access(this, function(value) {
                var elem = this[0] || {}, i = 0, l = this.length;
                if (value === undefined && elem.nodeType === 1) return elem.innerHTML;
                // See if we can take a shortcut and just use innerHTML
                if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || [
                    "",
                    ""
                ])[1].toLowerCase()]) {
                    value = jQuery.htmlPrefilter(value);
                    try {
                        for(; i < l; i++){
                            elem = this[i] || {};
                            // Remove element nodes and prevent memory leaks
                            if (elem.nodeType === 1) {
                                jQuery.cleanData(getAll(elem, false));
                                elem.innerHTML = value;
                            }
                        }
                        elem = 0;
                    // If using innerHTML throws an exception, use the fallback method
                    } catch (e) {}
                }
                if (elem) this.empty().append(value);
            }, null, value, arguments.length);
        },
        replaceWith: function() {
            var ignored = [];
            // Make the changes, replacing each non-ignored context element with the new content
            return domManip(this, arguments, function(elem) {
                var parent = this.parentNode;
                if (jQuery.inArray(this, ignored) < 0) {
                    jQuery.cleanData(getAll(this));
                    if (parent) parent.replaceChild(elem, this);
                }
            // Force callback invocation
            }, ignored);
        }
    });
    jQuery.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(name, original) {
        jQuery.fn[name] = function(selector) {
            var elems, ret = [], insert = jQuery(selector), last = insert.length - 1, i = 0;
            for(; i <= last; i++){
                elems = i === last ? this : this.clone(true);
                jQuery(insert[i])[original](elems);
                // Support: Android <=4.0 only, PhantomJS 1 only
                // .get() because push.apply(_, arraylike) throws on ancient WebKit
                push.apply(ret, elems.get());
            }
            return this.pushStack(ret);
        };
    });
    var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
    var rcustomProp = /^--/;
    var getStyles = function(elem) {
        // Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
        // IE throws on elements created in popups
        // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
        var view = elem.ownerDocument.defaultView;
        if (!view || !view.opener) view = window1;
        return view.getComputedStyle(elem);
    };
    var swap = function(elem, options, callback) {
        var ret, name, old = {};
        // Remember the old values, and insert the new ones
        for(name in options){
            old[name] = elem.style[name];
            elem.style[name] = options[name];
        }
        ret = callback.call(elem);
        // Revert the old values
        for(name in options)elem.style[name] = old[name];
        return ret;
    };
    var rboxStyle = new RegExp(cssExpand.join("|"), "i");
    (function() {
        // Executing both pixelPosition & boxSizingReliable tests require only one layout
        // so they're executed at the same time to save the second computation.
        function computeStyleTests() {
            // This is a singleton, we need to execute it only once
            if (!div) return;
            container.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0";
            div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%";
            documentElement.appendChild(container).appendChild(div);
            var divStyle = window1.getComputedStyle(div);
            pixelPositionVal = divStyle.top !== "1%";
            // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
            reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;
            // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
            // Some styles come back with percentage values, even though they shouldn't
            div.style.right = "60%";
            pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;
            // Support: IE 9 - 11 only
            // Detect misreporting of content dimensions for box-sizing:border-box elements
            boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;
            // Support: IE 9 only
            // Detect overflow:scroll screwiness (gh-3699)
            // Support: Chrome <=64
            // Don't get tricked when zoom affects offsetWidth (gh-4029)
            div.style.position = "absolute";
            scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;
            documentElement.removeChild(container);
            // Nullify the div so it wouldn't be stored in the memory and
            // it will also be a sign that checks already performed
            div = null;
        }
        function roundPixelMeasures(measure) {
            return Math.round(parseFloat(measure));
        }
        var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal, reliableTrDimensionsVal, reliableMarginLeftVal, container = document.createElement("div"), div = document.createElement("div");
        // Finish early in limited (non-browser) environments
        if (!div.style) return;
        // Support: IE <=9 - 11 only
        // Style of cloned element affects source element cloned (trac-8908)
        div.style.backgroundClip = "content-box";
        div.cloneNode(true).style.backgroundClip = "";
        support.clearCloneStyle = div.style.backgroundClip === "content-box";
        jQuery.extend(support, {
            boxSizingReliable: function() {
                computeStyleTests();
                return boxSizingReliableVal;
            },
            pixelBoxStyles: function() {
                computeStyleTests();
                return pixelBoxStylesVal;
            },
            pixelPosition: function() {
                computeStyleTests();
                return pixelPositionVal;
            },
            reliableMarginLeft: function() {
                computeStyleTests();
                return reliableMarginLeftVal;
            },
            scrollboxSize: function() {
                computeStyleTests();
                return scrollboxSizeVal;
            },
            // Support: IE 9 - 11+, Edge 15 - 18+
            // IE/Edge misreport `getComputedStyle` of table rows with width/height
            // set in CSS while `offset*` properties report correct values.
            // Behavior in IE 9 is more subtle than in newer versions & it passes
            // some versions of this test; make sure not to make it pass there!
            //
            // Support: Firefox 70+
            // Only Firefox includes border widths
            // in computed dimensions. (gh-4529)
            reliableTrDimensions: function() {
                var table, tr, trChild, trStyle;
                if (reliableTrDimensionsVal == null) {
                    table = document.createElement("table");
                    tr = document.createElement("tr");
                    trChild = document.createElement("div");
                    table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
                    tr.style.cssText = "box-sizing:content-box;border:1px solid";
                    // Support: Chrome 86+
                    // Height set through cssText does not get applied.
                    // Computed height then comes back as 0.
                    tr.style.height = "1px";
                    trChild.style.height = "9px";
                    // Support: Android 8 Chrome 86+
                    // In our bodyBackground.html iframe,
                    // display for all div elements is set to "inline",
                    // which causes a problem only in Android 8 Chrome 86.
                    // Ensuring the div is `display: block`
                    // gets around this issue.
                    trChild.style.display = "block";
                    documentElement.appendChild(table).appendChild(tr).appendChild(trChild);
                    trStyle = window1.getComputedStyle(tr);
                    reliableTrDimensionsVal = parseInt(trStyle.height, 10) + parseInt(trStyle.borderTopWidth, 10) + parseInt(trStyle.borderBottomWidth, 10) === tr.offsetHeight;
                    documentElement.removeChild(table);
                }
                return reliableTrDimensionsVal;
            }
        });
    })();
    function curCSS(elem, name, computed) {
        var width, minWidth, maxWidth, ret, isCustomProp = rcustomProp.test(name), // Support: Firefox 51+
        // Retrieving style before computed somehow
        // fixes an issue with getting wrong values
        // on detached elements
        style = elem.style;
        computed = computed || getStyles(elem);
        // getPropertyValue is needed for:
        //   .css('filter') (IE 9 only, trac-12537)
        //   .css('--customProperty) (gh-3144)
        if (computed) {
            // Support: IE <=9 - 11+
            // IE only supports `"float"` in `getPropertyValue`; in computed styles
            // it's only available as `"cssFloat"`. We no longer modify properties
            // sent to `.css()` apart from camelCasing, so we need to check both.
            // Normally, this would create difference in behavior: if
            // `getPropertyValue` returns an empty string, the value returned
            // by `.css()` would be `undefined`. This is usually the case for
            // disconnected elements. However, in IE even disconnected elements
            // with no styles return `"none"` for `getPropertyValue( "float" )`
            ret = computed.getPropertyValue(name) || computed[name];
            if (isCustomProp && ret) // Support: Firefox 105+, Chrome <=105+
            // Spec requires trimming whitespace for custom properties (gh-4926).
            // Firefox only trims leading whitespace. Chrome just collapses
            // both leading & trailing whitespace to a single space.
            //
            // Fall back to `undefined` if empty string returned.
            // This collapses a missing definition with property defined
            // and set to an empty string but there's no standard API
            // allowing us to differentiate them without a performance penalty
            // and returning `undefined` aligns with older jQuery.
            //
            // rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
            // as whitespace while CSS does not, but this is not a problem
            // because CSS preprocessing replaces them with U+000A LINE FEED
            // (which *is* CSS whitespace)
            // https://www.w3.org/TR/css-syntax-3/#input-preprocessing
            ret = ret.replace(rtrimCSS, "$1") || undefined;
            if (ret === "" && !isAttached(elem)) ret = jQuery.style(elem, name);
            // A tribute to the "awesome hack by Dean Edwards"
            // Android Browser returns percentage for some values,
            // but width seems to be reliably pixels.
            // This is against the CSSOM draft spec:
            // https://drafts.csswg.org/cssom/#resolved-values
            if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {
                // Remember the original values
                width = style.width;
                minWidth = style.minWidth;
                maxWidth = style.maxWidth;
                // Put in the new values to get a computed value out
                style.minWidth = style.maxWidth = style.width = ret;
                ret = computed.width;
                // Revert the changed values
                style.width = width;
                style.minWidth = minWidth;
                style.maxWidth = maxWidth;
            }
        }
        return ret !== undefined ? // Support: IE <=9 - 11 only
        // IE returns zIndex value as an integer.
        ret + "" : ret;
    }
    function addGetHookIf(conditionFn, hookFn) {
        // Define the hook, we'll check on the first run if it's really needed.
        return {
            get: function() {
                if (conditionFn()) {
                    // Hook not needed (or it's not possible to use it due
                    // to missing dependency), remove it.
                    delete this.get;
                    return;
                }
                // Hook needed; redefine it so that the support test is not executed again.
                return (this.get = hookFn).apply(this, arguments);
            }
        };
    }
    var cssPrefixes = [
        "Webkit",
        "Moz",
        "ms"
    ], emptyStyle = document.createElement("div").style, vendorProps = {};
    // Return a vendor-prefixed property or undefined
    function vendorPropName(name) {
        // Check for vendor prefixed names
        var capName = name[0].toUpperCase() + name.slice(1), i = cssPrefixes.length;
        while(i--){
            name = cssPrefixes[i] + capName;
            if (name in emptyStyle) return name;
        }
    }
    // Return a potentially-mapped jQuery.cssProps or vendor prefixed property
    function finalPropName(name) {
        var final = jQuery.cssProps[name] || vendorProps[name];
        if (final) return final;
        if (name in emptyStyle) return name;
        return vendorProps[name] = vendorPropName(name) || name;
    }
    var // Swappable if display is none or starts with table
    // except "table", "table-cell", or "table-caption"
    // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
    rdisplayswap = /^(none|table(?!-c[ea]).+)/, cssShow = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }, cssNormalTransform = {
        letterSpacing: "0",
        fontWeight: "400"
    };
    function setPositiveNumber(_elem, value, subtract) {
        // Any relative (+/-) values have already been
        // normalized at this point
        var matches = rcssNum.exec(value);
        return matches ? // Guard against undefined "subtract", e.g., when used as in cssHooks
        Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
    }
    function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
        var i = dimension === "width" ? 1 : 0, extra = 0, delta = 0, marginDelta = 0;
        // Adjustment may not be necessary
        if (box === (isBorderBox ? "border" : "content")) return 0;
        for(; i < 4; i += 2){
            // Both box models exclude margin
            // Count margin delta separately to only add it after scroll gutter adjustment.
            // This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
            if (box === "margin") marginDelta += jQuery.css(elem, box + cssExpand[i], true, styles);
            // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
            if (!isBorderBox) {
                // Add padding
                delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "border" or "margin", add border
                if (box !== "padding") delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
                else extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            // If we get here with a border-box (content + padding + border), we're seeking "content" or
            // "padding" or "margin"
            } else {
                // For "content", subtract padding
                if (box === "content") delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "content" or "padding", subtract border
                if (box !== "margin") delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            }
        }
        // Account for positive content-box scroll gutter when requested by providing computedVal
        if (!isBorderBox && computedVal >= 0) // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
        // Assuming integer scroll gutter, subtract the rest and round down
        delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5)) || 0;
        return delta + marginDelta;
    }
    function getWidthOrHeight(elem, dimension, extra) {
        // Start with computed style
        var styles = getStyles(elem), // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
        // Fake content-box until we know it's needed to know the true value.
        boxSizingNeeded = !support.boxSizingReliable() || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", valueIsBorderBox = isBorderBox, val = curCSS(elem, dimension, styles), offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);
        // Support: Firefox <=54
        // Return a confounding non-pixel value or feign ignorance, as appropriate.
        if (rnumnonpx.test(val)) {
            if (!extra) return val;
            val = "auto";
        }
        // Support: IE 9 - 11 only
        // Use offsetWidth/offsetHeight for when box sizing is unreliable.
        // In those cases, the computed value can be trusted to be border-box.
        if ((!support.boxSizingReliable() && isBorderBox || // Support: IE 10 - 11+, Edge 15 - 18+
        // IE/Edge misreport `getComputedStyle` of table rows with width/height
        // set in CSS while `offset*` properties report correct values.
        // Interestingly, in some cases IE 9 doesn't suffer from this issue.
        !support.reliableTrDimensions() && nodeName(elem, "tr") || // Fall back to offsetWidth/offsetHeight when value is "auto"
        // This happens for inline elements with no explicit setting (gh-3571)
        val === "auto" || // Support: Android <=4.1 - 4.3 only
        // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
        !parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") && // Make sure the element is visible & connected
        elem.getClientRects().length) {
            isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";
            // Where available, offsetWidth/offsetHeight approximate border box dimensions.
            // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
            // retrieved value as a content box dimension.
            valueIsBorderBox = offsetProp in elem;
            if (valueIsBorderBox) val = elem[offsetProp];
        }
        // Normalize "" and auto
        val = parseFloat(val) || 0;
        // Adjust for the element's box model
        return val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles, // Provide the current computed size to request scroll gutter calculation (gh-3589)
        val) + "px";
    }
    jQuery.extend({
        // Add in style property hooks for overriding the default
        // behavior of getting and setting a style property
        cssHooks: {
            opacity: {
                get: function(elem, computed) {
                    if (computed) {
                        // We should always get a number back from opacity
                        var ret = curCSS(elem, "opacity");
                        return ret === "" ? "1" : ret;
                    }
                }
            }
        },
        // Don't automatically add "px" to these possibly-unitless properties
        cssNumber: {
            animationIterationCount: true,
            aspectRatio: true,
            borderImageSlice: true,
            columnCount: true,
            flexGrow: true,
            flexShrink: true,
            fontWeight: true,
            gridArea: true,
            gridColumn: true,
            gridColumnEnd: true,
            gridColumnStart: true,
            gridRow: true,
            gridRowEnd: true,
            gridRowStart: true,
            lineHeight: true,
            opacity: true,
            order: true,
            orphans: true,
            scale: true,
            widows: true,
            zIndex: true,
            zoom: true,
            // SVG-related
            fillOpacity: true,
            floodOpacity: true,
            stopOpacity: true,
            strokeMiterlimit: true,
            strokeOpacity: true
        },
        // Add in properties whose names you wish to fix before
        // setting or getting the value
        cssProps: {},
        // Get and set the style property on a DOM Node
        style: function(elem, name, value, extra) {
            // Don't set styles on text and comment nodes
            if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) return;
            // Make sure that we're working with the right name
            var ret, type, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name), style = elem.style;
            // Make sure that we're working with the right name. We don't
            // want to query the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Gets hook for the prefixed version, then unprefixed version
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // Check if we're setting a value
            if (value !== undefined) {
                type = typeof value;
                // Convert "+=" or "-=" to relative numbers (trac-7345)
                if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
                    value = adjustCSS(elem, name, ret);
                    // Fixes bug trac-9237
                    type = "number";
                }
                // Make sure that null and NaN values aren't set (trac-7116)
                if (value == null || value !== value) return;
                // If a number was passed in, add the unit (except for certain CSS properties)
                // The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
                // "px" to a few hardcoded values.
                if (type === "number" && !isCustomProp) value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
                // background-* props affect original clone's values
                if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) style[name] = "inherit";
                // If a hook was provided, use that value, otherwise just set the specified value
                if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
                    if (isCustomProp) style.setProperty(name, value);
                    else style[name] = value;
                }
            } else {
                // If a hook was provided get the non-computed value from there
                if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) return ret;
                // Otherwise just get the value from the style object
                return style[name];
            }
        },
        css: function(elem, name, extra, styles) {
            var val, num, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name);
            // Make sure that we're working with the right name. We don't
            // want to modify the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Try prefixed name followed by the unprefixed name
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // If a hook was provided get the computed value from there
            if (hooks && "get" in hooks) val = hooks.get(elem, true, extra);
            // Otherwise, if a way to get the computed value exists, use that
            if (val === undefined) val = curCSS(elem, name, styles);
            // Convert "normal" to computed value
            if (val === "normal" && name in cssNormalTransform) val = cssNormalTransform[name];
            // Make numeric if forced or a qualifier was provided and val looks numeric
            if (extra === "" || extra) {
                num = parseFloat(val);
                return extra === true || isFinite(num) ? num || 0 : val;
            }
            return val;
        }
    });
    jQuery.each([
        "height",
        "width"
    ], function(_i, dimension) {
        jQuery.cssHooks[dimension] = {
            get: function(elem, computed, extra) {
                if (computed) // Certain elements can have dimension info if we invisibly show them
                // but it must have a current display style that would benefit
                return rdisplayswap.test(jQuery.css(elem, "display")) && // Support: Safari 8+
                // Table columns in Safari have non-zero offsetWidth & zero
                // getBoundingClientRect().width unless display is changed.
                // Support: IE <=11 only
                // Running getBoundingClientRect on a disconnected node
                // in IE throws an error.
                (!elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function() {
                    return getWidthOrHeight(elem, dimension, extra);
                }) : getWidthOrHeight(elem, dimension, extra);
            },
            set: function(elem, value, extra) {
                var matches, styles = getStyles(elem), // Only read styles.position if the test has a chance to fail
                // to avoid forcing a reflow.
                scrollboxSizeBuggy = !support.scrollboxSize() && styles.position === "absolute", // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
                boxSizingNeeded = scrollboxSizeBuggy || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", subtract = extra ? boxModelAdjustment(elem, dimension, extra, isBorderBox, styles) : 0;
                // Account for unreliable border-box dimensions by comparing offset* to computed and
                // faking a content-box to get border and padding (gh-3699)
                if (isBorderBox && scrollboxSizeBuggy) subtract -= Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", false, styles) - 0.5);
                // Convert to pixels if value adjustment is needed
                if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
                    elem.style[dimension] = value;
                    value = jQuery.css(elem, dimension);
                }
                return setPositiveNumber(elem, value, subtract);
            }
        };
    });
    jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function(elem, computed) {
        if (computed) return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, {
            marginLeft: 0
        }, function() {
            return elem.getBoundingClientRect().left;
        })) + "px";
    });
    // These hooks are used by animate to expand properties
    jQuery.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(prefix, suffix) {
        jQuery.cssHooks[prefix + suffix] = {
            expand: function(value) {
                var i = 0, expanded = {}, // Assumes a single number if not a string
                parts = typeof value === "string" ? value.split(" ") : [
                    value
                ];
                for(; i < 4; i++)expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
                return expanded;
            }
        };
        if (prefix !== "margin") jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
    });
    jQuery.fn.extend({
        css: function(name, value) {
            return access(this, function(elem, name, value) {
                var styles, len, map = {}, i = 0;
                if (Array.isArray(name)) {
                    styles = getStyles(elem);
                    len = name.length;
                    for(; i < len; i++)map[name[i]] = jQuery.css(elem, name[i], false, styles);
                    return map;
                }
                return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
            }, name, value, arguments.length > 1);
        }
    });
    function Tween(elem, options, prop, end, easing) {
        return new Tween.prototype.init(elem, options, prop, end, easing);
    }
    jQuery.Tween = Tween;
    Tween.prototype = {
        constructor: Tween,
        init: function(elem, options, prop, end, easing, unit) {
            this.elem = elem;
            this.prop = prop;
            this.easing = easing || jQuery.easing._default;
            this.options = options;
            this.start = this.now = this.cur();
            this.end = end;
            this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
        },
        cur: function() {
            var hooks = Tween.propHooks[this.prop];
            return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
        },
        run: function(percent) {
            var eased, hooks = Tween.propHooks[this.prop];
            if (this.options.duration) this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
            else this.pos = eased = percent;
            this.now = (this.end - this.start) * eased + this.start;
            if (this.options.step) this.options.step.call(this.elem, this.now, this);
            if (hooks && hooks.set) hooks.set(this);
            else Tween.propHooks._default.set(this);
            return this;
        }
    };
    Tween.prototype.init.prototype = Tween.prototype;
    Tween.propHooks = {
        _default: {
            get: function(tween) {
                var result;
                // Use a property on the element directly when it is not a DOM element,
                // or when there is no matching style property that exists.
                if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) return tween.elem[tween.prop];
                // Passing an empty string as a 3rd parameter to .css will automatically
                // attempt a parseFloat and fallback to a string if the parse fails.
                // Simple values such as "10px" are parsed to Float;
                // complex values such as "rotate(1rad)" are returned as-is.
                result = jQuery.css(tween.elem, tween.prop, "");
                // Empty strings, null, undefined and "auto" are converted to 0.
                return !result || result === "auto" ? 0 : result;
            },
            set: function(tween) {
                // Use step hook for back compat.
                // Use cssHook if its there.
                // Use .style if available and use plain properties where available.
                if (jQuery.fx.step[tween.prop]) jQuery.fx.step[tween.prop](tween);
                else if (tween.elem.nodeType === 1 && (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
                else tween.elem[tween.prop] = tween.now;
            }
        }
    };
    // Support: IE <=9 only
    // Panic based approach to setting things on disconnected nodes
    Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
        set: function(tween) {
            if (tween.elem.nodeType && tween.elem.parentNode) tween.elem[tween.prop] = tween.now;
        }
    };
    jQuery.easing = {
        linear: function(p) {
            return p;
        },
        swing: function(p) {
            return 0.5 - Math.cos(p * Math.PI) / 2;
        },
        _default: "swing"
    };
    jQuery.fx = Tween.prototype.init;
    // Back compat <1.8 extension point
    jQuery.fx.step = {};
    var fxNow, inProgress, rfxtypes = /^(?:toggle|show|hide)$/, rrun = /queueHooks$/;
    function schedule() {
        if (inProgress) {
            if (document.hidden === false && window1.requestAnimationFrame) window1.requestAnimationFrame(schedule);
            else window1.setTimeout(schedule, jQuery.fx.interval);
            jQuery.fx.tick();
        }
    }
    // Animations created synchronously will run synchronously
    function createFxNow() {
        window1.setTimeout(function() {
            fxNow = undefined;
        });
        return fxNow = Date.now();
    }
    // Generate parameters to create a standard animation
    function genFx(type, includeWidth) {
        var which, i = 0, attrs = {
            height: type
        };
        // If we include width, step value is 1 to do all cssExpand values,
        // otherwise step value is 2 to skip over Left and Right
        includeWidth = includeWidth ? 1 : 0;
        for(; i < 4; i += 2 - includeWidth){
            which = cssExpand[i];
            attrs["margin" + which] = attrs["padding" + which] = type;
        }
        if (includeWidth) attrs.opacity = attrs.width = type;
        return attrs;
    }
    function createTween(value, prop, animation) {
        var tween, collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]), index = 0, length = collection.length;
        for(; index < length; index++){
            if (tween = collection[index].call(animation, prop, value)) // We're done with this property
            return tween;
        }
    }
    function defaultPrefilter(elem, props, opts) {
        var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display, isBox = "width" in props || "height" in props, anim = this, orig = {}, style = elem.style, hidden = elem.nodeType && isHiddenWithinTree(elem), dataShow = dataPriv.get(elem, "fxshow");
        // Queue-skipping animations hijack the fx hooks
        if (!opts.queue) {
            hooks = jQuery._queueHooks(elem, "fx");
            if (hooks.unqueued == null) {
                hooks.unqueued = 0;
                oldfire = hooks.empty.fire;
                hooks.empty.fire = function() {
                    if (!hooks.unqueued) oldfire();
                };
            }
            hooks.unqueued++;
            anim.always(function() {
                // Ensure the complete handler is called before this completes
                anim.always(function() {
                    hooks.unqueued--;
                    if (!jQuery.queue(elem, "fx").length) hooks.empty.fire();
                });
            });
        }
        // Detect show/hide animations
        for(prop in props){
            value = props[prop];
            if (rfxtypes.test(value)) {
                delete props[prop];
                toggle = toggle || value === "toggle";
                if (value === (hidden ? "hide" : "show")) {
                    // Pretend to be hidden if this is a "show" and
                    // there is still data from a stopped show/hide
                    if (value === "show" && dataShow && dataShow[prop] !== undefined) hidden = true;
                    else continue;
                }
                orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
            }
        }
        // Bail out if this is a no-op like .hide().hide()
        propTween = !jQuery.isEmptyObject(props);
        if (!propTween && jQuery.isEmptyObject(orig)) return;
        // Restrict "overflow" and "display" styles during box animations
        if (isBox && elem.nodeType === 1) {
            // Support: IE <=9 - 11, Edge 12 - 15
            // Record all 3 overflow attributes because IE does not infer the shorthand
            // from identically-valued overflowX and overflowY and Edge just mirrors
            // the overflowX value there.
            opts.overflow = [
                style.overflow,
                style.overflowX,
                style.overflowY
            ];
            // Identify a display type, preferring old show/hide data over the CSS cascade
            restoreDisplay = dataShow && dataShow.display;
            if (restoreDisplay == null) restoreDisplay = dataPriv.get(elem, "display");
            display = jQuery.css(elem, "display");
            if (display === "none") {
                if (restoreDisplay) display = restoreDisplay;
                else {
                    // Get nonempty value(s) by temporarily forcing visibility
                    showHide([
                        elem
                    ], true);
                    restoreDisplay = elem.style.display || restoreDisplay;
                    display = jQuery.css(elem, "display");
                    showHide([
                        elem
                    ]);
                }
            }
            // Animate inline elements as inline-block
            if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
                if (jQuery.css(elem, "float") === "none") {
                    // Restore the original display value at the end of pure show/hide animations
                    if (!propTween) {
                        anim.done(function() {
                            style.display = restoreDisplay;
                        });
                        if (restoreDisplay == null) {
                            display = style.display;
                            restoreDisplay = display === "none" ? "" : display;
                        }
                    }
                    style.display = "inline-block";
                }
            }
        }
        if (opts.overflow) {
            style.overflow = "hidden";
            anim.always(function() {
                style.overflow = opts.overflow[0];
                style.overflowX = opts.overflow[1];
                style.overflowY = opts.overflow[2];
            });
        }
        // Implement show/hide animations
        propTween = false;
        for(prop in orig){
            // General show/hide setup for this element animation
            if (!propTween) {
                if (dataShow) {
                    if ("hidden" in dataShow) hidden = dataShow.hidden;
                } else dataShow = dataPriv.access(elem, "fxshow", {
                    display: restoreDisplay
                });
                // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
                if (toggle) dataShow.hidden = !hidden;
                // Show elements before animating them
                if (hidden) showHide([
                    elem
                ], true);
                /* eslint-disable no-loop-func */ anim.done(function() {
                    /* eslint-enable no-loop-func */ // The final step of a "hide" animation is actually hiding the element
                    if (!hidden) showHide([
                        elem
                    ]);
                    dataPriv.remove(elem, "fxshow");
                    for(prop in orig)jQuery.style(elem, prop, orig[prop]);
                });
            }
            // Per-property setup
            propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
            if (!(prop in dataShow)) {
                dataShow[prop] = propTween.start;
                if (hidden) {
                    propTween.end = propTween.start;
                    propTween.start = 0;
                }
            }
        }
    }
    function propFilter(props, specialEasing) {
        var index, name, easing, value, hooks;
        // camelCase, specialEasing and expand cssHook pass
        for(index in props){
            name = camelCase(index);
            easing = specialEasing[name];
            value = props[index];
            if (Array.isArray(value)) {
                easing = value[1];
                value = props[index] = value[0];
            }
            if (index !== name) {
                props[name] = value;
                delete props[index];
            }
            hooks = jQuery.cssHooks[name];
            if (hooks && "expand" in hooks) {
                value = hooks.expand(value);
                delete props[name];
                // Not quite $.extend, this won't overwrite existing keys.
                // Reusing 'index' because we have the correct "name"
                for(index in value)if (!(index in props)) {
                    props[index] = value[index];
                    specialEasing[index] = easing;
                }
            } else specialEasing[name] = easing;
        }
    }
    function Animation(elem, properties, options) {
        var result, stopped, index = 0, length = Animation.prefilters.length, deferred = jQuery.Deferred().always(function() {
            // Don't match elem in the :animated selector
            delete tick.elem;
        }), tick = function() {
            if (stopped) return false;
            var currentTime = fxNow || createFxNow(), remaining = Math.max(0, animation.startTime + animation.duration - currentTime), // Support: Android 2.3 only
            // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
            temp = remaining / animation.duration || 0, percent = 1 - temp, index = 0, length = animation.tweens.length;
            for(; index < length; index++)animation.tweens[index].run(percent);
            deferred.notifyWith(elem, [
                animation,
                percent,
                remaining
            ]);
            // If there's more to do, yield
            if (percent < 1 && length) return remaining;
            // If this was an empty animation, synthesize a final progress notification
            if (!length) deferred.notifyWith(elem, [
                animation,
                1,
                0
            ]);
            // Resolve the animation and report its conclusion
            deferred.resolveWith(elem, [
                animation
            ]);
            return false;
        }, animation = deferred.promise({
            elem: elem,
            props: jQuery.extend({}, properties),
            opts: jQuery.extend(true, {
                specialEasing: {},
                easing: jQuery.easing._default
            }, options),
            originalProperties: properties,
            originalOptions: options,
            startTime: fxNow || createFxNow(),
            duration: options.duration,
            tweens: [],
            createTween: function(prop, end) {
                var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
                animation.tweens.push(tween);
                return tween;
            },
            stop: function(gotoEnd) {
                var index = 0, // If we are going to the end, we want to run all the tweens
                // otherwise we skip this part
                length = gotoEnd ? animation.tweens.length : 0;
                if (stopped) return this;
                stopped = true;
                for(; index < length; index++)animation.tweens[index].run(1);
                // Resolve when we played the last frame; otherwise, reject
                if (gotoEnd) {
                    deferred.notifyWith(elem, [
                        animation,
                        1,
                        0
                    ]);
                    deferred.resolveWith(elem, [
                        animation,
                        gotoEnd
                    ]);
                } else deferred.rejectWith(elem, [
                    animation,
                    gotoEnd
                ]);
                return this;
            }
        }), props = animation.props;
        propFilter(props, animation.opts.specialEasing);
        for(; index < length; index++){
            result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
            if (result) {
                if (isFunction(result.stop)) jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
                return result;
            }
        }
        jQuery.map(props, createTween, animation);
        if (isFunction(animation.opts.start)) animation.opts.start.call(elem, animation);
        // Attach callbacks from options
        animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
        jQuery.fx.timer(jQuery.extend(tick, {
            elem: elem,
            anim: animation,
            queue: animation.opts.queue
        }));
        return animation;
    }
    jQuery.Animation = jQuery.extend(Animation, {
        tweeners: {
            "*": [
                function(prop, value) {
                    var tween = this.createTween(prop, value);
                    adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
                    return tween;
                }
            ]
        },
        tweener: function(props, callback) {
            if (isFunction(props)) {
                callback = props;
                props = [
                    "*"
                ];
            } else props = props.match(rnothtmlwhite);
            var prop, index = 0, length = props.length;
            for(; index < length; index++){
                prop = props[index];
                Animation.tweeners[prop] = Animation.tweeners[prop] || [];
                Animation.tweeners[prop].unshift(callback);
            }
        },
        prefilters: [
            defaultPrefilter
        ],
        prefilter: function(callback, prepend) {
            if (prepend) Animation.prefilters.unshift(callback);
            else Animation.prefilters.push(callback);
        }
    });
    jQuery.speed = function(speed, easing, fn) {
        var opt = speed && typeof speed === "object" ? jQuery.extend({}, speed) : {
            complete: fn || !fn && easing || isFunction(speed) && speed,
            duration: speed,
            easing: fn && easing || easing && !isFunction(easing) && easing
        };
        // Go to the end state if fx are off
        if (jQuery.fx.off) opt.duration = 0;
        else if (typeof opt.duration !== "number") {
            if (opt.duration in jQuery.fx.speeds) opt.duration = jQuery.fx.speeds[opt.duration];
            else opt.duration = jQuery.fx.speeds._default;
        }
        // Normalize opt.queue - true/undefined/null -> "fx"
        if (opt.queue == null || opt.queue === true) opt.queue = "fx";
        // Queueing
        opt.old = opt.complete;
        opt.complete = function() {
            if (isFunction(opt.old)) opt.old.call(this);
            if (opt.queue) jQuery.dequeue(this, opt.queue);
        };
        return opt;
    };
    jQuery.fn.extend({
        fadeTo: function(speed, to, easing, callback) {
            // Show any hidden elements after setting opacity to 0
            return this.filter(isHiddenWithinTree).css("opacity", 0).show()// Animate to the value specified
            .end().animate({
                opacity: to
            }, speed, easing, callback);
        },
        animate: function(prop, speed, easing, callback) {
            var empty = jQuery.isEmptyObject(prop), optall = jQuery.speed(speed, easing, callback), doAnimation = function() {
                // Operate on a copy of prop so per-property easing won't be lost
                var anim = Animation(this, jQuery.extend({}, prop), optall);
                // Empty animations, or finishing resolves immediately
                if (empty || dataPriv.get(this, "finish")) anim.stop(true);
            };
            doAnimation.finish = doAnimation;
            return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
        },
        stop: function(type, clearQueue, gotoEnd) {
            var stopQueue = function(hooks) {
                var stop = hooks.stop;
                delete hooks.stop;
                stop(gotoEnd);
            };
            if (typeof type !== "string") {
                gotoEnd = clearQueue;
                clearQueue = type;
                type = undefined;
            }
            if (clearQueue) this.queue(type || "fx", []);
            return this.each(function() {
                var dequeue = true, index = type != null && type + "queueHooks", timers = jQuery.timers, data = dataPriv.get(this);
                if (index) {
                    if (data[index] && data[index].stop) stopQueue(data[index]);
                } else {
                    for(index in data)if (data[index] && data[index].stop && rrun.test(index)) stopQueue(data[index]);
                }
                for(index = timers.length; index--;)if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
                    timers[index].anim.stop(gotoEnd);
                    dequeue = false;
                    timers.splice(index, 1);
                }
                // Start the next in the queue if the last step wasn't forced.
                // Timers currently will call their complete callbacks, which
                // will dequeue but only if they were gotoEnd.
                if (dequeue || !gotoEnd) jQuery.dequeue(this, type);
            });
        },
        finish: function(type) {
            if (type !== false) type = type || "fx";
            return this.each(function() {
                var index, data = dataPriv.get(this), queue = data[type + "queue"], hooks = data[type + "queueHooks"], timers = jQuery.timers, length = queue ? queue.length : 0;
                // Enable finishing flag on private data
                data.finish = true;
                // Empty the queue first
                jQuery.queue(this, type, []);
                if (hooks && hooks.stop) hooks.stop.call(this, true);
                // Look for any active animations, and finish them
                for(index = timers.length; index--;)if (timers[index].elem === this && timers[index].queue === type) {
                    timers[index].anim.stop(true);
                    timers.splice(index, 1);
                }
                // Look for any animations in the old queue and finish them
                for(index = 0; index < length; index++)if (queue[index] && queue[index].finish) queue[index].finish.call(this);
                // Turn off finishing flag
                delete data.finish;
            });
        }
    });
    jQuery.each([
        "toggle",
        "show",
        "hide"
    ], function(_i, name) {
        var cssFn = jQuery.fn[name];
        jQuery.fn[name] = function(speed, easing, callback) {
            return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
        };
    });
    // Generate shortcuts for custom animations
    jQuery.each({
        slideDown: genFx("show"),
        slideUp: genFx("hide"),
        slideToggle: genFx("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(name, props) {
        jQuery.fn[name] = function(speed, easing, callback) {
            return this.animate(props, speed, easing, callback);
        };
    });
    jQuery.timers = [];
    jQuery.fx.tick = function() {
        var timer, i = 0, timers = jQuery.timers;
        fxNow = Date.now();
        for(; i < timers.length; i++){
            timer = timers[i];
            // Run the timer and safely remove it when done (allowing for external removal)
            if (!timer() && timers[i] === timer) timers.splice(i--, 1);
        }
        if (!timers.length) jQuery.fx.stop();
        fxNow = undefined;
    };
    jQuery.fx.timer = function(timer) {
        jQuery.timers.push(timer);
        jQuery.fx.start();
    };
    jQuery.fx.interval = 13;
    jQuery.fx.start = function() {
        if (inProgress) return;
        inProgress = true;
        schedule();
    };
    jQuery.fx.stop = function() {
        inProgress = null;
    };
    jQuery.fx.speeds = {
        slow: 600,
        fast: 200,
        // Default speed
        _default: 400
    };
    // Based off of the plugin by Clint Helfers, with permission.
    jQuery.fn.delay = function(time, type) {
        time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
        type = type || "fx";
        return this.queue(type, function(next, hooks) {
            var timeout = window1.setTimeout(next, time);
            hooks.stop = function() {
                window1.clearTimeout(timeout);
            };
        });
    };
    (function() {
        var input = document.createElement("input"), select = document.createElement("select"), opt = select.appendChild(document.createElement("option"));
        input.type = "checkbox";
        // Support: Android <=4.3 only
        // Default value for a checkbox should be "on"
        support.checkOn = input.value !== "";
        // Support: IE <=11 only
        // Must access selectedIndex to make default options select
        support.optSelected = opt.selected;
        // Support: IE <=11 only
        // An input loses its value after becoming a radio
        input = document.createElement("input");
        input.value = "t";
        input.type = "radio";
        support.radioValue = input.value === "t";
    })();
    var boolHook, attrHandle = jQuery.expr.attrHandle;
    jQuery.fn.extend({
        attr: function(name, value) {
            return access(this, jQuery.attr, name, value, arguments.length > 1);
        },
        removeAttr: function(name) {
            return this.each(function() {
                jQuery.removeAttr(this, name);
            });
        }
    });
    jQuery.extend({
        attr: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set attributes on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            // Fallback to prop when attributes are not supported
            if (typeof elem.getAttribute === "undefined") return jQuery.prop(elem, name, value);
            // Attribute hooks are determined by the lowercase version
            // Grab necessary hook if one is defined
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
            if (value !== undefined) {
                if (value === null) {
                    jQuery.removeAttr(elem, name);
                    return;
                }
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                elem.setAttribute(name, value + "");
                return value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            ret = jQuery.find.attr(elem, name);
            // Non-existent attributes return null, we normalize to undefined
            return ret == null ? undefined : ret;
        },
        attrHooks: {
            type: {
                set: function(elem, value) {
                    if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
                        var val = elem.value;
                        elem.setAttribute("type", value);
                        if (val) elem.value = val;
                        return value;
                    }
                }
            }
        },
        removeAttr: function(elem, value) {
            var name, i = 0, // Attribute names can contain non-HTML whitespace characters
            // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
            attrNames = value && value.match(rnothtmlwhite);
            if (attrNames && elem.nodeType === 1) while(name = attrNames[i++])elem.removeAttribute(name);
        }
    });
    // Hooks for boolean attributes
    boolHook = {
        set: function(elem, value, name) {
            if (value === false) // Remove boolean attributes when set to false
            jQuery.removeAttr(elem, name);
            else elem.setAttribute(name, name);
            return name;
        }
    };
    jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function(_i, name) {
        var getter = attrHandle[name] || jQuery.find.attr;
        attrHandle[name] = function(elem, name, isXML) {
            var ret, handle, lowercaseName = name.toLowerCase();
            if (!isXML) {
                // Avoid an infinite loop by temporarily removing this function from the getter
                handle = attrHandle[lowercaseName];
                attrHandle[lowercaseName] = ret;
                ret = getter(elem, name, isXML) != null ? lowercaseName : null;
                attrHandle[lowercaseName] = handle;
            }
            return ret;
        };
    });
    var rfocusable = /^(?:input|select|textarea|button)$/i, rclickable = /^(?:a|area)$/i;
    jQuery.fn.extend({
        prop: function(name, value) {
            return access(this, jQuery.prop, name, value, arguments.length > 1);
        },
        removeProp: function(name) {
            return this.each(function() {
                delete this[jQuery.propFix[name] || name];
            });
        }
    });
    jQuery.extend({
        prop: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set properties on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                // Fix name and attach hooks
                name = jQuery.propFix[name] || name;
                hooks = jQuery.propHooks[name];
            }
            if (value !== undefined) {
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                return elem[name] = value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            return elem[name];
        },
        propHooks: {
            tabIndex: {
                get: function(elem) {
                    // Support: IE <=9 - 11 only
                    // elem.tabIndex doesn't always return the
                    // correct value when it hasn't been explicitly set
                    // Use proper attribute retrieval (trac-12072)
                    var tabindex = jQuery.find.attr(elem, "tabindex");
                    if (tabindex) return parseInt(tabindex, 10);
                    if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) return 0;
                    return -1;
                }
            }
        },
        propFix: {
            "for": "htmlFor",
            "class": "className"
        }
    });
    // Support: IE <=11 only
    // Accessing the selectedIndex property
    // forces the browser to respect setting selected
    // on the option
    // The getter ensures a default option is selected
    // when in an optgroup
    // eslint rule "no-unused-expressions" is disabled for this code
    // since it considers such accessions noop
    if (!support.optSelected) jQuery.propHooks.selected = {
        get: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent && parent.parentNode) parent.parentNode.selectedIndex;
            return null;
        },
        set: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent) {
                parent.selectedIndex;
                if (parent.parentNode) parent.parentNode.selectedIndex;
            }
        }
    };
    jQuery.each([
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable"
    ], function() {
        jQuery.propFix[this.toLowerCase()] = this;
    });
    // Strip and collapse whitespace according to HTML spec
    // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
    function stripAndCollapse(value) {
        var tokens = value.match(rnothtmlwhite) || [];
        return tokens.join(" ");
    }
    function getClass(elem) {
        return elem.getAttribute && elem.getAttribute("class") || "";
    }
    function classesToArray(value) {
        if (Array.isArray(value)) return value;
        if (typeof value === "string") return value.match(rnothtmlwhite) || [];
        return [];
    }
    jQuery.fn.extend({
        addClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).addClass(value.call(this, j, getClass(this)));
            });
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        if (cur.indexOf(" " + className + " ") < 0) cur += className + " ";
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        removeClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).removeClass(value.call(this, j, getClass(this)));
            });
            if (!arguments.length) return this.attr("class", "");
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                // This expression is here for better compressibility (see addClass)
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Remove *all* instances
                        while(cur.indexOf(" " + className + " ") > -1)cur = cur.replace(" " + className + " ", " ");
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        toggleClass: function(value, stateVal) {
            var classNames, className, i, self, type = typeof value, isValidValue = type === "string" || Array.isArray(value);
            if (isFunction(value)) return this.each(function(i) {
                jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
            });
            if (typeof stateVal === "boolean" && isValidValue) return stateVal ? this.addClass(value) : this.removeClass(value);
            classNames = classesToArray(value);
            return this.each(function() {
                if (isValidValue) {
                    // Toggle individual class names
                    self = jQuery(this);
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Check each className given, space separated list
                        if (self.hasClass(className)) self.removeClass(className);
                        else self.addClass(className);
                    }
                // Toggle whole class name
                } else if (value === undefined || type === "boolean") {
                    className = getClass(this);
                    if (className) // Store className if set
                    dataPriv.set(this, "__className__", className);
                    // If the element has a class name or if we're passed `false`,
                    // then remove the whole classname (if there was one, the above saved it).
                    // Otherwise bring back whatever was previously saved (if anything),
                    // falling back to the empty string if nothing was stored.
                    if (this.setAttribute) this.setAttribute("class", className || value === false ? "" : dataPriv.get(this, "__className__") || "");
                }
            });
        },
        hasClass: function(selector) {
            var className, elem, i = 0;
            className = " " + selector + " ";
            while(elem = this[i++]){
                if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) return true;
            }
            return false;
        }
    });
    var rreturn = /\r/g;
    jQuery.fn.extend({
        val: function(value) {
            var hooks, ret, valueIsFunction, elem = this[0];
            if (!arguments.length) {
                if (elem) {
                    hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
                    if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) return ret;
                    ret = elem.value;
                    // Handle most common string cases
                    if (typeof ret === "string") return ret.replace(rreturn, "");
                    // Handle cases where value is null/undef or number
                    return ret == null ? "" : ret;
                }
                return;
            }
            valueIsFunction = isFunction(value);
            return this.each(function(i) {
                var val;
                if (this.nodeType !== 1) return;
                if (valueIsFunction) val = value.call(this, i, jQuery(this).val());
                else val = value;
                // Treat null/undefined as ""; convert numbers to string
                if (val == null) val = "";
                else if (typeof val === "number") val += "";
                else if (Array.isArray(val)) val = jQuery.map(val, function(value) {
                    return value == null ? "" : value + "";
                });
                hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
                // If set returns undefined, fall back to normal setting
                if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) this.value = val;
            });
        }
    });
    jQuery.extend({
        valHooks: {
            option: {
                get: function(elem) {
                    var val = jQuery.find.attr(elem, "value");
                    return val != null ? val : // Support: IE <=10 - 11 only
                    // option.text throws exceptions (trac-14686, trac-14858)
                    // Strip and collapse whitespace
                    // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
                    stripAndCollapse(jQuery.text(elem));
                }
            },
            select: {
                get: function(elem) {
                    var value, option, i, options = elem.options, index = elem.selectedIndex, one = elem.type === "select-one", values = one ? null : [], max = one ? index + 1 : options.length;
                    if (index < 0) i = max;
                    else i = one ? index : 0;
                    // Loop through all the selected options
                    for(; i < max; i++){
                        option = options[i];
                        // Support: IE <=9 only
                        // IE8-9 doesn't update selected after form reset (trac-2551)
                        if ((option.selected || i === index) && // Don't return options that are disabled or in a disabled optgroup
                        !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
                            // Get the specific value for the option
                            value = jQuery(option).val();
                            // We don't need an array for one selects
                            if (one) return value;
                            // Multi-Selects return an array
                            values.push(value);
                        }
                    }
                    return values;
                },
                set: function(elem, value) {
                    var optionSet, option, options = elem.options, values = jQuery.makeArray(value), i = options.length;
                    while(i--){
                        option = options[i];
                        /* eslint-disable no-cond-assign */ if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) optionSet = true;
                    /* eslint-enable no-cond-assign */ }
                    // Force browsers to behave consistently when non-matching value is set
                    if (!optionSet) elem.selectedIndex = -1;
                    return values;
                }
            }
        }
    });
    // Radios and checkboxes getter/setter
    jQuery.each([
        "radio",
        "checkbox"
    ], function() {
        jQuery.valHooks[this] = {
            set: function(elem, value) {
                if (Array.isArray(value)) return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
            }
        };
        if (!support.checkOn) jQuery.valHooks[this].get = function(elem) {
            return elem.getAttribute("value") === null ? "on" : elem.value;
        };
    });
    // Return jQuery for attributes-only inclusion
    var location = window1.location;
    var nonce = {
        guid: Date.now()
    };
    var rquery = /\?/;
    // Cross-browser xml parsing
    jQuery.parseXML = function(data) {
        var xml, parserErrorElem;
        if (!data || typeof data !== "string") return null;
        // Support: IE 9 - 11 only
        // IE throws on parseFromString with invalid input.
        try {
            xml = new window1.DOMParser().parseFromString(data, "text/xml");
        } catch (e) {}
        parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
        if (!xml || parserErrorElem) jQuery.error("Invalid XML: " + (parserErrorElem ? jQuery.map(parserErrorElem.childNodes, function(el) {
            return el.textContent;
        }).join("\n") : data));
        return xml;
    };
    var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/, stopPropagationCallback = function(e) {
        e.stopPropagation();
    };
    jQuery.extend(jQuery.event, {
        trigger: function(event, data, elem, onlyHandlers) {
            var i, cur, tmp, bubbleType, ontype, handle, special, lastElement, eventPath = [
                elem || document
            ], type = hasOwn.call(event, "type") ? event.type : event, namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
            cur = lastElement = tmp = elem = elem || document;
            // Don't do events on text and comment nodes
            if (elem.nodeType === 3 || elem.nodeType === 8) return;
            // focus/blur morphs to focusin/out; ensure we're not firing them right now
            if (rfocusMorph.test(type + jQuery.event.triggered)) return;
            if (type.indexOf(".") > -1) {
                // Namespaced trigger; create a regexp to match event type in handle()
                namespaces = type.split(".");
                type = namespaces.shift();
                namespaces.sort();
            }
            ontype = type.indexOf(":") < 0 && "on" + type;
            // Caller can pass in a jQuery.Event object, Object, or just an event type string
            event = event[jQuery.expando] ? event : new jQuery.Event(type, typeof event === "object" && event);
            // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
            event.isTrigger = onlyHandlers ? 2 : 3;
            event.namespace = namespaces.join(".");
            event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
            // Clean up the event in case it is being reused
            event.result = undefined;
            if (!event.target) event.target = elem;
            // Clone any incoming data and prepend the event, creating the handler arg list
            data = data == null ? [
                event
            ] : jQuery.makeArray(data, [
                event
            ]);
            // Allow special events to draw outside the lines
            special = jQuery.event.special[type] || {};
            if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) return;
            // Determine event propagation path in advance, per W3C events spec (trac-9951)
            // Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
            if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
                bubbleType = special.delegateType || type;
                if (!rfocusMorph.test(bubbleType + type)) cur = cur.parentNode;
                for(; cur; cur = cur.parentNode){
                    eventPath.push(cur);
                    tmp = cur;
                }
                // Only add window if we got to document (e.g., not plain obj or detached DOM)
                if (tmp === (elem.ownerDocument || document)) eventPath.push(tmp.defaultView || tmp.parentWindow || window1);
            }
            // Fire handlers on the event path
            i = 0;
            while((cur = eventPath[i++]) && !event.isPropagationStopped()){
                lastElement = cur;
                event.type = i > 1 ? bubbleType : special.bindType || type;
                // jQuery handler
                handle = (dataPriv.get(cur, "events") || Object.create(null))[event.type] && dataPriv.get(cur, "handle");
                if (handle) handle.apply(cur, data);
                // Native handler
                handle = ontype && cur[ontype];
                if (handle && handle.apply && acceptData(cur)) {
                    event.result = handle.apply(cur, data);
                    if (event.result === false) event.preventDefault();
                }
            }
            event.type = type;
            // If nobody prevented the default action, do it now
            if (!onlyHandlers && !event.isDefaultPrevented()) {
                if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) // Call a native DOM method on the target with the same name as the event.
                // Don't do default actions on window, that's where global variables be (trac-6170)
                {
                    if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
                        // Don't re-trigger an onFOO event when we call its FOO() method
                        tmp = elem[ontype];
                        if (tmp) elem[ontype] = null;
                        // Prevent re-triggering of the same event, since we already bubbled it above
                        jQuery.event.triggered = type;
                        if (event.isPropagationStopped()) lastElement.addEventListener(type, stopPropagationCallback);
                        elem[type]();
                        if (event.isPropagationStopped()) lastElement.removeEventListener(type, stopPropagationCallback);
                        jQuery.event.triggered = undefined;
                        if (tmp) elem[ontype] = tmp;
                    }
                }
            }
            return event.result;
        },
        // Piggyback on a donor event to simulate a different one
        // Used only for `focus(in | out)` events
        simulate: function(type, elem, event) {
            var e = jQuery.extend(new jQuery.Event(), event, {
                type: type,
                isSimulated: true
            });
            jQuery.event.trigger(e, null, elem);
        }
    });
    jQuery.fn.extend({
        trigger: function(type, data) {
            return this.each(function() {
                jQuery.event.trigger(type, data, this);
            });
        },
        triggerHandler: function(type, data) {
            var elem = this[0];
            if (elem) return jQuery.event.trigger(type, data, elem, true);
        }
    });
    var rbracket = /\[\]$/, rCRLF = /\r?\n/g, rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i, rsubmittable = /^(?:input|select|textarea|keygen)/i;
    function buildParams(prefix, obj, traditional, add) {
        var name;
        if (Array.isArray(obj)) // Serialize array item.
        jQuery.each(obj, function(i, v) {
            if (traditional || rbracket.test(prefix)) // Treat each array item as a scalar.
            add(prefix, v);
            else // Item is non-scalar (array or object), encode its numeric index.
            buildParams(prefix + "[" + (typeof v === "object" && v != null ? i : "") + "]", v, traditional, add);
        });
        else if (!traditional && toType(obj) === "object") // Serialize object item.
        for(name in obj)buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
        else // Serialize scalar item.
        add(prefix, obj);
    }
    // Serialize an array of form elements or a set of
    // key/values into a query string
    jQuery.param = function(a, traditional) {
        var prefix, s = [], add = function(key, valueOrFunction) {
            // If value is a function, invoke it and use its return value
            var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;
            s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
        };
        if (a == null) return "";
        // If an array was passed in, assume that it is an array of form elements.
        if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) // Serialize the form elements
        jQuery.each(a, function() {
            add(this.name, this.value);
        });
        else // If traditional, encode the "old" way (the way 1.3.2 or older
        // did it), otherwise encode params recursively.
        for(prefix in a)buildParams(prefix, a[prefix], traditional, add);
        // Return the resulting serialization
        return s.join("&");
    };
    jQuery.fn.extend({
        serialize: function() {
            return jQuery.param(this.serializeArray());
        },
        serializeArray: function() {
            return this.map(function() {
                // Can add propHook for "elements" to filter or add form elements
                var elements = jQuery.prop(this, "elements");
                return elements ? jQuery.makeArray(elements) : this;
            }).filter(function() {
                var type = this.type;
                // Use .is( ":disabled" ) so that fieldset[disabled] works
                return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
            }).map(function(_i, elem) {
                var val = jQuery(this).val();
                if (val == null) return null;
                if (Array.isArray(val)) return jQuery.map(val, function(val) {
                    return {
                        name: elem.name,
                        value: val.replace(rCRLF, "\r\n")
                    };
                });
                return {
                    name: elem.name,
                    value: val.replace(rCRLF, "\r\n")
                };
            }).get();
        }
    });
    var r20 = /%20/g, rhash = /#.*$/, rantiCache = /([?&])_=[^&]*/, rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg, // trac-7653, trac-8125, trac-8152: local protocol detection
    rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, rnoContent = /^(?:GET|HEAD)$/, rprotocol = /^\/\//, /* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */ prefilters = {}, /* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */ transports = {}, // Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
    allTypes = "*/".concat("*"), // Anchor tag for parsing the document origin
    originAnchor = document.createElement("a");
    originAnchor.href = location.href;
    // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
    function addToPrefiltersOrTransports(structure) {
        // dataTypeExpression is optional and defaults to "*"
        return function(dataTypeExpression, func) {
            if (typeof dataTypeExpression !== "string") {
                func = dataTypeExpression;
                dataTypeExpression = "*";
            }
            var dataType, i = 0, dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
            if (isFunction(func)) {
                // For each dataType in the dataTypeExpression
                while(dataType = dataTypes[i++])// Prepend if requested
                if (dataType[0] === "+") {
                    dataType = dataType.slice(1) || "*";
                    (structure[dataType] = structure[dataType] || []).unshift(func);
                // Otherwise append
                } else (structure[dataType] = structure[dataType] || []).push(func);
            }
        };
    }
    // Base inspection function for prefilters and transports
    function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
        var inspected = {}, seekingTransport = structure === transports;
        function inspect(dataType) {
            var selected;
            inspected[dataType] = true;
            jQuery.each(structure[dataType] || [], function(_, prefilterOrFactory) {
                var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
                if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
                    options.dataTypes.unshift(dataTypeOrTransport);
                    inspect(dataTypeOrTransport);
                    return false;
                } else if (seekingTransport) return !(selected = dataTypeOrTransport);
            });
            return selected;
        }
        return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
    }
    // A special extend for ajax options
    // that takes "flat" options (not to be deep extended)
    // Fixes trac-9887
    function ajaxExtend(target, src) {
        var key, deep, flatOptions = jQuery.ajaxSettings.flatOptions || {};
        for(key in src)if (src[key] !== undefined) (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
        if (deep) jQuery.extend(true, target, deep);
        return target;
    }
    /* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */ function ajaxHandleResponses(s, jqXHR, responses) {
        var ct, type, finalDataType, firstDataType, contents = s.contents, dataTypes = s.dataTypes;
        // Remove auto dataType and get content-type in the process
        while(dataTypes[0] === "*"){
            dataTypes.shift();
            if (ct === undefined) ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
        }
        // Check if we're dealing with a known content-type
        if (ct) {
            for(type in contents)if (contents[type] && contents[type].test(ct)) {
                dataTypes.unshift(type);
                break;
            }
        }
        // Check to see if we have a response for the expected dataType
        if (dataTypes[0] in responses) finalDataType = dataTypes[0];
        else {
            // Try convertible dataTypes
            for(type in responses){
                if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
                    finalDataType = type;
                    break;
                }
                if (!firstDataType) firstDataType = type;
            }
            // Or just use first one
            finalDataType = finalDataType || firstDataType;
        }
        // If we found a dataType
        // We add the dataType to the list if needed
        // and return the corresponding response
        if (finalDataType) {
            if (finalDataType !== dataTypes[0]) dataTypes.unshift(finalDataType);
            return responses[finalDataType];
        }
    }
    /* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */ function ajaxConvert(s, response, jqXHR, isSuccess) {
        var conv2, current, conv, tmp, prev, converters = {}, // Work with a copy of dataTypes in case we need to modify it for conversion
        dataTypes = s.dataTypes.slice();
        // Create converters map with lowercased keys
        if (dataTypes[1]) for(conv in s.converters)converters[conv.toLowerCase()] = s.converters[conv];
        current = dataTypes.shift();
        // Convert to each sequential dataType
        while(current){
            if (s.responseFields[current]) jqXHR[s.responseFields[current]] = response;
            // Apply the dataFilter if provided
            if (!prev && isSuccess && s.dataFilter) response = s.dataFilter(response, s.dataType);
            prev = current;
            current = dataTypes.shift();
            if (current) {
                // There's only work to do if current dataType is non-auto
                if (current === "*") current = prev;
                else if (prev !== "*" && prev !== current) {
                    // Seek a direct converter
                    conv = converters[prev + " " + current] || converters["* " + current];
                    // If none found, seek a pair
                    if (!conv) for(conv2 in converters){
                        // If conv2 outputs current
                        tmp = conv2.split(" ");
                        if (tmp[1] === current) {
                            // If prev can be converted to accepted input
                            conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
                            if (conv) {
                                // Condense equivalence converters
                                if (conv === true) conv = converters[conv2];
                                else if (converters[conv2] !== true) {
                                    current = tmp[0];
                                    dataTypes.unshift(tmp[1]);
                                }
                                break;
                            }
                        }
                    }
                    // Apply converter (if not an equivalence)
                    if (conv !== true) {
                        // Unless errors are allowed to bubble, catch and return them
                        if (conv && s.throws) response = conv(response);
                        else try {
                            response = conv(response);
                        } catch (e) {
                            return {
                                state: "parsererror",
                                error: conv ? e : "No conversion from " + prev + " to " + current
                            };
                        }
                    }
                }
            }
        }
        return {
            state: "success",
            data: response
        };
    }
    jQuery.extend({
        // Counter for holding the number of active queries
        active: 0,
        // Last-Modified header cache for next request
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: location.href,
            type: "GET",
            isLocal: rlocalProtocol.test(location.protocol),
            global: true,
            processData: true,
            async: true,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            /*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/ accepts: {
                "*": allTypes,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            // Data converters
            // Keys separate source (or catchall "*") and destination types with a single space
            converters: {
                // Convert anything to text
                "* text": String,
                // Text to html (true = no transformation)
                "text html": true,
                // Evaluate text as a json expression
                "text json": JSON.parse,
                // Parse text as xml
                "text xml": jQuery.parseXML
            },
            // For options that shouldn't be deep extended:
            // you can add your own custom options here if
            // and when you create one that shouldn't be
            // deep extended (see ajaxExtend)
            flatOptions: {
                url: true,
                context: true
            }
        },
        // Creates a full fledged settings object into target
        // with both ajaxSettings and settings fields.
        // If target is omitted, writes into ajaxSettings.
        ajaxSetup: function(target, settings) {
            return settings ? // Building a settings object
            ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) : // Extending ajaxSettings
            ajaxExtend(jQuery.ajaxSettings, target);
        },
        ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
        ajaxTransport: addToPrefiltersOrTransports(transports),
        // Main method
        ajax: function(url, options) {
            // If url is an object, simulate pre-1.5 signature
            if (typeof url === "object") {
                options = url;
                url = undefined;
            }
            // Force options to be an object
            options = options || {};
            var transport, // URL without anti-cache param
            cacheURL, // Response headers
            responseHeadersString, responseHeaders, // timeout handle
            timeoutTimer, // Url cleanup var
            urlAnchor, // Request state (becomes false upon send and true upon completion)
            completed, // To know if global events are to be dispatched
            fireGlobals, // Loop variable
            i, // uncached part of the url
            uncached, // Create the final options object
            s = jQuery.ajaxSetup({}, options), // Callbacks context
            callbackContext = s.context || s, // Context for global events is callbackContext if it is a DOM node or jQuery collection
            globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event, // Deferreds
            deferred = jQuery.Deferred(), completeDeferred = jQuery.Callbacks("once memory"), // Status-dependent callbacks
            statusCode = s.statusCode || {}, // Headers (they are sent all at once)
            requestHeaders = {}, requestHeadersNames = {}, // Default abort message
            strAbort = "canceled", // Fake xhr
            jqXHR = {
                readyState: 0,
                // Builds headers hashtable if needed
                getResponseHeader: function(key) {
                    var match;
                    if (completed) {
                        if (!responseHeaders) {
                            responseHeaders = {};
                            while(match = rheaders.exec(responseHeadersString))responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
                        }
                        match = responseHeaders[key.toLowerCase() + " "];
                    }
                    return match == null ? null : match.join(", ");
                },
                // Raw string
                getAllResponseHeaders: function() {
                    return completed ? responseHeadersString : null;
                },
                // Caches the header
                setRequestHeader: function(name, value) {
                    if (completed == null) {
                        name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
                        requestHeaders[name] = value;
                    }
                    return this;
                },
                // Overrides response content-type header
                overrideMimeType: function(type) {
                    if (completed == null) s.mimeType = type;
                    return this;
                },
                // Status-dependent callbacks
                statusCode: function(map) {
                    var code;
                    if (map) {
                        if (completed) // Execute the appropriate callbacks
                        jqXHR.always(map[jqXHR.status]);
                        else // Lazy-add the new callbacks in a way that preserves old ones
                        for(code in map)statusCode[code] = [
                            statusCode[code],
                            map[code]
                        ];
                    }
                    return this;
                },
                // Cancel the request
                abort: function(statusText) {
                    var finalText = statusText || strAbort;
                    if (transport) transport.abort(finalText);
                    done(0, finalText);
                    return this;
                }
            };
            // Attach deferreds
            deferred.promise(jqXHR);
            // Add protocol if not provided (prefilters might expect it)
            // Handle falsy url in the settings object (trac-10093: consistency with old signature)
            // We also use the url parameter if available
            s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");
            // Alias method option to type as per ticket trac-12004
            s.type = options.method || options.type || s.method || s.type;
            // Extract dataTypes list
            s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [
                ""
            ];
            // A cross-domain request is in order when the origin doesn't match the current origin.
            if (s.crossDomain == null) {
                urlAnchor = document.createElement("a");
                // Support: IE <=8 - 11, Edge 12 - 15
                // IE throws exception on accessing the href property if url is malformed,
                // e.g. http://example.com:80x/
                try {
                    urlAnchor.href = s.url;
                    // Support: IE <=8 - 11 only
                    // Anchor's host property isn't correctly set when s.url is relative
                    urlAnchor.href = urlAnchor.href;
                    s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
                } catch (e) {
                    // If there is an error parsing the URL, assume it is crossDomain,
                    // it can be rejected by the transport if it is invalid
                    s.crossDomain = true;
                }
            }
            // Convert data if not already a string
            if (s.data && s.processData && typeof s.data !== "string") s.data = jQuery.param(s.data, s.traditional);
            // Apply prefilters
            inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
            // If request was aborted inside a prefilter, stop there
            if (completed) return jqXHR;
            // We can fire global events as of now if asked to
            // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
            fireGlobals = jQuery.event && s.global;
            // Watch for a new set of requests
            if (fireGlobals && jQuery.active++ === 0) jQuery.event.trigger("ajaxStart");
            // Uppercase the type
            s.type = s.type.toUpperCase();
            // Determine if request has content
            s.hasContent = !rnoContent.test(s.type);
            // Save the URL in case we're toying with the If-Modified-Since
            // and/or If-None-Match header later on
            // Remove hash to simplify url manipulation
            cacheURL = s.url.replace(rhash, "");
            // More options handling for requests with no content
            if (!s.hasContent) {
                // Remember the hash so we can put it back
                uncached = s.url.slice(cacheURL.length);
                // If data is available and should be processed, append data to url
                if (s.data && (s.processData || typeof s.data === "string")) {
                    cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;
                    // trac-9682: remove data so that it's not used in an eventual retry
                    delete s.data;
                }
                // Add or update anti-cache param if needed
                if (s.cache === false) {
                    cacheURL = cacheURL.replace(rantiCache, "$1");
                    uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce.guid++ + uncached;
                }
                // Put hash and anti-cache on the URL that will be requested (gh-1732)
                s.url = cacheURL + uncached;
            // Change '%20' to '+' if this is encoded form body content (gh-2658)
            } else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) s.data = s.data.replace(r20, "+");
            // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
            if (s.ifModified) {
                if (jQuery.lastModified[cacheURL]) jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
                if (jQuery.etag[cacheURL]) jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
            }
            // Set the correct header, if data is being sent
            if (s.data && s.hasContent && s.contentType !== false || options.contentType) jqXHR.setRequestHeader("Content-Type", s.contentType);
            // Set the Accepts header for the server, depending on the dataType
            jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);
            // Check for headers option
            for(i in s.headers)jqXHR.setRequestHeader(i, s.headers[i]);
            // Allow custom headers/mimetypes and early abort
            if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || completed)) // Abort if not done already and return
            return jqXHR.abort();
            // Aborting is no longer a cancellation
            strAbort = "abort";
            // Install callbacks on deferreds
            completeDeferred.add(s.complete);
            jqXHR.done(s.success);
            jqXHR.fail(s.error);
            // Get transport
            transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
            // If no transport, we auto-abort
            if (!transport) done(-1, "No Transport");
            else {
                jqXHR.readyState = 1;
                // Send global event
                if (fireGlobals) globalEventContext.trigger("ajaxSend", [
                    jqXHR,
                    s
                ]);
                // If request was aborted inside ajaxSend, stop there
                if (completed) return jqXHR;
                // Timeout
                if (s.async && s.timeout > 0) timeoutTimer = window1.setTimeout(function() {
                    jqXHR.abort("timeout");
                }, s.timeout);
                try {
                    completed = false;
                    transport.send(requestHeaders, done);
                } catch (e) {
                    // Rethrow post-completion exceptions
                    if (completed) throw e;
                    // Propagate others as results
                    done(-1, e);
                }
            }
            // Callback for when everything is done
            function done(status, nativeStatusText, responses, headers) {
                var isSuccess, success, error, response, modified, statusText = nativeStatusText;
                // Ignore repeat invocations
                if (completed) return;
                completed = true;
                // Clear timeout if it exists
                if (timeoutTimer) window1.clearTimeout(timeoutTimer);
                // Dereference transport for early garbage collection
                // (no matter how long the jqXHR object will be used)
                transport = undefined;
                // Cache response headers
                responseHeadersString = headers || "";
                // Set readyState
                jqXHR.readyState = status > 0 ? 4 : 0;
                // Determine if successful
                isSuccess = status >= 200 && status < 300 || status === 304;
                // Get response data
                if (responses) response = ajaxHandleResponses(s, jqXHR, responses);
                // Use a noop converter for missing script but not if jsonp
                if (!isSuccess && jQuery.inArray("script", s.dataTypes) > -1 && jQuery.inArray("json", s.dataTypes) < 0) s.converters["text script"] = function() {};
                // Convert no matter what (that way responseXXX fields are always set)
                response = ajaxConvert(s, response, jqXHR, isSuccess);
                // If successful, handle type chaining
                if (isSuccess) {
                    // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                    if (s.ifModified) {
                        modified = jqXHR.getResponseHeader("Last-Modified");
                        if (modified) jQuery.lastModified[cacheURL] = modified;
                        modified = jqXHR.getResponseHeader("etag");
                        if (modified) jQuery.etag[cacheURL] = modified;
                    }
                    // if no content
                    if (status === 204 || s.type === "HEAD") statusText = "nocontent";
                    else if (status === 304) statusText = "notmodified";
                    else {
                        statusText = response.state;
                        success = response.data;
                        error = response.error;
                        isSuccess = !error;
                    }
                } else {
                    // Extract error from statusText and normalize for non-aborts
                    error = statusText;
                    if (status || !statusText) {
                        statusText = "error";
                        if (status < 0) status = 0;
                    }
                }
                // Set data for the fake xhr object
                jqXHR.status = status;
                jqXHR.statusText = (nativeStatusText || statusText) + "";
                // Success/Error
                if (isSuccess) deferred.resolveWith(callbackContext, [
                    success,
                    statusText,
                    jqXHR
                ]);
                else deferred.rejectWith(callbackContext, [
                    jqXHR,
                    statusText,
                    error
                ]);
                // Status-dependent callbacks
                jqXHR.statusCode(statusCode);
                statusCode = undefined;
                if (fireGlobals) globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [
                    jqXHR,
                    s,
                    isSuccess ? success : error
                ]);
                // Complete
                completeDeferred.fireWith(callbackContext, [
                    jqXHR,
                    statusText
                ]);
                if (fireGlobals) {
                    globalEventContext.trigger("ajaxComplete", [
                        jqXHR,
                        s
                    ]);
                    // Handle the global AJAX counter
                    if (!--jQuery.active) jQuery.event.trigger("ajaxStop");
                }
            }
            return jqXHR;
        },
        getJSON: function(url, data, callback) {
            return jQuery.get(url, data, callback, "json");
        },
        getScript: function(url, callback) {
            return jQuery.get(url, undefined, callback, "script");
        }
    });
    jQuery.each([
        "get",
        "post"
    ], function(_i, method) {
        jQuery[method] = function(url, data, callback, type) {
            // Shift arguments if data argument was omitted
            if (isFunction(data)) {
                type = type || callback;
                callback = data;
                data = undefined;
            }
            // The url can be an options object (which then must have .url)
            return jQuery.ajax(jQuery.extend({
                url: url,
                type: method,
                dataType: type,
                data: data,
                success: callback
            }, jQuery.isPlainObject(url) && url));
        };
    });
    jQuery.ajaxPrefilter(function(s) {
        var i;
        for(i in s.headers)if (i.toLowerCase() === "content-type") s.contentType = s.headers[i] || "";
    });
    jQuery._evalUrl = function(url, options, doc) {
        return jQuery.ajax({
            url: url,
            // Make this explicit, since user can override this through ajaxSetup (trac-11264)
            type: "GET",
            dataType: "script",
            cache: true,
            async: false,
            global: false,
            // Only evaluate the response if it is successful (gh-4126)
            // dataFilter is not invoked for failure responses, so using it instead
            // of the default converter is kludgy but it works.
            converters: {
                "text script": function() {}
            },
            dataFilter: function(response) {
                jQuery.globalEval(response, options, doc);
            }
        });
    };
    jQuery.fn.extend({
        wrapAll: function(html) {
            var wrap;
            if (this[0]) {
                if (isFunction(html)) html = html.call(this[0]);
                // The elements to wrap the target around
                wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
                if (this[0].parentNode) wrap.insertBefore(this[0]);
                wrap.map(function() {
                    var elem = this;
                    while(elem.firstElementChild)elem = elem.firstElementChild;
                    return elem;
                }).append(this);
            }
            return this;
        },
        wrapInner: function(html) {
            if (isFunction(html)) return this.each(function(i) {
                jQuery(this).wrapInner(html.call(this, i));
            });
            return this.each(function() {
                var self = jQuery(this), contents = self.contents();
                if (contents.length) contents.wrapAll(html);
                else self.append(html);
            });
        },
        wrap: function(html) {
            var htmlIsFunction = isFunction(html);
            return this.each(function(i) {
                jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
            });
        },
        unwrap: function(selector) {
            this.parent(selector).not("body").each(function() {
                jQuery(this).replaceWith(this.childNodes);
            });
            return this;
        }
    });
    jQuery.expr.pseudos.hidden = function(elem) {
        return !jQuery.expr.pseudos.visible(elem);
    };
    jQuery.expr.pseudos.visible = function(elem) {
        return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
    };
    jQuery.ajaxSettings.xhr = function() {
        try {
            return new window1.XMLHttpRequest();
        } catch (e) {}
    };
    var xhrSuccessStatus = {
        // File protocol always yields status code 0, assume 200
        0: 200,
        // Support: IE <=9 only
        // trac-1450: sometimes IE returns 1223 when it should be 204
        1223: 204
    }, xhrSupported = jQuery.ajaxSettings.xhr();
    support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
    support.ajax = xhrSupported = !!xhrSupported;
    jQuery.ajaxTransport(function(options) {
        var callback, errorCallback;
        // Cross domain only allowed if supported through XMLHttpRequest
        if (support.cors || xhrSupported && !options.crossDomain) return {
            send: function(headers, complete) {
                var i, xhr = options.xhr();
                xhr.open(options.type, options.url, options.async, options.username, options.password);
                // Apply custom fields if provided
                if (options.xhrFields) for(i in options.xhrFields)xhr[i] = options.xhrFields[i];
                // Override mime type if needed
                if (options.mimeType && xhr.overrideMimeType) xhr.overrideMimeType(options.mimeType);
                // X-Requested-With header
                // For cross-domain requests, seeing as conditions for a preflight are
                // akin to a jigsaw puzzle, we simply never set it to be sure.
                // (it can always be set on a per-request basis or even using ajaxSetup)
                // For same-domain requests, won't change header if already provided.
                if (!options.crossDomain && !headers["X-Requested-With"]) headers["X-Requested-With"] = "XMLHttpRequest";
                // Set headers
                for(i in headers)xhr.setRequestHeader(i, headers[i]);
                // Callback
                callback = function(type) {
                    return function() {
                        if (callback) {
                            callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null;
                            if (type === "abort") xhr.abort();
                            else if (type === "error") {
                                // Support: IE <=9 only
                                // On a manual native abort, IE9 throws
                                // errors on any property access that is not readyState
                                if (typeof xhr.status !== "number") complete(0, "error");
                                else complete(// File: protocol always yields status 0; see trac-8605, trac-14207
                                xhr.status, xhr.statusText);
                            } else complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText, // Support: IE <=9 only
                            // IE9 has no XHR2 but throws on binary (trac-11426)
                            // For XHR2 non-text, let the caller handle it (gh-2498)
                            (xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? {
                                binary: xhr.response
                            } : {
                                text: xhr.responseText
                            }, xhr.getAllResponseHeaders());
                        }
                    };
                };
                // Listen to events
                xhr.onload = callback();
                errorCallback = xhr.onerror = xhr.ontimeout = callback("error");
                // Support: IE 9 only
                // Use onreadystatechange to replace onabort
                // to handle uncaught aborts
                if (xhr.onabort !== undefined) xhr.onabort = errorCallback;
                else xhr.onreadystatechange = function() {
                    // Check readyState before timeout as it changes
                    if (xhr.readyState === 4) // Allow onerror to be called first,
                    // but that will not handle a native abort
                    // Also, save errorCallback to a variable
                    // as xhr.onerror cannot be accessed
                    window1.setTimeout(function() {
                        if (callback) errorCallback();
                    });
                };
                // Create the abort callback
                callback = callback("abort");
                try {
                    // Do send the request (this may raise an exception)
                    xhr.send(options.hasContent && options.data || null);
                } catch (e) {
                    // trac-14683: Only rethrow if this hasn't been notified as an error yet
                    if (callback) throw e;
                }
            },
            abort: function() {
                if (callback) callback();
            }
        };
    });
    // Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
    jQuery.ajaxPrefilter(function(s) {
        if (s.crossDomain) s.contents.script = false;
    });
    // Install script dataType
    jQuery.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(text) {
                jQuery.globalEval(text);
                return text;
            }
        }
    });
    // Handle cache's special case and crossDomain
    jQuery.ajaxPrefilter("script", function(s) {
        if (s.cache === undefined) s.cache = false;
        if (s.crossDomain) s.type = "GET";
    });
    // Bind script tag hack transport
    jQuery.ajaxTransport("script", function(s) {
        // This transport only deals with cross domain or forced-by-attrs requests
        if (s.crossDomain || s.scriptAttrs) {
            var script, callback;
            return {
                send: function(_, complete) {
                    script = jQuery("<script>").attr(s.scriptAttrs || {}).prop({
                        charset: s.scriptCharset,
                        src: s.url
                    }).on("load error", callback = function(evt) {
                        script.remove();
                        callback = null;
                        if (evt) complete(evt.type === "error" ? 404 : 200, evt.type);
                    });
                    // Use native DOM manipulation to avoid our domManip AJAX trickery
                    document.head.appendChild(script[0]);
                },
                abort: function() {
                    if (callback) callback();
                }
            };
        }
    });
    var oldCallbacks = [], rjsonp = /(=)\?(?=&|$)|\?\?/;
    // Default jsonp settings
    jQuery.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
            this[callback] = true;
            return callback;
        }
    });
    // Detect, normalize options and install callbacks for jsonp requests
    jQuery.ajaxPrefilter("json jsonp", function(s, originalSettings, jqXHR) {
        var callbackName, overwritten, responseContainer, jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");
        // Handle iff the expected data type is "jsonp" or we have a parameter to set
        if (jsonProp || s.dataTypes[0] === "jsonp") {
            // Get callback name, remembering preexisting value associated with it
            callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;
            // Insert callback into url or form data
            if (jsonProp) s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
            else if (s.jsonp !== false) s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
            // Use data converter to retrieve json after script execution
            s.converters["script json"] = function() {
                if (!responseContainer) jQuery.error(callbackName + " was not called");
                return responseContainer[0];
            };
            // Force json dataType
            s.dataTypes[0] = "json";
            // Install callback
            overwritten = window1[callbackName];
            window1[callbackName] = function() {
                responseContainer = arguments;
            };
            // Clean-up function (fires after converters)
            jqXHR.always(function() {
                // If previous value didn't exist - remove it
                if (overwritten === undefined) jQuery(window1).removeProp(callbackName);
                else window1[callbackName] = overwritten;
                // Save back as free
                if (s[callbackName]) {
                    // Make sure that re-using the options doesn't screw things around
                    s.jsonpCallback = originalSettings.jsonpCallback;
                    // Save the callback name for future use
                    oldCallbacks.push(callbackName);
                }
                // Call if it was a function and we have a response
                if (responseContainer && isFunction(overwritten)) overwritten(responseContainer[0]);
                responseContainer = overwritten = undefined;
            });
            // Delegate to script
            return "script";
        }
    });
    // Support: Safari 8 only
    // In Safari 8 documents created via document.implementation.createHTMLDocument
    // collapse sibling forms: the second one becomes a child of the first one.
    // Because of that, this security measure has to be disabled in Safari 8.
    // https://bugs.webkit.org/show_bug.cgi?id=137337
    support.createHTMLDocument = function() {
        var body = document.implementation.createHTMLDocument("").body;
        body.innerHTML = "<form></form><form></form>";
        return body.childNodes.length === 2;
    }();
    // Argument "data" should be string of html
    // context (optional): If specified, the fragment will be created in this context,
    // defaults to document
    // keepScripts (optional): If true, will include scripts passed in the html string
    jQuery.parseHTML = function(data, context, keepScripts) {
        if (typeof data !== "string") return [];
        if (typeof context === "boolean") {
            keepScripts = context;
            context = false;
        }
        var base, parsed, scripts;
        if (!context) {
            // Stop scripts or inline event handlers from being executed immediately
            // by using document.implementation
            if (support.createHTMLDocument) {
                context = document.implementation.createHTMLDocument("");
                // Set the base href for the created document
                // so any parsed elements with URLs
                // are based on the document's URL (gh-2965)
                base = context.createElement("base");
                base.href = document.location.href;
                context.head.appendChild(base);
            } else context = document;
        }
        parsed = rsingleTag.exec(data);
        scripts = !keepScripts && [];
        // Single tag
        if (parsed) return [
            context.createElement(parsed[1])
        ];
        parsed = buildFragment([
            data
        ], context, scripts);
        if (scripts && scripts.length) jQuery(scripts).remove();
        return jQuery.merge([], parsed.childNodes);
    };
    /**
 * Load a url into a page
 */ jQuery.fn.load = function(url, params, callback) {
        var selector, type, response, self = this, off = url.indexOf(" ");
        if (off > -1) {
            selector = stripAndCollapse(url.slice(off));
            url = url.slice(0, off);
        }
        // If it's a function
        if (isFunction(params)) {
            // We assume that it's the callback
            callback = params;
            params = undefined;
        // Otherwise, build a param string
        } else if (params && typeof params === "object") type = "POST";
        // If we have elements to modify, make the request
        if (self.length > 0) jQuery.ajax({
            url: url,
            // If "type" variable is undefined, then "GET" method will be used.
            // Make value of this field explicit since
            // user can override it through ajaxSetup method
            type: type || "GET",
            dataType: "html",
            data: params
        }).done(function(responseText) {
            // Save response for use in complete callback
            response = arguments;
            self.html(selector ? // If a selector was specified, locate the right elements in a dummy div
            // Exclude scripts to avoid IE 'Permission Denied' errors
            jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) : // Otherwise use the full result
            responseText);
        // If the request succeeds, this function gets "data", "status", "jqXHR"
        // but they are ignored because response was set above.
        // If it fails, this function gets "jqXHR", "status", "error"
        }).always(callback && function(jqXHR, status) {
            self.each(function() {
                callback.apply(this, response || [
                    jqXHR.responseText,
                    status,
                    jqXHR
                ]);
            });
        });
        return this;
    };
    jQuery.expr.pseudos.animated = function(elem) {
        return jQuery.grep(jQuery.timers, function(fn) {
            return elem === fn.elem;
        }).length;
    };
    jQuery.offset = {
        setOffset: function(elem, options, i) {
            var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition, position = jQuery.css(elem, "position"), curElem = jQuery(elem), props = {};
            // Set position first, in-case top/left are set even on static elem
            if (position === "static") elem.style.position = "relative";
            curOffset = curElem.offset();
            curCSSTop = jQuery.css(elem, "top");
            curCSSLeft = jQuery.css(elem, "left");
            calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;
            // Need to be able to calculate position if either
            // top or left is auto and position is either absolute or fixed
            if (calculatePosition) {
                curPosition = curElem.position();
                curTop = curPosition.top;
                curLeft = curPosition.left;
            } else {
                curTop = parseFloat(curCSSTop) || 0;
                curLeft = parseFloat(curCSSLeft) || 0;
            }
            if (isFunction(options)) // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
            options = options.call(elem, i, jQuery.extend({}, curOffset));
            if (options.top != null) props.top = options.top - curOffset.top + curTop;
            if (options.left != null) props.left = options.left - curOffset.left + curLeft;
            if ("using" in options) options.using.call(elem, props);
            else curElem.css(props);
        }
    };
    jQuery.fn.extend({
        // offset() relates an element's border box to the document origin
        offset: function(options) {
            // Preserve chaining for setter
            if (arguments.length) return options === undefined ? this : this.each(function(i) {
                jQuery.offset.setOffset(this, options, i);
            });
            var rect, win, elem = this[0];
            if (!elem) return;
            // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
            // Support: IE <=11 only
            // Running getBoundingClientRect on a
            // disconnected node in IE throws an error
            if (!elem.getClientRects().length) return {
                top: 0,
                left: 0
            };
            // Get document-relative position by adding viewport scroll to viewport-relative gBCR
            rect = elem.getBoundingClientRect();
            win = elem.ownerDocument.defaultView;
            return {
                top: rect.top + win.pageYOffset,
                left: rect.left + win.pageXOffset
            };
        },
        // position() relates an element's margin box to its offset parent's padding box
        // This corresponds to the behavior of CSS absolute positioning
        position: function() {
            if (!this[0]) return;
            var offsetParent, offset, doc, elem = this[0], parentOffset = {
                top: 0,
                left: 0
            };
            // position:fixed elements are offset from the viewport, which itself always has zero offset
            if (jQuery.css(elem, "position") === "fixed") // Assume position:fixed implies availability of getBoundingClientRect
            offset = elem.getBoundingClientRect();
            else {
                offset = this.offset();
                // Account for the *real* offset parent, which can be the document or its root element
                // when a statically positioned element is identified
                doc = elem.ownerDocument;
                offsetParent = elem.offsetParent || doc.documentElement;
                while(offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.parentNode;
                if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {
                    // Incorporate borders into its offset, since they are outside its content origin
                    parentOffset = jQuery(offsetParent).offset();
                    parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
                    parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
                }
            }
            // Subtract parent offsets and element margins
            return {
                top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
                left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
            };
        },
        // This method will return documentElement in the following cases:
        // 1) For the element inside the iframe without offsetParent, this method will return
        //    documentElement of the parent window
        // 2) For the hidden or detached element
        // 3) For body or html element, i.e. in case of the html node - it will return itself
        //
        // but those exceptions were never presented as a real life use-cases
        // and might be considered as more preferable results.
        //
        // This logic, however, is not guaranteed and can change at any point in the future
        offsetParent: function() {
            return this.map(function() {
                var offsetParent = this.offsetParent;
                while(offsetParent && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.offsetParent;
                return offsetParent || documentElement;
            });
        }
    });
    // Create scrollLeft and scrollTop methods
    jQuery.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(method, prop) {
        var top = "pageYOffset" === prop;
        jQuery.fn[method] = function(val) {
            return access(this, function(elem, method, val) {
                // Coalesce documents and windows
                var win;
                if (isWindow(elem)) win = elem;
                else if (elem.nodeType === 9) win = elem.defaultView;
                if (val === undefined) return win ? win[prop] : elem[method];
                if (win) win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
                else elem[method] = val;
            }, method, val, arguments.length);
        };
    });
    // Support: Safari <=7 - 9.1, Chrome <=37 - 49
    // Add the top/left cssHooks using jQuery.fn.position
    // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
    // Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
    // getComputedStyle returns percent when specified for top/left/bottom/right;
    // rather than make the css module depend on the offset module, just check for it here
    jQuery.each([
        "top",
        "left"
    ], function(_i, prop) {
        jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function(elem, computed) {
            if (computed) {
                computed = curCSS(elem, prop);
                // If curCSS returns percentage, fallback to offset
                return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
            }
        });
    });
    // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
    jQuery.each({
        Height: "height",
        Width: "width"
    }, function(name, type) {
        jQuery.each({
            padding: "inner" + name,
            content: type,
            "": "outer" + name
        }, function(defaultExtra, funcName) {
            // Margin is only for outerHeight, outerWidth
            jQuery.fn[funcName] = function(margin, value) {
                var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"), extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
                return access(this, function(elem, type, value) {
                    var doc;
                    if (isWindow(elem)) // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                    return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
                    // Get document width or height
                    if (elem.nodeType === 9) {
                        doc = elem.documentElement;
                        // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                        // whichever is greatest
                        return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
                    }
                    return value === undefined ? // Get width or height on the element, requesting but not forcing parseFloat
                    jQuery.css(elem, type, extra) : // Set width or height on the element
                    jQuery.style(elem, type, value, extra);
                }, type, chainable ? margin : undefined, chainable);
            };
        });
    });
    jQuery.each([
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend"
    ], function(_i, type) {
        jQuery.fn[type] = function(fn) {
            return this.on(type, fn);
        };
    });
    jQuery.fn.extend({
        bind: function(types, data, fn) {
            return this.on(types, null, data, fn);
        },
        unbind: function(types, fn) {
            return this.off(types, null, fn);
        },
        delegate: function(selector, types, data, fn) {
            return this.on(types, selector, data, fn);
        },
        undelegate: function(selector, types, fn) {
            // ( namespace ) or ( selector, types [, fn] )
            return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
        },
        hover: function(fnOver, fnOut) {
            return this.on("mouseenter", fnOver).on("mouseleave", fnOut || fnOver);
        }
    });
    jQuery.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(_i, name) {
        // Handle event binding
        jQuery.fn[name] = function(data, fn) {
            return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
        };
    });
    // Support: Android <=4.0 only
    // Make sure we trim BOM and NBSP
    // Require that the "whitespace run" starts from a non-whitespace
    // to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
    var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
    // Bind a function to a context, optionally partially applying any
    // arguments.
    // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
    // However, it is not slated for removal any time soon
    jQuery.proxy = function(fn, context) {
        var tmp, args, proxy;
        if (typeof context === "string") {
            tmp = fn[context];
            context = fn;
            fn = tmp;
        }
        // Quick check to determine if target is callable, in the spec
        // this throws a TypeError, but we will just return undefined.
        if (!isFunction(fn)) return undefined;
        // Simulated bind
        args = slice.call(arguments, 2);
        proxy = function() {
            return fn.apply(context || this, args.concat(slice.call(arguments)));
        };
        // Set the guid of unique handler to the same of original handler, so it can be removed
        proxy.guid = fn.guid = fn.guid || jQuery.guid++;
        return proxy;
    };
    jQuery.holdReady = function(hold) {
        if (hold) jQuery.readyWait++;
        else jQuery.ready(true);
    };
    jQuery.isArray = Array.isArray;
    jQuery.parseJSON = JSON.parse;
    jQuery.nodeName = nodeName;
    jQuery.isFunction = isFunction;
    jQuery.isWindow = isWindow;
    jQuery.camelCase = camelCase;
    jQuery.type = toType;
    jQuery.now = Date.now;
    jQuery.isNumeric = function(obj) {
        // As of jQuery 3.0, isNumeric is limited to
        // strings and numbers (primitives or objects)
        // that can be coerced to finite numbers (gh-2662)
        var type = jQuery.type(obj);
        return (type === "number" || type === "string") && // parseFloat NaNs numeric-cast false positives ("")
        // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
        // subtraction forces infinities to NaN
        !isNaN(obj - parseFloat(obj));
    };
    jQuery.trim = function(text) {
        return text == null ? "" : (text + "").replace(rtrim, "$1");
    };
    // Register as a named AMD module, since jQuery can be concatenated with other
    // files that may use define, but not via a proper concatenation script that
    // understands anonymous AMD modules. A named AMD is safest and most robust
    // way to register. Lowercase jquery is used because AMD module names are
    // derived from file names, and jQuery is normally delivered in a lowercase
    // file name. Do this after creating the global so that if an AMD module wants
    // to call noConflict to hide this version of jQuery, it will work.
    // Note that for maximum portability, libraries that are not jQuery should
    // declare themselves as anonymous modules, and avoid setting a global if an
    // AMD loader is present. jQuery is a special case. For more information, see
    // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
    if (typeof define === "function" && define.amd) define("jquery", [], function() {
        return jQuery;
    });
    var // Map over jQuery in case of overwrite
    _jQuery = window1.jQuery, // Map over the $ in case of overwrite
    _$ = window1.$;
    jQuery.noConflict = function(deep) {
        if (window1.$ === jQuery) window1.$ = _$;
        if (deep && window1.jQuery === jQuery) window1.jQuery = _jQuery;
        return jQuery;
    };
    // Expose jQuery and $ identifiers, even in AMD
    // (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
    // and CommonJS for browser emulators (trac-13566)
    if (typeof noGlobal === "undefined") window1.jQuery = window1.$ = jQuery;
    return jQuery;
});

});


parcelRequire("dbPRX");
var $blLX2 = parcelRequire("blLX2");

var $5I3lV = parcelRequire("5I3lV");

var $aPsVO = parcelRequire("aPsVO");
var $cFPH9 = parcelRequire("cFPH9");
parcelRequire("fcmEp");

var $bj2Xw = parcelRequire("bj2Xw");
const $f01fb3b47a5e3562$var$boRow = (bo)=>(0, $aPsVO.html)`        
<tr>
<td>
${bo.boString}
</td>
<td>
${bo.name || ""}
</td>
<td>
${bo.amount}
</td>
<td>
${bo.won}
</td>
<td>
${bo.lost}
</td>
<td>
${(0, $5I3lV.default).percentFormat(bo.won / (bo.won + bo.lost))}
</td>
</tr>`;
const $f01fb3b47a5e3562$var$boRows = (bos)=>bos.map((bo)=>$f01fb3b47a5e3562$var$boRow(bo));
const $f01fb3b47a5e3562$var$boRowsNode = document.querySelector("#boRows");
(0, $blLX2.default).get((0, $5I3lV.default).dataBaseUrl + "stats/top_bos.json").then((result)=>{
    let data = result.data;
    (0, $cFPH9.render)($f01fb3b47a5e3562$var$boRows(data), $f01fb3b47a5e3562$var$boRowsNode);
    (0, (/*@__PURE__*/$parcel$interopDefault($bj2Xw)))("#boTable").tablesorter();
});

})();
//# sourceMappingURL=buildorders.js.map
